import * as be from "react";
import Bn, { Children as d2, isValidElement as Da, createContext as Nr, useContext as tn, useRef as Le, useEffect as Ue, useCallback as q, useState as Ee, useId as Zr, useLayoutEffect as Oa, useMemo as at, useInsertionEffect as Ep, forwardRef as Fe, createElement as Rp, cloneElement as bo, memo as uL, useSyncExternalStore as cL, Fragment as ol, PureComponent as dL, Component as fL } from "react";
import { __unsafe_useEmotionCache as hL, Global as f2, ThemeProvider as pL, ThemeContext as gL, keyframes as Cl, jsx as He, css as _p } from "@emotion/react";
import mL from "@emotion/styled";
import { createPortal as Mf } from "react-dom";
import { unreachable as Pf, isUndefined as Un, isDefined as qe, AloftDate as td, AloftPrice as nd, AloftArea as Tp, addressToString as CL, stringToAddress as vL, isString as bL, isNonEmptyString as I7, guid as yL } from "@aloft/toolkit-shared";
var ko = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ef(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var y5 = { exports: {} }, C1 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V7;
function xL() {
  if (V7)
    return C1;
  V7 = 1;
  var e = Bn, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(u, c, d) {
    var f, p = {}, g = null, m = null;
    d !== void 0 && (g = "" + d), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (f in c)
      r.call(c, f) && !i.hasOwnProperty(f) && (p[f] = c[f]);
    if (u && u.defaultProps)
      for (f in c = u.defaultProps, c)
        p[f] === void 0 && (p[f] = c[f]);
    return { $$typeof: t, type: u, key: g, ref: m, props: p, _owner: o.current };
  }
  return C1.Fragment = n, C1.jsx = a, C1.jsxs = a, C1;
}
var v1 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A7;
function SL() {
  return A7 || (A7 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Bn, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), b = Symbol.iterator, v = "@@iterator";
    function y(F) {
      if (F === null || typeof F != "object")
        return null;
      var fe = b && F[b] || F[v];
      return typeof fe == "function" ? fe : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(F) {
      {
        for (var fe = arguments.length, we = new Array(fe > 1 ? fe - 1 : 0), Ze = 1; Ze < fe; Ze++)
          we[Ze - 1] = arguments[Ze];
        V("error", F, we);
      }
    }
    function V(F, fe, we) {
      {
        var Ze = w.ReactDebugCurrentFrame, et = Ze.getStackAddendum();
        et !== "" && (fe += "%s", we = we.concat([et]));
        var vt = we.map(function(lt) {
          return String(lt);
        });
        vt.unshift("Warning: " + fe), Function.prototype.apply.call(console[F], console, vt);
      }
    }
    var M = !1, L = !1, R = !1, _ = !1, H = !1, B;
    B = Symbol.for("react.module.reference");
    function Z(F) {
      return !!(typeof F == "string" || typeof F == "function" || F === r || F === i || H || F === o || F === d || F === f || _ || F === m || M || L || R || typeof F == "object" && F !== null && (F.$$typeof === g || F.$$typeof === p || F.$$typeof === a || F.$$typeof === u || F.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      F.$$typeof === B || F.getModuleId !== void 0));
    }
    function G(F, fe, we) {
      var Ze = F.displayName;
      if (Ze)
        return Ze;
      var et = fe.displayName || fe.name || "";
      return et !== "" ? we + "(" + et + ")" : we;
    }
    function se(F) {
      return F.displayName || "Context";
    }
    function ue(F) {
      if (F == null)
        return null;
      if (typeof F.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof F == "function")
        return F.displayName || F.name || null;
      if (typeof F == "string")
        return F;
      switch (F) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof F == "object")
        switch (F.$$typeof) {
          case u:
            var fe = F;
            return se(fe) + ".Consumer";
          case a:
            var we = F;
            return se(we._context) + ".Provider";
          case c:
            return G(F, F.render, "ForwardRef");
          case p:
            var Ze = F.displayName || null;
            return Ze !== null ? Ze : ue(F.type) || "Memo";
          case g: {
            var et = F, vt = et._payload, lt = et._init;
            try {
              return ue(lt(vt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ce = Object.assign, xe = 0, he, z, Y, ae, j, X, ie;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function re() {
      {
        if (xe === 0) {
          he = console.log, z = console.info, Y = console.warn, ae = console.error, j = console.group, X = console.groupCollapsed, ie = console.groupEnd;
          var F = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: F,
            log: F,
            warn: F,
            error: F,
            group: F,
            groupCollapsed: F,
            groupEnd: F
          });
        }
        xe++;
      }
    }
    function te() {
      {
        if (xe--, xe === 0) {
          var F = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ce({}, F, {
              value: he
            }),
            info: ce({}, F, {
              value: z
            }),
            warn: ce({}, F, {
              value: Y
            }),
            error: ce({}, F, {
              value: ae
            }),
            group: ce({}, F, {
              value: j
            }),
            groupCollapsed: ce({}, F, {
              value: X
            }),
            groupEnd: ce({}, F, {
              value: ie
            })
          });
        }
        xe < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ee = w.ReactCurrentDispatcher, ge;
    function pe(F, fe, we) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (et) {
            var Ze = et.stack.trim().match(/\n( *(at )?)/);
            ge = Ze && Ze[1] || "";
          }
        return `
` + ge + F;
      }
    }
    var Se = !1, de;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      de = new Ve();
    }
    function K(F, fe) {
      if (!F || Se)
        return "";
      {
        var we = de.get(F);
        if (we !== void 0)
          return we;
      }
      var Ze;
      Se = !0;
      var et = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var vt;
      vt = ee.current, ee.current = null, re();
      try {
        if (fe) {
          var lt = function() {
            throw Error();
          };
          if (Object.defineProperty(lt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(lt, []);
            } catch (an) {
              Ze = an;
            }
            Reflect.construct(F, [], lt);
          } else {
            try {
              lt.call();
            } catch (an) {
              Ze = an;
            }
            F.call(lt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (an) {
            Ze = an;
          }
          F();
        }
      } catch (an) {
        if (an && Ze && typeof an.stack == "string") {
          for (var nt = an.stack.split(`
`), cn = Ze.stack.split(`
`), Dt = nt.length - 1, Nt = cn.length - 1; Dt >= 1 && Nt >= 0 && nt[Dt] !== cn[Nt]; )
            Nt--;
          for (; Dt >= 1 && Nt >= 0; Dt--, Nt--)
            if (nt[Dt] !== cn[Nt]) {
              if (Dt !== 1 || Nt !== 1)
                do
                  if (Dt--, Nt--, Nt < 0 || nt[Dt] !== cn[Nt]) {
                    var Kt = `
` + nt[Dt].replace(" at new ", " at ");
                    return F.displayName && Kt.includes("<anonymous>") && (Kt = Kt.replace("<anonymous>", F.displayName)), typeof F == "function" && de.set(F, Kt), Kt;
                  }
                while (Dt >= 1 && Nt >= 0);
              break;
            }
        }
      } finally {
        Se = !1, ee.current = vt, te(), Error.prepareStackTrace = et;
      }
      var ao = F ? F.displayName || F.name : "", xn = ao ? pe(ao) : "";
      return typeof F == "function" && de.set(F, xn), xn;
    }
    function Ye(F, fe, we) {
      return K(F, !1);
    }
    function ve(F) {
      var fe = F.prototype;
      return !!(fe && fe.isReactComponent);
    }
    function ot(F, fe, we) {
      if (F == null)
        return "";
      if (typeof F == "function")
        return K(F, ve(F));
      if (typeof F == "string")
        return pe(F);
      switch (F) {
        case d:
          return pe("Suspense");
        case f:
          return pe("SuspenseList");
      }
      if (typeof F == "object")
        switch (F.$$typeof) {
          case c:
            return Ye(F.render);
          case p:
            return ot(F.type, fe, we);
          case g: {
            var Ze = F, et = Ze._payload, vt = Ze._init;
            try {
              return ot(vt(et), fe, we);
            } catch {
            }
          }
        }
      return "";
    }
    var Mt = Object.prototype.hasOwnProperty, ft = {}, un = w.ReactDebugCurrentFrame;
    function on(F) {
      if (F) {
        var fe = F._owner, we = ot(F.type, F._source, fe ? fe.type : null);
        un.setExtraStackFrame(we);
      } else
        un.setExtraStackFrame(null);
    }
    function Ct(F, fe, we, Ze, et) {
      {
        var vt = Function.call.bind(Mt);
        for (var lt in F)
          if (vt(F, lt)) {
            var nt = void 0;
            try {
              if (typeof F[lt] != "function") {
                var cn = Error((Ze || "React class") + ": " + we + " type `" + lt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof F[lt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw cn.name = "Invariant Violation", cn;
              }
              nt = F[lt](fe, lt, Ze, we, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Dt) {
              nt = Dt;
            }
            nt && !(nt instanceof Error) && (on(et), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ze || "React class", we, lt, typeof nt), on(null)), nt instanceof Error && !(nt.message in ft) && (ft[nt.message] = !0, on(et), I("Failed %s type: %s", we, nt.message), on(null));
          }
      }
    }
    var Pt = Array.isArray;
    function jt(F) {
      return Pt(F);
    }
    function Xt(F) {
      {
        var fe = typeof Symbol == "function" && Symbol.toStringTag, we = fe && F[Symbol.toStringTag] || F.constructor.name || "Object";
        return we;
      }
    }
    function tr(F) {
      try {
        return An(F), !1;
      } catch {
        return !0;
      }
    }
    function An(F) {
      return "" + F;
    }
    function $r(F) {
      if (tr(F))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(F)), An(F);
    }
    var vn = w.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, gt, zt, sn;
    sn = {};
    function Zn(F) {
      if (Mt.call(F, "ref")) {
        var fe = Object.getOwnPropertyDescriptor(F, "ref").get;
        if (fe && fe.isReactWarning)
          return !1;
      }
      return F.ref !== void 0;
    }
    function zr(F) {
      if (Mt.call(F, "key")) {
        var fe = Object.getOwnPropertyDescriptor(F, "key").get;
        if (fe && fe.isReactWarning)
          return !1;
      }
      return F.key !== void 0;
    }
    function Hi(F, fe) {
      if (typeof F.ref == "string" && vn.current && fe && vn.current.stateNode !== fe) {
        var we = ue(vn.current.type);
        sn[we] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ue(vn.current.type), F.ref), sn[we] = !0);
      }
    }
    function Fi(F, fe) {
      {
        var we = function() {
          gt || (gt = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", fe));
        };
        we.isReactWarning = !0, Object.defineProperty(F, "key", {
          get: we,
          configurable: !0
        });
      }
    }
    function nr(F, fe) {
      {
        var we = function() {
          zt || (zt = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", fe));
        };
        we.isReactWarning = !0, Object.defineProperty(F, "ref", {
          get: we,
          configurable: !0
        });
      }
    }
    var io = function(F, fe, we, Ze, et, vt, lt) {
      var nt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: F,
        key: fe,
        ref: we,
        props: lt,
        // Record the component responsible for creating this element.
        _owner: vt
      };
      return nt._store = {}, Object.defineProperty(nt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(nt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ze
      }), Object.defineProperty(nt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: et
      }), Object.freeze && (Object.freeze(nt.props), Object.freeze(nt)), nt;
    };
    function za(F, fe, we, Ze, et) {
      {
        var vt, lt = {}, nt = null, cn = null;
        we !== void 0 && ($r(we), nt = "" + we), zr(fe) && ($r(fe.key), nt = "" + fe.key), Zn(fe) && (cn = fe.ref, Hi(fe, et));
        for (vt in fe)
          Mt.call(fe, vt) && !me.hasOwnProperty(vt) && (lt[vt] = fe[vt]);
        if (F && F.defaultProps) {
          var Dt = F.defaultProps;
          for (vt in Dt)
            lt[vt] === void 0 && (lt[vt] = Dt[vt]);
        }
        if (nt || cn) {
          var Nt = typeof F == "function" ? F.displayName || F.name || "Unknown" : F;
          nt && Fi(lt, Nt), cn && nr(lt, Nt);
        }
        return io(F, nt, cn, et, Ze, vn.current, lt);
      }
    }
    var ti = w.ReactCurrentOwner, As = w.ReactDebugCurrentFrame;
    function mr(F) {
      if (F) {
        var fe = F._owner, we = ot(F.type, F._source, fe ? fe.type : null);
        As.setExtraStackFrame(we);
      } else
        As.setExtraStackFrame(null);
    }
    var Cr;
    Cr = !1;
    function ki(F) {
      return typeof F == "object" && F !== null && F.$$typeof === t;
    }
    function vr() {
      {
        if (ti.current) {
          var F = ue(ti.current.type);
          if (F)
            return `

Check the render method of \`` + F + "`.";
        }
        return "";
      }
    }
    function Wa(F) {
      {
        if (F !== void 0) {
          var fe = F.fileName.replace(/^.*[\\\/]/, ""), we = F.lineNumber;
          return `

Check your code at ` + fe + ":" + we + ".";
        }
        return "";
      }
    }
    var Ls = {};
    function Ms(F) {
      {
        var fe = vr();
        if (!fe) {
          var we = typeof F == "string" ? F : F.displayName || F.name;
          we && (fe = `

Check the top-level render call using <` + we + ">.");
        }
        return fe;
      }
    }
    function Ps(F, fe) {
      {
        if (!F._store || F._store.validated || F.key != null)
          return;
        F._store.validated = !0;
        var we = Ms(fe);
        if (Ls[we])
          return;
        Ls[we] = !0;
        var Ze = "";
        F && F._owner && F._owner !== ti.current && (Ze = " It was passed a child from " + ue(F._owner.type) + "."), mr(F), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', we, Ze), mr(null);
      }
    }
    function Es(F, fe) {
      {
        if (typeof F != "object")
          return;
        if (jt(F))
          for (var we = 0; we < F.length; we++) {
            var Ze = F[we];
            ki(Ze) && Ps(Ze, fe);
          }
        else if (ki(F))
          F._store && (F._store.validated = !0);
        else if (F) {
          var et = y(F);
          if (typeof et == "function" && et !== F.entries)
            for (var vt = et.call(F), lt; !(lt = vt.next()).done; )
              ki(lt.value) && Ps(lt.value, fe);
        }
      }
    }
    function rr(F) {
      {
        var fe = F.type;
        if (fe == null || typeof fe == "string")
          return;
        var we;
        if (typeof fe == "function")
          we = fe.propTypes;
        else if (typeof fe == "object" && (fe.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        fe.$$typeof === p))
          we = fe.propTypes;
        else
          return;
        if (we) {
          var Ze = ue(fe);
          Ct(we, F.props, "prop", Ze, F);
        } else if (fe.PropTypes !== void 0 && !Cr) {
          Cr = !0;
          var et = ue(fe);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", et || "Unknown");
        }
        typeof fe.getDefaultProps == "function" && !fe.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Bi(F) {
      {
        for (var fe = Object.keys(F.props), we = 0; we < fe.length; we++) {
          var Ze = fe[we];
          if (Ze !== "children" && Ze !== "key") {
            mr(F), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ze), mr(null);
            break;
          }
        }
        F.ref !== null && (mr(F), I("Invalid attribute `ref` supplied to `React.Fragment`."), mr(null));
      }
    }
    var Rs = {};
    function ni(F, fe, we, Ze, et, vt) {
      {
        var lt = Z(F);
        if (!lt) {
          var nt = "";
          (F === void 0 || typeof F == "object" && F !== null && Object.keys(F).length === 0) && (nt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var cn = Wa(et);
          cn ? nt += cn : nt += vr();
          var Dt;
          F === null ? Dt = "null" : jt(F) ? Dt = "array" : F !== void 0 && F.$$typeof === t ? (Dt = "<" + (ue(F.type) || "Unknown") + " />", nt = " Did you accidentally export a JSX literal instead of a component?") : Dt = typeof F, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Dt, nt);
        }
        var Nt = za(F, fe, we, et, vt);
        if (Nt == null)
          return Nt;
        if (lt) {
          var Kt = fe.children;
          if (Kt !== void 0)
            if (Ze)
              if (jt(Kt)) {
                for (var ao = 0; ao < Kt.length; ao++)
                  Es(Kt[ao], F);
                Object.freeze && Object.freeze(Kt);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Es(Kt, F);
        }
        if (Mt.call(fe, "key")) {
          var xn = ue(F), an = Object.keys(fe).filter(function(Oi) {
            return Oi !== "key";
          }), Di = an.length > 0 ? "{key: someKey, " + an.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Rs[xn + Di]) {
            var ri = an.length > 0 ? "{" + an.join(": ..., ") + ": ...}" : "{}";
            I(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Di, xn, ri, xn), Rs[xn + Di] = !0;
          }
        }
        return F === r ? Bi(Nt) : rr(Nt), Nt;
      }
    }
    function Ga(F, fe, we) {
      return ni(F, fe, we, !0);
    }
    function ja(F, fe, we) {
      return ni(F, fe, we, !1);
    }
    var so = ja, Xa = Ga;
    v1.Fragment = r, v1.jsx = so, v1.jsxs = Xa;
  }()), v1;
}
process.env.NODE_ENV === "production" ? y5.exports = xL() : y5.exports = SL();
var x = y5.exports;
function h2(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function wL() {
  return !!(globalThis != null && globalThis.document);
}
function Hp(e) {
  return e.parentElement && Hp(e.parentElement) ? !0 : e.hidden;
}
function IL(e) {
  const t = e.getAttribute("contenteditable");
  return t !== "false" && t != null;
}
function VL(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function AL(e) {
  var t;
  return ((t = Fp(e)) == null ? void 0 : t.defaultView) ?? window;
}
function Fp(e) {
  return h2(e) ? e.ownerDocument : document;
}
function LL(e) {
  return Fp(e).activeElement;
}
function ML(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...e };
  for (const r of t)
    if (r != null)
      for (const o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (o in n && delete n[o], n[o] = r[o]);
  return n;
}
const Ne = (e) => e ? "" : void 0, $o = (e) => e ? !0 : void 0;
function x5(e) {
  return Array.isArray(e);
}
function gn(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !x5(e);
}
function PL(e) {
  const t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function EL(e) {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}
function S5(e) {
  if (e == null)
    return e;
  const { unitless: t } = EL(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
const kp = (e, t) => parseInt(e[1], 10) > parseInt(t[1], 10) ? 1 : -1, Rf = (e) => Object.fromEntries(Object.entries(e).sort(kp));
function L7(e) {
  const t = Rf(e);
  return Object.assign(Object.values(t), t);
}
function RL(e) {
  const t = Object.keys(Rf(e));
  return new Set(t);
}
function M7(e) {
  if (!e)
    return e;
  e = S5(e) ?? e;
  const t = -0.02;
  return typeof e == "number" ? `${e + t}` : e.replace(/(\d+\.?\d*)/u, (n) => `${parseFloat(n) + t}`);
}
function E1(e, t) {
  const n = ["@media screen"];
  return e && n.push("and", `(min-width: ${S5(e)})`), t && n.push("and", `(max-width: ${S5(t)})`), n.join(" ");
}
function _L(e) {
  if (!e)
    return null;
  e.base = e.base ?? "0px";
  const t = L7(e), n = Object.entries(e).sort(kp).map(([i, a], u, c) => {
    let [, d] = c[u + 1] ?? [];
    return d = parseFloat(d) > 0 ? M7(d) : void 0, {
      _minW: M7(a),
      breakpoint: i,
      minW: a,
      maxW: d,
      maxWQuery: E1(null, d),
      minWQuery: E1(a),
      minMaxQuery: E1(a, d)
    };
  }), r = RL(e), o = Array.from(r.values());
  return {
    keys: r,
    normalized: t,
    isResponsive(i) {
      const a = Object.keys(i);
      return a.length > 0 && a.every((u) => r.has(u));
    },
    asObject: Rf(e),
    asArray: L7(e),
    details: n,
    get(i) {
      return n.find((a) => a.breakpoint === i);
    },
    media: [
      null,
      ...t.map((i) => E1(i)).slice(1)
    ],
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue(i) {
      if (!gn(i))
        throw new Error("toArrayValue: value must be an object");
      const a = o.map((u) => i[u] ?? null);
      for (; PL(a) === null; )
        a.pop();
      return a;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue(i) {
      if (!Array.isArray(i))
        throw new Error("toObjectValue: value must be an array");
      return i.reduce(
        (a, u, c) => {
          const d = o[c];
          return d != null && u != null && (a[d] = u), a;
        },
        {}
      );
    }
  };
}
function _f(...e) {
  return function(...n) {
    e.forEach((r) => r == null ? void 0 : r(...n));
  };
}
function We(...e) {
  return function(n) {
    e.some((r) => (r == null || r(n), n == null ? void 0 : n.defaultPrevented));
  };
}
function Bp(e) {
  return d2.toArray(e).filter(
    (t) => Da(t)
  );
}
function Tf(e) {
  const t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function TL(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function Bt(e = {}) {
  const {
    name: t,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: o = "Provider",
    errorMessage: i,
    defaultValue: a
  } = e, u = Nr(a);
  u.displayName = t;
  function c() {
    var f;
    const d = tn(u);
    if (!d && n) {
      const p = new Error(
        i ?? TL(r, o)
      );
      throw p.name = "ContextError", (f = Error.captureStackTrace) == null || f.call(Error, p, c), p;
    }
    return d;
  }
  return [u.Provider, c, u];
}
const _e = (...e) => e.filter(Boolean).join(" "), Dp = (e) => e.hasAttribute("tabindex"), HL = (e) => Dp(e) && e.tabIndex === -1;
function Op(e) {
  if (!h2(e) || Hp(e) || VL(e))
    return !1;
  const { localName: t } = e;
  if (["input", "select", "textarea", "button"].indexOf(t) >= 0)
    return !0;
  const r = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return t in r ? r[t]() : IL(e) ? !0 : Dp(e);
}
function FL(e) {
  return e ? h2(e) && Op(e) && !HL(e) : !1;
}
const kL = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
], BL = kL.join(), DL = (e) => e.offsetWidth > 0 && e.offsetHeight > 0;
function OL(e) {
  const t = Array.from(
    e.querySelectorAll(BL)
  );
  return t.unshift(e), t.filter((n) => Op(n) && DL(n));
}
function NL(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const ZL = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, i, a) => {
    if (typeof r > "u")
      return e(r, o, i);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const u = t.get(r);
    if (u.has(o))
      return u.get(o);
    const c = e(r, o, i, a);
    return u.set(o, c), c;
  };
}, Np = ZL(NL), $L = (e) => e.default || e;
function zL(e) {
  const { wasSelected: t, enabled: n, isSelected: r, mode: o = "unmount" } = e;
  return !!(!n || r || o === "keepMounted" && t);
}
function WL(e) {
  const t = parseFloat(e);
  return typeof t != "number" || Number.isNaN(t) ? 0 : t;
}
function Zp(e, t) {
  let n = WL(e);
  const r = 10 ** (t ?? 10);
  return n = Math.round(n * r) / r, t ? n.toFixed(t) : n.toString();
}
function P7(e) {
  if (!Number.isFinite(e))
    return 0;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n += 1;
  return n;
}
function GL(e, t, n) {
  return e == null ? e : (n < t && console.warn("clamp: max cannot be less than min"), Math.min(Math.max(e, t), n));
}
function p2(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function $p(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
function jL(e, t) {
  return Array.isArray(e) ? e.map((n) => n === null ? null : t(n)) : gn(e) ? Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {}) : e != null ? t(e) : null;
}
const XL = (e) => typeof e == "function";
function eo(e, ...t) {
  return XL(e) ? e(...t) : e;
}
function UL(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: n, overflowX: r, overflowY: o } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function YL(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function zp(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : h2(e) && UL(e) ? e : zp(YL(e));
}
function Wp(e, t) {
  const n = {}, r = {};
  for (const [o, i] of Object.entries(e))
    t.includes(o) ? n[o] = i : r[o] = i;
  return [n, r];
}
function JL(e, ...t) {
  const n = Object.getOwnPropertyDescriptors(e), r = Object.keys(n), o = (a) => {
    const u = {};
    for (let c = 0; c < a.length; c++) {
      const d = a[c];
      n[d] && (Object.defineProperty(u, d, n[d]), delete n[d]);
    }
    return u;
  }, i = (a) => o(Array.isArray(a) ? a : r.filter(a));
  return t.map(i).concat(o(r));
}
function E7(e, t, n = {}) {
  const { stop: r, getKey: o } = n;
  function i(a, u = []) {
    if (gn(a) || Array.isArray(a)) {
      const c = {};
      for (const [d, f] of Object.entries(a)) {
        const p = (o == null ? void 0 : o(d)) ?? d, g = [...u, p];
        if (r != null && r(a, g))
          return t(a, u);
        c[p] = i(f, g);
      }
      return c;
    }
    return t(a, u);
  }
  return i(e);
}
const vl = (e) => {
  const { condition: t, message: n } = e;
  t && process.env.NODE_ENV !== "production" && console.warn(n);
};
var kc = { exports: {} };
kc.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 800, i = 16, a = 9007199254740991, u = "[object Arguments]", c = "[object Array]", d = "[object AsyncFunction]", f = "[object Boolean]", p = "[object Date]", g = "[object Error]", m = "[object Function]", b = "[object GeneratorFunction]", v = "[object Map]", y = "[object Number]", w = "[object Null]", I = "[object Object]", V = "[object Proxy]", M = "[object RegExp]", L = "[object Set]", R = "[object String]", _ = "[object Undefined]", H = "[object WeakMap]", B = "[object ArrayBuffer]", Z = "[object DataView]", G = "[object Float32Array]", se = "[object Float64Array]", ue = "[object Int8Array]", ce = "[object Int16Array]", xe = "[object Int32Array]", he = "[object Uint8Array]", z = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", ae = "[object Uint32Array]", j = /[\\^$.*+?()[\]{}|]/g, X = /^\[object .+?Constructor\]$/, ie = /^(?:0|[1-9]\d*)$/, W = {};
  W[G] = W[se] = W[ue] = W[ce] = W[xe] = W[he] = W[z] = W[Y] = W[ae] = !0, W[u] = W[c] = W[B] = W[f] = W[Z] = W[p] = W[g] = W[m] = W[v] = W[y] = W[I] = W[M] = W[L] = W[R] = W[H] = !1;
  var re = typeof ko == "object" && ko && ko.Object === Object && ko, te = typeof self == "object" && self && self.Object === Object && self, ee = re || te || Function("return this")(), ge = t && !t.nodeType && t, pe = ge && !0 && e && !e.nodeType && e, Se = pe && pe.exports === ge, de = Se && re.process, Ve = function() {
    try {
      var E = pe && pe.require && pe.require("util").types;
      return E || de && de.binding && de.binding("util");
    } catch {
    }
  }(), K = Ve && Ve.isTypedArray;
  function Ye(E, D, U) {
    switch (U.length) {
      case 0:
        return E.call(D);
      case 1:
        return E.call(D, U[0]);
      case 2:
        return E.call(D, U[0], U[1]);
      case 3:
        return E.call(D, U[0], U[1], U[2]);
    }
    return E.apply(D, U);
  }
  function ve(E, D) {
    for (var U = -1, Ae = Array(E); ++U < E; )
      Ae[U] = D(U);
    return Ae;
  }
  function ot(E) {
    return function(D) {
      return E(D);
    };
  }
  function Mt(E, D) {
    return E == null ? void 0 : E[D];
  }
  function ft(E, D) {
    return function(U) {
      return E(D(U));
    };
  }
  var un = Array.prototype, on = Function.prototype, Ct = Object.prototype, Pt = ee["__core-js_shared__"], jt = on.toString, Xt = Ct.hasOwnProperty, tr = function() {
    var E = /[^.]+$/.exec(Pt && Pt.keys && Pt.keys.IE_PROTO || "");
    return E ? "Symbol(src)_1." + E : "";
  }(), An = Ct.toString, $r = jt.call(Object), vn = RegExp(
    "^" + jt.call(Xt).replace(j, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), me = Se ? ee.Buffer : void 0, gt = ee.Symbol, zt = ee.Uint8Array, sn = me ? me.allocUnsafe : void 0, Zn = ft(Object.getPrototypeOf, Object), zr = Object.create, Hi = Ct.propertyIsEnumerable, Fi = un.splice, nr = gt ? gt.toStringTag : void 0, io = function() {
    try {
      var E = Hs(Object, "defineProperty");
      return E({}, "", {}), E;
    } catch {
    }
  }(), za = me ? me.isBuffer : void 0, ti = Math.max, As = Date.now, mr = Hs(ee, "Map"), Cr = Hs(Object, "create"), ki = function() {
    function E() {
    }
    return function(D) {
      if (!Wr(D))
        return {};
      if (zr)
        return zr(D);
      E.prototype = D;
      var U = new E();
      return E.prototype = void 0, U;
    };
  }();
  function vr(E) {
    var D = -1, U = E == null ? 0 : E.length;
    for (this.clear(); ++D < U; ) {
      var Ae = E[D];
      this.set(Ae[0], Ae[1]);
    }
  }
  function Wa() {
    this.__data__ = Cr ? Cr(null) : {}, this.size = 0;
  }
  function Ls(E) {
    var D = this.has(E) && delete this.__data__[E];
    return this.size -= D ? 1 : 0, D;
  }
  function Ms(E) {
    var D = this.__data__;
    if (Cr) {
      var U = D[E];
      return U === r ? void 0 : U;
    }
    return Xt.call(D, E) ? D[E] : void 0;
  }
  function Ps(E) {
    var D = this.__data__;
    return Cr ? D[E] !== void 0 : Xt.call(D, E);
  }
  function Es(E, D) {
    var U = this.__data__;
    return this.size += this.has(E) ? 0 : 1, U[E] = Cr && D === void 0 ? r : D, this;
  }
  vr.prototype.clear = Wa, vr.prototype.delete = Ls, vr.prototype.get = Ms, vr.prototype.has = Ps, vr.prototype.set = Es;
  function rr(E) {
    var D = -1, U = E == null ? 0 : E.length;
    for (this.clear(); ++D < U; ) {
      var Ae = E[D];
      this.set(Ae[0], Ae[1]);
    }
  }
  function Bi() {
    this.__data__ = [], this.size = 0;
  }
  function Rs(E) {
    var D = this.__data__, U = xn(D, E);
    if (U < 0)
      return !1;
    var Ae = D.length - 1;
    return U == Ae ? D.pop() : Fi.call(D, U, 1), --this.size, !0;
  }
  function ni(E) {
    var D = this.__data__, U = xn(D, E);
    return U < 0 ? void 0 : D[U][1];
  }
  function Ga(E) {
    return xn(this.__data__, E) > -1;
  }
  function ja(E, D) {
    var U = this.__data__, Ae = xn(U, E);
    return Ae < 0 ? (++this.size, U.push([E, D])) : U[Ae][1] = D, this;
  }
  rr.prototype.clear = Bi, rr.prototype.delete = Rs, rr.prototype.get = ni, rr.prototype.has = Ga, rr.prototype.set = ja;
  function so(E) {
    var D = -1, U = E == null ? 0 : E.length;
    for (this.clear(); ++D < U; ) {
      var Ae = E[D];
      this.set(Ae[0], Ae[1]);
    }
  }
  function Xa() {
    this.size = 0, this.__data__ = {
      hash: new vr(),
      map: new (mr || rr)(),
      string: new vr()
    };
  }
  function F(E) {
    var D = Ts(this, E).delete(E);
    return this.size -= D ? 1 : 0, D;
  }
  function fe(E) {
    return Ts(this, E).get(E);
  }
  function we(E) {
    return Ts(this, E).has(E);
  }
  function Ze(E, D) {
    var U = Ts(this, E), Ae = U.size;
    return U.set(E, D), this.size += U.size == Ae ? 0 : 1, this;
  }
  so.prototype.clear = Xa, so.prototype.delete = F, so.prototype.get = fe, so.prototype.has = we, so.prototype.set = Ze;
  function et(E) {
    var D = this.__data__ = new rr(E);
    this.size = D.size;
  }
  function vt() {
    this.__data__ = new rr(), this.size = 0;
  }
  function lt(E) {
    var D = this.__data__, U = D.delete(E);
    return this.size = D.size, U;
  }
  function nt(E) {
    return this.__data__.get(E);
  }
  function cn(E) {
    return this.__data__.has(E);
  }
  function Dt(E, D) {
    var U = this.__data__;
    if (U instanceof rr) {
      var Ae = U.__data__;
      if (!mr || Ae.length < n - 1)
        return Ae.push([E, D]), this.size = ++U.size, this;
      U = this.__data__ = new so(Ae);
    }
    return U.set(E, D), this.size = U.size, this;
  }
  et.prototype.clear = vt, et.prototype.delete = lt, et.prototype.get = nt, et.prototype.has = cn, et.prototype.set = Dt;
  function Nt(E, D) {
    var U = Qa(E), Ae = !U && Ka(E), ut = !U && !Ae && eu(E), At = !U && !Ae && !ut && nu(E), Qe = U || Ae || ut || At, it = Qe ? ve(E.length, String) : [], mt = it.length;
    for (var _n in E)
      (D || Xt.call(E, _n)) && !(Qe && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_n == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ut && (_n == "offset" || _n == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      At && (_n == "buffer" || _n == "byteLength" || _n == "byteOffset") || // Skip index properties.
      Xl(_n, mt))) && it.push(_n);
    return it;
  }
  function Kt(E, D, U) {
    (U !== void 0 && !ks(E[D], U) || U === void 0 && !(D in E)) && an(E, D, U);
  }
  function ao(E, D, U) {
    var Ae = E[D];
    (!(Xt.call(E, D) && ks(Ae, U)) || U === void 0 && !(D in E)) && an(E, D, U);
  }
  function xn(E, D) {
    for (var U = E.length; U--; )
      if (ks(E[U][0], D))
        return U;
    return -1;
  }
  function an(E, D, U) {
    D == "__proto__" && io ? io(E, D, {
      configurable: !0,
      enumerable: !0,
      value: U,
      writable: !0
    }) : E[D] = U;
  }
  var Di = Gl();
  function ri(E) {
    return E == null ? E === void 0 ? _ : w : nr && nr in Object(E) ? jl(E) : Jl(E);
  }
  function Oi(E) {
    return Ni(E) && ri(E) == u;
  }
  function Dl(E) {
    if (!Wr(E) || qa(E))
      return !1;
    var D = e1(E) ? vn : X;
    return D.test(Ql(E));
  }
  function Ol(E) {
    return Ni(E) && tu(E.length) && !!W[ri(E)];
  }
  function z2(E) {
    if (!Wr(E))
      return Yl(E);
    var D = wo(E), U = [];
    for (var Ae in E)
      Ae == "constructor" && (D || !Xt.call(E, Ae)) || U.push(Ae);
    return U;
  }
  function Nl(E, D, U, Ae, ut) {
    E !== D && Di(D, function(At, Qe) {
      if (ut || (ut = new et()), Wr(At))
        W2(E, D, Qe, U, Nl, Ae, ut);
      else {
        var it = Ae ? Ae(Fs(E, Qe), At, Qe + "", E, D, ut) : void 0;
        it === void 0 && (it = At), Kt(E, Qe, it);
      }
    }, ru);
  }
  function W2(E, D, U, Ae, ut, At, Qe) {
    var it = Fs(E, U), mt = Fs(D, U), _n = Qe.get(mt);
    if (_n) {
      Kt(E, U, _n);
      return;
    }
    var Sn = At ? At(it, mt, U + "", E, D, Qe) : void 0, bn = Sn === void 0;
    if (bn) {
      var Ds = Qa(mt), Os = !Ds && eu(mt), t1 = !Ds && !Os && nu(mt);
      Sn = mt, Ds || Os || t1 ? Qa(it) ? Sn = it : U2(it) ? Sn = j2(it) : Os ? (bn = !1, Sn = $l(mt, !0)) : t1 ? (bn = !1, Sn = Ua(mt, !0)) : Sn = [] : Y2(mt) || Ka(mt) ? (Sn = it, Ka(it) ? Sn = J2(it) : (!Wr(it) || e1(it)) && (Sn = Ya(mt))) : bn = !1;
    }
    bn && (Qe.set(mt, Sn), ut(Sn, mt, Ae, At, Qe), Qe.delete(mt)), Kt(E, U, Sn);
  }
  function G2(E, D) {
    return ql(X2(E, D, ou), E + "");
  }
  var Zl = io ? function(E, D) {
    return io(E, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Et(D),
      writable: !0
    });
  } : ou;
  function $l(E, D) {
    if (D)
      return E.slice();
    var U = E.length, Ae = sn ? sn(U) : new E.constructor(U);
    return E.copy(Ae), Ae;
  }
  function zl(E) {
    var D = new E.constructor(E.byteLength);
    return new zt(D).set(new zt(E)), D;
  }
  function Ua(E, D) {
    var U = D ? zl(E.buffer) : E.buffer;
    return new E.constructor(U, E.byteOffset, E.length);
  }
  function j2(E, D) {
    var U = -1, Ae = E.length;
    for (D || (D = Array(Ae)); ++U < Ae; )
      D[U] = E[U];
    return D;
  }
  function Wl(E, D, U, Ae) {
    var ut = !U;
    U || (U = {});
    for (var At = -1, Qe = D.length; ++At < Qe; ) {
      var it = D[At], mt = Ae ? Ae(U[it], E[it], it, U, E) : void 0;
      mt === void 0 && (mt = E[it]), ut ? an(U, it, mt) : ao(U, it, mt);
    }
    return U;
  }
  function _s(E) {
    return G2(function(D, U) {
      var Ae = -1, ut = U.length, At = ut > 1 ? U[ut - 1] : void 0, Qe = ut > 2 ? U[2] : void 0;
      for (At = E.length > 3 && typeof At == "function" ? (ut--, At) : void 0, Qe && Ul(U[0], U[1], Qe) && (At = ut < 3 ? void 0 : At, ut = 1), D = Object(D); ++Ae < ut; ) {
        var it = U[Ae];
        it && E(D, it, Ae, At);
      }
      return D;
    });
  }
  function Gl(E) {
    return function(D, U, Ae) {
      for (var ut = -1, At = Object(D), Qe = Ae(D), it = Qe.length; it--; ) {
        var mt = Qe[E ? it : ++ut];
        if (U(At[mt], mt, At) === !1)
          break;
      }
      return D;
    };
  }
  function Ts(E, D) {
    var U = E.__data__;
    return Ja(D) ? U[typeof D == "string" ? "string" : "hash"] : U.map;
  }
  function Hs(E, D) {
    var U = Mt(E, D);
    return Dl(U) ? U : void 0;
  }
  function jl(E) {
    var D = Xt.call(E, nr), U = E[nr];
    try {
      E[nr] = void 0;
      var Ae = !0;
    } catch {
    }
    var ut = An.call(E);
    return Ae && (D ? E[nr] = U : delete E[nr]), ut;
  }
  function Ya(E) {
    return typeof E.constructor == "function" && !wo(E) ? ki(Zn(E)) : {};
  }
  function Xl(E, D) {
    var U = typeof E;
    return D = D ?? a, !!D && (U == "number" || U != "symbol" && ie.test(E)) && E > -1 && E % 1 == 0 && E < D;
  }
  function Ul(E, D, U) {
    if (!Wr(U))
      return !1;
    var Ae = typeof D;
    return (Ae == "number" ? Bs(U) && Xl(D, U.length) : Ae == "string" && D in U) ? ks(U[D], E) : !1;
  }
  function Ja(E) {
    var D = typeof E;
    return D == "string" || D == "number" || D == "symbol" || D == "boolean" ? E !== "__proto__" : E === null;
  }
  function qa(E) {
    return !!tr && tr in E;
  }
  function wo(E) {
    var D = E && E.constructor, U = typeof D == "function" && D.prototype || Ct;
    return E === U;
  }
  function Yl(E) {
    var D = [];
    if (E != null)
      for (var U in Object(E))
        D.push(U);
    return D;
  }
  function Jl(E) {
    return An.call(E);
  }
  function X2(E, D, U) {
    return D = ti(D === void 0 ? E.length - 1 : D, 0), function() {
      for (var Ae = arguments, ut = -1, At = ti(Ae.length - D, 0), Qe = Array(At); ++ut < At; )
        Qe[ut] = Ae[D + ut];
      ut = -1;
      for (var it = Array(D + 1); ++ut < D; )
        it[ut] = Ae[ut];
      return it[D] = U(Qe), Ye(E, this, it);
    };
  }
  function Fs(E, D) {
    if (!(D === "constructor" && typeof E[D] == "function") && D != "__proto__")
      return E[D];
  }
  var ql = Kl(Zl);
  function Kl(E) {
    var D = 0, U = 0;
    return function() {
      var Ae = As(), ut = i - (Ae - U);
      if (U = Ae, ut > 0) {
        if (++D >= o)
          return arguments[0];
      } else
        D = 0;
      return E.apply(void 0, arguments);
    };
  }
  function Ql(E) {
    if (E != null) {
      try {
        return jt.call(E);
      } catch {
      }
      try {
        return E + "";
      } catch {
      }
    }
    return "";
  }
  function ks(E, D) {
    return E === D || E !== E && D !== D;
  }
  var Ka = Oi(function() {
    return arguments;
  }()) ? Oi : function(E) {
    return Ni(E) && Xt.call(E, "callee") && !Hi.call(E, "callee");
  }, Qa = Array.isArray;
  function Bs(E) {
    return E != null && tu(E.length) && !e1(E);
  }
  function U2(E) {
    return Ni(E) && Bs(E);
  }
  var eu = za || q2;
  function e1(E) {
    if (!Wr(E))
      return !1;
    var D = ri(E);
    return D == m || D == b || D == d || D == V;
  }
  function tu(E) {
    return typeof E == "number" && E > -1 && E % 1 == 0 && E <= a;
  }
  function Wr(E) {
    var D = typeof E;
    return E != null && (D == "object" || D == "function");
  }
  function Ni(E) {
    return E != null && typeof E == "object";
  }
  function Y2(E) {
    if (!Ni(E) || ri(E) != I)
      return !1;
    var D = Zn(E);
    if (D === null)
      return !0;
    var U = Xt.call(D, "constructor") && D.constructor;
    return typeof U == "function" && U instanceof U && jt.call(U) == $r;
  }
  var nu = K ? ot(K) : Ol;
  function J2(E) {
    return Wl(E, ru(E));
  }
  function ru(E) {
    return Bs(E) ? Nt(E, !0) : z2(E);
  }
  var _t = _s(function(E, D, U, Ae) {
    Nl(E, D, U, Ae);
  });
  function Et(E) {
    return function() {
      return E;
    };
  }
  function ou(E) {
    return E;
  }
  function q2() {
    return !1;
  }
  e.exports = _t;
})(kc, kc.exports);
var qL = kc.exports;
const Tr = /* @__PURE__ */ Ef(qL);
function pn(e, t = []) {
  const n = Le(e);
  return Ue(() => {
    n.current = e;
  }), q((...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, t);
}
function N1(e, t, n, r) {
  const o = pn(n);
  return Ue(() => {
    const i = typeof e == "function" ? e() : e ?? document;
    if (!(!n || !i))
      return i.addEventListener(t, o, r), () => {
        i.removeEventListener(t, o, r);
      };
  }, [t, e, r, o, n]), () => {
    const i = typeof e == "function" ? e() : e ?? document;
    i == null || i.removeEventListener(t, o, r);
  };
}
function KL(e) {
  const { isOpen: t, ref: n } = e, [r, o] = Ee(t), [i, a] = Ee(!1);
  return Ue(() => {
    i || (o(t), a(!0));
  }, [t, i, r]), N1(
    () => n.current,
    "animationend",
    () => {
      o(t);
    }
  ), {
    present: !(t ? !1 : !r),
    onComplete() {
      var f;
      const c = AL(n.current), d = new c.CustomEvent("animationend", { bubbles: !0 });
      (f = n.current) == null || f.dispatchEvent(d);
    }
  };
}
function Gp(e) {
  const {
    value: t,
    defaultValue: n,
    onChange: r,
    shouldUpdate: o = (g, m) => g !== m
  } = e, i = pn(r), a = pn(o), [u, c] = Ee(n), d = t !== void 0, f = d ? t : u, p = pn(
    (g) => {
      const b = typeof g == "function" ? g(f) : g;
      a(f, b) && (d || c(b), i(b));
    },
    [d, i, f, a]
  );
  return [f, p];
}
function QL(e = {}) {
  const {
    onChange: t,
    precision: n,
    defaultValue: r,
    value: o,
    step: i = 1,
    min: a = Number.MIN_SAFE_INTEGER,
    max: u = Number.MAX_SAFE_INTEGER,
    keepWithinRange: c = !0
  } = e, d = pn(t), [f, p] = Ee(() => r == null ? "" : rd(r, i, n) ?? ""), g = typeof o < "u", m = g ? o : f, b = jp(gi(m), i), v = n ?? b, y = q(
    (Z) => {
      Z !== m && (g || p(Z.toString()), d == null || d(Z.toString(), gi(Z)));
    },
    [d, g, m]
  ), w = q(
    (Z) => {
      let G = Z;
      return c && (G = GL(G, a, u)), Zp(G, v);
    },
    [v, c, u, a]
  ), I = q(
    (Z = i) => {
      let G;
      m === "" ? G = gi(Z) : G = gi(m) + Z, G = w(G), y(G);
    },
    [w, i, y, m]
  ), V = q(
    (Z = i) => {
      let G;
      m === "" ? G = gi(-Z) : G = gi(m) - Z, G = w(G), y(G);
    },
    [w, i, y, m]
  ), M = q(() => {
    let Z;
    r == null ? Z = "" : Z = rd(r, i, n) ?? a, y(Z);
  }, [r, n, i, y, a]), L = q(
    (Z) => {
      const G = rd(Z, i, v) ?? a;
      y(G);
    },
    [v, i, y, a]
  ), R = gi(m);
  return {
    isOutOfRange: R > u || R < a,
    isAtMax: R === u,
    isAtMin: R === a,
    precision: v,
    value: m,
    valueAsNumber: R,
    update: y,
    reset: M,
    increment: I,
    decrement: V,
    clamp: w,
    cast: L,
    setValue: p
  };
}
function gi(e) {
  return parseFloat(e.toString().replace(/[^\w.-]+/g, ""));
}
function jp(e, t) {
  return Math.max(P7(t), P7(e));
}
function rd(e, t, n) {
  const r = gi(e);
  if (Number.isNaN(r))
    return;
  const o = jp(r, t);
  return Zp(r, n ?? o);
}
function Xp(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: o
  } = e, i = pn(n), a = pn(t), [u, c] = Ee(e.defaultIsOpen || !1), d = r !== void 0 ? r : u, f = r !== void 0, p = Zr(), g = o ?? `disclosure-${p}`, m = q(() => {
    f || c(!1), a == null || a();
  }, [f, a]), b = q(() => {
    f || c(!0), i == null || i();
  }, [f, i]), v = q(() => {
    d ? m() : b();
  }, [d, b, m]);
  function y(I = {}) {
    return {
      ...I,
      "aria-expanded": d,
      "aria-controls": g,
      onClick(V) {
        var M;
        (M = I.onClick) == null || M.call(I, V), v();
      }
    };
  }
  function w(I = {}) {
    return {
      ...I,
      hidden: !d,
      id: g
    };
  }
  return {
    isOpen: d,
    onOpen: b,
    onClose: m,
    onToggle: v,
    isControlled: f,
    getButtonProps: y,
    getDisclosureProps: w
  };
}
const wi = globalThis != null && globalThis.document ? Oa : Ue, fs = (e, t) => {
  const n = Le(!1), r = Le(!1);
  Ue(() => {
    if (n.current && r.current)
      return e();
    r.current = !0;
  }, t), Ue(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
};
function eM(e) {
  const t = e.current;
  if (!t)
    return !1;
  const n = LL(t);
  return !n || t.contains(n) ? !1 : !!FL(n);
}
function tM(e, t) {
  const { shouldFocus: n, visible: r, focusRef: o } = t, i = n && !r;
  fs(() => {
    if (!i || eM(e))
      return;
    const a = (o == null ? void 0 : o.current) || e.current;
    let u;
    if (a)
      return u = requestAnimationFrame(() => {
        a.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(u);
      };
  }, [i, e, o]);
}
function nM(e, t) {
  const n = Zr();
  return at(
    () => e || [t, n].filter(Boolean).join("-"),
    [e, t, n]
  );
}
function rM(e, ...t) {
  const n = nM(e);
  return at(() => t.map((r) => `${r}-${n}`), [n, t]);
}
function oM(e, t) {
  const n = pn(e);
  Ue(() => {
    let r = null;
    const o = () => n();
    return t !== null && (r = window.setInterval(o, t)), () => {
      r && window.clearInterval(r);
    };
  }, [t, n]);
}
function iM(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function mn(...e) {
  return (t) => {
    e.forEach((n) => {
      iM(n, t);
    });
  };
}
function sM(e) {
  const { ref: t, handler: n, enabled: r = !0 } = e, o = pn(n), a = Le({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  Ue(() => {
    if (!r)
      return;
    const u = (p) => {
      od(p, t) && (a.isPointerDown = !0);
    }, c = (p) => {
      if (a.ignoreEmulatedMouseEvents) {
        a.ignoreEmulatedMouseEvents = !1;
        return;
      }
      a.isPointerDown && n && od(p, t) && (a.isPointerDown = !1, o(p));
    }, d = (p) => {
      a.ignoreEmulatedMouseEvents = !0, n && a.isPointerDown && od(p, t) && (a.isPointerDown = !1, o(p));
    }, f = Up(t.current);
    return f.addEventListener("mousedown", u, !0), f.addEventListener("mouseup", c, !0), f.addEventListener("touchstart", u, !0), f.addEventListener("touchend", d, !0), () => {
      f.removeEventListener("mousedown", u, !0), f.removeEventListener("mouseup", c, !0), f.removeEventListener("touchstart", u, !0), f.removeEventListener("touchend", d, !0);
    };
  }, [n, t, o, a, r]);
}
function od(e, t) {
  var r, o;
  const n = ((r = e.composedPath) == null ? void 0 : r.call(e)[0]) ?? e.target;
  return n && !Up(n).contains(n) ? !1 : !((o = t.current) != null && o.contains(n));
}
function Up(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function aM(e, t) {
  const n = pn(e);
  Ue(() => {
    if (t == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, t), () => {
      r && window.clearTimeout(r);
    };
  }, [t, n]);
}
const hn = {
  open: (e, t) => `${e}[data-open], ${e}[open], ${e}[data-state=open] ${t}`,
  closed: (e, t) => `${e}[data-closed], ${e}[data-state=closed] ${t}`,
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, fo = (e) => Yp((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), To = (e) => Yp((t) => e(t, "~ &"), "[data-peer]", ".peer"), Yp = (e, ...t) => t.map(e).join(", "), va = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within, &[data-focus-within]",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty, &[data-empty]",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
   */
  _groupOpen: fo(hn.open),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
   */
  _groupClosed: fo(hn.closed),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: fo(hn.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: To(hn.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: fo(hn.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: To(hn.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: fo(hn.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: To(hn.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: fo(hn.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: To(hn.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: fo(hn.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: To(hn.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: fo(hn.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: To(hn.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: fo(hn.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: To(hn.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: fo(hn.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: To(hn.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: To(hn.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder, &[data-placeholder]",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen, &[data-fullscreen]",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]",
  /**
   * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
   */
  _open: "&[data-open], &[open], &[data-state=open]",
  /**
   * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
   */
  _closed: "&[data-closed], &[data-state=closed]",
  /**
   * Styles for the CSS Selector `&[data-complete]`
   */
  _complete: "&[data-complete]",
  /**
   * Styles for the CSS Selector `&[data-incomplete]`
   */
  _incomplete: "&[data-incomplete]",
  /**
   * Styles for the CSS Selector `&[data-current]`
   */
  _current: "&[data-current]"
}, Jp = Object.keys(
  va
), lM = (e) => /!(important)?$/.test(e), R7 = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, uM = (e, t) => (n) => {
  const r = String(t), o = lM(r), i = R7(r), a = e ? `${e}.${i}` : i;
  let u = gn(n.__cssMap) && a in n.__cssMap ? n.__cssMap[a].varRef : t;
  return u = R7(u), o ? `${u} !important` : u;
};
function Hf(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (i, a) => {
    const u = uM(t, i)(a);
    let c = (n == null ? void 0 : n(u, a)) ?? u;
    return r && (c = r(c, a)), c;
  };
}
const Wu = (...e) => (t) => e.reduce((n, r) => r(n), t);
function Ar(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = Hf({
      scale: e,
      transform: t
    }), r;
  };
}
const cM = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function dM(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: cM(t),
    transform: n ? Hf({
      scale: n,
      compose: r
    }) : r
  };
}
const qp = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function fM() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...qp
  ].join(" ");
}
function hM() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...qp
  ].join(" ");
}
const pM = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, gM = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function mM(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
const CM = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, w5 = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, vM = new Set(Object.values(w5)), I5 = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), bM = (e) => e.trim();
function yM(e, t) {
  if (e == null || I5.has(e))
    return e;
  if (!(V5(e) || I5.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), i = o == null ? void 0 : o[1], a = o == null ? void 0 : o[2];
  if (!i || !a)
    return e;
  const u = i.includes("-gradient") ? i : `${i}-gradient`, [c, ...d] = a.split(",").map(bM).filter(Boolean);
  if ((d == null ? void 0 : d.length) === 0)
    return e;
  const f = c in w5 ? w5[c] : c;
  d.unshift(f);
  const p = d.map((g) => {
    if (vM.has(g))
      return g;
    const m = g.indexOf(" "), [b, v] = m !== -1 ? [g.substr(0, m), g.substr(m + 1)] : [g], y = V5(v) ? v : v && v.split(" "), w = `colors.${b}`, I = w in t.__cssMap ? t.__cssMap[w].varRef : b;
    return y ? [
      I,
      ...Array.isArray(y) ? y : [y]
    ].join(" ") : I;
  });
  return `${u}(${p.join(", ")})`;
}
const V5 = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), xM = (e, t) => yM(e, t ?? {});
function SM(e) {
  return /^var\(--.+\)$/.test(e);
}
const wM = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, ho = (e) => (t) => `${e}(${t})`, pt = {
  filter(e) {
    return e !== "auto" ? e : pM;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : gM;
  },
  ring(e) {
    return mM(pt.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? fM() : e === "auto-gpu" ? hM() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = wM(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (SM(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: xM,
  blur: ho("blur"),
  opacity: ho("opacity"),
  brightness: ho("brightness"),
  contrast: ho("contrast"),
  dropShadow: ho("drop-shadow"),
  grayscale: ho("grayscale"),
  hueRotate: (e) => ho("hue-rotate")(pt.degree(e)),
  invert: ho("invert"),
  saturate: ho("saturate"),
  sepia: ho("sepia"),
  bgImage(e) {
    return e == null || V5(e) || I5.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    const { space: t, divide: n } = CM[e] ?? {}, r = { flexDirection: e };
    return t && (r[t] = 1), n && (r[n] = 1), r;
  }
}, O = {
  borderWidths: Ar("borderWidths"),
  borderStyles: Ar("borderStyles"),
  colors: Ar("colors"),
  borders: Ar("borders"),
  gradients: Ar("gradients", pt.gradient),
  radii: Ar("radii", pt.px),
  space: Ar("space", Wu(pt.vh, pt.px)),
  spaceT: Ar("space", Wu(pt.vh, pt.px)),
  degreeT(e) {
    return { property: e, transform: pt.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: Hf({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: Ar("sizes", Wu(pt.vh, pt.px)),
  sizesT: Ar("sizes", Wu(pt.vh, pt.fraction)),
  shadows: Ar("shadows"),
  logical: dM,
  blur: Ar("blur", pt.blur)
}, bc = {
  background: O.colors("background"),
  backgroundColor: O.colors("backgroundColor"),
  backgroundImage: O.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: pt.bgClip },
  bgSize: O.prop("backgroundSize"),
  bgPosition: O.prop("backgroundPosition"),
  bg: O.colors("background"),
  bgColor: O.colors("backgroundColor"),
  bgPos: O.prop("backgroundPosition"),
  bgRepeat: O.prop("backgroundRepeat"),
  bgAttachment: O.prop("backgroundAttachment"),
  bgGradient: O.gradients("backgroundImage"),
  bgClip: { transform: pt.bgClip }
};
Object.assign(bc, {
  bgImage: bc.backgroundImage,
  bgImg: bc.backgroundImage
});
const yt = {
  border: O.borders("border"),
  borderWidth: O.borderWidths("borderWidth"),
  borderStyle: O.borderStyles("borderStyle"),
  borderColor: O.colors("borderColor"),
  borderRadius: O.radii("borderRadius"),
  borderTop: O.borders("borderTop"),
  borderBlockStart: O.borders("borderBlockStart"),
  borderTopLeftRadius: O.radii("borderTopLeftRadius"),
  borderStartStartRadius: O.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: O.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: O.radii("borderTopRightRadius"),
  borderStartEndRadius: O.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: O.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: O.borders("borderRight"),
  borderInlineEnd: O.borders("borderInlineEnd"),
  borderBottom: O.borders("borderBottom"),
  borderBlockEnd: O.borders("borderBlockEnd"),
  borderBottomLeftRadius: O.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: O.radii("borderBottomRightRadius"),
  borderLeft: O.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: O.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: O.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: O.borders(["borderLeft", "borderRight"]),
  borderInline: O.borders("borderInline"),
  borderY: O.borders(["borderTop", "borderBottom"]),
  borderBlock: O.borders("borderBlock"),
  borderTopWidth: O.borderWidths("borderTopWidth"),
  borderBlockStartWidth: O.borderWidths("borderBlockStartWidth"),
  borderTopColor: O.colors("borderTopColor"),
  borderBlockStartColor: O.colors("borderBlockStartColor"),
  borderTopStyle: O.borderStyles("borderTopStyle"),
  borderBlockStartStyle: O.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: O.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: O.borderWidths("borderBlockEndWidth"),
  borderBottomColor: O.colors("borderBottomColor"),
  borderBlockEndColor: O.colors("borderBlockEndColor"),
  borderBottomStyle: O.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: O.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: O.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: O.borderWidths("borderInlineStartWidth"),
  borderLeftColor: O.colors("borderLeftColor"),
  borderInlineStartColor: O.colors("borderInlineStartColor"),
  borderLeftStyle: O.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: O.borderStyles("borderInlineStartStyle"),
  borderRightWidth: O.borderWidths("borderRightWidth"),
  borderInlineEndWidth: O.borderWidths("borderInlineEndWidth"),
  borderRightColor: O.colors("borderRightColor"),
  borderInlineEndColor: O.colors("borderInlineEndColor"),
  borderRightStyle: O.borderStyles("borderRightStyle"),
  borderInlineEndStyle: O.borderStyles("borderInlineEndStyle"),
  borderTopRadius: O.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: O.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: O.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: O.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(yt, {
  rounded: yt.borderRadius,
  roundedTop: yt.borderTopRadius,
  roundedTopLeft: yt.borderTopLeftRadius,
  roundedTopRight: yt.borderTopRightRadius,
  roundedTopStart: yt.borderStartStartRadius,
  roundedTopEnd: yt.borderStartEndRadius,
  roundedBottom: yt.borderBottomRadius,
  roundedBottomLeft: yt.borderBottomLeftRadius,
  roundedBottomRight: yt.borderBottomRightRadius,
  roundedBottomStart: yt.borderEndStartRadius,
  roundedBottomEnd: yt.borderEndEndRadius,
  roundedLeft: yt.borderLeftRadius,
  roundedRight: yt.borderRightRadius,
  roundedStart: yt.borderInlineStartRadius,
  roundedEnd: yt.borderInlineEndRadius,
  borderStart: yt.borderInlineStart,
  borderEnd: yt.borderInlineEnd,
  borderTopStartRadius: yt.borderStartStartRadius,
  borderTopEndRadius: yt.borderStartEndRadius,
  borderBottomStartRadius: yt.borderEndStartRadius,
  borderBottomEndRadius: yt.borderEndEndRadius,
  borderStartRadius: yt.borderInlineStartRadius,
  borderEndRadius: yt.borderInlineEndRadius,
  borderStartWidth: yt.borderInlineStartWidth,
  borderEndWidth: yt.borderInlineEndWidth,
  borderStartColor: yt.borderInlineStartColor,
  borderEndColor: yt.borderInlineEndColor,
  borderStartStyle: yt.borderInlineStartStyle,
  borderEndStyle: yt.borderInlineEndStyle
});
const IM = {
  color: O.colors("color"),
  textColor: O.colors("color"),
  fill: O.colors("fill"),
  stroke: O.colors("stroke"),
  accentColor: O.colors("accentColor"),
  textFillColor: O.colors("textFillColor")
}, Bc = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: pt.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: O.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: O.space("gap"),
  rowGap: O.space("rowGap"),
  columnGap: O.space("columnGap")
};
Object.assign(Bc, {
  flexDir: Bc.flexDirection
});
const Mr = {
  width: O.sizesT("width"),
  inlineSize: O.sizesT("inlineSize"),
  height: O.sizes("height"),
  blockSize: O.sizes("blockSize"),
  boxSize: O.sizes(["width", "height"]),
  minWidth: O.sizes("minWidth"),
  minInlineSize: O.sizes("minInlineSize"),
  minHeight: O.sizes("minHeight"),
  minBlockSize: O.sizes("minBlockSize"),
  maxWidth: O.sizes("maxWidth"),
  maxInlineSize: O.sizes("maxInlineSize"),
  maxHeight: O.sizes("maxHeight"),
  maxBlockSize: O.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, i;
      return { [`@media screen and (min-width: ${((i = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : i.minW) ?? e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, i;
      return { [`@media screen and (max-width: ${((i = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : i._minW) ?? e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: O.propT("float", pt.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Mr, {
  w: Mr.width,
  h: Mr.height,
  minW: Mr.minWidth,
  maxW: Mr.maxWidth,
  minH: Mr.minHeight,
  maxH: Mr.maxHeight,
  overscroll: Mr.overscrollBehavior,
  overscrollX: Mr.overscrollBehaviorX,
  overscrollY: Mr.overscrollBehaviorY
});
const VM = {
  filter: { transform: pt.filter },
  blur: O.blur("--chakra-blur"),
  brightness: O.propT("--chakra-brightness", pt.brightness),
  contrast: O.propT("--chakra-contrast", pt.contrast),
  hueRotate: O.propT("--chakra-hue-rotate", pt.hueRotate),
  invert: O.propT("--chakra-invert", pt.invert),
  saturate: O.propT("--chakra-saturate", pt.saturate),
  dropShadow: O.propT("--chakra-drop-shadow", pt.dropShadow),
  backdropFilter: { transform: pt.backdropFilter },
  backdropBlur: O.blur("--chakra-backdrop-blur"),
  backdropBrightness: O.propT(
    "--chakra-backdrop-brightness",
    pt.brightness
  ),
  backdropContrast: O.propT("--chakra-backdrop-contrast", pt.contrast),
  backdropHueRotate: O.propT(
    "--chakra-backdrop-hue-rotate",
    pt.hueRotate
  ),
  backdropInvert: O.propT("--chakra-backdrop-invert", pt.invert),
  backdropSaturate: O.propT("--chakra-backdrop-saturate", pt.saturate)
}, AM = {
  ring: { transform: pt.ring },
  ringColor: O.colors("--chakra-ring-color"),
  ringOffset: O.prop("--chakra-ring-offset-width"),
  ringOffsetColor: O.colors("--chakra-ring-offset-color"),
  ringInset: O.prop("--chakra-ring-inset")
}, LM = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: pt.outline },
  outlineOffset: !0,
  outlineColor: O.colors("outlineColor")
}, Kp = {
  gridGap: O.space("gridGap"),
  gridColumnGap: O.space("gridColumnGap"),
  gridRowGap: O.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
};
function MM(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const PM = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, i, a) => {
    if (typeof r > "u")
      return e(r, o, i);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const u = t.get(r);
    if (u.has(o))
      return u.get(o);
    const c = e(r, o, i, a);
    return u.set(o, c), c;
  };
}, EM = PM(MM), RM = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, _M = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, id = (e, t, n) => {
  const r = {}, o = EM(e, t, {});
  for (const i in o)
    i in n && n[i] != null || (r[i] = o[i]);
  return r;
}, TM = {
  srOnly: {
    transform(e) {
      return e === !0 ? RM : e === "focusable" ? _M : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => id(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => id(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => id(t, e, n)
  }
}, Z1 = {
  position: !0,
  pos: O.prop("position"),
  zIndex: O.prop("zIndex", "zIndices"),
  inset: O.spaceT("inset"),
  insetX: O.spaceT(["left", "right"]),
  insetInline: O.spaceT("insetInline"),
  insetY: O.spaceT(["top", "bottom"]),
  insetBlock: O.spaceT("insetBlock"),
  top: O.spaceT("top"),
  insetBlockStart: O.spaceT("insetBlockStart"),
  bottom: O.spaceT("bottom"),
  insetBlockEnd: O.spaceT("insetBlockEnd"),
  left: O.spaceT("left"),
  insetInlineStart: O.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: O.spaceT("right"),
  insetInlineEnd: O.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(Z1, {
  insetStart: Z1.insetInlineStart,
  insetEnd: Z1.insetInlineEnd
});
const A5 = {
  boxShadow: O.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: O.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: O.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(A5, {
  shadow: A5.boxShadow
});
const Ot = {
  margin: O.spaceT("margin"),
  marginTop: O.spaceT("marginTop"),
  marginBlockStart: O.spaceT("marginBlockStart"),
  marginRight: O.spaceT("marginRight"),
  marginInlineEnd: O.spaceT("marginInlineEnd"),
  marginBottom: O.spaceT("marginBottom"),
  marginBlockEnd: O.spaceT("marginBlockEnd"),
  marginLeft: O.spaceT("marginLeft"),
  marginInlineStart: O.spaceT("marginInlineStart"),
  marginX: O.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: O.spaceT("marginInline"),
  marginY: O.spaceT(["marginTop", "marginBottom"]),
  marginBlock: O.spaceT("marginBlock"),
  padding: O.space("padding"),
  paddingTop: O.space("paddingTop"),
  paddingBlockStart: O.space("paddingBlockStart"),
  paddingRight: O.space("paddingRight"),
  paddingBottom: O.space("paddingBottom"),
  paddingBlockEnd: O.space("paddingBlockEnd"),
  paddingLeft: O.space("paddingLeft"),
  paddingInlineStart: O.space("paddingInlineStart"),
  paddingInlineEnd: O.space("paddingInlineEnd"),
  paddingX: O.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: O.space("paddingInline"),
  paddingY: O.space(["paddingTop", "paddingBottom"]),
  paddingBlock: O.space("paddingBlock")
};
Object.assign(Ot, {
  m: Ot.margin,
  mt: Ot.marginTop,
  mr: Ot.marginRight,
  me: Ot.marginInlineEnd,
  marginEnd: Ot.marginInlineEnd,
  mb: Ot.marginBottom,
  ml: Ot.marginLeft,
  ms: Ot.marginInlineStart,
  marginStart: Ot.marginInlineStart,
  mx: Ot.marginX,
  my: Ot.marginY,
  p: Ot.padding,
  pt: Ot.paddingTop,
  py: Ot.paddingY,
  px: Ot.paddingX,
  pb: Ot.paddingBottom,
  pl: Ot.paddingLeft,
  ps: Ot.paddingInlineStart,
  paddingStart: Ot.paddingInlineStart,
  pr: Ot.paddingRight,
  pe: Ot.paddingInlineEnd,
  paddingEnd: Ot.paddingInlineEnd
});
const HM = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: O.spaceT("scrollMargin"),
  scrollMarginTop: O.spaceT("scrollMarginTop"),
  scrollMarginBottom: O.spaceT("scrollMarginBottom"),
  scrollMarginLeft: O.spaceT("scrollMarginLeft"),
  scrollMarginRight: O.spaceT("scrollMarginRight"),
  scrollMarginX: O.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: O.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: O.spaceT("scrollPadding"),
  scrollPaddingTop: O.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: O.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: O.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: O.spaceT("scrollPaddingRight"),
  scrollPaddingX: O.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: O.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
}, FM = {
  fontFamily: O.prop("fontFamily", "fonts"),
  fontSize: O.prop("fontSize", "fontSizes", pt.px),
  fontWeight: O.prop("fontWeight", "fontWeights"),
  lineHeight: O.prop("lineHeight", "lineHeights"),
  letterSpacing: O.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, kM = {
  textDecorationColor: O.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: O.shadows("textShadow")
}, BM = {
  clipPath: !0,
  transform: O.propT("transform", pt.transform),
  transformOrigin: !0,
  translateX: O.spaceT("--chakra-translate-x"),
  translateY: O.spaceT("--chakra-translate-y"),
  skewX: O.degreeT("--chakra-skew-x"),
  skewY: O.degreeT("--chakra-skew-y"),
  scaleX: O.prop("--chakra-scale-x"),
  scaleY: O.prop("--chakra-scale-y"),
  scale: O.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: O.degreeT("--chakra-rotate")
}, DM = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: O.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: O.prop("listStyleImage")
}, OM = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: O.prop("transitionDuration", "transition.duration"),
  transitionProperty: O.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: O.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, Ff = Tr(
  {},
  bc,
  yt,
  IM,
  Bc,
  Mr,
  VM,
  AM,
  LM,
  Kp,
  TM,
  Z1,
  A5,
  Ot,
  HM,
  FM,
  kM,
  BM,
  DM,
  OM
), NM = Object.assign({}, Ot, Mr, Bc, Kp, Z1), Qp = Object.keys(
  NM
), ZM = [...Object.keys(Ff), ...Jp], $M = { ...Ff, ...va }, zM = (e) => e in $M, WM = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: n, toArrayValue: r, media: o } = t.__breakpoints, i = {};
  for (const a in e) {
    let u = eo(e[a], t);
    if (u == null)
      continue;
    if (u = gn(u) && n(u) ? r(u) : u, !Array.isArray(u)) {
      i[a] = u;
      continue;
    }
    const c = u.slice(0, o.length).length;
    for (let d = 0; d < c; d += 1) {
      const f = o == null ? void 0 : o[d];
      if (!f) {
        i[a] = u[d];
        continue;
      }
      i[f] = i[f] || {}, u[d] != null && (i[f][a] = u[d]);
    }
  }
  return i;
};
function GM(e) {
  const t = [];
  let n = "", r = !1;
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    i === "(" ? (r = !0, n += i) : i === ")" ? (r = !1, n += i) : i === "," && !r ? (t.push(n), n = "") : n += i;
  }
  return n = n.trim(), n && t.push(n), t;
}
function jM(e) {
  return /^var\(--.+\)$/.test(e);
}
const XM = (e, t) => e.startsWith("--") && typeof t == "string" && !jM(t), UM = (e, t) => {
  if (t == null)
    return t;
  const n = (a) => {
    var u, c;
    return (c = (u = e.__cssMap) == null ? void 0 : u[a]) == null ? void 0 : c.varRef;
  }, r = (a) => n(a) ?? a, [o, i] = GM(t);
  return t = n(o) ?? r(i) ?? r(t), t;
};
function YM(e) {
  const { configs: t = {}, pseudos: n = {}, theme: r } = e, o = (i, a = !1) => {
    var f;
    const u = eo(i, r), c = WM(u)(r);
    let d = {};
    for (let p in c) {
      const g = c[p];
      let m = eo(g, r);
      p in n && (p = n[p]), XM(p, m) && (m = UM(r, m));
      let b = t[p];
      if (b === !0 && (b = { property: p }), gn(m)) {
        d[p] = d[p] ?? {}, d[p] = Tr(
          {},
          d[p],
          o(m, !0)
        );
        continue;
      }
      let v = ((f = b == null ? void 0 : b.transform) == null ? void 0 : f.call(b, m, r, u)) ?? m;
      v = b != null && b.processResult ? o(v, !0) : v;
      const y = eo(b == null ? void 0 : b.property, r);
      if (!a && (b != null && b.static)) {
        const w = eo(b.static, r);
        d = Tr({}, d, w);
      }
      if (y && Array.isArray(y)) {
        for (const w of y)
          d[w] = v;
        continue;
      }
      if (y) {
        y === "&" && gn(v) ? d = Tr({}, d, v) : d[y] = v;
        continue;
      }
      if (gn(v)) {
        d = Tr({}, d, v);
        continue;
      }
      d[p] = v;
    }
    return d;
  };
  return o;
}
const eg = (e) => (t) => YM({
  theme: t,
  pseudos: va,
  configs: Ff
})(e);
function Rt(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function JM(e, t, n) {
  var r, o;
  return ((o = (r = e.__cssMap) == null ? void 0 : r[`${t}.${n}`]) == null ? void 0 : o.varRef) ?? n;
}
function qM(e, t) {
  if (Array.isArray(e))
    return e;
  if (gn(e))
    return t(e);
  if (e != null)
    return [e];
}
function KM(e, t) {
  for (let n = t + 1; n < e.length; n++)
    if (e[n] != null)
      return n;
  return -1;
}
function QM(e) {
  const t = e.__breakpoints;
  return function(r, o, i, a) {
    var g, m;
    if (!t)
      return;
    const u = {}, c = qM(i, t.toArrayValue);
    if (!c)
      return u;
    const d = c.length, f = d === 1, p = !!r.parts;
    for (let b = 0; b < d; b++) {
      const v = t.details[b], y = t.details[KM(c, b)], w = E1(v.minW, y == null ? void 0 : y._minW), I = eo((g = r[o]) == null ? void 0 : g[c[b]], a);
      if (I) {
        if (p) {
          (m = r.parts) == null || m.forEach((V) => {
            Tr(u, {
              [V]: f ? I[V] : { [w]: I[V] }
            });
          });
          continue;
        }
        if (!p) {
          f ? Tr(u, I) : u[w] = I;
          continue;
        }
        u[w] = I;
      }
    }
    return u;
  };
}
function eP(e) {
  return (t) => {
    const { variant: n, size: r, theme: o } = t, i = QM(o);
    return Tr(
      {},
      eo(e.baseStyle ?? {}, t),
      i(e, "sizes", r, t),
      i(e, "variants", n, t)
    );
  };
}
function rn(e) {
  return p2(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function tg(e) {
  return gn(e) && e.reference ? e.reference : String(e);
}
const g2 = (e, ...t) => t.map(tg).join(` ${e} `).replace(/calc/g, ""), _7 = (...e) => `calc(${g2("+", ...e)})`, T7 = (...e) => `calc(${g2("-", ...e)})`, L5 = (...e) => `calc(${g2("*", ...e)})`, H7 = (...e) => `calc(${g2("/", ...e)})`, F7 = (e) => {
  const t = tg(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : L5(t, -1);
}, Bo = Object.assign(
  (e) => ({
    add: (...t) => Bo(_7(e, ...t)),
    subtract: (...t) => Bo(T7(e, ...t)),
    multiply: (...t) => Bo(L5(e, ...t)),
    divide: (...t) => Bo(H7(e, ...t)),
    negate: () => Bo(F7(e)),
    toString: () => e.toString()
  }),
  {
    add: _7,
    subtract: T7,
    multiply: L5,
    divide: H7,
    negate: F7
  }
);
function tP(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function nP(e) {
  const t = tP(e.toString());
  return oP(rP(t));
}
function rP(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function oP(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function iP(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function sP(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function aP(e, t = "") {
  return nP(`--${iP(e, t)}`);
}
function De(e, t, n) {
  const r = aP(e, n);
  return {
    variable: r,
    reference: sP(r, t)
  };
}
function lP(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [o, i] = r;
      n[o] = De(`${e}-${o}`, i);
      continue;
    }
    n[r] = De(`${e}-${r}`);
  }
  return n;
}
const uP = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function cP(e) {
  return $p(e, uP);
}
function dP(e) {
  return e.semanticTokens;
}
function fP(e) {
  const { __cssMap: t, __cssVars: n, __breakpoints: r, ...o } = e;
  return o;
}
function hP(e) {
  const t = cP(e), n = dP(e), r = (i) => (
    // @ts-ignore
    Jp.includes(i) || i === "default"
  ), o = {};
  return E7(t, (i, a) => {
    i != null && (o[a.join(".")] = { isSemantic: !1, value: i });
  }), E7(
    n,
    (i, a) => {
      i != null && (o[a.join(".")] = { isSemantic: !0, value: i });
    },
    {
      stop: (i) => Object.keys(i).every(r)
    }
  ), o;
}
function k7(e, t) {
  return De(String(e).replace(/\./g, "-"), void 0, t);
}
function pP(e) {
  var a;
  const t = hP(e), n = (a = e.config) == null ? void 0 : a.cssVarPrefix;
  let r = {};
  const o = {};
  function i(u, c) {
    const f = [String(u).split(".")[0], c].join(".");
    if (!t[f])
      return c;
    const { reference: g } = k7(f, n);
    return g;
  }
  for (const [u, c] of Object.entries(t)) {
    const { isSemantic: d, value: f } = c, { variable: p, reference: g } = k7(u, n);
    if (!d) {
      if (u.startsWith("space")) {
        const b = u.split("."), [v, ...y] = b, w = `${v}.-${y.join(".")}`, I = Bo.negate(f), V = Bo.negate(g);
        o[w] = {
          value: I,
          var: p,
          varRef: V
        };
      }
      r[p] = f, o[u] = {
        value: f,
        var: p,
        varRef: g
      };
      continue;
    }
    const m = gn(f) ? f : { default: f };
    r = Tr(
      r,
      Object.entries(m).reduce(
        (b, [v, y]) => {
          if (!y)
            return b;
          const w = i(u, `${y}`);
          if (v === "default")
            return b[p] = w, b;
          const I = (va == null ? void 0 : va[v]) ?? v;
          return b[I] = { [p]: w }, b;
        },
        {}
      )
    ), o[u] = {
      value: g,
      var: p,
      varRef: g
    };
  }
  return {
    cssVars: r,
    cssMap: o
  };
}
function gP(e) {
  const t = fP(e), {
    /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */
    cssMap: n,
    /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */
    cssVars: r
  } = pP(t);
  return Object.assign(t, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...r },
    __cssMap: n,
    __breakpoints: _L(t.breakpoints)
  }), t;
}
function St(e, t = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function o(...f) {
    r();
    for (const p of f)
      t[p] = c(p);
    return St(e, t);
  }
  function i(...f) {
    for (const p of f)
      p in t || (t[p] = c(p));
    return St(e, t);
  }
  function a() {
    return Object.fromEntries(
      Object.entries(t).map(([p, g]) => [p, g.selector])
    );
  }
  function u() {
    return Object.fromEntries(
      Object.entries(t).map(([p, g]) => [p, g.className])
    );
  }
  function c(f) {
    const m = `chakra-${(["container", "root"].includes(f ?? "") ? [e] : [e, f]).filter(Boolean).join("__")}`;
    return {
      className: m,
      selector: `.${m}`,
      toString: () => f
    };
  }
  return {
    parts: o,
    toPart: c,
    extend: i,
    selectors: a,
    classnames: u,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
const mP = St("accordion").parts(
  "root",
  "container",
  "button",
  "panel",
  "icon"
), CP = St("alert").parts(
  "title",
  "description",
  "container",
  "icon",
  "spinner"
), vP = St("avatar").parts(
  "label",
  "badge",
  "container",
  "excessLabel",
  "group"
), bP = St("breadcrumb").parts(
  "link",
  "item",
  "container",
  "separator"
);
St("button").parts();
const yP = St("checkbox").parts(
  "control",
  "icon",
  "container",
  "label"
);
St("progress").parts(
  "track",
  "filledTrack",
  "label"
);
const xP = St("drawer").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), SP = St("editable").parts(
  "preview",
  "input",
  "textarea"
), wP = St("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), IP = St("formError").parts("text", "icon"), VP = St("input").parts(
  "addon",
  "field",
  "element",
  "group"
), AP = St("list").parts("container", "item", "icon"), LP = St("menu").parts(
  "button",
  "list",
  "item",
  "groupTitle",
  "icon",
  "command",
  "divider"
), MP = St("modal").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), PP = St("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
St("pininput").parts("field");
const ng = St("popover").parts(
  "content",
  "header",
  "body",
  "footer",
  "popper",
  "arrow",
  "closeButton"
), EP = St("progress").parts(
  "label",
  "filledTrack",
  "track"
), RP = St("radio").parts(
  "container",
  "control",
  "label"
), _P = St("select").parts("field", "icon"), TP = St("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), HP = St("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), FP = St("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
), kP = St("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), BP = St("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), DP = St("tag").parts(
  "container",
  "label",
  "closeButton"
), OP = St("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
St("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
const { definePartsStyle: NP, defineMultiStyleConfig: ZP } = Rt(mP.keys), $P = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, zP = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, WP = {
  pt: "2",
  px: "4",
  pb: "5"
}, GP = {
  fontSize: "1.25em"
}, jP = NP({
  container: $P,
  button: zP,
  panel: WP,
  icon: GP
}), XP = ZP({ baseStyle: jP });
function ts(e, t, n) {
  return Math.min(Math.max(e, n), t);
}
class UP extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var R1 = UP;
function kf(e) {
  if (typeof e != "string")
    throw new R1(e);
  if (e.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let t = e.trim();
  t = nE.test(e) ? qP(e) : e;
  const n = KP.exec(t);
  if (n) {
    const a = Array.from(n).slice(1);
    return [...a.slice(0, 3).map((u) => parseInt(il(u, 2), 16)), parseInt(il(a[3] || "f", 2), 16) / 255];
  }
  const r = QP.exec(t);
  if (r) {
    const a = Array.from(r).slice(1);
    return [...a.slice(0, 3).map((u) => parseInt(u, 16)), parseInt(a[3] || "ff", 16) / 255];
  }
  const o = eE.exec(t);
  if (o) {
    const a = Array.from(o).slice(1);
    return [...a.slice(0, 3).map((u) => parseInt(u, 10)), parseFloat(a[3] || "1")];
  }
  const i = tE.exec(t);
  if (i) {
    const [a, u, c, d] = Array.from(i).slice(1).map(parseFloat);
    if (ts(0, 100, u) !== u)
      throw new R1(e);
    if (ts(0, 100, c) !== c)
      throw new R1(e);
    return [...rE(a, u, c), Number.isNaN(d) ? 1 : d];
  }
  throw new R1(e);
}
function YP(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0) % 2341;
}
const B7 = (e) => parseInt(e.replace(/_/g, ""), 36), JP = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((e, t) => {
  const n = B7(t.substring(0, 3)), r = B7(t.substring(3)).toString(16);
  let o = "";
  for (let i = 0; i < 6 - r.length; i++)
    o += "0";
  return e[n] = `${o}${r}`, e;
}, {});
function qP(e) {
  const t = e.toLowerCase().trim(), n = JP[YP(t)];
  if (!n)
    throw new R1(e);
  return `#${n}`;
}
const il = (e, t) => Array.from(Array(t)).map(() => e).join(""), KP = new RegExp(`^#${il("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), QP = new RegExp(`^#${il("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), eE = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${il(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), tE = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, nE = /^[a-z]+$/i, D7 = (e) => Math.round(e * 255), rE = (e, t, n) => {
  let r = n / 100;
  if (t === 0)
    return [r, r, r].map(D7);
  const o = (e % 360 + 360) % 360 / 60, i = (1 - Math.abs(2 * r - 1)) * (t / 100), a = i * (1 - Math.abs(o % 2 - 1));
  let u = 0, c = 0, d = 0;
  o >= 0 && o < 1 ? (u = i, c = a) : o >= 1 && o < 2 ? (u = a, c = i) : o >= 2 && o < 3 ? (c = i, d = a) : o >= 3 && o < 4 ? (c = a, d = i) : o >= 4 && o < 5 ? (u = a, d = i) : o >= 5 && o < 6 && (u = i, d = a);
  const f = r - i / 2, p = u + f, g = c + f, m = d + f;
  return [p, g, m].map(D7);
};
function oE(e, t, n, r) {
  return `rgba(${ts(0, 255, e).toFixed()}, ${ts(0, 255, t).toFixed()}, ${ts(0, 255, n).toFixed()}, ${parseFloat(ts(0, 1, r).toFixed(3))})`;
}
function iE(e, t) {
  const [n, r, o, i] = kf(e);
  return oE(n, r, o, i - t);
}
function sE(e) {
  const [t, n, r, o] = kf(e);
  let i = (a) => {
    const u = ts(0, 255, a).toString(16);
    return u.length === 1 ? `0${u}` : u;
  };
  return `#${i(t)}${i(n)}${i(r)}${o < 1 ? i(Math.round(o * 255)) : ""}`;
}
const aE = (e) => Object.keys(e).length === 0;
function lE(e, t, n, r, o) {
  for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++)
    e = e ? e[t[r]] : o;
  return e === o ? n : e;
}
const Dn = (e, t, n) => {
  const r = lE(e, `colors.${t}`, t);
  try {
    return sE(r), r;
  } catch {
    return n ?? "#000000";
  }
}, uE = (e) => {
  const [t, n, r] = kf(e);
  return (t * 299 + n * 587 + r * 114) / 1e3;
}, cE = (e) => (t) => {
  const n = Dn(t, e);
  return uE(n) < 128 ? "dark" : "light";
}, dE = (e) => (t) => cE(e)(t) === "dark", Aa = (e, t) => (n) => {
  const r = Dn(n, e);
  return iE(r, 1 - t);
};
function O7(e = "1rem", t = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${t} 25%,
    transparent 25%,
    transparent 50%,
    ${t} 50%,
    ${t} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${e} ${e}`
  };
}
const fE = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function hE(e) {
  const t = fE();
  return !e || aE(e) ? t : e.string && e.colors ? gE(e.string, e.colors) : e.string && !e.colors ? pE(e.string) : e.colors && !e.string ? mE(e.colors) : t;
}
function pE(e) {
  let t = 0;
  if (e.length === 0)
    return t.toString();
  for (let r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const o = t >> r * 8 & 255;
    n += `00${o.toString(16)}`.substr(-2);
  }
  return n;
}
function gE(e, t) {
  let n = 0;
  if (e.length === 0)
    return t[0];
  for (let r = 0; r < e.length; r += 1)
    n = e.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % t.length + t.length) % t.length, t[n];
}
function mE(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function ke(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function Bf(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t ? t === "vertical" ? n : r : {};
}
function rg(e) {
  return gn(e) && e.reference ? e.reference : String(e);
}
const m2 = (e, ...t) => t.map(rg).join(` ${e} `).replace(/calc/g, ""), N7 = (...e) => `calc(${m2("+", ...e)})`, Z7 = (...e) => `calc(${m2("-", ...e)})`, M5 = (...e) => `calc(${m2("*", ...e)})`, $7 = (...e) => `calc(${m2("/", ...e)})`, z7 = (e) => {
  const t = rg(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : M5(t, -1);
}, Do = Object.assign(
  (e) => ({
    add: (...t) => Do(N7(e, ...t)),
    subtract: (...t) => Do(Z7(e, ...t)),
    multiply: (...t) => Do(M5(e, ...t)),
    divide: (...t) => Do($7(e, ...t)),
    negate: () => Do(z7(e)),
    toString: () => e.toString()
  }),
  {
    add: N7,
    subtract: Z7,
    multiply: M5,
    divide: $7,
    negate: z7
  }
);
function CE(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function vE(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function og(e) {
  const t = vE(e.toString());
  return t.includes("\\.") ? e : CE(e) ? t.replace(".", "\\.") : e;
}
function bE(e, t = "") {
  return [t, og(e)].filter(Boolean).join("-");
}
function yE(e, t) {
  return `var(${og(e)}${t ? `, ${t}` : ""})`;
}
function xE(e, t = "") {
  return `--${bE(e, t)}`;
}
function Cn(e, t) {
  const n = xE(e, t == null ? void 0 : t.prefix);
  return {
    variable: n,
    reference: yE(n, SE(t == null ? void 0 : t.fallback))
  };
}
function SE(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
const { definePartsStyle: bl, defineMultiStyleConfig: wE } = Rt(CP.keys), fr = De("alert-fg"), Uo = De("alert-bg"), IE = bl({
  container: {
    bg: Uo.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: fr.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: fr.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function Df(e) {
  const { theme: t, colorScheme: n } = e, r = Aa(`${n}.200`, 0.16)(t);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
const VE = bl((e) => {
  const { colorScheme: t } = e, n = Df(e);
  return {
    container: {
      [fr.variable]: `colors.${t}.600`,
      [Uo.variable]: n.light,
      _dark: {
        [fr.variable]: `colors.${t}.200`,
        [Uo.variable]: n.dark
      }
    }
  };
}), AE = bl((e) => {
  const { colorScheme: t } = e, n = Df(e);
  return {
    container: {
      [fr.variable]: `colors.${t}.600`,
      [Uo.variable]: n.light,
      _dark: {
        [fr.variable]: `colors.${t}.200`,
        [Uo.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: fr.reference
    }
  };
}), LE = bl((e) => {
  const { colorScheme: t } = e, n = Df(e);
  return {
    container: {
      [fr.variable]: `colors.${t}.600`,
      [Uo.variable]: n.light,
      _dark: {
        [fr.variable]: `colors.${t}.200`,
        [Uo.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: fr.reference
    }
  };
}), ME = bl((e) => {
  const { colorScheme: t } = e;
  return {
    container: {
      [fr.variable]: "colors.white",
      [Uo.variable]: `colors.${t}.600`,
      _dark: {
        [fr.variable]: "colors.gray.900",
        [Uo.variable]: `colors.${t}.200`
      },
      color: fr.reference
    }
  };
}), PE = {
  subtle: VE,
  "left-accent": AE,
  "top-accent": LE,
  solid: ME
}, EE = wE({
  baseStyle: IE,
  variants: PE,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), ig = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, RE = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, _E = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, sg = {
  ...ig,
  ...RE,
  container: _E
}, TE = (e) => typeof e == "function";
function On(e, ...t) {
  return TE(e) ? e(...t) : e;
}
const { definePartsStyle: ag, defineMultiStyleConfig: HE } = Rt(vP.keys), ba = De("avatar-border-color"), $1 = De("avatar-bg"), sl = De("avatar-font-size"), La = De("avatar-size"), FE = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: ba.reference,
  [ba.variable]: "white",
  _dark: {
    [ba.variable]: "colors.gray.800"
  }
}, kE = {
  bg: $1.reference,
  fontSize: sl.reference,
  width: La.reference,
  height: La.reference,
  lineHeight: "1",
  [$1.variable]: "colors.gray.200",
  _dark: {
    [$1.variable]: "colors.whiteAlpha.400"
  }
}, BE = (e) => {
  const { name: t, theme: n } = e, r = t ? hE({ string: t }) : "colors.gray.400", o = dE(r)(n);
  let i = "white";
  return o || (i = "gray.800"), {
    bg: $1.reference,
    fontSize: sl.reference,
    color: i,
    borderColor: ba.reference,
    verticalAlign: "top",
    width: La.reference,
    height: La.reference,
    "&:not([data-loaded])": {
      [$1.variable]: r
    },
    [ba.variable]: "colors.white",
    _dark: {
      [ba.variable]: "colors.gray.800"
    }
  };
}, DE = {
  fontSize: sl.reference,
  lineHeight: "1"
}, OE = ag((e) => ({
  badge: On(FE, e),
  excessLabel: On(kE, e),
  container: On(BE, e),
  label: DE
}));
function hi(e) {
  const t = e !== "100%" ? sg[e] : void 0;
  return ag({
    container: {
      [La.variable]: t ?? e,
      [sl.variable]: `calc(${t ?? e} / 2.5)`
    },
    excessLabel: {
      [La.variable]: t ?? e,
      [sl.variable]: `calc(${t ?? e} / 2.5)`
    }
  });
}
const NE = {
  "2xs": hi(4),
  xs: hi(6),
  sm: hi(8),
  md: hi(12),
  lg: hi(16),
  xl: hi(24),
  "2xl": hi(32),
  full: hi("100%")
}, ZE = HE({
  baseStyle: OE,
  sizes: NE,
  defaultProps: {
    size: "md"
  }
}), nn = lP("badge", ["bg", "color", "shadow"]), $E = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: nn.bg.reference,
  color: nn.color.reference,
  boxShadow: nn.shadow.reference
}, zE = (e) => {
  const { colorScheme: t, theme: n } = e, r = Aa(`${t}.500`, 0.6)(n);
  return {
    [nn.bg.variable]: `colors.${t}.500`,
    [nn.color.variable]: "colors.white",
    _dark: {
      [nn.bg.variable]: r,
      [nn.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, WE = (e) => {
  const { colorScheme: t, theme: n } = e, r = Aa(`${t}.200`, 0.16)(n);
  return {
    [nn.bg.variable]: `colors.${t}.100`,
    [nn.color.variable]: `colors.${t}.800`,
    _dark: {
      [nn.bg.variable]: r,
      [nn.color.variable]: `colors.${t}.200`
    }
  };
}, GE = (e) => {
  const { colorScheme: t, theme: n } = e, r = Aa(`${t}.200`, 0.8)(n);
  return {
    [nn.color.variable]: `colors.${t}.500`,
    _dark: {
      [nn.color.variable]: r
    },
    [nn.shadow.variable]: `inset 0 0 0px 1px ${nn.color.reference}`
  };
}, jE = {
  solid: zE,
  subtle: WE,
  outline: GE
}, z1 = {
  baseStyle: $E,
  variants: jE,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: XE, definePartsStyle: UE } = Rt(bP.keys), sd = De("breadcrumb-link-decor"), YE = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: sd.reference,
  [sd.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [sd.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, JE = UE({
  link: YE
}), qE = XE({
  baseStyle: JE
}), KE = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, lg = (e) => {
  const { colorScheme: t, theme: n } = e;
  if (t === "gray")
    return {
      color: ke("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: ke("gray.100", "whiteAlpha.200")(e)
      },
      _active: { bg: ke("gray.200", "whiteAlpha.300")(e) }
    };
  const r = Aa(`${t}.200`, 0.12)(n), o = Aa(`${t}.200`, 0.24)(n);
  return {
    color: ke(`${t}.600`, `${t}.200`)(e),
    bg: "transparent",
    _hover: {
      bg: ke(`${t}.50`, r)(e)
    },
    _active: {
      bg: ke(`${t}.100`, o)(e)
    }
  };
}, QE = (e) => {
  const { colorScheme: t } = e, n = ke("gray.200", "whiteAlpha.300")(e);
  return {
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...On(lg, e)
  };
}, eR = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, tR = (e) => {
  const { colorScheme: t } = e;
  if (t === "gray") {
    const u = ke("gray.100", "whiteAlpha.200")(e);
    return {
      bg: u,
      color: ke("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: ke("gray.200", "whiteAlpha.300")(e),
        _disabled: {
          bg: u
        }
      },
      _active: { bg: ke("gray.300", "whiteAlpha.400")(e) }
    };
  }
  const {
    bg: n = `${t}.500`,
    color: r = "white",
    hoverBg: o = `${t}.600`,
    activeBg: i = `${t}.700`
  } = eR[t] ?? {}, a = ke(n, `${t}.200`)(e);
  return {
    bg: a,
    color: ke(r, "gray.800")(e),
    _hover: {
      bg: ke(o, `${t}.300`)(e),
      _disabled: {
        bg: a
      }
    },
    _active: { bg: ke(i, `${t}.400`)(e) }
  };
}, nR = (e) => {
  const { colorScheme: t } = e;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: ke(`${t}.500`, `${t}.200`)(e),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: ke(`${t}.700`, `${t}.500`)(e)
    }
  };
}, rR = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, oR = {
  ghost: lg,
  outline: QE,
  solid: tR,
  link: nR,
  unstyled: rR
}, iR = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, sR = {
  baseStyle: KE,
  variants: oR,
  sizes: iR,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: ss, defineMultiStyleConfig: aR } = Rt(OP.keys), Dc = De("card-bg"), zo = De("card-padding"), ug = De("card-shadow"), yc = De("card-radius"), cg = De("card-border-width", "0"), dg = De("card-border-color"), lR = ss({
  container: {
    [Dc.variable]: "colors.chakra-body-bg",
    backgroundColor: Dc.reference,
    boxShadow: ug.reference,
    borderRadius: yc.reference,
    color: "chakra-body-text",
    borderWidth: cg.reference,
    borderColor: dg.reference
  },
  body: {
    padding: zo.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: zo.reference
  },
  footer: {
    padding: zo.reference
  }
}), uR = {
  sm: ss({
    container: {
      [yc.variable]: "radii.base",
      [zo.variable]: "space.3"
    }
  }),
  md: ss({
    container: {
      [yc.variable]: "radii.md",
      [zo.variable]: "space.5"
    }
  }),
  lg: ss({
    container: {
      [yc.variable]: "radii.xl",
      [zo.variable]: "space.7"
    }
  })
}, cR = {
  elevated: ss({
    container: {
      [ug.variable]: "shadows.base",
      _dark: {
        [Dc.variable]: "colors.gray.700"
      }
    }
  }),
  outline: ss({
    container: {
      [cg.variable]: "1px",
      [dg.variable]: "colors.chakra-border-color"
    }
  }),
  filled: ss({
    container: {
      [Dc.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [zo.variable]: 0
    },
    header: {
      [zo.variable]: 0
    },
    footer: {
      [zo.variable]: 0
    }
  }
}, dR = aR({
  baseStyle: lR,
  variants: cR,
  sizes: uR,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), { definePartsStyle: xc, defineMultiStyleConfig: fR } = Rt(yP.keys), W1 = De("checkbox-size"), hR = (e) => {
  const { colorScheme: t } = e;
  return {
    w: W1.reference,
    h: W1.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: ke(`${t}.500`, `${t}.200`)(e),
      borderColor: ke(`${t}.500`, `${t}.200`)(e),
      color: ke("white", "gray.900")(e),
      _hover: {
        bg: ke(`${t}.600`, `${t}.300`)(e),
        borderColor: ke(`${t}.600`, `${t}.300`)(e)
      },
      _disabled: {
        borderColor: ke("gray.200", "transparent")(e),
        bg: ke("gray.200", "whiteAlpha.300")(e),
        color: ke("gray.500", "whiteAlpha.500")(e)
      }
    },
    _indeterminate: {
      bg: ke(`${t}.500`, `${t}.200`)(e),
      borderColor: ke(`${t}.500`, `${t}.200`)(e),
      color: ke("white", "gray.900")(e)
    },
    _disabled: {
      bg: ke("gray.100", "whiteAlpha.100")(e),
      borderColor: ke("gray.100", "transparent")(e)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: ke("red.500", "red.300")(e)
    }
  };
}, pR = {
  _disabled: { cursor: "not-allowed" }
}, gR = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, mR = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, CR = xc((e) => ({
  icon: mR,
  container: pR,
  control: On(hR, e),
  label: gR
})), vR = {
  sm: xc({
    control: { [W1.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: xc({
    control: { [W1.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: xc({
    control: { [W1.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, vi = fR({
  baseStyle: CR,
  sizes: vR,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), G1 = Cn("close-button-size"), b1 = Cn("close-button-bg"), bR = {
  w: [G1.reference],
  h: [G1.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [b1.variable]: "colors.blackAlpha.100",
    _dark: {
      [b1.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [b1.variable]: "colors.blackAlpha.200",
    _dark: {
      [b1.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: b1.reference
}, yR = {
  lg: {
    [G1.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [G1.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [G1.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, xR = {
  baseStyle: bR,
  sizes: yR,
  defaultProps: {
    size: "md"
  }
}, { variants: SR, defaultProps: wR } = z1, IR = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: nn.bg.reference,
  color: nn.color.reference,
  boxShadow: nn.shadow.reference
}, VR = {
  baseStyle: IR,
  variants: SR,
  defaultProps: wR
}, AR = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, LR = {
  baseStyle: AR
}, MR = {
  opacity: 0.6,
  borderColor: "inherit"
}, PR = {
  borderStyle: "solid"
}, ER = {
  borderStyle: "dashed"
}, RR = {
  solid: PR,
  dashed: ER
}, _R = {
  baseStyle: MR,
  variants: RR,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: P5, defineMultiStyleConfig: TR } = Rt(xP.keys), ad = De("drawer-bg"), ld = De("drawer-box-shadow");
function Qs(e) {
  return P5(e === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: e }
  });
}
const HR = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, FR = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, kR = (e) => {
  const { isFullHeight: t } = e;
  return {
    ...t && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [ad.variable]: "colors.white",
    [ld.variable]: "shadows.lg",
    _dark: {
      [ad.variable]: "colors.gray.700",
      [ld.variable]: "shadows.dark-lg"
    },
    bg: ad.reference,
    boxShadow: ld.reference
  };
}, BR = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, DR = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, OR = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, NR = {
  px: "6",
  py: "4"
}, ZR = P5((e) => ({
  overlay: HR,
  dialogContainer: FR,
  dialog: On(kR, e),
  header: BR,
  closeButton: DR,
  body: OR,
  footer: NR
})), $R = {
  xs: Qs("xs"),
  sm: Qs("md"),
  md: Qs("lg"),
  lg: Qs("2xl"),
  xl: Qs("4xl"),
  full: Qs("full")
}, zR = TR({
  baseStyle: ZR,
  sizes: $R,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: WR, defineMultiStyleConfig: GR } = Rt(SP.keys), jR = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, XR = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, UR = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, YR = WR({
  preview: jR,
  input: XR,
  textarea: UR
}), JR = GR({
  baseStyle: YR
}), { definePartsStyle: qR, defineMultiStyleConfig: KR } = Rt(wP.keys), ya = De("form-control-color"), QR = {
  marginStart: "1",
  [ya.variable]: "colors.red.500",
  _dark: {
    [ya.variable]: "colors.red.300"
  },
  color: ya.reference
}, e_ = {
  mt: "2",
  [ya.variable]: "colors.gray.600",
  _dark: {
    [ya.variable]: "colors.whiteAlpha.600"
  },
  color: ya.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, t_ = qR({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: QR,
  helperText: e_
}), n_ = KR({
  baseStyle: t_
}), { definePartsStyle: r_, defineMultiStyleConfig: o_ } = Rt(IP.keys), xa = De("form-error-color"), i_ = {
  [xa.variable]: "colors.red.500",
  _dark: {
    [xa.variable]: "colors.red.300"
  },
  color: xa.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, s_ = {
  marginEnd: "0.5em",
  [xa.variable]: "colors.red.500",
  _dark: {
    [xa.variable]: "colors.red.300"
  },
  color: xa.reference
}, a_ = r_({
  text: i_,
  icon: s_
}), l_ = o_({
  baseStyle: a_
}), u_ = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, c_ = {
  baseStyle: u_
}, d_ = {
  fontFamily: "heading",
  fontWeight: "bold"
}, f_ = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, h_ = {
  baseStyle: d_,
  sizes: f_,
  defaultProps: {
    size: "xl"
  }
}, { definePartsStyle: No, defineMultiStyleConfig: p_ } = Rt(VP.keys), aa = De("input-height"), la = De("input-font-size"), ua = De("input-padding"), ca = De("input-border-radius"), g_ = No({
  addon: {
    height: aa.reference,
    fontSize: la.reference,
    px: ua.reference,
    borderRadius: ca.reference
  },
  field: {
    width: "100%",
    height: aa.reference,
    fontSize: la.reference,
    px: ua.reference,
    borderRadius: ca.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), pi = {
  lg: {
    [la.variable]: "fontSizes.lg",
    [ua.variable]: "space.4",
    [ca.variable]: "radii.md",
    [aa.variable]: "sizes.12"
  },
  md: {
    [la.variable]: "fontSizes.md",
    [ua.variable]: "space.4",
    [ca.variable]: "radii.md",
    [aa.variable]: "sizes.10"
  },
  sm: {
    [la.variable]: "fontSizes.sm",
    [ua.variable]: "space.3",
    [ca.variable]: "radii.sm",
    [aa.variable]: "sizes.8"
  },
  xs: {
    [la.variable]: "fontSizes.xs",
    [ua.variable]: "space.2",
    [ca.variable]: "radii.sm",
    [aa.variable]: "sizes.6"
  }
}, m_ = {
  lg: No({
    field: pi.lg,
    group: pi.lg
  }),
  md: No({
    field: pi.md,
    group: pi.md
  }),
  sm: No({
    field: pi.sm,
    group: pi.sm
  }),
  xs: No({
    field: pi.xs,
    group: pi.xs
  })
};
function Of(e) {
  const { focusBorderColor: t, errorBorderColor: n } = e;
  return {
    focusBorderColor: t || ke("blue.500", "blue.300")(e),
    errorBorderColor: n || ke("red.500", "red.300")(e)
  };
}
const C_ = No((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = Of(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: ke("gray.300", "whiteAlpha.400")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Dn(t, r),
        boxShadow: `0 0 0 1px ${Dn(t, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: Dn(t, n),
        boxShadow: `0 0 0 1px ${Dn(t, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: ke("inherit", "whiteAlpha.50")(e),
      bg: ke("gray.100", "whiteAlpha.300")(e)
    }
  };
}), v_ = No((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = Of(e);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: ke("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: ke("gray.200", "whiteAlpha.100")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Dn(t, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: Dn(t, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: ke("gray.100", "whiteAlpha.50")(e)
    }
  };
}), b_ = No((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = Of(e);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Dn(t, r),
        boxShadow: `0px 1px 0px 0px ${Dn(t, r)}`
      },
      _focusVisible: {
        borderColor: Dn(t, n),
        boxShadow: `0px 1px 0px 0px ${Dn(t, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), y_ = No({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), x_ = {
  outline: C_,
  filled: v_,
  flushed: b_,
  unstyled: y_
}, xt = p_({
  baseStyle: g_,
  sizes: m_,
  variants: x_,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), ud = De("kbd-bg"), S_ = {
  [ud.variable]: "colors.gray.100",
  _dark: {
    [ud.variable]: "colors.whiteAlpha.100"
  },
  bg: ud.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, w_ = {
  baseStyle: S_
}, I_ = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, V_ = {
  baseStyle: I_
}, { defineMultiStyleConfig: A_, definePartsStyle: L_ } = Rt(AP.keys), M_ = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, P_ = L_({
  icon: M_
}), E_ = A_({
  baseStyle: P_
}), { defineMultiStyleConfig: R_, definePartsStyle: __ } = Rt(LP.keys), po = De("menu-bg"), cd = De("menu-shadow"), T_ = {
  [po.variable]: "#fff",
  [cd.variable]: "shadows.sm",
  _dark: {
    [po.variable]: "colors.gray.700",
    [cd.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: "dropdown",
  borderRadius: "md",
  borderWidth: "1px",
  bg: po.reference,
  boxShadow: cd.reference
}, H_ = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [po.variable]: "colors.gray.100",
    _dark: {
      [po.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [po.variable]: "colors.gray.200",
    _dark: {
      [po.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [po.variable]: "colors.gray.100",
    _dark: {
      [po.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: po.reference
}, F_ = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, k_ = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}, B_ = {
  opacity: 0.6
}, D_ = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, O_ = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, N_ = __({
  button: O_,
  list: T_,
  item: H_,
  groupTitle: F_,
  icon: k_,
  command: B_,
  divider: D_
}), Z_ = R_({
  baseStyle: N_
}), { defineMultiStyleConfig: $_, definePartsStyle: E5 } = Rt(MP.keys), dd = De("modal-bg"), fd = De("modal-shadow"), z_ = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, W_ = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, G_ = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: "md",
    color: "inherit",
    my: t ? "auto" : "16",
    mx: t ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [dd.variable]: "colors.white",
    [fd.variable]: "shadows.lg",
    _dark: {
      [dd.variable]: "colors.gray.700",
      [fd.variable]: "shadows.dark-lg"
    },
    bg: dd.reference,
    boxShadow: fd.reference
  };
}, j_ = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, X_ = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, U_ = (e) => {
  const { scrollBehavior: t } = e;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: t === "inside" ? "auto" : void 0
  };
}, Y_ = {
  px: "6",
  py: "4"
}, J_ = E5((e) => ({
  overlay: z_,
  dialogContainer: On(W_, e),
  dialog: On(G_, e),
  header: j_,
  closeButton: X_,
  body: On(U_, e),
  footer: Y_
}));
function Yr(e) {
  return E5(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
const q_ = {
  xs: Yr("xs"),
  sm: Yr("sm"),
  md: Yr("md"),
  lg: Yr("lg"),
  xl: Yr("xl"),
  "2xl": Yr("2xl"),
  "3xl": Yr("3xl"),
  "4xl": Yr("4xl"),
  "5xl": Yr("5xl"),
  "6xl": Yr("6xl"),
  full: Yr("full")
}, K_ = $_({
  baseStyle: J_,
  sizes: q_,
  defaultProps: { size: "md" }
}), fg = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, { defineMultiStyleConfig: Q_, definePartsStyle: hg } = Rt(PP.keys), Nf = Cn("number-input-stepper-width"), pg = Cn("number-input-input-padding"), eT = Do(Nf).add("0.5rem").toString(), hd = Cn("number-input-bg"), pd = Cn("number-input-color"), gd = Cn("number-input-border-color"), tT = {
  [Nf.variable]: "sizes.6",
  [pg.variable]: eT
}, nT = (e) => {
  var t;
  return ((t = On(xt.baseStyle, e)) == null ? void 0 : t.field) ?? {};
}, rT = {
  width: Nf.reference
}, oT = {
  borderStart: "1px solid",
  borderStartColor: gd.reference,
  color: pd.reference,
  bg: hd.reference,
  [pd.variable]: "colors.chakra-body-text",
  [gd.variable]: "colors.chakra-border-color",
  _dark: {
    [pd.variable]: "colors.whiteAlpha.800",
    [gd.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [hd.variable]: "colors.gray.200",
    _dark: {
      [hd.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, iT = hg((e) => ({
  root: tT,
  field: On(nT, e) ?? {},
  stepperGroup: rT,
  stepper: oT
}));
function Gu(e) {
  var i, a;
  const t = (i = xt.sizes) == null ? void 0 : i[e], n = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, r = ((a = t.field) == null ? void 0 : a.fontSize) ?? "md", o = fg.fontSizes[r];
  return hg({
    field: {
      ...t.field,
      paddingInlineEnd: pg.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: Do(o).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: n[e]
      },
      _last: {
        borderBottomEndRadius: n[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
const sT = {
  xs: Gu("xs"),
  sm: Gu("sm"),
  md: Gu("md"),
  lg: Gu("lg")
}, aT = Q_({
  baseStyle: iT,
  sizes: sT,
  variants: xt.variants,
  defaultProps: xt.defaultProps
});
var Qh;
const lT = {
  ...(Qh = xt.baseStyle) == null ? void 0 : Qh.field,
  textAlign: "center"
}, uT = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
};
var ep;
const cT = {
  outline: (e) => {
    var t, n;
    return ((n = On((t = xt.variants) == null ? void 0 : t.outline, e)) == null ? void 0 : n.field) ?? {};
  },
  flushed: (e) => {
    var t, n;
    return ((n = On((t = xt.variants) == null ? void 0 : t.flushed, e)) == null ? void 0 : n.field) ?? {};
  },
  filled: (e) => {
    var t, n;
    return ((n = On((t = xt.variants) == null ? void 0 : t.filled, e)) == null ? void 0 : n.field) ?? {};
  },
  unstyled: ((ep = xt.variants) == null ? void 0 : ep.unstyled.field) ?? {}
}, dT = {
  baseStyle: lT,
  sizes: uT,
  variants: cT,
  defaultProps: xt.defaultProps
}, { defineMultiStyleConfig: fT, definePartsStyle: hT } = Rt(ng.keys), ju = Cn("popper-bg"), pT = Cn("popper-arrow-bg"), W7 = Cn("popper-arrow-shadow-color"), gT = {
  zIndex: "popover"
}, mT = {
  [ju.variable]: "colors.white",
  bg: ju.reference,
  [pT.variable]: ju.reference,
  [W7.variable]: "colors.gray.200",
  _dark: {
    [ju.variable]: "colors.gray.700",
    [W7.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, CT = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, vT = {
  px: 3,
  py: 2
}, bT = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, yT = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, xT = hT({
  popper: gT,
  content: mT,
  header: CT,
  body: vT,
  footer: bT,
  closeButton: yT
}), ST = fT({
  baseStyle: xT
}), { defineMultiStyleConfig: wT, definePartsStyle: _1 } = Rt(EP.keys), IT = (e) => {
  const { colorScheme: t, theme: n, isIndeterminate: r, hasStripe: o } = e, i = ke(
    O7(),
    O7("1rem", "rgba(0,0,0,0.1)")
  )(e), a = ke(`${t}.500`, `${t}.200`)(e), u = `linear-gradient(
    to right,
    transparent 0%,
    ${Dn(n, a)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && o && i,
    ...r ? { bgImage: u } : { bgColor: a }
  };
}, VT = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, AT = (e) => ({
  bg: ke("gray.100", "whiteAlpha.300")(e)
}), LT = (e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...IT(e)
}), MT = _1((e) => ({
  label: VT,
  filledTrack: LT(e),
  track: AT(e)
})), PT = {
  xs: _1({
    track: { h: "1" }
  }),
  sm: _1({
    track: { h: "2" }
  }),
  md: _1({
    track: { h: "3" }
  }),
  lg: _1({
    track: { h: "4" }
  })
}, ET = wT({
  sizes: PT,
  baseStyle: MT,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: RT, definePartsStyle: Sc } = Rt(RP.keys), _T = (e) => {
  var n;
  const t = (n = On(vi.baseStyle, e)) == null ? void 0 : n.control;
  return {
    ...t,
    borderRadius: "full",
    _checked: {
      ...t == null ? void 0 : t._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, TT = Sc((e) => {
  var t, n;
  return {
    label: (t = vi.baseStyle) == null ? void 0 : t.call(vi, e).label,
    container: (n = vi.baseStyle) == null ? void 0 : n.call(vi, e).container,
    control: _T(e)
  };
}), HT = {
  md: Sc({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: Sc({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: Sc({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, FT = RT({
  baseStyle: TT,
  sizes: HT,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: kT, definePartsStyle: BT } = Rt(_P.keys), Xu = De("select-bg");
var tp;
const DT = {
  ...(tp = xt.baseStyle) == null ? void 0 : tp.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: Xu.reference,
  [Xu.variable]: "colors.white",
  _dark: {
    [Xu.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: Xu.reference
  }
}, OT = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, NT = BT({
  field: DT,
  icon: OT
}), Uu = {
  paddingInlineEnd: "8"
};
var np, rp, op, ip, sp, ap, lp, up;
const ZT = {
  lg: {
    ...(np = xt.sizes) == null ? void 0 : np.lg,
    field: {
      ...(rp = xt.sizes) == null ? void 0 : rp.lg.field,
      ...Uu
    }
  },
  md: {
    ...(op = xt.sizes) == null ? void 0 : op.md,
    field: {
      ...(ip = xt.sizes) == null ? void 0 : ip.md.field,
      ...Uu
    }
  },
  sm: {
    ...(sp = xt.sizes) == null ? void 0 : sp.sm,
    field: {
      ...(ap = xt.sizes) == null ? void 0 : ap.sm.field,
      ...Uu
    }
  },
  xs: {
    ...(lp = xt.sizes) == null ? void 0 : lp.xs,
    field: {
      ...(up = xt.sizes) == null ? void 0 : up.xs.field,
      ...Uu
    },
    icon: {
      insetEnd: "1"
    }
  }
}, $T = kT({
  baseStyle: NT,
  sizes: ZT,
  variants: xt.variants,
  defaultProps: xt.defaultProps
}), md = De("skeleton-start-color"), Cd = De("skeleton-end-color"), zT = {
  [md.variable]: "colors.gray.100",
  [Cd.variable]: "colors.gray.400",
  _dark: {
    [md.variable]: "colors.gray.800",
    [Cd.variable]: "colors.gray.600"
  },
  background: md.reference,
  borderColor: Cd.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, WT = {
  baseStyle: zT
}, vd = De("skip-link-bg"), GT = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [vd.variable]: "colors.white",
    _dark: {
      [vd.variable]: "colors.gray.700"
    },
    bg: vd.reference
  }
}, jT = {
  baseStyle: GT
}, { defineMultiStyleConfig: XT, definePartsStyle: C2 } = Rt(TP.keys), hs = De("slider-thumb-size"), al = De("slider-track-size"), yi = De("slider-bg"), UT = (e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...Bf({
      orientation: t,
      vertical: {
        h: "100%",
        px: Bo(hs.reference).divide(2).toString()
      },
      horizontal: {
        w: "100%",
        py: Bo(hs.reference).divide(2).toString()
      }
    })
  };
}, YT = (e) => ({
  ...Bf({
    orientation: e.orientation,
    horizontal: { h: al.reference },
    vertical: { w: al.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [yi.variable]: "colors.gray.200",
  _dark: {
    [yi.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [yi.variable]: "colors.gray.300",
    _dark: {
      [yi.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: yi.reference
}), JT = (e) => {
  const { orientation: t } = e;
  return {
    ...Bf({
      orientation: t,
      vertical: { left: "50%" },
      horizontal: { top: "50%" }
    }),
    w: hs.reference,
    h: hs.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _active: {
      "--slider-thumb-scale": "1.15"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, qT = (e) => {
  const { colorScheme: t } = e;
  return {
    width: "inherit",
    height: "inherit",
    [yi.variable]: `colors.${t}.500`,
    _dark: {
      [yi.variable]: `colors.${t}.200`
    },
    bg: yi.reference
  };
}, KT = C2((e) => ({
  container: UT(e),
  track: YT(e),
  thumb: JT(e),
  filledTrack: qT(e)
})), QT = C2({
  container: {
    [hs.variable]: "sizes.4",
    [al.variable]: "sizes.1"
  }
}), eH = C2({
  container: {
    [hs.variable]: "sizes.3.5",
    [al.variable]: "sizes.1"
  }
}), tH = C2({
  container: {
    [hs.variable]: "sizes.2.5",
    [al.variable]: "sizes.0.5"
  }
}), nH = {
  lg: QT,
  md: eH,
  sm: tH
}, rH = XT({
  baseStyle: KT,
  sizes: nH,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), es = Cn("spinner-size"), oH = {
  width: [es.reference],
  height: [es.reference]
}, iH = {
  xs: {
    [es.variable]: "sizes.3"
  },
  sm: {
    [es.variable]: "sizes.4"
  },
  md: {
    [es.variable]: "sizes.6"
  },
  lg: {
    [es.variable]: "sizes.8"
  },
  xl: {
    [es.variable]: "sizes.12"
  }
}, sH = {
  baseStyle: oH,
  sizes: iH,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: aH, definePartsStyle: gg } = Rt(HP.keys), lH = {
  fontWeight: "medium"
}, uH = {
  opacity: 0.8,
  marginBottom: "2"
}, cH = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, dH = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, fH = gg({
  container: {},
  label: lH,
  helpText: uH,
  number: cH,
  icon: dH
}), hH = {
  md: gg({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, pH = aH({
  baseStyle: fH,
  sizes: hH,
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: gH, definePartsStyle: T1 } = Rt([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), Oo = De("stepper-indicator-size"), da = De("stepper-icon-size"), fa = De("stepper-title-font-size"), H1 = De("stepper-description-font-size"), y1 = De("stepper-accent-color"), mH = T1(({ colorScheme: e }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [y1.variable]: `colors.${e}.500`,
    _dark: {
      [y1.variable]: `colors.${e}.200`
    }
  },
  title: {
    fontSize: fa.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: H1.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: fa.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: da.reference,
    height: da.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: Oo.reference,
    height: Oo.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: y1.reference
    },
    "&[data-status=complete]": {
      bg: y1.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: y1.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${Oo.reference} - 8px)`,
      top: `calc(${Oo.reference} + 4px)`,
      insetStart: `calc(${Oo.reference} / 2 - 1px)`
    }
  }
})), CH = gH({
  baseStyle: mH,
  sizes: {
    xs: T1({
      stepper: {
        [Oo.variable]: "sizes.4",
        [da.variable]: "sizes.3",
        [fa.variable]: "fontSizes.xs",
        [H1.variable]: "fontSizes.xs"
      }
    }),
    sm: T1({
      stepper: {
        [Oo.variable]: "sizes.6",
        [da.variable]: "sizes.4",
        [fa.variable]: "fontSizes.sm",
        [H1.variable]: "fontSizes.xs"
      }
    }),
    md: T1({
      stepper: {
        [Oo.variable]: "sizes.8",
        [da.variable]: "sizes.5",
        [fa.variable]: "fontSizes.md",
        [H1.variable]: "fontSizes.sm"
      }
    }),
    lg: T1({
      stepper: {
        [Oo.variable]: "sizes.10",
        [da.variable]: "sizes.6",
        [fa.variable]: "fontSizes.lg",
        [H1.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: vH, definePartsStyle: wc } = Rt(FP.keys), j1 = Cn("switch-track-width"), as = Cn("switch-track-height"), bd = Cn("switch-track-diff"), bH = Do.subtract(j1, as), R5 = Cn("switch-thumb-x"), x1 = Cn("switch-bg"), yH = (e) => {
  const { colorScheme: t } = e;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [j1.reference],
    height: [as.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [x1.variable]: "colors.gray.300",
    _dark: {
      [x1.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [x1.variable]: `colors.${t}.500`,
      _dark: {
        [x1.variable]: `colors.${t}.200`
      }
    },
    bg: x1.reference
  };
}, xH = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [as.reference],
  height: [as.reference],
  _checked: {
    transform: `translateX(${R5.reference})`
  }
}, SH = wc((e) => ({
  container: {
    [bd.variable]: bH,
    [R5.variable]: bd.reference,
    _rtl: {
      [R5.variable]: Do(bd).negate().toString()
    }
  },
  track: yH(e),
  thumb: xH
})), wH = {
  sm: wc({
    container: {
      [j1.variable]: "1.375rem",
      [as.variable]: "sizes.3"
    }
  }),
  md: wc({
    container: {
      [j1.variable]: "1.875rem",
      [as.variable]: "sizes.4"
    }
  }),
  lg: wc({
    container: {
      [j1.variable]: "2.875rem",
      [as.variable]: "sizes.6"
    }
  })
}, IH = vH({
  baseStyle: SH,
  sizes: wH,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: VH, definePartsStyle: Sa } = Rt(kP.keys), AH = Sa({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), Oc = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, LH = Sa((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: ke("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Oc
    },
    td: {
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Oc
    },
    caption: {
      color: ke("gray.600", "gray.100")(e)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), MH = Sa((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: ke("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Oc
    },
    td: {
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Oc
    },
    caption: {
      color: ke("gray.600", "gray.100")(e)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: ke(`${t}.100`, `${t}.700`)(e)
          },
          td: {
            background: ke(`${t}.100`, `${t}.700`)(e)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), PH = {
  simple: LH,
  striped: MH,
  unstyled: {}
}, EH = {
  sm: Sa({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: Sa({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: Sa({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, RH = VH({
  baseStyle: AH,
  variants: PH,
  sizes: EH,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), Yn = De("tabs-color"), Kr = De("tabs-bg"), Yu = De("tabs-border-color"), { defineMultiStyleConfig: _H, definePartsStyle: mo } = Rt(BP.keys), TH = (e) => {
  const { orientation: t } = e;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, HH = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, FH = (e) => {
  const { align: t = "start", orientation: n } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[t],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, kH = {
  p: 4
}, BH = mo((e) => ({
  root: TH(e),
  tab: HH(e),
  tablist: FH(e),
  tabpanel: kH
})), DH = {
  sm: mo({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: mo({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: mo({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, OH = mo((e) => {
  const { colorScheme: t, orientation: n } = e, r = n === "vertical", o = r ? "borderStart" : "borderBottom", i = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [o]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [o]: "2px solid",
      borderColor: "transparent",
      [i]: "-2px",
      _selected: {
        [Yn.variable]: `colors.${t}.600`,
        _dark: {
          [Yn.variable]: `colors.${t}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [Kr.variable]: "colors.gray.200",
        _dark: {
          [Kr.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: Yn.reference,
      bg: Kr.reference
    }
  };
}), NH = mo((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [Yu.variable]: "transparent",
      _selected: {
        [Yn.variable]: `colors.${t}.600`,
        [Yu.variable]: "colors.white",
        _dark: {
          [Yn.variable]: `colors.${t}.300`,
          [Yu.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: Yu.reference
      },
      color: Yn.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), ZH = mo((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [Kr.variable]: "colors.gray.50",
      _dark: {
        [Kr.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [Kr.variable]: "colors.white",
        [Yn.variable]: `colors.${t}.600`,
        _dark: {
          [Kr.variable]: "colors.gray.800",
          [Yn.variable]: `colors.${t}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: Yn.reference,
      bg: Kr.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), $H = mo((e) => {
  const { colorScheme: t, theme: n } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: Dn(n, `${t}.700`),
        bg: Dn(n, `${t}.100`)
      }
    }
  };
}), zH = mo((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [Yn.variable]: "colors.gray.600",
      _dark: {
        [Yn.variable]: "inherit"
      },
      _selected: {
        [Yn.variable]: "colors.white",
        [Kr.variable]: `colors.${t}.600`,
        _dark: {
          [Yn.variable]: "colors.gray.800",
          [Kr.variable]: `colors.${t}.300`
        }
      },
      color: Yn.reference,
      bg: Kr.reference
    }
  };
}), WH = mo({}), GH = {
  line: OH,
  enclosed: NH,
  "enclosed-colored": ZH,
  "soft-rounded": $H,
  "solid-rounded": zH,
  unstyled: WH
}, jH = _H({
  baseStyle: BH,
  sizes: DH,
  variants: GH,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: XH, definePartsStyle: ls } = Rt(DP.keys), G7 = De("tag-bg"), j7 = De("tag-color"), yd = De("tag-shadow"), Ic = De("tag-min-height"), Vc = De("tag-min-width"), Ac = De("tag-font-size"), Lc = De("tag-padding-inline"), UH = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [j7.variable]: nn.color.reference,
  [G7.variable]: nn.bg.reference,
  [yd.variable]: nn.shadow.reference,
  color: j7.reference,
  bg: G7.reference,
  boxShadow: yd.reference,
  borderRadius: "md",
  minH: Ic.reference,
  minW: Vc.reference,
  fontSize: Ac.reference,
  px: Lc.reference,
  _focusVisible: {
    [yd.variable]: "shadows.outline"
  }
}, YH = {
  lineHeight: 1.2,
  overflow: "visible"
}, JH = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, qH = ls({
  container: UH,
  label: YH,
  closeButton: JH
}), KH = {
  sm: ls({
    container: {
      [Ic.variable]: "sizes.5",
      [Vc.variable]: "sizes.5",
      [Ac.variable]: "fontSizes.xs",
      [Lc.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: ls({
    container: {
      [Ic.variable]: "sizes.6",
      [Vc.variable]: "sizes.6",
      [Ac.variable]: "fontSizes.sm",
      [Lc.variable]: "space.2"
    }
  }),
  lg: ls({
    container: {
      [Ic.variable]: "sizes.8",
      [Vc.variable]: "sizes.8",
      [Ac.variable]: "fontSizes.md",
      [Lc.variable]: "space.3"
    }
  })
}, QH = {
  subtle: ls((e) => {
    var t;
    return {
      container: (t = z1.variants) == null ? void 0 : t.subtle(e)
    };
  }),
  solid: ls((e) => {
    var t;
    return {
      container: (t = z1.variants) == null ? void 0 : t.solid(e)
    };
  }),
  outline: ls((e) => {
    var t;
    return {
      container: (t = z1.variants) == null ? void 0 : t.outline(e)
    };
  })
}, eF = XH({
  variants: QH,
  baseStyle: qH,
  sizes: KH,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});
var cp;
const tF = {
  ...(cp = xt.baseStyle) == null ? void 0 : cp.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
};
var dp;
const nF = {
  outline: (e) => {
    var t;
    return ((t = xt.variants) == null ? void 0 : t.outline(e).field) ?? {};
  },
  flushed: (e) => {
    var t;
    return ((t = xt.variants) == null ? void 0 : t.flushed(e).field) ?? {};
  },
  filled: (e) => {
    var t;
    return ((t = xt.variants) == null ? void 0 : t.filled(e).field) ?? {};
  },
  unstyled: ((dp = xt.variants) == null ? void 0 : dp.unstyled.field) ?? {}
};
var fp, hp, pp, gp;
const rF = {
  xs: ((fp = xt.sizes) == null ? void 0 : fp.xs.field) ?? {},
  sm: ((hp = xt.sizes) == null ? void 0 : hp.sm.field) ?? {},
  md: ((pp = xt.sizes) == null ? void 0 : pp.md.field) ?? {},
  lg: ((gp = xt.sizes) == null ? void 0 : gp.lg.field) ?? {}
}, oF = {
  baseStyle: tF,
  sizes: rF,
  variants: nF,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, Ju = Cn("tooltip-bg"), xd = Cn("tooltip-fg"), iF = Cn("popper-arrow-bg"), sF = {
  bg: Ju.reference,
  color: xd.reference,
  [Ju.variable]: "colors.gray.700",
  [xd.variable]: "colors.whiteAlpha.900",
  _dark: {
    [Ju.variable]: "colors.gray.300",
    [xd.variable]: "colors.gray.900"
  },
  [iF.variable]: Ju.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, aF = {
  baseStyle: sF
}, lF = {
  Accordion: XP,
  Alert: EE,
  Avatar: ZE,
  Badge: z1,
  Breadcrumb: qE,
  Button: sR,
  Checkbox: vi,
  CloseButton: xR,
  Code: VR,
  Container: LR,
  Divider: _R,
  Drawer: zR,
  Editable: JR,
  Form: n_,
  FormError: l_,
  FormLabel: c_,
  Heading: h_,
  Input: xt,
  Kbd: w_,
  Link: V_,
  List: E_,
  Menu: Z_,
  Modal: K_,
  NumberInput: aT,
  PinInput: dT,
  Popover: ST,
  Progress: ET,
  Radio: FT,
  Select: $T,
  Skeleton: WT,
  SkipLink: jT,
  Slider: rH,
  Spinner: sH,
  Stat: pH,
  Switch: IH,
  Table: RH,
  Tabs: jH,
  Tag: eF,
  Textarea: oF,
  Tooltip: aF,
  Card: dR,
  Stepper: CH
}, uF = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, cF = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, dF = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  }
}, fF = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, hF = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, pF = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, gF = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, mF = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, CF = {
  property: pF,
  easing: gF,
  duration: mF
}, vF = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, bF = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, yF = {
  breakpoints: cF,
  zIndices: vF,
  radii: fF,
  blur: bF,
  colors: dF,
  ...fg,
  sizes: sg,
  shadows: hF,
  space: ig,
  borders: uF,
  transition: CF
}, xF = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, SF = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, wF = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function IF(e) {
  return gn(e) ? wF.every(
    (t) => Object.prototype.hasOwnProperty.call(e, t)
  ) : !1;
}
const VF = "ltr", AF = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, mg = {
  semanticTokens: xF,
  direction: VF,
  ...yF,
  components: lF,
  styles: SF,
  config: AF
}, Zf = Nr({});
Zf.displayName = "ColorModeContext";
function $f() {
  const e = tn(Zf);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
const qu = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function LF(e = {}) {
  const { preventTransition: t = !0, nonce: n } = e, r = {
    setDataset: (o) => {
      const i = t ? r.preventTransition() : void 0;
      document.documentElement.dataset.theme = o, document.documentElement.style.colorScheme = o, i == null || i();
    },
    setClassName(o) {
      document.body.classList.add(o ? qu.dark : qu.light), document.body.classList.remove(o ? qu.light : qu.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(o) {
      return r.query().matches ?? o === "dark" ? "dark" : "light";
    },
    addListener(o) {
      const i = r.query(), a = (u) => {
        o(u.matches ? "dark" : "light");
      };
      return typeof i.addListener == "function" ? i.addListener(a) : i.addEventListener("change", a), () => {
        typeof i.removeListener == "function" ? i.removeListener(a) : i.removeEventListener("change", a);
      };
    },
    preventTransition() {
      const o = document.createElement("style");
      return o.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), n !== void 0 && (o.nonce = n), document.head.appendChild(o), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(o);
          });
        });
      };
    }
  };
  return r;
}
const MF = "chakra-ui-color-mode";
function PF(e) {
  return {
    ssr: !1,
    type: "localStorage",
    get(t) {
      if (!(globalThis != null && globalThis.document))
        return t;
      let n;
      try {
        n = localStorage.getItem(e) || t;
      } catch {
      }
      return n || t;
    },
    set(t) {
      try {
        localStorage.setItem(e, t);
      } catch {
      }
    }
  };
}
const EF = PF(MF), X7 = () => {
}, RF = wL() ? Oa : Ue;
function U7(e, t) {
  return e.type === "cookie" && e.ssr ? e.get(t) : t;
}
const Cg = function(t) {
  const {
    value: n,
    children: r,
    options: {
      useSystemColorMode: o,
      initialColorMode: i,
      disableTransitionOnChange: a
    } = {},
    colorModeManager: u = EF
  } = t, c = hL(), d = i === "dark" ? "dark" : "light", [f, p] = Ee(
    () => U7(u, d)
  ), [g, m] = Ee(
    () => U7(u)
  ), { getSystemTheme: b, setClassName: v, setDataset: y, addListener: w } = at(
    () => LF({
      preventTransition: a,
      nonce: c == null ? void 0 : c.nonce
    }),
    [a, c == null ? void 0 : c.nonce]
  ), I = i === "system" && !f ? g : f, V = q(
    (R) => {
      const _ = R === "system" ? b() : R;
      p(_), v(_ === "dark"), y(_), u.set(_);
    },
    [u, b, v, y]
  );
  RF(() => {
    i === "system" && m(b());
  }, []), Ue(() => {
    const R = u.get();
    if (R) {
      V(R);
      return;
    }
    if (i === "system") {
      V("system");
      return;
    }
    V(d);
  }, [u, d, i, V]);
  const M = q(() => {
    V(I === "dark" ? "light" : "dark");
  }, [I, V]);
  Ue(() => {
    if (o)
      return w(V);
  }, [o, w, V]);
  const L = at(
    () => ({
      colorMode: n ?? I,
      toggleColorMode: n ? X7 : M,
      setColorMode: n ? X7 : V,
      forced: n !== void 0
    }),
    [I, M, V, n]
  );
  return /* @__PURE__ */ x.jsx(Zf.Provider, { value: L, children: r });
};
Cg.displayName = "ColorModeProvider";
const vg = String.raw, bg = vg`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, _F = () => /* @__PURE__ */ x.jsx(f2, { styles: bg }), TF = ({ scope: e = "" }) => /* @__PURE__ */ x.jsx(
  f2,
  {
    styles: vg`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${bg}
    `
  }
);
function HF(e) {
  const { cssVarsRoot: t, theme: n, children: r } = e, o = at(() => gP(n), [n]);
  return /* @__PURE__ */ x.jsxs(pL, { theme: o, children: [
    /* @__PURE__ */ x.jsx(FF, { root: t }),
    r
  ] });
}
function FF({ root: e = ":host, :root" }) {
  const t = [e, "[data-theme]"].join(",");
  return /* @__PURE__ */ x.jsx(f2, { styles: (n) => ({ [t]: n.__cssVars }) });
}
Bt({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function kF(e) {
  return Bt({
    name: `${e}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${e} />" `
  });
}
function BF() {
  const { colorMode: e } = $f();
  return /* @__PURE__ */ x.jsx(
    f2,
    {
      styles: (t) => {
        const n = Np(t, "styles.global"), r = eo(n, { theme: t, colorMode: e });
        return r ? eg(r)(t) : void 0;
      }
    }
  );
}
const [DF, OF] = Bt({
  strict: !1,
  name: "PortalManagerContext"
});
function yg(e) {
  const { children: t, zIndex: n } = e;
  return /* @__PURE__ */ x.jsx(DF, { value: { zIndex: n }, children: t });
}
yg.displayName = "PortalManager";
const xg = Nr({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
xg.displayName = "EnvironmentContext";
function Sg(e) {
  const { children: t, environment: n, disabled: r } = e, o = Le(null), i = at(() => n || {
    getDocument: () => {
      var u;
      return ((u = o.current) == null ? void 0 : u.ownerDocument) ?? document;
    },
    getWindow: () => {
      var u;
      return ((u = o.current) == null ? void 0 : u.ownerDocument.defaultView) ?? window;
    }
  }, [n]), a = !r || !n;
  return /* @__PURE__ */ x.jsxs(xg.Provider, { value: i, children: [
    t,
    a && /* @__PURE__ */ x.jsx("span", { id: "__chakra_env", hidden: !0, ref: o })
  ] });
}
Sg.displayName = "EnvironmentProvider";
const NF = (e) => {
  const {
    children: t,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: o,
    resetCSS: i = !0,
    theme: a = {},
    environment: u,
    cssVarsRoot: c,
    disableEnvironment: d,
    disableGlobalStyle: f
  } = e, p = /* @__PURE__ */ x.jsx(
    Sg,
    {
      environment: u,
      disabled: d,
      children: t
    }
  );
  return /* @__PURE__ */ x.jsx(HF, { theme: a, cssVarsRoot: c, children: /* @__PURE__ */ x.jsxs(
    Cg,
    {
      colorModeManager: n,
      options: a.config,
      children: [
        i ? /* @__PURE__ */ x.jsx(TF, { scope: o }) : /* @__PURE__ */ x.jsx(_F, {}),
        !f && /* @__PURE__ */ x.jsx(BF, {}),
        r ? /* @__PURE__ */ x.jsx(yg, { zIndex: r, children: p }) : p
      ]
    }
  ) });
}, wg = Nr({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), v2 = Nr({}), yl = Nr(null), b2 = typeof document < "u", zf = b2 ? Oa : Ue, Ig = Nr({ strict: !1 }), Wf = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), ZF = "framerAppearId", Vg = "data-" + Wf(ZF);
function $F(e, t, n, r) {
  const { visualElement: o } = tn(v2), i = tn(Ig), a = tn(yl), u = tn(wg).reducedMotion, c = Le();
  r = r || i.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const d = c.current;
  Ep(() => {
    d && d.update(n, a);
  });
  const f = Le(!!(n[Vg] && !window.HandoffComplete));
  return zf(() => {
    d && (d.render(), f.current && d.animationState && d.animationState.animateChanges());
  }), Ue(() => {
    d && (d.updateFeatures(), !f.current && d.animationState && d.animationState.animateChanges(), f.current && (f.current = !1, window.HandoffComplete = !0));
  }), d;
}
function ha(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function zF(e, t, n) {
  return q(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : ha(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function ll(e) {
  return typeof e == "string" || Array.isArray(e);
}
function y2(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const Gf = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], jf = ["initial", ...Gf];
function x2(e) {
  return y2(e.animate) || jf.some((t) => ll(e[t]));
}
function Ag(e) {
  return !!(x2(e) || e.variants);
}
function WF(e, t) {
  if (x2(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || ll(n) ? n : void 0,
      animate: ll(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function GF(e) {
  const { initial: t, animate: n } = WF(e, tn(v2));
  return at(() => ({ initial: t, animate: n }), [Y7(t), Y7(n)]);
}
function Y7(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const J7 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, ul = {};
for (const e in J7)
  ul[e] = {
    isEnabled: (t) => J7[e].some((n) => !!t[n])
  };
function jF(e) {
  for (const t in e)
    ul[t] = {
      ...ul[t],
      ...e[t]
    };
}
const Xf = Nr({}), Lg = Nr({}), XF = Symbol.for("motionComponentSymbol");
function UF({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && jF(e);
  function i(u, c) {
    let d;
    const f = {
      ...tn(wg),
      ...u,
      layoutId: YF(u)
    }, { isStatic: p } = f, g = GF(u), m = r(u, p);
    if (!p && b2) {
      g.visualElement = $F(o, m, f, t);
      const b = tn(Lg), v = tn(Ig).strict;
      g.visualElement && (d = g.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        f,
        v,
        e,
        b
      ));
    }
    return be.createElement(
      v2.Provider,
      { value: g },
      d && g.visualElement ? be.createElement(d, { visualElement: g.visualElement, ...f }) : null,
      n(o, u, zF(m, g.visualElement, c), m, p, g.visualElement)
    );
  }
  const a = Fe(i);
  return a[XF] = o, a;
}
function YF({ layoutId: e }) {
  const t = tn(Xf).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function JF(e) {
  function t(r, o = {}) {
    return UF(e(r, o));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => (n.has(o) || n.set(o, t(o)), n.get(o))
  });
}
const qF = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Uf(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(qF.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const Nc = {};
function KF(e) {
  Object.assign(Nc, e);
}
const xl = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], ys = new Set(xl);
function Mg(e, { layout: t, layoutId: n }) {
  return ys.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Nc[e] || e === "opacity");
}
const Kn = (e) => !!(e && e.getVelocity), QF = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, ek = xl.length;
function tk(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, o) {
  let i = "";
  for (let a = 0; a < ek; a++) {
    const u = xl[a];
    if (e[u] !== void 0) {
      const c = QF[u] || u;
      i += `${c}(${e[u]}) `;
    }
  }
  return t && !e.z && (i += "translateZ(0)"), i = i.trim(), o ? i = o(e, r ? "" : i) : n && r && (i = "none"), i;
}
const Pg = (e) => (t) => typeof t == "string" && t.startsWith(e), Eg = Pg("--"), _5 = Pg("var(--"), nk = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, rk = (e, t) => t && typeof e == "number" ? t.transform(e) : e, Ai = (e, t, n) => Math.min(Math.max(n, e), t), xs = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, X1 = {
  ...xs,
  transform: (e) => Ai(0, 1, e)
}, Ku = {
  ...xs,
  default: 1
}, U1 = (e) => Math.round(e * 1e5) / 1e5, S2 = /(-)?([\d]*\.?[\d])+/g, Rg = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, ok = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Sl(e) {
  return typeof e == "string";
}
const wl = (e) => ({
  test: (t) => Sl(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), mi = wl("deg"), Co = wl("%"), Ge = wl("px"), ik = wl("vh"), sk = wl("vw"), q7 = {
  ...Co,
  parse: (e) => Co.parse(e) / 100,
  transform: (e) => Co.transform(e * 100)
}, K7 = {
  ...xs,
  transform: Math.round
}, _g = {
  // Border props
  borderWidth: Ge,
  borderTopWidth: Ge,
  borderRightWidth: Ge,
  borderBottomWidth: Ge,
  borderLeftWidth: Ge,
  borderRadius: Ge,
  radius: Ge,
  borderTopLeftRadius: Ge,
  borderTopRightRadius: Ge,
  borderBottomRightRadius: Ge,
  borderBottomLeftRadius: Ge,
  // Positioning props
  width: Ge,
  maxWidth: Ge,
  height: Ge,
  maxHeight: Ge,
  size: Ge,
  top: Ge,
  right: Ge,
  bottom: Ge,
  left: Ge,
  // Spacing props
  padding: Ge,
  paddingTop: Ge,
  paddingRight: Ge,
  paddingBottom: Ge,
  paddingLeft: Ge,
  margin: Ge,
  marginTop: Ge,
  marginRight: Ge,
  marginBottom: Ge,
  marginLeft: Ge,
  // Transform props
  rotate: mi,
  rotateX: mi,
  rotateY: mi,
  rotateZ: mi,
  scale: Ku,
  scaleX: Ku,
  scaleY: Ku,
  scaleZ: Ku,
  skew: mi,
  skewX: mi,
  skewY: mi,
  distance: Ge,
  translateX: Ge,
  translateY: Ge,
  translateZ: Ge,
  x: Ge,
  y: Ge,
  z: Ge,
  perspective: Ge,
  transformPerspective: Ge,
  opacity: X1,
  originX: q7,
  originY: q7,
  originZ: Ge,
  // Misc
  zIndex: K7,
  // SVG
  fillOpacity: X1,
  strokeOpacity: X1,
  numOctaves: K7
};
function Yf(e, t, n, r) {
  const { style: o, vars: i, transform: a, transformOrigin: u } = e;
  let c = !1, d = !1, f = !0;
  for (const p in t) {
    const g = t[p];
    if (Eg(p)) {
      i[p] = g;
      continue;
    }
    const m = _g[p], b = rk(g, m);
    if (ys.has(p)) {
      if (c = !0, a[p] = b, !f)
        continue;
      g !== (m.default || 0) && (f = !1);
    } else
      p.startsWith("origin") ? (d = !0, u[p] = b) : o[p] = b;
  }
  if (t.transform || (c || r ? o.transform = tk(e.transform, n, f, r) : o.transform && (o.transform = "none")), d) {
    const { originX: p = "50%", originY: g = "50%", originZ: m = 0 } = u;
    o.transformOrigin = `${p} ${g} ${m}`;
  }
}
const Jf = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Tg(e, t, n) {
  for (const r in t)
    !Kn(t[r]) && !Mg(r, n) && (e[r] = t[r]);
}
function ak({ transformTemplate: e }, t, n) {
  return at(() => {
    const r = Jf();
    return Yf(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function lk(e, t, n) {
  const r = e.style || {}, o = {};
  return Tg(o, r, e), Object.assign(o, ak(e, t, n)), e.transformValues ? e.transformValues(o) : o;
}
function uk(e, t, n) {
  const r = {}, o = lk(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = o, r;
}
const ck = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Zc(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || ck.has(e);
}
let Hg = (e) => !Zc(e);
function dk(e) {
  e && (Hg = (t) => t.startsWith("on") ? !Zc(t) : e(t));
}
try {
  dk(require("@emotion/is-prop-valid").default);
} catch {
}
function fk(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (Hg(o) || n === !0 && Zc(o) || !t && !Zc(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function Q7(e, t, n) {
  return typeof e == "string" ? e : Ge.transform(t + n * e);
}
function hk(e, t, n) {
  const r = Q7(t, e.x, e.width), o = Q7(n, e.y, e.height);
  return `${r} ${o}`;
}
const pk = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, gk = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function mk(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? pk : gk;
  e[i.offset] = Ge.transform(-r);
  const a = Ge.transform(t), u = Ge.transform(n);
  e[i.array] = `${a} ${u}`;
}
function qf(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: i,
  pathLength: a,
  pathSpacing: u = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...d
}, f, p, g) {
  if (Yf(e, d, f, g), p) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: m, style: b, dimensions: v } = e;
  m.transform && (v && (b.transform = m.transform), delete m.transform), v && (o !== void 0 || i !== void 0 || b.transform) && (b.transformOrigin = hk(v, o !== void 0 ? o : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (m.x = t), n !== void 0 && (m.y = n), r !== void 0 && (m.scale = r), a !== void 0 && mk(m, a, u, c, !1);
}
const Fg = () => ({
  ...Jf(),
  attrs: {}
}), Kf = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Ck(e, t, n, r) {
  const o = at(() => {
    const i = Fg();
    return qf(i, t, { enableHardwareAcceleration: !1 }, Kf(r), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Tg(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
function vk(e = !1) {
  return (n, r, o, { latestValues: i }, a) => {
    const c = (Uf(n) ? Ck : uk)(r, i, a, n), f = {
      ...fk(r, typeof n == "string", e),
      ...c,
      ref: o
    }, { children: p } = r, g = at(() => Kn(p) ? p.get() : p, [p]);
    return Rp(n, {
      ...f,
      children: g
    });
  };
}
function kg(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const Bg = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Dg(e, t, n, r) {
  kg(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Bg.has(o) ? o : Wf(o), t.attrs[o]);
}
function Qf(e, t) {
  const { style: n } = e, r = {};
  for (const o in n)
    (Kn(n[o]) || t.style && Kn(t.style[o]) || Mg(o, e)) && (r[o] = n[o]);
  return r;
}
function Og(e, t) {
  const n = Qf(e, t);
  for (const r in e)
    if (Kn(e[r]) || Kn(t[r])) {
      const o = xl.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      n[o] = e[r];
    }
  return n;
}
function e3(e, t, n, r = {}, o = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), t;
}
function Ng(e) {
  const t = Le(null);
  return t.current === null && (t.current = e()), t.current;
}
const $c = (e) => Array.isArray(e), bk = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), yk = (e) => $c(e) ? e[e.length - 1] || 0 : e;
function Mc(e) {
  const t = Kn(e) ? e.get() : e;
  return bk(t) ? t.toValue() : t;
}
function xk({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, o, i) {
  const a = {
    latestValues: Sk(r, o, i, e),
    renderState: t()
  };
  return n && (a.mount = (u) => n(r, u, a)), a;
}
const Zg = (e) => (t, n) => {
  const r = tn(v2), o = tn(yl), i = () => xk(e, t, r, o);
  return n ? i() : Ng(i);
};
function Sk(e, t, n, r) {
  const o = {}, i = r(e, {});
  for (const g in i)
    o[g] = Mc(i[g]);
  let { initial: a, animate: u } = e;
  const c = x2(e), d = Ag(e);
  t && d && !c && e.inherit !== !1 && (a === void 0 && (a = t.initial), u === void 0 && (u = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || a === !1;
  const p = f ? u : a;
  return p && typeof p != "boolean" && !y2(p) && (Array.isArray(p) ? p : [p]).forEach((m) => {
    const b = e3(e, m);
    if (!b)
      return;
    const { transitionEnd: v, transition: y, ...w } = b;
    for (const I in w) {
      let V = w[I];
      if (Array.isArray(V)) {
        const M = f ? V.length - 1 : 0;
        V = V[M];
      }
      V !== null && (o[I] = V);
    }
    for (const I in v)
      o[I] = v[I];
  }), o;
}
const Jt = (e) => e;
class e6 {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(t) {
    if (!this.scheduled.has(t))
      return this.scheduled.add(t), this.order.push(t), !0;
  }
  remove(t) {
    const n = this.order.indexOf(t);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(t));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function wk(e) {
  let t = new e6(), n = new e6(), r = 0, o = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet(), u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, d = !1, f = !1) => {
      const p = f && o, g = p ? t : n;
      return d && a.add(c), g.add(c) && p && o && (r = t.order.length), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.remove(c), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o) {
        i = !0;
        return;
      }
      if (o = !0, [t, n] = [n, t], n.clear(), r = t.order.length, r)
        for (let d = 0; d < r; d++) {
          const f = t.order[d];
          f(c), a.has(f) && (u.schedule(f), e());
        }
      o = !1, i && (i = !1, u.process(c));
    }
  };
  return u;
}
const Qu = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], Ik = 40;
function Vk(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = Qu.reduce((p, g) => (p[g] = wk(() => n = !0), p), {}), a = (p) => i[p].process(o), u = () => {
    const p = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(p - o.timestamp, Ik), 1), o.timestamp = p, o.isProcessing = !0, Qu.forEach(a), o.isProcessing = !1, n && t && (r = !1, e(u));
  }, c = () => {
    n = !0, r = !0, o.isProcessing || e(u);
  };
  return { schedule: Qu.reduce((p, g) => {
    const m = i[g];
    return p[g] = (b, v = !1, y = !1) => (n || c(), m.schedule(b, v, y)), p;
  }, {}), cancel: (p) => Qu.forEach((g) => i[g].cancel(p)), state: o, steps: i };
}
const { schedule: kt, cancel: Yo, state: En, steps: Sd } = Vk(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Jt, !0), Ak = {
  useVisualState: Zg({
    scrapeMotionValuesFromProps: Og,
    createRenderState: Fg,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      kt.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), kt.render(() => {
        qf(n, r, { enableHardwareAcceleration: !1 }, Kf(t.tagName), e.transformTemplate), Dg(t, n);
      });
    }
  })
}, Lk = {
  useVisualState: Zg({
    scrapeMotionValuesFromProps: Qf,
    createRenderState: Jf
  })
};
function Mk(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ...Uf(e) ? Ak : Lk,
    preloadedFeatures: n,
    useRender: vk(t),
    createVisualElement: r,
    Component: e
  };
}
function Zo(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const $g = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function w2(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const Pk = (e) => (t) => $g(t) && e(t, w2(t));
function Wo(e, t, n, r) {
  return Zo(e, t, Pk(n), r);
}
const Ek = (e, t) => (n) => t(e(n)), Ii = (...e) => e.reduce(Ek);
function zg(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const t6 = zg("dragHorizontal"), n6 = zg("dragVertical");
function Wg(e) {
  let t = !1;
  if (e === "y")
    t = n6();
  else if (e === "x")
    t = t6();
  else {
    const n = t6(), r = n6();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function Gg() {
  const e = Wg(!0);
  return e ? (e(), !1) : !0;
}
class Ei {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function r6(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), r = "onHover" + (t ? "Start" : "End"), o = (i, a) => {
    if (i.pointerType === "touch" || Gg())
      return;
    const u = e.getProps();
    e.animationState && u.whileHover && e.animationState.setActive("whileHover", t), u[r] && kt.update(() => u[r](i, a));
  };
  return Wo(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class Rk extends Ei {
  mount() {
    this.unmount = Ii(r6(this.node, !0), r6(this.node, !1));
  }
  unmount() {
  }
}
class _k extends Ei {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ii(Zo(this.node.current, "focus", () => this.onFocus()), Zo(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const jg = (e, t) => t ? e === t ? !0 : jg(e, t.parentElement) : !1;
function wd(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, w2(n));
}
class Tk extends Ei {
  constructor() {
    super(...arguments), this.removeStartListeners = Jt, this.removeEndListeners = Jt, this.removeAccessibleListeners = Jt, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), i = Wo(window, "pointerup", (u, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: d, onTapCancel: f, globalTapTarget: p } = this.node.getProps();
        kt.update(() => {
          !p && !jg(this.node.current, u.target) ? f && f(u, c) : d && d(u, c);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), a = Wo(window, "pointercancel", (u, c) => this.cancelPress(u, c), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = Ii(i, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const a = (u) => {
          u.key !== "Enter" || !this.checkPressEnd() || wd("up", (c, d) => {
            const { onTap: f } = this.node.getProps();
            f && kt.update(() => f(c, d));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Zo(this.node.current, "keyup", a), wd("down", (u, c) => {
          this.startPress(u, c);
        });
      }, n = Zo(this.node.current, "keydown", t), r = () => {
        this.isPressing && wd("cancel", (i, a) => this.cancelPress(i, a));
      }, o = Zo(this.node.current, "blur", r);
      this.removeAccessibleListeners = Ii(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && kt.update(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !Gg();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && kt.update(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = Wo(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), r = Zo(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Ii(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const T5 = /* @__PURE__ */ new WeakMap(), Id = /* @__PURE__ */ new WeakMap(), Hk = (e) => {
  const t = T5.get(e.target);
  t && t(e);
}, Fk = (e) => {
  e.forEach(Hk);
};
function kk({ root: e, ...t }) {
  const n = e || document;
  Id.has(n) || Id.set(n, {});
  const r = Id.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(Fk, { root: e, ...t })), r[o];
}
function Bk(e, t, n) {
  const r = kk(t);
  return T5.set(e, n), r.observe(e), () => {
    T5.delete(e), r.unobserve(e);
  };
}
const Dk = {
  some: 0,
  all: 1
};
class Ok extends Ei {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : Dk[o]
    }, u = (c) => {
      const { isIntersecting: d } = c;
      if (this.isInView === d || (this.isInView = d, i && !d && this.hasEnteredView))
        return;
      d && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", d);
      const { onViewportEnter: f, onViewportLeave: p } = this.node.getProps(), g = d ? f : p;
      g && g(c);
    };
    return Bk(this.node.current, a, u);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Nk(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Nk({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Zk = {
  inView: {
    Feature: Ok
  },
  tap: {
    Feature: Tk
  },
  focus: {
    Feature: _k
  },
  hover: {
    Feature: Rk
  }
};
function Xg(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function $k(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.get()), t;
}
function zk(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.getVelocity()), t;
}
function I2(e, t, n) {
  const r = e.getProps();
  return e3(r, t, n !== void 0 ? n : r.custom, $k(e), zk(e));
}
let Il = Jt, kr = Jt;
process.env.NODE_ENV !== "production" && (Il = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, kr = (e, t) => {
  if (!e)
    throw new Error(t);
});
const Vi = (e) => e * 1e3, Go = (e) => e / 1e3, Wk = {
  current: !1
}, Ug = (e) => Array.isArray(e) && typeof e[0] == "number";
function Yg(e) {
  return !!(!e || typeof e == "string" && Jg[e] || Ug(e) || Array.isArray(e) && e.every(Yg));
}
const F1 = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Jg = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: F1([0, 0.65, 0.55, 1]),
  circOut: F1([0.55, 0, 1, 0.45]),
  backIn: F1([0.31, 0.01, 0.66, -0.59]),
  backOut: F1([0.33, 1.53, 0.69, 0.99])
};
function qg(e) {
  if (e)
    return Ug(e) ? F1(e) : Array.isArray(e) ? e.map(qg) : Jg[e];
}
function Gk(e, t, n, { delay: r = 0, duration: o, repeat: i = 0, repeatType: a = "loop", ease: u, times: c } = {}) {
  const d = { [t]: n };
  c && (d.offset = c);
  const f = qg(u);
  return Array.isArray(f) && (d.easing = f), e.animate(d, {
    delay: r,
    duration: o,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
function jk(e, { repeat: t, repeatType: n = "loop" }) {
  const r = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const Kg = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, Xk = 1e-7, Uk = 12;
function Yk(e, t, n, r, o) {
  let i, a, u = 0;
  do
    a = t + (n - t) / 2, i = Kg(a, r, o) - e, i > 0 ? n = a : t = a;
  while (Math.abs(i) > Xk && ++u < Uk);
  return a;
}
function Vl(e, t, n, r) {
  if (e === t && n === r)
    return Jt;
  const o = (i) => Yk(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : Kg(o(i), t, r);
}
const Jk = Vl(0.42, 0, 1, 1), qk = Vl(0, 0, 0.58, 1), Qg = Vl(0.42, 0, 0.58, 1), Kk = (e) => Array.isArray(e) && typeof e[0] != "number", em = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, tm = (e) => (t) => 1 - e(1 - t), t3 = (e) => 1 - Math.sin(Math.acos(e)), nm = tm(t3), Qk = em(t3), rm = Vl(0.33, 1.53, 0.69, 0.99), n3 = tm(rm), eB = em(n3), tB = (e) => (e *= 2) < 1 ? 0.5 * n3(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), o6 = {
  linear: Jt,
  easeIn: Jk,
  easeInOut: Qg,
  easeOut: qk,
  circIn: t3,
  circInOut: Qk,
  circOut: nm,
  backIn: n3,
  backInOut: eB,
  backOut: rm,
  anticipate: tB
}, i6 = (e) => {
  if (Array.isArray(e)) {
    kr(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return Vl(t, n, r, o);
  } else if (typeof e == "string")
    return kr(o6[e] !== void 0, `Invalid easing type '${e}'`), o6[e];
  return e;
}, r3 = (e, t) => (n) => !!(Sl(n) && ok.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), om = (e, t, n) => (r) => {
  if (!Sl(r))
    return r;
  const [o, i, a, u] = r.match(S2);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: u !== void 0 ? parseFloat(u) : 1
  };
}, nB = (e) => Ai(0, 255, e), Vd = {
  ...xs,
  transform: (e) => Math.round(nB(e))
}, ns = {
  test: r3("rgb", "red"),
  parse: om("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Vd.transform(e) + ", " + Vd.transform(t) + ", " + Vd.transform(n) + ", " + U1(X1.transform(r)) + ")"
};
function rB(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const H5 = {
  test: r3("#"),
  parse: rB,
  transform: ns.transform
}, pa = {
  test: r3("hsl", "hue"),
  parse: om("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Co.transform(U1(t)) + ", " + Co.transform(U1(n)) + ", " + U1(X1.transform(r)) + ")"
}, kn = {
  test: (e) => ns.test(e) || H5.test(e) || pa.test(e),
  parse: (e) => ns.test(e) ? ns.parse(e) : pa.test(e) ? pa.parse(e) : H5.parse(e),
  transform: (e) => Sl(e) ? e : e.hasOwnProperty("red") ? ns.transform(e) : pa.transform(e)
}, Gt = (e, t, n) => -n * e + n * t + e;
function Ad(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function oB({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, a = 0;
  if (!t)
    o = i = a = n;
  else {
    const u = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - u;
    o = Ad(c, u, e + 1 / 3), i = Ad(c, u, e), a = Ad(c, u, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const Ld = (e, t, n) => {
  const r = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - r) + r));
}, iB = [H5, ns, pa], sB = (e) => iB.find((t) => t.test(e));
function s6(e) {
  const t = sB(e);
  kr(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let n = t.parse(e);
  return t === pa && (n = oB(n)), n;
}
const im = (e, t) => {
  const n = s6(e), r = s6(t), o = { ...n };
  return (i) => (o.red = Ld(n.red, r.red, i), o.green = Ld(n.green, r.green, i), o.blue = Ld(n.blue, r.blue, i), o.alpha = Gt(n.alpha, r.alpha, i), ns.transform(o));
};
function aB(e) {
  var t, n;
  return isNaN(e) && Sl(e) && (((t = e.match(S2)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(Rg)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const sm = {
  regex: nk,
  countKey: "Vars",
  token: "${v}",
  parse: Jt
}, am = {
  regex: Rg,
  countKey: "Colors",
  token: "${c}",
  parse: kn.parse
}, lm = {
  regex: S2,
  countKey: "Numbers",
  token: "${n}",
  parse: xs.parse
};
function Md(e, { regex: t, countKey: n, token: r, parse: o }) {
  const i = e.tokenised.match(t);
  i && (e["num" + n] = i.length, e.tokenised = e.tokenised.replace(t, r), e.values.push(...i.map(o)));
}
function zc(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && Md(n, sm), Md(n, am), Md(n, lm), n;
}
function um(e) {
  return zc(e).values;
}
function cm(e) {
  const { values: t, numColors: n, numVars: r, tokenised: o } = zc(e), i = t.length;
  return (a) => {
    let u = o;
    for (let c = 0; c < i; c++)
      c < r ? u = u.replace(sm.token, a[c]) : c < r + n ? u = u.replace(am.token, kn.transform(a[c])) : u = u.replace(lm.token, U1(a[c]));
    return u;
  };
}
const lB = (e) => typeof e == "number" ? 0 : e;
function uB(e) {
  const t = um(e);
  return cm(e)(t.map(lB));
}
const Li = {
  test: aB,
  parse: um,
  createTransformer: cm,
  getAnimatableNone: uB
}, dm = (e, t) => (n) => `${n > 0 ? t : e}`;
function fm(e, t) {
  return typeof e == "number" ? (n) => Gt(e, t, n) : kn.test(e) ? im(e, t) : e.startsWith("var(") ? dm(e, t) : pm(e, t);
}
const hm = (e, t) => {
  const n = [...e], r = n.length, o = e.map((i, a) => fm(i, t[a]));
  return (i) => {
    for (let a = 0; a < r; a++)
      n[a] = o[a](i);
    return n;
  };
}, cB = (e, t) => {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = fm(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}, pm = (e, t) => {
  const n = Li.createTransformer(t), r = zc(e), o = zc(t);
  return r.numVars === o.numVars && r.numColors === o.numColors && r.numNumbers >= o.numNumbers ? Ii(hm(r.values, o.values), n) : (Il(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), dm(e, t));
}, cl = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, a6 = (e, t) => (n) => Gt(e, t, n);
function dB(e) {
  return typeof e == "number" ? a6 : typeof e == "string" ? kn.test(e) ? im : pm : Array.isArray(e) ? hm : typeof e == "object" ? cB : a6;
}
function fB(e, t, n) {
  const r = [], o = n || dB(e[0]), i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let u = o(e[a], e[a + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[a] || Jt : t;
      u = Ii(c, u);
    }
    r.push(u);
  }
  return r;
}
function gm(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (kr(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = fB(t, r, o), u = a.length, c = (d) => {
    let f = 0;
    if (u > 1)
      for (; f < e.length - 2 && !(d < e[f + 1]); f++)
        ;
    const p = cl(e[f], e[f + 1], d);
    return a[f](p);
  };
  return n ? (d) => c(Ai(e[0], e[i - 1], d)) : c;
}
function hB(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = cl(0, t, r);
    e.push(Gt(n, 1, o));
  }
}
function pB(e) {
  const t = [0];
  return hB(t, e.length - 1), t;
}
function gB(e, t) {
  return e.map((n) => n * t);
}
function mB(e, t) {
  return e.map(() => t || Qg).splice(0, e.length - 1);
}
function Wc({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = Kk(r) ? r.map(i6) : i6(r), i = {
    done: !1,
    value: t[0]
  }, a = gB(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : pB(t),
    e
  ), u = gm(a, t, {
    ease: Array.isArray(o) ? o : mB(t, o)
  });
  return {
    calculatedDuration: e,
    next: (c) => (i.value = u(c), i.done = c >= e, i)
  };
}
function mm(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const CB = 5;
function Cm(e, t, n) {
  const r = Math.max(t - CB, 0);
  return mm(n - e(r), t - r);
}
const Pd = 1e-3, vB = 0.01, l6 = 10, bB = 0.05, yB = 1;
function xB({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, i;
  Il(e <= Vi(l6), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = Ai(bB, yB, a), e = Ai(vB, l6, Go(e)), a < 1 ? (o = (d) => {
    const f = d * a, p = f * e, g = f - n, m = F5(d, a), b = Math.exp(-p);
    return Pd - g / m * b;
  }, i = (d) => {
    const p = d * a * e, g = p * n + n, m = Math.pow(a, 2) * Math.pow(d, 2) * e, b = Math.exp(-p), v = F5(Math.pow(d, 2), a);
    return (-o(d) + Pd > 0 ? -1 : 1) * ((g - m) * b) / v;
  }) : (o = (d) => {
    const f = Math.exp(-d * e), p = (d - n) * e + 1;
    return -Pd + f * p;
  }, i = (d) => {
    const f = Math.exp(-d * e), p = (n - d) * (e * e);
    return f * p;
  });
  const u = 5 / e, c = wB(o, i, u);
  if (e = Vi(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const d = Math.pow(c, 2) * r;
    return {
      stiffness: d,
      damping: a * 2 * Math.sqrt(r * d),
      duration: e
    };
  }
}
const SB = 12;
function wB(e, t, n) {
  let r = n;
  for (let o = 1; o < SB; o++)
    r = r - e(r) / t(r);
  return r;
}
function F5(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const IB = ["duration", "bounce"], VB = ["stiffness", "damping", "mass"];
function u6(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function AB(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!u6(e, VB) && u6(e, IB)) {
    const n = xB(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function vm({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], i = e[e.length - 1], a = { done: !1, value: o }, { stiffness: u, damping: c, mass: d, duration: f, velocity: p, isResolvedFromDuration: g } = AB({
    ...r,
    velocity: -Go(r.velocity || 0)
  }), m = p || 0, b = c / (2 * Math.sqrt(u * d)), v = i - o, y = Go(Math.sqrt(u / d)), w = Math.abs(v) < 5;
  n || (n = w ? 0.01 : 2), t || (t = w ? 5e-3 : 0.5);
  let I;
  if (b < 1) {
    const V = F5(y, b);
    I = (M) => {
      const L = Math.exp(-b * y * M);
      return i - L * ((m + b * y * v) / V * Math.sin(V * M) + v * Math.cos(V * M));
    };
  } else if (b === 1)
    I = (V) => i - Math.exp(-y * V) * (v + (m + y * v) * V);
  else {
    const V = y * Math.sqrt(b * b - 1);
    I = (M) => {
      const L = Math.exp(-b * y * M), R = Math.min(V * M, 300);
      return i - L * ((m + b * y * v) * Math.sinh(R) + V * v * Math.cosh(R)) / V;
    };
  }
  return {
    calculatedDuration: g && f || null,
    next: (V) => {
      const M = I(V);
      if (g)
        a.done = V >= f;
      else {
        let L = m;
        V !== 0 && (b < 1 ? L = Cm(I, V, M) : L = 0);
        const R = Math.abs(L) <= n, _ = Math.abs(i - M) <= t;
        a.done = R && _;
      }
      return a.value = a.done ? i : M, a;
    }
  };
}
function c6({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: a, min: u, max: c, restDelta: d = 0.5, restSpeed: f }) {
  const p = e[0], g = {
    done: !1,
    value: p
  }, m = (H) => u !== void 0 && H < u || c !== void 0 && H > c, b = (H) => u === void 0 ? c : c === void 0 || Math.abs(u - H) < Math.abs(c - H) ? u : c;
  let v = n * t;
  const y = p + v, w = a === void 0 ? y : a(y);
  w !== y && (v = w - p);
  const I = (H) => -v * Math.exp(-H / r), V = (H) => w + I(H), M = (H) => {
    const B = I(H), Z = V(H);
    g.done = Math.abs(B) <= d, g.value = g.done ? w : Z;
  };
  let L, R;
  const _ = (H) => {
    m(g.value) && (L = H, R = vm({
      keyframes: [g.value, b(g.value)],
      velocity: Cm(V, H, g.value),
      damping: o,
      stiffness: i,
      restDelta: d,
      restSpeed: f
    }));
  };
  return _(0), {
    calculatedDuration: null,
    next: (H) => {
      let B = !1;
      return !R && L === void 0 && (B = !0, M(H), _(H)), L !== void 0 && H > L ? R.next(H - L) : (!B && M(H), g);
    }
  };
}
const LB = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => kt.update(t, !0),
    stop: () => Yo(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => En.isProcessing ? En.timestamp : performance.now()
  };
}, d6 = 2e4;
function f6(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < d6; )
    t += n, r = e.next(t);
  return t >= d6 ? 1 / 0 : t;
}
const MB = {
  decay: c6,
  inertia: c6,
  tween: Wc,
  keyframes: Wc,
  spring: vm
};
function Gc({ autoplay: e = !0, delay: t = 0, driver: n = LB, keyframes: r, type: o = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: u = "loop", onPlay: c, onStop: d, onComplete: f, onUpdate: p, ...g }) {
  let m = 1, b = !1, v, y;
  const w = () => {
    y = new Promise((X) => {
      v = X;
    });
  };
  w();
  let I;
  const V = MB[o] || Wc;
  let M;
  V !== Wc && typeof r[0] != "number" && (process.env.NODE_ENV !== "production" && kr(r.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${r}`), M = gm([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const L = V({ ...g, keyframes: r });
  let R;
  u === "mirror" && (R = V({
    ...g,
    keyframes: [...r].reverse(),
    velocity: -(g.velocity || 0)
  }));
  let _ = "idle", H = null, B = null, Z = null;
  L.calculatedDuration === null && i && (L.calculatedDuration = f6(L));
  const { calculatedDuration: G } = L;
  let se = 1 / 0, ue = 1 / 0;
  G !== null && (se = G + a, ue = se * (i + 1) - a);
  let ce = 0;
  const xe = (X) => {
    if (B === null)
      return;
    m > 0 && (B = Math.min(B, X)), m < 0 && (B = Math.min(X - ue / m, B)), H !== null ? ce = H : ce = Math.round(X - B) * m;
    const ie = ce - t * (m >= 0 ? 1 : -1), W = m >= 0 ? ie < 0 : ie > ue;
    ce = Math.max(ie, 0), _ === "finished" && H === null && (ce = ue);
    let re = ce, te = L;
    if (i) {
      const Se = Math.min(ce, ue) / se;
      let de = Math.floor(Se), Ve = Se % 1;
      !Ve && Se >= 1 && (Ve = 1), Ve === 1 && de--, de = Math.min(de, i + 1), !!(de % 2) && (u === "reverse" ? (Ve = 1 - Ve, a && (Ve -= a / se)) : u === "mirror" && (te = R)), re = Ai(0, 1, Ve) * se;
    }
    const ee = W ? { done: !1, value: r[0] } : te.next(re);
    M && (ee.value = M(ee.value));
    let { done: ge } = ee;
    !W && G !== null && (ge = m >= 0 ? ce >= ue : ce <= 0);
    const pe = H === null && (_ === "finished" || _ === "running" && ge);
    return p && p(ee.value), pe && Y(), ee;
  }, he = () => {
    I && I.stop(), I = void 0;
  }, z = () => {
    _ = "idle", he(), v(), w(), B = Z = null;
  }, Y = () => {
    _ = "finished", f && f(), he(), v();
  }, ae = () => {
    if (b)
      return;
    I || (I = n(xe));
    const X = I.now();
    c && c(), H !== null ? B = X - H : (!B || _ === "finished") && (B = X), _ === "finished" && w(), Z = B, H = null, _ = "running", I.start();
  };
  e && ae();
  const j = {
    then(X, ie) {
      return y.then(X, ie);
    },
    get time() {
      return Go(ce);
    },
    set time(X) {
      X = Vi(X), ce = X, H !== null || !I || m === 0 ? H = X : B = I.now() - X / m;
    },
    get duration() {
      const X = L.calculatedDuration === null ? f6(L) : L.calculatedDuration;
      return Go(X);
    },
    get speed() {
      return m;
    },
    set speed(X) {
      X === m || !I || (m = X, j.time = Go(ce));
    },
    get state() {
      return _;
    },
    play: ae,
    pause: () => {
      _ = "paused", H = ce;
    },
    stop: () => {
      b = !0, _ !== "idle" && (_ = "idle", d && d(), z());
    },
    cancel: () => {
      Z !== null && xe(Z), z();
    },
    complete: () => {
      _ = "finished";
    },
    sample: (X) => (B = 0, xe(X))
  };
  return j;
}
function PB(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const EB = PB(() => Object.hasOwnProperty.call(Element.prototype, "animate")), RB = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), ec = 10, _B = 2e4, TB = (e, t) => t.type === "spring" || e === "backgroundColor" || !Yg(t.ease);
function HB(e, t, { onUpdate: n, onComplete: r, ...o }) {
  if (!(EB() && RB.has(t) && !o.repeatDelay && o.repeatType !== "mirror" && o.damping !== 0 && o.type !== "inertia"))
    return !1;
  let a = !1, u, c, d = !1;
  const f = () => {
    c = new Promise((V) => {
      u = V;
    });
  };
  f();
  let { keyframes: p, duration: g = 300, ease: m, times: b } = o;
  if (TB(t, o)) {
    const V = Gc({
      ...o,
      repeat: 0,
      delay: 0
    });
    let M = { done: !1, value: p[0] };
    const L = [];
    let R = 0;
    for (; !M.done && R < _B; )
      M = V.sample(R), L.push(M.value), R += ec;
    b = void 0, p = L, g = R - ec, m = "linear";
  }
  const v = Gk(e.owner.current, t, p, {
    ...o,
    duration: g,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: m,
    times: b
  }), y = () => {
    d = !1, v.cancel();
  }, w = () => {
    d = !0, kt.update(y), u(), f();
  };
  return v.onfinish = () => {
    d || (e.set(jk(p, o)), r && r(), w());
  }, {
    then(V, M) {
      return c.then(V, M);
    },
    attachTimeline(V) {
      return v.timeline = V, v.onfinish = null, Jt;
    },
    get time() {
      return Go(v.currentTime || 0);
    },
    set time(V) {
      v.currentTime = Vi(V);
    },
    get speed() {
      return v.playbackRate;
    },
    set speed(V) {
      v.playbackRate = V;
    },
    get duration() {
      return Go(g);
    },
    play: () => {
      a || (v.play(), Yo(y));
    },
    pause: () => v.pause(),
    stop: () => {
      if (a = !0, v.playState === "idle")
        return;
      const { currentTime: V } = v;
      if (V) {
        const M = Gc({
          ...o,
          autoplay: !1
        });
        e.setWithVelocity(M.sample(V - ec).value, M.sample(V).value, ec);
      }
      w();
    },
    complete: () => {
      d || v.finish();
    },
    cancel: w
  };
}
function FB({ keyframes: e, delay: t, onUpdate: n, onComplete: r }) {
  const o = () => (n && n(e[e.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: Jt,
    pause: Jt,
    stop: Jt,
    then: (i) => (i(), Promise.resolve()),
    cancel: Jt,
    complete: Jt
  });
  return t ? Gc({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: o
  }) : o();
}
const kB = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, BB = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), DB = {
  type: "keyframes",
  duration: 0.8
}, OB = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, NB = (e, { keyframes: t }) => t.length > 2 ? DB : ys.has(e) ? e.startsWith("scale") ? BB(t[1]) : kB : OB, k5 = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(Li.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), ZB = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function $B(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(S2) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = ZB.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const zB = /([a-z-]*)\(.*?\)/g, B5 = {
  ...Li,
  getAnimatableNone: (e) => {
    const t = e.match(zB);
    return t ? t.map($B).join(" ") : e;
  }
}, WB = {
  ..._g,
  // Color props
  color: kn,
  backgroundColor: kn,
  outlineColor: kn,
  fill: kn,
  stroke: kn,
  // Border props
  borderColor: kn,
  borderTopColor: kn,
  borderRightColor: kn,
  borderBottomColor: kn,
  borderLeftColor: kn,
  filter: B5,
  WebkitFilter: B5
}, o3 = (e) => WB[e];
function bm(e, t) {
  let n = o3(e);
  return n !== B5 && (n = Li), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const ym = (e) => /^0[^.\s]+$/.test(e);
function GB(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || ym(e);
}
function jB(e, t, n, r) {
  const o = k5(t, n);
  let i;
  Array.isArray(n) ? i = [...n] : i = [null, n];
  const a = r.from !== void 0 ? r.from : e.get();
  let u;
  const c = [];
  for (let d = 0; d < i.length; d++)
    i[d] === null && (i[d] = d === 0 ? a : i[d - 1]), GB(i[d]) && c.push(d), typeof i[d] == "string" && i[d] !== "none" && i[d] !== "0" && (u = i[d]);
  if (o && c.length && u)
    for (let d = 0; d < c.length; d++) {
      const f = c[d];
      i[f] = bm(t, u);
    }
  return i;
}
function XB({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: i, repeatType: a, repeatDelay: u, from: c, elapsed: d, ...f }) {
  return !!Object.keys(f).length;
}
function i3(e, t) {
  return e[t] || e.default || e;
}
const UB = {
  skipAnimations: !1
}, s3 = (e, t, n, r = {}) => (o) => {
  const i = i3(r, e) || {}, a = i.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - Vi(a);
  const c = jB(t, e, n, i), d = c[0], f = c[c.length - 1], p = k5(e, d), g = k5(e, f);
  Il(p === g, `You are trying to animate ${e} from "${d}" to "${f}". ${d} is not an animatable value - to enable this animation set ${d} to a value animatable to ${f} via the \`style\` property.`);
  let m = {
    keyframes: c,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...i,
    delay: -u,
    onUpdate: (b) => {
      t.set(b), i.onUpdate && i.onUpdate(b);
    },
    onComplete: () => {
      o(), i.onComplete && i.onComplete();
    }
  };
  if (XB(i) || (m = {
    ...m,
    ...NB(e, m)
  }), m.duration && (m.duration = Vi(m.duration)), m.repeatDelay && (m.repeatDelay = Vi(m.repeatDelay)), !p || !g || Wk.current || i.type === !1 || UB.skipAnimations)
    return FB(m);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !r.isHandoff && t.owner && t.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !t.owner.getProps().onUpdate
  ) {
    const b = HB(t, e, m);
    if (b)
      return b;
  }
  return Gc(m);
};
function jc(e) {
  return !!(Kn(e) && e.add);
}
const xm = (e) => /^\-?\d*\.?\d+$/.test(e);
function a3(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function l3(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class u3 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return a3(this.subscriptions, t), () => l3(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const a = this.subscriptions[i];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const h6 = /* @__PURE__ */ new Set();
function c3(e, t, n) {
  e || h6.has(t) || (console.warn(t), n && console.warn(n), h6.add(t));
}
const YB = (e) => !isNaN(parseFloat(e));
class JB {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: i, timestamp: a } = En;
      this.lastUpdated !== a && (this.timeDelta = i, this.lastUpdated = a, kt.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => kt.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = YB(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && c3(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new u3());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), kt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = t, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      mm(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ma(e, t) {
  return new JB(e, t);
}
const Sm = (e) => (t) => t.test(e), qB = {
  test: (e) => e === "auto",
  parse: (e) => e
}, wm = [xs, Ge, Co, mi, sk, ik, qB], S1 = (e) => wm.find(Sm(e)), KB = [...wm, kn, Li], QB = (e) => KB.find(Sm(e));
function eD(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ma(n));
}
function tD(e, t) {
  const n = I2(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n ? e.makeTargetAnimatable(n, !1) : {};
  i = { ...i, ...r };
  for (const a in i) {
    const u = yk(i[a]);
    eD(e, a, u);
  }
}
function nD(e, t, n) {
  var r, o;
  const i = Object.keys(t).filter((u) => !e.hasValue(u)), a = i.length;
  if (a)
    for (let u = 0; u < a; u++) {
      const c = i[u], d = t[c];
      let f = null;
      Array.isArray(d) && (f = d[0]), f === null && (f = (o = (r = n[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && o !== void 0 ? o : t[c]), f != null && (typeof f == "string" && (xm(f) || ym(f)) ? f = parseFloat(f) : !QB(f) && Li.test(d) && (f = bm(c, d)), e.addValue(c, Ma(f, { owner: e })), n[c] === void 0 && (n[c] = f), f !== null && e.setBaseTarget(c, f));
    }
}
function rD(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function oD(e, t, n) {
  const r = {};
  for (const o in e) {
    const i = rD(o, t);
    if (i !== void 0)
      r[o] = i;
    else {
      const a = n.getValue(o);
      a && (r[o] = a.get());
    }
  }
  return r;
}
function iD({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function sD(e, t) {
  const n = e.get();
  if (Array.isArray(t)) {
    for (let r = 0; r < t.length; r++)
      if (t[r] !== n)
        return !0;
  } else
    return n !== t;
}
function Im(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: a, ...u } = e.makeTargetAnimatable(t);
  const c = e.getValue("willChange");
  r && (i = r);
  const d = [], f = o && e.animationState && e.animationState.getState()[o];
  for (const p in u) {
    const g = e.getValue(p), m = u[p];
    if (!g || m === void 0 || f && iD(f, p))
      continue;
    const b = {
      delay: n,
      elapsed: 0,
      ...i3(i || {}, p)
    };
    if (window.HandoffAppearAnimations) {
      const w = e.getProps()[Vg];
      if (w) {
        const I = window.HandoffAppearAnimations(w, p, g, kt);
        I !== null && (b.elapsed = I, b.isHandoff = !0);
      }
    }
    let v = !b.isHandoff && !sD(g, m);
    if (b.type === "spring" && (g.getVelocity() || b.velocity) && (v = !1), g.animation && (v = !1), v)
      continue;
    g.start(s3(p, g, m, e.shouldReduceMotion && ys.has(p) ? { type: !1 } : b));
    const y = g.animation;
    jc(c) && (c.add(p), y.then(() => c.remove(p))), d.push(y);
  }
  return a && Promise.all(d).then(() => {
    a && tD(e, a);
  }), d;
}
function D5(e, t, n = {}) {
  const r = I2(e, t, n.custom);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const i = r ? () => Promise.all(Im(e, r, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: d = 0, staggerChildren: f, staggerDirection: p } = o;
    return aD(e, t, d + c, f, p, n);
  } : () => Promise.resolve(), { when: u } = o;
  if (u) {
    const [c, d] = u === "beforeChildren" ? [i, a] : [a, i];
    return c().then(() => d());
  } else
    return Promise.all([i(), a(n.delay)]);
}
function aD(e, t, n = 0, r = 0, o = 1, i) {
  const a = [], u = (e.variantChildren.size - 1) * r, c = o === 1 ? (d = 0) => d * r : (d = 0) => u - d * r;
  return Array.from(e.variantChildren).sort(lD).forEach((d, f) => {
    d.notify("AnimationStart", t), a.push(D5(d, t, {
      ...i,
      delay: n + c(f)
    }).then(() => d.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function lD(e, t) {
  return e.sortNodePosition(t);
}
function uD(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => D5(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = D5(e, t, n);
  else {
    const o = typeof t == "function" ? I2(e, t, n.custom) : t;
    r = Promise.all(Im(e, o, n));
  }
  return r.then(() => e.notify("AnimationComplete", t));
}
const cD = [...Gf].reverse(), dD = Gf.length;
function fD(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => uD(e, n, r)));
}
function hD(e) {
  let t = fD(e);
  const n = gD();
  let r = !0;
  const o = (c, d) => {
    const f = I2(e, d);
    if (f) {
      const { transition: p, transitionEnd: g, ...m } = f;
      c = { ...c, ...m, ...g };
    }
    return c;
  };
  function i(c) {
    t = c(e);
  }
  function a(c, d) {
    const f = e.getProps(), p = e.getVariantContext(!0) || {}, g = [], m = /* @__PURE__ */ new Set();
    let b = {}, v = 1 / 0;
    for (let w = 0; w < dD; w++) {
      const I = cD[w], V = n[I], M = f[I] !== void 0 ? f[I] : p[I], L = ll(M), R = I === d ? V.isActive : null;
      R === !1 && (v = w);
      let _ = M === p[I] && M !== f[I] && L;
      if (_ && r && e.manuallyAnimateOnMount && (_ = !1), V.protectedKeys = { ...b }, // If it isn't active and hasn't *just* been set as inactive
      !V.isActive && R === null || // If we didn't and don't have any defined prop for this animation type
      !M && !V.prevProp || // Or if the prop doesn't define an animation
      y2(M) || typeof M == "boolean")
        continue;
      let B = pD(V.prevProp, M) || // If we're making this variant active, we want to always make it active
      I === d && V.isActive && !_ && L || // If we removed a higher-priority variant (i is in reverse order)
      w > v && L, Z = !1;
      const G = Array.isArray(M) ? M : [M];
      let se = G.reduce(o, {});
      R === !1 && (se = {});
      const { prevResolvedValues: ue = {} } = V, ce = {
        ...ue,
        ...se
      }, xe = (he) => {
        B = !0, m.has(he) && (Z = !0, m.delete(he)), V.needsAnimating[he] = !0;
      };
      for (const he in ce) {
        const z = se[he], Y = ue[he];
        if (b.hasOwnProperty(he))
          continue;
        let ae = !1;
        $c(z) && $c(Y) ? ae = !Xg(z, Y) : ae = z !== Y, ae ? z !== void 0 ? xe(he) : m.add(he) : z !== void 0 && m.has(he) ? xe(he) : V.protectedKeys[he] = !0;
      }
      V.prevProp = M, V.prevResolvedValues = se, V.isActive && (b = { ...b, ...se }), r && e.blockInitialAnimation && (B = !1), B && (!_ || Z) && g.push(...G.map((he) => ({
        animation: he,
        options: { type: I, ...c }
      })));
    }
    if (m.size) {
      const w = {};
      m.forEach((I) => {
        const V = e.getBaseTarget(I);
        V !== void 0 && (w[I] = V);
      }), g.push({ animation: w });
    }
    let y = !!g.length;
    return r && (f.initial === !1 || f.initial === f.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, y ? t(g) : Promise.resolve();
  }
  function u(c, d, f) {
    var p;
    if (n[c].isActive === d)
      return Promise.resolve();
    (p = e.variantChildren) === null || p === void 0 || p.forEach((m) => {
      var b;
      return (b = m.animationState) === null || b === void 0 ? void 0 : b.setActive(c, d);
    }), n[c].isActive = d;
    const g = a(f, c);
    for (const m in n)
      n[m].protectedKeys = {};
    return g;
  }
  return {
    animateChanges: a,
    setActive: u,
    setAnimateFunction: i,
    getState: () => n
  };
}
function pD(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Xg(t, e) : !1;
}
function Yi(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function gD() {
  return {
    animate: Yi(!0),
    whileInView: Yi(),
    whileHover: Yi(),
    whileTap: Yi(),
    whileDrag: Yi(),
    whileFocus: Yi(),
    exit: Yi()
  };
}
class mD extends Ei {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = hD(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), y2(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let CD = 0;
class vD extends Ei {
  constructor() {
    super(...arguments), this.id = CD++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === o)
      return;
    const i = this.node.animationState.setActive("exit", !t, { custom: r ?? this.node.getProps().custom });
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const bD = {
  animation: {
    Feature: mD
  },
  exit: {
    Feature: vD
  }
}, p6 = (e, t) => Math.abs(e - t);
function yD(e, t) {
  const n = p6(e.x, t.x), r = p6(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Vm {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const p = Rd(this.lastMoveEventInfo, this.history), g = this.startEvent !== null, m = yD(p.offset, { x: 0, y: 0 }) >= 3;
      if (!g && !m)
        return;
      const { point: b } = p, { timestamp: v } = En;
      this.history.push({ ...b, timestamp: v });
      const { onStart: y, onMove: w } = this.handlers;
      g || (y && y(this.lastMoveEvent, p), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, p);
    }, this.handlePointerMove = (p, g) => {
      this.lastMoveEvent = p, this.lastMoveEventInfo = Ed(g, this.transformPagePoint), kt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (p, g) => {
      this.end();
      const { onEnd: m, onSessionEnd: b, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Rd(p.type === "pointercancel" ? this.lastMoveEventInfo : Ed(g, this.transformPagePoint), this.history);
      this.startEvent && m && m(p, y), b && b(p, y);
    }, !$g(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const a = w2(t), u = Ed(a, this.transformPagePoint), { point: c } = u, { timestamp: d } = En;
    this.history = [{ ...c, timestamp: d }];
    const { onSessionStart: f } = n;
    f && f(t, Rd(u, this.history)), this.removeListeners = Ii(Wo(this.contextWindow, "pointermove", this.handlePointerMove), Wo(this.contextWindow, "pointerup", this.handlePointerUp), Wo(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Yo(this.updatePoint);
  }
}
function Ed(e, t) {
  return t ? { point: t(e.point) } : e;
}
function g6(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Rd({ point: e }, t) {
  return {
    point: e,
    delta: g6(e, Am(t)),
    offset: g6(e, xD(t)),
    velocity: SD(t, 0.1)
  };
}
function xD(e) {
  return e[0];
}
function Am(e) {
  return e[e.length - 1];
}
function SD(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = Am(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > Vi(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = Go(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function hr(e) {
  return e.max - e.min;
}
function O5(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function m6(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Gt(t.min, t.max, e.origin), e.scale = hr(n) / hr(t), (O5(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Gt(n.min, n.max, e.origin) - e.originPoint, (O5(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Y1(e, t, n, r) {
  m6(e.x, t.x, n.x, r ? r.originX : void 0), m6(e.y, t.y, n.y, r ? r.originY : void 0);
}
function C6(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + hr(t);
}
function wD(e, t, n) {
  C6(e.x, t.x, n.x), C6(e.y, t.y, n.y);
}
function v6(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + hr(t);
}
function J1(e, t, n) {
  v6(e.x, t.x, n.x), v6(e.y, t.y, n.y);
}
function ID(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Gt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Gt(n, e, r.max) : Math.min(e, n)), e;
}
function b6(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function VD(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: b6(e.x, n, o),
    y: b6(e.y, t, r)
  };
}
function y6(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function AD(e, t) {
  return {
    x: y6(e.x, t.x),
    y: y6(e.y, t.y)
  };
}
function LD(e, t) {
  let n = 0.5;
  const r = hr(e), o = hr(t);
  return o > r ? n = cl(t.min, t.max - r, e.min) : r > o && (n = cl(e.min, e.max - o, t.min)), Ai(0, 1, n);
}
function MD(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const N5 = 0.35;
function PD(e = N5) {
  return e === !1 ? e = 0 : e === !0 && (e = N5), {
    x: x6(e, "left", "right"),
    y: x6(e, "top", "bottom")
  };
}
function x6(e, t, n) {
  return {
    min: S6(e, t),
    max: S6(e, n)
  };
}
function S6(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const w6 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), ga = () => ({
  x: w6(),
  y: w6()
}), I6 = () => ({ min: 0, max: 0 }), ln = () => ({
  x: I6(),
  y: I6()
});
function Pr(e) {
  return [e("x"), e("y")];
}
function Lm({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function ED({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function RD(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function _d(e) {
  return e === void 0 || e === 1;
}
function Z5({ scale: e, scaleX: t, scaleY: n }) {
  return !_d(e) || !_d(t) || !_d(n);
}
function Ji(e) {
  return Z5(e) || Mm(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function Mm(e) {
  return V6(e.x) || V6(e.y);
}
function V6(e) {
  return e && e !== "0%";
}
function Xc(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function A6(e, t, n, r, o) {
  return o !== void 0 && (e = Xc(e, o, r)), Xc(e, n, r) + t;
}
function $5(e, t = 0, n = 1, r, o) {
  e.min = A6(e.min, t, n, r, o), e.max = A6(e.max, t, n, r, o);
}
function Pm(e, { x: t, y: n }) {
  $5(e.x, t.translate, t.scale, t.originPoint), $5(e.y, n.translate, n.scale, n.originPoint);
}
function _D(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, a;
  for (let u = 0; u < o; u++) {
    i = n[u], a = i.projectionDelta;
    const c = i.instance;
    c && c.style && c.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && ma(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, Pm(e, a)), r && Ji(i.latestValues) && ma(e, i.latestValues));
  }
  t.x = L6(t.x), t.y = L6(t.y);
}
function L6(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function bi(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function M6(e, t, [n, r, o]) {
  const i = t[o] !== void 0 ? t[o] : 0.5, a = Gt(e.min, e.max, i);
  $5(e, t[n], t[r], a, t.scale);
}
const TD = ["x", "scaleX", "originX"], HD = ["y", "scaleY", "originY"];
function ma(e, t) {
  M6(e.x, t, TD), M6(e.y, t, HD);
}
function Em(e, t) {
  return Lm(RD(e.getBoundingClientRect(), t));
}
function FD(e, t, n) {
  const r = Em(e, n), { scroll: o } = t;
  return o && (bi(r.x, o.offset.x), bi(r.y, o.offset.y)), r;
}
const Rm = ({ current: e }) => e ? e.ownerDocument.defaultView : null, kD = /* @__PURE__ */ new WeakMap();
class BD {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ln(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (f) => {
      const { dragSnapToOrigin: p } = this.getProps();
      p ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(w2(f, "page").point);
    }, i = (f, p) => {
      const { drag: g, dragPropagation: m, onDragStart: b } = this.getProps();
      if (g && !m && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = Wg(g), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Pr((y) => {
        let w = this.getAxisMotionValue(y).get() || 0;
        if (Co.test(w)) {
          const { projection: I } = this.visualElement;
          if (I && I.layout) {
            const V = I.layout.layoutBox[y];
            V && (w = hr(V) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[y] = w;
      }), b && kt.update(() => b(f, p), !1, !0);
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, a = (f, p) => {
      const { dragPropagation: g, dragDirectionLock: m, onDirectionLock: b, onDrag: v } = this.getProps();
      if (!g && !this.openGlobalLock)
        return;
      const { offset: y } = p;
      if (m && this.currentDirection === null) {
        this.currentDirection = DD(y), this.currentDirection !== null && b && b(this.currentDirection);
        return;
      }
      this.updateAxis("x", p.point, y), this.updateAxis("y", p.point, y), this.visualElement.render(), v && v(f, p);
    }, u = (f, p) => this.stop(f, p), c = () => Pr((f) => {
      var p;
      return this.getAnimationState(f) === "paused" && ((p = this.getAxisMotionValue(f).animation) === null || p === void 0 ? void 0 : p.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new Vm(t, {
      onSessionStart: o,
      onStart: i,
      onMove: a,
      onSessionEnd: u,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      contextWindow: Rm(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: i } = this.getProps();
    i && kt.update(() => i(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !tc(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = ID(a, this.constraints[t], this.elastic[t])), i.set(a);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, i = this.constraints;
    n && ha(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = VD(o.layoutBox, n) : this.constraints = !1, this.elastic = PD(r), i !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && Pr((a) => {
      this.getAxisMotionValue(a) && (this.constraints[a] = MD(o.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !ha(t))
      return !1;
    const r = t.current;
    kr(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = FD(r, o.root, this.visualElement.getTransformPagePoint());
    let a = AD(o.layout.layoutBox, i);
    if (n) {
      const u = n(ED(a));
      this.hasMutatedConstraints = !!u, u && (a = Lm(u));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: u } = this.getProps(), c = this.constraints || {}, d = Pr((f) => {
      if (!tc(f, n, this.currentDirection))
        return;
      let p = c && c[f] || {};
      a && (p = { min: 0, max: 0 });
      const g = o ? 200 : 1e6, m = o ? 40 : 1e7, b = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: g,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...p
      };
      return this.startAxisValueAnimation(f, b);
    });
    return Promise.all(d).then(u);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(s3(t, r, 0, n));
  }
  stopAnimation() {
    Pr((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Pr((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = "_drag" + t.toUpperCase(), r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Pr((n) => {
      const { drag: r } = this.getProps();
      if (!tc(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: a, max: u } = o.layout.layoutBox[n];
        i.set(t[n] - Gt(a, u, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!ha(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    Pr((a) => {
      const u = this.getAxisMotionValue(a);
      if (u) {
        const c = u.get();
        o[a] = LD({ min: c, max: c }, this.constraints[a]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Pr((a) => {
      if (!tc(a, t, null))
        return;
      const u = this.getAxisMotionValue(a), { min: c, max: d } = this.constraints[a];
      u.set(Gt(c, d, o[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    kD.set(this.visualElement, this);
    const t = this.visualElement.current, n = Wo(t, "pointerdown", (c) => {
      const { drag: d, dragListener: f = !0 } = this.getProps();
      d && f && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      ha(c) && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), r();
    const a = Zo(window, "resize", () => this.scalePositionWithinConstraints()), u = o.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: d }) => {
      this.isDragging && d && (Pr((f) => {
        const p = this.getAxisMotionValue(f);
        p && (this.originPoint[f] += c[f].translate, p.set(p.get() + c[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), i(), u && u();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: a = N5, dragMomentum: u = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: a,
      dragMomentum: u
    };
  }
}
function tc(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function DD(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class OD extends Ei {
  constructor(t) {
    super(t), this.removeGroupControls = Jt, this.removeListeners = Jt, this.controls = new BD(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Jt;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const P6 = (e) => (t, n) => {
  e && kt.update(() => e(t, n));
};
class ND extends Ei {
  constructor() {
    super(...arguments), this.removePointerDownListener = Jt;
  }
  onPointerDown(t) {
    this.session = new Vm(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Rm(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: P6(t),
      onStart: P6(n),
      onMove: r,
      onEnd: (i, a) => {
        delete this.session, o && kt.update(() => o(i, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Wo(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function _m() {
  const e = tn(yl);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = Zr();
  return Ue(() => r(o), []), !t && n ? [!1, () => n && n(o)] : [!0];
}
function ZD() {
  return $D(tn(yl));
}
function $D(e) {
  return e === null ? !0 : e.isPresent;
}
const Pc = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function E6(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const w1 = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Ge.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = E6(e, t.target.x), r = E6(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, zD = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = Li.parse(e);
    if (o.length > 5)
      return r;
    const i = Li.createTransformer(e), a = typeof o[0] != "number" ? 1 : 0, u = n.x.scale * t.x, c = n.y.scale * t.y;
    o[0 + a] /= u, o[1 + a] /= c;
    const d = Gt(u, c, 0.5);
    return typeof o[2 + a] == "number" && (o[2 + a] /= d), typeof o[3 + a] == "number" && (o[3 + a] /= d), i(o);
  }
};
class WD extends Bn.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    KF(GD), i && (n.group && n.group.add(i), r && r.register && o && r.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Pc.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, a = r.projection;
    return a && (a.isPresent = i, o || t.layoutDependency !== n || n === void 0 ? a.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? a.promote() : a.relegate() || kt.postRender(() => {
      const u = a.getStack();
      (!u || !u.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), queueMicrotask(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Tm(e) {
  const [t, n] = _m(), r = tn(Xf);
  return Bn.createElement(WD, { ...e, layoutGroup: r, switchLayoutGroup: tn(Lg), isPresent: t, safeToRemove: n });
}
const GD = {
  borderRadius: {
    ...w1,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: w1,
  borderTopRightRadius: w1,
  borderBottomLeftRadius: w1,
  borderBottomRightRadius: w1,
  boxShadow: zD
}, Hm = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], jD = Hm.length, R6 = (e) => typeof e == "string" ? parseFloat(e) : e, _6 = (e) => typeof e == "number" || Ge.test(e);
function XD(e, t, n, r, o, i) {
  o ? (e.opacity = Gt(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    UD(r)
  ), e.opacityExit = Gt(t.opacity !== void 0 ? t.opacity : 1, 0, YD(r))) : i && (e.opacity = Gt(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let a = 0; a < jD; a++) {
    const u = `border${Hm[a]}Radius`;
    let c = T6(t, u), d = T6(n, u);
    if (c === void 0 && d === void 0)
      continue;
    c || (c = 0), d || (d = 0), c === 0 || d === 0 || _6(c) === _6(d) ? (e[u] = Math.max(Gt(R6(c), R6(d), r), 0), (Co.test(d) || Co.test(c)) && (e[u] += "%")) : e[u] = d;
  }
  (t.rotate || n.rotate) && (e.rotate = Gt(t.rotate || 0, n.rotate || 0, r));
}
function T6(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const UD = Fm(0, 0.5, nm), YD = Fm(0.5, 0.95, Jt);
function Fm(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(cl(e, t, r));
}
function H6(e, t) {
  e.min = t.min, e.max = t.max;
}
function Lr(e, t) {
  H6(e.x, t.x), H6(e.y, t.y);
}
function F6(e, t, n, r, o) {
  return e -= t, e = Xc(e, 1 / n, r), o !== void 0 && (e = Xc(e, 1 / o, r)), e;
}
function JD(e, t = 0, n = 1, r = 0.5, o, i = e, a = e) {
  if (Co.test(t) && (t = parseFloat(t), t = Gt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let u = Gt(i.min, i.max, r);
  e === i && (u -= t), e.min = F6(e.min, t, n, u, o), e.max = F6(e.max, t, n, u, o);
}
function k6(e, t, [n, r, o], i, a) {
  JD(e, t[n], t[r], t[o], t.scale, i, a);
}
const qD = ["x", "scaleX", "originX"], KD = ["y", "scaleY", "originY"];
function B6(e, t, n, r) {
  k6(e.x, t, qD, n ? n.x : void 0, r ? r.x : void 0), k6(e.y, t, KD, n ? n.y : void 0, r ? r.y : void 0);
}
function D6(e) {
  return e.translate === 0 && e.scale === 1;
}
function km(e) {
  return D6(e.x) && D6(e.y);
}
function QD(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function Bm(e, t) {
  return Math.round(e.x.min) === Math.round(t.x.min) && Math.round(e.x.max) === Math.round(t.x.max) && Math.round(e.y.min) === Math.round(t.y.min) && Math.round(e.y.max) === Math.round(t.y.max);
}
function O6(e) {
  return hr(e.x) / hr(e.y);
}
class eO {
  constructor() {
    this.members = [];
  }
  add(t) {
    a3(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (l3(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function N6(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y;
  if ((o || i) && (r = `translate3d(${o}px, ${i}px, 0) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { rotate: c, rotateX: d, rotateY: f } = n;
    c && (r += `rotate(${c}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `);
  }
  const a = e.x.scale * t.x, u = e.y.scale * t.y;
  return (a !== 1 || u !== 1) && (r += `scale(${a}, ${u})`), r || "none";
}
const tO = (e, t) => e.depth - t.depth;
class nO {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    a3(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    l3(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(tO), this.isDirty = !1, this.children.forEach(t);
  }
}
function rO(e, t) {
  const n = performance.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (Yo(r), e(i - t));
  };
  return kt.read(r, !0), () => Yo(r);
}
function oO(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function iO(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function sO(e, t, n) {
  const r = Kn(e) ? e : Ma(e);
  return r.start(s3("", r, t, n)), r.animation;
}
const Z6 = ["", "X", "Y", "Z"], aO = { visibility: "hidden" }, $6 = 1e3;
let lO = 0;
const qi = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function Dm({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(a = {}, u = t == null ? void 0 : t()) {
      this.id = lO++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, qi.totalNodes = qi.resolvedTargetDeltas = qi.recalculatedProjection = 0, this.nodes.forEach(dO), this.nodes.forEach(mO), this.nodes.forEach(CO), this.nodes.forEach(fO), oO(qi);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = u ? u.root || u : this, this.path = u ? [...u.path, u] : [], this.parent = u, this.depth = u ? u.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new nO());
    }
    addEventListener(a, u) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new u3()), this.eventHandlers.get(a).add(u);
    }
    notifyListeners(a, ...u) {
      const c = this.eventHandlers.get(a);
      c && c.notify(...u);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, u = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = iO(a), this.instance = a;
      const { layoutId: c, layout: d, visualElement: f } = this.options;
      if (f && !f.current && f.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), u && (d || c) && (this.isLayoutDirty = !0), e) {
        let p;
        const g = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, p && p(), p = rO(g, 250), Pc.hasAnimatedSinceResize && (Pc.hasAnimatedSinceResize = !1, this.nodes.forEach(W6));
        });
      }
      c && this.root.registerSharedNode(c, this), this.options.animate !== !1 && f && (c || d) && this.addEventListener("didUpdate", ({ delta: p, hasLayoutChanged: g, hasRelativeTargetChanged: m, layout: b }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || f.getDefaultTransition() || SO, { onLayoutAnimationStart: y, onLayoutAnimationComplete: w } = f.getProps(), I = !this.targetLayout || !Bm(this.targetLayout, b) || m, V = !g && m;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || V || g && (I || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(p, V);
          const M = {
            ...i3(v, "layout"),
            onPlay: y,
            onComplete: w
          };
          (f.shouldReduceMotion || this.options.layoutRoot) && (M.delay = 0, M.type = !1), this.startAnimation(M);
        } else
          g || W6(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = b;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Yo(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(vO), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const p = this.path[f];
        p.shouldResetTransform = !0, p.updateScroll("snapshot"), p.options.layoutRoot && p.willUpdate(!1);
      }
      const { layoutId: u, layout: c } = this.options;
      if (u === void 0 && !c)
        return;
      const d = this.getTransformTemplate();
      this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(z6);
        return;
      }
      this.isUpdating || this.nodes.forEach(pO), this.isUpdating = !1, this.nodes.forEach(gO), this.nodes.forEach(uO), this.nodes.forEach(cO), this.clearAllSnapshots();
      const u = performance.now();
      En.delta = Ai(0, 1e3 / 60, u - En.timestamp), En.timestamp = u, En.isProcessing = !0, Sd.update.process(En), Sd.preRender.process(En), Sd.render.process(En), En.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(hO), this.sharedNodes.forEach(bO);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, kt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      kt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ln(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: u } = this.options;
      u && u.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let u = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (u = !1), u && (this.scroll = {
        animationId: this.root.animationId,
        phase: a,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!o)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform, u = this.projectionDelta && !km(this.projectionDelta), c = this.getTransformTemplate(), d = c ? c(this.latestValues, "") : void 0, f = d !== this.prevTransformTemplateValue;
      a && (u || Ji(this.latestValues) || f) && (o(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const u = this.measurePageBox();
      let c = this.removeElementScroll(u);
      return a && (c = this.removeTransform(c)), wO(c), {
        animationId: this.root.animationId,
        measuredBox: u,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return ln();
      const u = a.measureViewportBox(), { scroll: c } = this.root;
      return c && (bi(u.x, c.offset.x), bi(u.y, c.offset.y)), u;
    }
    removeElementScroll(a) {
      const u = ln();
      Lr(u, a);
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c], { scroll: f, options: p } = d;
        if (d !== this.root && f && p.layoutScroll) {
          if (f.isRoot) {
            Lr(u, a);
            const { scroll: g } = this.root;
            g && (bi(u.x, -g.offset.x), bi(u.y, -g.offset.y));
          }
          bi(u.x, f.offset.x), bi(u.y, f.offset.y);
        }
      }
      return u;
    }
    applyTransform(a, u = !1) {
      const c = ln();
      Lr(c, a);
      for (let d = 0; d < this.path.length; d++) {
        const f = this.path[d];
        !u && f.options.layoutScroll && f.scroll && f !== f.root && ma(c, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), Ji(f.latestValues) && ma(c, f.latestValues);
      }
      return Ji(this.latestValues) && ma(c, this.latestValues), c;
    }
    removeTransform(a) {
      const u = ln();
      Lr(u, a);
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        if (!d.instance || !Ji(d.latestValues))
          continue;
        Z5(d.latestValues) && d.updateSnapshot();
        const f = ln(), p = d.measurePageBox();
        Lr(f, p), B6(u, d.latestValues, d.snapshot ? d.snapshot.layoutBox : void 0, f);
      }
      return Ji(this.latestValues) && B6(u, this.latestValues), u;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== En.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var u;
      const c = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = c.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = c.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = c.isSharedProjectionDirty);
      const d = !!this.resumingFrom || this !== c;
      if (!(a || d && this.isSharedProjectionDirty || this.isProjectionDirty || !((u = this.parent) === null || u === void 0) && u.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: p, layoutId: g } = this.options;
      if (!(!this.layout || !(p || g))) {
        if (this.resolvedRelativeTargetAt = En.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ln(), this.relativeTargetOrigin = ln(), J1(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), Lr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = ln(), this.targetWithTransforms = ln()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), wD(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Lr(this.target, this.layout.layoutBox), Pm(this.target, this.targetDelta)) : Lr(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const m = this.getClosestProjectingParent();
            m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ln(), this.relativeTargetOrigin = ln(), J1(this.relativeTargetOrigin, this.target, m.target), Lr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          qi.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Z5(this.parent.latestValues) || Mm(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const u = this.getLead(), c = !!this.resumingFrom || this !== u;
      let d = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (d = !1), c && (this.isSharedProjectionDirty || this.isTransformDirty) && (d = !1), this.resolvedRelativeTargetAt === En.timestamp && (d = !1), d)
        return;
      const { layout: f, layoutId: p } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(f || p))
        return;
      Lr(this.layoutCorrected, this.layout.layoutBox);
      const g = this.treeScale.x, m = this.treeScale.y;
      _D(this.layoutCorrected, this.treeScale, this.path, c), u.layout && !u.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (u.target = u.layout.layoutBox);
      const { target: b } = u;
      if (!b) {
        this.projectionTransform && (this.projectionDelta = ga(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = ga(), this.projectionDeltaWithTransform = ga());
      const v = this.projectionTransform;
      Y1(this.projectionDelta, this.layoutCorrected, b, this.latestValues), this.projectionTransform = N6(this.projectionDelta, this.treeScale), (this.projectionTransform !== v || this.treeScale.x !== g || this.treeScale.y !== m) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", b)), qi.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), a) {
        const u = this.getStack();
        u && u.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(a, u = !1) {
      const c = this.snapshot, d = c ? c.latestValues : {}, f = { ...this.latestValues }, p = ga();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !u;
      const g = ln(), m = c ? c.source : void 0, b = this.layout ? this.layout.source : void 0, v = m !== b, y = this.getStack(), w = !y || y.members.length <= 1, I = !!(v && !w && this.options.crossfade === !0 && !this.path.some(xO));
      this.animationProgress = 0;
      let V;
      this.mixTargetDelta = (M) => {
        const L = M / 1e3;
        G6(p.x, a.x, L), G6(p.y, a.y, L), this.setTargetDelta(p), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (J1(g, this.layout.layoutBox, this.relativeParent.layout.layoutBox), yO(this.relativeTarget, this.relativeTargetOrigin, g, L), V && QD(this.relativeTarget, V) && (this.isProjectionDirty = !1), V || (V = ln()), Lr(V, this.relativeTarget)), v && (this.animationValues = f, XD(f, d, this.latestValues, L, I, w)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = L;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Yo(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = kt.update(() => {
        Pc.hasAnimatedSinceResize = !0, this.currentAnimation = sO(0, $6, {
          ...a,
          onUpdate: (u) => {
            this.mixTargetDelta(u), a.onUpdate && a.onUpdate(u);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta($6), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: u, target: c, layout: d, latestValues: f } = a;
      if (!(!u || !c || !d)) {
        if (this !== a && this.layout && d && Om(this.options.animationType, this.layout.layoutBox, d.layoutBox)) {
          c = this.target || ln();
          const p = hr(this.layout.layoutBox.x);
          c.x.min = a.target.x.min, c.x.max = c.x.min + p;
          const g = hr(this.layout.layoutBox.y);
          c.y.min = a.target.y.min, c.y.max = c.y.min + g;
        }
        Lr(u, c), ma(u, f), Y1(this.projectionDeltaWithTransform, this.layoutCorrected, u, f);
      }
    }
    registerSharedNode(a, u) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new eO()), this.sharedNodes.get(a).add(u);
      const d = u.options.initialPromotionConfig;
      u.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity: d && d.shouldPreserveFollowOpacity ? d.shouldPreserveFollowOpacity(u) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: u } = this.options;
      return u ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: u } = this.options;
      return u ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: u, preserveFollowOpacity: c } = {}) {
      const d = this.getStack();
      d && d.promote(this, c), a && (this.projectionDelta = void 0, this.needsReset = !0), u && this.setOptions({ transition: u });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let u = !1;
      const { latestValues: c } = a;
      if ((c.rotate || c.rotateX || c.rotateY || c.rotateZ) && (u = !0), !u)
        return;
      const d = {};
      for (let f = 0; f < Z6.length; f++) {
        const p = "rotate" + Z6[f];
        c[p] && (d[p] = c[p], a.setStaticValue(p, 0));
      }
      a.render();
      for (const f in d)
        a.setStaticValue(f, d[f]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var u, c;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return aO;
      const d = {
        visibility: ""
      }, f = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, d.opacity = "", d.pointerEvents = Mc(a == null ? void 0 : a.pointerEvents) || "", d.transform = f ? f(this.latestValues, "") : "none", d;
      const p = this.getLead();
      if (!this.projectionDelta || !this.layout || !p.target) {
        const v = {};
        return this.options.layoutId && (v.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, v.pointerEvents = Mc(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Ji(this.latestValues) && (v.transform = f ? f({}, "") : "none", this.hasProjected = !1), v;
      }
      const g = p.animationValues || p.latestValues;
      this.applyTransformsToTarget(), d.transform = N6(this.projectionDeltaWithTransform, this.treeScale, g), f && (d.transform = f(g, d.transform));
      const { x: m, y: b } = this.projectionDelta;
      d.transformOrigin = `${m.origin * 100}% ${b.origin * 100}% 0`, p.animationValues ? d.opacity = p === this ? (c = (u = g.opacity) !== null && u !== void 0 ? u : this.latestValues.opacity) !== null && c !== void 0 ? c : 1 : this.preserveOpacity ? this.latestValues.opacity : g.opacityExit : d.opacity = p === this ? g.opacity !== void 0 ? g.opacity : "" : g.opacityExit !== void 0 ? g.opacityExit : 0;
      for (const v in Nc) {
        if (g[v] === void 0)
          continue;
        const { correct: y, applyTo: w } = Nc[v], I = d.transform === "none" ? g[v] : y(g[v], p);
        if (w) {
          const V = w.length;
          for (let M = 0; M < V; M++)
            d[w[M]] = I;
        } else
          d[v] = I;
      }
      return this.options.layoutId && (d.pointerEvents = p === this ? Mc(a == null ? void 0 : a.pointerEvents) || "" : "none"), d;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var u;
        return (u = a.currentAnimation) === null || u === void 0 ? void 0 : u.stop();
      }), this.root.nodes.forEach(z6), this.root.sharedNodes.clear();
    }
  };
}
function uO(e) {
  e.updateLayout();
}
function cO(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, a = n.source !== e.layout.source;
    i === "size" ? Pr((p) => {
      const g = a ? n.measuredBox[p] : n.layoutBox[p], m = hr(g);
      g.min = r[p].min, g.max = g.min + m;
    }) : Om(i, n.layoutBox, r) && Pr((p) => {
      const g = a ? n.measuredBox[p] : n.layoutBox[p], m = hr(r[p]);
      g.max = g.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[p].max = e.relativeTarget[p].min + m);
    });
    const u = ga();
    Y1(u, r, n.layoutBox);
    const c = ga();
    a ? Y1(c, e.applyTransform(o, !0), n.measuredBox) : Y1(c, r, n.layoutBox);
    const d = !km(u);
    let f = !1;
    if (!e.resumeFrom) {
      const p = e.getClosestProjectingParent();
      if (p && !p.resumeFrom) {
        const { snapshot: g, layout: m } = p;
        if (g && m) {
          const b = ln();
          J1(b, n.layoutBox, g.layoutBox);
          const v = ln();
          J1(v, r, m.layoutBox), Bm(b, v) || (f = !0), p.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = b, e.relativeParent = p);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: c,
      layoutDelta: u,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function dO(e) {
  qi.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function fO(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function hO(e) {
  e.clearSnapshot();
}
function z6(e) {
  e.clearMeasurements();
}
function pO(e) {
  e.isLayoutDirty = !1;
}
function gO(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function W6(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function mO(e) {
  e.resolveTargetDelta();
}
function CO(e) {
  e.calcProjection();
}
function vO(e) {
  e.resetRotation();
}
function bO(e) {
  e.removeLeadSnapshot();
}
function G6(e, t, n) {
  e.translate = Gt(t.translate, 0, n), e.scale = Gt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function j6(e, t, n, r) {
  e.min = Gt(t.min, n.min, r), e.max = Gt(t.max, n.max, r);
}
function yO(e, t, n, r) {
  j6(e.x, t.x, n.x, r), j6(e.y, t.y, n.y, r);
}
function xO(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const SO = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, X6 = (e) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(e), U6 = X6("applewebkit/") && !X6("chrome/") ? Math.round : Jt;
function Y6(e) {
  e.min = U6(e.min), e.max = U6(e.max);
}
function wO(e) {
  Y6(e.x), Y6(e.y);
}
function Om(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !O5(O6(t), O6(n), 0.2);
}
const IO = Dm({
  attachResizeListener: (e, t) => Zo(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Td = {
  current: void 0
}, Nm = Dm({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Td.current) {
      const e = new IO({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Td.current = e;
    }
    return Td.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), VO = {
  pan: {
    Feature: ND
  },
  drag: {
    Feature: OD,
    ProjectionNode: Nm,
    MeasureLayout: Tm
  }
}, AO = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function LO(e) {
  const t = AO.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}
const MO = 4;
function z5(e, t, n = 1) {
  kr(n <= MO, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = LO(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const a = i.trim();
    return xm(a) ? parseFloat(a) : a;
  } else
    return _5(o) ? z5(o, t, n + 1) : o;
}
function PO(e, { ...t }, n) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((o) => {
    const i = o.get();
    if (!_5(i))
      return;
    const a = z5(i, r);
    a && o.set(a);
  });
  for (const o in t) {
    const i = t[o];
    if (!_5(i))
      continue;
    const a = z5(i, r);
    a && (t[o] = a, n || (n = {}), n[o] === void 0 && (n[o] = i));
  }
  return { target: t, transitionEnd: n };
}
const EO = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), Zm = (e) => EO.has(e), RO = (e) => Object.keys(e).some(Zm), nc = (e) => e === xs || e === Ge, J6 = (e, t) => parseFloat(e.split(", ")[t]), q6 = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/);
  if (o)
    return J6(o[1], t);
  {
    const i = r.match(/^matrix\((.+)\)$/);
    return i ? J6(i[1], e) : 0;
  }
}, _O = /* @__PURE__ */ new Set(["x", "y", "z"]), TO = xl.filter((e) => !_O.has(e));
function HO(e) {
  const t = [];
  return TO.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const Pa = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: q6(4, 13),
  y: q6(5, 14)
};
Pa.translateX = Pa.x;
Pa.translateY = Pa.y;
const FO = (e, t, n) => {
  const r = t.measureViewportBox(), o = t.current, i = getComputedStyle(o), { display: a } = i, u = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((d) => {
    u[d] = Pa[d](r, i);
  }), t.render();
  const c = t.measureViewportBox();
  return n.forEach((d) => {
    const f = t.getValue(d);
    f && f.jump(u[d]), e[d] = Pa[d](c, i);
  }), e;
}, kO = (e, t, n = {}, r = {}) => {
  t = { ...t }, r = { ...r };
  const o = Object.keys(t).filter(Zm);
  let i = [], a = !1;
  const u = [];
  if (o.forEach((c) => {
    const d = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let f = n[c], p = S1(f);
    const g = t[c];
    let m;
    if ($c(g)) {
      const b = g.length, v = g[0] === null ? 1 : 0;
      f = g[v], p = S1(f);
      for (let y = v; y < b && g[y] !== null; y++)
        m ? kr(S1(g[y]) === m, "All keyframes must be of the same type") : (m = S1(g[y]), kr(m === p || nc(p) && nc(m), "Keyframes must be of the same dimension as the current value"));
    } else
      m = S1(g);
    if (p !== m)
      if (nc(p) && nc(m)) {
        const b = d.get();
        typeof b == "string" && d.set(parseFloat(b)), typeof g == "string" ? t[c] = parseFloat(g) : Array.isArray(g) && m === Ge && (t[c] = g.map(parseFloat));
      } else
        p != null && p.transform && (m != null && m.transform) && (f === 0 || g === 0) ? f === 0 ? d.set(m.transform(f)) : t[c] = p.transform(g) : (a || (i = HO(e), a = !0), u.push(c), r[c] = r[c] !== void 0 ? r[c] : t[c], d.jump(g));
  }), u.length) {
    const c = u.indexOf("height") >= 0 ? window.pageYOffset : null, d = FO(t, e, u);
    return i.length && i.forEach(([f, p]) => {
      e.getValue(f).set(p);
    }), e.render(), b2 && c !== null && window.scrollTo({ top: c }), { target: d, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function BO(e, t, n, r) {
  return RO(t) ? kO(e, t, n, r) : { target: t, transitionEnd: r };
}
const DO = (e, t, n, r) => {
  const o = PO(e, t, r);
  return t = o.target, r = o.transitionEnd, BO(e, t, n, r);
}, W5 = { current: null }, $m = { current: !1 };
function OO() {
  if ($m.current = !0, !!b2)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => W5.current = e.matches;
      e.addListener(t), t();
    } else
      W5.current = !1;
}
function NO(e, t, n) {
  const { willChange: r } = t;
  for (const o in t) {
    const i = t[o], a = n[o];
    if (Kn(i))
      e.addValue(o, i), jc(r) && r.add(o), process.env.NODE_ENV === "development" && c3(i.version === "10.18.0", `Attempting to mix Framer Motion versions ${i.version} with 10.18.0 may not work as expected.`);
    else if (Kn(a))
      e.addValue(o, Ma(i, { owner: e })), jc(r) && r.remove(o);
    else if (a !== i)
      if (e.hasValue(o)) {
        const u = e.getValue(o);
        !u.hasAnimated && u.set(i);
      } else {
        const u = e.getStaticValue(o);
        e.addValue(o, Ma(u !== void 0 ? u : i, { owner: e }));
      }
  }
  for (const o in n)
    t[o] === void 0 && e.removeValue(o);
  return t;
}
const K6 = /* @__PURE__ */ new WeakMap(), zm = Object.keys(ul), ZO = zm.length, Q6 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], $O = jf.length;
class zO {
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, visualState: i }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => kt.render(this.render, !1, !0);
    const { latestValues: u, renderState: c } = i;
    this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = n.initial ? { ...u } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.isControllingVariants = x2(n), this.isVariantNode = Ag(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {});
    for (const p in f) {
      const g = f[p];
      u[p] !== void 0 && Kn(g) && (g.set(u[p], !1), jc(d) && d.add(p));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, K6.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), $m.current || OO(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : W5.current, process.env.NODE_ENV !== "production" && c3(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    K6.delete(this.current), this.projection && this.projection.unmount(), Yo(this.notifyUpdate), Yo(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = ys.has(t), o = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && kt.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      o(), i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, o, i) {
    let a, u;
    if (process.env.NODE_ENV !== "production" && o && r) {
      const c = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? Il(!1, c) : kr(!1, c);
    }
    for (let c = 0; c < ZO; c++) {
      const d = zm[c], { isEnabled: f, Feature: p, ProjectionNode: g, MeasureLayout: m } = ul[d];
      g && (a = g), f(n) && (!this.features[d] && p && (this.features[d] = new p(this)), m && (u = m));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && a) {
      this.projection = new a(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: d, drag: f, dragConstraints: p, layoutScroll: g, layoutRoot: m } = n;
      this.projection.setOptions({
        layoutId: c,
        layout: d,
        alwaysMeasureLayout: !!f || p && ha(p),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof d == "string" ? d : "both",
        initialPromotionConfig: i,
        layoutScroll: g,
        layoutRoot: m
      });
    }
    return u;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ln();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Q6.length; r++) {
      const o = Q6[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = t["on" + o];
      i && (this.propEventSubscriptions[o] = this.on(o, i));
    }
    this.prevMotionValues = NO(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < $O; r++) {
      const o = jf[r], i = this.props[o];
      (ll(i) || i === !1) && (n[o] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Ma(n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    var n;
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (n = this.getBaseTargetFromProps(this.props, t)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props, o = typeof r == "string" || typeof r == "object" ? (n = e3(this.props, r)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (r && o !== void 0)
      return o;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Kn(i) ? i : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new u3()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class Wm extends zO {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...r }, { transformValues: o }, i) {
    let a = oD(r, t || {}, this);
    if (o && (n && (n = o(n)), r && (r = o(r)), a && (a = o(a))), i) {
      nD(this, r, a);
      const u = DO(this, r, a, n);
      n = u.transitionEnd, r = u.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...r
    };
  }
}
function WO(e) {
  return window.getComputedStyle(e);
}
class GO extends Wm {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(t, n) {
    if (ys.has(n)) {
      const r = o3(n);
      return r && r.default || 0;
    } else {
      const r = WO(t), o = (Eg(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Em(t, n);
  }
  build(t, n, r, o) {
    Yf(t, n, r, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return Qf(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Kn(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, o) {
    kg(t, n, r, o);
  }
}
class jO extends Wm {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (ys.has(n)) {
      const r = o3(n);
      return r && r.default || 0;
    }
    return n = Bg.has(n) ? n : Wf(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return ln();
  }
  scrapeMotionValuesFromProps(t, n) {
    return Og(t, n);
  }
  build(t, n, r, o) {
    qf(t, n, r, this.isSVGTag, o.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    Dg(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = Kf(t.tagName), super.mount(t);
  }
}
const XO = (e, t) => Uf(e) ? new jO(t, { enableHardwareAcceleration: !1 }) : new GO(t, { enableHardwareAcceleration: !0 }), UO = {
  layout: {
    ProjectionNode: Nm,
    MeasureLayout: Tm
  }
}, YO = {
  ...bD,
  ...Zk,
  ...VO,
  ...UO
}, xo = /* @__PURE__ */ JF((e, t) => Mk(e, t, YO, XO));
function Gm() {
  const e = Le(!1);
  return zf(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function JO() {
  const e = Gm(), [t, n] = Ee(0), r = q(() => {
    e.current && n(t + 1);
  }, [t]);
  return [q(() => kt.postRender(r), [r]), t];
}
class qO extends be.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function KO({ children: e, isPresent: t }) {
  const n = Zr(), r = Le(null), o = Le({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return Ep(() => {
    const { width: i, height: a, top: u, left: c } = o.current;
    if (t || !r.current || !i || !a)
      return;
    r.current.dataset.motionPopId = n;
    const d = document.createElement("style");
    return document.head.appendChild(d), d.sheet && d.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${i}px !important;
            height: ${a}px !important;
            top: ${u}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(d);
    };
  }, [t]), be.createElement(qO, { isPresent: t, childRef: r, sizeRef: o }, be.cloneElement(e, { ref: r }));
}
const Hd = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: i, mode: a }) => {
  const u = Ng(QO), c = Zr(), d = at(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: (f) => {
        u.set(f, !0);
        for (const p of u.values())
          if (!p)
            return;
        r && r();
      },
      register: (f) => (u.set(f, !1), () => u.delete(f))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? void 0 : [n]
  );
  return at(() => {
    u.forEach((f, p) => u.set(p, !1));
  }, [n]), be.useEffect(() => {
    !n && !u.size && r && r();
  }, [n]), a === "popLayout" && (e = be.createElement(KO, { isPresent: n }, e)), be.createElement(yl.Provider, { value: d }, e);
};
function QO() {
  return /* @__PURE__ */ new Map();
}
function eN(e) {
  return Ue(() => () => e(), []);
}
const Ki = (e) => e.key || "";
function tN(e, t) {
  e.forEach((n) => {
    const r = Ki(n);
    t.set(r, n);
  });
}
function nN(e) {
  const t = [];
  return d2.forEach(e, (n) => {
    Da(n) && t.push(n);
  }), t;
}
const Ri = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: o, presenceAffectsLayout: i = !0, mode: a = "sync" }) => {
  kr(!o, "Replace exitBeforeEnter with mode='wait'");
  const u = tn(Xf).forceRender || JO()[0], c = Gm(), d = nN(e);
  let f = d;
  const p = Le(/* @__PURE__ */ new Map()).current, g = Le(f), m = Le(/* @__PURE__ */ new Map()).current, b = Le(!0);
  if (zf(() => {
    b.current = !1, tN(d, m), g.current = f;
  }), eN(() => {
    b.current = !0, m.clear(), p.clear();
  }), b.current)
    return be.createElement(be.Fragment, null, f.map((I) => be.createElement(Hd, { key: Ki(I), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: i, mode: a }, I)));
  f = [...f];
  const v = g.current.map(Ki), y = d.map(Ki), w = v.length;
  for (let I = 0; I < w; I++) {
    const V = v[I];
    y.indexOf(V) === -1 && !p.has(V) && p.set(V, void 0);
  }
  return a === "wait" && p.size && (f = []), p.forEach((I, V) => {
    if (y.indexOf(V) !== -1)
      return;
    const M = m.get(V);
    if (!M)
      return;
    const L = v.indexOf(V);
    let R = I;
    if (!R) {
      const _ = () => {
        p.delete(V);
        const H = Array.from(m.keys()).filter((B) => !y.includes(B));
        if (H.forEach((B) => m.delete(B)), g.current = d.filter((B) => {
          const Z = Ki(B);
          return (
            // filter out the node exiting
            Z === V || // filter out the leftover children
            H.includes(Z)
          );
        }), !p.size) {
          if (c.current === !1)
            return;
          u(), r && r();
        }
      };
      R = be.createElement(Hd, { key: Ki(M), isPresent: !1, onExitComplete: _, custom: t, presenceAffectsLayout: i, mode: a }, M), p.set(V, R);
    }
    f.splice(L, 0, R);
  }), f = f.map((I) => {
    const V = I.key;
    return p.has(V) ? I : be.createElement(Hd, { key: Ki(I), isPresent: !0, presenceAffectsLayout: i, mode: a }, I);
  }), process.env.NODE_ENV !== "production" && a === "wait" && f.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), be.createElement(be.Fragment, null, p.size ? f : f.map((I) => bo(I)));
}, rN = (e, t) => e.find((n) => n.id === t);
function e8(e, t) {
  const n = jm(e, t), r = n ? e[n].findIndex((o) => o.id === t) : -1;
  return {
    position: n,
    index: r
  };
}
function jm(e, t) {
  for (const [n, r] of Object.entries(e))
    if (rN(r, t))
      return n;
}
function oN(e) {
  const t = e.includes("right"), n = e.includes("left");
  let r = "center";
  return t && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function iN(e) {
  const n = e === "top" || e === "bottom" ? "0 auto" : void 0, r = e.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, o = e.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, i = e.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", a = e.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: o,
    right: i,
    left: a
  };
}
const sN = /* @__PURE__ */ new Set([
  ...ZM,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), aN = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function lN(e) {
  return (aN.has(e) || !sN.has(e)) && e[0] !== "_";
}
const uN = $L(mL), cN = ({ baseStyle: e }) => (t) => {
  const { theme: n, css: r, __css: o, sx: i, ...a } = t, [u] = JL(a, zM), c = eo(e, t), d = ML(
    {},
    o,
    c,
    Tf(u),
    i
  ), f = eg(d)(t.theme);
  return r ? [f, r] : f;
};
function Fd(e, t) {
  const { baseStyle: n, ...r } = t ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = lN);
  const o = cN({ baseStyle: n }), i = uN(
    e,
    r
  )(o);
  return Fe(
    function(c, d) {
      const { children: f, ...p } = c, { colorMode: g, forced: m } = $f();
      return Rp(
        i,
        { ref: d, "data-theme": m ? g : void 0, ...p },
        f
      );
    }
  );
}
function dN() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Fd, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(t, n, r) {
      return Fd(...r);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(t, n) {
      return e.has(n) || e.set(n, Fd(n)), e.get(n);
    }
  });
}
const ye = dN(), fN = {
  initial: (e) => {
    const { position: t } = e, n = ["top", "bottom"].includes(t) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(t) ? 1 : -1;
    return t === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, Xm = uL((e) => {
  const {
    id: t,
    message: n,
    onCloseComplete: r,
    onRequestRemove: o,
    requestClose: i = !1,
    position: a = "bottom",
    duration: u = 5e3,
    containerStyle: c,
    motionVariants: d = fN,
    toastSpacing: f = "0.5rem"
  } = e, [p, g] = Ee(u), m = ZD();
  fs(() => {
    m || r == null || r();
  }, [m]), fs(() => {
    g(u);
  }, [u]);
  const b = () => g(null), v = () => g(u), y = () => {
    m && o();
  };
  Ue(() => {
    m && i && o();
  }, [m, i, o]), aM(y, p);
  const w = at(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: f,
      ...c
    }),
    [c, f]
  ), I = at(() => oN(a), [a]);
  return /* @__PURE__ */ x.jsx(
    xo.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: d,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: b,
      onHoverEnd: v,
      custom: { position: a },
      style: I,
      children: /* @__PURE__ */ x.jsx(
        ye.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: w,
          children: eo(n, { id: t, onClose: y })
        }
      )
    }
  );
});
Xm.displayName = "ToastComponent";
function Pe(e) {
  return Fe(e);
}
var hN = typeof Element < "u", pN = typeof Map == "function", gN = typeof Set == "function", mN = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Ec(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Ec(e[r], t[r]))
          return !1;
      return !0;
    }
    var i;
    if (pN && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!Ec(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (gN && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (mN && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    if (hN && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((o[r] === "_owner" || o[r] === "__v" || o[r] === "__o") && e.$$typeof) && !Ec(e[o[r]], t[o[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var CN = function(t, n) {
  try {
    return Ec(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const vN = /* @__PURE__ */ Ef(CN);
function V2() {
  const e = tn(
    gL
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
function bN() {
  const e = $f(), t = V2();
  return { ...e, theme: t };
}
function yN(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t, n]) => n !== void 0 && t !== "children" && !Da(n))
  );
}
function Um(e, t = {}) {
  const { styleConfig: n, ...r } = t, { theme: o, colorMode: i } = bN(), a = e ? Np(o, `components.${e}`) : void 0, u = n || a, c = Tr(
    { theme: o, colorMode: i },
    (u == null ? void 0 : u.defaultProps) ?? {},
    yN(r),
    (f, p) => f ? void 0 : p
  ), d = Le({});
  if (u) {
    const p = eP(u)(c);
    vN(d.current, p) || (d.current = p);
  }
  return d.current;
}
function Ss(e, t = {}) {
  return Um(e, t);
}
function Rn(e, t = {}) {
  return Um(e, t);
}
const t8 = {
  path: /* @__PURE__ */ x.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ x.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ x.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ x.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, Ko = Pe((e, t) => {
  const {
    as: n,
    viewBox: r,
    color: o = "currentColor",
    focusable: i = !1,
    children: a,
    className: u,
    __css: c,
    ...d
  } = e, f = _e("chakra-icon", u), p = Ss("Icon", e), g = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...c,
    ...p
  }, m = {
    ref: t,
    focusable: i,
    className: f,
    __css: g
  }, b = r ?? t8.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ x.jsx(ye.svg, { as: n, ...m, ...d });
  const v = a ?? t8.path;
  return /* @__PURE__ */ x.jsx(ye.svg, { verticalAlign: "middle", viewBox: b, ...m, ...d, children: v });
});
Ko.displayName = "Icon";
function xN(e) {
  return /* @__PURE__ */ x.jsx(Ko, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ x.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function SN(e) {
  return /* @__PURE__ */ x.jsx(Ko, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ x.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function n8(e) {
  return /* @__PURE__ */ x.jsx(Ko, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ x.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
const wN = Cl({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Ym = Pe((e, t) => {
  const n = Ss("Spinner", e), {
    label: r = "Loading...",
    thickness: o = "2px",
    speed: i = "0.45s",
    emptyColor: a = "transparent",
    className: u,
    ...c
  } = rn(e), d = _e("chakra-spinner", u), f = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: a,
    borderLeftColor: a,
    animation: `${wN} ${i} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ x.jsx(
    ye.div,
    {
      ref: t,
      __css: f,
      className: d,
      ...c,
      children: r && /* @__PURE__ */ x.jsx(ye.span, { srOnly: !0, children: r })
    }
  );
});
Ym.displayName = "Spinner";
const [IN, d3] = Bt({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [VN, f3] = Bt({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), Jm = {
  info: { icon: SN, colorScheme: "blue" },
  warning: { icon: n8, colorScheme: "orange" },
  success: { icon: xN, colorScheme: "green" },
  error: { icon: n8, colorScheme: "red" },
  loading: { icon: Ym, colorScheme: "blue" }
};
function AN(e) {
  return Jm[e].colorScheme;
}
function LN(e) {
  return Jm[e].icon;
}
const h3 = Pe(function(t, n) {
  const { status: r = "info", addRole: o = !0, ...i } = rn(t), a = t.colorScheme ?? AN(r), u = Rn("Alert", { ...t, colorScheme: a }), c = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...u.container
  };
  return /* @__PURE__ */ x.jsx(IN, { value: { status: r }, children: /* @__PURE__ */ x.jsx(VN, { value: u, children: /* @__PURE__ */ x.jsx(
    ye.div,
    {
      "data-status": r,
      role: o ? "alert" : void 0,
      ref: n,
      ...i,
      className: _e("chakra-alert", t.className),
      __css: c
    }
  ) }) });
});
h3.displayName = "Alert";
function p3(e) {
  const { status: t } = d3(), n = LN(t), r = f3(), o = t === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ x.jsx(
    ye.span,
    {
      display: "inherit",
      "data-status": t,
      ...e,
      className: _e("chakra-alert__icon", e.className),
      __css: o,
      children: e.children || /* @__PURE__ */ x.jsx(n, { h: "100%", w: "100%" })
    }
  );
}
p3.displayName = "AlertIcon";
const qm = Pe(
  function(t, n) {
    const r = f3(), { status: o } = d3();
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ref: n,
        "data-status": o,
        ...t,
        className: _e("chakra-alert__title", t.className),
        __css: r.title
      }
    );
  }
);
qm.displayName = "AlertTitle";
const Km = Pe(
  function(t, n) {
    const { status: r } = d3(), o = f3(), i = {
      display: "inline",
      ...o.description
    };
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ref: n,
        "data-status": r,
        ...t,
        className: _e("chakra-alert__desc", t.className),
        __css: i
      }
    );
  }
);
Km.displayName = "AlertDescription";
function MN(e) {
  return /* @__PURE__ */ x.jsx(Ko, { focusable: "false", "aria-hidden": !0, ...e, children: /* @__PURE__ */ x.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
const A2 = Pe(
  function(t, n) {
    const r = Ss("CloseButton", t), { children: o, isDisabled: i, __css: a, ...u } = rn(t), c = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ x.jsx(
      ye.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: i,
        __css: {
          ...c,
          ...r,
          ...a
        },
        ...u,
        children: o || /* @__PURE__ */ x.jsx(MN, { width: "1em", height: "1em" })
      }
    );
  }
);
A2.displayName = "CloseButton";
const PN = (e) => {
  const {
    status: t,
    variant: n = "solid",
    id: r,
    title: o,
    isClosable: i,
    onClose: a,
    description: u,
    colorScheme: c,
    icon: d
  } = e, f = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ x.jsxs(
    h3,
    {
      addRole: !1,
      status: t,
      variant: n,
      id: f == null ? void 0 : f.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: c,
      children: [
        /* @__PURE__ */ x.jsx(p3, { children: d }),
        /* @__PURE__ */ x.jsxs(ye.div, { flex: "1", maxWidth: "100%", children: [
          o && /* @__PURE__ */ x.jsx(qm, { id: f == null ? void 0 : f.title, children: o }),
          u && /* @__PURE__ */ x.jsx(Km, { id: f == null ? void 0 : f.description, display: "block", children: u })
        ] }),
        i && /* @__PURE__ */ x.jsx(
          A2,
          {
            size: "sm",
            onClick: a,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function EN(e = {}) {
  const { render: t, toastComponent: n = PN } = e;
  return (o) => typeof t == "function" ? t({ ...o, ...e }) : /* @__PURE__ */ x.jsx(n, { ...o, ...e });
}
const RN = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, q1 = _N(RN);
function _N(e) {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (o) => {
    t = o(t), n.forEach((i) => i());
  };
  return {
    getState: () => t,
    subscribe: (o) => (n.add(o), () => {
      r(() => e), n.delete(o);
    }),
    /**
     * Delete a toast record at its position
     */
    removeToast: (o, i) => {
      r((a) => ({
        ...a,
        // id may be string or number
        // eslint-disable-next-line eqeqeq
        [i]: a[i].filter((u) => u.id != o)
      }));
    },
    notify: (o, i) => {
      const a = TN(o, i), { position: u, id: c } = a;
      return r((d) => {
        const p = u.includes("top") ? [a, ...d[u] ?? []] : [...d[u] ?? [], a];
        return {
          ...d,
          [u]: p
        };
      }), c;
    },
    update: (o, i) => {
      o && r((a) => {
        const u = { ...a }, { position: c, index: d } = e8(u, o);
        return c && d !== -1 && (u[c][d] = {
          ...u[c][d],
          ...i,
          message: EN(i)
        }), u;
      });
    },
    closeAll: ({ positions: o } = {}) => {
      r((i) => (o ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (c, d) => (c[d] = i[d].map((f) => ({
          ...f,
          requestClose: !0
        })), c),
        { ...i }
      ));
    },
    close: (o) => {
      r((i) => {
        const a = jm(i, o);
        return a ? {
          ...i,
          [a]: i[a].map((u) => u.id == o ? {
            ...u,
            requestClose: !0
          } : u)
        } : i;
      });
    },
    isActive: (o) => !!e8(q1.getState(), o).position
  };
}
let r8 = 0;
function TN(e, t = {}) {
  r8 += 1;
  const n = t.id ?? r8, r = t.position ?? "bottom";
  return {
    id: n,
    message: e,
    position: r,
    duration: t.duration,
    onCloseComplete: t.onCloseComplete,
    onRequestRemove: () => q1.removeToast(String(n), r),
    status: t.status,
    requestClose: !1,
    containerStyle: t.containerStyle
  };
}
const [Qm, HN] = Bt({
  strict: !1,
  name: "PortalContext"
}), g3 = "chakra-portal", FN = ".chakra-portal", kN = (e) => /* @__PURE__ */ x.jsx(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: e.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: e.children
  }
), BN = (e) => {
  const { appendToParentPortal: t, children: n } = e, [r, o] = Ee(null), i = Le(null), [, a] = Ee({});
  Ue(() => a({}), []);
  const u = HN(), c = OF();
  wi(() => {
    if (!r)
      return;
    const f = r.ownerDocument, p = t ? u ?? f.body : f.body;
    if (!p)
      return;
    i.current = f.createElement("div"), i.current.className = g3, p.appendChild(i.current), a({});
    const g = i.current;
    return () => {
      p.contains(g) && p.removeChild(g);
    };
  }, [r]);
  const d = c != null && c.zIndex ? /* @__PURE__ */ x.jsx(kN, { zIndex: c == null ? void 0 : c.zIndex, children: n }) : n;
  return i.current ? Mf(
    /* @__PURE__ */ x.jsx(Qm, { value: i.current, children: d }),
    i.current
  ) : /* @__PURE__ */ x.jsx(
    "span",
    {
      ref: (f) => {
        f && o(f);
      }
    }
  );
}, DN = (e) => {
  const { children: t, containerRef: n, appendToParentPortal: r } = e, o = n.current, i = o ?? (typeof window < "u" ? document.body : void 0), a = at(() => {
    const c = o == null ? void 0 : o.ownerDocument.createElement("div");
    return c && (c.className = g3), c;
  }, [o]), [, u] = Ee({});
  return wi(() => u({}), []), wi(() => {
    if (!(!a || !i))
      return i.appendChild(a), () => {
        i.removeChild(a);
      };
  }, [a, i]), i && a ? Mf(
    /* @__PURE__ */ x.jsx(Qm, { value: r ? a : null, children: t }),
    a
  ) : null;
};
function Na(e) {
  const t = {
    appendToParentPortal: !0,
    ...e
  }, { containerRef: n, ...r } = t;
  return n ? /* @__PURE__ */ x.jsx(DN, { containerRef: n, ...r }) : /* @__PURE__ */ x.jsx(BN, { ...r });
}
Na.className = g3;
Na.selector = FN;
Na.displayName = "Portal";
const [ON, Nee] = Bt({
  name: "ToastOptionsContext",
  strict: !1
}), NN = (e) => {
  const t = cL(
    q1.subscribe,
    q1.getState,
    q1.getState
  ), {
    motionVariants: n,
    component: r = Xm,
    portalProps: o,
    animatePresenceProps: i
  } = e, u = Object.keys(t).map((c) => {
    const d = t[c];
    return /* @__PURE__ */ x.jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": `Notifications-${c}`,
        id: `chakra-toast-manager-${c}`,
        style: iN(c),
        children: /* @__PURE__ */ x.jsx(Ri, { ...i, initial: !1, children: d.map((f) => /* @__PURE__ */ x.jsx(
          r,
          {
            motionVariants: n,
            ...f
          },
          f.id
        )) })
      },
      c
    );
  });
  return /* @__PURE__ */ x.jsx(Na, { ...o, children: u });
}, ZN = (e) => function({
  children: n,
  theme: r = e,
  toastOptions: o,
  ...i
}) {
  return /* @__PURE__ */ x.jsxs(NF, { theme: r, ...i, children: [
    /* @__PURE__ */ x.jsx(ON, { value: o == null ? void 0 : o.defaultOptions, children: n }),
    /* @__PURE__ */ x.jsx(NN, { ...o })
  ] });
}, $N = ZN(mg);
function o8(e) {
  return e.sort((t, n) => {
    const r = t.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
const zN = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function i8(e, t, n) {
  let r = e + 1;
  return n && r >= t && (r = 0), r;
}
function s8(e, t, n) {
  let r = e - 1;
  return n && r < 0 && (r = t), r;
}
const kd = typeof window < "u" ? Oa : Ue, a8 = (e) => e;
var WN = Object.defineProperty, GN = (e, t, n) => t in e ? WN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Yt = (e, t, n) => (GN(e, typeof t != "symbol" ? t + "" : t, n), n);
class jN {
  constructor() {
    Yt(this, "descendants", /* @__PURE__ */ new Map()), Yt(this, "register", (t) => {
      if (t != null)
        return zN(t) ? this.registerNode(t) : (n) => {
          this.registerNode(n, t);
        };
    }), Yt(this, "unregister", (t) => {
      this.descendants.delete(t);
      const n = o8(Array.from(this.descendants.keys()));
      this.assignIndex(n);
    }), Yt(this, "destroy", () => {
      this.descendants.clear();
    }), Yt(this, "assignIndex", (t) => {
      this.descendants.forEach((n) => {
        const r = t.indexOf(n.node);
        n.index = r, n.node.dataset.index = n.index.toString();
      });
    }), Yt(this, "count", () => this.descendants.size), Yt(this, "enabledCount", () => this.enabledValues().length), Yt(this, "values", () => Array.from(this.descendants.values()).sort((n, r) => n.index - r.index)), Yt(this, "enabledValues", () => this.values().filter((t) => !t.disabled)), Yt(this, "item", (t) => {
      if (this.count() !== 0)
        return this.values()[t];
    }), Yt(this, "enabledItem", (t) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[t];
    }), Yt(this, "first", () => this.item(0)), Yt(this, "firstEnabled", () => this.enabledItem(0)), Yt(this, "last", () => this.item(this.descendants.size - 1)), Yt(this, "lastEnabled", () => {
      const t = this.enabledValues().length - 1;
      return this.enabledItem(t);
    }), Yt(this, "indexOf", (t) => {
      var n;
      return t ? ((n = this.descendants.get(t)) == null ? void 0 : n.index) ?? -1 : -1;
    }), Yt(this, "enabledIndexOf", (t) => t == null ? -1 : this.enabledValues().findIndex((n) => n.node.isSameNode(t))), Yt(this, "next", (t, n = !0) => {
      const r = i8(t, this.count(), n);
      return this.item(r);
    }), Yt(this, "nextEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), i = i8(
        o,
        this.enabledCount(),
        n
      );
      return this.enabledItem(i);
    }), Yt(this, "prev", (t, n = !0) => {
      const r = s8(t, this.count() - 1, n);
      return this.item(r);
    }), Yt(this, "prevEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), i = s8(
        o,
        this.enabledCount() - 1,
        n
      );
      return this.enabledItem(i);
    }), Yt(this, "registerNode", (t, n) => {
      if (!t || this.descendants.has(t))
        return;
      const r = Array.from(this.descendants.keys()).concat(t), o = o8(r);
      n != null && n.disabled && (n.disabled = !!n.disabled);
      const i = { node: t, index: -1, ...n };
      this.descendants.set(t, i), this.assignIndex(o);
    });
  }
}
function eC() {
  const [e, t] = Bt({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
  });
  return [
    // context provider
    e,
    // call this when you need to read from context
    t,
    () => {
      const o = Le(new jN());
      return kd(() => () => o.current.destroy()), o.current;
    },
    (o) => {
      const i = t(), [a, u] = Ee(-1), c = Le(null);
      kd(() => () => {
        c.current && i.unregister(c.current);
      }, []), kd(() => {
        if (!c.current)
          return;
        const f = Number(c.current.dataset.index);
        a != f && !Number.isNaN(f) && u(f);
      });
      const d = a8(o ? i.register(o) : i.register);
      return {
        descendants: i,
        index: a,
        enabledIndex: i.enabledIndexOf(c.current),
        register: mn(d, c)
      };
    }
  ];
}
const [XN, L2] = Bt({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
}), [UN, m3] = Bt({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
}), [
  YN,
  Zee,
  JN,
  qN
] = eC();
function KN(e) {
  const {
    onChange: t,
    defaultIndex: n,
    index: r,
    allowMultiple: o,
    allowToggle: i,
    ...a
  } = e;
  tZ(e), nZ(e);
  const u = JN(), [c, d] = Ee(-1);
  Ue(() => () => {
    d(-1);
  }, []);
  const [f, p] = Gp({
    value: r,
    defaultValue() {
      return o ? n ?? [] : n ?? -1;
    },
    onChange: t
  });
  return {
    index: f,
    setIndex: p,
    htmlProps: a,
    getAccordionItemProps: (m) => {
      let b = !1;
      return m !== null && (b = Array.isArray(f) ? f.includes(m) : f === m), { isOpen: b, onChange: (y) => {
        if (m !== null)
          if (o && Array.isArray(f)) {
            const w = y ? f.concat(m) : f.filter((I) => I !== m);
            p(w);
          } else
            y ? p(m) : i && p(-1);
      } };
    },
    focusedIndex: c,
    setFocusedIndex: d,
    descendants: u
  };
}
const [QN, C3] = Bt({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function eZ(e) {
  const { isDisabled: t, isFocusable: n, id: r, ...o } = e, { getAccordionItemProps: i, setFocusedIndex: a } = C3(), u = Le(null), c = Zr(), d = r ?? c, f = `accordion-button-${d}`, p = `accordion-panel-${d}`;
  rZ(e);
  const { register: g, index: m, descendants: b } = qN({
    disabled: t && !n
  }), { isOpen: v, onChange: y } = i(
    m === -1 ? null : m
  );
  oZ({ isOpen: v, isDisabled: t });
  const w = () => {
    y == null || y(!0);
  }, I = () => {
    y == null || y(!1);
  }, V = q(() => {
    y == null || y(!v), a(m);
  }, [m, a, v, y]), M = q(
    (H) => {
      const Z = {
        ArrowDown: () => {
          const G = b.nextEnabled(m);
          G == null || G.node.focus();
        },
        ArrowUp: () => {
          const G = b.prevEnabled(m);
          G == null || G.node.focus();
        },
        Home: () => {
          const G = b.firstEnabled();
          G == null || G.node.focus();
        },
        End: () => {
          const G = b.lastEnabled();
          G == null || G.node.focus();
        }
      }[H.key];
      Z && (H.preventDefault(), Z(H));
    },
    [b, m]
  ), L = q(() => {
    a(m);
  }, [a, m]), R = q(
    function(B = {}, Z = null) {
      return {
        ...B,
        type: "button",
        ref: mn(g, u, Z),
        id: f,
        disabled: !!t,
        "aria-expanded": !!v,
        "aria-controls": p,
        onClick: We(B.onClick, V),
        onFocus: We(B.onFocus, L),
        onKeyDown: We(B.onKeyDown, M)
      };
    },
    [
      f,
      t,
      v,
      V,
      L,
      M,
      p,
      g
    ]
  ), _ = q(
    function(B = {}, Z = null) {
      return {
        ...B,
        ref: Z,
        role: "region",
        id: p,
        "aria-labelledby": f,
        hidden: !v
      };
    },
    [f, v, p]
  );
  return {
    isOpen: v,
    isDisabled: t,
    isFocusable: n,
    onOpen: w,
    onClose: I,
    getButtonProps: R,
    getPanelProps: _,
    htmlProps: o
  };
}
function tZ(e) {
  const t = e.index || e.defaultIndex, n = t != null && !Array.isArray(t) && e.allowMultiple;
  vl({
    condition: !!n,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof t},`
  });
}
function nZ(e) {
  vl({
    condition: !!(e.allowMultiple && e.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function rZ(e) {
  vl({
    condition: !!(e.isFocusable && !e.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function oZ(e) {
  vl({
    condition: e.isOpen && !!e.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}
const tC = Pe(function({ children: t, reduceMotion: n, ...r }, o) {
  const i = Rn("Accordion", r), a = rn(r), { htmlProps: u, descendants: c, ...d } = KN(a), f = at(
    () => ({ ...d, reduceMotion: !!n }),
    [d, n]
  );
  return /* @__PURE__ */ x.jsx(YN, { value: c, children: /* @__PURE__ */ x.jsx(QN, { value: f, children: /* @__PURE__ */ x.jsx(XN, { value: i, children: /* @__PURE__ */ x.jsx(
    ye.div,
    {
      ref: o,
      ...u,
      className: _e("chakra-accordion", r.className),
      __css: i.root,
      children: t
    }
  ) }) }) });
});
tC.displayName = "Accordion";
const nC = Pe(
  function(t, n) {
    const { getButtonProps: r } = m3(), o = r(t, n), a = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: 0,
      ...L2().button
    };
    return /* @__PURE__ */ x.jsx(
      ye.button,
      {
        ...o,
        className: _e("chakra-accordion__button", t.className),
        __css: a
      }
    );
  }
);
nC.displayName = "AccordionButton";
function rC(e) {
  const { isOpen: t, isDisabled: n } = m3(), { reduceMotion: r } = C3(), o = _e("chakra-accordion__icon", e.className), i = L2(), a = {
    opacity: n ? 0.4 : 1,
    transform: t ? "rotate(-180deg)" : void 0,
    transition: r ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...i.icon
  };
  return /* @__PURE__ */ x.jsx(
    Ko,
    {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: o,
      __css: a,
      ...e,
      children: /* @__PURE__ */ x.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        }
      )
    }
  );
}
rC.displayName = "AccordionIcon";
const oC = Pe(
  function(t, n) {
    const { children: r, className: o } = t, { htmlProps: i, ...a } = eZ(t), u = L2(), c = {
      ...u.container,
      overflowAnchor: "none"
    }, d = at(() => a, [a]);
    return /* @__PURE__ */ x.jsx(UN, { value: d, children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ref: n,
        ...i,
        className: _e("chakra-accordion__item", o),
        __css: c,
        children: typeof r == "function" ? r({
          isExpanded: !!a.isOpen,
          isDisabled: !!a.isDisabled
        }) : r
      }
    ) });
  }
);
oC.displayName = "AccordionItem";
const rs = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, I1 = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function G5(e) {
  switch ((e == null ? void 0 : e.direction) ?? "right") {
    case "right":
      return I1.slideRight;
    case "left":
      return I1.slideLeft;
    case "bottom":
      return I1.slideDown;
    case "top":
      return I1.slideUp;
    default:
      return I1.slideRight;
  }
}
const us = {
  enter: {
    duration: 0.2,
    ease: rs.easeOut
  },
  exit: {
    duration: 0.1,
    ease: rs.easeIn
  }
}, to = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.exit
  })
}, iZ = (e) => e != null && parseInt(e.toString(), 10) > 0, l8 = {
  exit: {
    height: { duration: 0.2, ease: rs.ease },
    opacity: { duration: 0.3, ease: rs.ease }
  },
  enter: {
    height: { duration: 0.3, ease: rs.ease },
    opacity: { duration: 0.4, ease: rs.ease }
  }
}, sZ = {
  exit: ({
    animateOpacity: e,
    startingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: iZ(t) ? 1 : 0 },
    height: t,
    transitionEnd: r == null ? void 0 : r.exit,
    transition: (n == null ? void 0 : n.exit) ?? to.exit(l8.exit, o)
  }),
  enter: ({
    animateOpacity: e,
    endingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: 1 },
    height: t,
    transitionEnd: r == null ? void 0 : r.enter,
    transition: (n == null ? void 0 : n.enter) ?? to.enter(l8.enter, o)
  })
}, iC = Fe(
  (e, t) => {
    const {
      in: n,
      unmountOnExit: r,
      animateOpacity: o = !0,
      startingHeight: i = 0,
      endingHeight: a = "auto",
      style: u,
      className: c,
      transition: d,
      transitionEnd: f,
      animatePresenceProps: p,
      ...g
    } = e, [m, b] = Ee(!1);
    Ue(() => {
      const V = setTimeout(() => {
        b(!0);
      });
      return () => clearTimeout(V);
    }, []), vl({
      condition: Number(i) > 0 && !!r,
      message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    const v = parseFloat(i.toString()) > 0, y = {
      startingHeight: i,
      endingHeight: a,
      animateOpacity: o,
      transition: m ? d : { enter: { duration: 0 } },
      transitionEnd: {
        enter: f == null ? void 0 : f.enter,
        exit: r ? f == null ? void 0 : f.exit : {
          ...f == null ? void 0 : f.exit,
          display: v ? "block" : "none"
        }
      }
    }, w = r ? n : !0, I = n || r ? "enter" : "exit";
    return /* @__PURE__ */ x.jsx(
      Ri,
      {
        ...p,
        initial: !1,
        custom: y,
        children: w && /* @__PURE__ */ x.jsx(
          xo.div,
          {
            ref: t,
            ...g,
            className: _e("chakra-collapse", c),
            style: {
              overflow: "hidden",
              display: "block",
              ...u
            },
            custom: y,
            variants: sZ,
            initial: r ? "exit" : !1,
            animate: I,
            exit: "exit"
          }
        )
      }
    );
  }
);
iC.displayName = "Collapse";
const sC = Pe(
  function(t, n) {
    const { className: r, motionProps: o, ...i } = t, { reduceMotion: a } = C3(), { getPanelProps: u, isOpen: c } = m3(), d = u(i, n), f = _e("chakra-accordion__panel", r), p = L2();
    a || delete d.hidden;
    const g = /* @__PURE__ */ x.jsx(ye.div, { ...d, __css: p.panel, className: f });
    return a ? g : /* @__PURE__ */ x.jsx(iC, { in: c, ...o, children: g });
  }
);
sC.displayName = "AccordionPanel";
const [aZ, lZ] = Bt({
  name: "AvatarStylesContext",
  hookName: "useAvatarStyles",
  providerName: "<Avatar/>"
});
function uZ(e) {
  const t = e.trim().split(" "), n = t[0] ?? "", r = t.length > 1 ? t[t.length - 1] : "";
  return n && r ? `${n.charAt(0)}${r.charAt(0)}` : n.charAt(0);
}
function aC(e) {
  const { name: t, getInitials: n, ...r } = e, o = lZ();
  return /* @__PURE__ */ x.jsx(ye.div, { role: "img", "aria-label": t, ...r, __css: o.label, children: t ? n == null ? void 0 : n(t) : null });
}
aC.displayName = "AvatarName";
const lC = (e) => /* @__PURE__ */ x.jsxs(
  ye.svg,
  {
    viewBox: "0 0 128 128",
    color: "#fff",
    width: "100%",
    height: "100%",
    className: "chakra-avatar__svg",
    ...e,
    children: [
      /* @__PURE__ */ x.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
        }
      ),
      /* @__PURE__ */ x.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
        }
      )
    ]
  }
);
function cZ(e) {
  const {
    loading: t,
    src: n,
    srcSet: r,
    onLoad: o,
    onError: i,
    crossOrigin: a,
    sizes: u,
    ignoreFallback: c
  } = e, [d, f] = Ee("pending");
  Ue(() => {
    f(n ? "loading" : "pending");
  }, [n]);
  const p = Le(null), g = q(() => {
    if (!n)
      return;
    m();
    const b = new Image();
    b.src = n, a && (b.crossOrigin = a), r && (b.srcset = r), u && (b.sizes = u), t && (b.loading = t), b.onload = (v) => {
      m(), f("loaded"), o == null || o(v);
    }, b.onerror = (v) => {
      m(), f("failed"), i == null || i(v);
    }, p.current = b;
  }, [n, a, r, u, o, i, t]), m = () => {
    p.current && (p.current.onload = null, p.current.onerror = null, p.current = null);
  };
  return wi(() => {
    if (!c)
      return d === "loading" && g(), () => {
        m();
      };
  }, [d, g, c]), c ? "loaded" : d;
}
function uC(e) {
  const {
    src: t,
    srcSet: n,
    onError: r,
    onLoad: o,
    getInitials: i,
    name: a,
    borderRadius: u,
    loading: c,
    iconLabel: d,
    icon: f = /* @__PURE__ */ x.jsx(lC, {}),
    ignoreFallback: p,
    referrerPolicy: g,
    crossOrigin: m
  } = e, v = cZ({ src: t, onError: r, crossOrigin: m, ignoreFallback: p }) === "loaded";
  return !t || !v ? a ? /* @__PURE__ */ x.jsx(
    aC,
    {
      className: "chakra-avatar__initials",
      getInitials: i,
      name: a
    }
  ) : bo(f, {
    role: "img",
    "aria-label": d
  }) : /* @__PURE__ */ x.jsx(
    ye.img,
    {
      src: t,
      srcSet: n,
      alt: a ?? d,
      onLoad: o,
      referrerPolicy: g,
      crossOrigin: m ?? void 0,
      className: "chakra-avatar__img",
      loading: c,
      __css: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: u
      }
    }
  );
}
uC.displayName = "AvatarImage";
const dZ = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "medium",
  position: "relative",
  flexShrink: 0
}, cC = Pe((e, t) => {
  const n = Rn("Avatar", e), [r, o] = Ee(!1), {
    src: i,
    srcSet: a,
    name: u,
    showBorder: c,
    borderRadius: d = "full",
    onError: f,
    onLoad: p,
    getInitials: g = uZ,
    icon: m = /* @__PURE__ */ x.jsx(lC, {}),
    iconLabel: b = " avatar",
    loading: v,
    children: y,
    borderColor: w,
    ignoreFallback: I,
    crossOrigin: V,
    referrerPolicy: M,
    ...L
  } = rn(e), R = {
    borderRadius: d,
    borderWidth: c ? "2px" : void 0,
    ...dZ,
    ...n.container
  };
  return w && (R.borderColor = w), /* @__PURE__ */ x.jsx(
    ye.span,
    {
      ref: t,
      ...L,
      className: _e("chakra-avatar", e.className),
      "data-loaded": Ne(r),
      __css: R,
      children: /* @__PURE__ */ x.jsxs(aZ, { value: n, children: [
        /* @__PURE__ */ x.jsx(
          uC,
          {
            src: i,
            srcSet: a,
            loading: v,
            onLoad: We(p, () => {
              o(!0);
            }),
            onError: f,
            getInitials: g,
            name: u,
            borderRadius: d,
            icon: m,
            iconLabel: b,
            ignoreFallback: I,
            crossOrigin: V,
            referrerPolicy: M
          }
        ),
        y
      ] })
    }
  );
});
cC.displayName = "Avatar";
const Jo = ye("div");
Jo.displayName = "Box";
const [fZ, v3] = kF("Card"), hZ = Pe(function(t, n) {
  const {
    className: r,
    children: o,
    direction: i = "column",
    justify: a,
    align: u,
    ...c
  } = rn(t), d = Rn("Card", t);
  return /* @__PURE__ */ x.jsx(
    ye.div,
    {
      ref: n,
      className: _e("chakra-card", r),
      __css: {
        display: "flex",
        flexDirection: i,
        justifyContent: a,
        alignItems: u,
        position: "relative",
        minWidth: 0,
        wordWrap: "break-word",
        ...d.container
      },
      ...c,
      children: /* @__PURE__ */ x.jsx(fZ, { value: d, children: o })
    }
  );
}), pZ = Pe(
  function(t, n) {
    const { className: r, ...o } = t, i = v3();
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ref: n,
        className: _e("chakra-card__body", r),
        __css: i.body,
        ...o
      }
    );
  }
), gZ = Pe(
  function(t, n) {
    const { className: r, justify: o, ...i } = t, a = v3();
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ref: n,
        className: _e("chakra-card__footer", r),
        __css: {
          display: "flex",
          justifyContent: o,
          ...a.footer
        },
        ...i
      }
    );
  }
), mZ = Pe(
  function(t, n) {
    const { className: r, ...o } = t, i = v3();
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ref: n,
        className: _e("chakra-card__header", r),
        __css: i.header,
        ...o
      }
    );
  }
), [CZ, vZ] = Bt({
  name: "CheckboxGroupContext",
  strict: !1
});
function bZ(e) {
  return /* @__PURE__ */ x.jsx(
    ye.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...e,
      children: /* @__PURE__ */ x.jsx("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function yZ(e) {
  return /* @__PURE__ */ x.jsx(
    ye.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...e,
      children: /* @__PURE__ */ x.jsx("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function xZ(e) {
  const { isIndeterminate: t, isChecked: n, ...r } = e, o = t ? yZ : bZ;
  return n || t ? /* @__PURE__ */ x.jsx(
    ye.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ x.jsx(o, { ...r })
    }
  ) : null;
}
var SZ = () => typeof document < "u", u8 = !1, Al = null, ps = !1, j5 = !1, X5 = /* @__PURE__ */ new Set();
function b3(e, t) {
  X5.forEach((n) => n(e, t));
}
var wZ = typeof window < "u" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : !1;
function IZ(e) {
  return !(e.metaKey || !wZ && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function c8(e) {
  ps = !0, IZ(e) && (Al = "keyboard", b3("keyboard", e));
}
function ea(e) {
  if (Al = "pointer", e.type === "mousedown" || e.type === "pointerdown") {
    ps = !0;
    const t = e.composedPath ? e.composedPath()[0] : e.target;
    let n = !1;
    try {
      n = t.matches(":focus-visible");
    } catch {
    }
    if (n)
      return;
    b3("pointer", e);
  }
}
function VZ(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : e.detail === 0 && !e.pointerType;
}
function AZ(e) {
  VZ(e) && (ps = !0, Al = "virtual");
}
function LZ(e) {
  e.target === window || e.target === document || e.target instanceof Element && e.target.hasAttribute("tabindex") || (!ps && !j5 && (Al = "virtual", b3("virtual", e)), ps = !1, j5 = !1);
}
function MZ() {
  ps = !1, j5 = !0;
}
function d8() {
  return Al !== "pointer";
}
function PZ() {
  if (!SZ() || u8)
    return;
  const { focus: e } = HTMLElement.prototype;
  HTMLElement.prototype.focus = function(...n) {
    ps = !0, e.apply(this, n);
  }, document.addEventListener("keydown", c8, !0), document.addEventListener("keyup", c8, !0), document.addEventListener("click", AZ, !0), window.addEventListener("focus", LZ, !0), window.addEventListener("blur", MZ, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", ea, !0), document.addEventListener("pointermove", ea, !0), document.addEventListener("pointerup", ea, !0)) : (document.addEventListener("mousedown", ea, !0), document.addEventListener("mousemove", ea, !0), document.addEventListener("mouseup", ea, !0)), u8 = !0;
}
function dC(e) {
  PZ(), e(d8());
  const t = () => e(d8());
  return X5.add(t), () => {
    X5.delete(t);
  };
}
const [EZ, fC] = Bt({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [RZ, ws] = Bt({
  strict: !1,
  name: "FormControlContext"
});
function _Z(e) {
  const {
    id: t,
    isRequired: n,
    isInvalid: r,
    isDisabled: o,
    isReadOnly: i,
    ...a
  } = e, u = Zr(), c = t || `field-${u}`, d = `${c}-label`, f = `${c}-feedback`, p = `${c}-helptext`, [g, m] = Ee(!1), [b, v] = Ee(!1), [y, w] = Ee(!1), I = q(
    (_ = {}, H = null) => ({
      id: p,
      ..._,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: mn(H, (B) => {
        B && v(!0);
      })
    }),
    [p]
  ), V = q(
    (_ = {}, H = null) => ({
      ..._,
      ref: H,
      "data-focus": Ne(y),
      "data-disabled": Ne(o),
      "data-invalid": Ne(r),
      "data-readonly": Ne(i),
      id: _.id !== void 0 ? _.id : d,
      htmlFor: _.htmlFor !== void 0 ? _.htmlFor : c
    }),
    [c, o, y, r, i, d]
  ), M = q(
    (_ = {}, H = null) => ({
      id: f,
      ..._,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: mn(H, (B) => {
        B && m(!0);
      }),
      "aria-live": "polite"
    }),
    [f]
  ), L = q(
    (_ = {}, H = null) => ({
      ..._,
      ...a,
      ref: H,
      role: "group",
      "data-focus": Ne(y),
      "data-disabled": Ne(o),
      "data-invalid": Ne(r),
      "data-readonly": Ne(i)
    }),
    [a, o, y, r, i]
  ), R = q(
    (_ = {}, H = null) => ({
      ..._,
      ref: H,
      role: "presentation",
      "aria-hidden": !0,
      children: _.children || "*"
    }),
    []
  );
  return {
    isRequired: !!n,
    isInvalid: !!r,
    isReadOnly: !!i,
    isDisabled: !!o,
    isFocused: !!y,
    onFocus: () => w(!0),
    onBlur: () => w(!1),
    hasFeedbackText: g,
    setHasFeedbackText: m,
    hasHelpText: b,
    setHasHelpText: v,
    id: c,
    labelId: d,
    feedbackId: f,
    helpTextId: p,
    htmlProps: a,
    getHelpTextProps: I,
    getErrorMessageProps: M,
    getRootProps: L,
    getLabelProps: V,
    getRequiredIndicatorProps: R
  };
}
const hC = Pe(
  function(t, n) {
    const r = Rn("Form", t), o = rn(t), {
      getRootProps: i,
      htmlProps: a,
      ...u
    } = _Z(o), c = _e("chakra-form-control", t.className);
    return /* @__PURE__ */ x.jsx(RZ, { value: u, children: /* @__PURE__ */ x.jsx(EZ, { value: r, children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...i({}, n),
        className: c,
        __css: r.container
      }
    ) }) });
  }
);
hC.displayName = "FormControl";
const pC = Pe(
  function(t, n) {
    const r = ws(), o = fC(), i = _e("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...r == null ? void 0 : r.getHelpTextProps(t, n),
        __css: o.helperText,
        className: i
      }
    );
  }
);
pC.displayName = "FormHelperText";
function y3(e) {
  const { isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: o, ...i } = x3(e);
  return {
    ...i,
    disabled: t,
    readOnly: r,
    required: o,
    "aria-invalid": $o(n),
    "aria-required": $o(o),
    "aria-readonly": $o(r)
  };
}
function x3(e) {
  const t = ws(), {
    id: n,
    disabled: r,
    readOnly: o,
    required: i,
    isRequired: a,
    isInvalid: u,
    isReadOnly: c,
    isDisabled: d,
    onFocus: f,
    onBlur: p,
    ...g
  } = e, m = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return t != null && t.hasFeedbackText && (t != null && t.isInvalid) && m.push(t.feedbackId), t != null && t.hasHelpText && m.push(t.helpTextId), {
    ...g,
    "aria-describedby": m.join(" ") || void 0,
    id: n ?? (t == null ? void 0 : t.id),
    isDisabled: r ?? d ?? (t == null ? void 0 : t.isDisabled),
    isReadOnly: o ?? c ?? (t == null ? void 0 : t.isReadOnly),
    isRequired: i ?? a ?? (t == null ? void 0 : t.isRequired),
    isInvalid: u ?? (t == null ? void 0 : t.isInvalid),
    onFocus: We(t == null ? void 0 : t.onFocus, f),
    onBlur: We(t == null ? void 0 : t.onBlur, p)
  };
}
const gC = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
function mC(e = {}) {
  const t = x3(e), {
    isDisabled: n,
    isReadOnly: r,
    isRequired: o,
    isInvalid: i,
    id: a,
    onBlur: u,
    onFocus: c,
    "aria-describedby": d
  } = t, {
    defaultChecked: f,
    isChecked: p,
    isFocusable: g,
    onChange: m,
    isIndeterminate: b,
    name: v,
    value: y,
    tabIndex: w = void 0,
    "aria-label": I,
    "aria-labelledby": V,
    "aria-invalid": M,
    ...L
  } = e, R = p2(L, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]), _ = pn(m), H = pn(u), B = pn(c), [Z, G] = Ee(!1), [se, ue] = Ee(!1), [ce, xe] = Ee(!1), he = Le(!1);
  Ue(() => dC((ve) => {
    he.current = ve;
  }), []);
  const z = Le(null), [Y, ae] = Ee(!0), [j, X] = Ee(!!f), ie = p !== void 0, W = ie ? p : j, re = q(
    (ve) => {
      if (r || n) {
        ve.preventDefault();
        return;
      }
      ie || X(W ? ve.currentTarget.checked : b ? !0 : ve.currentTarget.checked), _ == null || _(ve);
    },
    [
      r,
      n,
      W,
      ie,
      b,
      _
    ]
  );
  wi(() => {
    z.current && (z.current.indeterminate = !!b);
  }, [b]), fs(() => {
    n && G(!1);
  }, [n, G]), wi(() => {
    const ve = z.current;
    if (!(ve != null && ve.form))
      return;
    const ot = () => {
      X(!!f);
    };
    return ve.form.addEventListener("reset", ot), () => {
      var Mt;
      return (Mt = ve.form) == null ? void 0 : Mt.removeEventListener("reset", ot);
    };
  }, []);
  const te = n && !g, ee = q(
    (ve) => {
      ve.key === " " && xe(!0);
    },
    [xe]
  ), ge = q(
    (ve) => {
      ve.key === " " && xe(!1);
    },
    [xe]
  );
  wi(() => {
    if (!z.current)
      return;
    z.current.checked !== W && X(z.current.checked);
  }, [z.current]);
  const pe = q(
    (ve = {}, ot = null) => {
      const Mt = (ft) => {
        Z && ft.preventDefault(), xe(!0);
      };
      return {
        ...ve,
        ref: ot,
        "data-active": Ne(ce),
        "data-hover": Ne(se),
        "data-checked": Ne(W),
        "data-focus": Ne(Z),
        "data-focus-visible": Ne(Z && he.current),
        "data-indeterminate": Ne(b),
        "data-disabled": Ne(n),
        "data-invalid": Ne(i),
        "data-readonly": Ne(r),
        "aria-hidden": !0,
        onMouseDown: We(ve.onMouseDown, Mt),
        onMouseUp: We(ve.onMouseUp, () => xe(!1)),
        onMouseEnter: We(
          ve.onMouseEnter,
          () => ue(!0)
        ),
        onMouseLeave: We(
          ve.onMouseLeave,
          () => ue(!1)
        )
      };
    },
    [
      ce,
      W,
      n,
      Z,
      se,
      b,
      i,
      r
    ]
  ), Se = q(
    (ve = {}, ot = null) => ({
      ...ve,
      ref: ot,
      "data-active": Ne(ce),
      "data-hover": Ne(se),
      "data-checked": Ne(W),
      "data-focus": Ne(Z),
      "data-focus-visible": Ne(Z && he.current),
      "data-indeterminate": Ne(b),
      "data-disabled": Ne(n),
      "data-invalid": Ne(i),
      "data-readonly": Ne(r)
    }),
    [
      ce,
      W,
      n,
      Z,
      se,
      b,
      i,
      r
    ]
  ), de = q(
    (ve = {}, ot = null) => ({
      ...R,
      ...ve,
      ref: mn(ot, (Mt) => {
        Mt && ae(Mt.tagName === "LABEL");
      }),
      onClick: We(ve.onClick, () => {
        var Mt;
        Y || ((Mt = z.current) == null || Mt.click(), requestAnimationFrame(() => {
          var ft;
          (ft = z.current) == null || ft.focus({ preventScroll: !0 });
        }));
      }),
      "data-disabled": Ne(n),
      "data-checked": Ne(W),
      "data-invalid": Ne(i)
    }),
    [R, n, W, i, Y]
  ), Ve = q(
    (ve = {}, ot = null) => ({
      ...ve,
      ref: mn(z, ot),
      type: "checkbox",
      name: v,
      value: y,
      id: a,
      tabIndex: w,
      onChange: We(ve.onChange, re),
      onBlur: We(
        ve.onBlur,
        H,
        () => G(!1)
      ),
      onFocus: We(
        ve.onFocus,
        B,
        () => G(!0)
      ),
      onKeyDown: We(ve.onKeyDown, ee),
      onKeyUp: We(ve.onKeyUp, ge),
      required: o,
      checked: W,
      disabled: te,
      readOnly: r,
      "aria-label": I,
      "aria-labelledby": V,
      "aria-invalid": M ? !!M : i,
      "aria-describedby": d,
      "aria-disabled": n,
      "aria-checked": b ? "mixed" : W,
      style: gC
    }),
    [
      v,
      y,
      a,
      w,
      re,
      H,
      B,
      ee,
      ge,
      o,
      W,
      te,
      r,
      I,
      V,
      M,
      i,
      d,
      n,
      b
    ]
  ), K = q(
    (ve = {}, ot = null) => ({
      ...ve,
      ref: ot,
      onMouseDown: We(ve.onMouseDown, TZ),
      "data-disabled": Ne(n),
      "data-checked": Ne(W),
      "data-invalid": Ne(i)
    }),
    [W, n, i]
  );
  return {
    state: {
      isInvalid: i,
      isFocused: Z,
      isChecked: W,
      isActive: ce,
      isHovered: se,
      isIndeterminate: b,
      isDisabled: n,
      isReadOnly: r,
      isRequired: o
    },
    getRootProps: de,
    getCheckboxProps: pe,
    getIndicatorProps: Se,
    getInputProps: Ve,
    getLabelProps: K,
    htmlProps: R
  };
}
function TZ(e) {
  e.preventDefault(), e.stopPropagation();
}
function HZ(e) {
  const [t, n] = Ee(e), [r, o] = Ee(!1);
  return e !== t && (o(!0), n(e)), r;
}
const FZ = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
}, kZ = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
}, BZ = Cl({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
}), DZ = Cl({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
}), OZ = Cl({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
}), S3 = Pe(
  function(t, n) {
    const r = vZ(), o = { ...r, ...t }, i = Rn("Checkbox", o), a = rn(t), {
      spacing: u = "0.5rem",
      className: c,
      children: d,
      iconColor: f,
      iconSize: p,
      icon: g = /* @__PURE__ */ x.jsx(xZ, {}),
      isChecked: m,
      isDisabled: b = r == null ? void 0 : r.isDisabled,
      onChange: v,
      inputProps: y,
      ...w
    } = a;
    let I = m;
    r != null && r.value && a.value && (I = r.value.includes(a.value));
    let V = v;
    r != null && r.onChange && a.value && (V = _f(r.onChange, v));
    const {
      state: M,
      getInputProps: L,
      getCheckboxProps: R,
      getLabelProps: _,
      getRootProps: H
    } = mC({
      ...w,
      isDisabled: b,
      isChecked: I,
      onChange: V
    }), B = HZ(M.isChecked), Z = at(
      () => ({
        animation: B ? M.isIndeterminate ? `${DZ} 20ms linear, ${OZ} 200ms linear` : `${BZ} 200ms linear` : void 0,
        ...i.icon,
        ...Tf({
          fontSize: p,
          color: f
        })
      }),
      [f, p, B, M.isIndeterminate, i.icon]
    ), G = bo(g, {
      __css: Z,
      isIndeterminate: M.isIndeterminate,
      isChecked: M.isChecked
    });
    return /* @__PURE__ */ x.jsxs(
      ye.label,
      {
        __css: { ...kZ, ...i.container },
        className: _e("chakra-checkbox", c),
        ...H(),
        children: [
          /* @__PURE__ */ x.jsx(
            "input",
            {
              className: "chakra-checkbox__input",
              ...L(y, n)
            }
          ),
          /* @__PURE__ */ x.jsx(
            ye.span,
            {
              __css: { ...FZ, ...i.control },
              className: "chakra-checkbox__control",
              ...R(),
              children: G
            }
          ),
          d && /* @__PURE__ */ x.jsx(
            ye.span,
            {
              className: "chakra-checkbox__label",
              ..._(),
              __css: {
                marginStart: u,
                ...i.label
              },
              children: d
            }
          )
        ]
      }
    );
  }
);
S3.displayName = "Checkbox";
function f8(e) {
  return e && gn(e) && gn(e.target);
}
function NZ(e = {}) {
  const {
    defaultValue: t,
    value: n,
    onChange: r,
    isDisabled: o,
    isNative: i
  } = e, a = pn(r), [u, c] = Gp({
    value: n,
    defaultValue: t || [],
    onChange: a
  }), d = q(
    (p) => {
      if (!u)
        return;
      const g = f8(p) ? p.target.checked : !u.includes(p), m = f8(p) ? p.target.value : p, b = g ? [...u, m] : u.filter((v) => String(v) !== String(m));
      c(b);
    },
    [c, u]
  ), f = q(
    (p = {}) => ({
      ...p,
      [i ? "checked" : "isChecked"]: u.some((m) => String(p.value) === String(m)),
      onChange: d
    }),
    [d, i, u]
  );
  return {
    value: u,
    isDisabled: o,
    onChange: d,
    setValue: c,
    getCheckboxProps: f
  };
}
function CC(e) {
  const { colorScheme: t, size: n, variant: r, children: o, isDisabled: i } = e, { value: a, onChange: u } = NZ(e), c = at(
    () => ({
      size: n,
      onChange: u,
      colorScheme: t,
      value: a,
      variant: r,
      isDisabled: i
    }),
    [n, u, t, a, r, i]
  );
  return /* @__PURE__ */ x.jsx(CZ, { value: c, children: o });
}
CC.displayName = "CheckboxGroup";
function k1(e) {
  return typeof e == "function";
}
function ZZ(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
const $Z = (e) => function(...n) {
  let r = [...n], o = n[n.length - 1];
  return IF(o) && // this ensures backward compatibility
  // previously only `extendTheme(override, activeTheme?)` was allowed
  r.length > 1 ? r = r.slice(0, r.length - 1) : o = e, ZZ(
    ...r.map(
      (i) => (a) => k1(i) ? i(a) : WZ(a, i)
    )
  )(o);
}, zZ = $Z(mg);
function WZ(...e) {
  return Tr({}, ...e, vC);
}
function vC(e, t, n, r) {
  if ((k1(e) || k1(t)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...o) => {
      const i = k1(e) ? e(...o) : e, a = k1(t) ? t(...o) : t;
      return Tr({}, i, a, vC);
    };
  if (gn(e) && x5(t) || x5(e) && gn(t))
    return t;
}
const Uc = Pe(function(t, n) {
  const { direction: r, align: o, justify: i, wrap: a, basis: u, grow: c, shrink: d, ...f } = t, p = {
    display: "flex",
    flexDirection: r,
    alignItems: o,
    justifyContent: i,
    flexWrap: a,
    flexBasis: u,
    flexGrow: c,
    flexShrink: d
  };
  return /* @__PURE__ */ x.jsx(ye.div, { ref: n, __css: p, ...f });
});
Uc.displayName = "Flex";
function bC(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function Te() {
  return Te = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Te.apply(null, arguments);
}
var U5 = { exports: {} }, rc = { exports: {} }, It = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h8;
function GZ() {
  if (h8)
    return It;
  h8 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function V(L) {
    if (typeof L == "object" && L !== null) {
      var R = L.$$typeof;
      switch (R) {
        case t:
          switch (L = L.type, L) {
            case c:
            case d:
            case r:
            case i:
            case o:
            case p:
              return L;
            default:
              switch (L = L && L.$$typeof, L) {
                case u:
                case f:
                case b:
                case m:
                case a:
                  return L;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function M(L) {
    return V(L) === d;
  }
  return It.AsyncMode = c, It.ConcurrentMode = d, It.ContextConsumer = u, It.ContextProvider = a, It.Element = t, It.ForwardRef = f, It.Fragment = r, It.Lazy = b, It.Memo = m, It.Portal = n, It.Profiler = i, It.StrictMode = o, It.Suspense = p, It.isAsyncMode = function(L) {
    return M(L) || V(L) === c;
  }, It.isConcurrentMode = M, It.isContextConsumer = function(L) {
    return V(L) === u;
  }, It.isContextProvider = function(L) {
    return V(L) === a;
  }, It.isElement = function(L) {
    return typeof L == "object" && L !== null && L.$$typeof === t;
  }, It.isForwardRef = function(L) {
    return V(L) === f;
  }, It.isFragment = function(L) {
    return V(L) === r;
  }, It.isLazy = function(L) {
    return V(L) === b;
  }, It.isMemo = function(L) {
    return V(L) === m;
  }, It.isPortal = function(L) {
    return V(L) === n;
  }, It.isProfiler = function(L) {
    return V(L) === i;
  }, It.isStrictMode = function(L) {
    return V(L) === o;
  }, It.isSuspense = function(L) {
    return V(L) === p;
  }, It.isValidElementType = function(L) {
    return typeof L == "string" || typeof L == "function" || L === r || L === d || L === i || L === o || L === p || L === g || typeof L == "object" && L !== null && (L.$$typeof === b || L.$$typeof === m || L.$$typeof === a || L.$$typeof === u || L.$$typeof === f || L.$$typeof === y || L.$$typeof === w || L.$$typeof === I || L.$$typeof === v);
  }, It.typeOf = V, It;
}
var Vt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p8;
function jZ() {
  return p8 || (p8 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function V(K) {
      return typeof K == "string" || typeof K == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      K === r || K === d || K === i || K === o || K === p || K === g || typeof K == "object" && K !== null && (K.$$typeof === b || K.$$typeof === m || K.$$typeof === a || K.$$typeof === u || K.$$typeof === f || K.$$typeof === y || K.$$typeof === w || K.$$typeof === I || K.$$typeof === v);
    }
    function M(K) {
      if (typeof K == "object" && K !== null) {
        var Ye = K.$$typeof;
        switch (Ye) {
          case t:
            var ve = K.type;
            switch (ve) {
              case c:
              case d:
              case r:
              case i:
              case o:
              case p:
                return ve;
              default:
                var ot = ve && ve.$$typeof;
                switch (ot) {
                  case u:
                  case f:
                  case b:
                  case m:
                  case a:
                    return ot;
                  default:
                    return Ye;
                }
            }
          case n:
            return Ye;
        }
      }
    }
    var L = c, R = d, _ = u, H = a, B = t, Z = f, G = r, se = b, ue = m, ce = n, xe = i, he = o, z = p, Y = !1;
    function ae(K) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(K) || M(K) === c;
    }
    function j(K) {
      return M(K) === d;
    }
    function X(K) {
      return M(K) === u;
    }
    function ie(K) {
      return M(K) === a;
    }
    function W(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function re(K) {
      return M(K) === f;
    }
    function te(K) {
      return M(K) === r;
    }
    function ee(K) {
      return M(K) === b;
    }
    function ge(K) {
      return M(K) === m;
    }
    function pe(K) {
      return M(K) === n;
    }
    function Se(K) {
      return M(K) === i;
    }
    function de(K) {
      return M(K) === o;
    }
    function Ve(K) {
      return M(K) === p;
    }
    Vt.AsyncMode = L, Vt.ConcurrentMode = R, Vt.ContextConsumer = _, Vt.ContextProvider = H, Vt.Element = B, Vt.ForwardRef = Z, Vt.Fragment = G, Vt.Lazy = se, Vt.Memo = ue, Vt.Portal = ce, Vt.Profiler = xe, Vt.StrictMode = he, Vt.Suspense = z, Vt.isAsyncMode = ae, Vt.isConcurrentMode = j, Vt.isContextConsumer = X, Vt.isContextProvider = ie, Vt.isElement = W, Vt.isForwardRef = re, Vt.isFragment = te, Vt.isLazy = ee, Vt.isMemo = ge, Vt.isPortal = pe, Vt.isProfiler = Se, Vt.isStrictMode = de, Vt.isSuspense = Ve, Vt.isValidElementType = V, Vt.typeOf = M;
  }()), Vt;
}
var g8;
function yC() {
  return g8 || (g8 = 1, process.env.NODE_ENV === "production" ? rc.exports = GZ() : rc.exports = jZ()), rc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Bd, m8;
function XZ() {
  if (m8)
    return Bd;
  m8 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, u = 0; u < 10; u++)
        a["_" + String.fromCharCode(u)] = u;
      var c = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Bd = o() ? Object.assign : function(i, a) {
    for (var u, c = r(i), d, f = 1; f < arguments.length; f++) {
      u = Object(arguments[f]);
      for (var p in u)
        t.call(u, p) && (c[p] = u[p]);
      if (e) {
        d = e(u);
        for (var g = 0; g < d.length; g++)
          n.call(u, d[g]) && (c[d[g]] = u[d[g]]);
      }
    }
    return c;
  }, Bd;
}
var Dd, C8;
function w3() {
  if (C8)
    return Dd;
  C8 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Dd = e, Dd;
}
var Od, v8;
function xC() {
  return v8 || (v8 = 1, Od = Function.call.bind(Object.prototype.hasOwnProperty)), Od;
}
var Nd, b8;
function UZ() {
  if (b8)
    return Nd;
  b8 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = w3(), n = {}, r = xC();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, u, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var p;
          try {
            if (typeof i[f] != "function") {
              var g = Error(
                (c || "React class") + ": " + u + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            p = i[f](a, f, c, u, null, t);
          } catch (b) {
            p = b;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + u + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var m = d ? d() : "";
            e(
              "Failed " + u + " type: " + p.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Nd = o, Nd;
}
var Zd, y8;
function YZ() {
  if (y8)
    return Zd;
  y8 = 1;
  var e = yC(), t = XZ(), n = w3(), r = xC(), o = UZ(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var c = "Warning: " + u;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Zd = function(u, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function p(j) {
      var X = j && (d && j[d] || j[f]);
      if (typeof X == "function")
        return X;
    }
    var g = "<<anonymous>>", m = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: I(),
      arrayOf: V,
      element: M(),
      elementType: L(),
      instanceOf: R,
      node: Z(),
      objectOf: H,
      oneOf: _,
      oneOfType: B,
      shape: se,
      exact: ue
    };
    function b(j, X) {
      return j === X ? j !== 0 || 1 / j === 1 / X : j !== j && X !== X;
    }
    function v(j, X) {
      this.message = j, this.data = X && typeof X == "object" ? X : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function y(j) {
      if (process.env.NODE_ENV !== "production")
        var X = {}, ie = 0;
      function W(te, ee, ge, pe, Se, de, Ve) {
        if (pe = pe || g, de = de || ge, Ve !== n) {
          if (c) {
            var K = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw K.name = "Invariant Violation", K;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ye = pe + ":" + ge;
            !X[Ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            ie < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + de + "` prop on `" + pe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), X[Ye] = !0, ie++);
          }
        }
        return ee[ge] == null ? te ? ee[ge] === null ? new v("The " + Se + " `" + de + "` is marked as required " + ("in `" + pe + "`, but its value is `null`.")) : new v("The " + Se + " `" + de + "` is marked as required in " + ("`" + pe + "`, but its value is `undefined`.")) : null : j(ee, ge, pe, Se, de);
      }
      var re = W.bind(null, !1);
      return re.isRequired = W.bind(null, !0), re;
    }
    function w(j) {
      function X(ie, W, re, te, ee, ge) {
        var pe = ie[W], Se = he(pe);
        if (Se !== j) {
          var de = z(pe);
          return new v(
            "Invalid " + te + " `" + ee + "` of type " + ("`" + de + "` supplied to `" + re + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return y(X);
    }
    function I() {
      return y(a);
    }
    function V(j) {
      function X(ie, W, re, te, ee) {
        if (typeof j != "function")
          return new v("Property `" + ee + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var ge = ie[W];
        if (!Array.isArray(ge)) {
          var pe = he(ge);
          return new v("Invalid " + te + " `" + ee + "` of type " + ("`" + pe + "` supplied to `" + re + "`, expected an array."));
        }
        for (var Se = 0; Se < ge.length; Se++) {
          var de = j(ge, Se, re, te, ee + "[" + Se + "]", n);
          if (de instanceof Error)
            return de;
        }
        return null;
      }
      return y(X);
    }
    function M() {
      function j(X, ie, W, re, te) {
        var ee = X[ie];
        if (!u(ee)) {
          var ge = he(ee);
          return new v("Invalid " + re + " `" + te + "` of type " + ("`" + ge + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(j);
    }
    function L() {
      function j(X, ie, W, re, te) {
        var ee = X[ie];
        if (!e.isValidElementType(ee)) {
          var ge = he(ee);
          return new v("Invalid " + re + " `" + te + "` of type " + ("`" + ge + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(j);
    }
    function R(j) {
      function X(ie, W, re, te, ee) {
        if (!(ie[W] instanceof j)) {
          var ge = j.name || g, pe = ae(ie[W]);
          return new v("Invalid " + te + " `" + ee + "` of type " + ("`" + pe + "` supplied to `" + re + "`, expected ") + ("instance of `" + ge + "`."));
        }
        return null;
      }
      return y(X);
    }
    function _(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function X(ie, W, re, te, ee) {
        for (var ge = ie[W], pe = 0; pe < j.length; pe++)
          if (b(ge, j[pe]))
            return null;
        var Se = JSON.stringify(j, function(Ve, K) {
          var Ye = z(K);
          return Ye === "symbol" ? String(K) : K;
        });
        return new v("Invalid " + te + " `" + ee + "` of value `" + String(ge) + "` " + ("supplied to `" + re + "`, expected one of " + Se + "."));
      }
      return y(X);
    }
    function H(j) {
      function X(ie, W, re, te, ee) {
        if (typeof j != "function")
          return new v("Property `" + ee + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var ge = ie[W], pe = he(ge);
        if (pe !== "object")
          return new v("Invalid " + te + " `" + ee + "` of type " + ("`" + pe + "` supplied to `" + re + "`, expected an object."));
        for (var Se in ge)
          if (r(ge, Se)) {
            var de = j(ge, Se, re, te, ee + "." + Se, n);
            if (de instanceof Error)
              return de;
          }
        return null;
      }
      return y(X);
    }
    function B(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var X = 0; X < j.length; X++) {
        var ie = j[X];
        if (typeof ie != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Y(ie) + " at index " + X + "."
          ), a;
      }
      function W(re, te, ee, ge, pe) {
        for (var Se = [], de = 0; de < j.length; de++) {
          var Ve = j[de], K = Ve(re, te, ee, ge, pe, n);
          if (K == null)
            return null;
          K.data && r(K.data, "expectedType") && Se.push(K.data.expectedType);
        }
        var Ye = Se.length > 0 ? ", expected one of type [" + Se.join(", ") + "]" : "";
        return new v("Invalid " + ge + " `" + pe + "` supplied to " + ("`" + ee + "`" + Ye + "."));
      }
      return y(W);
    }
    function Z() {
      function j(X, ie, W, re, te) {
        return ce(X[ie]) ? null : new v("Invalid " + re + " `" + te + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return y(j);
    }
    function G(j, X, ie, W, re) {
      return new v(
        (j || "React class") + ": " + X + " type `" + ie + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function se(j) {
      function X(ie, W, re, te, ee) {
        var ge = ie[W], pe = he(ge);
        if (pe !== "object")
          return new v("Invalid " + te + " `" + ee + "` of type `" + pe + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var Se in j) {
          var de = j[Se];
          if (typeof de != "function")
            return G(re, te, ee, Se, z(de));
          var Ve = de(ge, Se, re, te, ee + "." + Se, n);
          if (Ve)
            return Ve;
        }
        return null;
      }
      return y(X);
    }
    function ue(j) {
      function X(ie, W, re, te, ee) {
        var ge = ie[W], pe = he(ge);
        if (pe !== "object")
          return new v("Invalid " + te + " `" + ee + "` of type `" + pe + "` " + ("supplied to `" + re + "`, expected `object`."));
        var Se = t({}, ie[W], j);
        for (var de in Se) {
          var Ve = j[de];
          if (r(j, de) && typeof Ve != "function")
            return G(re, te, ee, de, z(Ve));
          if (!Ve)
            return new v(
              "Invalid " + te + " `" + ee + "` key `" + de + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(ie[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var K = Ve(ge, de, re, te, ee + "." + de, n);
          if (K)
            return K;
        }
        return null;
      }
      return y(X);
    }
    function ce(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(ce);
          if (j === null || u(j))
            return !0;
          var X = p(j);
          if (X) {
            var ie = X.call(j), W;
            if (X !== j.entries) {
              for (; !(W = ie.next()).done; )
                if (!ce(W.value))
                  return !1;
            } else
              for (; !(W = ie.next()).done; ) {
                var re = W.value;
                if (re && !ce(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function xe(j, X) {
      return j === "symbol" ? !0 : X ? X["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && X instanceof Symbol : !1;
    }
    function he(j) {
      var X = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : xe(X, j) ? "symbol" : X;
    }
    function z(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var X = he(j);
      if (X === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return X;
    }
    function Y(j) {
      var X = z(j);
      switch (X) {
        case "array":
        case "object":
          return "an " + X;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + X;
        default:
          return X;
      }
    }
    function ae(j) {
      return !j.constructor || !j.constructor.name ? g : j.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, Zd;
}
var $d, x8;
function JZ() {
  if (x8)
    return $d;
  x8 = 1;
  var e = w3();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, $d = function() {
    function r(a, u, c, d, f, p) {
      if (p !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, $d;
}
if (process.env.NODE_ENV !== "production") {
  var qZ = yC(), KZ = !0;
  U5.exports = YZ()(qZ.isElement, KZ);
} else
  U5.exports = JZ()();
var Ht = U5.exports;
const SC = /* @__PURE__ */ Ef(Ht);
var Y5 = "data-focus-lock", wC = "data-focus-lock-disabled", QZ = "data-no-focus-lock", e$ = "data-autofocus-inside", t$ = "data-no-autofocus";
function zd(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function n$(e, t) {
  var n = Ee(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var r$ = typeof window < "u" ? be.useLayoutEffect : be.useEffect, S8 = /* @__PURE__ */ new WeakMap();
function IC(e, t) {
  var n = n$(t || null, function(r) {
    return e.forEach(function(o) {
      return zd(o, r);
    });
  });
  return r$(function() {
    var r = S8.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(u) {
        i.has(u) || zd(u, null);
      }), i.forEach(function(u) {
        o.has(u) || zd(u, a);
      });
    }
    S8.set(n, e);
  }, [e]), n;
}
var Wd = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && SC.node;
var go = function() {
  return go = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, go.apply(this, arguments);
};
function VC(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function o$(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function AC(e) {
  return e;
}
function LC(e, t) {
  t === void 0 && (t = AC);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(u) {
          return u !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(u) {
          return i(u);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var u = n;
        n = [], u.forEach(i), a = n;
      }
      var c = function() {
        var f = a;
        a = [], f.forEach(i);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(f) {
          a.push(f), d();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return o;
}
function I3(e, t) {
  return t === void 0 && (t = AC), LC(e, t);
}
function MC(e) {
  e === void 0 && (e = {});
  var t = LC(null);
  return t.options = go({ async: !0, ssr: !1 }, e), t;
}
var PC = function(e) {
  var t = e.sideCar, n = VC(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return be.createElement(r, go({}, n));
};
PC.isSideCarExport = !0;
function i$(e, t) {
  return e.useMedium(t), PC;
}
var EC = I3({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), RC = I3(), s$ = I3(), a$ = MC({
  async: !0,
  ssr: typeof document < "u"
}), l$ = /* @__PURE__ */ Nr(void 0), u$ = [], _C = /* @__PURE__ */ Fe(function(t, n) {
  var r, o = Ee(), i = o[0], a = o[1], u = Le(), c = Le(!1), d = Le(null), f = Ee({}), p = f[1], g = t.children, m = t.disabled, b = m === void 0 ? !1 : m, v = t.noFocusGuards, y = v === void 0 ? !1 : v, w = t.persistentFocus, I = w === void 0 ? !1 : w, V = t.crossFrame, M = V === void 0 ? !0 : V, L = t.autoFocus, R = L === void 0 ? !0 : L, _ = t.allowTextSelection, H = t.group, B = t.className, Z = t.whiteList, G = t.hasPositiveIndices, se = t.shards, ue = se === void 0 ? u$ : se, ce = t.as, xe = ce === void 0 ? "div" : ce, he = t.lockProps, z = he === void 0 ? {} : he, Y = t.sideCar, ae = t.returnFocus, j = ae === void 0 ? !1 : ae, X = t.focusOptions, ie = t.onActivation, W = t.onDeactivation, re = Ee({}), te = re[0], ee = q(function(ft) {
    var un = ft.captureFocusRestore;
    if (!d.current) {
      var on, Ct = (on = document) == null ? void 0 : on.activeElement;
      d.current = Ct, Ct !== document.body && (d.current = un(Ct));
    }
    u.current && ie && ie(u.current), c.current = !0, p();
  }, [ie]), ge = q(function() {
    c.current = !1, W && W(u.current), p();
  }, [W]), pe = q(function(ft) {
    var un = d.current;
    if (un) {
      var on = (typeof un == "function" ? un() : un) || document.body, Ct = typeof j == "function" ? j(on) : j;
      if (Ct) {
        var Pt = typeof Ct == "object" ? Ct : void 0;
        d.current = null, ft ? Promise.resolve().then(function() {
          return on.focus(Pt);
        }) : on.focus(Pt);
      }
    }
  }, [j]), Se = q(function(ft) {
    c.current && EC.useMedium(ft);
  }, []), de = RC.useMedium, Ve = q(function(ft) {
    u.current !== ft && (u.current = ft, a(ft));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof _ < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), Ue(function() {
    !u.current && typeof xe != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var K = Te((r = {}, r[wC] = b && "disabled", r[Y5] = H, r), z), Ye = y !== !0, ve = Ye && y !== "tail", ot = IC([n, Ve]), Mt = at(function() {
    return {
      observed: u,
      shards: ue,
      enabled: !b,
      active: c.current
    };
  }, [b, c.current, ue, i]);
  return /* @__PURE__ */ Bn.createElement(ol, null, Ye && [
    /* @__PURE__ */ Bn.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: b ? -1 : 0,
      style: Wd
    }),
    G ? /* @__PURE__ */ Bn.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: b ? -1 : 1,
      style: Wd
    }) : null
  ], !b && /* @__PURE__ */ Bn.createElement(Y, {
    id: te,
    sideCar: a$,
    observed: i,
    disabled: b,
    persistentFocus: I,
    crossFrame: M,
    autoFocus: R,
    whiteList: Z,
    shards: ue,
    onActivation: ee,
    onDeactivation: ge,
    returnFocus: pe,
    focusOptions: X,
    noFocusGuards: y
  }), /* @__PURE__ */ Bn.createElement(xe, Te({
    ref: ot
  }, K, {
    className: B,
    onBlur: de,
    onFocus: Se
  }), /* @__PURE__ */ Bn.createElement(l$.Provider, {
    value: Mt
  }, g)), ve && /* @__PURE__ */ Bn.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: b ? -1 : 0,
    style: Wd
  }));
});
_C.propTypes = process.env.NODE_ENV !== "production" ? {
  children: Ht.node,
  disabled: Ht.bool,
  returnFocus: Ht.oneOfType([Ht.bool, Ht.object, Ht.func]),
  focusOptions: Ht.object,
  noFocusGuards: Ht.bool,
  hasPositiveIndices: Ht.bool,
  allowTextSelection: Ht.bool,
  autoFocus: Ht.bool,
  persistentFocus: Ht.bool,
  crossFrame: Ht.bool,
  group: Ht.string,
  className: Ht.string,
  whiteList: Ht.func,
  shards: Ht.arrayOf(Ht.any),
  as: Ht.oneOfType([Ht.string, Ht.func, Ht.object]),
  lockProps: Ht.object,
  onActivation: Ht.func,
  onDeactivation: Ht.func,
  sideCar: Ht.any.isRequired
} : {};
const TC = _C;
function Yc(e, t) {
  return Yc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Yc(e, t);
}
function c$(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Yc(e, t);
}
function gs(e) {
  "@babel/helpers - typeof";
  return gs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gs(e);
}
function d$(e, t) {
  if (gs(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (gs(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function HC(e) {
  var t = d$(e, "string");
  return gs(t) == "symbol" ? t : t + "";
}
function Ca(e, t, n) {
  return (t = HC(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function f$(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var i = [], a;
    function u() {
      a = e(i.map(function(d) {
        return d.props;
      })), t(a);
    }
    var c = /* @__PURE__ */ function(d) {
      c$(f, d);
      function f() {
        return d.apply(this, arguments) || this;
      }
      f.peek = function() {
        return a;
      };
      var p = f.prototype;
      return p.componentDidMount = function() {
        i.push(this), u();
      }, p.componentDidUpdate = function() {
        u();
      }, p.componentWillUnmount = function() {
        var m = i.indexOf(this);
        i.splice(m, 1), u();
      }, p.render = function() {
        return /* @__PURE__ */ Bn.createElement(o, this.props);
      }, f;
    }(dL);
    return Ca(c, "displayName", "SideEffect(" + n(o) + ")"), c;
  };
}
var So = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, ms = function(e) {
  return Array.isArray(e) ? e : [e];
}, FC = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, h$ = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, kC = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, BC = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, p$ = function(e) {
  return e.hasAttribute("inert");
}, g$ = function(e, t) {
  return !e || BC(e) || !h$(e) && !p$(e) && t(kC(e));
}, DC = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = g$(t, DC.bind(void 0, e));
  return e.set(t, r), r;
}, m$ = function(e, t) {
  return e && !BC(e) ? b$(e) ? t(kC(e)) : !1 : !0;
}, OC = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = m$(t, OC.bind(void 0, e));
  return e.set(t, r), r;
}, NC = function(e) {
  return e.dataset;
}, C$ = function(e) {
  return e.tagName === "BUTTON";
}, ZC = function(e) {
  return e.tagName === "INPUT";
}, $C = function(e) {
  return ZC(e) && e.type === "radio";
}, v$ = function(e) {
  return !((ZC(e) || C$(e)) && (e.type === "hidden" || e.disabled));
}, b$ = function(e) {
  var t = e.getAttribute(t$);
  return ![!0, "true", ""].includes(t);
}, V3 = function(e) {
  var t;
  return !!(e && (!((t = NC(e)) === null || t === void 0) && t.focusGuard));
}, J5 = function(e) {
  return !V3(e);
}, y$ = function(e) {
  return !!e;
}, x$ = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), o = n - r, i = e.index - t.index;
  if (o) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return o || i;
}, S$ = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, A3 = function(e, t, n) {
  return So(e).map(function(r, o) {
    var i = S$(r);
    return {
      node: r,
      index: o,
      tabIndex: n && i === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : i
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(x$);
}, w$ = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], L3 = w$.join(","), I$ = "".concat(L3, ", [data-focus-guard]"), zC = function(e, t) {
  return So((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? I$ : L3) ? [r] : [], zC(r));
  }, []);
}, V$ = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? Ea([e.contentDocument.body], t) : [e];
}, Ea = function(e, t) {
  return e.reduce(function(n, r) {
    var o, i = zC(r, t), a = (o = []).concat.apply(o, i.map(function(u) {
      return V$(u, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      a,
      // add if node is tabbable itself
      r.parentNode ? So(r.parentNode.querySelectorAll(L3)).filter(function(u) {
        return u === r;
      }) : []
    );
  }, []);
}, A$ = function(e) {
  var t = e.querySelectorAll("[".concat(e$, "]"));
  return So(t).map(function(n) {
    return Ea([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, M3 = function(e, t) {
  return So(e).filter(function(n) {
    return DC(t, n);
  }).filter(function(n) {
    return v$(n);
  });
}, w8 = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), So(e).filter(function(n) {
    return OC(t, n);
  });
}, P3 = function(e, t, n) {
  return A3(M3(Ea(e, n), t), !0, n);
}, dl = function(e, t) {
  return A3(M3(Ea(e), t), !1);
}, L$ = function(e, t) {
  return M3(A$(e), t);
}, cs = function(e, t) {
  return e.shadowRoot ? cs(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : So(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var o = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return o ? cs(o, t) : !1;
    }
    return cs(n, t);
  });
}, M$ = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var o = r + 1; o < n; o += 1) {
      var i = e[r].compareDocumentPosition(e[o]);
      (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(o), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(a, u) {
    return !t.has(u);
  });
}, WC = function(e) {
  return e.parentNode ? WC(e.parentNode) : e;
}, E3 = function(e) {
  var t = ms(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var o = r.getAttribute(Y5);
    return n.push.apply(n, o ? M$(So(WC(r).querySelectorAll("[".concat(Y5, '="').concat(o, '"]:not([').concat(wC, '="disabled"])')))) : [r]), n;
  }, []);
}, P$ = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, fl = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? fl(t.shadowRoot) : t instanceof HTMLIFrameElement && P$(function() {
      return t.contentWindow.document;
    }) ? fl(t.contentWindow.document) : t;
  }
}, E$ = function(e, t) {
  return e === t;
}, R$ = function(e, t) {
  return !!So(e.querySelectorAll("iframe")).some(function(n) {
    return E$(n, t);
  });
}, GC = function(e, t) {
  return t === void 0 && (t = fl(FC(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : E3(e).some(function(n) {
    return cs(n, t) || R$(n, t);
  });
}, _$ = function(e) {
  e === void 0 && (e = document);
  var t = fl(e);
  return t ? So(e.querySelectorAll("[".concat(QZ, "]"))).some(function(n) {
    return cs(n, t);
  }) : !1;
}, T$ = function(e, t) {
  return t.filter($C).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, R3 = function(e, t) {
  return $C(e) && e.name ? T$(e, t) : e;
}, H$ = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(R3(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, I8 = function(e) {
  return e[0] && e.length > 1 ? R3(e[0], e) : e[0];
}, V8 = function(e, t) {
  return e.indexOf(R3(t, e));
}, q5 = "NEW_FOCUS", F$ = function(e, t, n, r, o) {
  var i = e.length, a = e[0], u = e[i - 1], c = V3(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var d = r !== void 0 ? n.indexOf(r) : -1, f = o ? n.indexOf(o) : d, p = o ? e.indexOf(o) : -1;
    if (d === -1)
      return p !== -1 ? p : q5;
    if (p === -1)
      return q5;
    var g = d - f, m = n.indexOf(a), b = n.indexOf(u), v = H$(n), y = r !== void 0 ? v.indexOf(r) : -1, w = o ? v.indexOf(o) : y, I = v.filter(function(H) {
      return H.tabIndex >= 0;
    }), V = r !== void 0 ? I.indexOf(r) : -1, M = o ? I.indexOf(o) : V, L = V >= 0 && M >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      M - V
    ) : (
      // or else measure in focusable space
      w - y
    );
    if (!g && p >= 0 || t.length === 0)
      return p;
    var R = V8(e, t[0]), _ = V8(e, t[t.length - 1]);
    if (d <= m && c && Math.abs(g) > 1)
      return _;
    if (d >= b && c && Math.abs(g) > 1)
      return R;
    if (g && Math.abs(L) > 1)
      return p;
    if (d <= m)
      return _;
    if (d > b)
      return R;
    if (g)
      return Math.abs(g) > 1 ? p : (i + p + g) % i;
  }
}, k$ = function(e) {
  return function(t) {
    var n, r = (n = NC(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, A8 = function(e, t, n) {
  var r = e.map(function(i) {
    var a = i.node;
    return a;
  }), o = w8(r.filter(k$(n)));
  return o && o.length ? I8(o) : I8(w8(t));
}, K5 = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && K5(e.parentNode.host || e.parentNode, t), t;
}, Gd = function(e, t) {
  for (var n = K5(e), r = K5(t), o = 0; o < n.length; o += 1) {
    var i = n[o];
    if (r.indexOf(i) >= 0)
      return i;
  }
  return !1;
}, jC = function(e, t, n) {
  var r = ms(e), o = ms(t), i = r[0], a = !1;
  return o.filter(Boolean).forEach(function(u) {
    a = Gd(a || u, u) || a, n.filter(Boolean).forEach(function(c) {
      var d = Gd(i, c);
      d && (!a || cs(d, a) ? a = d : a = Gd(d, a));
    });
  }), a;
}, L8 = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(L$(r, t));
  }, []);
}, B$ = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(y$);
}, D$ = function(e, t) {
  var n = fl(ms(e).length > 0 ? document : FC(e).ownerDocument), r = E3(e).filter(J5), o = jC(n || e, e, r), i = /* @__PURE__ */ new Map(), a = dl(r, i), u = a.filter(function(b) {
    var v = b.node;
    return J5(v);
  });
  if (u[0]) {
    var c = dl([o], i).map(function(b) {
      var v = b.node;
      return v;
    }), d = B$(c, u), f = d.map(function(b) {
      var v = b.node;
      return v;
    }), p = d.filter(function(b) {
      var v = b.tabIndex;
      return v >= 0;
    }).map(function(b) {
      var v = b.node;
      return v;
    }), g = F$(f, p, c, n, t);
    if (g === q5) {
      var m = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        A8(a, p, L8(r, i)) || A8(a, f, L8(r, i))
      );
      if (m)
        return { node: m };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return g === void 0 ? g : d[g];
  }
}, O$ = function(e) {
  var t = E3(e).filter(J5), n = jC(e, e, t), r = A3(Ea([n], !0), !0, !0), o = Ea(t, !1);
  return r.map(function(i) {
    var a = i.node, u = i.index;
    return {
      node: a,
      index: u,
      lockItem: o.indexOf(a) >= 0,
      guard: V3(a)
    };
  });
}, _3 = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, jd = 0, Xd = !1, XC = function(e, t, n) {
  n === void 0 && (n = {});
  var r = D$(e, t);
  if (!Xd && r) {
    if (jd > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Xd = !0, setTimeout(function() {
        Xd = !1;
      }, 1);
      return;
    }
    jd++, _3(r.node, n.focusOptions), jd--;
  }
};
function V1(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return (t == null ? void 0 : t.deref()) || null;
  };
}
var N$ = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: V1(n),
      parent: V1(n.parentElement),
      left: V1(n.previousElementSibling),
      right: V1(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: V1(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, Z$ = function(e) {
  var t, n, r, o, i;
  if (e)
    for (var a = e.stack, u = e.ownerDocument, c = /* @__PURE__ */ new Map(), d = 0, f = a; d < f.length; d++) {
      var p = f[d], g = (t = p.parent) === null || t === void 0 ? void 0 : t.call(p);
      if (g && u.contains(g)) {
        for (var m = (n = p.left) === null || n === void 0 ? void 0 : n.call(p), b = p.current(), v = g.contains(b) ? b : void 0, y = (r = p.right) === null || r === void 0 ? void 0 : r.call(p), w = P3([g], c), I = (
          // that is element itself
          (i = (o = v ?? // or something in it's place
          (m == null ? void 0 : m.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && i !== void 0 ? i : (
            // or somebody to the left, something?
            m
          )
        ); I; ) {
          for (var V = 0, M = w; V < M.length; V++) {
            var L = M[V];
            if (I != null && I.contains(L.node))
              return L.node;
          }
          I = I.nextElementSibling;
        }
        if (w.length)
          return w[0].node;
      }
    }
}, UC = function(e) {
  var t = N$(e);
  return function() {
    return Z$(t);
  };
}, $$ = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = ms(t);
  if (r.every(function(a) {
    return !cs(a, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? P3(r, /* @__PURE__ */ new Map()) : dl(r, /* @__PURE__ */ new Map()), i = o.findIndex(function(a) {
    var u = a.node;
    return u === e;
  });
  if (i !== -1)
    return {
      prev: o[i - 1],
      next: o[i + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, z$ = function(e, t) {
  var n = t ? P3(ms(e), /* @__PURE__ */ new Map()) : dl(ms(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, W$ = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, YC = function(e, t, n) {
  t === void 0 && (t = {});
  var r = W$(t), o = $$(e, r.scope, r.onlyTabbable);
  if (o) {
    var i = n(o, r.cycle);
    i && _3(i.node, r.focusOptions);
  }
}, G$ = function(e, t) {
  t === void 0 && (t = {}), YC(e, t, function(n, r) {
    var o = n.next, i = n.first;
    return o || r && i;
  });
}, j$ = function(e, t) {
  t === void 0 && (t = {}), YC(e, t, function(n, r) {
    var o = n.prev, i = n.last;
    return o || r && i;
  });
}, JC = function(e, t, n) {
  var r, o = z$(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), i = o[n];
  i && _3(i.node, t.focusOptions);
}, X$ = function(e, t) {
  t === void 0 && (t = {}), JC(e, t, "first");
}, U$ = function(e, t) {
  t === void 0 && (t = {}), JC(e, t, "last");
};
function T3(e) {
  setTimeout(e, 1);
}
var Y$ = function(t) {
  return t && "current" in t ? t.current : t;
}, qC = function() {
  return document && document.activeElement === document.body;
}, J$ = function() {
  return qC() || _$();
}, wa = null, Xn = null, M8 = function() {
  return null;
}, Ia = null, hl = !1, H3 = !1, q$ = function() {
  return !0;
}, K$ = function(t) {
  return (wa.whiteList || q$)(t);
}, Q$ = function(t, n) {
  Ia = {
    observerNode: t,
    portaledElement: n
  };
}, ez = function(t) {
  return Ia && Ia.portaledElement === t;
};
function P8(e, t, n, r) {
  var o = null, i = e;
  do {
    var a = r[i];
    if (a.guard)
      a.node.dataset.focusAutoGuard && (o = a);
    else if (a.lockItem) {
      if (i !== e)
        return;
      o = null;
    } else
      break;
  } while ((i += n) !== t);
  o && (o.node.tabIndex = 0);
}
var tz = function(t) {
  return t ? !!hl : hl === "meanwhile";
}, nz = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, rz = function(t, n) {
  return n.some(function(r) {
    return nz(t, r, r);
  });
}, KC = function(t) {
  return dl(t, /* @__PURE__ */ new Map());
}, oz = function(t) {
  return !KC([t.parentNode]).some(function(n) {
    return n.node === t;
  });
}, Jc = function() {
  var t = !1;
  if (wa) {
    var n = wa, r = n.observed, o = n.persistentFocus, i = n.autoFocus, a = n.shards, u = n.crossFrame, c = n.focusOptions, d = n.noFocusGuards, f = r || Ia && Ia.portaledElement;
    if (qC() && Xn && Xn !== document.body && (!document.body.contains(Xn) || oz(Xn))) {
      var p = M8();
      p && p.focus();
    }
    var g = document && document.activeElement;
    if (f) {
      var m = [f].concat(a.map(Y$).filter(Boolean)), b = function() {
        if (!tz(u) || !d || !Xn || H3)
          return !1;
        var V = KC(m), M = V.findIndex(function(L) {
          var R = L.node;
          return R === Xn;
        });
        return M === 0 || M === V.length - 1;
      };
      if ((!g || K$(g)) && (o || b() || !J$() || !Xn && i) && (f && !(GC(m) || g && rz(g, m) || ez(g)) && (document && !Xn && g && !i ? (g.blur && g.blur(), document.body.focus()) : (t = XC(m, Xn, {
        focusOptions: c
      }), Ia = {})), Xn = document && document.activeElement, Xn !== document.body && (M8 = UC(Xn)), hl = !1), document && g !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var v = document && document.activeElement, y = O$(m), w = y.map(function(I) {
          var V = I.node;
          return V;
        }).indexOf(v);
        w > -1 && (y.filter(function(I) {
          var V = I.guard, M = I.node;
          return V && M.dataset.focusAutoGuard;
        }).forEach(function(I) {
          var V = I.node;
          return V.removeAttribute("tabIndex");
        }), P8(w, y.length, 1, y), P8(w, -1, -1, y));
      }
    }
  }
  return t;
}, QC = function(t) {
  Jc() && t && (t.stopPropagation(), t.preventDefault());
}, F3 = function() {
  return T3(Jc);
}, iz = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || Q$(r, n);
}, sz = function() {
  return null;
};
process.env.NODE_ENV !== "production" && SC.node.isRequired;
var ev = function() {
  H3 = !0;
}, tv = function() {
  H3 = !1, hl = "just", T3(function() {
    hl = "meanwhile";
  });
}, az = function() {
  document.addEventListener("focusin", QC), document.addEventListener("focusout", F3), window.addEventListener("focus", ev), window.addEventListener("blur", tv);
}, lz = function() {
  document.removeEventListener("focusin", QC), document.removeEventListener("focusout", F3), window.removeEventListener("focus", ev), window.removeEventListener("blur", tv);
};
function uz(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var nv = {
  moveFocusInside: XC,
  focusInside: GC,
  focusNextElement: G$,
  focusPrevElement: j$,
  focusFirstElement: X$,
  focusLastElement: U$,
  captureFocusRestore: UC
};
function cz(e) {
  var t = e.slice(-1)[0];
  t && !wa && az();
  var n = wa, r = n && t && t.id === n.id;
  wa = t, n && !r && (n.onDeactivation(), e.filter(function(o) {
    var i = o.id;
    return i === n.id;
  }).length || n.returnFocus(!t)), t ? (Xn = null, (!r || n.observed !== t.observed) && t.onActivation(nv), Jc(), T3(Jc)) : (lz(), Xn = null);
}
EC.assignSyncMedium(iz);
RC.assignMedium(F3);
s$.assignMedium(function(e) {
  return e(nv);
});
const dz = f$(uz, cz)(sz);
var rv = /* @__PURE__ */ Fe(function(t, n) {
  return /* @__PURE__ */ Bn.createElement(TC, Te({
    sideCar: dz,
    ref: n
  }, t));
}), ov = TC.propTypes || {};
ov.sideCar;
var fz = bC(ov, ["sideCar"]);
rv.propTypes = process.env.NODE_ENV !== "production" ? fz : {};
const E8 = rv, hz = E8.default ?? E8, iv = (e) => {
  const {
    initialFocusRef: t,
    finalFocusRef: n,
    contentRef: r,
    restoreFocus: o,
    children: i,
    isDisabled: a,
    autoFocus: u,
    persistentFocus: c,
    lockFocusAcrossFrames: d
  } = e, f = q(() => {
    t != null && t.current ? t.current.focus() : r != null && r.current && OL(r.current).length === 0 && requestAnimationFrame(() => {
      var b;
      (b = r.current) == null || b.focus();
    });
  }, [t, r]), p = q(() => {
    var m;
    (m = n == null ? void 0 : n.current) == null || m.focus();
  }, [n]), g = o && !n;
  return /* @__PURE__ */ x.jsx(
    hz,
    {
      crossFrame: d,
      persistentFocus: c,
      autoFocus: u,
      disabled: a,
      onActivation: f,
      onDeactivation: p,
      returnFocus: g,
      children: i
    }
  );
};
iv.displayName = "FocusLock";
const [pz, gz] = Bt({
  name: "FormErrorStylesContext",
  errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
}), sv = Pe(
  (e, t) => {
    const n = Rn("FormError", e), r = rn(e), o = ws();
    return o != null && o.isInvalid ? /* @__PURE__ */ x.jsx(pz, { value: n, children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...o == null ? void 0 : o.getErrorMessageProps(r, t),
        className: _e("chakra-form__error-message", e.className),
        __css: {
          display: "flex",
          alignItems: "center",
          ...n.text
        }
      }
    ) }) : null;
  }
);
sv.displayName = "FormErrorMessage";
const mz = Pe((e, t) => {
  const n = gz(), r = ws();
  if (!(r != null && r.isInvalid))
    return null;
  const o = _e("chakra-form__error-icon", e.className);
  return /* @__PURE__ */ x.jsx(
    Ko,
    {
      ref: t,
      "aria-hidden": !0,
      ...e,
      __css: n.icon,
      className: o,
      children: /* @__PURE__ */ x.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        }
      )
    }
  );
});
mz.displayName = "FormErrorIcon";
const av = Pe(
  function(t, n) {
    const r = Ss("FormLabel", t), o = rn(t), {
      className: i,
      children: a,
      requiredIndicator: u = /* @__PURE__ */ x.jsx(lv, {}),
      optionalIndicator: c = null,
      ...d
    } = o, f = ws(), p = (f == null ? void 0 : f.getLabelProps(d, n)) ?? { ref: n, ...d };
    return /* @__PURE__ */ x.jsxs(
      ye.label,
      {
        ...p,
        className: _e("chakra-form__label", o.className),
        __css: {
          display: "block",
          textAlign: "start",
          ...r
        },
        children: [
          a,
          f != null && f.isRequired ? u : c
        ]
      }
    );
  }
);
av.displayName = "FormLabel";
const lv = Pe(
  function(t, n) {
    const r = ws(), o = fC();
    if (!(r != null && r.isRequired))
      return null;
    const i = _e("chakra-form__required-indicator", t.className);
    return /* @__PURE__ */ x.jsx(
      ye.span,
      {
        ...r == null ? void 0 : r.getRequiredIndicatorProps(t, n),
        __css: o.requiredIndicator,
        className: i
      }
    );
  }
);
lv.displayName = "RequiredIndicator";
const er = Pe(
  function(t, n) {
    const { htmlSize: r, ...o } = t, i = Rn("Input", o), a = rn(o), u = y3(a), c = _e("chakra-input", t.className);
    return /* @__PURE__ */ x.jsx(
      ye.input,
      {
        size: r,
        ...u,
        __css: i.field,
        ref: n,
        className: c
      }
    );
  }
);
er.displayName = "Input";
er.id = "Input";
const [Cz, uv] = Bt({
  name: "InputGroupStylesContext",
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
}), k3 = Pe(
  function(t, n) {
    const r = Rn("Input", t), { children: o, className: i, ...a } = rn(t), u = _e("chakra-input__group", i), c = {}, d = Bp(o), f = r.field;
    d.forEach((g) => {
      r && (f && g.type.id === "InputLeftElement" && (c.paddingStart = f.height ?? f.h), f && g.type.id === "InputRightElement" && (c.paddingEnd = f.height ?? f.h), g.type.id === "InputRightAddon" && (c.borderEndRadius = 0), g.type.id === "InputLeftAddon" && (c.borderStartRadius = 0));
    });
    const p = d.map((g) => {
      var b, v;
      const m = Tf({
        size: ((b = g.props) == null ? void 0 : b.size) || t.size,
        variant: ((v = g.props) == null ? void 0 : v.variant) || t.variant
      });
      return g.type.id !== "Input" ? bo(g, m) : bo(g, Object.assign(m, c, g.props));
    });
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        className: u,
        ref: n,
        __css: {
          width: "100%",
          display: "flex",
          position: "relative",
          // Parts of inputs override z-index to ensure that they stack correctly on each other
          // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
          isolation: "isolate",
          ...r.group
        },
        "data-group": !0,
        ...a,
        children: /* @__PURE__ */ x.jsx(Cz, { value: r, children: p })
      }
    );
  }
);
k3.displayName = "InputGroup";
const vz = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
}, bz = ye("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
}), B3 = Pe(
  function(t, n) {
    const { placement: r = "left", ...o } = t, i = vz[r] ?? {}, a = uv();
    return /* @__PURE__ */ x.jsx(
      bz,
      {
        ref: n,
        ...o,
        __css: {
          ...a.addon,
          ...i
        }
      }
    );
  }
);
B3.displayName = "InputAddon";
const D3 = Pe(
  function(t, n) {
    return /* @__PURE__ */ x.jsx(
      B3,
      {
        ref: n,
        placement: "left",
        ...t,
        className: _e("chakra-input__left-addon", t.className)
      }
    );
  }
);
D3.displayName = "InputLeftAddon";
D3.id = "InputLeftAddon";
const O3 = Pe(
  function(t, n) {
    return /* @__PURE__ */ x.jsx(
      B3,
      {
        ref: n,
        placement: "right",
        ...t,
        className: _e("chakra-input__right-addon", t.className)
      }
    );
  }
);
O3.displayName = "InputRightAddon";
O3.id = "InputRightAddon";
const yz = ye("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), M2 = Pe(
  function(t, n) {
    const { placement: r = "left", ...o } = t, i = uv(), a = i.field, c = {
      [r === "left" ? "insetStart" : "insetEnd"]: "0",
      width: (a == null ? void 0 : a.height) ?? (a == null ? void 0 : a.h),
      height: (a == null ? void 0 : a.height) ?? (a == null ? void 0 : a.h),
      fontSize: a == null ? void 0 : a.fontSize,
      ...i.element
    };
    return /* @__PURE__ */ x.jsx(yz, { ref: n, __css: c, ...o });
  }
);
M2.id = "InputElement";
M2.displayName = "InputElement";
const N3 = Pe(
  function(t, n) {
    const { className: r, ...o } = t, i = _e("chakra-input__left-element", r);
    return /* @__PURE__ */ x.jsx(
      M2,
      {
        ref: n,
        placement: "left",
        className: i,
        ...o
      }
    );
  }
);
N3.id = "InputLeftElement";
N3.displayName = "InputLeftElement";
const Z3 = Pe(
  function(t, n) {
    const { className: r, ...o } = t, i = _e("chakra-input__right-element", r);
    return /* @__PURE__ */ x.jsx(
      M2,
      {
        ref: n,
        placement: "right",
        className: i,
        ...o
      }
    );
  }
);
Z3.id = "InputRightElement";
Z3.displayName = "InputRightElement";
const Q5 = Pe(function(t, n) {
  const r = Ss("Link", t), { className: o, isExternal: i, ...a } = rn(t);
  return /* @__PURE__ */ x.jsx(
    ye.a,
    {
      target: i ? "_blank" : void 0,
      rel: i ? "noopener" : void 0,
      ref: n,
      className: _e("chakra-link", o),
      ...a,
      __css: r
    }
  );
});
Q5.displayName = "Link";
function xz(e, t, n, r) {
  if (t == null)
    return r;
  if (!r)
    return e.find(
      (a) => n(a).toLowerCase().startsWith(t.toLowerCase())
    );
  const o = e.filter(
    (i) => n(i).toLowerCase().startsWith(t.toLowerCase())
  );
  if (o.length > 0) {
    let i;
    return o.includes(r) ? (i = o.indexOf(r) + 1, i === o.length && (i = 0), o[i]) : (i = e.indexOf(o[0]), e[i]);
  }
  return r;
}
function Sz(e) {
  const { key: t } = e;
  return t.length === 1 || t.length > 1 && /[^a-zA-Z0-9]/.test(t);
}
function wz(e = {}) {
  const { timeout: t = 300, preventDefault: n = () => !0 } = e, [r, o] = Ee([]), i = Le(void 0), a = () => {
    i.current && (clearTimeout(i.current), i.current = null);
  }, u = () => {
    a(), i.current = setTimeout(() => {
      o([]), i.current = null;
    }, t);
  };
  Ue(() => a, []);
  function c(d) {
    return (f) => {
      if (f.key === "Backspace") {
        const p = [...r];
        p.pop(), o(p);
        return;
      }
      if (Sz(f)) {
        const p = r.concat(f.key);
        n(f) && (f.preventDefault(), f.stopPropagation()), o(p), d(p.join("")), u();
      }
    };
  }
  return c;
}
var Jn = "top", Br = "bottom", Dr = "right", qn = "left", $3 = "auto", Ll = [Jn, Br, Dr, qn], Ra = "start", pl = "end", Iz = "clippingParents", cv = "viewport", A1 = "popper", Vz = "reference", R8 = /* @__PURE__ */ Ll.reduce(function(e, t) {
  return e.concat([t + "-" + Ra, t + "-" + pl]);
}, []), dv = /* @__PURE__ */ [].concat(Ll, [$3]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ra, t + "-" + pl]);
}, []), Az = "beforeRead", Lz = "read", Mz = "afterRead", Pz = "beforeMain", Ez = "main", Rz = "afterMain", _z = "beforeWrite", Tz = "write", Hz = "afterWrite", Fz = [Az, Lz, Mz, Pz, Ez, Rz, _z, Tz, Hz];
function yo(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function pr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Cs(e) {
  var t = pr(e).Element;
  return e instanceof t || e instanceof Element;
}
function Hr(e) {
  var t = pr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function z3(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = pr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function kz(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Hr(i) || !yo(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var u = o[a];
      u === !1 ? i.removeAttribute(a) : i.setAttribute(a, u === !0 ? "" : u);
    }));
  });
}
function Bz(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), u = a.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !Hr(o) || !yo(o) || (Object.assign(o.style, u), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const Dz = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: kz,
  effect: Bz,
  requires: ["computeStyles"]
};
function vo(e) {
  return e.split("-")[0];
}
var ds = Math.max, qc = Math.min, _a = Math.round;
function ef() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function fv() {
  return !/^((?!chrome|android).)*safari/i.test(ef());
}
function Ta(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Hr(e) && (o = e.offsetWidth > 0 && _a(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && _a(r.height) / e.offsetHeight || 1);
  var a = Cs(e) ? pr(e) : window, u = a.visualViewport, c = !fv() && n, d = (r.left + (c && u ? u.offsetLeft : 0)) / o, f = (r.top + (c && u ? u.offsetTop : 0)) / i, p = r.width / o, g = r.height / i;
  return {
    width: p,
    height: g,
    top: f,
    right: d + p,
    bottom: f + g,
    left: d,
    x: d,
    y: f
  };
}
function W3(e) {
  var t = Ta(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function hv(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && z3(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function qo(e) {
  return pr(e).getComputedStyle(e);
}
function Oz(e) {
  return ["table", "td", "th"].indexOf(yo(e)) >= 0;
}
function _i(e) {
  return ((Cs(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function P2(e) {
  return yo(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (z3(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    _i(e)
  );
}
function _8(e) {
  return !Hr(e) || // https://github.com/popperjs/popper-core/issues/837
  qo(e).position === "fixed" ? null : e.offsetParent;
}
function Nz(e) {
  var t = /firefox/i.test(ef()), n = /Trident/i.test(ef());
  if (n && Hr(e)) {
    var r = qo(e);
    if (r.position === "fixed")
      return null;
  }
  var o = P2(e);
  for (z3(o) && (o = o.host); Hr(o) && ["html", "body"].indexOf(yo(o)) < 0; ) {
    var i = qo(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Ml(e) {
  for (var t = pr(e), n = _8(e); n && Oz(n) && qo(n).position === "static"; )
    n = _8(n);
  return n && (yo(n) === "html" || yo(n) === "body" && qo(n).position === "static") ? t : n || Nz(e) || t;
}
function G3(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function K1(e, t, n) {
  return ds(e, qc(t, n));
}
function Zz(e, t, n) {
  var r = K1(e, t, n);
  return r > n ? n : r;
}
function pv() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function gv(e) {
  return Object.assign({}, pv(), e);
}
function mv(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var $z = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, gv(typeof t != "number" ? t : mv(t, Ll));
};
function zz(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, u = vo(n.placement), c = G3(u), d = [qn, Dr].indexOf(u) >= 0, f = d ? "height" : "width";
  if (!(!i || !a)) {
    var p = $z(o.padding, n), g = W3(i), m = c === "y" ? Jn : qn, b = c === "y" ? Br : Dr, v = n.rects.reference[f] + n.rects.reference[c] - a[c] - n.rects.popper[f], y = a[c] - n.rects.reference[c], w = Ml(i), I = w ? c === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, V = v / 2 - y / 2, M = p[m], L = I - g[f] - p[b], R = I / 2 - g[f] / 2 + V, _ = K1(M, R, L), H = c;
    n.modifiersData[r] = (t = {}, t[H] = _, t.centerOffset = _ - R, t);
  }
}
function Wz(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || hv(t.elements.popper, o) && (t.elements.arrow = o));
}
const Gz = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: zz,
  effect: Wz,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ha(e) {
  return e.split("-")[1];
}
var jz = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Xz(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: _a(n * o) / o || 0,
    y: _a(r * o) / o || 0
  };
}
function T8(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, u = e.position, c = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, p = e.isFixed, g = a.x, m = g === void 0 ? 0 : g, b = a.y, v = b === void 0 ? 0 : b, y = typeof f == "function" ? f({
    x: m,
    y: v
  }) : {
    x: m,
    y: v
  };
  m = y.x, v = y.y;
  var w = a.hasOwnProperty("x"), I = a.hasOwnProperty("y"), V = qn, M = Jn, L = window;
  if (d) {
    var R = Ml(n), _ = "clientHeight", H = "clientWidth";
    if (R === pr(n) && (R = _i(n), qo(R).position !== "static" && u === "absolute" && (_ = "scrollHeight", H = "scrollWidth")), R = R, o === Jn || (o === qn || o === Dr) && i === pl) {
      M = Br;
      var B = p && R === L && L.visualViewport ? L.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        R[_]
      );
      v -= B - r.height, v *= c ? 1 : -1;
    }
    if (o === qn || (o === Jn || o === Br) && i === pl) {
      V = Dr;
      var Z = p && R === L && L.visualViewport ? L.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        R[H]
      );
      m -= Z - r.width, m *= c ? 1 : -1;
    }
  }
  var G = Object.assign({
    position: u
  }, d && jz), se = f === !0 ? Xz({
    x: m,
    y: v
  }, pr(n)) : {
    x: m,
    y: v
  };
  if (m = se.x, v = se.y, c) {
    var ue;
    return Object.assign({}, G, (ue = {}, ue[M] = I ? "0" : "", ue[V] = w ? "0" : "", ue.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + v + "px)" : "translate3d(" + m + "px, " + v + "px, 0)", ue));
  }
  return Object.assign({}, G, (t = {}, t[M] = I ? v + "px" : "", t[V] = w ? m + "px" : "", t.transform = "", t));
}
function Uz(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, u = n.roundOffsets, c = u === void 0 ? !0 : u, d = {
    placement: vo(t.placement),
    variation: Ha(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, T8(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, T8(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Yz = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Uz,
  data: {}
};
var oc = {
  passive: !0
};
function Jz(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, u = a === void 0 ? !0 : a, c = pr(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && d.forEach(function(f) {
    f.addEventListener("scroll", n.update, oc);
  }), u && c.addEventListener("resize", n.update, oc), function() {
    i && d.forEach(function(f) {
      f.removeEventListener("scroll", n.update, oc);
    }), u && c.removeEventListener("resize", n.update, oc);
  };
}
const qz = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Jz,
  data: {}
};
var Kz = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Rc(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Kz[t];
  });
}
var Qz = {
  start: "end",
  end: "start"
};
function H8(e) {
  return e.replace(/start|end/g, function(t) {
    return Qz[t];
  });
}
function j3(e) {
  var t = pr(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function X3(e) {
  return Ta(_i(e)).left + j3(e).scrollLeft;
}
function eW(e, t) {
  var n = pr(e), r = _i(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, u = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var d = fv();
    (d || !d && t === "fixed") && (u = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: u + X3(e),
    y: c
  };
}
function tW(e) {
  var t, n = _i(e), r = j3(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = ds(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = ds(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), u = -r.scrollLeft + X3(e), c = -r.scrollTop;
  return qo(o || n).direction === "rtl" && (u += ds(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: u,
    y: c
  };
}
function U3(e) {
  var t = qo(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Cv(e) {
  return ["html", "body", "#document"].indexOf(yo(e)) >= 0 ? e.ownerDocument.body : Hr(e) && U3(e) ? e : Cv(P2(e));
}
function Q1(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Cv(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = pr(r), a = o ? [i].concat(i.visualViewport || [], U3(r) ? r : []) : r, u = t.concat(a);
  return o ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(Q1(P2(a)))
  );
}
function tf(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function nW(e, t) {
  var n = Ta(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function F8(e, t, n) {
  return t === cv ? tf(eW(e, n)) : Cs(t) ? nW(t, n) : tf(tW(_i(e)));
}
function rW(e) {
  var t = Q1(P2(e)), n = ["absolute", "fixed"].indexOf(qo(e).position) >= 0, r = n && Hr(e) ? Ml(e) : e;
  return Cs(r) ? t.filter(function(o) {
    return Cs(o) && hv(o, r) && yo(o) !== "body";
  }) : [];
}
function oW(e, t, n, r) {
  var o = t === "clippingParents" ? rW(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], u = i.reduce(function(c, d) {
    var f = F8(e, d, r);
    return c.top = ds(f.top, c.top), c.right = qc(f.right, c.right), c.bottom = qc(f.bottom, c.bottom), c.left = ds(f.left, c.left), c;
  }, F8(e, a, r));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function vv(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? vo(r) : null, i = r ? Ha(r) : null, a = t.x + t.width / 2 - n.width / 2, u = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Jn:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Br:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Dr:
      c = {
        x: t.x + t.width,
        y: u
      };
      break;
    case qn:
      c = {
        x: t.x - n.width,
        y: u
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? G3(o) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (i) {
      case Ra:
        c[d] = c[d] - (t[f] / 2 - n[f] / 2);
        break;
      case pl:
        c[d] = c[d] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return c;
}
function gl(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, u = n.boundary, c = u === void 0 ? Iz : u, d = n.rootBoundary, f = d === void 0 ? cv : d, p = n.elementContext, g = p === void 0 ? A1 : p, m = n.altBoundary, b = m === void 0 ? !1 : m, v = n.padding, y = v === void 0 ? 0 : v, w = gv(typeof y != "number" ? y : mv(y, Ll)), I = g === A1 ? Vz : A1, V = e.rects.popper, M = e.elements[b ? I : g], L = oW(Cs(M) ? M : M.contextElement || _i(e.elements.popper), c, f, a), R = Ta(e.elements.reference), _ = vv({
    reference: R,
    element: V,
    strategy: "absolute",
    placement: o
  }), H = tf(Object.assign({}, V, _)), B = g === A1 ? H : R, Z = {
    top: L.top - B.top + w.top,
    bottom: B.bottom - L.bottom + w.bottom,
    left: L.left - B.left + w.left,
    right: B.right - L.right + w.right
  }, G = e.modifiersData.offset;
  if (g === A1 && G) {
    var se = G[o];
    Object.keys(Z).forEach(function(ue) {
      var ce = [Dr, Br].indexOf(ue) >= 0 ? 1 : -1, xe = [Jn, Br].indexOf(ue) >= 0 ? "y" : "x";
      Z[ue] += se[xe] * ce;
    });
  }
  return Z;
}
function iW(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, u = n.flipVariations, c = n.allowedAutoPlacements, d = c === void 0 ? dv : c, f = Ha(r), p = f ? u ? R8 : R8.filter(function(b) {
    return Ha(b) === f;
  }) : Ll, g = p.filter(function(b) {
    return d.indexOf(b) >= 0;
  });
  g.length === 0 && (g = p);
  var m = g.reduce(function(b, v) {
    return b[v] = gl(e, {
      placement: v,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[vo(v)], b;
  }, {});
  return Object.keys(m).sort(function(b, v) {
    return m[b] - m[v];
  });
}
function sW(e) {
  if (vo(e) === $3)
    return [];
  var t = Rc(e);
  return [H8(e), t, H8(t)];
}
function aW(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, u = a === void 0 ? !0 : a, c = n.fallbackPlacements, d = n.padding, f = n.boundary, p = n.rootBoundary, g = n.altBoundary, m = n.flipVariations, b = m === void 0 ? !0 : m, v = n.allowedAutoPlacements, y = t.options.placement, w = vo(y), I = w === y, V = c || (I || !b ? [Rc(y)] : sW(y)), M = [y].concat(V).reduce(function(re, te) {
      return re.concat(vo(te) === $3 ? iW(t, {
        placement: te,
        boundary: f,
        rootBoundary: p,
        padding: d,
        flipVariations: b,
        allowedAutoPlacements: v
      }) : te);
    }, []), L = t.rects.reference, R = t.rects.popper, _ = /* @__PURE__ */ new Map(), H = !0, B = M[0], Z = 0; Z < M.length; Z++) {
      var G = M[Z], se = vo(G), ue = Ha(G) === Ra, ce = [Jn, Br].indexOf(se) >= 0, xe = ce ? "width" : "height", he = gl(t, {
        placement: G,
        boundary: f,
        rootBoundary: p,
        altBoundary: g,
        padding: d
      }), z = ce ? ue ? Dr : qn : ue ? Br : Jn;
      L[xe] > R[xe] && (z = Rc(z));
      var Y = Rc(z), ae = [];
      if (i && ae.push(he[se] <= 0), u && ae.push(he[z] <= 0, he[Y] <= 0), ae.every(function(re) {
        return re;
      })) {
        B = G, H = !1;
        break;
      }
      _.set(G, ae);
    }
    if (H)
      for (var j = b ? 3 : 1, X = function(te) {
        var ee = M.find(function(ge) {
          var pe = _.get(ge);
          if (pe)
            return pe.slice(0, te).every(function(Se) {
              return Se;
            });
        });
        if (ee)
          return B = ee, "break";
      }, ie = j; ie > 0; ie--) {
        var W = X(ie);
        if (W === "break")
          break;
      }
    t.placement !== B && (t.modifiersData[r]._skip = !0, t.placement = B, t.reset = !0);
  }
}
const lW = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: aW,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function k8(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function B8(e) {
  return [Jn, Dr, Br, qn].some(function(t) {
    return e[t] >= 0;
  });
}
function uW(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = gl(t, {
    elementContext: "reference"
  }), u = gl(t, {
    altBoundary: !0
  }), c = k8(a, r), d = k8(u, o, i), f = B8(c), p = B8(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": p
  });
}
const cW = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: uW
};
function dW(e, t, n) {
  var r = vo(e), o = [qn, Jn].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], u = i[1];
  return a = a || 0, u = (u || 0) * o, [qn, Dr].indexOf(r) >= 0 ? {
    x: u,
    y: a
  } : {
    x: a,
    y: u
  };
}
function fW(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = dv.reduce(function(f, p) {
    return f[p] = dW(p, t.rects, i), f;
  }, {}), u = a[t.placement], c = u.x, d = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += d), t.modifiersData[r] = a;
}
const hW = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: fW
};
function pW(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = vv({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const gW = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: pW,
  data: {}
};
function mW(e) {
  return e === "x" ? "y" : "x";
}
function CW(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, u = a === void 0 ? !1 : a, c = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.padding, g = n.tether, m = g === void 0 ? !0 : g, b = n.tetherOffset, v = b === void 0 ? 0 : b, y = gl(t, {
    boundary: c,
    rootBoundary: d,
    padding: p,
    altBoundary: f
  }), w = vo(t.placement), I = Ha(t.placement), V = !I, M = G3(w), L = mW(M), R = t.modifiersData.popperOffsets, _ = t.rects.reference, H = t.rects.popper, B = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, Z = typeof B == "number" ? {
    mainAxis: B,
    altAxis: B
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, B), G = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, se = {
    x: 0,
    y: 0
  };
  if (R) {
    if (i) {
      var ue, ce = M === "y" ? Jn : qn, xe = M === "y" ? Br : Dr, he = M === "y" ? "height" : "width", z = R[M], Y = z + y[ce], ae = z - y[xe], j = m ? -H[he] / 2 : 0, X = I === Ra ? _[he] : H[he], ie = I === Ra ? -H[he] : -_[he], W = t.elements.arrow, re = m && W ? W3(W) : {
        width: 0,
        height: 0
      }, te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : pv(), ee = te[ce], ge = te[xe], pe = K1(0, _[he], re[he]), Se = V ? _[he] / 2 - j - pe - ee - Z.mainAxis : X - pe - ee - Z.mainAxis, de = V ? -_[he] / 2 + j + pe + ge + Z.mainAxis : ie + pe + ge + Z.mainAxis, Ve = t.elements.arrow && Ml(t.elements.arrow), K = Ve ? M === "y" ? Ve.clientTop || 0 : Ve.clientLeft || 0 : 0, Ye = (ue = G == null ? void 0 : G[M]) != null ? ue : 0, ve = z + Se - Ye - K, ot = z + de - Ye, Mt = K1(m ? qc(Y, ve) : Y, z, m ? ds(ae, ot) : ae);
      R[M] = Mt, se[M] = Mt - z;
    }
    if (u) {
      var ft, un = M === "x" ? Jn : qn, on = M === "x" ? Br : Dr, Ct = R[L], Pt = L === "y" ? "height" : "width", jt = Ct + y[un], Xt = Ct - y[on], tr = [Jn, qn].indexOf(w) !== -1, An = (ft = G == null ? void 0 : G[L]) != null ? ft : 0, $r = tr ? jt : Ct - _[Pt] - H[Pt] - An + Z.altAxis, vn = tr ? Ct + _[Pt] + H[Pt] - An - Z.altAxis : Xt, me = m && tr ? Zz($r, Ct, vn) : K1(m ? $r : jt, Ct, m ? vn : Xt);
      R[L] = me, se[L] = me - Ct;
    }
    t.modifiersData[r] = se;
  }
}
const vW = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: CW,
  requiresIfExists: ["offset"]
};
function bW(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function yW(e) {
  return e === pr(e) || !Hr(e) ? j3(e) : bW(e);
}
function xW(e) {
  var t = e.getBoundingClientRect(), n = _a(t.width) / e.offsetWidth || 1, r = _a(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function SW(e, t, n) {
  n === void 0 && (n = !1);
  var r = Hr(t), o = Hr(t) && xW(t), i = _i(t), a = Ta(e, o, n), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((yo(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  U3(i)) && (u = yW(t)), Hr(t) ? (c = Ta(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = X3(i))), {
    x: a.left + u.scrollLeft - c.x,
    y: a.top + u.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function wW(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(u) {
      if (!n.has(u)) {
        var c = t.get(u);
        c && o(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function IW(e) {
  var t = wW(e);
  return Fz.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function VW(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function AW(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var D8 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function O8() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function LW(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? D8 : o;
  return function(u, c, d) {
    d === void 0 && (d = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, D8, i),
      modifiersData: {},
      elements: {
        reference: u,
        popper: c
      },
      attributes: {},
      styles: {}
    }, p = [], g = !1, m = {
      state: f,
      setOptions: function(w) {
        var I = typeof w == "function" ? w(f.options) : w;
        v(), f.options = Object.assign({}, i, f.options, I), f.scrollParents = {
          reference: Cs(u) ? Q1(u) : u.contextElement ? Q1(u.contextElement) : [],
          popper: Q1(c)
        };
        var V = IW(AW([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = V.filter(function(M) {
          return M.enabled;
        }), b(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var w = f.elements, I = w.reference, V = w.popper;
          if (O8(I, V)) {
            f.rects = {
              reference: SW(I, Ml(V), f.options.strategy === "fixed"),
              popper: W3(V)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(Z) {
              return f.modifiersData[Z.name] = Object.assign({}, Z.data);
            });
            for (var M = 0; M < f.orderedModifiers.length; M++) {
              if (f.reset === !0) {
                f.reset = !1, M = -1;
                continue;
              }
              var L = f.orderedModifiers[M], R = L.fn, _ = L.options, H = _ === void 0 ? {} : _, B = L.name;
              typeof R == "function" && (f = R({
                state: f,
                options: H,
                name: B,
                instance: m
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: VW(function() {
        return new Promise(function(y) {
          m.forceUpdate(), y(f);
        });
      }),
      destroy: function() {
        v(), g = !0;
      }
    };
    if (!O8(u, c))
      return m;
    m.setOptions(d).then(function(y) {
      !g && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function b() {
      f.orderedModifiers.forEach(function(y) {
        var w = y.name, I = y.options, V = I === void 0 ? {} : I, M = y.effect;
        if (typeof M == "function") {
          var L = M({
            state: f,
            name: w,
            instance: m,
            options: V
          }), R = function() {
          };
          p.push(L || R);
        }
      });
    }
    function v() {
      p.forEach(function(y) {
        return y();
      }), p = [];
    }
    return m;
  };
}
var MW = [qz, gW, Yz, Dz, hW, lW, vW, Gz, cW], PW = /* @__PURE__ */ LW({
  defaultModifiers: MW
});
const ta = (e, t) => ({
  var: e,
  varRef: t ? `var(${e}, ${t})` : `var(${e})`
}), In = {
  arrowShadowColor: ta("--popper-arrow-shadow-color"),
  arrowSize: ta("--popper-arrow-size", "8px"),
  arrowSizeHalf: ta("--popper-arrow-size-half"),
  arrowBg: ta("--popper-arrow-bg"),
  transformOrigin: ta("--popper-transform-origin"),
  arrowOffset: ta("--popper-arrow-offset")
};
function EW(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
const RW = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, _W = (e) => RW[e], N8 = {
  scroll: !0,
  resize: !0
};
function TW(e) {
  let t;
  return typeof e == "object" ? t = {
    enabled: !0,
    options: { ...N8, ...e }
  } : t = {
    enabled: e,
    options: N8
  }, t;
}
const HW = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const t = e.elements.reference;
    e.elements.popper.style.width = `${t.offsetWidth}px`;
  }
}, FW = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    Z8(e);
  },
  effect: ({ state: e }) => () => {
    Z8(e);
  }
}, Z8 = (e) => {
  e.elements.popper.style.setProperty(
    In.transformOrigin.var,
    _W(e.placement)
  );
}, kW = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    BW(e);
  }
}, BW = (e) => {
  var n;
  if (!e.placement)
    return;
  const t = DW(e.placement);
  if ((n = e.elements) != null && n.arrow && t) {
    Object.assign(e.elements.arrow.style, {
      [t.property]: t.value,
      width: In.arrowSize.varRef,
      height: In.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [In.arrowSizeHalf.var]: `calc(${In.arrowSize.varRef} / 2 - 1px)`,
      [In.arrowOffset.var]: `calc(${In.arrowSizeHalf.varRef} * -1)`
    };
    for (const o in r)
      e.elements.arrow.style.setProperty(o, r[o]);
  }
}, DW = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: In.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: In.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: In.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: In.arrowOffset.varRef };
}, OW = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    $8(e);
  },
  effect: ({ state: e }) => () => {
    $8(e);
  }
}, $8 = (e) => {
  if (!e.elements.arrow)
    return;
  const t = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!t)
    return;
  const n = EW(e.placement);
  n && t.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(t.style, {
    transform: "rotate(45deg)",
    background: In.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, NW = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, ZW = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function $W(e, t = "ltr") {
  var r;
  const n = ((r = NW[e]) == null ? void 0 : r[t]) || e;
  return t === "ltr" ? n : ZW[e] ?? n;
}
function bv(e = {}) {
  const {
    enabled: t = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: o = "absolute",
    arrowPadding: i = 8,
    eventListeners: a = !0,
    offset: u,
    gutter: c = 8,
    flip: d = !0,
    boundary: f = "clippingParents",
    preventOverflow: p = !0,
    matchWidth: g,
    direction: m = "ltr"
  } = e, b = Le(null), v = Le(null), y = Le(null), w = $W(r, m), I = Le(() => {
  }), V = q(() => {
    var Z;
    !t || !b.current || !v.current || ((Z = I.current) == null || Z.call(I), y.current = PW(b.current, v.current, {
      placement: w,
      modifiers: [
        OW,
        kW,
        FW,
        {
          ...HW,
          enabled: !!g
        },
        {
          name: "eventListeners",
          ...TW(a)
        },
        {
          name: "arrow",
          options: { padding: i }
        },
        {
          name: "offset",
          options: {
            offset: u ?? [0, c]
          }
        },
        {
          name: "flip",
          enabled: !!d,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!p,
          options: { boundary: f }
        },
        // allow users override internal modifiers
        ...n ?? []
      ],
      strategy: o
    }), y.current.forceUpdate(), I.current = y.current.destroy);
  }, [
    w,
    t,
    n,
    g,
    a,
    i,
    u,
    c,
    d,
    p,
    f,
    o
  ]);
  Ue(() => () => {
    var Z;
    !b.current && !v.current && ((Z = y.current) == null || Z.destroy(), y.current = null);
  }, []);
  const M = q(
    (Z) => {
      b.current = Z, V();
    },
    [V]
  ), L = q(
    (Z = {}, G = null) => ({
      ...Z,
      ref: mn(M, G)
    }),
    [M]
  ), R = q(
    (Z) => {
      v.current = Z, V();
    },
    [V]
  ), _ = q(
    (Z = {}, G = null) => ({
      ...Z,
      ref: mn(R, G),
      style: {
        ...Z.style,
        position: o,
        minWidth: g ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [o, R, g]
  ), H = q((Z = {}, G = null) => {
    const { size: se, shadowColor: ue, bg: ce, style: xe, ...he } = Z;
    return {
      ...he,
      ref: G,
      "data-popper-arrow": "",
      style: zW(Z)
    };
  }, []), B = q(
    (Z = {}, G = null) => ({
      ...Z,
      ref: G,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var Z;
      (Z = y.current) == null || Z.update();
    },
    forceUpdate() {
      var Z;
      (Z = y.current) == null || Z.forceUpdate();
    },
    transformOrigin: In.transformOrigin.varRef,
    referenceRef: M,
    popperRef: R,
    getPopperProps: _,
    getArrowProps: H,
    getArrowInnerProps: B,
    getReferenceProps: L
  };
}
function zW(e) {
  const { size: t, shadowColor: n, bg: r, style: o } = e, i = { ...o, position: "absolute" };
  return t && (i["--popper-arrow-size"] = t), n && (i["--popper-arrow-shadow-color"] = n), r && (i["--popper-arrow-bg"] = r), i;
}
function WW() {
  const e = Le(/* @__PURE__ */ new Map()), t = e.current, n = q((o, i, a, u) => {
    e.current.set(a, { type: i, el: o, options: u }), o.addEventListener(i, a, u);
  }, []), r = q(
    (o, i, a, u) => {
      o.removeEventListener(i, a, u), e.current.delete(a);
    },
    []
  );
  return Ue(
    () => () => {
      t.forEach((o, i) => {
        r(o.el, o.type, i, o.options);
      });
    },
    [r, t]
  ), { add: n, remove: r };
}
function Ud(e) {
  var o, i;
  const t = ((i = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : i[0]) ?? e.target, { tagName: n, isContentEditable: r } = t;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function GW(e = {}) {
  const {
    ref: t,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: o = !0,
    clickOnSpace: i = !0,
    onMouseDown: a,
    onMouseUp: u,
    onClick: c,
    onKeyDown: d,
    onKeyUp: f,
    tabIndex: p,
    onMouseOver: g,
    onMouseLeave: m,
    ...b
  } = e, [v, y] = Ee(!0), [w, I] = Ee(!1), V = WW(), M = (z) => {
    z && z.tagName !== "BUTTON" && y(!1);
  }, L = v ? p : p || 0, R = n && !r, _ = q(
    (z) => {
      if (n) {
        z.stopPropagation(), z.preventDefault();
        return;
      }
      z.currentTarget.focus(), c == null || c(z);
    },
    [n, c]
  ), H = q(
    (z) => {
      w && Ud(z) && (z.preventDefault(), z.stopPropagation(), I(!1), V.remove(document, "keyup", H, !1));
    },
    [w, V]
  ), B = q(
    (z) => {
      if (d == null || d(z), n || z.defaultPrevented || z.metaKey || !Ud(z.nativeEvent) || v)
        return;
      const Y = o && z.key === "Enter";
      i && z.key === " " && (z.preventDefault(), I(!0)), Y && (z.preventDefault(), z.currentTarget.click()), V.add(document, "keyup", H, !1);
    },
    [
      n,
      v,
      d,
      o,
      i,
      V,
      H
    ]
  ), Z = q(
    (z) => {
      if (f == null || f(z), n || z.defaultPrevented || z.metaKey || !Ud(z.nativeEvent) || v)
        return;
      i && z.key === " " && (z.preventDefault(), I(!1), z.currentTarget.click());
    },
    [i, v, n, f]
  ), G = q(
    (z) => {
      z.button === 0 && (I(!1), V.remove(document, "mouseup", G, !1));
    },
    [V]
  ), se = q(
    (z) => {
      if (z.button !== 0)
        return;
      if (n) {
        z.stopPropagation(), z.preventDefault();
        return;
      }
      v || I(!0), z.currentTarget.focus({ preventScroll: !0 }), V.add(document, "mouseup", G, !1), a == null || a(z);
    },
    [n, v, a, V, G]
  ), ue = q(
    (z) => {
      z.button === 0 && (v || I(!1), u == null || u(z));
    },
    [u, v]
  ), ce = q(
    (z) => {
      if (n) {
        z.preventDefault();
        return;
      }
      g == null || g(z);
    },
    [n, g]
  ), xe = q(
    (z) => {
      w && (z.preventDefault(), I(!1)), m == null || m(z);
    },
    [w, m]
  ), he = mn(t, M);
  return v ? {
    ...b,
    ref: he,
    type: "button",
    "aria-disabled": R ? void 0 : n,
    disabled: R,
    onClick: _,
    onMouseDown: a,
    onMouseUp: u,
    onKeyUp: f,
    onKeyDown: d,
    onMouseOver: g,
    onMouseLeave: m
  } : {
    ...b,
    ref: he,
    role: "button",
    "data-active": Ne(w),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: R ? void 0 : L,
    onClick: _,
    onMouseDown: se,
    onMouseUp: ue,
    onKeyUp: Z,
    onKeyDown: B,
    onMouseOver: ce,
    onMouseLeave: xe
  };
}
const [
  jW,
  XW,
  UW,
  YW
] = eC(), [JW, Pl] = Bt({
  strict: !1,
  name: "MenuContext"
});
function yv(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function qW(e) {
  return yv(e).activeElement === e;
}
function KW(e = {}) {
  const {
    id: t,
    closeOnSelect: n = !0,
    closeOnBlur: r = !0,
    initialFocusRef: o,
    autoSelect: i = !0,
    isLazy: a,
    isOpen: u,
    defaultIsOpen: c,
    onClose: d,
    onOpen: f,
    placement: p = "bottom-start",
    lazyBehavior: g = "unmount",
    direction: m,
    computePositionOnMount: b = !1,
    ...v
  } = e, y = Le(null), w = Le(null), I = Le(!0), V = UW(), M = q(() => {
    requestAnimationFrame(() => {
      var W;
      (W = y.current) == null || W.focus({ preventScroll: !1 });
    });
  }, []), L = q(() => {
    const W = setTimeout(() => {
      var re, te;
      if (o)
        (re = o.current) == null || re.focus();
      else if (!V.count())
        (te = y.current) == null || te.focus({ preventScroll: !1 });
      else {
        const ee = V.firstEnabled();
        ee && ce(ee.index);
      }
    });
    ae.current.add(W);
  }, [V, o]), R = q(() => {
    const W = setTimeout(() => {
      var re;
      if (!V.count())
        (re = y.current) == null || re.focus({ preventScroll: !1 });
      else {
        const te = V.lastEnabled();
        te && ce(te.index);
      }
    });
    ae.current.add(W);
  }, [V]), _ = q(() => {
    f == null || f(), i ? L() : M();
  }, [i, L, M, f]), { isOpen: H, onOpen: B, onClose: Z, onToggle: G } = Xp({
    isOpen: u,
    defaultIsOpen: c,
    onClose: d,
    onOpen: _
  });
  sM({
    enabled: H && r,
    ref: y,
    handler: (W) => {
      var te, ee, ge;
      const re = ((ee = (te = W.composedPath) == null ? void 0 : te.call(W)) == null ? void 0 : ee[0]) ?? W.target;
      (ge = w.current) != null && ge.contains(re) || Z();
    }
  });
  const se = bv({
    ...v,
    enabled: H || b,
    placement: p,
    direction: m
  }), [ue, ce] = Ee(-1);
  tM(y, {
    focusRef: w,
    visible: H,
    shouldFocus: !0
  });
  const xe = KL({ isOpen: H, ref: y }), [he, z] = rM(t, "menu-button", "menu-list"), Y = q(() => {
    B(), M();
  }, [B, M]), ae = Le(/* @__PURE__ */ new Set([]));
  Ue(() => {
    const W = ae.current;
    return () => {
      W.forEach((re) => clearTimeout(re)), W.clear();
    };
  }, []), fs(() => {
    var W;
    H || (ce(-1), (W = y.current) == null || W.scrollTo(0, 0));
  }, [H]), fs(() => {
    H && ue === -1 && M();
  }, [ue, H]), Ue(() => {
    var re;
    if (!H)
      return;
    const W = V.item(ue);
    (re = W == null ? void 0 : W.node) == null || re.focus({ preventScroll: !I.current });
  }, [V, ue, H]);
  const j = q(() => {
    B(), L();
  }, [L, B]), X = q(() => {
    I.current = !0, B(), R();
  }, [B, R]), ie = q(() => {
    var ge, pe;
    const W = yv(y.current), re = (ge = y.current) == null ? void 0 : ge.contains(W.activeElement);
    if (!(H && !re))
      return;
    const ee = (pe = V.item(ue)) == null ? void 0 : pe.node;
    ee == null || ee.focus({ preventScroll: !I.current });
  }, [H, ue, V]);
  return {
    openAndFocusMenu: Y,
    openAndFocusFirstItem: j,
    openAndFocusLastItem: X,
    onTransitionEnd: ie,
    unstable__animationState: xe,
    descendants: V,
    popper: se,
    buttonId: he,
    menuId: z,
    forceUpdate: se.forceUpdate,
    orientation: "vertical",
    isOpen: H,
    onToggle: G,
    onOpen: B,
    onClose: Z,
    menuRef: y,
    buttonRef: w,
    focusedIndex: ue,
    closeOnSelect: n,
    closeOnBlur: r,
    autoSelect: i,
    setFocusedIndex: ce,
    isLazy: a,
    lazyBehavior: g,
    initialFocusRef: o,
    scrollIntoViewRef: I
  };
}
function QW(e = {}, t = null) {
  const n = Pl(), {
    onToggle: r,
    popper: o,
    openAndFocusFirstItem: i,
    openAndFocusLastItem: a,
    scrollIntoViewRef: u
  } = n, c = q(
    (d) => {
      const f = d.key, g = {
        Enter: i,
        ArrowDown: i,
        ArrowUp: a
      }[f];
      g && (u.current = !0, d.preventDefault(), d.stopPropagation(), g(d));
    },
    [i, a, u]
  );
  return {
    ...e,
    ref: mn(n.buttonRef, t, o.referenceRef),
    id: n.buttonId,
    "data-active": Ne(n.isOpen),
    "aria-expanded": n.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": n.menuId,
    onClick: We(e.onClick, r),
    onKeyDown: We(e.onKeyDown, c)
  };
}
function nf(e) {
  var t;
  return rG(e) && !!((t = e == null ? void 0 : e.getAttribute("role")) != null && t.startsWith("menuitem"));
}
function eG(e = {}, t = null) {
  const n = Pl();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const {
    focusedIndex: r,
    setFocusedIndex: o,
    menuRef: i,
    isOpen: a,
    onClose: u,
    menuId: c,
    isLazy: d,
    lazyBehavior: f,
    scrollIntoViewRef: p,
    unstable__animationState: g
  } = n, m = XW(), b = wz({
    preventDefault: (I) => I.key !== " " && nf(I.target)
  }), v = q(
    (I) => {
      if (!I.currentTarget.contains(I.target))
        return;
      const V = I.key, L = {
        Tab: (_) => _.preventDefault(),
        Escape: (_) => {
          _.stopPropagation(), u();
        },
        ArrowDown: () => {
          p.current = !0;
          const _ = m.nextEnabled(r) ?? m.firstEnabled();
          _ && o(_.index);
        },
        ArrowUp: () => {
          p.current = !0;
          const _ = m.prevEnabled(r) ?? m.firstEnabled();
          _ && o(_.index);
        }
      }[V];
      if (L) {
        I.preventDefault(), L(I);
        return;
      }
      const R = b((_) => {
        const H = xz(
          m.values(),
          _,
          (B) => {
            var Z;
            return ((Z = B == null ? void 0 : B.node) == null ? void 0 : Z.textContent) ?? "";
          },
          m.item(r)
        );
        if (H) {
          const B = m.indexOf(H.node);
          o(B);
        }
      });
      nf(I.target) && R(I);
    },
    [
      m,
      r,
      b,
      u,
      o,
      p
    ]
  ), y = Le(!1);
  a && (y.current = !0);
  const w = zL({
    wasSelected: y.current,
    enabled: d,
    mode: f,
    isSelected: g.present
  });
  return {
    ...e,
    ref: mn(i, t),
    children: w ? e.children : null,
    tabIndex: -1,
    role: "menu",
    id: c,
    style: {
      ...e.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: We(e.onKeyDown, v)
  };
}
function tG(e = {}) {
  const { popper: t, isOpen: n } = Pl();
  return t.getPopperProps({
    ...e,
    style: {
      visibility: n ? "visible" : "hidden",
      ...e.style
    }
  });
}
function nG(e = {}, t = null) {
  const {
    onMouseEnter: n,
    onMouseMove: r,
    onMouseLeave: o,
    onClick: i,
    onFocus: a,
    isDisabled: u,
    isFocusable: c,
    closeOnSelect: d,
    type: f,
    ...p
  } = e, g = Pl(), {
    setFocusedIndex: m,
    focusedIndex: b,
    closeOnSelect: v,
    onClose: y,
    menuId: w,
    scrollIntoViewRef: I
  } = g, V = Le(null), M = `${w}-menuitem-${Zr()}`, { index: L, register: R } = YW({
    disabled: u && !c
  }), _ = q(
    (ce) => {
      n == null || n(ce), !u && (I.current = !1, m(L));
    },
    [m, L, u, n, I]
  ), H = q(
    (ce) => {
      r == null || r(ce), V.current && !qW(V.current) && _(ce);
    },
    [_, r]
  ), B = q(
    (ce) => {
      o == null || o(ce), !u && m(-1);
    },
    [m, u, o]
  ), Z = q(
    (ce) => {
      i == null || i(ce), nf(ce.currentTarget) && (d ?? v) && y();
    },
    [y, i, v, d]
  ), G = q(
    (ce) => {
      a == null || a(ce), m(L);
    },
    [m, a, L]
  ), se = L === b, ue = GW({
    onClick: Z,
    onFocus: G,
    onMouseEnter: _,
    onMouseMove: H,
    onMouseLeave: B,
    ref: mn(R, V, t),
    isDisabled: u,
    isFocusable: c
  });
  return {
    ...p,
    ...ue,
    type: f ?? ue.type,
    id: M,
    role: "menuitem",
    tabIndex: se ? 0 : -1
  };
}
function rG(e) {
  if (!oG(e))
    return !1;
  const t = e.ownerDocument.defaultView ?? window;
  return e instanceof t.HTMLElement;
}
function oG(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
const [iG, El] = Bt({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), xv = (e) => {
  const { children: t } = e, n = Rn("Menu", e), r = rn(e), { direction: o } = V2(), { descendants: i, ...a } = KW({ ...r, direction: o }), u = at(() => a, [a]), { isOpen: c, onClose: d, forceUpdate: f } = u;
  return /* @__PURE__ */ x.jsx(jW, { value: i, children: /* @__PURE__ */ x.jsx(JW, { value: u, children: /* @__PURE__ */ x.jsx(iG, { value: n, children: eo(t, { isOpen: c, onClose: d, forceUpdate: f }) }) }) });
};
xv.displayName = "Menu";
const sG = Pe((e, t) => {
  const n = El();
  return /* @__PURE__ */ x.jsx(
    ye.button,
    {
      ref: t,
      ...e,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...n.button
      }
    }
  );
}), Sv = Pe(
  (e, t) => {
    const { children: n, as: r, ...o } = e, i = QW(o, t), a = r || sG;
    return /* @__PURE__ */ x.jsx(
      a,
      {
        ...i,
        className: _e("chakra-menu__menu-button", e.className),
        children: /* @__PURE__ */ x.jsx(
          ye.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: e.children
          }
        )
      }
    );
  }
);
Sv.displayName = "MenuButton";
const wv = Pe(
  (e, t) => {
    const n = El();
    return /* @__PURE__ */ x.jsx(
      ye.span,
      {
        ref: t,
        ...e,
        __css: n.command,
        className: "chakra-menu__command"
      }
    );
  }
);
wv.displayName = "MenuCommand";
const Iv = (e) => {
  const { className: t, children: n, ...r } = e, o = El(), i = d2.only(n), a = Da(i) ? bo(i, {
    focusable: "false",
    "aria-hidden": !0,
    className: _e("chakra-menu__icon", i.props.className)
  }) : null, u = _e("chakra-menu__icon-wrapper", t);
  return /* @__PURE__ */ x.jsx(ye.span, { className: u, ...r, __css: o.icon, children: a });
};
Iv.displayName = "MenuIcon";
const aG = Pe(
  (e, t) => {
    const { type: n, ...r } = e, o = El(), i = r.as || n ? n ?? void 0 : "button", a = at(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...o.item
      }),
      [o.item]
    );
    return /* @__PURE__ */ x.jsx(ye.button, { ref: t, type: i, ...r, __css: a });
  }
), Vv = Pe((e, t) => {
  const {
    icon: n,
    iconSpacing: r = "0.75rem",
    command: o,
    commandSpacing: i = "0.75rem",
    children: a,
    ...u
  } = e, c = nG(u, t), f = n || o ? /* @__PURE__ */ x.jsx("span", { style: { pointerEvents: "none", flex: 1 }, children: a }) : a;
  return /* @__PURE__ */ x.jsxs(
    aG,
    {
      ...c,
      className: _e("chakra-menu__menuitem", c.className),
      children: [
        n && /* @__PURE__ */ x.jsx(Iv, { fontSize: "0.8em", marginEnd: r, children: n }),
        f,
        o && /* @__PURE__ */ x.jsx(wv, { marginStart: i, children: o })
      ]
    }
  );
});
Vv.displayName = "MenuItem";
const lG = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
}, uG = ye(xo.div), Av = Pe(
  function(t, n) {
    var g;
    const { rootProps: r, motionProps: o, ...i } = t, {
      isOpen: a,
      onTransitionEnd: u,
      unstable__animationState: c
    } = Pl(), d = eG(i, n), f = tG(r), p = El();
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...f,
        __css: { zIndex: t.zIndex ?? ((g = p.list) == null ? void 0 : g.zIndex) },
        children: /* @__PURE__ */ x.jsx(
          uG,
          {
            variants: lG,
            initial: !1,
            animate: a ? "enter" : "exit",
            __css: { outline: 0, ...p.list },
            ...o,
            ...d,
            className: _e("chakra-menu__menu-list", d.className),
            onUpdate: u,
            onAnimationComplete: _f(
              c.onComplete,
              d.onAnimationComplete
            )
          }
        )
      }
    );
  }
);
Av.displayName = "MenuList";
var cG = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, na = /* @__PURE__ */ new WeakMap(), ic = /* @__PURE__ */ new WeakMap(), sc = {}, Yd = 0, Lv = function(e) {
  return e && (e.host || Lv(e.parentNode));
}, dG = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Lv(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, fG = function(e, t, n, r) {
  var o = dG(t, Array.isArray(e) ? e : [e]);
  sc[n] || (sc[n] = /* @__PURE__ */ new WeakMap());
  var i = sc[n], a = [], u = /* @__PURE__ */ new Set(), c = new Set(o), d = function(p) {
    !p || u.has(p) || (u.add(p), d(p.parentNode));
  };
  o.forEach(d);
  var f = function(p) {
    !p || c.has(p) || Array.prototype.forEach.call(p.children, function(g) {
      if (u.has(g))
        f(g);
      else
        try {
          var m = g.getAttribute(r), b = m !== null && m !== "false", v = (na.get(g) || 0) + 1, y = (i.get(g) || 0) + 1;
          na.set(g, v), i.set(g, y), a.push(g), v === 1 && b && ic.set(g, !0), y === 1 && g.setAttribute(n, "true"), b || g.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", g, w);
        }
    });
  };
  return f(t), u.clear(), Yd++, function() {
    a.forEach(function(p) {
      var g = na.get(p) - 1, m = i.get(p) - 1;
      na.set(p, g), i.set(p, m), g || (ic.has(p) || p.removeAttribute(r), ic.delete(p)), m || p.removeAttribute(n);
    }), Yd--, Yd || (na = /* @__PURE__ */ new WeakMap(), na = /* @__PURE__ */ new WeakMap(), ic = /* @__PURE__ */ new WeakMap(), sc = {});
  };
}, hG = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || cG(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), fG(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, pG = Object.defineProperty, gG = (e, t, n) => t in e ? pG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, mG = (e, t, n) => (gG(e, typeof t != "symbol" ? t + "" : t, n), n);
class CG {
  constructor() {
    mG(this, "modals"), this.modals = /* @__PURE__ */ new Set();
  }
  add(t) {
    return this.modals.add(t), this.modals.size;
  }
  remove(t) {
    this.modals.delete(t);
  }
  isTopModal(t) {
    if (!t)
      return !1;
    const n = Array.from(this.modals)[this.modals.size - 1];
    return t === n;
  }
}
const rf = new CG();
function Mv(e, t) {
  const [n, r] = Ee(0);
  return Ue(() => {
    const o = e.current;
    if (o) {
      if (t) {
        const i = rf.add(o);
        r(i);
      }
      return () => {
        rf.remove(o), r(0);
      };
    }
  }, [t, e]), n;
}
function vG(e) {
  const {
    isOpen: t,
    onClose: n,
    id: r,
    closeOnOverlayClick: o = !0,
    closeOnEsc: i = !0,
    useInert: a = !0,
    onOverlayClick: u,
    onEsc: c
  } = e, d = Le(null), f = Le(null), [p, g, m] = yG(
    r,
    "chakra-modal",
    "chakra-modal--header",
    "chakra-modal--body"
  );
  bG(d, t && a);
  const b = Mv(d, t), v = Le(null), y = q((B) => {
    v.current = B.target;
  }, []), w = q(
    (B) => {
      B.key === "Escape" && (B.stopPropagation(), i && (n == null || n()), c == null || c());
    },
    [i, n, c]
  ), [I, V] = Ee(!1), [M, L] = Ee(!1), R = q(
    (B = {}, Z = null) => ({
      role: "dialog",
      ...B,
      ref: mn(Z, d),
      id: p,
      tabIndex: -1,
      "aria-modal": !0,
      "aria-labelledby": I ? g : void 0,
      "aria-describedby": M ? m : void 0,
      onClick: We(
        B.onClick,
        (G) => G.stopPropagation()
      )
    }),
    [m, M, p, g, I]
  ), _ = q(
    (B) => {
      B.stopPropagation(), v.current === B.target && rf.isTopModal(d.current) && (o && (n == null || n()), u == null || u());
    },
    [n, o, u]
  ), H = q(
    (B = {}, Z = null) => ({
      ...B,
      ref: mn(Z, f),
      onClick: We(B.onClick, _),
      onKeyDown: We(B.onKeyDown, w),
      onMouseDown: We(B.onMouseDown, y)
    }),
    [w, y, _]
  );
  return {
    isOpen: t,
    onClose: n,
    headerId: g,
    bodyId: m,
    setBodyMounted: L,
    setHeaderMounted: V,
    dialogRef: d,
    overlayRef: f,
    getDialogProps: R,
    getDialogContainerProps: H,
    index: b
  };
}
function bG(e, t) {
  const n = e.current;
  Ue(() => {
    if (!(!e.current || !t))
      return hG(e.current);
  }, [t, e, n]);
}
function yG(e, ...t) {
  const n = Zr(), r = e || n;
  return at(() => t.map((o) => `${o}-${r}`), [r, t]);
}
const [xG, Is] = Bt({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), [SG, Mi] = Bt({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}), Y3 = (e) => {
  const t = {
    scrollBehavior: "outside",
    autoFocus: !0,
    trapFocus: !0,
    returnFocusOnClose: !0,
    blockScrollOnMount: !0,
    allowPinchZoom: !1,
    preserveScrollBarGap: !0,
    motionPreset: "scale",
    ...e,
    lockFocusAcrossFrames: e.lockFocusAcrossFrames ?? !0
  }, {
    portalProps: n,
    children: r,
    autoFocus: o,
    trapFocus: i,
    initialFocusRef: a,
    finalFocusRef: u,
    returnFocusOnClose: c,
    blockScrollOnMount: d,
    allowPinchZoom: f,
    preserveScrollBarGap: p,
    motionPreset: g,
    lockFocusAcrossFrames: m,
    animatePresenceProps: b,
    onCloseComplete: v
  } = t, y = Rn("Modal", t), I = {
    ...vG(t),
    autoFocus: o,
    trapFocus: i,
    initialFocusRef: a,
    finalFocusRef: u,
    returnFocusOnClose: c,
    blockScrollOnMount: d,
    allowPinchZoom: f,
    preserveScrollBarGap: p,
    motionPreset: g,
    lockFocusAcrossFrames: m
  };
  return /* @__PURE__ */ x.jsx(SG, { value: I, children: /* @__PURE__ */ x.jsx(xG, { value: y, children: /* @__PURE__ */ x.jsx(
    Ri,
    {
      ...b,
      onExitComplete: v,
      children: I.isOpen && /* @__PURE__ */ x.jsx(Na, { ...n, children: r })
    }
  ) }) });
};
Y3.displayName = "Modal";
var _c = "right-scroll-bar-position", Tc = "width-before-scroll-bar", wG = "with-scroll-bars-hidden", IG = "--removed-body-scroll-bar-size", Pv = MC(), Jd = function() {
}, E2 = be.forwardRef(function(e, t) {
  var n = be.useRef(null), r = be.useState({
    onScrollCapture: Jd,
    onWheelCapture: Jd,
    onTouchMoveCapture: Jd
  }), o = r[0], i = r[1], a = e.forwardProps, u = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, p = e.shards, g = e.sideCar, m = e.noRelative, b = e.noIsolation, v = e.inert, y = e.allowPinchZoom, w = e.as, I = w === void 0 ? "div" : w, V = e.gapMode, M = VC(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), L = g, R = IC([n, t]), _ = go(go({}, M), o);
  return be.createElement(
    be.Fragment,
    null,
    f && be.createElement(L, { sideCar: Pv, removeScrollBar: d, shards: p, noRelative: m, noIsolation: b, inert: v, setCallbacks: i, allowPinchZoom: !!y, lockRef: n, gapMode: V }),
    a ? be.cloneElement(be.Children.only(u), go(go({}, _), { ref: R })) : be.createElement(I, go({}, _, { className: c, ref: R }), u)
  );
});
E2.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
E2.classNames = {
  fullWidth: Tc,
  zeroRight: _c
};
var z8, VG = function() {
  if (z8)
    return z8;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function AG() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = VG();
  return t && e.setAttribute("nonce", t), e;
}
function LG(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function MG(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var PG = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = AG()) && (LG(t, n), MG(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, EG = function() {
  var e = PG();
  return function(t, n) {
    be.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Ev = function() {
  var e = EG(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, RG = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, qd = function(e) {
  return parseInt(e || "", 10) || 0;
}, _G = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [qd(n), qd(r), qd(o)];
}, TG = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return RG;
  var t = _G(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, HG = Ev(), Va = "data-scroll-locked", FG = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, u = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(wG, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(u, "px ").concat(r, `;
  }
  body[`).concat(Va, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(u, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(u, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(_c, ` {
    right: `).concat(u, "px ").concat(r, `;
  }
  
  .`).concat(Tc, ` {
    margin-right: `).concat(u, "px ").concat(r, `;
  }
  
  .`).concat(_c, " .").concat(_c, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Tc, " .").concat(Tc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Va, `] {
    `).concat(IG, ": ").concat(u, `px;
  }
`);
}, W8 = function() {
  var e = parseInt(document.body.getAttribute(Va) || "0", 10);
  return isFinite(e) ? e : 0;
}, kG = function() {
  be.useEffect(function() {
    return document.body.setAttribute(Va, (W8() + 1).toString()), function() {
      var e = W8() - 1;
      e <= 0 ? document.body.removeAttribute(Va) : document.body.setAttribute(Va, e.toString());
    };
  }, []);
}, BG = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  kG();
  var i = be.useMemo(function() {
    return TG(o);
  }, [o]);
  return be.createElement(HG, { styles: FG(i, !t, o, n ? "" : "!important") });
}, of = !1;
if (typeof window < "u")
  try {
    var ac = Object.defineProperty({}, "passive", {
      get: function() {
        return of = !0, !0;
      }
    });
    window.addEventListener("test", ac, ac), window.removeEventListener("test", ac, ac);
  } catch {
    of = !1;
  }
var ra = of ? { passive: !1 } : !1, DG = function(e) {
  return e.tagName === "TEXTAREA";
}, Rv = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !DG(e) && n[t] === "visible")
  );
}, OG = function(e) {
  return Rv(e, "overflowY");
}, NG = function(e) {
  return Rv(e, "overflowX");
}, G8 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = _v(e, r);
    if (o) {
      var i = Tv(e, r), a = i[1], u = i[2];
      if (a > u)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, ZG = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, $G = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, _v = function(e, t) {
  return e === "v" ? OG(t) : NG(t);
}, Tv = function(e, t) {
  return e === "v" ? ZG(t) : $G(t);
}, zG = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, WG = function(e, t, n, r, o) {
  var i = zG(e, window.getComputedStyle(t).direction), a = i * r, u = n.target, c = t.contains(u), d = !1, f = a > 0, p = 0, g = 0;
  do {
    if (!u)
      break;
    var m = Tv(e, u), b = m[0], v = m[1], y = m[2], w = v - y - i * b;
    (b || w) && _v(e, u) && (p += w, g += b);
    var I = u.parentNode;
    u = I && I.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? I.host : I;
  } while (
    // portaled content
    !c && u !== document.body || // self content
    c && (t.contains(u) || t === u)
  );
  return (f && (o && Math.abs(p) < 1 || !o && a > p) || !f && (o && Math.abs(g) < 1 || !o && -a > g)) && (d = !0), d;
}, lc = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, j8 = function(e) {
  return [e.deltaX, e.deltaY];
}, X8 = function(e) {
  return e && "current" in e ? e.current : e;
}, GG = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, jG = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, XG = 0, oa = [];
function UG(e) {
  var t = be.useRef([]), n = be.useRef([0, 0]), r = be.useRef(), o = be.useState(XG++)[0], i = be.useState(Ev)[0], a = be.useRef(e);
  be.useEffect(function() {
    a.current = e;
  }, [e]), be.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = o$([e.lockRef.current], (e.shards || []).map(X8), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var u = be.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = lc(v), I = n.current, V = "deltaX" in v ? v.deltaX : I[0] - w[0], M = "deltaY" in v ? v.deltaY : I[1] - w[1], L, R = v.target, _ = Math.abs(V) > Math.abs(M) ? "h" : "v";
    if ("touches" in v && _ === "h" && R.type === "range")
      return !1;
    var H = G8(_, R);
    if (!H)
      return !0;
    if (H ? L = _ : (L = _ === "v" ? "h" : "v", H = G8(_, R)), !H)
      return !1;
    if (!r.current && "changedTouches" in v && (V || M) && (r.current = L), !L)
      return !0;
    var B = r.current || L;
    return WG(B, y, v, B === "h" ? V : M, !0);
  }, []), c = be.useCallback(function(v) {
    var y = v;
    if (!(!oa.length || oa[oa.length - 1] !== i)) {
      var w = "deltaY" in y ? j8(y) : lc(y), I = t.current.filter(function(L) {
        return L.name === y.type && (L.target === y.target || y.target === L.shadowParent) && GG(L.delta, w);
      })[0];
      if (I && I.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!I) {
        var V = (a.current.shards || []).map(X8).filter(Boolean).filter(function(L) {
          return L.contains(y.target);
        }), M = V.length > 0 ? u(y, V[0]) : !a.current.noIsolation;
        M && y.cancelable && y.preventDefault();
      }
    }
  }, []), d = be.useCallback(function(v, y, w, I) {
    var V = { name: v, delta: y, target: w, should: I, shadowParent: YG(w) };
    t.current.push(V), setTimeout(function() {
      t.current = t.current.filter(function(M) {
        return M !== V;
      });
    }, 1);
  }, []), f = be.useCallback(function(v) {
    n.current = lc(v), r.current = void 0;
  }, []), p = be.useCallback(function(v) {
    d(v.type, j8(v), v.target, u(v, e.lockRef.current));
  }, []), g = be.useCallback(function(v) {
    d(v.type, lc(v), v.target, u(v, e.lockRef.current));
  }, []);
  be.useEffect(function() {
    return oa.push(i), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, ra), document.addEventListener("touchmove", c, ra), document.addEventListener("touchstart", f, ra), function() {
      oa = oa.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", c, ra), document.removeEventListener("touchmove", c, ra), document.removeEventListener("touchstart", f, ra);
    };
  }, []);
  var m = e.removeScrollBar, b = e.inert;
  return be.createElement(
    be.Fragment,
    null,
    b ? be.createElement(i, { styles: jG(o) }) : null,
    m ? be.createElement(BG, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function YG(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const JG = i$(Pv, UG);
var Hv = be.forwardRef(function(e, t) {
  return be.createElement(E2, go({}, e, { ref: t, sideCar: JG }));
});
Hv.classNames = E2.classNames;
const qG = Hv;
function Fv(e) {
  const {
    autoFocus: t,
    trapFocus: n,
    dialogRef: r,
    initialFocusRef: o,
    blockScrollOnMount: i,
    allowPinchZoom: a,
    finalFocusRef: u,
    returnFocusOnClose: c,
    preserveScrollBarGap: d,
    lockFocusAcrossFrames: f,
    isOpen: p
  } = Mi(), [g, m] = _m();
  Ue(() => {
    !g && m && setTimeout(m);
  }, [g, m]);
  const b = Mv(r, p);
  return /* @__PURE__ */ x.jsx(
    iv,
    {
      autoFocus: t,
      isDisabled: !n,
      initialFocusRef: o,
      finalFocusRef: u,
      restoreFocus: c,
      contentRef: r,
      lockFocusAcrossFrames: f,
      children: /* @__PURE__ */ x.jsx(
        qG,
        {
          removeScrollBar: !d,
          allowPinchZoom: a,
          enabled: b === 1 && i,
          forwardProps: !0,
          children: e.children
        }
      )
    }
  );
}
const KG = {
  initial: ({ offsetX: e, offsetY: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    x: e,
    y: t,
    transition: (n == null ? void 0 : n.exit) ?? to.exit(us.exit, o),
    transitionEnd: r == null ? void 0 : r.exit
  }),
  enter: ({ transition: e, transitionEnd: t, delay: n }) => ({
    opacity: 1,
    x: 0,
    y: 0,
    transition: (e == null ? void 0 : e.enter) ?? to.enter(us.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ offsetY: e, offsetX: t, transition: n, transitionEnd: r, reverse: o, delay: i }) => {
    const a = { x: t, y: e };
    return {
      opacity: 0,
      transition: (n == null ? void 0 : n.exit) ?? to.exit(us.exit, i),
      ...o ? { ...a, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { ...a, ...r == null ? void 0 : r.exit } }
    };
  }
}, B1 = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: KG
}, QG = Fe(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: i = !0,
      className: a,
      offsetX: u = 0,
      offsetY: c = 8,
      transition: d,
      transitionEnd: f,
      delay: p,
      animatePresenceProps: g,
      ...m
    } = t, b = r ? o && r : !0, v = o || r ? "enter" : "exit", y = {
      offsetX: u,
      offsetY: c,
      reverse: i,
      transition: d,
      transitionEnd: f,
      delay: p
    };
    return /* @__PURE__ */ x.jsx(Ri, { ...g, custom: y, children: b && /* @__PURE__ */ x.jsx(
      xo.div,
      {
        ref: n,
        className: _e("chakra-offset-slide", a),
        custom: y,
        ...B1,
        animate: v,
        ...m
      }
    ) });
  }
);
QG.displayName = "SlideFade";
const ej = {
  exit: ({ reverse: e, initialScale: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    ...e ? { scale: t, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { scale: t, ...r == null ? void 0 : r.exit } },
    transition: (n == null ? void 0 : n.exit) ?? to.exit(us.exit, o)
  }),
  enter: ({ transitionEnd: e, transition: t, delay: n }) => ({
    opacity: 1,
    scale: 1,
    transition: (t == null ? void 0 : t.enter) ?? to.enter(us.enter, n),
    transitionEnd: e == null ? void 0 : e.enter
  })
}, kv = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: ej
}, tj = Fe(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: i = !0,
      initialScale: a = 0.95,
      className: u,
      transition: c,
      transitionEnd: d,
      delay: f,
      animatePresenceProps: p,
      ...g
    } = t, m = r ? o && r : !0, b = o || r ? "enter" : "exit", v = { initialScale: a, reverse: i, transition: c, transitionEnd: d, delay: f };
    return /* @__PURE__ */ x.jsx(Ri, { ...p, custom: v, children: m && /* @__PURE__ */ x.jsx(
      xo.div,
      {
        ref: n,
        className: _e("chakra-offset-slide", u),
        ...kv,
        animate: b,
        custom: v,
        ...g
      }
    ) });
  }
);
tj.displayName = "ScaleFade";
const nj = {
  slideInBottom: {
    ...B1,
    custom: { offsetY: 16, reverse: !0 }
  },
  slideInRight: {
    ...B1,
    custom: { offsetX: 16, reverse: !0 }
  },
  slideInTop: {
    ...B1,
    custom: { offsetY: -16, reverse: !0 }
  },
  slideInLeft: {
    ...B1,
    custom: { offsetX: -16, reverse: !0 }
  },
  scale: {
    ...kv,
    custom: { initialScale: 0.95, reverse: !0 }
  },
  none: {}
}, rj = ye(xo.section), oj = (e) => nj[e || "none"], Bv = Fe(
  (e, t) => {
    const { preset: n, motionProps: r = oj(n), ...o } = e;
    return /* @__PURE__ */ x.jsx(rj, { ref: t, ...r, ...o });
  }
);
Bv.displayName = "ModalTransition";
const Dv = Pe(
  (e, t) => {
    const {
      className: n,
      children: r,
      containerProps: o,
      motionProps: i,
      ...a
    } = e, { getDialogProps: u, getDialogContainerProps: c } = Mi(), d = u(a, t), f = c(o), p = _e("chakra-modal__content", n), g = Is(), m = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...g.dialog
    }, b = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...g.dialogContainer
    }, { motionPreset: v } = Mi();
    return /* @__PURE__ */ x.jsx(Fv, { children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...f,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: b,
        children: /* @__PURE__ */ x.jsx(
          Bv,
          {
            preset: v,
            motionProps: i,
            className: p,
            ...d,
            __css: m,
            children: r
          }
        )
      }
    ) });
  }
);
Dv.displayName = "ModalContent";
const J3 = Pe((e, t) => {
  const { className: n, ...r } = e, { bodyId: o, setBodyMounted: i } = Mi();
  Ue(() => (i(!0), () => i(!1)), [i]);
  const a = _e("chakra-modal__body", n), u = Is();
  return /* @__PURE__ */ x.jsx(
    ye.div,
    {
      ref: t,
      className: a,
      id: o,
      ...r,
      __css: u.body
    }
  );
});
J3.displayName = "ModalBody";
const Ov = Pe(
  (e, t) => {
    const { onClick: n, className: r, ...o } = e, { onClose: i } = Mi(), a = _e("chakra-modal__close-btn", r), u = Is();
    return /* @__PURE__ */ x.jsx(
      A2,
      {
        ref: t,
        __css: u.closeButton,
        className: a,
        onClick: We(n, (c) => {
          c.stopPropagation(), i();
        }),
        ...o
      }
    );
  }
);
Ov.displayName = "ModalCloseButton";
const q3 = Pe(
  (e, t) => {
    const { className: n, ...r } = e, o = _e("chakra-modal__footer", n), i = Is(), a = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...i.footer
    };
    return /* @__PURE__ */ x.jsx(
      ye.footer,
      {
        ref: t,
        ...r,
        __css: a,
        className: o
      }
    );
  }
);
q3.displayName = "ModalFooter";
const K3 = Pe(
  (e, t) => {
    const { className: n, ...r } = e, { headerId: o, setHeaderMounted: i } = Mi();
    Ue(() => (i(!0), () => i(!1)), [i]);
    const a = _e("chakra-modal__header", n), u = Is(), c = {
      flex: 0,
      ...u.header
    };
    return /* @__PURE__ */ x.jsx(
      ye.header,
      {
        ref: t,
        className: a,
        id: o,
        ...r,
        __css: c
      }
    );
  }
);
K3.displayName = "ModalHeader";
const ij = {
  enter: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 1,
    transition: (e == null ? void 0 : e.enter) ?? to.enter(us.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 0,
    transition: (e == null ? void 0 : e.exit) ?? to.exit(us.exit, n),
    transitionEnd: t == null ? void 0 : t.exit
  })
}, Nv = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: ij
}, sj = Fe(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      className: i,
      transition: a,
      transitionEnd: u,
      delay: c,
      animatePresenceProps: d,
      ...f
    } = t, p = o || r ? "enter" : "exit", g = r ? o && r : !0, m = { transition: a, transitionEnd: u, delay: c };
    return /* @__PURE__ */ x.jsx(Ri, { ...d, custom: m, children: g && /* @__PURE__ */ x.jsx(
      xo.div,
      {
        ref: n,
        className: _e("chakra-fade", i),
        custom: m,
        ...Nv,
        animate: p,
        ...f
      }
    ) });
  }
);
sj.displayName = "Fade";
const aj = ye(xo.div), Q3 = Pe(
  (e, t) => {
    const { className: n, transition: r, motionProps: o, ...i } = e, a = _e("chakra-modal__overlay", n), c = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...Is().overlay
    }, { motionPreset: d } = Mi(), p = o || (d === "none" ? {} : Nv);
    return /* @__PURE__ */ x.jsx(
      aj,
      {
        ...p,
        __css: c,
        ref: t,
        className: a,
        ...i
      }
    );
  }
);
Q3.displayName = "ModalOverlay";
const [lj, uj] = Bt(), cj = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function dj(e, t) {
  var n;
  if (e)
    return ((n = cj[e]) == null ? void 0 : n[t]) ?? e;
}
function fj(e) {
  var d;
  const {
    isOpen: t,
    onClose: n,
    placement: r = "right",
    children: o,
    ...i
  } = e, a = V2(), u = (d = a.components) == null ? void 0 : d.Drawer, c = dj(r, a.direction);
  return /* @__PURE__ */ x.jsx(lj, { value: { placement: c }, children: /* @__PURE__ */ x.jsx(
    Y3,
    {
      isOpen: t,
      onClose: n,
      styleConfig: u,
      ...i,
      children: o
    }
  ) });
}
const U8 = {
  exit: {
    duration: 0.15,
    ease: rs.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
}, hj = {
  exit: ({ direction: e, transition: t, transitionEnd: n, delay: r }) => {
    const { exit: o } = G5({ direction: e });
    return {
      ...o,
      transition: (t == null ? void 0 : t.exit) ?? to.exit(U8.exit, r),
      transitionEnd: n == null ? void 0 : n.exit
    };
  },
  enter: ({ direction: e, transitionEnd: t, transition: n, delay: r }) => {
    const { enter: o } = G5({ direction: e });
    return {
      ...o,
      transition: (n == null ? void 0 : n.enter) ?? to.enter(U8.enter, r),
      transitionEnd: t == null ? void 0 : t.enter
    };
  }
}, Zv = Fe(
  function(t, n) {
    const {
      direction: r = "right",
      style: o,
      unmountOnExit: i,
      in: a,
      className: u,
      transition: c,
      transitionEnd: d,
      delay: f,
      motionProps: p,
      animatePresenceProps: g,
      ...m
    } = t, b = G5({ direction: r }), v = Object.assign(
      { position: "fixed" },
      b.position,
      o
    ), y = i ? a && i : !0, w = a || i ? "enter" : "exit", I = { transitionEnd: d, transition: c, direction: r, delay: f };
    return /* @__PURE__ */ x.jsx(Ri, { ...g, custom: I, children: y && /* @__PURE__ */ x.jsx(
      xo.div,
      {
        ...m,
        ref: n,
        initial: "exit",
        className: _e("chakra-slide", u),
        animate: w,
        exit: "exit",
        custom: I,
        variants: hj,
        style: v,
        ...p
      }
    ) });
  }
);
Zv.displayName = "Slide";
const pj = ye(Zv), $v = Pe(
  (e, t) => {
    const {
      className: n,
      children: r,
      motionProps: o,
      containerProps: i,
      ...a
    } = e, { getDialogProps: u, getDialogContainerProps: c, isOpen: d } = Mi(), f = u(a, t), p = c(i), g = _e("chakra-modal__content", n), m = Is(), b = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...m.dialog
    }, v = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...m.dialogContainer
    }, { placement: y } = uj();
    return /* @__PURE__ */ x.jsx(Fv, { children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...p,
        className: "chakra-modal__content-container",
        __css: v,
        children: /* @__PURE__ */ x.jsx(
          pj,
          {
            motionProps: o,
            direction: y,
            in: d,
            className: g,
            ...f,
            __css: b,
            children: r
          }
        )
      }
    ) });
  }
);
$v.displayName = "DrawerContent";
const gj = (e) => /* @__PURE__ */ x.jsx(Ko, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ x.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
  }
) }), mj = (e) => /* @__PURE__ */ x.jsx(Ko, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ x.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
  }
) });
function Y8(e, t, n, r) {
  Ue(() => {
    if (!e.current || !r)
      return;
    const o = e.current.ownerDocument.defaultView ?? window, i = Array.isArray(t) ? t : [t], a = new o.MutationObserver((u) => {
      for (const c of u)
        c.type === "attributes" && c.attributeName && i.includes(c.attributeName) && n(c);
    });
    return a.observe(e.current, { attributes: !0, attributeFilter: i }), () => a.disconnect();
  });
}
const Cj = 50, J8 = 300;
function vj(e, t) {
  const [n, r] = Ee(!1), [o, i] = Ee(null), [a, u] = Ee(!0), c = Le(null), d = () => clearTimeout(c.current);
  oM(
    () => {
      o === "increment" && e(), o === "decrement" && t();
    },
    n ? Cj : null
  );
  const f = q(() => {
    a && e(), c.current = setTimeout(() => {
      u(!1), r(!0), i("increment");
    }, J8);
  }, [e, a]), p = q(() => {
    a && t(), c.current = setTimeout(() => {
      u(!1), r(!0), i("decrement");
    }, J8);
  }, [t, a]), g = q(() => {
    u(!0), r(!1), d();
  }, []);
  return Ue(() => () => d(), []), { up: f, down: p, stop: g, isSpinning: n };
}
const bj = /^[Ee0-9+\-.]$/;
function yj(e) {
  return bj.test(e);
}
function xj(e, t) {
  if (e.key == null)
    return !0;
  const n = e.ctrlKey || e.altKey || e.metaKey;
  return !(e.key.length === 1) || n ? !0 : t(e.key);
}
function Sj(e = {}) {
  const {
    focusInputOnChange: t = !0,
    clampValueOnBlur: n = !0,
    keepWithinRange: r = !0,
    min: o = Number.MIN_SAFE_INTEGER,
    max: i = Number.MAX_SAFE_INTEGER,
    step: a = 1,
    isReadOnly: u,
    isDisabled: c,
    isRequired: d,
    isInvalid: f,
    pattern: p = "[0-9]*(.[0-9]+)?",
    inputMode: g = "decimal",
    allowMouseWheel: m,
    id: b,
    onChange: v,
    precision: y,
    name: w,
    "aria-describedby": I,
    "aria-label": V,
    "aria-labelledby": M,
    onFocus: L,
    onBlur: R,
    onInvalid: _,
    getAriaValueText: H,
    isValidCharacter: B,
    format: Z,
    parse: G,
    ...se
  } = e, ue = pn(L), ce = pn(R), xe = pn(_), he = pn(
    B ?? yj
  ), z = pn(H), Y = QL(e), {
    update: ae,
    increment: j,
    decrement: X
  } = Y, [ie, W] = Ee(!1), re = !(u || c), te = Le(null), ee = Le(null), ge = Le(null), pe = Le(null), Se = q(
    (me) => me.split("").filter(he).join(""),
    [he]
  ), de = q(
    (me) => (G == null ? void 0 : G(me)) ?? me,
    [G]
  ), Ve = q(
    (me) => ((Z == null ? void 0 : Z(me)) ?? me).toString(),
    [Z]
  );
  fs(() => {
    (Y.valueAsNumber > i || Y.valueAsNumber < o) && (xe == null || xe("rangeOverflow", Ve(Y.value), Y.valueAsNumber));
  }, [Y.valueAsNumber, Y.value, Ve, xe]), wi(() => {
    if (!te.current)
      return;
    if (te.current.value != Y.value) {
      const gt = de(te.current.value);
      Y.setValue(Se(gt));
    }
  }, [de, Se]);
  const K = q(
    (me = a) => {
      re && j(me);
    },
    [j, re, a]
  ), Ye = q(
    (me = a) => {
      re && X(me);
    },
    [X, re, a]
  ), ve = vj(K, Ye);
  Y8(
    ge,
    "disabled",
    ve.stop,
    ve.isSpinning
  ), Y8(
    pe,
    "disabled",
    ve.stop,
    ve.isSpinning
  );
  const ot = q(
    (me) => {
      if (me.nativeEvent.isComposing)
        return;
      const zt = de(me.currentTarget.value);
      ae(Se(zt)), ee.current = {
        start: me.currentTarget.selectionStart,
        end: me.currentTarget.selectionEnd
      };
    },
    [ae, Se, de]
  ), Mt = q(
    (me) => {
      var gt;
      ue == null || ue(me), ee.current && (me.currentTarget.selectionStart = ee.current.start ?? ((gt = me.currentTarget.value) == null ? void 0 : gt.length), me.currentTarget.selectionEnd = ee.current.end ?? me.currentTarget.selectionStart);
    },
    [ue]
  ), ft = q(
    (me) => {
      if (me.nativeEvent.isComposing)
        return;
      xj(me, he) || me.preventDefault();
      const gt = un(me) * a, zt = me.key, Zn = {
        ArrowUp: () => K(gt),
        ArrowDown: () => Ye(gt),
        Home: () => ae(o),
        End: () => ae(i)
      }[zt];
      Zn && (me.preventDefault(), Zn(me));
    },
    [he, a, K, Ye, ae, o, i]
  ), un = (me) => {
    let gt = 1;
    return (me.metaKey || me.ctrlKey) && (gt = 0.1), me.shiftKey && (gt = 10), gt;
  }, on = at(() => {
    const me = z == null ? void 0 : z(Y.value);
    if (me != null)
      return me;
    const gt = Y.value.toString();
    return gt || void 0;
  }, [Y.value, z]), Ct = q(() => {
    let me = Y.value;
    if (Y.value === "")
      return;
    /^[eE]/.test(Y.value.toString()) ? Y.setValue("") : (Y.valueAsNumber < o && (me = o), Y.valueAsNumber > i && (me = i), Y.cast(me));
  }, [Y, i, o]), Pt = q(() => {
    W(!1), n && Ct();
  }, [n, W, Ct]), jt = q(() => {
    t && requestAnimationFrame(() => {
      var me;
      (me = te.current) == null || me.focus();
    });
  }, [t]), Xt = q(
    (me) => {
      me.preventDefault(), ve.up(), jt();
    },
    [jt, ve]
  ), tr = q(
    (me) => {
      me.preventDefault(), ve.down(), jt();
    },
    [jt, ve]
  );
  N1(
    () => te.current,
    "wheel",
    (me) => {
      var zr;
      const zt = (((zr = te.current) == null ? void 0 : zr.ownerDocument) ?? document).activeElement === te.current;
      if (!m || !zt)
        return;
      me.preventDefault();
      const sn = un(me) * a, Zn = Math.sign(me.deltaY);
      Zn === -1 ? K(sn) : Zn === 1 && Ye(sn);
    },
    { passive: !1 }
  );
  const An = q(
    (me = {}, gt = null) => {
      const zt = c || r && Y.isAtMax;
      return {
        ...me,
        ref: mn(gt, ge),
        role: "button",
        tabIndex: -1,
        onPointerDown: We(me.onPointerDown, (sn) => {
          sn.button !== 0 || zt || Xt(sn);
        }),
        onPointerLeave: We(me.onPointerLeave, ve.stop),
        onPointerUp: We(me.onPointerUp, ve.stop),
        disabled: zt,
        "aria-disabled": $o(zt)
      };
    },
    [Y.isAtMax, r, Xt, ve.stop, c]
  ), $r = q(
    (me = {}, gt = null) => {
      const zt = c || r && Y.isAtMin;
      return {
        ...me,
        ref: mn(gt, pe),
        role: "button",
        tabIndex: -1,
        onPointerDown: We(me.onPointerDown, (sn) => {
          sn.button !== 0 || zt || tr(sn);
        }),
        onPointerLeave: We(me.onPointerLeave, ve.stop),
        onPointerUp: We(me.onPointerUp, ve.stop),
        disabled: zt,
        "aria-disabled": $o(zt)
      };
    },
    [Y.isAtMin, r, tr, ve.stop, c]
  ), vn = q(
    (me = {}, gt = null) => ({
      name: w,
      inputMode: g,
      type: "text",
      pattern: p,
      "aria-labelledby": M,
      "aria-label": V,
      "aria-describedby": I,
      id: b,
      disabled: c,
      role: "spinbutton",
      ...me,
      readOnly: me.readOnly ?? u,
      "aria-readonly": me.readOnly ?? u,
      "aria-required": me.required ?? d,
      required: me.required ?? d,
      ref: mn(te, gt),
      value: Ve(Y.value),
      "aria-valuemin": o,
      "aria-valuemax": i,
      "aria-valuenow": Number.isNaN(Y.valueAsNumber) ? void 0 : Y.valueAsNumber,
      "aria-invalid": $o(f ?? Y.isOutOfRange),
      "aria-valuetext": on,
      autoComplete: "off",
      autoCorrect: "off",
      onChange: We(me.onChange, ot),
      onKeyDown: We(me.onKeyDown, ft),
      onFocus: We(
        me.onFocus,
        Mt,
        () => W(!0)
      ),
      onBlur: We(me.onBlur, ce, Pt)
    }),
    [
      w,
      g,
      p,
      M,
      V,
      Ve,
      I,
      b,
      c,
      d,
      u,
      f,
      Y.value,
      Y.valueAsNumber,
      Y.isOutOfRange,
      o,
      i,
      on,
      ot,
      ft,
      Mt,
      ce,
      Pt
    ]
  );
  return {
    value: Ve(Y.value),
    valueAsNumber: Y.valueAsNumber,
    isFocused: ie,
    isDisabled: c,
    isReadOnly: u,
    getIncrementButtonProps: An,
    getDecrementButtonProps: $r,
    getInputProps: vn,
    htmlProps: se
  };
}
const [wj, R2] = Bt({
  name: "NumberInputStylesContext",
  errorMessage: `useNumberInputStyles returned is 'undefined'. Seems you forgot to wrap the components in "<NumberInput />" `
}), [Ij, e4] = Bt({
  name: "NumberInputContext",
  errorMessage: "useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"
}), zv = Pe(
  function(t, n) {
    const r = Rn("NumberInput", t), o = rn(t), i = x3(o), { htmlProps: a, ...u } = Sj(i), c = at(() => u, [u]);
    return /* @__PURE__ */ x.jsx(Ij, { value: c, children: /* @__PURE__ */ x.jsx(wj, { value: r, children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...a,
        ref: n,
        className: _e("chakra-numberinput", t.className),
        __css: {
          position: "relative",
          zIndex: 0,
          ...r.root
        }
      }
    ) }) });
  }
);
zv.displayName = "NumberInput";
const Wv = Pe(
  function(t, n) {
    const r = R2();
    return /* @__PURE__ */ x.jsx(
      ye.div,
      {
        "aria-hidden": !0,
        ref: n,
        ...t,
        __css: {
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: "0",
          insetEnd: "0px",
          margin: "1px",
          height: "calc(100% - 2px)",
          zIndex: 1,
          ...r.stepperGroup
        }
      }
    );
  }
);
Wv.displayName = "NumberInputStepper";
const Gv = Pe(
  function(t, n) {
    const { getInputProps: r } = e4(), o = r(t, n), i = R2();
    return /* @__PURE__ */ x.jsx(
      ye.input,
      {
        ...o,
        className: _e("chakra-numberinput__field", t.className),
        __css: {
          width: "100%",
          ...i.field
        }
      }
    );
  }
);
Gv.displayName = "NumberInputField";
const jv = ye("div", {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    transitionProperty: "common",
    transitionDuration: "normal",
    userSelect: "none",
    cursor: "pointer",
    lineHeight: "normal"
  }
}), Xv = Pe(function(t, n) {
  const r = R2(), { getDecrementButtonProps: o } = e4(), i = o(t, n);
  return /* @__PURE__ */ x.jsx(jv, { ...i, __css: r.stepper, children: t.children ?? /* @__PURE__ */ x.jsx(gj, {}) });
});
Xv.displayName = "NumberDecrementStepper";
const Uv = Pe(function(t, n) {
  const { getIncrementButtonProps: r } = e4(), o = r(t, n), i = R2();
  return /* @__PURE__ */ x.jsx(jv, { ...o, __css: i.stepper, children: t.children ?? /* @__PURE__ */ x.jsx(mj, {}) });
});
Uv.displayName = "NumberIncrementStepper";
function Vj(e) {
  var n;
  const t = be.version;
  return typeof t != "string" || t.startsWith("18.") ? e == null ? void 0 : e.ref : (n = e == null ? void 0 : e.props) == null ? void 0 : n.ref;
}
function Aj(e) {
  return e && gn(e) && gn(e.target);
}
function Yv(e = {}) {
  const {
    onChange: t,
    value: n,
    defaultValue: r,
    name: o,
    isDisabled: i,
    isFocusable: a,
    isNative: u,
    ...c
  } = e, [d, f] = Ee(r || ""), p = typeof n < "u", g = p ? n : d, m = Le(null), b = q(() => {
    const L = m.current;
    if (!L)
      return;
    let R = "input:not(:disabled):checked";
    const _ = L.querySelector(
      R
    );
    if (_) {
      _.focus();
      return;
    }
    R = "input:not(:disabled)";
    const H = L.querySelector(R);
    H == null || H.focus();
  }, []), y = `radio-${Zr()}`, w = o || y, I = q(
    (L) => {
      const R = Aj(L) ? L.target.value : L;
      p || f(R), t == null || t(String(R));
    },
    [t, p]
  ), V = q(
    (L = {}, R = null) => ({
      ...L,
      ref: mn(R, m),
      role: "radiogroup"
    }),
    []
  ), M = q(
    (L = {}, R = null) => ({
      ...L,
      ref: R,
      name: w,
      [u ? "checked" : "isChecked"]: g != null ? L.value === g : void 0,
      onChange(H) {
        I(H);
      },
      "data-radiogroup": !0
    }),
    [u, w, I, g]
  );
  return {
    getRootProps: V,
    getRadioProps: M,
    name: w,
    ref: m,
    focus: b,
    setValue: f,
    value: g,
    onChange: I,
    isDisabled: i,
    isFocusable: a,
    htmlProps: c
  };
}
const [Lj, Jv] = Bt({
  name: "RadioGroupContext",
  strict: !1
}), qv = Pe((e, t) => {
  const {
    colorScheme: n,
    size: r,
    variant: o,
    children: i,
    className: a,
    isDisabled: u,
    isFocusable: c,
    ...d
  } = e, { value: f, onChange: p, getRootProps: g, name: m, htmlProps: b } = Yv(d), v = at(
    () => ({
      name: m,
      size: r,
      onChange: p,
      colorScheme: n,
      value: f,
      variant: o,
      isDisabled: u,
      isFocusable: c
    }),
    [
      m,
      r,
      p,
      n,
      f,
      o,
      u,
      c
    ]
  );
  return /* @__PURE__ */ x.jsx(Lj, { value: v, children: /* @__PURE__ */ x.jsx(
    ye.div,
    {
      ...g(b, t),
      className: _e("chakra-radio-group", a),
      children: i
    }
  ) });
});
qv.displayName = "RadioGroup";
function Kv(e = {}) {
  const {
    defaultChecked: t,
    isChecked: n,
    isFocusable: r,
    isDisabled: o,
    isReadOnly: i,
    isRequired: a,
    onChange: u,
    isInvalid: c,
    name: d,
    value: f,
    id: p,
    "data-radiogroup": g,
    "aria-describedby": m,
    ...b
  } = e, v = `radio-${Zr()}`, y = ws(), I = !!Jv() || !!g;
  let M = !!y && !I ? y.id : v;
  M = p ?? M;
  const L = o ?? (y == null ? void 0 : y.isDisabled), R = i ?? (y == null ? void 0 : y.isReadOnly), _ = a ?? (y == null ? void 0 : y.isRequired), H = c ?? (y == null ? void 0 : y.isInvalid), [B, Z] = Ee(!1), [G, se] = Ee(!1), [ue, ce] = Ee(!1), [xe, he] = Ee(!!t), z = typeof n < "u", Y = z ? n : xe, ae = Le(!1);
  Ue(() => dC((de) => {
    ae.current = de;
  }), []);
  const j = q(
    (de) => {
      if (R || L) {
        de.preventDefault();
        return;
      }
      z || he(de.currentTarget.checked), u == null || u(de);
    },
    [z, L, R, u]
  ), X = q(
    (de) => {
      de.key === " " && ce(!0);
    },
    [ce]
  ), ie = q(
    (de) => {
      de.key === " " && ce(!1);
    },
    [ce]
  ), W = q(
    (de = {}, Ve = null) => ({
      ...de,
      ref: Ve,
      "data-active": Ne(ue),
      "data-hover": Ne(G),
      "data-disabled": Ne(L),
      "data-invalid": Ne(H),
      "data-checked": Ne(Y),
      "data-focus": Ne(B),
      "data-focus-visible": Ne(B && ae.current),
      "data-readonly": Ne(R),
      "aria-hidden": !0,
      onMouseDown: We(de.onMouseDown, () => ce(!0)),
      onMouseUp: We(de.onMouseUp, () => ce(!1)),
      onMouseEnter: We(
        de.onMouseEnter,
        () => se(!0)
      ),
      onMouseLeave: We(
        de.onMouseLeave,
        () => se(!1)
      )
    }),
    [
      ue,
      G,
      L,
      H,
      Y,
      B,
      R
    ]
  ), { onFocus: re, onBlur: te } = y ?? {}, ee = q(
    (de = {}, Ve = null) => {
      const K = L && !r;
      return {
        ...de,
        id: M,
        ref: Ve,
        type: "radio",
        name: d,
        value: f,
        onChange: We(de.onChange, j),
        onBlur: We(
          te,
          de.onBlur,
          () => Z(!1)
        ),
        onFocus: We(
          re,
          de.onFocus,
          () => Z(!0)
        ),
        onKeyDown: We(de.onKeyDown, X),
        onKeyUp: We(de.onKeyUp, ie),
        checked: Y,
        disabled: K,
        readOnly: R,
        required: _,
        "aria-invalid": $o(H),
        "aria-disabled": $o(K),
        "aria-required": $o(_),
        "data-readonly": Ne(R),
        "aria-describedby": m,
        style: gC
      };
    },
    [
      L,
      r,
      M,
      d,
      f,
      j,
      te,
      re,
      X,
      ie,
      Y,
      R,
      _,
      H,
      m
    ]
  );
  return {
    state: {
      isInvalid: H,
      isFocused: B,
      isChecked: Y,
      isActive: ue,
      isHovered: G,
      isDisabled: L,
      isReadOnly: R,
      isRequired: _
    },
    getRadioProps: W,
    getInputProps: ee,
    getLabelProps: (de = {}, Ve = null) => ({
      ...de,
      ref: Ve,
      onMouseDown: We(de.onMouseDown, Mj),
      "data-disabled": Ne(L),
      "data-checked": Ne(Y),
      "data-invalid": Ne(H)
    }),
    getRootProps: (de, Ve = null) => ({
      htmlFor: M,
      ...de,
      ref: Ve,
      "data-disabled": Ne(L),
      "data-checked": Ne(Y),
      "data-invalid": Ne(H)
    }),
    htmlProps: b
  };
}
function Mj(e) {
  e.preventDefault(), e.stopPropagation();
}
const Qv = Pe((e, t) => {
  const n = Jv(), { onChange: r, value: o } = e, i = Rn("Radio", { ...n, ...e }), a = rn(e), {
    spacing: u = "0.5rem",
    children: c,
    isDisabled: d = n == null ? void 0 : n.isDisabled,
    isFocusable: f = n == null ? void 0 : n.isFocusable,
    inputProps: p,
    ...g
  } = a;
  let m = e.isChecked;
  (n == null ? void 0 : n.value) != null && o != null && (m = n.value === o);
  let b = r;
  n != null && n.onChange && o != null && (b = _f(n.onChange, r));
  const v = (e == null ? void 0 : e.name) ?? (n == null ? void 0 : n.name), {
    getInputProps: y,
    getRadioProps: w,
    getLabelProps: I,
    getRootProps: V,
    htmlProps: M
  } = Kv({
    ...g,
    isChecked: m,
    isFocusable: f,
    isDisabled: d,
    onChange: b,
    name: v
  }), [L, R] = Wp(M, Qp), _ = w(R), H = y(p, t), B = I(), Z = Object.assign({}, L, V()), G = {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative",
    ...i.container
  }, se = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...i.control
  }, ue = {
    userSelect: "none",
    marginStart: u,
    ...i.label
  };
  return /* @__PURE__ */ x.jsxs(ye.label, { className: "chakra-radio", ...Z, __css: G, children: [
    /* @__PURE__ */ x.jsx("input", { className: "chakra-radio__input", ...H }),
    /* @__PURE__ */ x.jsx(
      ye.span,
      {
        className: "chakra-radio__control",
        ..._,
        __css: se
      }
    ),
    c && /* @__PURE__ */ x.jsx(
      ye.span,
      {
        className: "chakra-radio__label",
        ...B,
        __css: ue,
        children: c
      }
    )
  ] });
});
Qv.displayName = "Radio";
const eb = Pe(
  function(t, n) {
    const { children: r, placeholder: o, className: i, ...a } = t;
    return /* @__PURE__ */ x.jsxs(
      ye.select,
      {
        ...a,
        ref: n,
        className: _e("chakra-select", i),
        children: [
          o && /* @__PURE__ */ x.jsx("option", { value: "", children: o }),
          r
        ]
      }
    );
  }
);
eb.displayName = "SelectField";
const tb = Pe((e, t) => {
  var V;
  const n = Rn("Select", e), {
    rootProps: r,
    placeholder: o,
    icon: i,
    color: a,
    height: u,
    h: c,
    minH: d,
    minHeight: f,
    iconColor: p,
    iconSize: g,
    ...m
  } = rn(e), [b, v] = Wp(m, Qp), y = y3(v), w = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: a
  }, I = {
    paddingEnd: "2rem",
    ...n.field,
    _focus: {
      zIndex: "unset",
      ...(V = n.field) == null ? void 0 : V._focus
    }
  };
  return /* @__PURE__ */ x.jsxs(
    ye.div,
    {
      className: "chakra-select__wrapper",
      __css: w,
      ...b,
      ...r,
      children: [
        /* @__PURE__ */ x.jsx(
          eb,
          {
            ref: t,
            height: c ?? u,
            minH: d ?? f,
            placeholder: o,
            ...y,
            __css: I,
            children: e.children
          }
        ),
        /* @__PURE__ */ x.jsx(
          nb,
          {
            "data-disabled": Ne(y.disabled),
            ...(p || a) && { color: p || a },
            __css: n.icon,
            ...g && { fontSize: g },
            children: i
          }
        )
      ]
    }
  );
});
tb.displayName = "Select";
const Pj = (e) => /* @__PURE__ */ x.jsx("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ x.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }
) }), Ej = ye("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
}), nb = (e) => {
  const { children: t = /* @__PURE__ */ x.jsx(Pj, {}), ...n } = e, r = bo(t, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: !1,
    "aria-hidden": !0,
    // force icon to adhere to `IconWrapper` styles
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ x.jsx(Ej, { ...n, className: "chakra-select__icon-wrapper", children: Da(t) ? r : null });
};
nb.displayName = "SelectIcon";
const rb = (e) => /* @__PURE__ */ x.jsx(
  ye.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
rb.displayName = "StackItem";
function Rj(e) {
  const { spacing: t, direction: n } = e, r = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": jL(
      n,
      (o) => r[o]
    )
  };
}
const ob = Pe((e, t) => {
  const {
    isInline: n,
    direction: r,
    align: o,
    justify: i,
    spacing: a = "0.5rem",
    wrap: u,
    children: c,
    divider: d,
    className: f,
    shouldWrapChildren: p,
    ...g
  } = e, m = n ? "row" : r ?? "column", b = at(
    () => Rj({ spacing: a, direction: m }),
    [a, m]
  ), v = !!d, y = !p && !v, w = at(() => {
    const V = Bp(c);
    return y ? V : V.map((M, L) => {
      const R = typeof M.key < "u" ? M.key : L, _ = L + 1 === V.length, B = p ? /* @__PURE__ */ x.jsx(rb, { children: M }, R) : M;
      if (!v)
        return B;
      const Z = bo(
        d,
        {
          __css: b
        }
      ), G = _ ? null : Z;
      return /* @__PURE__ */ x.jsxs(ol, { children: [
        B,
        G
      ] }, R);
    });
  }, [
    d,
    b,
    v,
    y,
    p,
    c
  ]), I = _e("chakra-stack", f);
  return /* @__PURE__ */ x.jsx(
    ye.div,
    {
      ref: t,
      display: "flex",
      alignItems: o,
      justifyContent: i,
      flexDirection: m,
      flexWrap: u,
      gap: v ? void 0 : a,
      className: I,
      ...g,
      children: w
    }
  );
});
ob.displayName = "Stack";
const sf = Pe((e, t) => /* @__PURE__ */ x.jsx(ob, { align: "center", ...e, direction: "row", ref: t }));
sf.displayName = "HStack";
const ib = Pe(
  function(t, n) {
    const r = Rn("Switch", t), {
      spacing: o = "0.5rem",
      children: i,
      ...a
    } = rn(t), {
      getIndicatorProps: u,
      getInputProps: c,
      getCheckboxProps: d,
      getRootProps: f,
      getLabelProps: p
    } = mC(a), g = at(
      () => ({
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        lineHeight: 0,
        ...r.container
      }),
      [r.container]
    ), m = at(
      () => ({
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "flex-start",
        boxSizing: "content-box",
        cursor: "pointer",
        ...r.track
      }),
      [r.track]
    ), b = at(
      () => ({
        userSelect: "none",
        marginStart: o,
        ...r.label
      }),
      [o, r.label]
    );
    return /* @__PURE__ */ x.jsxs(
      ye.label,
      {
        ...f(),
        className: _e("chakra-switch", t.className),
        __css: g,
        children: [
          /* @__PURE__ */ x.jsx("input", { className: "chakra-switch__input", ...c({}, n) }),
          /* @__PURE__ */ x.jsx(
            ye.span,
            {
              ...d(),
              className: "chakra-switch__track",
              __css: m,
              children: /* @__PURE__ */ x.jsx(
                ye.span,
                {
                  __css: r.thumb,
                  className: "chakra-switch__thumb",
                  ...u()
                }
              )
            }
          ),
          i && /* @__PURE__ */ x.jsx(
            ye.span,
            {
              className: "chakra-switch__label",
              ...p(),
              __css: b,
              children: i
            }
          )
        ]
      }
    );
  }
);
ib.displayName = "Switch";
const [_j, Rl] = Bt({
  name: "TableStylesContext",
  errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
}), sb = Pe((e, t) => {
  const n = Rn("Table", e), { className: r, layout: o, ...i } = rn(e);
  return /* @__PURE__ */ x.jsx(_j, { value: n, children: /* @__PURE__ */ x.jsx(
    ye.table,
    {
      ref: t,
      __css: { tableLayout: o, ...n.table },
      className: _e("chakra-table", r),
      ...i
    }
  ) });
});
sb.displayName = "Table";
const Tj = Pe((e, t) => {
  const n = Rl();
  return /* @__PURE__ */ x.jsx(ye.tbody, { ...e, ref: t, __css: n.tbody });
}), Hj = Pe(
  ({ isNumeric: e, ...t }, n) => {
    const r = Rl();
    return /* @__PURE__ */ x.jsx(
      ye.td,
      {
        ...t,
        ref: n,
        __css: r.td,
        "data-is-numeric": e
      }
    );
  }
), Fj = Pe(
  ({ isNumeric: e, ...t }, n) => {
    const r = Rl();
    return /* @__PURE__ */ x.jsx(
      ye.th,
      {
        ...t,
        ref: n,
        __css: r.th,
        "data-is-numeric": e
      }
    );
  }
), kj = Pe((e, t) => {
  const n = Rl();
  return /* @__PURE__ */ x.jsx(ye.thead, { ...e, ref: t, __css: n.thead });
}), q8 = Pe((e, t) => {
  const n = Rl();
  return /* @__PURE__ */ x.jsx(ye.tr, { ...e, ref: t, __css: n.tr });
}), Bj = ["h", "minH", "height", "minHeight"], ab = Pe((e, t) => {
  const n = Ss("Textarea", e), { className: r, rows: o, ...i } = rn(e), a = y3(i), u = o ? p2(n, Bj) : n;
  return /* @__PURE__ */ x.jsx(
    ye.textarea,
    {
      ref: t,
      rows: o,
      ...a,
      className: _e("chakra-textarea", r),
      __css: u
    }
  );
});
ab.displayName = "Textarea";
const Dj = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
}, af = (e) => {
  var t;
  return ((t = e.current) == null ? void 0 : t.ownerDocument) || document;
}, Hc = (e) => {
  var t, n;
  return ((n = (t = e.current) == null ? void 0 : t.ownerDocument) == null ? void 0 : n.defaultView) || window;
};
function Oj(e = {}) {
  const {
    openDelay: t = 0,
    closeDelay: n = 0,
    closeOnClick: r = !0,
    closeOnMouseDown: o,
    closeOnScroll: i,
    closeOnPointerDown: a = o,
    closeOnEsc: u = !0,
    onOpen: c,
    onClose: d,
    placement: f,
    id: p,
    isOpen: g,
    defaultIsOpen: m,
    arrowSize: b = 10,
    arrowShadowColor: v,
    arrowPadding: y,
    modifiers: w,
    isDisabled: I,
    gutter: V,
    offset: M,
    direction: L,
    ...R
  } = e, { isOpen: _, onOpen: H, onClose: B } = Xp({
    isOpen: g,
    defaultIsOpen: m,
    onOpen: c,
    onClose: d
  }), { referenceRef: Z, getPopperProps: G, getArrowInnerProps: se, getArrowProps: ue } = bv({
    enabled: _,
    placement: f,
    arrowPadding: y,
    modifiers: w,
    gutter: V,
    offset: M,
    direction: L
  }), ce = Zr(), he = `tooltip-${p ?? ce}`, z = Le(null), Y = Le(void 0), ae = q(() => {
    Y.current && (clearTimeout(Y.current), Y.current = void 0);
  }, []), j = Le(void 0), X = q(() => {
    j.current && (clearTimeout(j.current), j.current = void 0);
  }, []), ie = q(() => {
    X(), B();
  }, [B, X]), W = Nj(z, ie), re = q(() => {
    if (!I && !Y.current) {
      _ && W();
      const K = Hc(z);
      Y.current = K.setTimeout(H, t);
    }
  }, [W, I, _, H, t]), te = q(() => {
    ae();
    const K = Hc(z);
    j.current = K.setTimeout(ie, n);
  }, [n, ie, ae]), ee = q(() => {
    _ && r && te();
  }, [r, te, _]), ge = q(() => {
    _ && a && te();
  }, [a, te, _]), pe = q(
    (K) => {
      _ && K.key === "Escape" && te();
    },
    [_, te]
  );
  N1(
    () => af(z),
    "keydown",
    u ? pe : void 0
  ), N1(
    () => {
      if (!i)
        return null;
      const K = z.current;
      if (!K)
        return null;
      const Ye = zp(K);
      return Ye.localName === "body" ? Hc(z) : Ye;
    },
    "scroll",
    () => {
      _ && i && ie();
    },
    { passive: !0, capture: !0 }
  ), Ue(() => {
    I && (ae(), _ && B());
  }, [I, _, B, ae]), Ue(() => () => {
    ae(), X();
  }, [ae, X]), N1(() => z.current, "pointerleave", te);
  const Se = q(
    (K = {}, Ye = null) => ({
      ...K,
      ref: mn(z, Ye, Z),
      onPointerEnter: We(K.onPointerEnter, (ot) => {
        ot.pointerType !== "touch" && re();
      }),
      onClick: We(K.onClick, ee),
      onPointerDown: We(K.onPointerDown, ge),
      onFocus: We(K.onFocus, re),
      onBlur: We(K.onBlur, te),
      "aria-describedby": _ ? he : void 0
    }),
    [
      re,
      te,
      ge,
      _,
      he,
      ee,
      Z
    ]
  ), de = q(
    (K = {}, Ye = null) => G(
      {
        ...K,
        style: {
          ...K.style,
          [In.arrowSize.var]: b ? `${b}px` : void 0,
          [In.arrowShadowColor.var]: v
        }
      },
      Ye
    ),
    [G, b, v]
  ), Ve = q(
    (K = {}, Ye = null) => {
      const ve = {
        ...K.style,
        position: "relative",
        transformOrigin: In.transformOrigin.varRef
      };
      return {
        ref: Ye,
        ...R,
        ...K,
        id: he,
        role: "tooltip",
        style: ve
      };
    },
    [R, he]
  );
  return {
    isOpen: _,
    show: re,
    hide: te,
    getTriggerProps: Se,
    getTooltipProps: Ve,
    getTooltipPositionerProps: de,
    getArrowProps: ue,
    getArrowInnerProps: se
  };
}
const Kd = "chakra-ui:close-tooltip";
function Nj(e, t) {
  return Ue(() => {
    const n = af(e);
    return n.addEventListener(Kd, t), () => n.removeEventListener(Kd, t);
  }, [t, e]), () => {
    const n = af(e), r = Hc(e);
    n.dispatchEvent(new r.CustomEvent(Kd));
  };
}
const Zj = ye(xo.div), t4 = Pe((e, t) => {
  const n = Ss("Tooltip", e), r = rn(e), o = V2(), {
    children: i,
    label: a,
    shouldWrapChildren: u,
    "aria-label": c,
    hasArrow: d,
    bg: f,
    portalProps: p,
    background: g,
    backgroundColor: m,
    bgColor: b,
    motionProps: v,
    animatePresenceProps: y,
    ...w
  } = r, I = g ?? m ?? f ?? b;
  if (I) {
    n.bg = I;
    const Z = JM(o, "colors", I);
    n[In.arrowBg.var] = Z;
  }
  const V = Oj({ ...w, direction: o.direction }), M = !Da(i) || u;
  let L;
  if (M)
    L = /* @__PURE__ */ x.jsx(
      ye.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...V.getTriggerProps(),
        children: i
      }
    );
  else {
    const Z = d2.only(i);
    L = bo(
      Z,
      V.getTriggerProps(Z.props, Vj(Z))
    );
  }
  const R = !!c, _ = V.getTooltipProps({}, t), H = R ? p2(_, ["role", "id"]) : _, B = $p(_, ["role", "id"]);
  return a ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    L,
    /* @__PURE__ */ x.jsx(Ri, { ...y, children: V.isOpen && /* @__PURE__ */ x.jsx(Na, { ...p, children: /* @__PURE__ */ x.jsx(
      ye.div,
      {
        ...V.getTooltipPositionerProps(),
        __css: {
          zIndex: n.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ x.jsxs(
          Zj,
          {
            variants: Dj,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...v,
            ...H,
            __css: n,
            children: [
              a,
              R && /* @__PURE__ */ x.jsx(ye.span, { srOnly: !0, ...B, children: c }),
              d && /* @__PURE__ */ x.jsx(
                ye.div,
                {
                  "data-popper-arrow": !0,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ x.jsx(
                    ye.div,
                    {
                      "data-popper-arrow-inner": !0,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: n.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] }) : /* @__PURE__ */ x.jsx(x.Fragment, { children: i });
});
t4.displayName = "Tooltip";
const $j = "#E8F4FE", zj = "#F8FBFE", Wj = "#40A7FF", K8 = "#E4E8EC", Gj = "#728291", jj = "#394D60", Xj = jj, Uj = "#F23636", Yj = $j, Jj = zj, qj = {
  primary: Wj,
  primaryBackground: Yj,
  secondaryBackground: Jj,
  disabled: K8,
  textSecondary: Xj,
  inputLabelText: Gj,
  border: K8,
  danger: Uj
}, Ce = {
  white: "#FFFFFF",
  black: "#000000",
  gray: "#9CA6AF",
  "gray.50": "#FAFAFA",
  "gray.100": "#F7F7F7",
  "gray.200": "#E7E7E7",
  "gray.300": "#CDD3D7",
  "gray.350": "#394D6015",
  "gray.400": "#E1E4E7",
  "gray.600": "#728291",
  "gray.650": "#657888",
  "gray.675": "#465C72",
  "gray.700": "#394D60",
  "gray.800": "#45525F",
  "gray.900": "#072138",
  "red.200": "#F4CCCD",
  "red.400": "#FA3C48",
  "red.700": "#CE161B",
  "orange.100": "#FBE7C3",
  "orange.500": "#EE9611",
  "orange.600": "#D55E00",
  "yellow.200": "#FFF6C7",
  "yellow.400": "#FFD600",
  lightYellow: "#FFFFE0",
  // maps to `lightyellow` named color
  "green.200": "#E0F4F0",
  "green.300": "#C7EBE3",
  "green.500": "#00A67F",
  "green.600": "#019E73",
  "green.700": "#087742",
  navy: "#3455DB",
  "navy.50": "#F4F7FF",
  "navy.100": "#EDF0FF",
  "navy.200": "#DAE1FE",
  "navy.250": "#D2E4F4",
  "navy.300": "#3455DB20",
  "navy.400": "#9CAFFF",
  "navy.450": "#5C76E2",
  "navy.600": "#2240B9",
  "navy.700": "#0072B2",
  "navy.800": "#00008B",
  "navy.900": "#1F364E",
  "pink.500": "#CC79A7",
  "purple.500": "#9552ee",
  "lavender.100": "#E6D7FC",
  "lavender.500": "#9552EE",
  "tiers.1": "#008B8B",
  "tiers.2": "#2A9570",
  "tiers.3": "#619B4E",
  "tiers.4": "#999933",
  "tiers.5": "#a17f2b",
  "tiers.6": "#b36d20",
  "tiers.7": "#d45a1d",
  "tiers.8": "#f04619",
  "tiers.9": "#f02c00",
  "tiers.10": "#FF0000"
}, Kj = {
  // Buttons
  buttonDefault: Ce.navy,
  buttonHover: Ce["navy.600"],
  buttonActive: Ce["navy.800"],
  // Non-button interactive items
  selected1: Ce["navy.100"],
  selected2: Ce.navy,
  selected3: Ce["navy.900"],
  selected4: Ce["navy.200"],
  selected5: Ce["lavender.100"],
  hover1: Ce["navy.50"],
  hover2: Ce["navy.400"],
  hoverTransparent: Ce["navy.300"],
  hoverTransparentLight: Ce["gray.350"],
  disabledFill: Ce["gray.100"],
  // Strokes
  strokeDefault: Ce["gray.300"],
  strokeLight: Ce["gray.200"],
  strokeHover: Ce.gray,
  strokeActive: Ce["gray.600"],
  strokeInteractive: Ce["gray.800"],
  // Surfaces
  surface1: Ce.white,
  surface2: Ce["gray.100"],
  surface3: Ce["navy.50"],
  surface4: Ce["gray.200"],
  surface5: Ce["gray.700"],
  surface6: Ce["gray.50"],
  surface7: Ce["gray.400"],
  surface8: Ce["green.200"],
  // Surface Accents
  surfaceAccent1: Ce["navy.600"],
  surfaceAccent2: Ce["navy.900"],
  surfaceAccent3: Ce["navy.800"],
  surfaceAccent4: Ce.navy,
  surfaceAccent5: Ce["navy.400"],
  surfaceAccent6: Ce["navy.450"],
  surfaceAccent7: Ce["gray.700"],
  surfaceAccent8: Ce["green.200"],
  surfaceAccent9: Ce.black,
  surfaceAccent10: Ce["lavender.500"],
  surfaceRequiredField: Ce["yellow.200"],
  surfaceReadonly: Ce["gray.400"],
  alertSuccess: Ce["green.600"],
  alertError: Ce["red.700"],
  alertWarning: Ce["yellow.400"],
  alertSuccessLight: Ce["green.300"],
  alertErrorLight: Ce["red.200"],
  alertWarningLight: Ce["orange.100"],
  alertInfoLight: Ce["navy.250"],
  // Text
  textPrimary: Ce["gray.900"],
  textSecondary: Ce["gray.700"],
  textTertiary: Ce["gray.650"],
  textOffset: Ce.white,
  textDisabled: Ce.gray,
  textError: Ce["red.700"],
  textSuccess: Ce["green.700"],
  textWarning: Ce["orange.600"],
  textLight: Ce["gray.675"],
  // Status
  statusOverdue: Ce["red.400"],
  statusInProgress: Ce["yellow.400"],
  statusComplete: Ce["green.600"],
  statusWarning: Ce["orange.500"],
  // Pins
  pinSold: Ce["navy.700"],
  pinPending: Ce["pink.500"],
  pinActive: Ce["green.600"],
  pinRented: Ce["orange.600"],
  pinOffMarket: Ce["gray.650"],
  pinOther: Ce["gray.900"],
  pinSubject: Ce["orange.500"],
  // Graphs
  graphBackground: Ce.white,
  graphAreaBackground: "#5C76E250",
  graphAreaBackgroundOpaque: "#5C76E2",
  graphChart: "#0072B2",
  graphChart2: "#B83280",
  graphChart3: "#CC79A7",
  graphChart4: "#FFA500",
  graphAdverse: "#D55E00",
  graphNeutral: "#657888",
  graphBeneficial: "#019E73",
  graphMedian: "#F5A623",
  graphAverage: "#E8619A",
  /** @deprecated - Use textError instead */
  error: Ce["red.700"],
  // TODO: Replace with textError
  /** @deprecated - Use textSuccess instead */
  success: Ce["green.700"],
  // TODO: Replace with textSuccess
  // Other
  aiv: Ce["yellow.400"],
  aivLight: Ce["yellow.200"],
  aivText: Ce["gray.900"],
  arv: Ce["green.500"],
  arvLight: Ce["green.200"],
  arvText: Ce.white,
  transparent: "#00000000",
  /** @deprecated - Use 'transparent' instead */
  none: "#00000000",
  // @ts-expect-error hacking our way to not overriding colors
  // eslint-disable-next-line object-shorthand
  undefined: void 0,
  // Quality tiers
  qualityTier1: Ce["tiers.1"],
  qualityTier2: Ce["tiers.2"],
  qualityTier3: Ce["tiers.3"],
  qualityTier4: Ce["tiers.4"],
  qualityTier5: Ce["tiers.5"],
  qualityTier6: Ce["tiers.6"],
  qualityTier7: Ce["tiers.7"],
  qualityTier8: Ce["tiers.8"],
  qualityTier9: Ce["tiers.9"],
  qualityTier10: Ce["tiers.10"]
}, _r = {
  ...qj,
  ...Kj,
  // all these are sorta hacky ways to use existing chakra components but hijacked with aloft colors
  // too tricky to figure out all the component style configs without TS help
  aloft: {
    100: Ce["navy.50"]
  },
  green: {
    500: Ce["green.600"]
  },
  red: {
    500: Ce["red.400"]
  },
  orange: {
    500: Ce["yellow.400"]
  },
  blue: {
    500: Ce.navy
  }
}, Qj = {
  background: "#FFFFFF",
  backgroundAccent: "#1F364E",
  backgroundAccentDark: "#394D60",
  backgroundAccentLight: "#3C70A7",
  strokeLight: "#EBEDEF",
  surface: "#F0F0F0",
  surfaceLight: "#FAFAFA",
  text: "#072138",
  textLight: "#465C72",
  textAccent: "#73A9EF",
  border: "#E0E0E0",
  borderDark: "#E1E1E1",
  positive: "#008646",
  negative: "#CE161B",
  aivBackground: "#FFD600",
  arvBackground: "#00A67F"
}, Q8 = {
  Accordion: {
    parts: ["container"],
    baseStyle: {
      container: {
        borderStyle: "solid",
        borderColor: "gray.200"
      }
    }
  }
}, eX = {
  ...Q8,
  Accordion: {
    ...Q8.Accordion,
    variants: {
      default: {
        button: {
          backgroundColor: "surface2"
        }
      }
    }
  }
};
function Vn(e, t) {
  tX(e) && (e = "100%");
  var n = nX(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function uc(e) {
  return Math.min(1, Math.max(0, e));
}
function tX(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function nX(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function lb(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function cc(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function os(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function rX(e, t, n) {
  return {
    r: Vn(e, 255) * 255,
    g: Vn(t, 255) * 255,
    b: Vn(n, 255) * 255
  };
}
function eh(e, t, n) {
  e = Vn(e, 255), t = Vn(t, 255), n = Vn(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i = 0, a = 0, u = (r + o) / 2;
  if (r === o)
    a = 0, i = 0;
  else {
    var c = r - o;
    switch (a = u > 0.5 ? c / (2 - r - o) : c / (r + o), r) {
      case e:
        i = (t - n) / c + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / c + 2;
        break;
      case n:
        i = (e - t) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: a, l: u };
}
function Qd(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function oX(e, t, n) {
  var r, o, i;
  if (e = Vn(e, 360), t = Vn(t, 100), n = Vn(n, 100), t === 0)
    o = n, i = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, u = 2 * n - a;
    r = Qd(u, a, e + 1 / 3), o = Qd(u, a, e), i = Qd(u, a, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: i * 255 };
}
function th(e, t, n) {
  e = Vn(e, 255), t = Vn(t, 255), n = Vn(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i = 0, a = r, u = r - o, c = r === 0 ? 0 : u / r;
  if (r === o)
    i = 0;
  else {
    switch (r) {
      case e:
        i = (t - n) / u + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / u + 2;
        break;
      case n:
        i = (e - t) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: a };
}
function iX(e, t, n) {
  e = Vn(e, 360) * 6, t = Vn(t, 100), n = Vn(n, 100);
  var r = Math.floor(e), o = e - r, i = n * (1 - t), a = n * (1 - o * t), u = n * (1 - (1 - o) * t), c = r % 6, d = [n, a, i, i, u, n][c], f = [u, n, n, a, i, i][c], p = [i, i, u, n, n, a][c];
  return { r: d * 255, g: f * 255, b: p * 255 };
}
function nh(e, t, n, r) {
  var o = [
    os(Math.round(e).toString(16)),
    os(Math.round(t).toString(16)),
    os(Math.round(n).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function sX(e, t, n, r, o) {
  var i = [
    os(Math.round(e).toString(16)),
    os(Math.round(t).toString(16)),
    os(Math.round(n).toString(16)),
    os(aX(r))
  ];
  return o && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function aX(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function rh(e) {
  return cr(e) / 255;
}
function cr(e) {
  return parseInt(e, 16);
}
function lX(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var lf = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function uX(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, o = null, i = null, a = !1, u = !1;
  return typeof e == "string" && (e = fX(e)), typeof e == "object" && (Ho(e.r) && Ho(e.g) && Ho(e.b) ? (t = rX(e.r, e.g, e.b), a = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ho(e.h) && Ho(e.s) && Ho(e.v) ? (r = cc(e.s), o = cc(e.v), t = iX(e.h, r, o), a = !0, u = "hsv") : Ho(e.h) && Ho(e.s) && Ho(e.l) && (r = cc(e.s), i = cc(e.l), t = oX(e.h, r, i), a = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = lb(n), {
    ok: a,
    format: e.format || u,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var cX = "[-\\+]?\\d+%?", dX = "[-\\+]?\\d*\\.\\d+%?", xi = "(?:".concat(dX, ")|(?:").concat(cX, ")"), e5 = "[\\s|\\(]+(".concat(xi, ")[,|\\s]+(").concat(xi, ")[,|\\s]+(").concat(xi, ")\\s*\\)?"), t5 = "[\\s|\\(]+(".concat(xi, ")[,|\\s]+(").concat(xi, ")[,|\\s]+(").concat(xi, ")[,|\\s]+(").concat(xi, ")\\s*\\)?"), Jr = {
  CSS_UNIT: new RegExp(xi),
  rgb: new RegExp("rgb" + e5),
  rgba: new RegExp("rgba" + t5),
  hsl: new RegExp("hsl" + e5),
  hsla: new RegExp("hsla" + t5),
  hsv: new RegExp("hsv" + e5),
  hsva: new RegExp("hsva" + t5),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function fX(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (lf[e])
    e = lf[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Jr.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Jr.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Jr.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Jr.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Jr.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Jr.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Jr.hex8.exec(e), n ? {
    r: cr(n[1]),
    g: cr(n[2]),
    b: cr(n[3]),
    a: rh(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Jr.hex6.exec(e), n ? {
    r: cr(n[1]),
    g: cr(n[2]),
    b: cr(n[3]),
    format: t ? "name" : "hex"
  } : (n = Jr.hex4.exec(e), n ? {
    r: cr(n[1] + n[1]),
    g: cr(n[2] + n[2]),
    b: cr(n[3] + n[3]),
    a: rh(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Jr.hex3.exec(e), n ? {
    r: cr(n[1] + n[1]),
    g: cr(n[2] + n[2]),
    b: cr(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Ho(e) {
  return !!Jr.CSS_UNIT.exec(String(e));
}
var _2 = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = lX(t)), this.originalInput = t;
      var o = uX(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, o, i = t.r / 255, a = t.g / 255, u = t.b / 255;
      return i <= 0.03928 ? n = i / 12.92 : n = Math.pow((i + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), u <= 0.03928 ? o = u / 12.92 : o = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = lb(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = th(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = th(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = eh(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = eh(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), nh(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), sX(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(Vn(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(Vn(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + nh(this.r, this.g, this.b, !1), n = 0, r = Object.entries(lf); n < r.length; n++) {
        var o = r[n], i = o[0], a = o[1];
        if (t === a)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, o = this.a < 1 && this.a >= 0, i = !n && o && (t.startsWith("hex") || t === "name");
      return i ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = uc(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = uc(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = uc(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = uc(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), o = new e(t).toRgb(), i = n / 100, a = {
        r: (o.r - r.r) * i + r.r,
        g: (o.g - r.g) * i + r.g,
        b: (o.b - r.b) * i + r.b,
        a: (o.a - r.a) * i + r.a
      };
      return new e(a);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), o = 360 / n, i = [this];
      for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + o) % 360, i.push(new e(r));
      return i;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, o = n.s, i = n.v, a = [], u = 1 / t; t--; )
        a.push(new e({ h: r, s: o, v: i })), i = (i + u) % 1;
      return a;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), o = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / o,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / o,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, o = [this], i = 360 / t, a = 1; a < t; a++)
        o.push(new e({ h: (r + a * i) % 360, s: n.s, l: n.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function hX(e) {
  return Array.isArray(e);
}
function pX(e) {
  var t = typeof e;
  return e != null && (t === "object" || t === "function") && !hX(e);
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function gX(e, t, n, r) {
  var o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
var mX = function(t) {
  var n = /* @__PURE__ */ new WeakMap(), r = function(i, a, u, c) {
    if (typeof i > "u")
      return t(i, a, u);
    n.has(i) || n.set(i, /* @__PURE__ */ new Map());
    var d = n.get(i);
    if (d.has(a))
      return d.get(a);
    var f = t(i, a, u, c);
    return d.set(a, f), f;
  };
  return r;
}, CX = mX(gX), n4 = function(t, n, r) {
  var o = CX(t, "colors." + n, n), i = new _2(o), a = i.isValid;
  return a ? o : r;
}, Ft = function(t, n) {
  return function(r) {
    var o = n4(r, t);
    return new _2(o).setAlpha(n).toRgbString();
  };
}, qr = function(t, n) {
  return function(r) {
    var o = n4(r, t);
    return new _2(o).darken(n).toHexString();
  };
}, n5 = function(t, n) {
  return function(r) {
    return new _2(n4(r, t)).lighten(n).toHexString();
  };
};
function ub(e) {
  return pX(e) && e.reference ? e.reference : String(e);
}
var T2 = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return r.map(ub).join(" " + t + " ").replace(/calc/g, "");
}, oh = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + T2.apply(void 0, ["+"].concat(n)) + ")";
}, ih = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + T2.apply(void 0, ["-"].concat(n)) + ")";
}, uf = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + T2.apply(void 0, ["*"].concat(n)) + ")";
}, sh = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + T2.apply(void 0, ["/"].concat(n)) + ")";
}, ah = function(t) {
  var n = ub(t);
  return n != null && !Number.isNaN(parseFloat(n)) ? String(n).startsWith("-") ? String(n).slice(1) : "-" + n : uf(n, -1);
}, L1 = Object.assign(function(e) {
  return {
    add: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return L1(oh.apply(void 0, [e].concat(r)));
    },
    subtract: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return L1(ih.apply(void 0, [e].concat(r)));
    },
    multiply: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return L1(uf.apply(void 0, [e].concat(r)));
    },
    divide: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return L1(sh.apply(void 0, [e].concat(r)));
    },
    negate: function() {
      return L1(ah(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: oh,
  subtract: ih,
  multiply: uf,
  divide: sh,
  negate: ah
});
const Kc = {
  Button: {
    // nope -- use SoundUI
    // baseStyle: {
    //     borderRadius: 'sm',
    //     _focus: {
    //         boxShadow: 'none',
    //     },
    // },
    variants: {
      filled: {
        color: "white",
        backgroundColor: "primary",
        _hover: {
          backgroundColor: qr("primary", 10),
          _disabled: {
            backgroundColor: "disabled"
          }
        },
        _focus: {
          backgroundColor: qr("primary", 10)
        },
        _active: {
          backgroundColor: qr("primary", 20)
        },
        _disabled: {
          backgroundColor: "disabled",
          color: qr("disabled", 50)
        }
      },
      outline: {
        color: "primary",
        backgroundColor: "transparent",
        borderColor: "border",
        borderWidth: "1px",
        borderStyle: "solid",
        _hover: {
          backgroundColor: n5("primary", 35)
        },
        _focus: {
          backgroundColor: n5("primary", 35)
        },
        _active: {
          backgroundColor: n5("primary", 30)
        },
        _disabled: {
          color: qr("disabled", 50)
        }
      },
      danger: {
        backgroundColor: "danger",
        color: "white",
        _hover: {
          backgroundColor: qr("danger", 10),
          _disabled: {
            backgroundColor: "danger"
          }
        },
        _focus: {
          backgroundColor: qr("danger", 10)
        },
        _active: {
          backgroundColor: qr("danger", 20)
        }
      }
    },
    defaultProps: {
      variant: "filled"
    }
  }
}, lh = {
  color: "buttonDefault",
  _hover: {
    color: "buttonHover",
    textDecoration: "underline"
  },
  _focus: {
    color: "buttonHover",
    textDecoration: "underline"
  },
  _active: {
    color: "buttonActive",
    textDecoration: "underline"
  }
}, $t = {
  Text: {
    variants: {
      link: lh,
      // headings
      h1: {
        fontSize: "1.5rem",
        fontWeight: "800",
        color: "textPrimary"
      },
      h2: {
        fontSize: "1.25rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h3: {
        fontSize: "1rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h4: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h5: {
        fontSize: "0.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      // bodies 🪦
      body1: {
        fontSize: "0.875rem",
        fontWeight: "400",
        color: "textPrimary",
        maxWidth: "40rem"
        // roughly 100 characters; no super wide lines please
      },
      body2: {
        fontSize: "0.75rem",
        fontWeight: "400",
        color: "textPrimary",
        maxWidth: "40rem"
        // roughly 110 characters; no super wide lines please
      },
      // placeholder
      placeholder: {
        fontSize: "0.875rem",
        fontWeight: "400",
        color: "textTertiary",
        fontStyle: "italic"
      },
      // subtitles
      subtitle1: {
        fontSize: "0.75rem",
        fontWeight: "600",
        color: "textSecondary",
        textTransform: "uppercase"
      },
      subtitle2: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textPrimary",
        textTransform: "uppercase"
      },
      subtitle3: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textSecondary"
      },
      // buttons and chips
      chip: {
        fontSize: "0.75rem",
        fontWeight: "600",
        color: "textPrimary"
      },
      buttonSmall: {
        fontSize: "0.75rem",
        fontWeight: "800",
        color: "typography.white"
      },
      buttonRegular: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "typography.white"
      },
      // tables
      tableColumnTitle: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      tableH1: {
        fontSize: "0.75rem",
        fontWeight: "700",
        color: "textSecondary"
      },
      tableH2: {
        fontSize: "0.75rem",
        fontWeight: "500",
        color: "typography.black"
      },
      tableH3: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textPrimary",
        textTransform: "uppercase"
      },
      tableTag: {
        fontSize: "0.375rem",
        fontWeight: "800",
        color: "textPrimary"
      },
      // displays
      displayLarge: {
        fontSize: "3.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      displayMedium: {
        fontSize: "2.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      displaySmall: {
        fontSize: "1.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      label: {
        fontSize: "1rem",
        fontWeight: "700",
        color: "textPrimary"
      }
    }
  },
  Link: {
    variants: {
      default: lh,
      unstyled: {}
    }
  }
}, vX = {
  color: "textOffset",
  backgroundColor: "buttonDefault",
  _hover: {
    color: "textOffset",
    backgroundColor: "buttonHover",
    _disabled: {
      backgroundColor: Ft("buttonHover", 0.5)
    }
  },
  _focus: {
    color: "textOffset",
    backgroundColor: "buttonHover"
  },
  _active: {
    color: "textOffset",
    backgroundColor: "buttonActive"
  },
  _disabled: {
    color: "textOffset",
    backgroundColor: Ft("buttonDefault", 0.5)
  }
}, bX = {
  backgroundColor: "surface1",
  border: "1px solid",
  color: "buttonDefault",
  borderColor: "buttonDefault",
  _hover: {
    color: "buttonHover",
    borderColor: "buttonHover",
    backgroundColor: "surface1",
    _disabled: {
      backgroundColor: Ft("surface1", 0.5)
    }
  },
  _focus: {
    color: "buttonHover",
    borderColor: "buttonHover",
    backgroundColor: "surface1"
  },
  _active: {
    color: "buttonActive",
    borderColor: "buttonActive",
    backgroundColor: "surface1"
  },
  _disabled: {
    backgroundColor: Ft("surface1", 0.5),
    color: Ft("buttonDefault", 0.5),
    borderColor: Ft("buttonDefault", 0.5)
  }
}, uh = {
  backgroundColor: "textTertiary",
  border: "1px solid",
  borderColor: "strokeDefault",
  color: "textOffset",
  _hover: {
    backgroundColor: "textSecondary",
    borderColor: "strokeHover",
    _disabled: {
      backgroundColor: Ft("strokeHover", 0.5),
      color: Ft("textPrimary", 0.5)
    }
  },
  _focus: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover"
  },
  _active: {
    backgroundColor: "strokeActive",
    borderColor: "strokeActive"
  },
  _disabled: {
    backgroundColor: Ft("textTertiary", 0.5),
    borderColor: Ft("strokeDefault", 0.5),
    color: Ft("textOffset", 0.5)
  }
}, yX = {
  backgroundColor: "strokeDefault",
  border: "1px solid",
  borderColor: "strokeDefault",
  color: "textPrimary",
  _hover: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover",
    _disabled: {
      backgroundColor: Ft("strokeHover", 0.5),
      color: Ft("textPrimary", 0.5)
    }
  },
  _focus: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover"
  },
  _active: {
    backgroundColor: "strokeActive",
    borderColor: "strokeActive"
  },
  _disabled: {
    backgroundColor: Ft("strokeDefault", 0.5),
    borderColor: Ft("strokeDefault", 0.5),
    color: Ft("textPrimary", 0.5)
  }
};
var mp, Cp, vp, bp, yp, xp;
const xX = {
  Button: {
    baseStyle: {
      borderRadius: "4px"
    },
    variants: {
      ...Kc.Button.variants,
      primary: vX,
      danger: {
        color: "textOffset",
        backgroundColor: "error",
        _hover: {
          backgroundColor: qr("error", 5),
          _disabled: {
            backgroundColor: Ft("error", 0.6)
          }
        },
        _focus: {
          backgroundColor: qr("error", 10)
        },
        _active: {
          backgroundColor: qr("error", 15)
        },
        _disabled: {
          backgroundColor: Ft("error", 0.5)
        }
      },
      secondary: bX,
      quaternary: uh,
      inline: {
        padding: "inlineButtonPadding",
        color: "buttonDefault",
        _hover: {
          color: "buttonHover",
          textDecoration: "underline",
          textUnderlineOffset: "2px",
          _disabled: {
            color: Ft("buttonHover", 0.5)
          }
        },
        _focus: {
          color: "buttonHover"
        },
        _active: {
          color: "buttonActive"
        },
        _disabled: {
          color: Ft("buttonDefault", 0.5)
        }
      },
      inlineSecondary: {
        padding: "inlineButtonPadding",
        color: "textPrimary",
        _hover: {
          color: "strokeHover",
          textUnderlineOffset: "2px",
          _disabled: {
            color: Ft("strokeHover", 0.7)
          }
        },
        _focus: {
          color: "strokeHover"
        },
        _active: {
          color: "strokeHover"
        },
        _disabled: {
          color: Ft("textPrimary", 0.7)
        }
      },
      nav: {
        backgroundColor: "transparent",
        padding: "navButtonPadding",
        color: "buttonDefault",
        _hover: {
          color: "buttonHover",
          backgroundColor: "transparent",
          _disabled: {
            backgroundColor: Ft("navBackgroundHover", 0.5)
          }
        },
        _focus: {
          color: "buttonHover",
          backgroundColor: "transparent"
        },
        _active: {
          color: "buttonActive",
          backgroundColor: "transparent"
        },
        _disabled: {
          color: Ft("buttonDefault", 0.5)
        }
      },
      tertiary: {
        color: "strokeDefault",
        _hover: {
          color: "strokeHover",
          backgroundColor: Ft("strokeHover", 0.1),
          _disabled: {
            backgroundColor: Ft("strokeHover", 0.5)
          }
        },
        _focus: {
          color: "strokeHover"
        },
        _active: {
          color: "strokeActive"
        },
        _disabled: {
          color: Ft("strokeHover", 0.5)
        }
      },
      lowContrast: yX
    },
    sizes: {
      sm: {
        ...(Cp = (mp = $t == null ? void 0 : $t.Text) == null ? void 0 : mp.variants) == null ? void 0 : Cp.buttonSmall,
        px: "12px",
        py: "4px",
        height: "22px"
      },
      md: {
        ...(bp = (vp = $t == null ? void 0 : $t.Text) == null ? void 0 : vp.variants) == null ? void 0 : bp.buttonRegular,
        px: "40px",
        py: "10px"
      },
      lg: {
        ...(xp = (yp = $t == null ? void 0 : $t.Text) == null ? void 0 : yp.variants) == null ? void 0 : xp.buttonRegular,
        px: "40px",
        py: "10px"
      }
    },
    defaultProps: {
      ...Kc.Button.defaultProps
    }
  },
  IconButton: {
    sizes: {
      xs: {
        padding: "0rem"
      },
      sm: {
        padding: ".25rem"
      },
      md: {
        padding: ".5rem"
      },
      lg: {
        padding: ".75rem"
      }
    },
    variants: {
      quaternary: uh
    }
  }
};
var Sp, wp, Ip, Vp;
const SX = {
  Checkbox: {
    baseStyle: {
      control: {
        borderColor: "strokeInteractive",
        _checked: {
          borderColor: "selected2",
          backgroundColor: "selected2",
          _before: {
            content: '""',
            display: "inline-block",
            pos: "relative",
            borderWidth: 0,
            bg: "selected2"
          },
          _hover: {
            background: "hover2"
          }
        },
        _hover: {
          background: "hover2"
        }
      }
    },
    variants: {
      boxed: {
        container: {
          marginBottom: ".5rem",
          borderWidth: "1px",
          borderColor: "strokeDefault",
          padding: ".5rem",
          width: "100%"
        }
      }
    },
    sizes: {
      sm: {
        control: {
          width: "12px",
          height: "12px",
          borderWidth: 1.5
        },
        label: {
          ...(wp = (Sp = $t == null ? void 0 : $t.Text) == null ? void 0 : Sp.variants) == null ? void 0 : wp.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "8px"
        }
      },
      lg: {
        control: {
          width: "18px",
          height: "18px",
          borderWidth: 2
        },
        label: {
          ...(Vp = (Ip = $t == null ? void 0 : $t.Text) == null ? void 0 : Ip.variants) == null ? void 0 : Vp.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "10px"
        }
      }
    }
  }
}, wX = {
  FormLabel: {
    baseStyle: {
      fontSize: "sm",
      color: "inputLabelText"
    }
  }
}, IX = {
  ...wX,
  FormLabel: {
    baseStyle: {
      color: "typography.tertiary",
      fontWeight: "bold",
      fontSize: "md"
    }
  },
  FormError: {
    parts: ["text"],
    baseStyle: {
      text: {
        ...$t.Text.variants.body2,
        color: "typography.danger"
      }
    }
  },
  Form: {
    parts: ["helperText"],
    baseStyle: {
      helperText: {
        ...$t.Text.variants.body1,
        color: "typography.tertiary"
      }
    }
  }
}, cf = {
  outline: {
    borderRadius: "4px",
    borderColor: "strokeDefault",
    backgroundColor: "surface1",
    _hover: {
      borderColor: "strokeHover"
    },
    _invalid: {
      borderColor: "error"
    },
    _selected: {
      borderColor: "selected2"
    },
    _focusVisible: {
      borderColor: "selected2",
      boxShadow: "0 0 0 1px var(--chakra-colors-selected2)",
      // transparent outline doesn't show in any case except Windows with high-contrast theme enabled
      // in this case, boxShadow is _disabled_, and windows overrides 'transparent' with a new value
      outlineColor: "transparent",
      outlineWidth: "1px",
      outlineStyle: "dotted"
    }
  }
}, VX = {
  Input: {
    variants: {
      outline: {
        field: {
          borderRadius: "sm",
          borderColor: "border",
          _focus: {
            borderColor: "primary",
            _invalid: {
              borderColor: "danger"
            }
          },
          _invalid: {
            borderColor: "danger"
          }
        }
      }
    }
  }
}, AX = {
  Input: {
    variants: {
      ...VX.Input.variants,
      outline: {
        field: cf.outline
      },
      ghost: {
        border: "none",
        backgroundColor: "surface3",
        _focus: {
          border: "none"
        },
        _disabled: {
          backgroundColor: "none"
        }
      }
    },
    defaultProps: {
      variant: "outline"
    },
    sizes: {
      xs: {
        field: {
          height: "1.5rem"
        }
      },
      sm: {
        field: {
          height: "2rem"
        }
      },
      md: {
        field: {
          height: "2.75rem"
        }
      },
      lg: {
        field: {
          height: "3rem"
        }
      }
    }
  },
  Textarea: {
    variants: {
      outline: cf.outline
    },
    defaultProps: {
      variant: "outline"
    }
  }
}, cb = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 500,
  sticky: 600,
  banner: 700,
  overlay: 800,
  modal: 900,
  popover: 950,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, { definePartsStyle: LX } = Rt(ng.keys), MX = {
  Popover: {
    baseStyle: {
      popper: {
        zIndex: "popover"
      }
    },
    variants: {
      inline: LX({
        popper: { zIndex: cb.base + 1 }
      })
    }
  }
};
var Ap, Lp, Mp, Pp;
const PX = {
  RadioGroup: {
    baseStyle: {
      backgroundColor: "red"
    }
  },
  Radio: {
    parts: ["control"],
    baseStyle: {
      control: {
        borderColor: "strokeInteractive",
        _checked: {
          borderColor: "selected2",
          background: "none",
          _before: {
            content: '""',
            display: "inline-block",
            pos: "relative",
            borderWidth: 0,
            bg: "selected2"
          },
          _hover: {
            background: "hover2"
          }
        },
        _hover: {
          background: "hover2"
        },
        _disabled: {
          _checked: {
            _before: {
              bg: "selected1"
            }
          }
        }
      }
    },
    variants: {
      __dangerDoNotUseCheckmarks: {
        control: {
          position: "relative",
          borderColor: "none",
          background: "white",
          _before: {
            position: "absolute",
            top: "-2px",
            content: '""',
            transform: "rotate(45deg)",
            height: "1rem",
            width: ".5rem",
            borderRadius: "0px",
            borderBottomWidth: "3px",
            borderBottomStyle: "solid",
            borderBottomColor: "selected1",
            borderRightWidth: "3px",
            borderRightStyle: "solid",
            borderRightColor: "selected1"
          },
          _checked: {
            borderColor: "none",
            background: "white",
            _before: {
              content: '""',
              height: "1rem",
              width: ".5rem",
              borderRadius: "0px",
              borderBottomWidth: "3px",
              borderBottomStyle: "solid",
              borderBottomColor: "selected2",
              borderRightWidth: "3px",
              borderRightStyle: "solid",
              borderRightColor: "selected2",
              display: "inline-block",
              pos: "absolute",
              bg: "none"
            },
            _hover: {
              borderColor: "none",
              background: "white",
              _before: {
                content: '""',
                height: "1rem",
                width: ".5rem",
                borderRadius: "0px",
                borderBottomWidth: "3px",
                borderBottomStyle: "solid",
                borderBottomColor: "selected3",
                borderRightWidth: "3px",
                borderRightStyle: "solid",
                borderRightColor: "selected3",
                display: "inline-block",
                pos: "absolute",
                bg: "none"
              }
            }
          },
          _hover: {
            borderColor: "none",
            background: "white",
            _before: {
              content: '""',
              height: "1rem",
              width: ".5rem",
              borderRadius: "0px",
              borderBottomWidth: "3px",
              borderBottomStyle: "solid",
              borderBottomColor: "surfaceAccent5",
              borderRightWidth: "3px",
              borderRightStyle: "solid",
              borderRightColor: "surfaceAccent5",
              display: "inline-block",
              pos: "absolute",
              bg: "none"
            }
          }
        }
      }
    },
    sizes: {
      sm: {
        control: {
          width: "14px",
          height: "14px",
          borderWidth: 1.5,
          _checked: {
            _before: {
              w: "7px",
              h: "7px"
            }
          }
        },
        label: {
          ...(Lp = (Ap = $t == null ? void 0 : $t.Text) == null ? void 0 : Ap.variants) == null ? void 0 : Lp.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "8px",
          _last: {
            marginBottom: 0
          }
        }
      },
      lg: {
        control: {
          width: "20px",
          height: "20px",
          borderWidth: 2,
          _checked: {
            _before: {
              w: "10px",
              h: "10px"
            }
          }
        },
        label: {
          ...(Pp = (Mp = $t == null ? void 0 : $t.Text) == null ? void 0 : Mp.variants) == null ? void 0 : Pp.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "10px",
          _last: {
            marginBottom: 0
          }
        }
      }
    }
  }
}, EX = {
  ReactTableUI: {
    parts: ["tbody"],
    baseStyle: {
      tbody: {
        tr: {
          "th, td": {
            borderBottomWidth: 0
          }
        }
      }
    }
  }
}, { defineMultiStyleConfig: RX } = Rt(["field"]), _X = {
  Select: RX({
    defaultProps: {
      variant: "outline"
    },
    variants: {
      outline: {
        field: cf.outline
      }
    },
    sizes: {
      xs: {
        field: {
          height: "1.5rem"
        }
      },
      sm: {
        field: {
          height: "2rem"
        }
      },
      md: {
        field: {
          height: "2.75rem"
        }
      },
      lg: {
        field: {
          height: "3rem"
        }
      }
    }
  })
}, TX = {
  Switch: {
    baseStyle: {
      track: {
        borderRadius: "4px",
        bg: "strokeDefault",
        _checked: {
          bg: "surfaceAccent4"
        }
      },
      thumb: {
        borderRadius: "2px"
      }
    }
  }
}, HX = {
  ...eX,
  ...xX,
  ...SX,
  ...IX,
  ...AX,
  ...PX,
  ...MX,
  ...TX,
  ...$t,
  ...EX,
  ..._X
}, FX = {
  xxs: "8px",
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "24px",
  "2xl": "28px"
}, kX = {
  xs: "7px",
  sm: "8px",
  md: "10px",
  lg: "12px",
  xl: "16px",
  xxxl: "56px"
}, db = {
  heading: "'Lato', sans-serif",
  body: "'Lato', sans-serif",
  mono: "'Lato', sans-serif"
}, BX = {
  styles: {
    global: () => {
      var e;
      return {
        a: {
          textDecoration: "underline"
        },
        svg: {
          display: "inline"
        },
        ".fc": {
          button: {
            ...Kc.Button.baseStyle,
            ...(e = Kc.Button.variants) == null ? void 0 : e.filled,
            border: "0px"
          },
          ".fc-daygrid-day.fc-day-sat, .fc-daygrid-day.fc-day-sun": {
            backgroundColor: "secondaryBackground"
          },
          ".fc-col-header-cell": {
            color: "black",
            backgroundColor: "initial"
          }
        }
      };
    }
  }
}, DX = {}, OX = {
  primaryButtonPadding: "10px 40px",
  secondaryButtonPadding: "10px 40px",
  secondarySmallButtonPadding: "4px 12px",
  inlineButtonPadding: "0px 3px",
  navButtonPadding: "8px 20px"
}, NX = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: !1
  },
  ...BX,
  colors: _r,
  components: HX,
  fonts: db,
  fontSizes: FX,
  space: OX,
  sizes: DX,
  zIndices: cb
}, $ee = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: !1
  },
  colors: Qj,
  fonts: db,
  fontSizes: kX
};
const zee = ({ children: e, themes: t }) => {
  const n = zZ(NX, ...t ?? []);
  return /* @__PURE__ */ x.jsx($N, { theme: n, children: e });
}, Wee = (e) => /* @__PURE__ */ x.jsx(cC, { ...e });
function fb(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = fb(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Qn() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = fb(e)) && (r && (r += " "), r += t);
  return r;
}
const hb = ({ text: e, variant: t = "primary", size: n = "sm" }) => /* @__PURE__ */ x.jsx("span", { className: `badge ${t} ${n}`, children: e }), ZX = ["home-heart-filled", "baths", "location", "error-warning"], $X = (e) => ZX.includes(e) ? "evenodd" : "nonzero", zX = {
  add: {
    paths: [
      "M11 11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11Z"
    ]
  },
  "arrow-left": {
    paths: [
      "M7.828 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.828L12.485 17.657C12.8755 18.0475 12.8755 18.6805 12.485 19.071C12.0945 19.4615 11.4615 19.4615 11.071 19.071L4 12L11.071 4.929C11.4615 4.53853 12.0945 4.53853 12.485 4.929C12.8755 5.31947 12.8755 5.95254 12.485 6.343L7.828 11Z"
    ]
  },
  "assignment-add": {
    paths: [
      "M180-120q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v329q-14-8-29.5-13t-30.5-8v-308H180v600h309q4 16 9.023 31.172Q503.045-133.655 510-120H180Zm0-107v47-600 308-4 249Zm100-53h211q4-16 9-31t13-29H280v60Zm0-170h344q14-7 27-11.5t29-8.5v-40H280v60Zm0-170h400v-60H280v60Zm200-177q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM732.5-41Q655-41 600-96.5T545-228q0-78.435 54.99-133.717Q654.98-417 733-417q77 0 132.5 55.283Q921-306.435 921-228q0 76-55.5 131.5T732.5-41ZM718-101h33v-110h110v-33H751v-110h-33v110H608v33h110v110Z"
    ],
    viewBox: "0 -960 960 960"
  },
  bank: {
    paths: [
      "M11 1.57752L2.70577 6.3662C2.26904 6.61834 2 7.08433 2 7.58863C2 8.3682 2.63197 9.00017 3.41154 9.00017H20.5885C21.368 9.00017 22 8.3682 22 7.58863C22 7.08434 21.731 6.61835 21.2942 6.3662L13 1.57752C12.3812 1.22025 11.6188 1.22025 11 1.57752ZM12 3.88692L7.47372 6.50017H16.5263L12 3.88692Z",
      "M12 11.0002C12.6904 11.0002 13.25 11.5598 13.25 12.2502V16.5002C13.25 17.1905 12.6904 17.7502 12 17.7502C11.3096 17.7502 10.75 17.1905 10.75 16.5002V12.2502C10.75 11.5598 11.3096 11.0002 12 11.0002Z",
      "M20.75 22.0002C21.4404 22.0002 22 21.4405 22 20.7502C22 20.0598 21.4404 19.5002 20.75 19.5002H3.25C2.55964 19.5002 2 20.0598 2 20.7502C2 21.4405 2.55964 22.0002 3.25 22.0002H20.75Z",
      "M17.5 11.0002C18.1904 11.0002 18.75 11.5598 18.75 12.2502V16.5002C18.75 17.1905 18.1904 17.7502 17.5 17.7502C16.8096 17.7502 16.25 17.1905 16.25 16.5002V12.2502C16.25 11.5598 16.8096 11.0002 17.5 11.0002Z",
      "M6.5 11.0002C7.19036 11.0002 7.75 11.5598 7.75 12.2502V16.5002C7.75 17.1905 7.19036 17.7502 6.5 17.7502C5.80964 17.7502 5.25 17.1905 5.25 16.5002V12.2502C5.25 11.5598 5.80964 11.0002 6.5 11.0002Z"
    ]
  },
  cursor: {
    paths: [
      "M17.94 20.512L15.388 13.498H15.389L19.947 12.865L8.41004 1.633L6.79004 17.653L10.689 15.208L13.242 22.222L17.94 20.512Z"
    ]
  },
  "heart-3": {
    paths: [
      "M16.5 3C19.538 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.36 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.934 18.604C13.815 18.048 14.61 17.495 15.354 16.903C18.335 14.533 20 11.943 20 9C20 6.64 18.463 5 16.5 5C15.424 5 14.26 5.57 13.414 6.414L12 7.828L10.586 6.414C9.74 5.57 8.576 5 7.5 5C5.56 5 4 6.656 4 9C4 11.944 5.666 14.533 8.645 16.903C9.39 17.495 10.185 18.048 11.066 18.603C11.365 18.792 11.661 18.973 12 19.175C12.339 18.973 12.635 18.792 12.934 18.604V18.604Z"
    ]
  },
  lock: {
    paths: [
      "M19 10H20C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H5V9C5 8.08075 5.18106 7.1705 5.53284 6.32122C5.88463 5.47194 6.40024 4.70026 7.05025 4.05025C7.70026 3.40024 8.47194 2.88463 9.32122 2.53284C10.1705 2.18106 11.0807 2 12 2C12.9193 2 13.8295 2.18106 14.6788 2.53284C15.5281 2.88463 16.2997 3.40024 16.9497 4.05025C17.5998 4.70026 18.1154 5.47194 18.4672 6.32122C18.8189 7.1705 19 8.08075 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V10H17Z"
    ]
  },
  "indeterminate-circle": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 11H17V13H7V11Z"
    ]
  },
  "arrow-drop-down": {
    paths: [
      "M11.9998 15L8.46419 11.4643C8.07357 11.0737 8.07376 10.4403 8.46452 10.0498V10.0498C8.85514 9.65946 9.48829 9.65955 9.87869 10.0501L11.9998 12.172L14.121 10.0501C14.5114 9.65955 15.1445 9.65946 15.5351 10.0498V10.0498C15.9259 10.4403 15.9261 11.0737 15.5355 11.4643L11.9998 15Z"
    ]
  },
  subtract: {
    paths: [
      "M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12V12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12V12Z"
    ]
  },
  "settings-3": {
    paths: [
      "M3.33933 17C2.9166 16.269 2.58799 15.4875 2.36133 14.674C2.85464 14.4231 3.26892 14.0406 3.55836 13.5689C3.84779 13.0972 4.00109 12.5546 4.0013 12.0011C4.00151 11.4477 3.84861 10.905 3.55953 10.433C3.27045 9.96106 2.85645 9.57828 2.36333 9.32701C2.81536 7.69249 3.67606 6.19996 4.86433 4.99001C5.32842 5.29173 5.86695 5.45917 6.42031 5.47379C6.97367 5.48841 7.52028 5.34964 7.99966 5.07284C8.47904 4.79604 8.87248 4.392 9.13646 3.90545C9.40043 3.41889 9.52463 2.86878 9.49533 2.31601C11.1374 1.89163 12.8606 1.89232 14.5023 2.31801C14.4733 2.87077 14.5977 3.4208 14.8619 3.90721C15.1261 4.39363 15.5197 4.79748 15.9992 5.07407C16.4786 5.35065 17.0253 5.48919 17.5786 5.47436C18.1319 5.45952 18.6704 5.29189 19.1343 4.99001C19.7133 5.58001 20.2273 6.25101 20.6593 7.00001C21.0923 7.74901 21.4163 8.53001 21.6373 9.32601C21.144 9.57691 20.7297 9.95938 20.4403 10.4311C20.1509 10.9028 19.9976 11.4454 19.9974 11.9989C19.9971 12.5523 20.15 13.0951 20.4391 13.567C20.7282 14.039 21.1422 14.4217 21.6353 14.673C21.1833 16.3075 20.3226 17.8001 19.1343 19.01C18.6702 18.7083 18.1317 18.5408 17.5784 18.5262C17.025 18.5116 16.4784 18.6504 15.999 18.9272C15.5196 19.204 15.1262 19.608 14.8622 20.0946C14.5982 20.5811 14.474 21.1312 14.5033 21.684C12.8612 22.1084 11.1381 22.1077 9.49633 21.682C9.52537 21.1292 9.40093 20.5792 9.13675 20.0928C8.87257 19.6064 8.47897 19.2025 7.9995 18.9259C7.52003 18.6494 6.97338 18.5108 6.42005 18.5257C5.86673 18.5405 5.32829 18.7081 4.86433 19.01C4.27332 18.407 3.76092 17.7316 3.33933 17V17ZM8.99933 17.196C10.065 17.8106 10.8662 18.797 11.2493 19.966C11.7483 20.013 12.2493 20.014 12.7483 19.967C13.1317 18.7979 13.9333 17.8114 14.9993 17.197C16.0645 16.5807 17.3199 16.3795 18.5243 16.632C18.8143 16.224 19.0643 15.789 19.2723 15.334C18.4518 14.4174 17.9984 13.2302 17.9993 12C17.9993 10.74 18.4693 9.56301 19.2723 8.66601C19.0629 8.21115 18.8118 7.77664 18.5223 7.36801C17.3186 7.62032 16.0641 7.41948 14.9993 6.80401C13.9337 6.18938 13.1325 5.20299 12.7493 4.03401C12.2503 3.98701 11.7493 3.98601 11.2503 4.03301C10.8669 5.20215 10.0653 6.18857 8.99933 6.80301C7.93411 7.41932 6.67881 7.62053 5.47433 7.36801C5.18489 7.77629 4.93446 8.21087 4.72633 8.66601C5.5469 9.58257 6.00021 10.7698 5.99933 12C5.99933 13.26 5.52933 14.437 4.72633 15.334C4.9358 15.7889 5.18687 16.2234 5.47633 16.632C6.68005 16.3797 7.93454 16.5805 8.99933 17.196ZM11.9993 15C11.2037 15 10.4406 14.6839 9.87801 14.1213C9.3154 13.5587 8.99933 12.7957 8.99933 12C8.99933 11.2044 9.3154 10.4413 9.87801 9.87869C10.4406 9.31608 11.2037 9.00001 11.9993 9.00001C12.795 9.00001 13.558 9.31608 14.1206 9.87869C14.6833 10.4413 14.9993 11.2044 14.9993 12C14.9993 12.7957 14.6833 13.5587 14.1206 14.1213C13.558 14.6839 12.795 15 11.9993 15ZM11.9993 13C12.2645 13 12.5189 12.8946 12.7064 12.7071C12.894 12.5196 12.9993 12.2652 12.9993 12C12.9993 11.7348 12.894 11.4804 12.7064 11.2929C12.5189 11.1054 12.2645 11 11.9993 11C11.7341 11 11.4798 11.1054 11.2922 11.2929C11.1047 11.4804 10.9993 11.7348 10.9993 12C10.9993 12.2652 11.1047 12.5196 11.2922 12.7071C11.4798 12.8946 11.7341 13 11.9993 13V13Z"
    ]
  },
  "apps-2": {
    paths: [
      "M6.5 11.5C5.90905 11.5 5.32389 11.3836 4.77792 11.1575C4.23196 10.9313 3.73588 10.5998 3.31802 10.182C2.90016 9.76412 2.56869 9.26804 2.34254 8.72208C2.1164 8.17611 2 7.59095 2 7C2 6.40905 2.1164 5.82389 2.34254 5.27792C2.56869 4.73196 2.90016 4.23588 3.31802 3.81802C3.73588 3.40016 4.23196 3.06869 4.77792 2.84254C5.32389 2.6164 5.90905 2.5 6.5 2.5C7.69347 2.5 8.83807 2.97411 9.68198 3.81802C10.5259 4.66193 11 5.80653 11 7C11 8.19347 10.5259 9.33807 9.68198 10.182C8.83807 11.0259 7.69347 11.5 6.5 11.5V11.5ZM7 21.5C5.80653 21.5 4.66193 21.0259 3.81802 20.182C2.97411 19.3381 2.5 18.1935 2.5 17C2.5 15.8065 2.97411 14.6619 3.81802 13.818C4.66193 12.9741 5.80653 12.5 7 12.5C8.19347 12.5 9.33807 12.9741 10.182 13.818C11.0259 14.6619 11.5 15.8065 11.5 17C11.5 18.1935 11.0259 19.3381 10.182 20.182C9.33807 21.0259 8.19347 21.5 7 21.5V21.5ZM17 11.5C16.4091 11.5 15.8239 11.3836 15.2779 11.1575C14.732 10.9313 14.2359 10.5998 13.818 10.182C13.4002 9.76412 13.0687 9.26804 12.8425 8.72208C12.6164 8.17611 12.5 7.59095 12.5 7C12.5 6.40905 12.6164 5.82389 12.8425 5.27792C13.0687 4.73196 13.4002 4.23588 13.818 3.81802C14.2359 3.40016 14.732 3.06869 15.2779 2.84254C15.8239 2.6164 16.4091 2.5 17 2.5C18.1935 2.5 19.3381 2.97411 20.182 3.81802C21.0259 4.66193 21.5 5.80653 21.5 7C21.5 8.19347 21.0259 9.33807 20.182 10.182C19.3381 11.0259 18.1935 11.5 17 11.5V11.5ZM17 21.5C15.8065 21.5 14.6619 21.0259 13.818 20.182C12.9741 19.3381 12.5 18.1935 12.5 17C12.5 15.8065 12.9741 14.6619 13.818 13.818C14.6619 12.9741 15.8065 12.5 17 12.5C18.1935 12.5 19.3381 12.9741 20.182 13.818C21.0259 14.6619 21.5 15.8065 21.5 17C21.5 18.1935 21.0259 19.3381 20.182 20.182C19.3381 21.0259 18.1935 21.5 17 21.5ZM6.5 9.5C7.16304 9.5 7.79893 9.23661 8.26777 8.76777C8.73661 8.29893 9 7.66304 9 7C9 6.33696 8.73661 5.70107 8.26777 5.23223C7.79893 4.76339 7.16304 4.5 6.5 4.5C5.83696 4.5 5.20107 4.76339 4.73223 5.23223C4.26339 5.70107 4 6.33696 4 7C4 7.66304 4.26339 8.29893 4.73223 8.76777C5.20107 9.23661 5.83696 9.5 6.5 9.5V9.5ZM7 19.5C7.66304 19.5 8.29893 19.2366 8.76777 18.7678C9.23661 18.2989 9.5 17.663 9.5 17C9.5 16.337 9.23661 15.7011 8.76777 15.2322C8.29893 14.7634 7.66304 14.5 7 14.5C6.33696 14.5 5.70107 14.7634 5.23223 15.2322C4.76339 15.7011 4.5 16.337 4.5 17C4.5 17.663 4.76339 18.2989 5.23223 18.7678C5.70107 19.2366 6.33696 19.5 7 19.5ZM17 9.5C17.663 9.5 18.2989 9.23661 18.7678 8.76777C19.2366 8.29893 19.5 7.66304 19.5 7C19.5 6.33696 19.2366 5.70107 18.7678 5.23223C18.2989 4.76339 17.663 4.5 17 4.5C16.337 4.5 15.7011 4.76339 15.2322 5.23223C14.7634 5.70107 14.5 6.33696 14.5 7C14.5 7.66304 14.7634 8.29893 15.2322 8.76777C15.7011 9.23661 16.337 9.5 17 9.5ZM17 19.5C17.663 19.5 18.2989 19.2366 18.7678 18.7678C19.2366 18.2989 19.5 17.663 19.5 17C19.5 16.337 19.2366 15.7011 18.7678 15.2322C18.2989 14.7634 17.663 14.5 17 14.5C16.337 14.5 15.7011 14.7634 15.2322 15.2322C14.7634 15.7011 14.5 16.337 14.5 17C14.5 17.663 14.7634 18.2989 15.2322 18.7678C15.7011 19.2366 16.337 19.5 17 19.5Z"
    ]
  },
  "arrow-drop-up": {
    paths: [
      "M11.9998 11.828L9.87869 13.9499C9.48829 14.3404 8.85514 14.3405 8.46452 13.9502V13.9502C8.07376 13.5597 8.07357 12.9263 8.46419 12.5356L11.9998 9L15.5355 12.5356C15.9261 12.9263 15.9259 13.5597 15.5351 13.9502V13.9502C15.1445 14.3405 14.5114 14.3404 14.121 13.9499L11.9998 11.828Z"
    ]
  },
  "thumb-down": {
    paths: [
      "M9.4 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V11.896C0.999731 11.6346 1.05069 11.3758 1.15 11.134L4.246 3.62C4.32128 3.43675 4.4493 3.28 4.6138 3.16961C4.77831 3.05923 4.97189 3.0002 5.17 3H22C22.2652 3 22.5196 3.10536 22.7071 3.29289C22.8946 3.48043 23 3.73478 23 4V14C23 14.2652 22.8946 14.5196 22.7071 14.7071C22.5196 14.8946 22.2652 15 22 15H18.518C18.3579 15 18.2001 15.0384 18.058 15.112C17.9158 15.1856 17.7934 15.2922 17.701 15.423L12.248 23.149C12.1791 23.2467 12.0774 23.3164 11.9615 23.3456C11.8455 23.3748 11.723 23.3614 11.616 23.308L9.802 22.4C9.2915 22.1448 8.88367 21.7227 8.64627 21.2037C8.40887 20.6847 8.3562 20.1001 8.497 19.547L9.4 16ZM17 13.412V5H5.84L3 11.896V14H9.4C9.7046 14 10.0052 14.0697 10.2788 14.2035C10.5524 14.3374 10.7918 14.532 10.9787 14.7725C11.1657 15.013 11.2952 15.293 11.3575 15.5912C11.4197 15.8893 11.4131 16.1978 11.338 16.493L10.435 20.041C10.4067 20.1517 10.4172 20.2687 10.4647 20.3726C10.5122 20.4765 10.5938 20.561 10.696 20.612L11.357 20.942L16.067 14.27C16.317 13.916 16.637 13.626 17 13.412V13.412ZM19 13H21V5H19V13Z"
    ]
  },
  "external-link": {
    paths: [
      "M10 6V8H5V19H16V14H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H10ZM21 3V11H19V6.413L11.207 14.207L9.793 12.793L17.585 5H13V3H21Z"
    ]
  },
  "delete-bin": {
    paths: [
      "M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
    ]
  },
  remove: {
    viewBox: "0 0 16 16",
    paths: [
      "M7.99967 14.6666C4.31767 14.6666 1.33301 11.6819 1.33301 7.99992C1.33301 4.31792 4.31767 1.33325 7.99967 1.33325C11.6817 1.33325 14.6663 4.31792 14.6663 7.99992C14.6663 11.6819 11.6817 14.6666 7.99967 14.6666ZM7.99967 13.3333C9.41416 13.3333 10.7707 12.7713 11.7709 11.7712C12.7711 10.771 13.333 9.41441 13.333 7.99992C13.333 6.58543 12.7711 5.22888 11.7709 4.22868C10.7707 3.22849 9.41416 2.66659 7.99967 2.66659C6.58519 2.66659 5.22863 3.22849 4.22844 4.22868C3.22824 5.22888 2.66634 6.58543 2.66634 7.99992C2.66634 9.41441 3.22824 10.771 4.22844 11.7712C5.22863 12.7713 6.58519 13.3333 7.99967 13.3333ZM4.66634 7.33325H11.333V8.66659H4.66634V7.33325Z"
    ]
  },
  "arrow-left-down": {
    paths: [
      "M9 13.59L16.9 5.69C17.2905 5.29954 17.9235 5.29954 18.314 5.69V5.69C18.7045 6.08047 18.7045 6.71354 18.314 7.104L10.414 15.004H17C17.5523 15.004 18 15.4517 18 16.004V16.004C18 16.5563 17.5523 17.004 17 17.004H7V7.004C7 6.45172 7.44772 6.004 8 6.004V6.004C8.55228 6.004 9 6.45172 9 7.004V13.589V13.59Z"
    ]
  },
  "arrow-left-up": {
    paths: [
      "M10.41 9L18.31 16.9C18.7005 17.2905 18.7005 17.9235 18.31 18.314V18.314C17.9195 18.7045 17.2865 18.7045 16.896 18.314L8.996 10.414L8.996 17C8.996 17.5523 8.54828 18 7.996 18V18C7.44371 18 6.996 17.5523 6.996 17L6.996 7L16.996 7C17.5483 7 17.996 7.44772 17.996 8V8C17.996 8.55228 17.5483 9 16.996 9L10.411 9L10.41 9Z"
    ]
  },
  question: {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9 13H11V15H9V13ZM11 11.355V12H9V10.5C9 10.2348 9.10536 9.98043 9.29289 9.79289C9.48043 9.60536 9.73478 9.5 10 9.5C10.2841 9.49998 10.5623 9.4193 10.8023 9.26733C11.0423 9.11536 11.2343 8.89837 11.3558 8.64158C11.4773 8.3848 11.5234 8.0988 11.4887 7.81684C11.454 7.53489 11.34 7.26858 11.1598 7.04891C10.9797 6.82924 10.7409 6.66523 10.4712 6.57597C10.2015 6.48671 9.91204 6.47587 9.63643 6.54471C9.36081 6.61354 9.11042 6.75923 8.91437 6.96482C8.71832 7.1704 8.58468 7.42743 8.529 7.706L6.567 7.313C6.68863 6.70508 6.96951 6.14037 7.38092 5.67659C7.79233 5.2128 8.31952 4.86658 8.90859 4.67332C9.49766 4.48006 10.1275 4.44669 10.7337 4.57661C11.3399 4.70654 11.9007 4.99511 12.3588 5.41282C12.8169 5.83054 13.1559 6.36241 13.3411 6.95406C13.5263 7.54572 13.5511 8.17594 13.4129 8.78031C13.2747 9.38467 12.9785 9.9415 12.5545 10.3939C12.1306 10.8462 11.5941 11.1779 11 11.355Z"
    ],
    viewBox: "0 0 20 20"
  },
  close: {
    paths: [
      "M12.0007 10.586L16.2437 6.34299C16.6342 5.95252 17.2673 5.95252 17.6577 6.34299V6.34299C18.0482 6.73345 18.0482 7.36652 17.6577 7.75699L13.4147 12L17.6577 16.243C18.0482 16.6335 18.0482 17.2665 17.6577 17.657V17.657C17.2673 18.0475 16.6342 18.0475 16.2437 17.657L12.0007 13.414L7.75772 17.657C7.36725 18.0475 6.73418 18.0475 6.34372 17.657V17.657C5.95325 17.2665 5.95325 16.6335 6.34372 16.243L10.5867 12L6.34372 7.75699C5.95325 7.36652 5.95325 6.73345 6.34372 6.34299V6.34299C6.73418 5.95252 7.36725 5.95252 7.75772 6.34299L12.0007 10.586Z"
    ]
  },
  "close-circle": {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z",
      "M10 8.88906L13.3336 5.55547C13.6404 5.24869 14.1378 5.24869 14.4445 5.55547C14.7513 5.86224 14.7513 6.35963 14.4445 6.6664L11.1109 10L14.4445 13.3336C14.7513 13.6404 14.7513 14.1378 14.4445 14.4445C14.1378 14.7513 13.6404 14.7513 13.3336 14.4445L10 11.1109L6.6664 14.4445C6.35963 14.7513 5.86224 14.7513 5.55547 14.4445C5.24869 14.1378 5.24869 13.6404 5.55547 13.3336L8.88906 10L5.55547 6.6664C5.24869 6.35963 5.24869 5.86224 5.55547 5.55547C5.86224 5.24869 6.35963 5.24869 6.6664 5.55547L10 8.88906Z"
    ]
  },
  "arrow-left-s": {
    paths: [
      "M10.828 12L15.071 16.243C15.4615 16.6335 15.4615 17.2665 15.071 17.657V17.657C14.6805 18.0475 14.0475 18.0475 13.657 17.657L8 12L13.657 6.343C14.0475 5.95253 14.6805 5.95253 15.071 6.343V6.343C15.4615 6.73347 15.4615 7.36653 15.071 7.757L10.828 12Z"
    ]
  },
  "lock-unlock": {
    paths: [
      "M10.828 12L15.071 16.243C15.4615 16.6335 15.4615 17.2665 15.071 17.657V17.657C14.6805 18.0475 14.0475 18.0475 13.657 17.657L8 12L13.657 6.343C14.0475 5.95253 14.6805 5.95253 15.071 6.343V6.343C15.4615 6.73347 15.4615 7.36653 15.071 7.757L10.828 12Z"
    ]
  },
  time: {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM13 12H17V14H11V7H13V12Z"
    ]
  },
  "zoom-out": {
    paths: [
      "M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM7 10H15V12H7V10Z"
    ]
  },
  "more-2": {
    paths: [
      "M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
    ]
  },
  information: {
    viewBox: "0 0 20 20",
    paths: [
      "M10 18.3333C5.39751 18.3333 1.66667 14.6025 1.66667 9.99999C1.66667 5.39749 5.39751 1.66666 10 1.66666C14.6025 1.66666 18.3333 5.39749 18.3333 9.99999C18.3333 14.6025 14.6025 18.3333 10 18.3333ZM10 16.6667C11.7681 16.6667 13.4638 15.9643 14.7141 14.714C15.9643 13.4638 16.6667 11.7681 16.6667 9.99999C16.6667 8.23188 15.9643 6.53619 14.7141 5.28594C13.4638 4.0357 11.7681 3.33332 10 3.33332C8.2319 3.33332 6.5362 4.0357 5.28596 5.28594C4.03572 6.53619 3.33334 8.23188 3.33334 9.99999C3.33334 11.7681 4.03572 13.4638 5.28596 14.714C6.5362 15.9643 8.2319 16.6667 10 16.6667ZM9.16667 5.83332H10.8333V7.49999H9.16667V5.83332ZM9.16667 9.16666H10.8333V14.1667H9.16667V9.16666Z"
    ]
  },
  "information-inverse": {
    viewBox: "0 0 16 16",
    paths: [
      "M8.00049 1.33334C11.6822 1.33352 14.6665 4.31855 14.6665 8.00034C14.6663 11.682 11.6821 14.6662 8.00049 14.6664C4.3187 14.6664 1.33367 11.6821 1.3335 8.00034C1.3335 4.31844 4.31859 1.33334 8.00049 1.33334ZM7.44189 10.7601V11.8714H8.55322V10.7601H7.44189ZM7.44189 4.09409V9.09409H8.55322V4.09409H7.44189Z"
    ]
  },
  "arrow-right-up": {
    paths: [
      "M16.0044 9.414L8.10442 17.314C7.71394 17.7045 7.08085 17.7045 6.69038 17.314V17.314C6.29992 16.9235 6.2999 16.2905 6.69034 15.9L14.5894 8H8.0044C7.45211 8 7.0044 7.55228 7.0044 7V7C7.0044 6.44772 7.45211 6 8.0044 6H18.0044V16C18.0044 16.5523 17.5567 17 17.0044 17V17C16.4521 17 16.0044 16.5523 16.0044 16V9.414Z"
    ]
  },
  "arrow-right-down": {
    paths: [
      "M14.586 16.0044L6.68602 8.10442C6.29554 7.71394 6.29554 7.08085 6.68602 6.69038V6.69038C7.07648 6.29992 7.70954 6.2999 8.10002 6.69034L16 14.5894L16 8.0044C16 7.45211 16.4477 7.0044 17 7.0044V7.0044C17.5523 7.0044 18 7.45211 18 8.0044L18 18.0044L8 18.0044C7.44771 18.0044 7 17.5567 7 17.0044V17.0044C7 16.4521 7.44771 16.0044 8 16.0044L14.586 16.0044Z"
    ]
  },
  "alarm-warning": {
    paths: [
      "M4.00059 20V14C4.00059 11.8783 4.84345 9.84344 6.34374 8.34315C7.84403 6.84285 9.87886 6 12.0006 6C14.1223 6 16.1572 6.84285 17.6574 8.34315C19.1577 9.84344 20.0006 11.8783 20.0006 14V20H21.0006V22H3.00059V20H4.00059ZM6.00059 20H18.0006V14C18.0006 12.4087 17.3685 10.8826 16.2432 9.75736C15.118 8.63214 13.5919 8 12.0006 8C10.4093 8 8.88317 8.63214 7.75795 9.75736C6.63273 10.8826 6.00059 12.4087 6.00059 14V20ZM11.0006 2H13.0006V5H11.0006V2ZM19.7786 4.808L21.1926 6.222L19.0726 8.343L17.6576 6.929L19.7786 4.808ZM2.80859 6.222L4.22259 4.808L6.34359 6.928L4.93059 8.344L2.80859 6.222ZM7.00059 14C7.00059 12.6739 7.52738 11.4021 8.46506 10.4645C9.40274 9.52678 10.6745 9 12.0006 9V11C11.2049 11 10.4419 11.3161 9.87927 11.8787C9.31666 12.4413 9.00059 13.2044 9.00059 14H7.00059Z"
    ]
  },
  "arrow-up-down": {
    paths: [
      "M11.9498 7.95L10.5358 9.364L7.9998 6.828V20H5.9998V6.828L3.4648 9.364L2.0498 7.95L6.9998 3L11.9498 7.95ZM21.9498 16.05L16.9998 21L12.0498 16.05L13.4638 14.636L16.0008 17.172L15.9998 4H17.9998V17.172L20.5358 14.636L21.9498 16.05V16.05Z"
    ]
  },
  filter: {
    paths: [
      "M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.404 6L11 12.894V20H13V12.894L17.596 6H6.404Z"
    ]
  },
  "delete-bin-6": {
    paths: [
      "M7 4V2H17V4H22V6H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
    ]
  },
  "delete-bin-7": {
    paths: [
      "M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z"
    ]
  },
  "add-circle": {
    paths: [
      "M11 11V8C11 7.44772 11.4477 7 12 7V7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12V12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17V17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12V12C7 11.4477 7.44772 11 8 11H11ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
    ]
  },
  "settings-5": {
    paths: [
      "M2.21276 14.06C1.92517 12.7017 1.92517 11.2983 2.21276 9.94001C3.32276 10.07 4.29276 9.70301 4.60876 8.93901C4.92576 8.17401 4.50076 7.22901 3.62276 6.53601C4.3798 5.37233 5.37209 4.38005 6.53576 3.62301C7.22776 4.50001 8.17376 4.92601 8.93876 4.60901C9.70376 4.29201 10.0708 3.32301 9.93976 2.21301C11.298 1.92542 12.7015 1.92542 14.0598 2.21301C13.9298 3.32301 14.2968 4.29301 15.0608 4.60901C15.8258 4.92601 16.7708 4.50101 17.4638 3.62301C18.6274 4.38005 19.6197 5.37233 20.3768 6.53601C19.4998 7.22801 19.0738 8.17401 19.3908 8.93901C19.7078 9.70401 20.6768 10.071 21.7868 9.94001C22.0744 11.2983 22.0744 12.7017 21.7868 14.06C20.6768 13.93 19.7068 14.297 19.3908 15.061C19.0738 15.826 19.4988 16.771 20.3768 17.464C19.6197 18.6277 18.6274 19.62 17.4638 20.377C16.7718 19.5 15.8258 19.074 15.0608 19.391C14.2958 19.708 13.9288 20.677 14.0598 21.787C12.7015 22.0746 11.298 22.0746 9.93976 21.787C10.0698 20.677 9.70276 19.707 8.93876 19.391C8.17376 19.074 7.22876 19.499 6.53576 20.377C5.37209 19.62 4.3798 18.6277 3.62276 17.464C4.49976 16.772 4.92576 15.826 4.60876 15.061C4.29176 14.296 3.32276 13.929 2.21276 14.06V14.06ZM3.99976 12.21C5.09976 12.515 6.00676 13.212 6.45676 14.296C6.90576 15.381 6.75676 16.516 6.19476 17.508C6.29076 17.61 6.38976 17.709 6.49176 17.805C7.48476 17.243 8.61876 17.095 9.70376 17.543C10.7878 17.993 11.4848 18.9 11.7898 20C11.9298 20.004 12.0698 20.004 12.2098 20C12.5148 18.9 13.2118 17.993 14.2958 17.543C15.3808 17.094 16.5158 17.243 17.5078 17.805C17.6098 17.709 17.7088 17.61 17.8048 17.508C17.2428 16.515 17.0948 15.381 17.5428 14.296C17.9928 13.212 18.8998 12.515 19.9998 12.21C20.0038 12.07 20.0038 11.93 19.9998 11.79C18.8998 11.485 17.9928 10.788 17.5428 9.70401C17.0938 8.61901 17.2428 7.48401 17.8048 6.49201C17.7084 6.3904 17.6094 6.29137 17.5078 6.19501C16.5148 6.75701 15.3808 6.90501 14.2958 6.45701C13.2118 6.00701 12.5148 5.10001 12.2098 4.00001C12.0698 3.9963 11.9297 3.9963 11.7898 4.00001C11.4848 5.10001 10.7878 6.00701 9.70376 6.45701C8.61876 6.90601 7.48376 6.75701 6.49176 6.19501C6.38976 6.29101 6.29076 6.39001 6.19476 6.49201C6.75676 7.48501 6.90476 8.61901 6.45676 9.70401C6.00676 10.788 5.09976 11.485 3.99976 11.79C3.99576 11.93 3.99576 12.07 3.99976 12.21V12.21ZM11.9998 15C11.2041 15 10.4411 14.6839 9.87844 14.1213C9.31583 13.5587 8.99976 12.7957 8.99976 12C8.99976 11.2044 9.31583 10.4413 9.87844 9.87869C10.4411 9.31608 11.2041 9.00001 11.9998 9.00001C12.7954 9.00001 13.5585 9.31608 14.1211 9.87869C14.6837 10.4413 14.9998 11.2044 14.9998 12C14.9998 12.7957 14.6837 13.5587 14.1211 14.1213C13.5585 14.6839 12.7954 15 11.9998 15ZM11.9998 13C12.265 13 12.5193 12.8946 12.7069 12.7071C12.8944 12.5196 12.9998 12.2652 12.9998 12C12.9998 11.7348 12.8944 11.4804 12.7069 11.2929C12.5193 11.1054 12.265 11 11.9998 11C11.7345 11 11.4802 11.1054 11.2927 11.2929C11.1051 11.4804 10.9998 11.7348 10.9998 12C10.9998 12.2652 11.1051 12.5196 11.2927 12.7071C11.4802 12.8946 11.7345 13 11.9998 13V13Z"
    ]
  },
  "arrow-up-s": {
    paths: [
      "M12.0007 10.828L7.75772 15.071C7.36725 15.4615 6.73418 15.4615 6.34372 15.071V15.071C5.95325 14.6805 5.95325 14.0475 6.34372 13.657L12.0007 8L17.6577 13.657C18.0482 14.0475 18.0482 14.6805 17.6577 15.071V15.071C17.2673 15.4615 16.6342 15.4615 16.2437 15.071L12.0007 10.828Z"
    ]
  },
  "zoom-in": {
    paths: [
      "M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM10 10V7H12V10H15V12H12V15H10V12H7V10H10Z"
    ]
  },
  "share-forward-fill": {
    paths: [
      "M13 14H11C9.3596 13.9994 7.75023 14.4471 6.34588 15.2949C4.94152 16.1427 3.7956 17.3582 3.032 18.81C3.01054 18.5405 2.99986 18.2703 3 18C3 12.477 7.477 8 13 8V3L23 11L13 19V14Z"
    ]
  },
  "upload-line": {
    paths: [
      "M3 19H21V21H3V19ZM13 5.828V17H11V5.828L4.929 11.9L3.515 10.486L12 2L20.485 10.485L19.071 11.899L13 5.83V5.828Z"
    ]
  },
  "error-warning": {
    paths: [
      "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM9.16309 14.1406V15.8076H10.8291V14.1406H9.16309ZM9.16309 4.14062V11.6406H10.8291V4.14062H9.16309Z"
    ]
  },
  "arrow-up": {
    paths: [
      "M13.0007 7.828V19C13.0007 19.5523 12.5529 20 12.0007 20V20C11.4484 20 11.0007 19.5523 11.0007 19V7.828L6.34366 12.485C5.95319 12.8755 5.32012 12.8755 4.92966 12.485V12.485C4.53919 12.0945 4.53919 11.4615 4.92966 11.071L12.0007 4L19.0717 11.071C19.4621 11.4615 19.4621 12.0945 19.0717 12.485V12.485C18.6812 12.8755 18.0481 12.8755 17.6577 12.485L13.0007 7.828Z"
    ]
  },
  share: {
    paths: [
      "M13.1202 17.023L8.92121 14.733C8.373 15.3191 7.66119 15.7267 6.87828 15.9029C6.09537 16.0791 5.27756 16.0157 4.53113 15.7211C3.7847 15.4264 3.14417 14.914 2.69277 14.2505C2.24138 13.587 2 12.803 2 12.0005C2 11.198 2.24138 10.4141 2.69277 9.75058C3.14417 9.08707 3.7847 8.57467 4.53113 8.27998C5.27756 7.98529 6.09537 7.92193 6.87828 8.09813C7.66119 8.27434 8.373 8.68196 8.92121 9.26802L13.1212 6.97802C12.8828 6.03409 12.9968 5.03561 13.4418 4.16972C13.8869 3.30384 14.6325 2.63 15.5389 2.27452C16.4452 1.91904 17.4501 1.90633 18.3652 2.23875C19.2803 2.57118 20.0427 3.22594 20.5095 4.08028C20.9764 4.93463 21.1156 5.92991 20.9011 6.87957C20.6866 7.82922 20.1332 8.66806 19.3444 9.23883C18.5557 9.8096 17.5859 10.0731 16.6168 9.98001C15.6477 9.8869 14.7458 9.44353 14.0802 8.73302L9.88021 11.023C10.0414 11.6644 10.0414 12.3357 9.88021 12.977L14.0792 15.267C14.7448 14.5565 15.6467 14.1131 16.6158 14.02C17.5849 13.9269 18.5547 14.1904 19.3434 14.7612C20.1322 15.332 20.6856 16.1708 20.9001 17.1205C21.1146 18.0701 20.9754 19.0654 20.5085 19.9198C20.0417 20.7741 19.2793 21.4289 18.3642 21.7613C17.4491 22.0937 16.4442 22.081 15.5379 21.7255C14.6315 21.37 13.8859 20.6962 13.4408 19.8303C12.9958 18.9644 12.8818 17.9659 13.1202 17.022V17.023ZM6.00021 14C6.53064 14 7.03935 13.7893 7.41442 13.4142C7.78949 13.0392 8.00021 12.5305 8.00021 12C8.00021 11.4696 7.78949 10.9609 7.41442 10.5858C7.03935 10.2107 6.53064 10 6.00021 10C5.46977 10 4.96107 10.2107 4.58599 10.5858C4.21092 10.9609 4.00021 11.4696 4.00021 12C4.00021 12.5305 4.21092 13.0392 4.58599 13.4142C4.96107 13.7893 5.46977 14 6.00021 14V14ZM17.0002 8.00002C17.5306 8.00002 18.0393 7.78931 18.4144 7.41423C18.7895 7.03916 19.0002 6.53045 19.0002 6.00002C19.0002 5.46959 18.7895 4.96088 18.4144 4.58581C18.0393 4.21073 17.5306 4.00002 17.0002 4.00002C16.4698 4.00002 15.9611 4.21073 15.586 4.58581C15.2109 4.96088 15.0002 5.46959 15.0002 6.00002C15.0002 6.53045 15.2109 7.03916 15.586 7.41423C15.9611 7.78931 16.4698 8.00002 17.0002 8.00002V8.00002ZM17.0002 20C17.5306 20 18.0393 19.7893 18.4144 19.4142C18.7895 19.0392 19.0002 18.5305 19.0002 18C19.0002 17.4696 18.7895 16.9609 18.4144 16.5858C18.0393 16.2107 17.5306 16 17.0002 16C16.4698 16 15.9611 16.2107 15.586 16.5858C15.2109 16.9609 15.0002 17.4696 15.0002 18C15.0002 18.5305 15.2109 19.0392 15.586 19.4142C15.9611 19.7893 16.4698 20 17.0002 20V20Z"
    ]
  },
  "side-nav-expand": {
    paths: [
      "M14.2861 16.1429L4.00042 16.1429L4.00042 15L14.2861 15L14.2861 16.1429ZM14.2861 12.1429L4.00042 12.1429L4.00042 11L14.2861 11L14.2861 12.1429ZM14.2861 8.14288L4.00042 8.14288L4.00042 7.00002L14.2861 7.00003L14.2861 8.14288Z",
      "M18.384 11.5715L16.7674 9.95546L17.5754 9.14689L20 11.5715L17.5754 13.996L16.7674 13.1875L18.384 11.5715Z"
    ]
  },
  "side-nav-collapse": {
    paths: [
      "M9.71387 7H19.9996V8.14286H9.71387V7ZM9.71387 11H19.9996V12.1429H9.71387V11ZM9.71387 15H19.9996V16.1429H9.71387V15Z",
      "M5.616 11.5714L7.23257 13.1874L6.42457 13.996L4 11.5714L6.42457 9.14685L7.23257 9.95542L5.616 11.5714Z"
    ]
  },
  "arrow-drop-left": {
    paths: [
      "M11.828 12L13.9499 14.1211C14.3404 14.5115 14.3405 15.1447 13.9502 15.5353V15.5353C13.5597 15.9261 12.9263 15.9263 12.5356 15.5356L9 12L12.5356 8.46436C12.9263 8.07374 13.5597 8.07393 13.9502 8.46469V8.46469C14.3405 8.8553 14.3404 9.48845 13.9499 9.87886L11.828 12Z"
    ]
  },
  "arrow-down": {
    paths: [
      "M13.0007 16.172L17.6577 11.515C18.0481 11.1245 18.6812 11.1245 19.0717 11.515V11.515C19.4621 11.9055 19.4621 12.5385 19.0717 12.929L12.0007 20L4.92966 12.929C4.53919 12.5385 4.53919 11.9055 4.92966 11.515V11.515C5.32012 11.1245 5.95319 11.1245 6.34366 11.515L11.0007 16.172V5C11.0007 4.44772 11.4484 4 12.0007 4V4C12.5529 4 13.0007 4.44772 13.0007 5V16.172Z"
    ]
  },
  dashboard: {
    paths: [
      "M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
    ]
  },
  "arrow-down-s": {
    paths: [
      "M12.0007 13.172L16.2437 8.92899C16.6342 8.53852 17.2673 8.53852 17.6577 8.92898V8.92898C18.0482 9.31945 18.0482 9.95252 17.6577 10.343L12.0007 16L6.34372 10.343C5.95325 9.95252 5.95325 9.31945 6.34372 8.92898V8.92898C6.73418 8.53852 7.36725 8.53852 7.75772 8.92898L12.0007 13.172Z"
    ]
  },
  "star-s": {
    paths: [
      "M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17ZM12.0002 14.656L14.8172 16.376L14.0512 13.166L16.5582 11.019L13.2682 10.755L12.0002 7.708L10.7322 10.755L7.44223 11.019L9.94923 13.166L9.18323 16.376L12.0002 14.657V14.656Z"
    ]
  },
  "lock-2": {
    paths: [
      "M6 8V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6ZM19 10H5V20H19V10ZM11 15.732C10.6187 15.5119 10.3207 15.1721 10.1522 14.7653C9.98376 14.3586 9.9542 13.9076 10.0681 13.4823C10.1821 13.057 10.4332 12.6813 10.7825 12.4132C11.1318 12.1452 11.5597 11.9999 12 11.9999C12.4403 11.9999 12.8682 12.1452 13.2175 12.4132C13.5668 12.6813 13.8179 13.057 13.9319 13.4823C14.0458 13.9076 14.0162 14.3586 13.8478 14.7653C13.6793 15.1721 13.3813 15.5119 13 15.732V18H11V15.732ZM8 8H16V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8Z"
    ]
  },
  "arrow-right": {
    paths: [
      "M16.172 11L11.515 6.343C11.1245 5.95253 11.1245 5.31947 11.515 4.929V4.929C11.9055 4.53853 12.5385 4.53853 12.929 4.929L20 12L12.929 19.071C12.5385 19.4615 11.9055 19.4615 11.515 19.071V19.071C11.1245 18.6805 11.1245 18.0475 11.515 17.657L16.172 13H5C4.44772 13 4 12.5523 4 12V12C4 11.4477 4.44772 11 5 11H16.172Z"
    ]
  },
  search: {
    paths: [
      "M18.031 16.617L21.6067 20.1919C21.9973 20.5824 21.9971 21.2159 21.6065 21.6065V21.6065C21.2159 21.9971 20.5824 21.9973 20.1919 21.6067L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875Z"
    ]
  },
  more: {
    paths: [
      "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
    ]
  },
  "lock-password": {
    paths: [
      "M18 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8ZM5 10V20H19V10H5ZM11 14H13V16H11V14ZM7 14H9V16H7V14ZM15 14H17V16H15V14ZM16 8V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8H16Z"
    ]
  },
  download: {
    paths: [
      "M3 19H21V21H3V19ZM13 13.172L19.071 7.1L20.485 8.514L12 17L3.515 8.515L4.929 7.1L11 13.17V2H13V13.172Z"
    ]
  },
  star: {
    paths: [
      "M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26ZM11.9999 15.968L16.2469 18.345L15.2979 13.572L18.8709 10.267L14.0379 9.694L11.9999 5.275L9.96191 9.695L5.12891 10.267L8.70191 13.572L7.75291 18.345L11.9999 15.968V15.968Z"
    ]
  },
  "arrow-go-forward": {
    paths: [
      "M18.172 7H11C9.4087 7 7.88258 7.63214 6.75736 8.75736C5.63214 9.88258 5 11.4087 5 13C5 14.5913 5.63214 16.1174 6.75736 17.2426C7.88258 18.3679 9.4087 19 11 19H19C19.5523 19 20 19.4477 20 20V20C20 20.5523 19.5523 21 19 21H11C8.87827 21 6.84344 20.1571 5.34315 18.6569C3.84285 17.1566 3 15.1217 3 13C3 10.8783 3.84285 8.84344 5.34315 7.34315C6.84344 5.84285 8.87827 5 11 5H18.172L16.343 3.171C15.9525 2.78053 15.9525 2.14746 16.343 1.757V1.757C16.7335 1.36653 17.3665 1.36653 17.757 1.757L22 6L17.757 10.243C17.3665 10.6335 16.7335 10.6335 16.343 10.243V10.243C15.9525 9.85253 15.9525 9.21946 16.343 8.829L18.172 7Z"
    ]
  },
  eye: {
    paths: [
      "M12.0006 3C17.3926 3 21.8786 6.88 22.8196 12C21.8796 17.12 17.3926 21 12.0006 21C6.60864 21 2.12264 17.12 1.18164 12C2.12164 6.88 6.60864 3 12.0006 3ZM12.0006 19C14.0401 18.9996 16.019 18.3068 17.6135 17.0352C19.208 15.7635 20.3235 13.9883 20.7776 12C20.3219 10.0133 19.2056 8.24 17.6113 6.97003C16.017 5.70005 14.0389 5.00853 12.0006 5.00853C9.96234 5.00853 7.98433 5.70005 6.39002 6.97003C4.7957 8.24 3.67941 10.0133 3.22364 12C3.67774 13.9883 4.79331 15.7635 6.38778 17.0352C7.98226 18.3068 9.96117 18.9996 12.0006 19V19ZM12.0006 16.5C10.8072 16.5 9.66257 16.0259 8.81866 15.182C7.97475 14.3381 7.50064 13.1935 7.50064 12C7.50064 10.8065 7.97475 9.66193 8.81866 8.81802C9.66257 7.97411 10.8072 7.5 12.0006 7.5C13.1941 7.5 14.3387 7.97411 15.1826 8.81802C16.0265 9.66193 16.5006 10.8065 16.5006 12C16.5006 13.1935 16.0265 14.3381 15.1826 15.182C14.3387 16.0259 13.1941 16.5 12.0006 16.5ZM12.0006 14.5C12.6637 14.5 13.2996 14.2366 13.7684 13.7678C14.2372 13.2989 14.5006 12.663 14.5006 12C14.5006 11.337 14.2372 10.7011 13.7684 10.2322C13.2996 9.76339 12.6637 9.5 12.0006 9.5C11.3376 9.5 10.7017 9.76339 10.2329 10.2322C9.76403 10.7011 9.50064 11.337 9.50064 12C9.50064 12.663 9.76403 13.2989 10.2329 13.7678C10.7017 14.2366 11.3376 14.5 12.0006 14.5Z"
    ]
  },
  "thumb-up": {
    paths: [
      "M14.6 8H21C21.5304 8 22.0391 8.21071 22.4142 8.58578C22.7893 8.96085 23 9.46956 23 10V12.104C23.0003 12.3654 22.9493 12.6242 22.85 12.866L19.755 20.381C19.6795 20.5642 19.5513 20.7209 19.3866 20.8311C19.2219 20.9413 19.0282 21.0001 18.83 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20V10C1 9.73478 1.10536 9.48043 1.29289 9.29289C1.48043 9.10535 1.73478 9 2 9H5.482C5.6421 9.00004 5.79986 8.96164 5.94203 8.88803C6.0842 8.81442 6.20662 8.70775 6.299 8.57699L11.752 0.849995C11.8209 0.752308 11.9226 0.682556 12.0385 0.653386C12.1545 0.624215 12.277 0.637558 12.384 0.690995L14.198 1.598C14.7085 1.85316 15.1163 2.27531 15.3537 2.79431C15.5911 3.31331 15.6438 3.89792 15.503 4.451L14.6 8ZM7 10.588V19H18.16L21 12.104V10H14.6C14.2954 9.99995 13.9948 9.93033 13.7212 9.79645C13.4476 9.66257 13.2082 9.46797 13.0213 9.22748C12.8343 8.987 12.7048 8.70699 12.6425 8.40882C12.5803 8.11065 12.5869 7.8022 12.662 7.507L13.565 3.959C13.5933 3.84832 13.5828 3.73131 13.5353 3.62742C13.4878 3.52354 13.4062 3.43904 13.304 3.388L12.643 3.058L7.933 9.72999C7.683 10.084 7.363 10.374 7 10.588V10.588ZM5 11H3V19H5V11Z"
    ]
  },
  function: {
    paths: [
      "M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13ZM15 5V9H19V5H15ZM15 15V19H19V15H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z"
    ]
  },
  "arrow-drop-right": {
    paths: [
      "M12.1718 12L10.0499 9.87885C9.65934 9.48844 9.65925 8.85529 10.0496 8.46468V8.46468C10.4401 8.07392 11.0735 8.07372 11.4641 8.46435L14.9998 12L11.4641 15.5356C11.0735 15.9263 10.4401 15.9261 10.0496 15.5353V15.5353C9.65925 15.1447 9.65934 14.5115 10.0499 14.1211L12.1718 12Z"
    ]
  },
  "eye-off": {
    paths: [
      "M17.8826 19.297C16.1239 20.4126 14.0834 21.0033 12.0006 21C6.60864 21 2.12264 17.12 1.18164 12C1.61167 9.67072 2.78327 7.5429 4.52164 5.93401L1.39264 2.80801L2.80764 1.39301L22.6066 21.193L21.1916 22.607L17.8816 19.297H17.8826ZM5.93564 7.35001C4.57665 8.5856 3.62996 10.2088 3.22364 12C3.53593 13.3665 4.1629 14.6411 5.05464 15.7226C5.94638 16.804 7.07827 17.6624 8.36019 18.2293C9.64212 18.7962 11.0387 19.0561 12.4387 18.9881C13.8388 18.9202 15.2036 18.5264 16.4246 17.838L14.3966 15.81C13.5333 16.3538 12.5108 16.5881 11.4969 16.4744C10.4829 16.3608 9.53768 15.9059 8.81621 15.1844C8.09474 14.463 7.63987 13.5177 7.5262 12.5038C7.41254 11.4898 7.64682 10.4673 8.19064 9.60401L5.93564 7.35001ZM12.9146 14.328L9.67264 11.086C9.49471 11.5389 9.45283 12.034 9.55215 12.5104C9.65146 12.9867 9.88766 13.4238 10.2318 13.7679C10.5759 14.112 11.0129 14.3482 11.4893 14.4475C11.9657 14.5468 12.4607 14.5049 12.9136 14.327L12.9146 14.328ZM20.8076 16.592L19.3766 15.162C20.0451 14.2093 20.521 13.1352 20.7776 12C20.5059 10.8097 19.9949 9.68715 19.2758 8.7005C18.5567 7.71385 17.6444 6.88373 16.5945 6.26061C15.5446 5.63749 14.3789 5.23437 13.1684 5.07577C11.9578 4.91717 10.7276 5.00638 9.55264 5.33801L7.97464 3.76001C9.22164 3.27001 10.5806 3.00001 12.0006 3.00001C17.3926 3.00001 21.8786 6.88001 22.8196 12C22.5132 13.6657 21.8245 15.2376 20.8076 16.592V16.592ZM11.7236 7.50801C12.3602 7.46867 12.9978 7.56507 13.5942 7.79082C14.1906 8.01657 14.7323 8.36652 15.1832 8.81746C15.6341 9.2684 15.9841 9.81003 16.2098 10.4065C16.4356 11.0029 16.532 11.6405 16.4926 12.277L11.7226 7.50801H11.7236Z"
    ]
  },
  "arrow-right-s": {
    paths: [
      "M13.1727 12L8.92966 7.75699C8.53919 7.36652 8.53919 6.73345 8.92966 6.34299V6.34299C9.32012 5.95252 9.95319 5.95252 10.3437 6.34299L16.0007 12L10.3437 17.657C9.95319 18.0475 9.32012 18.0475 8.92966 17.657V17.657C8.53919 17.2665 8.53919 16.6335 8.92966 16.243L13.1727 12Z"
    ]
  },
  "arrow-go-back": {
    paths: [
      "M5.828 7L7.657 8.829C8.04747 9.21946 8.04747 9.85253 7.657 10.243V10.243C7.26653 10.6335 6.63347 10.6335 6.243 10.243L2 6L6.243 1.757C6.63346 1.36653 7.26653 1.36653 7.657 1.757V1.757C8.04747 2.14746 8.04747 2.78053 7.657 3.171L5.828 5H13C15.1217 5 17.1566 5.84285 18.6569 7.34315C20.1571 8.84344 21 10.8783 21 13C21 15.1217 20.1571 17.1566 18.6569 18.6569C17.1566 20.1571 15.1217 21 13 21H5C4.44772 21 4 20.5523 4 20V20C4 19.4477 4.44772 19 5 19H13C14.5913 19 16.1174 18.3679 17.2426 17.2426C18.3679 16.1174 19 14.5913 19 13C19 11.4087 18.3679 9.88258 17.2426 8.75736C16.1174 7.63214 14.5913 7 13 7H5.828Z"
    ]
  },
  check: {
    paths: [
      "M10.0007 15.172L18.4859 6.68594C18.8763 6.29547 19.5094 6.29547 19.9 6.68577V6.68577C20.2907 7.07626 20.291 7.70974 19.9004 8.10036L10.7078 17.2929C10.3173 17.6834 9.68414 17.6834 9.29361 17.2929L4.34372 12.343C3.95325 11.9525 3.95325 11.3195 4.34372 10.929V10.929C4.73418 10.5385 5.36725 10.5385 5.75772 10.929L10.0007 15.172Z"
    ]
  },
  "check-circle": {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z",
      "M7.66667 14.6167L4 10.95L5.28333 9.66667L7.66667 12.05L13.7167 6L15 7.28333L7.66667 14.6167Z"
    ]
  },
  "share-box": {
    paths: [
      "M10 3V5H5V19H19V14H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10ZM17.586 5H13V3H21V11H19V6.414L12 13.414L10.586 12L17.586 5Z"
    ]
  },
  menu: {
    paths: ["M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"]
  },
  "notification-4": {
    paths: [
      "M18 10C18 8.4087 17.3679 6.88258 16.2426 5.75736C15.1174 4.63214 13.5913 4 12 4C10.4087 4 8.88258 4.63214 7.75736 5.75736C6.63214 6.88258 6 8.4087 6 10V18H18V10ZM20 18.667L20.4 19.2C20.4557 19.2743 20.4896 19.3626 20.498 19.4551C20.5063 19.5476 20.4887 19.6406 20.4472 19.7236C20.4057 19.8067 20.3419 19.8765 20.2629 19.9253C20.1839 19.9741 20.0929 20 20 20H4C3.90714 20 3.81612 19.9741 3.73713 19.9253C3.65815 19.8765 3.59431 19.8067 3.55279 19.7236C3.51126 19.6406 3.49368 19.5476 3.50202 19.4551C3.51036 19.3626 3.54429 19.2743 3.6 19.2L4 18.667V10C4 7.87827 4.84286 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10V18.667ZM9.5 21H14.5C14.5 21.663 14.2366 22.2989 13.7678 22.7678C13.2989 23.2366 12.663 23.5 12 23.5C11.337 23.5 10.7011 23.2366 10.2322 22.7678C9.76339 22.2989 9.5 21.663 9.5 21V21Z"
    ]
  },
  "logo-google-drive": {
    paths: [
      "M29.5004 21L26.3296 26.5489C26.0476 27.0036 25.6517 27.3768 25.181 27.6313C24.7103 27.8859 24.1813 28.0129 23.6463 28H8.35454C7.81961 28.0129 7.29058 27.8859 6.8199 27.6313C6.34923 27.3768 5.95325 27.0036 5.67124 26.5489L4.36914 24.27L9.75824 21H29.5004Z",
      "M12.3828 4.13C11.6626 4.38843 11.0577 4.89441 10.6761 5.5576L2.95974 18.76C2.67862 19.2153 2.52139 19.7362 2.50364 20.271C2.48589 20.8058 2.60823 21.336 2.85854 21.8089L4.38854 24.2747L9.75854 21L16.0006 10.32L12.3828 4.13Z",
      "M9.75816 21H2.56836C2.62045 21.2836 2.7184 21.5568 2.85836 21.8089L4.38036 24.2632L4.36886 24.2702L5.67126 26.549C5.98317 27.0645 6.45165 27.4669 7.00836 27.6974L9.75816 21L9.75006 21.0049L9.75816 21Z",
      "M19.6062 4.13C20.3264 4.3884 20.9312 4.89439 21.3128 5.5576L29.0294 18.76C29.3105 19.2153 29.4678 19.7362 29.4855 20.271C29.5033 20.8058 29.381 21.336 29.1307 21.8089L27.6012 24.2747L22.2305 21L15.9883 10.32L19.6062 4.13Z",
      "M22.2305 21H29.4205C29.3684 21.2836 29.2704 21.5568 29.1305 21.8089L27.6081 24.2633L27.6197 24.2703L26.3175 26.549C26.0055 27.0645 25.5371 27.4669 24.9804 27.6974L22.2306 21L22.2387 21.0049L22.2305 21Z",
      "M19.6159 4.1342L19.6182 4.1302C19.5003 4.08935 19.3797 4.05651 19.2573 4.0319L16.0004 4L12.7435 4.0319C12.6211 4.05651 12.5006 4.08935 12.3826 4.1302C12.2567 4.17751 12.1341 4.23316 12.0156 4.2968L15.9893 10.32L19.9774 4.2993C19.8607 4.23642 19.7399 4.18126 19.6159 4.1342Z"
    ]
  },
  "emotion-happy": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 13H9C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13H17C17 14.3261 16.4732 15.5979 15.5355 16.5355C14.5979 17.4732 13.3261 18 12 18C10.6739 18 9.40215 17.4732 8.46447 16.5355C7.52678 15.5979 7 14.3261 7 13V13ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ]
  },
  "user-add": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
    ]
  },
  "emotion-normal": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM8 14H16V16H8V14ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ]
  },
  "user-search": {
    paths: [
      "M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14V14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21.446 20.032L22.95 21.536L21.536 22.95L20.032 21.446C19.1933 21.9405 18.2031 22.1121 17.247 21.9288C16.2908 21.7454 15.4343 21.2196 14.8381 20.4499C14.2419 19.6802 13.9469 18.7195 14.0083 17.7479C14.0698 16.7762 14.4835 15.8604 15.1719 15.1719C15.8604 14.4835 16.7762 14.0698 17.7479 14.0083C18.7195 13.9469 19.6802 14.2419 20.4499 14.8381C21.2196 15.4343 21.7454 16.2908 21.9288 17.247C22.1121 18.2031 21.9405 19.1933 21.446 20.032V20.032ZM18 20C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18C20 17.4696 19.7893 16.9609 19.4142 16.5858C19.0391 16.2107 18.5304 16 18 16C17.4696 16 16.9609 16.2107 16.5858 16.5858C16.2107 16.9609 16 17.4696 16 18C16 18.5304 16.2107 19.0391 16.5858 19.4142C16.9609 19.7893 17.4696 20 18 20V20Z"
    ]
  },
  "user-shared": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18.586 17L16.757 15.172L18.172 13.757L22.414 18L18.172 22.243L16.757 20.828L18.586 19H15V17H18.586Z"
    ]
  },
  user: {
    paths: [
      "M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H18C18 20.4087 17.3679 18.8826 16.2426 17.7574C15.1174 16.6321 13.5913 16 12 16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
    ]
  },
  parent: {
    paths: [
      "M7 9C7.66304 9 8.29893 8.73661 8.76777 8.26777C9.23661 7.79893 9.5 7.16304 9.5 6.5C9.5 5.83696 9.23661 5.20107 8.76777 4.73223C8.29893 4.26339 7.66304 4 7 4C6.33696 4 5.70107 4.26339 5.23223 4.73223C4.76339 5.20107 4.5 5.83696 4.5 6.5C4.5 7.16304 4.76339 7.79893 5.23223 8.26777C5.70107 8.73661 6.33696 9 7 9ZM7 11C6.40905 11 5.82389 10.8836 5.27792 10.6575C4.73196 10.4313 4.23588 10.0998 3.81802 9.68198C3.40016 9.26412 3.06869 8.76804 2.84254 8.22208C2.6164 7.67611 2.5 7.09095 2.5 6.5C2.5 5.90905 2.6164 5.32389 2.84254 4.77792C3.06869 4.23196 3.40016 3.73588 3.81802 3.31802C4.23588 2.90016 4.73196 2.56869 5.27792 2.34254C5.82389 2.1164 6.40905 2 7 2C8.19347 2 9.33807 2.47411 10.182 3.31802C11.0259 4.16193 11.5 5.30653 11.5 6.5C11.5 7.69347 11.0259 8.83807 10.182 9.68198C9.33807 10.5259 8.19347 11 7 11V11ZM17.5 13C18.0304 13 18.5391 12.7893 18.9142 12.4142C19.2893 12.0391 19.5 11.5304 19.5 11C19.5 10.4696 19.2893 9.96086 18.9142 9.58579C18.5391 9.21071 18.0304 9 17.5 9C16.9696 9 16.4609 9.21071 16.0858 9.58579C15.7107 9.96086 15.5 10.4696 15.5 11C15.5 11.5304 15.7107 12.0391 16.0858 12.4142C16.4609 12.7893 16.9696 13 17.5 13V13ZM17.5 15C16.4391 15 15.4217 14.5786 14.6716 13.8284C13.9214 13.0783 13.5 12.0609 13.5 11C13.5 9.93913 13.9214 8.92172 14.6716 8.17157C15.4217 7.42143 16.4391 7 17.5 7C18.5609 7 19.5783 7.42143 20.3284 8.17157C21.0786 8.92172 21.5 9.93913 21.5 11C21.5 12.0609 21.0786 13.0783 20.3284 13.8284C19.5783 14.5786 18.5609 15 17.5 15ZM20 21V20.5C20 19.837 19.7366 19.2011 19.2678 18.7322C18.7989 18.2634 18.163 18 17.5 18C16.837 18 16.2011 18.2634 15.7322 18.7322C15.2634 19.2011 15 19.837 15 20.5V21H13V20.5C13 19.9091 13.1164 19.3239 13.3425 18.7779C13.5687 18.232 13.9002 17.7359 14.318 17.318C14.7359 16.9002 15.232 16.5687 15.7779 16.3425C16.3239 16.1164 16.9091 16 17.5 16C18.0909 16 18.6761 16.1164 19.2221 16.3425C19.768 16.5687 20.2641 16.9002 20.682 17.318C21.0998 17.7359 21.4313 18.232 21.6575 18.7779C21.8836 19.3239 22 19.9091 22 20.5V21H20ZM10 21V17C10 16.2044 9.68393 15.4413 9.12132 14.8787C8.55871 14.3161 7.79565 14 7 14C6.20435 14 5.44129 14.3161 4.87868 14.8787C4.31607 15.4413 4 16.2044 4 17V21H2V17C2 15.6739 2.52678 14.4021 3.46447 13.4645C4.40215 12.5268 5.67392 12 7 12C8.32608 12 9.59785 12.5268 10.5355 13.4645C11.4732 14.4021 12 15.6739 12 17V21H10Z"
    ]
  },
  team: {
    paths: [
      "M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645C16.4732 13.4021 17 14.6739 17 16V22H15V16C15 15.2348 14.7077 14.4985 14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14V14ZM18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22H20V17.5C20 17.1271 19.8611 16.7676 19.6104 16.4916C19.3597 16.2156 19.0152 16.0428 18.644 16.007L18.5 16C18.325 16 18.157 16.03 18 16.085V16C18 15.334 17.892 14.694 17.691 14.096C17.95 14.033 18.221 14 18.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8V8ZM18.5 8C19.163 8 19.7989 8.26339 20.2678 8.73223C20.7366 9.20107 21 9.83696 21 10.5C21 11.163 20.7366 11.7989 20.2678 12.2678C19.7989 12.7366 19.163 13 18.5 13C17.837 13 17.2011 12.7366 16.7322 12.2678C16.2634 11.7989 16 11.163 16 10.5C16 9.83696 16.2634 9.20107 16.7322 8.73223C17.2011 8.26339 17.837 8 18.5 8V8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM18.5 10C18.3674 10 18.2402 10.0527 18.1464 10.1464C18.0527 10.2402 18 10.3674 18 10.5C18 10.6326 18.0527 10.7598 18.1464 10.8536C18.2402 10.9473 18.3674 11 18.5 11C18.6326 11 18.7598 10.9473 18.8536 10.8536C18.9473 10.7598 19 10.6326 19 10.5C19 10.3674 18.9473 10.2402 18.8536 10.1464C18.7598 10.0527 18.6326 10 18.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2V2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4V4Z"
    ]
  },
  "user-follow": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM17.793 19.914L21.328 16.379L22.743 17.793L17.793 22.743L14.257 19.207L15.672 17.793L17.792 19.914H17.793Z"
    ]
  },
  "user-received": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19.418 17H23.004V19H19.418L21.247 20.828L19.833 22.243L15.59 18L19.833 13.757L21.247 15.172L19.418 17Z"
    ]
  },
  admin: {
    paths: [
      "M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14V14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21 17H22V22H14V17H15V16C15 15.2044 15.3161 14.4413 15.8787 13.8787C16.4413 13.3161 17.2044 13 18 13C18.7956 13 19.5587 13.3161 20.1213 13.8787C20.6839 14.4413 21 15.2044 21 16V17ZM19 17V16C19 15.7348 18.8946 15.4804 18.7071 15.2929C18.5196 15.1054 18.2652 15 18 15C17.7348 15 17.4804 15.1054 17.2929 15.2929C17.1054 15.4804 17 15.7348 17 16V17H19Z"
    ]
  },
  "user-heart": {
    paths: [
      "M17.841 15.659L18.017 15.836L18.195 15.659C18.4039 15.4501 18.652 15.2843 18.925 15.1713C19.1979 15.0582 19.4905 15 19.786 15C20.0815 15 20.3741 15.0582 20.647 15.1713C20.92 15.2843 21.1681 15.4501 21.377 15.659C21.5859 15.8679 21.7517 16.116 21.8647 16.389C21.9778 16.6619 22.036 16.9545 22.036 17.25C22.036 17.5455 21.9778 17.8381 21.8647 18.111C21.7517 18.384 21.5859 18.6321 21.377 18.841L18.017 22.2L14.659 18.841C14.237 18.419 14 17.8467 14 17.25C14 16.6533 14.237 16.081 14.659 15.659C15.081 15.237 15.6533 15 16.25 15C16.8467 15 17.419 15.237 17.841 15.659V15.659ZM12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4.00002 19.9216 4.80894 17.9247 6.25547 16.4323C7.702 14.9398 9.67259 14.069 11.75 14.004L12 14ZM12 1C15.315 1 18 3.685 18 7C18.0006 8.55253 17.3991 10.0448 16.3221 11.163C15.2451 12.2812 13.7765 12.9383 12.225 12.996L12 13C8.685 13 6 10.315 6 7C5.99944 5.44747 6.6009 3.95521 7.67791 2.83699C8.75491 1.71877 10.2235 1.06172 11.775 1.004L12 1ZM12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3Z"
    ]
  },
  "user-unfollow": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19 17.586L21.121 15.464L22.536 16.879L20.414 19L22.536 21.121L21.121 22.536L19 20.414L16.879 22.536L15.464 21.121L17.586 19L15.464 16.879L16.879 15.464L19 17.586Z"
    ]
  },
  "emotion-unhappy": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 17C7 15.6739 7.52678 14.4021 8.46447 13.4645C9.40215 12.5268 10.6739 12 12 12C13.3261 12 14.5979 12.5268 15.5355 13.4645C16.4732 14.4021 17 15.6739 17 17H15C15 16.2044 14.6839 15.4413 14.1213 14.8787C13.5587 14.3161 12.7956 14 12 14C11.2044 14 10.4413 14.3161 9.87868 14.8787C9.31607 15.4413 9 16.2044 9 17H7ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ]
  },
  "user-voice": {
    paths: [
      "M1 22C1 19.8783 1.84285 17.8434 3.34315 16.3431C4.84344 14.8429 6.87827 14 9 14C11.1217 14 13.1566 14.8429 14.6569 16.3431C16.1571 17.8434 17 19.8783 17 22H15C15 20.4087 14.3679 18.8826 13.2426 17.7574C12.1174 16.6321 10.5913 16 9 16C7.4087 16 5.88258 16.6321 4.75736 17.7574C3.63214 18.8826 3 20.4087 3 22H1ZM9 13C5.685 13 3 10.315 3 7C3 3.685 5.685 1 9 1C12.315 1 15 3.685 15 7C15 10.315 12.315 13 9 13ZM9 11C11.21 11 13 9.21 13 7C13 4.79 11.21 3 9 3C6.79 3 5 4.79 5 7C5 9.21 6.79 11 9 11ZM21.548 0.784C22.5062 2.71583 23.0032 4.84359 23 7C23 9.233 22.477 11.344 21.548 13.216L19.903 12.02C20.6282 10.446 21.0025 8.73307 21 7C21 5.208 20.607 3.507 19.903 1.98L21.548 0.784ZM18.246 3.184C18.7454 4.39416 19.0016 5.69083 19 7C19.0016 8.30917 18.7454 9.60584 18.246 10.816L16.569 9.596C16.8552 8.76044 17.0008 7.88321 17 7C17.0011 6.11685 16.8558 5.23962 16.57 4.404L18.246 3.184Z"
    ]
  },
  "camera-off": {
    paths: [
      "M19.5856 21H2.99958C2.73436 21 2.48001 20.8946 2.29247 20.7071C2.10493 20.5196 1.99958 20.2652 1.99958 20V6.00001C1.99958 5.73479 2.10493 5.48044 2.29247 5.2929C2.48001 5.10536 2.73436 5.00001 2.99958 5.00001H3.58558L1.39258 2.80801L2.80758 1.39301L22.6066 21.193L21.1916 22.607L19.5856 21ZM5.58558 7.00001H3.99958V19H17.5856L15.4056 16.82C14.3481 17.6569 13.0201 18.0762 11.6738 17.9981C10.3275 17.92 9.05677 17.35 8.10319 16.3964C7.14961 15.4428 6.57961 14.1721 6.50151 12.8258C6.42341 11.4795 6.84266 10.1515 7.67958 9.09401L5.58558 7.00001V7.00001ZM9.10958 10.525C8.64856 11.1988 8.43757 12.0125 8.5131 12.8253C8.58863 13.6382 8.94595 14.3991 9.52321 14.9764C10.1005 15.5536 10.8614 15.9109 11.6743 15.9865C12.4871 16.062 13.3008 15.851 13.9746 15.39L9.10958 10.525ZM21.9996 17.785L19.9996 15.785V7.00001H16.1716L14.1716 5.00001H9.82758L9.52058 5.30701L8.10658 3.89301L8.99958 3.00001H14.9996L16.9996 5.00001H20.9996C21.2648 5.00001 21.5191 5.10536 21.7067 5.2929C21.8942 5.48044 21.9996 5.73479 21.9996 6.00001V17.786V17.785ZM11.2626 7.05001C12.1019 6.9364 12.9562 7.01819 13.7587 7.28899C14.5613 7.55979 15.2904 8.0123 15.8894 8.61122C16.4883 9.21014 16.9408 9.9393 17.2116 10.7419C17.4824 11.5444 17.5642 12.3987 17.4506 13.238L15.1126 10.9C14.7778 10.2512 14.2494 9.72276 13.6006 9.388L11.2626 7.05001V7.05001Z"
    ]
  },
  "image-add": {
    paths: [
      "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.008 3C21.556 3 22 3.445 22 3.993V13H20V5H4V18.999L14 9L17 12V14.829L14 11.829L6.827 19H14V21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008ZM8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7V7Z"
    ]
  },
  camera: {
    paths: [
      "M9.828 5L7.828 7H4V19H20V7H16.172L14.172 5H9.828ZM9 3H15L17 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H7L9 3ZM12 18C10.5413 18 9.14236 17.4205 8.11091 16.3891C7.07946 15.3576 6.5 13.9587 6.5 12.5C6.5 11.0413 7.07946 9.64236 8.11091 8.61091C9.14236 7.57946 10.5413 7 12 7C13.4587 7 14.8576 7.57946 15.8891 8.61091C16.9205 9.64236 17.5 11.0413 17.5 12.5C17.5 13.9587 16.9205 15.3576 15.8891 16.3891C14.8576 17.4205 13.4587 18 12 18ZM12 16C12.9283 16 13.8185 15.6313 14.4749 14.9749C15.1313 14.3185 15.5 13.4283 15.5 12.5C15.5 11.5717 15.1313 10.6815 14.4749 10.0251C13.8185 9.36875 12.9283 9 12 9C11.0717 9 10.1815 9.36875 9.52513 10.0251C8.86875 10.6815 8.5 11.5717 8.5 12.5C8.5 13.4283 8.86875 14.3185 9.52513 14.9749C10.1815 15.6313 11.0717 16 12 16V16Z"
    ]
  },
  image: {
    paths: [
      "M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828V21ZM20 15V5H4V19L14 9L20 15ZM20 17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
    ]
  },
  equalizer: {
    paths: [
      "M6.17 18C6.3766 17.4145 6.75974 16.9074 7.2666 16.5488C7.77346 16.1901 8.37909 15.9976 9 15.9976C9.62091 15.9976 10.2265 16.1901 10.7334 16.5488C11.2403 16.9074 11.6234 17.4145 11.83 18H22V20H11.83C11.6234 20.5855 11.2403 21.0926 10.7334 21.4512C10.2265 21.8099 9.62091 22.0025 9 22.0025C8.37909 22.0025 7.77346 21.8099 7.2666 21.4512C6.75974 21.0926 6.3766 20.5855 6.17 20H2V18H6.17ZM12.17 11C12.3766 10.4145 12.7597 9.90743 13.2666 9.54879C13.7735 9.19015 14.3791 8.99755 15 8.99755C15.6209 8.99755 16.2265 9.19015 16.7334 9.54879C17.2403 9.90743 17.6234 10.4145 17.83 11H22V13H17.83C17.6234 13.5855 17.2403 14.0926 16.7334 14.4512C16.2265 14.8099 15.6209 15.0025 15 15.0025C14.3791 15.0025 13.7735 14.8099 13.2666 14.4512C12.7597 14.0926 12.3766 13.5855 12.17 13H2V11H12.17ZM6.17 4C6.3766 3.41447 6.75974 2.90744 7.2666 2.54879C7.77346 2.19015 8.37909 1.99755 9 1.99755C9.62091 1.99755 10.2265 2.19015 10.7334 2.54879C11.2403 2.90744 11.6234 3.41447 11.83 4H22V6H11.83C11.6234 6.58553 11.2403 7.09257 10.7334 7.45121C10.2265 7.80986 9.62091 8.00245 9 8.00245C8.37909 8.00245 7.77346 7.80986 7.2666 7.45121C6.75974 7.09257 6.3766 6.58553 6.17 6H2V4H6.17ZM9 6C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6V6ZM15 13C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12C14 12.2652 14.1054 12.5196 14.2929 12.7071C14.4804 12.8946 14.7348 13 15 13V13ZM9 20C9.26522 20 9.51957 19.8946 9.70711 19.7071C9.89464 19.5196 10 19.2652 10 19C10 18.7348 9.89464 18.4804 9.70711 18.2929C9.51957 18.1054 9.26522 18 9 18C8.73478 18 8.48043 18.1054 8.29289 18.2929C8.10536 18.4804 8 18.7348 8 19C8 19.2652 8.10536 19.5196 8.29289 19.7071C8.48043 19.8946 8.73478 20 9 20V20Z"
    ]
  },
  "map-pin": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9ZM12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728V23.728ZM12 13C12.5304 13 13.0391 12.7893 13.4142 12.4142C13.7893 12.0391 14 11.5304 14 11C14 10.4696 13.7893 9.96086 13.4142 9.58578C13.0391 9.21071 12.5304 9 12 9C11.4696 9 10.9609 9.21071 10.5858 9.58578C10.2107 9.96086 10 10.4696 10 11C10 11.5304 10.2107 12.0391 10.5858 12.4142C10.9609 12.7893 11.4696 13 12 13ZM12 15C10.9391 15 9.92172 14.5786 9.17158 13.8284C8.42143 13.0783 8 12.0609 8 11C8 9.93913 8.42143 8.92172 9.17158 8.17157C9.92172 7.42143 10.9391 7 12 7C13.0609 7 14.0783 7.42143 14.8284 8.17157C15.5786 8.92172 16 9.93913 16 11C16 12.0609 15.5786 13.0783 14.8284 13.8284C14.0783 14.5786 13.0609 15 12 15Z"
    ]
  },
  "map-pin-filled": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9Z"
    ],
    viewBox: "2 2 20 20"
  },
  "map-pin-add": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9ZM12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728V23.728ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
    ]
  },
  pushpin: {
    paths: [
      "M13.8277 1.686L22.3137 10.172L20.8987 11.586L20.1917 10.879L15.9497 15.121L15.2427 18.657L13.8277 20.071L9.58568 15.828L4.63568 20.778L3.22168 19.364L8.17168 14.414L3.92868 10.172L5.34268 8.757L8.87968 8.05L13.1217 3.808L12.4147 3.101L13.8287 1.686H13.8277ZM14.5357 5.222L9.86468 9.892L7.04268 10.457L13.5427 16.957L14.1067 14.135L18.7777 9.465L14.5357 5.222V5.222Z"
    ]
  },
  earth: {
    paths: [
      "M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453V6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
    ]
  },
  "map-2": {
    paths: [
      "M2 5L9 2L15 5L21.303 2.299C21.3791 2.26638 21.4621 2.25317 21.5445 2.26054C21.627 2.26792 21.7063 2.29565 21.7754 2.34124C21.8445 2.38684 21.9012 2.44888 21.9404 2.5218C21.9796 2.59471 22.0001 2.67622 22 2.759V19L15 22L9 19L2.697 21.701C2.62091 21.7336 2.53792 21.7468 2.45547 21.7395C2.37301 21.7321 2.29368 21.7044 2.22459 21.6588C2.1555 21.6132 2.09881 21.5511 2.05961 21.4782C2.02041 21.4053 1.99993 21.3238 2 21.241V5ZM16 19.395L20 17.681V5.033L16 6.747V19.395ZM14 19.264V6.736L10 4.736V17.264L14 19.264ZM8 17.253V4.605L4 6.319V18.967L8 17.253Z"
    ]
  },
  "pushpin-2": {
    paths: [
      "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18ZM9 5V11.606L7.404 14H16.596L15 11.606V5H9Z"
    ]
  },
  "map-pin-2": {
    paths: [
      "M12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728ZM16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9L16.95 15.95V15.95ZM12 13C11.4696 13 10.9609 12.7893 10.5858 12.4142C10.2107 12.0391 10 11.5304 10 11C10 10.4696 10.2107 9.96086 10.5858 9.58578C10.9609 9.21071 11.4696 9 12 9C12.5304 9 13.0391 9.21071 13.4142 9.58578C13.7893 9.96086 14 10.4696 14 11C14 11.5304 13.7893 12.0391 13.4142 12.4142C13.0391 12.7893 12.5304 13 12 13Z"
    ]
  },
  pencil: {
    paths: [
      "M15.728 9.686L14.314 8.272L5 17.586V19H6.414L15.728 9.686ZM17.142 8.272L18.556 6.858L17.142 5.444L15.728 6.858L17.142 8.272ZM7.242 21H3V16.757L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L7.243 21H7.242Z"
    ]
  },
  "layout-left-2": {
    paths: [
      "M21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21ZM20 5H4V19H20V5ZM8 7V17H6V7H8Z"
    ]
  },
  "edit-2": {
    paths: [
      "M5 19H6.414L15.728 9.686L14.314 8.272L5 17.586V19ZM21 21H3V16.757L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L9.243 19H21V21ZM15.728 6.858L17.142 8.272L18.556 6.858L17.142 5.444L15.728 6.858V6.858Z"
    ]
  },
  "edit-box": {
    paths: [
      "M16.757 3L14.757 5H5V19H19V9.243L21 7.243V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H16.757V3ZM20.485 2.1L21.9 3.516L12.708 12.708L11.296 12.711L11.294 11.294L20.485 2.1V2.1Z"
    ]
  },
  edit: {
    paths: [
      "M6.414 16L16.556 5.858L15.142 4.444L5 14.586V16H6.414ZM7.243 18H3V13.757L14.435 2.322C14.6225 2.13453 14.8768 2.02921 15.142 2.02921C15.4072 2.02921 15.6615 2.13453 15.849 2.322L18.678 5.151C18.8655 5.33853 18.9708 5.59284 18.9708 5.858C18.9708 6.12316 18.8655 6.37747 18.678 6.565L7.243 18V18ZM3 20H21V22H3V20Z"
    ]
  },
  "layout-top-2": {
    paths: [
      "M21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21ZM20 5H4V19H20V5ZM18 7V9H6V7H18Z"
    ]
  },
  "file-list-2": {
    paths: [
      "M20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H13V17H8V15Z"
    ]
  },
  clipboard: {
    paths: [
      "M7 4V2H17V4H20.007C20.555 4 21 4.445 21 4.993V21.007C20.9997 21.2703 20.895 21.5227 20.7089 21.7089C20.5227 21.895 20.2703 21.9997 20.007 22H3.993C3.72972 21.9997 3.4773 21.895 3.29114 21.7089C3.10497 21.5227 3.00026 21.2703 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"
    ]
  },
  "contacts-book-2": {
    paths: [
      "M20 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19V5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V18H6C5.73478 18 5.48043 18.1054 5.29289 18.2929C5.10536 18.4804 5 18.7348 5 19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20H19ZM5 16.17C5.313 16.06 5.65 16 6 16H19V4H6C5.73478 4 5.48043 4.10536 5.29289 4.29289C5.10536 4.48043 5 4.73478 5 5V16.17ZM12 10C11.4696 10 10.9609 9.78929 10.5858 9.41421C10.2107 9.03914 10 8.53043 10 8C10 7.46957 10.2107 6.96086 10.5858 6.58579C10.9609 6.21071 11.4696 6 12 6C12.5304 6 13.0391 6.21071 13.4142 6.58579C13.7893 6.96086 14 7.46957 14 8C14 8.53043 13.7893 9.03914 13.4142 9.41421C13.0391 9.78929 12.5304 10 12 10ZM9 14C9 13.2044 9.31607 12.4413 9.87868 11.8787C10.4413 11.3161 11.2044 11 12 11C12.7956 11 13.5587 11.3161 14.1213 11.8787C14.6839 12.4413 15 13.2044 15 14H9Z"
    ]
  },
  "file-3": {
    paths: [
      "M21 8V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3 2.455 3.449 2 4.002 2H14.997L21 8ZM19 9H14V4H5V20H19V9Z"
    ]
  },
  "file-lock": {
    paths: [
      "M15 4H5V20H19V8H15V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16L21 7V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992ZM15 11H16V16H8V11H9V10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10V11ZM13 11V10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9C11.7348 9 11.4804 9.10536 11.2929 9.29289C11.1054 9.48043 11 9.73478 11 10V11H13Z"
    ]
  },
  "file-copy": {
    paths: [
      "M17 6V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H7V21C7 21.552 7.45 22 8.007 22H19.993C20.1249 22.0008 20.2556 21.9755 20.3777 21.9256C20.4998 21.8757 20.6108 21.8022 20.7043 21.7093C20.7979 21.6164 20.8722 21.5059 20.9229 21.3841C20.9737 21.2624 20.9999 21.1319 21 21L20.997 7C20.997 6.448 20.547 6 19.99 6H17ZM18.997 8L19 20H9V8H18.997ZM15 6H7V16H5V4H15V6Z"
    ]
  },
  draft: {
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808V8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ]
  },
  "folder-3": {
    paths: [
      "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM4 7V19H20V7H4Z"
    ]
  },
  folder: {
    paths: [
      "M4 5V19H20V7H11.586L9.586 5H4ZM12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5Z"
    ]
  },
  "folder-4": {
    paths: [
      "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM8 19H20V11H8V19ZM6 19V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9H20V7H11.586L9.586 5H4V19H6Z"
    ]
  },
  "folder-copy-2": {
    paths: [
      "M17 6V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H7V21C7 21.552 7.45 22 8.007 22H19.993C20.1249 22.0008 20.2556 21.9755 20.3777 21.9256C20.4998 21.8757 20.6108 21.8022 20.7043 21.7093C20.7979 21.6164 20.8722 21.5059 20.9229 21.3841C20.9737 21.2624 20.9999 21.1319 21 21L20.997 7C20.997 6.448 20.547 6 19.991 6H17ZM18.998 8L19 20H9V8H18.998ZM15 6H7V16H5V4H15V6ZM17 11H11V13H17V11ZM17 15H11V17H17V15Z"
    ]
  },
  folders: {
    paths: [
      "M6 7V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H13.414L15.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V16C22 16.2652 21.8946 16.5196 21.7071 16.7071C21.5196 16.8946 21.2652 17 21 17H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V8C2 7.73478 2.10536 7.48043 2.29289 7.29289C2.48043 7.10536 2.73478 7 3 7H6ZM6 9H4V19H16V17H6V9ZM8 5V15H20V7H14.586L12.586 5H8Z"
    ]
  },
  task: {
    paths: [
      "M21 2.992V21.008C20.9979 21.2706 20.8926 21.5219 20.7068 21.7075C20.521 21.8931 20.2696 21.9982 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3.00209 2.72938 3.10742 2.47813 3.29322 2.29251C3.47902 2.1069 3.73038 2.00183 3.993 2H20.007C20.555 2 21 2.444 21 2.992V2.992ZM19 4H5V20H19V4ZM11.293 13.121L15.536 8.879L16.95 10.293L11.293 15.95L7.403 12.06L8.818 10.646L11.293 13.121V13.121Z"
    ]
  },
  "vip-crown": {
    paths: [
      "M2 19H22V21H2V19ZM2 5L7 8.5L12 2L17 8.5L22 5V17H2V5ZM4 8.841V15H20V8.841L16.58 11.235L12 5.28L7.42 11.235L4 8.84V8.841Z"
    ]
  },
  vip: {
    paths: [
      "M2 19H22V21H2V19ZM11 8H13V16H11V8ZM7.965 8H10.09L7.104 15.964H5.104L2.118 8H4.243L6.104 13.113L7.965 8ZM17 14V16H15V8H19C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11C22 11.7956 21.6839 12.5587 21.1213 13.1213C20.5587 13.6839 19.7956 14 19 14H17ZM17 10V12H19C19.2652 12 19.5196 11.8946 19.7071 11.7071C19.8946 11.5196 20 11.2652 20 11C20 10.7348 19.8946 10.4804 19.7071 10.2929C19.5196 10.1054 19.2652 10 19 10H17ZM2 3H22V5H2V3Z"
    ]
  },
  "vip-diamond": {
    paths: [
      "M4.87303 3H19.127C19.2848 2.99998 19.4404 3.0373 19.581 3.1089C19.7216 3.18051 19.8433 3.28437 19.936 3.412L23.759 8.668C23.827 8.76152 23.8605 8.8757 23.8537 8.99112C23.847 9.10653 23.8004 9.21603 23.722 9.301L12.367 21.602C12.2771 21.6992 12.1522 21.7568 12.0198 21.7621C11.8875 21.7673 11.7584 21.7198 11.661 21.63C11.654 21.624 7.86103 17.515 0.278033 9.301C0.199637 9.21603 0.153106 9.10653 0.14636 8.99112C0.139614 8.8757 0.17307 8.76152 0.241033 8.668L4.06403 3.412C4.15681 3.28437 4.27848 3.18051 4.41908 3.1089C4.55969 3.0373 4.71524 2.99998 4.87303 3ZM5.38303 5L2.58303 8.85L12 19.05L21.417 8.85L18.617 5H5.38303Z"
    ]
  },
  "money-dollar": {
    paths: [
      "M8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ]
  },
  "money-dollar-circle": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ]
  },
  "bank-card": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 11H4V19H20V11ZM20 9V5H4V9H20ZM14 15H18V17H14V15Z"
    ]
  },
  "gift-2": {
    paths: [
      "M14.5 2C15.0906 1.9998 15.6717 2.14908 16.1892 2.43393C16.7066 2.71879 17.1435 3.12995 17.4592 3.62914C17.7749 4.12832 17.9592 4.69929 17.9948 5.28886C18.0305 5.87843 17.9163 6.46743 17.663 7.001L21 7C21.2652 7 21.5196 7.10536 21.7071 7.2929C21.8946 7.48043 22 7.73479 22 8V12C22 12.2652 21.8946 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V13H3C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12V8C2 7.73479 2.10536 7.48043 2.29289 7.2929C2.48043 7.10536 2.73478 7 3 7L6.337 7.001C5.98076 6.25268 5.90163 5.40221 6.1137 4.601C6.32577 3.7998 6.81529 3.09985 7.4951 2.62576C8.17491 2.15167 9.0009 1.9342 9.82603 2.01207C10.6512 2.08994 11.4219 2.4581 12.001 3.051C12.326 2.71753 12.7147 2.45268 13.1439 2.27215C13.5732 2.09162 14.0343 1.99908 14.5 2V2ZM18 13H6V20H18V13ZM20 9H4V11H20V9ZM9.5 4C9.11478 4.00019 8.74441 4.14858 8.46561 4.41441C8.18682 4.68025 8.02099 5.04315 8.00248 5.42792C7.98396 5.81269 8.11419 6.18984 8.36618 6.48121C8.61816 6.77258 8.97258 6.95583 9.356 6.993L9.5 7H11V5.5C11 5.12712 10.8611 4.76761 10.6104 4.49158C10.3597 4.21556 10.0152 4.0428 9.644 4.007L9.5 4ZM14.5 4L14.356 4.007C14.0094 4.04021 13.6851 4.19298 13.4388 4.43911C13.1925 4.68525 13.0395 5.0094 13.006 5.356L13 5.5V7H14.5L14.644 6.993C15.015 6.95703 15.3594 6.7842 15.6099 6.50819C15.8605 6.23218 15.9993 5.87277 15.9993 5.5C15.9993 5.12724 15.8605 4.76783 15.6099 4.49182C15.3594 4.21581 15.015 4.04297 14.644 4.007L14.5 4Z"
    ]
  },
  "vip-crown-2": {
    paths: [
      "M3.49189 8.06499L4.77789 19H19.2219L20.5079 8.06499L16.4979 10.738L11.9999 4.44099L7.50189 10.738L3.49189 8.06499ZM2.80089 5.19999L6.99989 7.99999L11.1859 2.13999C11.2784 2.01036 11.4005 1.9047 11.5421 1.83179C11.6837 1.75889 11.8406 1.72086 11.9999 1.72086C12.1591 1.72086 12.3161 1.75889 12.4577 1.83179C12.5993 1.9047 12.7214 2.01036 12.8139 2.13999L16.9999 7.99999L21.1999 5.19999C21.3588 5.09424 21.5447 5.0362 21.7356 5.03273C21.9265 5.02926 22.1144 5.0805 22.2771 5.18041C22.4398 5.28032 22.5705 5.42471 22.6537 5.59653C22.737 5.76834 22.7693 5.96039 22.7469 6.14999L21.1039 20.117C21.0752 20.3602 20.9583 20.5845 20.7753 20.7473C20.5922 20.91 20.3558 21 20.1109 21H3.88889C3.64395 21 3.40755 20.91 3.22451 20.7473C3.04148 20.5845 2.92454 20.3602 2.89589 20.117L1.25289 6.14899C1.23069 5.95947 1.26317 5.76756 1.34651 5.59591C1.42984 5.42425 1.56055 5.28003 1.7232 5.18025C1.88584 5.08048 2.07364 5.02932 2.26442 5.03281C2.45521 5.03631 2.641 5.09432 2.79989 5.19999H2.80089ZM11.9999 15C11.4695 15 10.9607 14.7893 10.5857 14.4142C10.2106 14.0391 9.99989 13.5304 9.99989 13C9.99989 12.4696 10.2106 11.9609 10.5857 11.5858C10.9607 11.2107 11.4695 11 11.9999 11C12.5303 11 13.039 11.2107 13.4141 11.5858C13.7892 11.9609 13.9999 12.4696 13.9999 13C13.9999 13.5304 13.7892 14.0391 13.4141 14.4142C13.039 14.7893 12.5303 15 11.9999 15Z"
    ]
  },
  "bank-card-2": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 12H4V19H20V12ZM20 8V5H4V8H20Z"
    ]
  },
  "money-dollar-box": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM4 5V19H20V5H4ZM8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ]
  },
  gift: {
    paths: [
      "M15 2.00001C15.7023 1.99992 16.3922 2.18474 17.0004 2.53587C17.6086 2.887 18.1137 3.39207 18.4647 4.0003C18.8158 4.60853 19.0006 5.29847 19.0005 6.00075C19.0003 6.70304 18.8153 7.39291 18.464 8.00101L23 8.00001V10H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V10H1V8.00001L5.536 8.00101C5.03986 7.14189 4.88069 6.12906 5.08938 5.15918C5.29808 4.1893 5.85975 3.33157 6.66533 2.75256C7.47092 2.17354 8.46293 1.91456 9.44875 2.02588C10.4346 2.13721 11.3438 2.61091 12 3.35501C12.3746 2.92839 12.8361 2.58678 13.3535 2.35308C13.8709 2.11939 14.4323 1.99901 15 2.00001V2.00001ZM11 10H5V19H11V10ZM19 10H13V19H19V10ZM9 4.00001C8.48102 3.99768 7.98145 4.19719 7.60685 4.55639C7.23224 4.91558 7.01193 5.40632 6.99246 5.92495C6.97299 6.44357 7.15588 6.94945 7.50249 7.33572C7.84911 7.722 8.3323 7.9584 8.85 7.99501L9 8.00001H11V6.00001C11 5.52207 10.8289 5.05992 10.5176 4.69726C10.2063 4.33461 9.77542 4.09541 9.303 4.02301L9.149 4.00501L9 4.00001ZM15 4.00001C14.4954 3.99985 14.0094 4.19041 13.6395 4.5335C13.2695 4.87659 13.0428 5.34685 13.005 5.85001L13 6.00001V8.00001H15C15.5046 8.00017 15.9906 7.8096 16.3605 7.46651C16.7305 7.12342 16.9572 6.65316 16.995 6.15001L17 6.00001C17 5.46957 16.7893 4.96087 16.4142 4.58579C16.0391 4.21072 15.5304 4.00001 15 4.00001V4.00001Z"
    ]
  },
  "attachment-2": {
    paths: [
      "M14.8283 7.75701L9.17229 13.414C9.07678 13.5063 9.00059 13.6166 8.94819 13.7386C8.89578 13.8606 8.86819 13.9918 8.86704 14.1246C8.86588 14.2574 8.89118 14.3891 8.94147 14.512C8.99175 14.6349 9.066 14.7465 9.15989 14.8404C9.25378 14.9343 9.36544 15.0086 9.48833 15.0588C9.61123 15.1091 9.74291 15.1344 9.87569 15.1333C10.0085 15.1321 10.1397 15.1045 10.2617 15.0521C10.3837 14.9997 10.494 14.9235 10.5863 14.828L16.2433 9.17201C16.8059 8.60935 17.122 7.84623 17.122 7.05051C17.122 6.25479 16.8059 5.49167 16.2433 4.92901C15.6806 4.36635 14.9175 4.05026 14.1218 4.05026C13.3261 4.05026 12.5629 4.36635 12.0003 4.92901L6.34329 10.586C5.86936 11.0481 5.49192 11.5998 5.23284 12.2089C4.97377 12.818 4.83823 13.4726 4.83408 14.1345C4.82994 14.7964 4.95727 15.4526 5.20868 16.0649C5.4601 16.6773 5.83061 17.2336 6.2987 17.7016C6.7668 18.1696 7.32317 18.5401 7.93554 18.7914C8.54791 19.0427 9.20409 19.17 9.86602 19.1657C10.5279 19.1615 11.1824 19.0258 11.7915 18.7667C12.4006 18.5075 12.9522 18.13 13.4143 17.656L19.0713 12L20.4853 13.414L14.8283 19.071C14.1782 19.7211 13.4065 20.2367 12.5572 20.5885C11.7079 20.9403 10.7976 21.1214 9.87829 21.1214C8.95899 21.1214 8.04869 20.9403 7.19937 20.5885C6.35004 20.2367 5.57833 19.7211 4.92829 19.071C4.27824 18.421 3.7626 17.6493 3.4108 16.7999C3.059 15.9506 2.87793 15.0403 2.87793 14.121C2.87793 13.2017 3.059 12.2914 3.4108 11.4421C3.7626 10.5928 4.27824 9.82105 4.92829 9.17101L10.5863 3.51501C11.5293 2.60422 12.7923 2.10025 14.1033 2.11164C15.4143 2.12303 16.6683 2.64888 17.5954 3.57592C18.5224 4.50296 19.0483 5.75702 19.0597 7.068C19.071 8.37899 18.5671 9.642 17.6563 10.585L12.0003 16.244C11.7216 16.5226 11.3908 16.7436 11.0267 16.8943C10.6627 17.0451 10.2725 17.1227 9.87843 17.1226C9.48439 17.1226 9.09421 17.0449 8.73018 16.8941C8.36615 16.7432 8.03539 16.5222 7.75679 16.2435C7.47819 15.9648 7.2572 15.634 7.10645 15.27C6.9557 14.9059 6.87813 14.5157 6.87818 14.1217C6.87823 13.7276 6.95588 13.3374 7.10672 12.9734C7.25756 12.6094 7.47862 12.2786 7.75729 12L13.4143 6.34301L14.8283 7.75701Z"
    ]
  },
  asterisk: {
    paths: [
      "M13.0001 3V10.267L19.2941 6.634L20.2941 8.366L14.0011 11.999L20.2941 15.634L19.2941 17.366L13.0001 13.732V21H11.0001V13.732L4.70605 17.366L3.70605 15.634L9.99905 12L3.70605 8.366L4.70605 6.634L11.0001 10.267V3H13.0001Z"
    ]
  },
  autofill: {
    paths: [
      "M17 2V4H20.0068C20.5548 4 21 4.44516 21 4.99316V8H19V6H17V8H7V6H5V20H19V18H21V21.0068C20.9997 21.2701 20.8952 21.5228 20.709 21.709C20.5228 21.8952 20.2701 21.9997 20.0068 22H3.99316C3.72989 21.9997 3.47718 21.8952 3.29102 21.709C3.10485 21.5228 3.00026 21.2701 3 21.0068V4.99316C3 4.44516 3.44516 4 3.99316 4H7V2H17ZM9 4V6H15V4H9Z",
      "M17.4043 9.11073C17.7948 8.72042 18.4279 8.72033 18.8184 9.11073L22.707 12.9994L18.8184 16.889C18.428 17.2794 17.7948 17.2792 17.4043 16.889C17.0138 16.4985 17.0138 15.8655 17.4043 15.475L18.8789 13.9994H14.5C13.9477 13.9994 13.5 13.5517 13.5 12.9994C13.5002 12.4473 13.9478 11.9994 14.5 11.9994H18.8789L17.4043 10.5248C17.0138 10.1343 17.0138 9.50121 17.4043 9.11073Z"
    ],
    viewBox: "0 0 24 24"
  },
  phone: {
    paths: [
      "M9.366 10.682C10.3043 12.3305 11.6695 13.6957 13.318 14.634L14.202 13.396C14.3442 13.1969 14.5544 13.0569 14.7928 13.0023C15.0313 12.9478 15.2814 12.9825 15.496 13.1C16.9103 13.8729 18.4722 14.3378 20.079 14.464C20.3298 14.4839 20.5638 14.5975 20.7345 14.7823C20.9052 14.9671 21 15.2094 21 15.461V19.923C21.0001 20.1706 20.9083 20.4094 20.7424 20.5932C20.5765 20.777 20.3483 20.8927 20.102 20.918C19.572 20.973 19.038 21 18.5 21C9.94 21 3 14.06 3 5.5C3 4.962 3.027 4.428 3.082 3.898C3.10725 3.6517 3.22298 3.42352 3.40679 3.25763C3.5906 3.09175 3.82941 2.99995 4.077 3H8.539C8.79056 2.99997 9.0329 3.09475 9.21768 3.26545C9.40247 3.43615 9.51613 3.67022 9.536 3.921C9.66222 5.52779 10.1271 7.08968 10.9 8.504C11.0175 8.71856 11.0522 8.96874 10.9977 9.2072C10.9431 9.44565 10.8031 9.65584 10.604 9.798L9.366 10.682V10.682ZM6.844 10.025L8.744 8.668C8.20478 7.50409 7.83535 6.26884 7.647 5H5.01C5.004 5.166 5.001 5.333 5.001 5.5C5 12.956 11.044 19 18.5 19C18.667 19 18.834 18.997 19 18.99V16.353C17.7312 16.1646 16.4959 15.7952 15.332 15.256L13.975 17.156C13.4287 16.9437 12.898 16.6931 12.387 16.406L12.329 16.373C10.3676 15.2567 8.74328 13.6324 7.627 11.671L7.594 11.613C7.30691 11.102 7.05628 10.5713 6.844 10.025V10.025Z"
    ]
  },
  computer: {
    paths: [
      "M4.00004 16H20V5H4.00004V16ZM13 18V20H17V22H7.00004V20H11V18H2.99204C2.86073 17.9992 2.73086 17.9725 2.60988 17.9215C2.4889 17.8704 2.37919 17.7959 2.28703 17.7024C2.19488 17.6088 2.12209 17.498 2.07284 17.3763C2.02359 17.2546 1.99885 17.1243 2.00004 16.993V4.007C2.00004 3.451 2.45504 3 2.99204 3H21.008C21.556 3 22 3.449 22 4.007V16.993C22 17.549 21.545 18 21.008 18H13V18Z"
    ]
  },
  smartphone: {
    paths: [
      "M7 4V20H17V4H7ZM6 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H6C5.73478 22 5.48043 21.8946 5.29289 21.7071C5.10536 21.5196 5 21.2652 5 21V3C5 2.73478 5.10536 2.48043 5.29289 2.29289C5.48043 2.10536 5.73478 2 6 2ZM12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18C13 18.2652 12.8946 18.5196 12.7071 18.7071C12.5196 18.8946 12.2652 19 12 19C11.7348 19 11.4804 18.8946 11.2929 18.7071C11.1054 18.5196 11 18.2652 11 18C11 17.7348 11.1054 17.4804 11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17V17Z"
    ]
  },
  macbook: {
    paths: [
      "M4 5V16H20V5H4ZM2 4.007C2 3.451 2.455 3 2.992 3H21.008C21.556 3 22 3.449 22 4.007V18H2V4.007ZM1 19H23V21H1V19Z"
    ]
  },
  "chat-new": {
    paths: [
      "M14 3V5H4V18.385L5.763 17H20V10H22V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H14ZM19 3V0H21V3H24V5H21V8H19V5H16V3H19Z"
    ]
  },
  "chat-4": {
    paths: [
      "M5.763 17H20V5H4V18.385L5.763 17ZM6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455Z"
    ]
  },
  "question-answer": {
    paths: [
      "M5.455 15L1 18.5V3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V15H5.455ZM4.763 13H16V4H3V14.385L4.763 13ZM8 17H18.237L20 18.385V8H21C21.2652 8 21.5196 8.10536 21.7071 8.29289C21.8946 8.48043 22 8.73478 22 9V22.5L17.545 19H9C8.73478 19 8.48043 18.8946 8.29289 18.7071C8.10536 18.5196 8 18.2652 8 18V17Z"
    ]
  },
  "chat-3": {
    paths: [
      "M7.29101 20.824L2.00001 22L3.17601 16.709C2.40154 15.2604 1.99754 13.6426 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.3574 22.0025 8.73963 21.5985 7.29101 20.824V20.824ZM7.58101 18.711L8.23401 19.061C9.39256 19.6801 10.6864 20.0027 12 20C13.5823 20 15.129 19.5308 16.4446 18.6518C17.7602 17.7727 18.7855 16.5233 19.391 15.0615C19.9965 13.5997 20.155 11.9911 19.8463 10.4393C19.5376 8.88743 18.7757 7.46197 17.6569 6.34315C16.538 5.22433 15.1126 4.4624 13.5607 4.15372C12.0089 3.84504 10.4004 4.00346 8.93854 4.60896C7.47674 5.21447 6.22731 6.23984 5.34825 7.55544C4.4692 8.87103 4.00001 10.4177 4.00001 12C4.00001 13.334 4.32501 14.618 4.94001 15.766L5.28901 16.419L4.63401 19.366L7.58101 18.711V18.711Z"
    ]
  },
  "chat-2": {
    paths: [
      "M14.45 19L12 22.5L9.55 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H14.45ZM13.409 17H20V5H4V17H10.591L12 19.012L13.409 17V17Z"
    ]
  },
  "chat-check": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM5.763 17H20V5H4V18.385L5.763 17ZM11.293 12.121L15.536 7.879L16.95 9.293L11.293 14.95L7.403 11.06L8.818 9.646L11.293 12.121V12.121Z"
    ]
  },
  "message-2": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM5.763 17H20V5H4V18.385L5.763 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"
    ]
  },
  feedback: {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z"
    ]
  },
  "chat-heart": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM12.018 14.7L8.659 11.34C8.23704 10.918 7.99999 10.3457 7.99999 9.749C7.99999 9.45352 8.05818 9.16094 8.17126 8.88796C8.28433 8.61497 8.45007 8.36693 8.659 8.158C8.86793 7.94907 9.11597 7.78333 9.38896 7.67026C9.66194 7.55718 9.95452 7.49899 10.25 7.49899C10.8467 7.49899 11.419 7.73604 11.841 8.158L12.018 8.335L12.195 8.158C12.4039 7.94907 12.652 7.78333 12.925 7.67026C13.1979 7.55718 13.4905 7.49899 13.786 7.49899C14.0815 7.49899 14.3741 7.55718 14.647 7.67026C14.92 7.78333 15.1681 7.94907 15.377 8.158C15.5859 8.36693 15.7517 8.61497 15.8647 8.88796C15.9778 9.16094 16.036 9.45352 16.036 9.749C16.036 10.0445 15.9778 10.3371 15.8647 10.61C15.7517 10.883 15.5859 11.1311 15.377 11.34L12.017 14.699L12.018 14.7Z"
    ]
  },
  "chat-delete": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM13.414 11L15.889 13.475L14.475 14.889L12 12.414L9.525 14.89L8.111 13.476L10.586 11L8.11 8.525L9.524 7.111L12 9.586L14.475 7.111L15.889 8.525L13.414 11Z"
    ]
  },
  "chat-quote": {
    paths: [
      "M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM20 5H4V18.385L5.763 17H20V5ZM10.515 7.412L10.962 8.1C9.294 9.003 9.323 10.452 9.323 10.764C9.478 10.744 9.641 10.74 9.803 10.755C10.705 10.839 11.416 11.58 11.416 12.5C11.416 13.466 10.632 14.25 9.666 14.25C9.129 14.25 8.616 14.005 8.292 13.66C7.777 13.114 7.5 12.5 7.5 11.505C7.5 9.755 8.728 8.187 10.515 7.412V7.412ZM15.515 7.412L15.962 8.1C14.294 9.003 14.323 10.452 14.323 10.764C14.478 10.744 14.641 10.74 14.803 10.755C15.705 10.839 16.416 11.58 16.416 12.5C16.416 13.466 15.632 14.25 14.666 14.25C14.129 14.25 13.616 14.005 13.292 13.66C12.777 13.114 12.5 12.5 12.5 11.505C12.5 9.755 13.728 8.187 15.515 7.412V7.412Z"
    ]
  },
  numbers: {
    paths: [
      "M9 18H4V10H9V18ZM7 16V12H6V16H7ZM13 16V8H12V16H13ZM15 18H10V6H15V18ZM19 16V4H18V16H19ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
    ]
  },
  "line-chart": {
    paths: [
      "M5 3V19H21V21H3V3H5ZM20.293 6.293L21.707 7.707L16 13.414L13 10.415L8.707 14.707L7.293 13.293L13 7.586L16 10.585L20.293 6.293V6.293Z"
    ]
  },
  cloud: {
    paths: [
      "M16.9999 21H6.99987C5.5831 21.0009 4.21172 20.5004 3.12856 19.5872C2.0454 18.6739 1.32035 17.4069 1.08178 16.0103C0.843215 14.6138 1.10653 13.1779 1.82511 11.9568C2.54368 10.7358 3.67115 9.80847 5.00787 9.33899C4.96259 8.39265 5.10989 7.44697 5.44083 6.55923C5.77178 5.67149 6.2795 4.86017 6.93322 4.17441C7.58694 3.48866 8.37307 2.94275 9.24398 2.56975C10.1149 2.19675 11.0525 2.00443 11.9999 2.00443C12.9473 2.00443 13.8849 2.19675 14.7558 2.56975C15.6267 2.94275 16.4128 3.48866 17.0665 4.17441C17.7203 4.86017 18.228 5.67149 18.5589 6.55923C18.8899 7.44697 19.0372 8.39265 18.9919 9.33899C20.3286 9.80847 21.4561 10.7358 22.1746 11.9568C22.8932 13.1779 23.1565 14.6138 22.918 16.0103C22.6794 17.4069 21.9543 18.6739 20.8712 19.5872C19.788 20.5004 18.4166 21.0009 16.9999 21ZM16.9999 8.99999C17.0001 8.333 16.8669 7.67269 16.6081 7.05796C16.3493 6.44323 15.9701 5.88649 15.4928 5.42053C15.0156 4.95457 14.4499 4.58881 13.8292 4.34478C13.2084 4.10075 12.5451 3.98339 11.8783 3.9996C11.2115 4.01582 10.5547 4.16528 9.94657 4.43919C9.33841 4.7131 8.7912 5.10592 8.33716 5.59452C7.88312 6.08312 7.53143 6.65763 7.3028 7.28421C7.07417 7.9108 6.97321 8.5768 7.00587 9.24299L7.07587 10.731L5.67187 11.225C4.78238 11.5396 4.03263 12.1583 3.55497 12.9719C3.07732 13.7856 2.90249 14.7418 3.06133 15.6718C3.22018 16.6018 3.7025 17.4458 4.42314 18.0548C5.14378 18.6637 6.0564 18.9985 6.99987 19H16.9999C17.7362 18.9998 18.4582 18.7963 19.0863 18.4119C19.7144 18.0276 20.2242 17.4774 20.5596 16.8219C20.895 16.1663 21.0429 15.431 20.9871 14.6967C20.9312 13.9625 20.6738 13.258 20.2432 12.6607C19.8126 12.0634 19.2254 11.5966 18.5464 11.3116C17.8675 11.0267 17.123 10.9347 16.3951 11.0458C15.6672 11.1569 14.9841 11.4667 14.421 11.9412C13.8579 12.4157 13.4367 13.0364 13.2039 13.735L11.3059 13.102C11.7047 11.9074 12.4692 10.8685 13.491 10.1323C14.5129 9.39613 15.7404 9 16.9999 8.99999Z"
    ]
  },
  "bar-chart-2": {
    paths: [
      "M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"
    ]
  },
  "chart-mixed": {
    paths: [
      "M564 153C577.8 142 580 121.8 569 108C558 94.2 537.8 92 524 103L383.4 215.5L275.2 134.4C263.5 125.6 247.4 125.9 236 135L76 263C62.2 274 60 294.2 71 308C82 321.8 102.2 324 116 313L256.6 200.5L364.8 281.6C376.5 290.4 392.6 290.1 404 281L564 153zM224 320L224 512C224 529.7 238.3 544 256 544C273.7 544 288 529.7 288 512L288 320C288 302.3 273.7 288 256 288C238.3 288 224 302.3 224 320zM96 416L96 512C96 529.7 110.3 544 128 544C145.7 544 160 529.7 160 512L160 416C160 398.3 145.7 384 128 384C110.3 384 96 398.3 96 416zM384 352C366.3 352 352 366.3 352 384L352 512C352 529.7 366.3 544 384 544C401.7 544 416 529.7 416 512L416 384C416 366.3 401.7 352 384 352zM480 320L480 512C480 529.7 494.3 544 512 544C529.7 544 544 529.7 544 512L544 320C544 302.3 529.7 288 512 288C494.3 288 480 302.3 480 320z"
    ],
    viewBox: "0 0 640 640"
  },
  "mail-close": {
    paths: [
      "M22 14H20V7.238L12.072 14.338L4 7.216V19H15V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V14ZM4.511 5L12.061 11.662L19.502 5H4.511ZM21.414 19L23.536 21.121L22.121 22.536L20 20.414L17.879 22.536L16.464 21.121L18.586 19L16.464 16.879L17.879 15.464L20 17.586L22.121 15.464L23.536 16.879L21.414 19V19Z"
    ]
  },
  "record-mail": {
    paths: [
      "M14.2566 15C13.4613 14.0359 13.018 12.8296 12.9999 11.5798C12.9817 10.3301 13.3898 9.11142 14.1569 8.12461C14.9239 7.13779 16.0042 6.44166 17.2198 6.1509C18.4354 5.86014 19.7138 5.99208 20.8443 6.52499C21.9749 7.0579 22.8903 7.96 23.4396 9.08269C23.9889 10.2054 24.1395 11.4817 23.8665 12.7014C23.5935 13.9211 22.9132 15.0114 21.9376 15.7928C20.9621 16.5741 19.7495 16.9999 18.4996 17H5.49965C4.24977 16.9999 3.0372 16.5741 2.06166 15.7928C1.08613 15.0114 0.40583 13.9211 0.132818 12.7014C-0.140194 11.4817 0.0103691 10.2054 0.559706 9.08269C1.10904 7.96 2.02439 7.0579 3.15496 6.52499C4.28553 5.99208 5.5639 5.86014 6.77949 6.1509C7.99507 6.44166 9.07537 7.13779 9.84243 8.12461C10.6095 9.11142 11.0176 10.3301 10.9994 11.5798C10.9813 12.8296 10.538 14.0359 9.74265 15H14.2566V15ZM5.49965 15C6.4279 15 7.31814 14.6313 7.97452 13.9749C8.6309 13.3185 8.99965 12.4283 8.99965 11.5C8.99965 10.5717 8.6309 9.68151 7.97452 9.02513C7.31814 8.36875 6.4279 8 5.49965 8C4.57139 8 3.68115 8.36875 3.02477 9.02513C2.3684 9.68151 1.99965 10.5717 1.99965 11.5C1.99965 12.4283 2.3684 13.3185 3.02477 13.9749C3.68115 14.6313 4.57139 15 5.49965 15V15ZM18.4996 15C19.4279 15 20.3181 14.6313 20.9745 13.9749C21.6309 13.3185 21.9996 12.4283 21.9996 11.5C21.9996 10.5717 21.6309 9.68151 20.9745 9.02513C20.3181 8.36875 19.4279 8 18.4996 8C17.5714 8 16.6811 8.36875 16.0248 9.02513C15.3684 9.68151 14.9996 10.5717 14.9996 11.5C14.9996 12.4283 15.3684 13.3185 16.0248 13.9749C16.6811 14.6313 17.5714 15 18.4996 15V15Z"
    ]
  },
  refresh: {
    paths: [
      "M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C13.15 4 14.25 4.2375 15.3 4.7125C16.35 5.1875 17.25 5.86667 18 6.75V4H20V11H13V9H17.2C16.6667 8.06667 15.9375 7.33333 15.0125 6.8C14.0875 6.26667 13.0833 6 12 6C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18C13.2833 18 14.4417 17.6333 15.475 16.9C16.5083 16.1667 17.2333 15.2 17.65 14H19.75C19.2833 15.7667 18.3333 17.2083 16.9 18.325C15.4667 19.4417 13.8333 20 12 20Z"
    ]
  },
  mail: {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z"
    ]
  },
  "calendar-2": {
    paths: [
      "M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM20 11H4V19H20V11ZM15 5H9V7H7V5H4V9H20V5H17V7H15V5ZM6 13H8V15H6V13ZM11 13H13V15H11V13ZM16 13H18V15H16V13Z"
    ]
  },
  "flag-2": {
    paths: [
      "M4 17V22H2V3H21.138C21.2256 2.99985 21.3118 3.02275 21.3878 3.06639C21.4638 3.11002 21.527 3.17288 21.5711 3.24864C21.6151 3.3244 21.6385 3.41042 21.6388 3.49806C21.6392 3.5857 21.6165 3.6719 21.573 3.748L18 10L21.573 16.252C21.6165 16.3281 21.6392 16.4143 21.6388 16.5019C21.6385 16.5896 21.6151 16.6756 21.5711 16.7514C21.527 16.8271 21.4638 16.89 21.3878 16.9336C21.3118 16.9773 21.2256 17.0001 21.138 17H4ZM4 5V15H18.554L15.696 10L18.554 5H4Z"
    ]
  },
  "send-plane": {
    paths: [
      "M1.92302 9.37001C1.41302 9.16501 1.41902 8.86001 1.95702 8.68101L21.043 2.31901C21.572 2.14301 21.875 2.43901 21.727 2.95701L16.273 22.043C16.123 22.572 15.798 22.596 15.556 22.113L11 13L1.92302 9.37001ZM6.81302 9.17001L12.449 11.425L15.489 17.507L19.035 5.09701L6.81202 9.17001H6.81302Z"
    ]
  },
  "send-plane-2": {
    paths: [
      "M3.741 1.40801L22.203 11.562C22.2814 11.6052 22.3468 11.6686 22.3923 11.7456C22.4378 11.8227 22.4618 11.9105 22.4618 12C22.4618 12.0895 22.4378 12.1774 22.3923 12.2544C22.3468 12.3314 22.2814 12.3949 22.203 12.438L3.741 22.592C3.66487 22.6339 3.57915 22.6552 3.49227 22.6539C3.4054 22.6525 3.32037 22.6286 3.24558 22.5844C3.17078 22.5401 3.1088 22.4772 3.06573 22.4017C3.02267 22.3263 3.00001 22.2409 3 22.154V1.84601C3.00001 1.75913 3.02267 1.67375 3.06573 1.59828C3.1088 1.52282 3.17078 1.45988 3.24558 1.41567C3.32037 1.37146 3.4054 1.3475 3.49227 1.34616C3.57915 1.34482 3.66487 1.36614 3.741 1.40801V1.40801ZM5 13V19.617L18.85 12L5 4.38301V11H10V13H5Z"
    ]
  },
  "mail-add": {
    paths: [
      "M22 13H20V7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V13ZM4.511 5L12.061 11.662L19.502 5H4.511ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
    ]
  },
  bookmark: {
    paths: [
      "M5 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V22.143C20.0001 22.2324 19.9763 22.3202 19.9309 22.3973C19.8855 22.4743 19.8204 22.5378 19.7421 22.5811C19.6639 22.6244 19.5755 22.6459 19.4861 22.6434C19.3968 22.641 19.3097 22.6146 19.234 22.567L12 18.03L4.766 22.566C4.69037 22.6135 4.60339 22.6399 4.5141 22.6424C4.42482 22.6449 4.33649 22.6235 4.2583 22.5803C4.1801 22.5371 4.11491 22.4738 4.06948 22.3969C4.02406 22.32 4.00007 22.2323 4 22.143V3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2ZM18 4H6V19.432L12 15.671L18 19.432V4Z"
    ]
  },
  "calendar-check": {
    paths: [
      "M9 1V3H15V1H17V3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9ZM20 10H4V19H20V10ZM15.036 11.136L16.45 12.55L11.5 17.5L7.964 13.964L9.38 12.55L11.501 14.672L15.037 11.136H15.036ZM7 5H4V8H20V5H17V6H15V5H9V6H7V5Z"
    ]
  },
  "mail-check": {
    paths: [
      "M22 14H20V7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V14ZM4.511 5L12.061 11.662L19.502 5H4.511ZM19 22L15.464 18.464L16.879 17.05L19 19.172L22.536 15.636L23.95 17.05L19 22Z"
    ]
  },
  "mail-send": {
    paths: [
      "M22 20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V19H20V7.3L12 14.5L2 5.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20.007ZM4.434 5L12 11.81L19.566 5H4.434ZM0 15H8V17H0V15ZM0 10H5V12H0V10Z"
    ]
  },
  "building-4": {
    paths: [
      "M21 20H23V22H1V20H3V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z"
    ]
  },
  "home-2": {
    paths: [
      "M19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21ZM6 19H18V9.15701L12 3.70301L6 9.15701V19Z"
    ]
  },
  "home-2-filled": {
    paths: [
      "M19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21Z"
    ]
  },
  "home+building": {
    paths: [
      "M21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12.487C1.99998 12.3441 2.03059 12.2029 2.08976 12.0728C2.14892 11.9428 2.23528 11.8269 2.343 11.733L6 8.544V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21ZM9 19H12V12.942L8 9.454L4 12.942V19H7V15H9V19ZM14 19H20V5H8V7.127C8.234 7.127 8.469 7.209 8.657 7.374L13.657 11.733C13.7647 11.8269 13.8511 11.9428 13.9102 12.0728C13.9694 12.2029 14 12.3441 14 12.487V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
    ]
  },
  "home-heart": {
    paths: [
      "M20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20ZM18 19V9.15701L12 3.70301L6 9.15701V19H18ZM12 17L8.641 13.641C8.43207 13.4321 8.26633 13.184 8.15326 12.9111C8.04018 12.6381 7.98199 12.3455 7.98199 12.05C7.98199 11.7545 8.04018 11.462 8.15326 11.189C8.26633 10.916 8.43207 10.6679 8.641 10.459C8.84993 10.2501 9.09797 10.0843 9.37096 9.97127C9.64394 9.8582 9.93652 9.8 10.232 9.8C10.5275 9.8 10.8201 9.8582 11.093 9.97127C11.366 10.0843 11.6141 10.2501 11.823 10.459L12 10.636L12.177 10.459C12.3859 10.2501 12.634 10.0843 12.907 9.97127C13.1799 9.8582 13.4725 9.8 13.768 9.8C14.0635 9.8 14.3561 9.8582 14.629 9.97127C14.902 10.0843 15.1501 10.2501 15.359 10.459C15.5679 10.6679 15.7337 10.916 15.8467 11.189C15.9598 11.462 16.018 11.7545 16.018 12.05C16.018 12.3455 15.9598 12.6381 15.8467 12.9111C15.7337 13.184 15.5679 13.4321 15.359 13.641L12 17Z"
    ]
  },
  "home-heart-filled": {
    paths: [
      "M20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20ZM12 17L8.641 13.641C8.43207 13.4321 8.26633 13.184 8.15326 12.9111C8.04018 12.6381 7.98199 12.3455 7.98199 12.05C7.98199 11.7545 8.04018 11.462 8.15326 11.189C8.26633 10.916 8.43207 10.6679 8.641 10.459C8.84993 10.2501 9.09797 10.0843 9.37096 9.97127C9.64394 9.8582 9.93652 9.8 10.232 9.8C10.5275 9.8 10.8201 9.8582 11.093 9.97127C11.366 10.0843 11.6141 10.2501 11.823 10.459L12 10.636L12.177 10.459C12.3859 10.2501 12.634 10.0843 12.907 9.97127C13.1799 9.8582 13.4725 9.8 13.768 9.8C14.0635 9.8 14.3561 9.8582 14.629 9.97127C14.902 10.0843 15.1501 10.2501 15.359 10.459C15.5679 10.6679 15.7337 10.916 15.8467 11.189C15.9598 11.462 16.018 11.7545 16.018 12.05C16.018 12.3455 15.9598 12.6381 15.8467 12.9111C15.7337 13.184 15.5679 13.4321 15.359 13.641L12 17Z"
    ]
  },
  "arrow-out": {
    paths: [
      "M14.6667 4L16.7111 6.04444L14.1422 8.59556L15.4044 9.85778L17.9556 7.28889L20 9.33333V4L14.6667 4ZM4 9.33333L6.04444 7.28889L8.59556 9.85778L9.85778 8.59556L7.28889 6.04444L9.33333 4L4 4L4 9.33333ZM9.33333 20L7.28889 17.9556L9.85778 15.4044L8.59556 14.1422L6.04444 16.7111L4 14.6667L4 20H9.33333ZM20 14.6667L17.9556 16.7111L15.4044 14.1422L14.1422 15.4044L16.7111 17.9556L14.6667 20L20 20L20 14.6667Z"
    ]
  },
  "touch-point": {
    paths: [
      "M15.8464 13.1714L13.5982 12.0143C14.4933 11.3 15.0693 10.1857 15.0693 8.92857C15.0693 6.76429 13.3553 5 11.2528 5C9.15031 5 7.43637 6.76429 7.43637 8.92857C7.43637 10.45 8.28293 11.7714 9.51808 12.4214V14.75C8.02619 14.4214 8.1164 14.4357 7.94986 14.4357C7.58209 14.4357 7.23514 14.5857 6.97146 14.8571L6 15.8714L9.53195 19.5071C9.83033 19.8214 10.2467 20 10.6769 20H15.0485C15.7285 20 16.3044 19.5 16.4154 18.8071L16.9706 15.4429C17.1232 14.5143 16.6722 13.6 15.8464 13.1714ZM15.6036 15.2071L15.0485 18.5714H10.6769C10.6144 18.5714 10.5589 18.5429 10.5104 18.5L7.9568 15.8714L10.9059 16.5071V8.92857C10.9059 8.72857 11.0585 8.57143 11.2528 8.57143C11.4471 8.57143 11.5998 8.72857 11.5998 8.92857V13.2143H12.821L15.2219 14.45C15.4995 14.5929 15.6522 14.9 15.6036 15.2071ZM8.82417 8.92857C8.82417 7.55 9.9136 6.42857 11.2528 6.42857C12.5921 6.42857 13.6815 7.55 13.6815 8.92857C13.6815 9.60714 13.4178 10.2214 12.9876 10.6714V8.92857C12.9876 7.94286 12.2104 7.14286 11.2528 7.14286C10.2952 7.14286 9.51808 7.94286 9.51808 8.92857V10.6714C9.08786 10.2214 8.82417 9.60714 8.82417 8.92857Z"
    ]
  },
  tag: {
    paths: [
      "M8.6 8.8C9.26274 8.8 9.8 8.26274 9.8 7.6C9.8 6.93726 9.26274 6.4 8.6 6.4C7.93726 6.4 7.4 6.93726 7.4 7.6C7.4 8.26274 7.93726 8.8 8.6 8.8Z",
      "M20.528 11.664L13.328 4.464C13.04 4.176 12.64 4 12.2 4H6.6C5.72 4 5 4.72 5 5.6V11.2C5 11.64 5.176 12.04 5.472 12.336L12.672 19.536C12.96 19.824 13.36 20 13.8 20C14.24 20 14.64 19.824 14.928 19.528L20.528 13.928C20.824 13.64 21 13.24 21 12.8C21 12.36 20.816 11.952 20.528 11.664ZM13.8 18.408L6.6 11.2V5.6H12.2V5.592L19.4 12.792L13.8 18.408V18.408Z"
    ]
  },
  angle: {
    paths: [
      "M14.6,17.8c0.4,0.4,0.4,1,0,1.4l0,0c-0.4,0.4-1,0.4-1.4,0l-7.1-7.1L13.2,5c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L9,12",
      "M12.8,18l-1.4-1.4c2.6-2.6,2.6-6.7,0-9.3L12.8,6C16.1,9.3,16.1,14.7,12.8,18z"
    ]
  },
  percent: {
    paths: [
      "M19 3.58587L3.58594 18.9999L5.00014 20.4141L20.4142 5.00006L19 3.58587Z",
      "M7 11C9.209 11 11 9.209 11 7C11 4.791 9.209 3 7 3C4.791 3 3 4.791 3 7C3 9.209 4.791 11 7 11ZM7 5C8.103 5 9 5.897 9 7C9 8.103 8.103 9 7 9C5.897 9 5 8.103 5 7C5 5.897 5.897 5 7 5Z",
      "M17 21C19.209 21 21 19.209 21 17C21 14.791 19.209 13 17 13C14.791 13 13 14.791 13 17C13 19.209 14.791 21 17 21ZM17 15C18.103 15 19 15.897 19 17C19 18.103 18.103 19 17 19C15.897 19 15 18.103 15 17C15 15.897 15.897 15 17 15Z"
    ]
  },
  bolt: {
    paths: [
      "M10.0568 1.36475L3.20312 9.83535H7.204L6.21909 15.25C6.21722 15.2606 6.2177 15.2715 6.2205 15.2819C6.22329 15.2923 6.22834 15.302 6.23529 15.3103C6.24223 15.3185 6.2509 15.3251 6.26069 15.3297C6.27047 15.3342 6.28113 15.3366 6.29192 15.3365V15.3365C6.3034 15.3365 6.31472 15.3338 6.32497 15.3287C6.33523 15.3235 6.34414 15.3161 6.351 15.3068L13.2053 6.83469H9.20443L10.194 1.41945C10.1954 1.40866 10.1944 1.39772 10.1911 1.38734C10.1879 1.37696 10.1825 1.36738 10.1753 1.35925C10.1681 1.35112 10.1592 1.34462 10.1493 1.34018C10.1394 1.33574 10.1286 1.33346 10.1178 1.3335V1.3335C10.1059 1.33354 10.0941 1.3364 10.0835 1.34183C10.0729 1.34726 10.0638 1.35512 10.0568 1.36475V1.36475Z"
    ],
    viewBox: "0 0 16 16"
  },
  "resize-handlebar": {
    paths: ["M20 9H4V11H20V9ZM4 15H20V13H4V15Z"],
    viewBox: "0 0 24 24"
  },
  "resize-vertical": {
    paths: [
      "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z"
    ],
    viewBox: "0 0 16 16"
  },
  "share-forward-fill-down": {
    paths: [
      "M5 10L5 8C5.00063 6.3596 4.55286 4.75023 3.7051 3.34588C2.85734 1.94152 1.64184 0.795601 0.190001 0.0320007C0.459466 0.0105373 0.729681 -0.00013795 1 6.76941e-07C6.523 9.18359e-07 11 4.477 11 10L16 10L8 20L-4.37114e-07 10L5 10Z"
    ],
    viewBox: "0 0 16 20"
  },
  "directions-car": {
    paths: [
      "M15.7667 5.00841C15.6 4.51675 15.1333 4.16675 14.5833 4.16675H5.41667C4.86667 4.16675 4.40833 4.51675 4.23333 5.00841L2.5 10.0001V16.6667C2.5 17.1251 2.875 17.5001 3.33333 17.5001H4.16667C4.625 17.5001 5 17.1251 5 16.6667V15.8334H15V16.6667C15 17.1251 15.375 17.5001 15.8333 17.5001H16.6667C17.125 17.5001 17.5 17.1251 17.5 16.6667V10.0001L15.7667 5.00841ZM5.70833 5.83341H14.2833L15.1833 8.42508H4.80833L5.70833 5.83341ZM15.8333 14.1667H4.16667V10.0001H15.8333V14.1667Z",
      "M6.25 13.3333C6.94036 13.3333 7.5 12.7736 7.5 12.0833C7.5 11.3929 6.94036 10.8333 6.25 10.8333C5.55964 10.8333 5 11.3929 5 12.0833C5 12.7736 5.55964 13.3333 6.25 13.3333Z",
      "M13.75 13.3333C14.4404 13.3333 15 12.7736 15 12.0833C15 11.3929 14.4404 10.8333 13.75 10.8333C13.0596 10.8333 12.5 11.3929 12.5 12.0833C12.5 12.7736 13.0596 13.3333 13.75 13.3333Z"
    ]
  },
  roofing: {
    paths: [
      "M10.8337 15H9.16699V13.3333H10.8337V15ZM12.5003 11.6667H7.50033V16.6667H12.5003V11.6667ZM15.8337 7.75V3.33333H13.3337V5.5L10.0003 2.5L1.66699 10H4.16699L10.0003 4.74167L15.8337 10H18.3337L15.8337 7.75Z"
    ]
  },
  hotel: {
    paths: [
      "M5.83301 11.6667C7.21634 11.6667 8.33301 10.5501 8.33301 9.16675C8.33301 7.78341 7.21634 6.66675 5.83301 6.66675C4.44967 6.66675 3.33301 7.78341 3.33301 9.16675C3.33301 10.5501 4.44967 11.6667 5.83301 11.6667ZM5.83301 8.33341C6.29134 8.33341 6.66634 8.70841 6.66634 9.16675C6.66634 9.62508 6.29134 10.0001 5.83301 10.0001C5.37467 10.0001 4.99967 9.62508 4.99967 9.16675C4.99967 8.70841 5.37467 8.33341 5.83301 8.33341ZM15.833 5.83341H9.16634V12.5001H2.49967V4.16675H0.833008V16.6667H2.49967V14.1667H17.4997V16.6667H19.1663V9.16675C19.1663 7.32508 17.6747 5.83341 15.833 5.83341ZM17.4997 12.5001H10.833V7.50008H15.833C16.7497 7.50008 17.4997 8.25008 17.4997 9.16675V12.5001Z"
    ]
  },
  hvac: {
    paths: [
      "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333Z",
      "M10 15C12.7583 15 15 12.7583 15 10C15 7.24167 12.7583 5 10 5C7.24167 5 5 7.24167 5 10C5 12.7583 7.24167 15 10 15ZM12.8667 8.33333C13.0833 8.70833 13.2333 9.13333 13.2917 9.58333H6.70833C6.76667 9.13333 6.90833 8.70833 7.13333 8.33333H12.8667ZM13.2917 10.4167C13.2333 10.8667 13.0917 11.2917 12.8667 11.6667H7.13333C6.91667 11.2917 6.76667 10.8667 6.70833 10.4167H13.2917ZM7.81667 12.5H12.1833C11.6 13.0083 10.8417 13.3333 10 13.3333C9.15833 13.3333 8.40833 13.0083 7.81667 12.5ZM12.1833 7.5H7.81667C8.4 6.99167 9.15833 6.66667 10 6.66667C10.8417 6.66667 11.5917 6.99167 12.1833 7.5Z"
    ]
  },
  "rotate-right": {
    paths: [
      "M15.55 5.55L11 1V4.07C7.06 4.56 4 7.92 4 12C4 16.08 7.05 19.44 11 19.93V17.91C8.16 17.43 6 14.97 6 12C6 9.03 8.16 6.57 11 6.09V10L15.55 5.55ZM19.93 11C19.76 9.61 19.21 8.27 18.31 7.11L16.89 8.53C17.43 9.28 17.77 10.13 17.91 11H19.93ZM13 17.9V19.92C14.39 19.75 15.74 19.21 16.9 18.31L15.46 16.87C14.71 17.41 13.87 17.76 13 17.9ZM16.89 15.48L18.31 16.89C19.21 15.73 19.76 14.39 19.93 13H17.91C17.77 13.87 17.43 14.72 16.89 15.48V15.48Z"
    ]
  },
  "side-nav-collapse-2": {
    paths: [
      "M4.05579 18H17.479V16H4.05579V18ZM4.05579 13H14.3814V11H4.05579V13ZM4.05579 6V8H17.479V6H4.05579ZM22.6418 15.59L18.9453 12L22.6418 8.41L21.1859 7L16.0231 12L21.1859 17L22.6418 15.59Z"
    ],
    viewBox: "0 0 26 24"
  },
  "side-nav-expand-2": {
    paths: [
      "M21 6L8 6V8L21 8V6ZM21 11H11V13H21V11ZM21 18V16L8 16V18H21ZM3 8.41L6.58 12L3 15.59L4.41 17L9.41 12L4.41 7L3 8.41Z"
    ],
    viewBox: "0 0 24 24"
  },
  "cloud-upload": {
    paths: [
      "M22.4788 69.1667C17.2337 69.1667 12.7523 67.3511 9.03457 63.7198C5.31686 60.0886 3.45801 55.6504 3.45801 50.4052C3.45801 45.9094 4.81252 41.9035 7.52155 38.3875C10.2306 34.8716 13.7754 32.6237 18.1559 31.6438C19.5969 26.341 22.4788 22.0469 26.8018 18.7615C31.1247 15.4761 36.024 13.8334 41.4997 13.8334C48.2434 13.8334 53.9641 16.1822 58.6617 20.8797C63.3592 25.5773 65.708 31.298 65.708 38.0417C69.6851 38.5028 72.9849 40.2176 75.6075 43.186C78.2301 46.1544 79.5413 49.6271 79.5413 53.6042C79.5413 57.9271 78.0283 61.6016 75.0023 64.6276C71.9762 67.6537 68.3018 69.1667 63.9788 69.1667H44.958C43.0559 69.1667 41.4276 68.4895 40.0731 67.1349C38.7186 65.7804 38.0413 64.1521 38.0413 62.25V44.4396L32.508 49.8L27.6663 44.9584L41.4997 31.125L55.333 44.9584L50.4913 49.8L44.958 44.4396V62.25H63.9788C66.3997 62.25 68.4459 61.4143 70.1174 59.7427C71.7889 58.0712 72.6247 56.025 72.6247 53.6042C72.6247 51.1834 71.7889 49.1372 70.1174 47.4657C68.4459 45.7941 66.3997 44.9584 63.9788 44.9584H58.7913V38.0417C58.7913 33.2577 57.1054 29.1797 53.7335 25.8079C50.3617 22.436 46.2837 20.75 41.4997 20.75C36.7156 20.75 32.6377 22.436 29.2658 25.8079C25.8939 29.1797 24.208 33.2577 24.208 38.0417H22.4788C19.1358 38.0417 16.2827 39.2233 13.9195 41.5865C11.5563 43.9497 10.3747 46.8028 10.3747 50.1459C10.3747 53.4889 11.5563 56.3421 13.9195 58.7052C16.2827 61.0684 19.1358 62.25 22.4788 62.25H31.1247V69.1667H22.4788Z"
    ],
    viewBox: "0 0 83 83"
  },
  "mls-listing": {
    paths: [
      "M19 14V7.5L14 4L9 7.5V9H7V6.5L14 1.5L21 6.5V14H19ZM14.5 8H15.5V7H14.5V8ZM12.5 8H13.5V7H12.5V8ZM14.5 10H15.5V9H14.5V10ZM12.5 10H13.5V9H12.5V10ZM14 22.5L7 20.55V22H1V11H8.95L15.15 13.3C15.7 13.5 16.1458 13.85 16.4875 14.35C16.8292 14.85 17 15.4 17 16H19C19.8333 16 20.5417 16.275 21.125 16.825C21.7083 17.375 22 18.1 22 19V20L14 22.5ZM3 20H5V13H3V20ZM13.95 20.4L19.9 18.55C19.85 18.3667 19.7375 18.2292 19.5625 18.1375C19.3875 18.0458 19.2 18 19 18H14.2C13.6833 18 13.2167 17.9667 12.8 17.9C12.3833 17.8333 11.9333 17.7167 11.45 17.55L9.725 16.95L10.3 15.05L12.3 15.7C12.6 15.8 12.95 15.875 13.35 15.925C13.75 15.975 14.3 16 15 16C15 15.8167 14.9458 15.6417 14.8375 15.475C14.7292 15.3083 14.6 15.2 14.45 15.15L8.6 13H7V18.5L13.95 20.4Z"
    ]
  },
  "street-view": {
    paths: [
      "M7.875 18C6.59167 18 5.61667 17.525 4.95 16.575C4.28333 15.625 3.96667 14.5583 4 13.375L3.55 12.7C3.36667 12.4167 3.0625 11.775 2.6375 10.775C2.2125 9.775 2 8.51667 2 7C2 5.28333 2.425 3.85417 3.275 2.7125C4.125 1.57083 5.2 1 6.5 1C7.91667 1 9.02083 1.62917 9.8125 2.8875C10.6042 4.14583 11 5.51667 11 7C11 7.96667 10.8667 8.85833 10.6 9.675C10.3333 10.4917 10.1 11.15 9.9 11.65L10.1 11.975C10.2333 12.2083 10.4167 12.5792 10.65 13.0875C10.8833 13.5958 11 14.125 11 14.675C11 15.625 10.7042 16.4167 10.1125 17.05C9.52083 17.6833 8.775 18 7.875 18ZM5.25 11.6L8 11.05C8.21667 10.5167 8.4375 9.90833 8.6625 9.225C8.8875 8.54167 9 7.8 9 7C9 6 8.77083 5.08333 8.3125 4.25C7.85417 3.41667 7.25 3 6.5 3C5.75 3 5.14583 3.41667 4.6875 4.25C4.22917 5.08333 4 6 4 7C4 8.05 4.14583 8.97917 4.4375 9.7875C4.72917 10.5958 5 11.2 5.25 11.6ZM7.875 16C8.19167 16 8.45833 15.8833 8.675 15.65C8.89167 15.4167 9 15.0917 9 14.675C9 14.3917 8.93333 14.1 8.8 13.8C8.66667 13.5 8.53333 13.2333 8.4 13L6 13.5C6 14.1667 6.14583 14.75 6.4375 15.25C6.72917 15.75 7.20833 16 7.875 16ZM16.125 23C15.225 23 14.4792 22.6833 13.8875 22.05C13.2958 21.4167 13 20.625 13 19.675C13 19.125 13.1167 18.5958 13.35 18.0875C13.5833 17.5792 13.7667 17.2083 13.9 16.975L14.1 16.65C13.9 16.15 13.6667 15.4917 13.4 14.675C13.1333 13.8583 13 12.9667 13 12C13 10.5167 13.3958 9.14583 14.1875 7.8875C14.9792 6.62917 16.0833 6 17.5 6C18.8 6 19.875 6.57083 20.725 7.7125C21.575 8.85417 22 10.2833 22 12C22 13.5167 21.7875 14.7708 21.3625 15.7625C20.9375 16.7542 20.6333 17.3917 20.45 17.675L20 18.375C20.0167 19.5583 19.6958 20.625 19.0375 21.575C18.3792 22.525 17.4083 23 16.125 23ZM18.75 16.6C19 16.2 19.2708 15.6 19.5625 14.8C19.8542 14 20 13.0667 20 12C20 11 19.7708 10.0833 19.3125 9.25C18.8542 8.41667 18.25 8 17.5 8C16.75 8 16.1458 8.41667 15.6875 9.25C15.2292 10.0833 15 11 15 12C15 12.8 15.1125 13.5375 15.3375 14.2125C15.5625 14.8875 15.7833 15.5 16 16.05L18.75 16.6ZM16.125 21C16.7917 21 17.2708 20.75 17.5625 20.25C17.8542 19.75 18 19.1667 18 18.5L15.6 18C15.4667 18.2333 15.3333 18.5 15.2 18.8C15.0667 19.1 15 19.3917 15 19.675C15 20.0083 15.1042 20.3125 15.3125 20.5875C15.5208 20.8625 15.7917 21 16.125 21Z"
    ]
  },
  "play-button": {
    paths: [
      "M9.5 16.5L16.5 12L9.5 7.5V16.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
    ]
  },
  "arrow-left-right": {
    paths: ["M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"]
  },
  warning: {
    paths: ["M10.5 17H13.5V20H10.5V17ZM10.5 4H13.5V14H10.5V4Z"]
  },
  attachment: {
    paths: [
      "M19 20.9999H5C4.73478 20.9999 4.48043 20.8946 4.29289 20.707C4.10536 20.5195 4 20.2651 4 19.9999V10.9999H1L11.327 1.61192C11.5111 1.4444 11.7511 1.35156 12 1.35156C12.2489 1.35156 12.4889 1.4444 12.673 1.61192L23 10.9999H20V19.9999C20 20.2651 19.8946 20.5195 19.7071 20.707C19.5196 20.8946 19.2652 20.9999 19 20.9999ZM6 18.9999H18V9.15692L12 3.70292L6 9.15692V18.9999Z"
    ]
  },
  bedrooms: {
    paths: [
      "M21.9875 13V18.9875H20.0125V17V16.9875H20H4H3.9875V17V18.9875H2.0125V13C2.0125 12.5517 2.1038 12.1454 2.28618 11.7806C2.46885 11.4152 2.70964 11.0914 3.00858 10.8091L3.0125 10.8132V10.8V8C3.0125 7.16994 3.30288 6.4648 3.88384 5.88384C4.4648 5.30288 5.16994 5.0125 6 5.0125H10C10.3818 5.0125 10.7384 5.08303 11.0701 5.224C11.4022 5.36512 11.7094 5.56022 11.9917 5.80937L12 5.81667L12.0083 5.80937C12.2906 5.56022 12.5978 5.36512 12.9299 5.224C13.2616 5.08303 13.6182 5.0125 14 5.0125H18C18.8301 5.0125 19.5352 5.30288 20.1162 5.88384C20.6971 6.4648 20.9875 7.16994 20.9875 8V10.8H20.9818L20.9914 10.8091C21.2904 11.0914 21.5311 11.4152 21.7138 11.7806C21.8962 12.1454 21.9875 12.5517 21.9875 13ZM12.9875 10V10.0125H13H19H19.0125V10V8C19.0125 7.71352 18.9155 7.47279 18.7213 7.27866C18.5272 7.08453 18.2865 6.9875 18 6.9875H14C13.7135 6.9875 13.4728 7.08453 13.2787 7.27866C13.0845 7.47279 12.9875 7.71352 12.9875 8V10ZM4.9875 10V10.0125H5H11H11.0125V10V8C11.0125 7.71352 10.9155 7.47279 10.7213 7.27866C10.5272 7.08453 10.2865 6.9875 10 6.9875H6C5.71352 6.9875 5.47279 7.08453 5.27866 7.27866C5.08453 7.47279 4.9875 7.71352 4.9875 8V10ZM3.9875 15V15.0125H4H20H20.0125V15V13C20.0125 12.7135 19.9155 12.4728 19.7213 12.2787C19.5272 12.0845 19.2865 11.9875 19 11.9875H5C4.71352 11.9875 4.47279 12.0845 4.27866 12.2787C4.08453 12.4728 3.9875 12.7135 3.9875 13V15Z"
    ]
  },
  "basement-sf": {
    paths: [
      "M10.425 14.6625H10.4125V14.675V17.9875H6.0125V16.0125H8.425H8.4375V16V12.6625H11H11.0125V12.65V9.3375H13.575H13.5875V9.325V6.0125H17.9875V7.9875H15.575H15.5625V8V11.3375H13H12.9875V11.35V14.6625H10.425ZM4.9875 19V19.0125H5H19H19.0125V19V5V4.9875H19H5H4.9875V5V19ZM5 20.9875C4.45334 20.9875 3.98568 20.793 3.59634 20.4037C3.207 20.0143 3.0125 19.5467 3.0125 19V5C3.0125 4.45334 3.207 3.98568 3.59634 3.59634C3.98568 3.207 4.45334 3.0125 5 3.0125H19C19.5467 3.0125 20.0143 3.207 20.4037 3.59634C20.793 3.98568 20.9875 4.45334 20.9875 5V19C20.9875 19.5467 20.793 20.0143 20.4037 20.4037C20.0143 20.793 19.5467 20.9875 19 20.9875H5Z"
    ]
  },
  baths: {
    paths: [
      "M12.1719 4.23869C12.1719 4.38228 12.2883 4.49869 12.4319 4.49869H17.5959C17.7395 4.49869 17.8559 4.38228 17.8559 4.23869V2.81469C17.8559 2.67109 17.7395 2.55469 17.5959 2.55469H12.4319C12.2883 2.55469 12.1719 2.67109 12.1719 2.81469V4.23869ZM19.7263 1.94402C19.8165 1.94492 19.9034 1.97627 19.9731 2.03236C19.9842 2.04133 19.9949 2.05094 20.0052 2.06116C20.0726 2.12865 20.1135 2.21778 20.121 2.31225C20.1216 2.31881 20.1219 2.32539 20.1221 2.332C20.1223 2.33599 20.1223 2.33999 20.1223 2.344V10.44H21.9983V2.332C22.0047 1.72796 21.774 1.14576 21.3562 0.710149C21.352 0.705792 21.3478 0.701451 21.3436 0.697124C20.9178 0.260125 20.3363 0.00948271 19.7263 0H16.3343C16.329 8.20692e-05 16.3236 0.00018281 16.3182 0.000302187C16.048 0.0063234 15.7833 0.0597554 15.5355 0.156C15.3848 0.214518 15.2404 0.288864 15.1047 0.378003C15.023 0.43162 14.9446 0.49059 14.8698 0.554688C14.8395 0.580701 14.8098 0.607559 14.7807 0.635246C14.5696 0.836301 14.4004 1.07367 14.2798 1.33356C14.1607 1.59017 14.0888 1.86874 14.0703 2.156H16.0063C16.03 2.10622 16.0644 2.0625 16.1069 2.02785C16.118 2.01874 16.1297 2.01025 16.1419 2.00245C16.1995 1.96569 16.2661 1.9455 16.3343 1.94406C16.3356 1.94403 16.337 1.94401 16.3383 1.944H19.7223C19.7236 1.944 19.725 1.94401 19.7263 1.94402ZM0 11V15C0 17.2091 1.79086 19 4 19H20C22.2091 19 24 17.2091 24 15V11H0ZM22 13H2V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V13Z"
    ]
  },
  cooling: {
    paths: [
      "M11.25 21.75V17.2538L7.74998 20.7038L6.69615 19.65L11.25 15.0961V12.75H8.90383L4.34998 17.3038L3.29615 16.25L6.74617 12.75H2.25V11.25H6.74617L3.29615 7.74998L4.34998 6.69615L8.90383 11.25H11.25V8.90383L6.69615 4.34998L7.74998 3.29615L11.25 6.74618V2.25H12.75V6.74618L16.25 3.29615L17.3038 4.34998L12.75 8.90383V11.25H15.0961L19.65 6.69615L20.7038 7.74998L17.2538 11.25H21.75V12.75H17.2538L20.7038 16.25L19.65 17.3038L15.0961 12.75H12.75V15.0961L17.3038 19.65L16.25 20.7038L12.75 17.2538V21.75L11.25 21.75Z"
    ]
  },
  "energy-efficiency": {
    paths: [
      "M11.077 23.0355V19.5088H12.923V23.0354L11.077 23.0355ZM0 11.9585V10.1124H3.52662V11.9585H0ZM20.4734 11.9585V10.1124H24V11.9585H20.4734ZM19.4083 20.3561L16.942 17.8899L18.2391 16.5929L20.7053 19.0591L19.4083 20.3561ZM4.5917 20.3561L3.29469 19.0591L5.76094 16.5929L7.05796 17.8899L4.5917 20.3561ZM12 16.5739C10.4631 16.5739 9.15584 16.035 8.07811 14.9573C7.00041 13.8796 6.46156 12.5723 6.46156 11.0354C6.46156 10.0982 6.68207 9.22953 7.1231 8.42953C7.56412 7.62952 8.16412 6.9676 8.9231 6.44374V1H15.0769V6.44374C15.8359 6.9676 16.4359 7.62952 16.8769 8.42953C17.3179 9.22953 17.5384 10.0982 17.5384 11.0354C17.5384 12.5723 16.9996 13.8796 15.9219 14.9573C14.8442 16.035 13.5369 16.5739 12 16.5739ZM10.7692 5.64377C10.9744 5.59484 11.1775 5.55815 11.3787 5.5337C11.5799 5.50923 11.787 5.497 12 5.497C12.213 5.497 12.4201 5.50923 12.6213 5.5337C12.8225 5.55815 13.0256 5.59484 13.2308 5.64377V2.8461H10.7692V5.64377ZM12 14.7278C13.0256 14.7278 13.8974 14.3688 14.6154 13.6508C15.3333 12.9329 15.6923 12.0611 15.6923 11.0354C15.6923 10.0098 15.3333 9.138 14.6154 8.42005C13.8974 7.7021 13.0256 7.34312 12 7.34312C10.9744 7.34312 10.1026 7.7021 9.38461 8.42005C8.66666 9.138 8.30768 10.0098 8.30768 11.0354C8.30768 12.0611 8.66666 12.9329 9.38461 13.6508C10.1026 14.3688 10.9744 14.7278 12 14.7278Z"
    ]
  },
  gla: {
    paths: [
      "M5.81519 20.2306C5.24341 20.2306 4.75944 20.0325 4.36329 19.6363C3.96713 19.2402 3.76904 18.7562 3.76904 18.1844V6.31147C3.76904 5.88584 3.96039 5.59001 4.34309 5.42397C4.72578 5.25796 5.06134 5.31918 5.34979 5.60765L7.21517 7.473L6.15364 8.5345L6.73824 9.11912L7.79977 8.0576L10.169 10.4268L9.10747 11.4883L9.69207 12.0729L10.7536 11.0114L13.1613 13.4191L12.0997 14.4806L12.6844 15.0652L13.7459 14.0037L16.1151 16.3729L15.0536 17.4344L15.6382 18.019L16.6997 16.9575L18.4112 18.669C18.6933 18.9511 18.7513 19.2819 18.5852 19.6613C18.4192 20.0408 18.1266 20.2306 17.7074 20.2306H5.81519ZM6.30749 17.9998H14.2998L5.99977 9.69985V17.6921C5.99977 17.7819 6.02862 17.8556 6.08632 17.9133C6.14402 17.971 6.21774 17.9998 6.30749 17.9998Z"
    ]
  },
  heating: {
    paths: [
      "M8.01665 18.5093L8.04463 18.5344L8.03726 18.4975C8.02071 18.4148 8.0125 18.3407 8.0125 18.275V18.05C8.0125 17.5183 8.11219 17.02 8.31149 16.5549C8.51081 16.0898 8.80151 15.6662 9.18376 15.2839C9.18379 15.2839 9.18381 15.2839 9.18384 15.2838L12 12.5175L14.8162 15.2838C14.8162 15.2839 14.8162 15.2839 14.8162 15.2839C15.1985 15.6662 15.4892 16.0898 15.6885 16.5549C15.8878 17.02 15.9875 17.5183 15.9875 18.05V18.275C15.9875 18.3407 15.9793 18.4148 15.9627 18.4975L15.9554 18.5344L15.9833 18.5093C16.6346 17.9248 17.1357 17.2443 17.4864 16.4676C17.8371 15.691 18.0125 14.8684 18.0125 14C18.0125 13.1651 17.858 12.3759 17.549 11.6327C17.2401 10.8895 16.7933 10.2256 16.2088 9.64116L16.2017 9.634L16.1932 9.63952C15.8608 9.85556 15.5119 10.0175 15.1465 10.1255C14.7809 10.2335 14.4071 10.2875 14.025 10.2875C12.9947 10.2875 12.1019 9.94695 11.3459 9.26571C10.5898 8.58438 10.1537 7.74549 10.0374 6.74855L10.0347 6.7254L10.0169 6.74046C9.36645 7.29086 8.79094 7.86218 8.29045 8.45443C7.79 9.04664 7.3687 9.64728 7.0266 10.2564C6.68447 10.8655 6.42574 11.4873 6.25045 12.1217C6.07517 12.756 5.9875 13.3821 5.9875 14C5.9875 14.8684 6.16286 15.691 6.51361 16.4676C6.86434 17.2443 7.36539 17.9248 8.01665 18.5093ZM12.0088 15.2911L12 15.2825L11.9912 15.2911L10.5662 16.6911L10.5662 16.6912C10.3817 16.8756 10.2392 17.0852 10.1385 17.3201C10.0379 17.5549 9.9875 17.7983 9.9875 18.05C9.9875 18.5868 10.1848 19.0483 10.5788 19.4339C10.9728 19.8196 11.4467 20.0125 12 20.0125C12.5533 20.0125 13.0272 19.8196 13.4212 19.4339C13.8152 19.0483 14.0125 18.5868 14.0125 18.05C14.0125 17.7817 13.9622 17.5342 13.8614 17.3074C13.7608 17.0809 13.6182 16.8755 13.4338 16.6912L13.4338 16.6911L12.0088 15.2911ZM14.8679 8.12375C15.1281 7.99786 15.3587 7.80911 15.5597 7.55784C15.5597 7.55783 15.5598 7.55782 15.5598 7.55781L16.003 7.01608C17.23 7.71458 18.2004 8.68622 18.9142 9.93122C19.6297 11.1793 19.9875 12.5355 19.9875 14C19.9875 16.2301 19.2138 18.1186 17.6662 19.6662C16.1186 21.2138 14.2301 21.9875 12 21.9875C9.76991 21.9875 7.88145 21.2138 6.33384 19.6662C4.78623 18.1186 4.0125 16.2301 4.0125 14C4.0125 11.853 4.73226 9.81392 6.17252 7.88247C7.60933 5.95566 9.54753 4.33509 11.9875 3.02092V6.3C11.9875 6.8699 12.1846 7.34816 12.5788 7.73393C12.9728 8.11964 13.4552 8.3125 14.025 8.3125C14.3268 8.3125 14.6078 8.24961 14.8679 8.12375Z"
    ]
  },
  "lot-size": {
    paths: [
      "M5 22V20H11V16H9C7.61667 16 6.4375 15.5125 5.4625 14.5375C4.4875 13.5625 4 12.3833 4 11C4 10 4.275 9.07917 4.825 8.2375C5.375 7.39583 6.11667 6.78333 7.05 6.4C7.2 5.15 7.74583 4.10417 8.6875 3.2625C9.62917 2.42083 10.7333 2 12 2C13.2667 2 14.3708 2.42083 15.3125 3.2625C16.2542 4.10417 16.8 5.15 16.95 6.4C17.8833 6.78333 18.625 7.39583 19.175 8.2375C19.725 9.07917 20 10 20 11C20 12.3833 19.5125 13.5625 18.5375 14.5375C17.5625 15.5125 16.3833 16 15 16H13V20H19V22H5ZM9 14H15C15.8333 14 16.5417 13.7083 17.125 13.125C17.7083 12.5417 18 11.8333 18 11C18 10.4 17.8292 9.85 17.4875 9.35C17.1458 8.85 16.7 8.48333 16.15 8.25L15.1 7.8L14.95 6.65C14.85 5.9 14.5208 5.27083 13.9625 4.7625C13.4042 4.25417 12.75 4 12 4C11.25 4 10.5958 4.25417 10.0375 4.7625C9.47917 5.27083 9.15 5.9 9.05 6.65L8.9 7.8L7.85 8.25C7.3 8.48333 6.85417 8.85 6.5125 9.35C6.17083 9.85 6 10.4 6 11C6 11.8333 6.29167 12.5417 6.875 13.125C7.45833 13.7083 8.16667 14 9 14Z"
    ]
  },
  "patio-porch": {
    paths: [
      "M12 2.01526L21.9603 8.9875H13H12.9875V9V21.9875H11.0125V9V8.9875H11H2.03965L12 2.01526ZM4.9 16.0125H8.9875V21.9875H7.0125V18V17.9875H7H5H4.9875V18V21.9875H3.0125V16.75H3.0127L3.0123 16.7478L2.21454 12.3601L4.14 12.0145L4.88771 16.0023L4.88963 16.0125H4.9ZM19.86 12.0145L21.7855 12.3601L20.9877 16.7478L20.9875 16.7477V16.75V21.9875H19.0125V18V17.9875H19H17H16.9875V18V21.9875H15.0125V16.0125H19.1H19.1104L19.1123 16.0023L19.86 12.0145ZM8.34284 6.98975L8.31028 7.0125H8.35H15.65H15.6897L15.6572 6.98975L12.0072 4.43975L12 4.43475L11.9928 4.43975L8.34284 6.98975Z"
    ]
  },
  pool: {
    paths: [
      "M2 20.3484V18.3984C2.48333 18.3984 2.89583 18.3234 3.2375 18.1734C3.57917 18.0234 3.925 17.8609 4.275 17.6859C4.625 17.5109 5.0125 17.3526 5.4375 17.2109C5.8625 17.0693 6.38333 16.9984 7 16.9984C7.63333 16.9984 8.15417 17.0693 8.5625 17.2109C8.97083 17.3526 9.35 17.5109 9.7 17.6859C10.05 17.8609 10.4 18.0234 10.75 18.1734C11.1 18.3234 11.5167 18.3984 12 18.3984C12.4833 18.3984 12.9 18.3234 13.25 18.1734C13.6 18.0234 13.95 17.8609 14.3 17.6859C14.65 17.5109 15.0333 17.3526 15.45 17.2109C15.8667 17.0693 16.3833 16.9984 17 16.9984C17.6333 16.9984 18.1583 17.0693 18.575 17.2109C18.9917 17.3526 19.375 17.5109 19.725 17.6859C20.075 17.8609 20.425 18.0234 20.775 18.1734C21.125 18.3234 21.5333 18.3984 22 18.3984V20.3484C21.3667 20.3484 20.8375 20.2734 20.4125 20.1234C19.9875 19.9734 19.6 19.8109 19.25 19.6359C18.9 19.4609 18.5583 19.3026 18.225 19.1609C17.8917 19.0193 17.4833 18.9484 17 18.9484C16.5333 18.9484 16.1292 19.0193 15.7875 19.1609C15.4458 19.3026 15.1042 19.4609 14.7625 19.6359C14.4208 19.8109 14.0375 19.9734 13.6125 20.1234C13.1875 20.2734 12.65 20.3484 12 20.3484C11.35 20.3484 10.8125 20.2734 10.3875 20.1234C9.9625 19.9734 9.57917 19.8109 9.2375 19.6359C8.89583 19.4609 8.55833 19.3026 8.225 19.1609C7.89167 19.0193 7.48333 18.9484 7 18.9484C6.53333 18.9484 6.12917 19.0193 5.7875 19.1609C5.44583 19.3026 5.1 19.4609 4.75 19.6359C4.4 19.8109 4.0125 19.9734 3.5875 20.1234C3.1625 20.2734 2.63333 20.3484 2 20.3484ZM2 15.8984V13.9484C2.48333 13.9484 2.89583 13.8734 3.2375 13.7234C3.57917 13.5734 3.925 13.4109 4.275 13.2359C4.625 13.0609 5.0125 12.9026 5.4375 12.7609C5.8625 12.6193 6.38333 12.5484 7 12.5484C7.63333 12.5484 8.15417 12.6193 8.5625 12.7609C8.97083 12.9026 9.35 13.0609 9.7 13.2359C10.05 13.4109 10.4 13.5734 10.75 13.7234C11.1 13.8734 11.5167 13.9484 12 13.9484C12.4833 13.9484 12.9 13.8734 13.25 13.7234C13.6 13.5734 13.95 13.4109 14.3 13.2359C14.65 13.0609 15.0333 12.9026 15.45 12.7609C15.8667 12.6193 16.3833 12.5484 17 12.5484C17.6333 12.5484 18.1583 12.6193 18.575 12.7609C18.9917 12.9026 19.375 13.0609 19.725 13.2359C20.075 13.4109 20.425 13.5734 20.775 13.7234C21.125 13.8734 21.5333 13.9484 22 13.9484V15.8984C21.3667 15.8984 20.8375 15.8234 20.4125 15.6734C19.9875 15.5234 19.6 15.3609 19.25 15.1859C18.9 15.0109 18.5583 14.8526 18.225 14.7109C17.8917 14.5693 17.4833 14.4984 17 14.4984C16.5167 14.4984 16.1042 14.5693 15.7625 14.7109C15.4208 14.8526 15.0792 15.0109 14.7375 15.1859C14.3958 15.3609 14.0167 15.5234 13.6 15.6734C13.1833 15.8234 12.65 15.8984 12 15.8984C11.35 15.8984 10.8125 15.8234 10.3875 15.6734C9.9625 15.5234 9.57917 15.3609 9.2375 15.1859C8.89583 15.0109 8.55833 14.8526 8.225 14.7109C7.89167 14.5693 7.48333 14.4984 7 14.4984C6.53333 14.4984 6.12917 14.5693 5.7875 14.7109C5.44583 14.8526 5.1 15.0109 4.75 15.1859C4.4 15.3609 4.0125 15.5234 3.5875 15.6734C3.1625 15.8234 2.63333 15.8984 2 15.8984ZM2 11.4484V9.49844C2.48333 9.49844 2.89583 9.42344 3.2375 9.27344C3.57917 9.12344 3.925 8.96094 4.275 8.78594C4.625 8.61094 5.0125 8.4526 5.4375 8.31094C5.8625 8.16927 6.38333 8.09844 7 8.09844C7.63333 8.09844 8.15417 8.16927 8.5625 8.31094C8.97083 8.4526 9.35 8.61094 9.7 8.78594C10.05 8.96094 10.4 9.12344 10.75 9.27344C11.1 9.42344 11.5167 9.49844 12 9.49844C12.4833 9.49844 12.9 9.42344 13.25 9.27344C13.6 9.12344 13.95 8.96094 14.3 8.78594C14.65 8.61094 15.0333 8.4526 15.45 8.31094C15.8667 8.16927 16.3833 8.09844 17 8.09844C17.6333 8.09844 18.1583 8.16927 18.575 8.31094C18.9917 8.4526 19.375 8.61094 19.725 8.78594C20.075 8.96094 20.425 9.12344 20.775 9.27344C21.125 9.42344 21.5333 9.49844 22 9.49844V11.4484C21.3667 11.4484 20.8375 11.3734 20.4125 11.2234C19.9875 11.0734 19.6 10.9109 19.25 10.7359C18.9 10.5609 18.5583 10.4026 18.225 10.2609C17.8917 10.1193 17.4833 10.0484 17 10.0484C16.5333 10.0484 16.1292 10.1193 15.7875 10.2609C15.4458 10.4026 15.1042 10.5609 14.7625 10.7359C14.4208 10.9109 14.0375 11.0734 13.6125 11.2234C13.1875 11.3734 12.65 11.4484 12 11.4484C11.35 11.4484 10.8125 11.3734 10.3875 11.2234C9.9625 11.0734 9.57917 10.9109 9.2375 10.7359C8.89583 10.5609 8.55833 10.4026 8.225 10.2609C7.89167 10.1193 7.48333 10.0484 7 10.0484C6.53333 10.0484 6.12917 10.1193 5.7875 10.2609C5.44583 10.4026 5.1 10.5609 4.75 10.7359C4.4 10.9109 4.0125 11.0734 3.5875 11.2234C3.1625 11.3734 2.63333 11.4484 2 11.4484ZM2 6.99844V5.04844C2.48333 5.04844 2.89583 4.97344 3.2375 4.82344C3.57917 4.67344 3.925 4.51094 4.275 4.33594C4.625 4.16094 5.0125 4.0026 5.4375 3.86094C5.8625 3.71927 6.38333 3.64844 7 3.64844C7.63333 3.64844 8.15417 3.71927 8.5625 3.86094C8.97083 4.0026 9.35 4.16094 9.7 4.33594C10.05 4.51094 10.4 4.67344 10.75 4.82344C11.1 4.97344 11.5167 5.04844 12 5.04844C12.4833 5.04844 12.9 4.97344 13.25 4.82344C13.6 4.67344 13.95 4.51094 14.3 4.33594C14.65 4.16094 15.0333 4.0026 15.45 3.86094C15.8667 3.71927 16.3833 3.64844 17 3.64844C17.6333 3.64844 18.1583 3.71927 18.575 3.86094C18.9917 4.0026 19.375 4.16094 19.725 4.33594C20.075 4.51094 20.425 4.67344 20.775 4.82344C21.125 4.97344 21.5333 5.04844 22 5.04844V6.99844C21.3667 6.99844 20.8375 6.92344 20.4125 6.77344C19.9875 6.62344 19.6 6.46094 19.25 6.28594C18.9 6.11094 18.5583 5.9526 18.225 5.81094C17.8917 5.66927 17.4833 5.59844 17 5.59844C16.5333 5.59844 16.1292 5.66927 15.7875 5.81094C15.4458 5.9526 15.1042 6.11094 14.7625 6.28594C14.4208 6.46094 14.0375 6.62344 13.6125 6.77344C13.1875 6.92344 12.65 6.99844 12 6.99844C11.35 6.99844 10.8125 6.92344 10.3875 6.77344C9.9625 6.62344 9.57917 6.46094 9.2375 6.28594C8.89583 6.11094 8.55833 5.9526 8.225 5.81094C7.89167 5.66927 7.48333 5.59844 7 5.59844C6.53333 5.59844 6.12917 5.66927 5.7875 5.81094C5.44583 5.9526 5.1 6.11094 4.75 6.28594C4.4 6.46094 4.0125 6.62344 3.5875 6.77344C3.1625 6.92344 2.63333 6.99844 2 6.99844Z"
    ]
  },
  parking: {
    paths: [
      "M4.3077 21.5C3.80257 21.5 3.375 21.325 3.025 20.975C2.675 20.625 2.5 20.1974 2.5 19.6923V4.3077C2.5 3.80257 2.675 3.375 3.025 3.025C3.375 2.675 3.80257 2.5 4.3077 2.5H19.6923C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80257 21.5 4.3077V19.6923C21.5 20.1974 21.325 20.625 20.975 20.975C20.625 21.325 20.1974 21.5 19.6923 21.5H4.3077ZM4.3077 20H19.6923C19.7692 20 19.8397 19.9679 19.9038 19.9038C19.9679 19.8397 20 19.7692 20 19.6923V4.3077C20 4.23077 19.9679 4.16024 19.9038 4.09613C19.8397 4.03203 19.7692 3.99998 19.6923 3.99998H4.3077C4.23077 3.99998 4.16024 4.03203 4.09613 4.09613C4.03202 4.16024 3.99998 4.23077 3.99998 4.3077V19.6923C3.99998 19.7692 4.03202 19.8397 4.09613 19.9038C4.16024 19.9679 4.23077 20 4.3077 20ZM8.80765 13.8846C8.56278 13.8846 8.35413 13.7984 8.1817 13.6259C8.00927 13.4535 7.92305 13.2448 7.92305 13C7.92305 12.7551 8.00927 12.5465 8.1817 12.374C8.35413 12.2016 8.56278 12.1154 8.80765 12.1154C9.05252 12.1154 9.26117 12.2016 9.4336 12.374C9.60603 12.5465 9.69225 12.7551 9.69225 13C9.69225 13.2448 9.60603 13.4535 9.4336 13.6259C9.26117 13.7984 9.05252 13.8846 8.80765 13.8846ZM15.1923 13.8846C14.9474 13.8846 14.7388 13.7984 14.5664 13.6259C14.3939 13.4535 14.3077 13.2448 14.3077 13C14.3077 12.7551 14.3939 12.5465 14.5664 12.374C14.7388 12.2016 14.9474 12.1154 15.1923 12.1154C15.4372 12.1154 15.6458 12.2016 15.8183 12.374C15.9907 12.5465 16.0769 12.7551 16.0769 13C16.0769 13.2448 15.9907 13.4535 15.8183 13.6259C15.6458 13.7984 15.4372 13.8846 15.1923 13.8846ZM5.5 11.1769V17.373C5.5 17.5551 5.55898 17.7051 5.67693 17.823C5.79488 17.941 5.94488 18 6.12693 18H6.37308C6.55511 18 6.7051 17.941 6.82305 17.823C6.941 17.7051 6.99998 17.5551 6.99998 17.373V16H17V17.373C17 17.5551 17.059 17.7051 17.1769 17.823C17.2949 17.941 17.4448 18 17.6269 18H17.873C18.0551 18 18.2051 17.941 18.323 17.823C18.441 17.7051 18.5 17.5551 18.5 17.373V11.1769L16.9269 6.62693C16.8628 6.43846 16.7541 6.28686 16.6009 6.17213C16.4477 6.05738 16.2769 6 16.0884 6H7.91153C7.72308 6 7.55225 6.05738 7.39905 6.17213C7.24583 6.28686 7.13718 6.43846 7.07308 6.62693L5.5 11.1769ZM7.47687 10L8.34998 7.49998H15.65L16.5231 10H7.47687ZM6.99998 14.5V11.5H17V14.5H6.99998Z"
    ]
  },
  view: {
    paths: [
      "M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828ZM20 15V5H4V19L14 9L20 15ZM20 17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
    ]
  },
  other: {
    paths: [
      "M19 20.9999H5C4.73478 20.9999 4.48043 20.8946 4.29289 20.707C4.10536 20.5195 4 20.2651 4 19.9999V10.9999H1L11.327 1.61192C11.5111 1.4444 11.7511 1.35156 12 1.35156C12.2489 1.35156 12.4889 1.4444 12.673 1.61192L23 10.9999H20V19.9999C20 20.2651 19.8946 20.5195 19.7071 20.707C19.5196 20.8946 19.2652 20.9999 19 20.9999ZM6 18.9999H18V9.15692L12 3.70292L6 9.15692V18.9999Z",
      "M9.3125 8.79462C9.47117 8.65462 9.64383 8.52162 9.8305 8.39562C10.0218 8.26962 10.2272 8.15996 10.4465 8.06662C10.6658 7.97329 10.9038 7.90096 11.1605 7.84962C11.4172 7.79362 11.6948 7.76562 11.9935 7.76562C12.3995 7.76562 12.7682 7.82162 13.0995 7.93362C13.4355 8.04562 13.7225 8.20662 13.9605 8.41662C14.1985 8.62196 14.3828 8.87162 14.5135 9.16562C14.6442 9.45962 14.7095 9.78862 14.7095 10.1526C14.7095 10.5073 14.6582 10.8153 14.5555 11.0766C14.4528 11.3333 14.3222 11.5573 14.1635 11.7486C14.0095 11.94 13.8415 12.1056 13.6595 12.2456C13.4775 12.3856 13.3048 12.5186 13.1415 12.6446C12.9782 12.766 12.8358 12.8873 12.7145 13.0086C12.5978 13.1253 12.5278 13.2583 12.5045 13.4076L12.3435 14.4296H11.1605L11.0415 13.2886C11.0368 13.2653 11.0345 13.2466 11.0345 13.2326C11.0345 13.214 11.0345 13.193 11.0345 13.1696C11.0345 12.9643 11.0858 12.787 11.1885 12.6376C11.2912 12.4836 11.4195 12.3413 11.5735 12.2106C11.7275 12.0753 11.8932 11.9446 12.0705 11.8186C12.2478 11.6926 12.4135 11.5573 12.5675 11.4126C12.7215 11.2633 12.8498 11.0953 12.9525 10.9086C13.0552 10.722 13.1065 10.5026 13.1065 10.2506C13.1065 10.0826 13.0738 9.93329 13.0085 9.80263C12.9478 9.66729 12.8615 9.55296 12.7495 9.45962C12.6375 9.36162 12.5022 9.28696 12.3435 9.23562C12.1895 9.18429 12.0215 9.15863 11.8395 9.15863C11.5735 9.15863 11.3472 9.18896 11.1605 9.24963C10.9785 9.30562 10.8222 9.37096 10.6915 9.44563C10.5655 9.51562 10.4582 9.58096 10.3695 9.64163C10.2808 9.69762 10.2015 9.72562 10.1315 9.72562C9.9635 9.72562 9.84217 9.65562 9.7675 9.51562L9.3125 8.79462ZM10.6355 17.0476C10.6355 16.903 10.6612 16.7653 10.7125 16.6346C10.7685 16.504 10.8432 16.392 10.9365 16.2986C11.0345 16.2053 11.1488 16.1306 11.2795 16.0746C11.4102 16.0186 11.5502 15.9906 11.6995 15.9906C11.8442 15.9906 11.9818 16.0186 12.1125 16.0746C12.2432 16.1306 12.3552 16.2053 12.4485 16.2986C12.5418 16.392 12.6165 16.504 12.6725 16.6346C12.7285 16.7653 12.7565 16.903 12.7565 17.0476C12.7565 17.197 12.7285 17.337 12.6725 17.4676C12.6165 17.5936 12.5418 17.7033 12.4485 17.7966C12.3552 17.89 12.2432 17.9623 12.1125 18.0136C11.9818 18.0696 11.8442 18.0976 11.6995 18.0976C11.5502 18.0976 11.4102 18.0696 11.2795 18.0136C11.1488 17.9623 11.0345 17.89 10.9365 17.7966C10.8432 17.7033 10.7685 17.5936 10.7125 17.4676C10.6612 17.337 10.6355 17.197 10.6355 17.0476Z"
    ]
  },
  location: {
    paths: [
      "M0.10612 9.37871C0.326299 10.6258 0.8891 11.9482 1.79452 13.3461C1.85721 13.4429 1.92153 13.54 1.9875 13.6375C3.08066 15.2532 4.63611 16.9795 6.65384 18.8164C7.08177 19.2059 7.53049 19.6005 8 20C8.46951 19.6005 8.91823 19.2059 9.34616 18.8164C11.3639 16.9795 12.9193 15.2532 14.0125 13.6375C14.0785 13.54 14.1428 13.4429 14.2055 13.3461C14.2514 13.2752 14.2964 13.2045 14.3406 13.134C15.4469 11.3676 16 9.72291 16 8.2C16 5.7 15.1958 3.70833 13.5875 2.225C13.5067 2.1505 13.4253 2.07788 13.3433 2.00713C11.7915 0.669042 10.0104 0 8 0C5.98962 0 4.20853 0.669051 2.65671 2.00715C2.57467 2.0779 2.49326 2.15051 2.4125 2.225C0.804167 3.70833 0 5.7 0 8.2C0 8.58512 0.0353734 8.97802 0.10612 9.37871ZM8.007 17.3436C9.92431 15.5827 11.3743 13.974 12.3569 12.5173C12.4145 12.4319 12.4706 12.3469 12.525 12.2625C12.5632 12.2033 12.6006 12.1444 12.6373 12.0857C13.263 11.085 13.6732 10.1591 13.8679 9.30809C13.956 8.92343 14 8.55407 14 8.2C14 8.16382 13.9998 8.12778 13.9993 8.09186C13.9989 8.06115 13.9984 8.03053 13.9976 8C13.9838 7.42121 13.9096 6.87674 13.775 6.3666C13.5081 5.35535 13.004 4.47898 12.2625 3.7375C12.1833 3.65828 12.1028 3.58177 12.0212 3.50797C10.9086 2.50266 9.56821 2 8 2C6.43178 2 5.09139 2.50266 3.97883 3.50798C3.89716 3.58178 3.81671 3.65829 3.7375 3.7375C2.99602 4.47898 2.49186 5.35535 2.22502 6.36659C2.09041 6.87674 2.01619 7.42121 2.00237 8C2.00164 8.03053 2.00108 8.06115 2.00069 8.09186C2.00023 8.12778 2 8.16382 2 8.2C2 8.55407 2.04402 8.92344 2.13206 9.30809C2.32694 10.1596 2.73752 11.086 3.3638 12.0874C3.40014 12.1455 3.43721 12.2039 3.475 12.2625C3.52943 12.3469 3.58547 12.4319 3.64312 12.5173C4.62573 13.974 6.07569 15.5827 7.993 17.3436C7.99533 17.3457 7.99767 17.3479 8 17.35C8.00233 17.3479 8.00467 17.3457 8.007 17.3436ZM11.999 8.08821C11.9521 10.2566 10.1797 12 8 12C5.82034 12 4.04787 10.2566 4.00095 8.08821C4.00032 8.05889 4 8.02948 4 8C4 7.62717 4.05101 7.26626 4.14642 6.92386C4.61638 5.2374 6.16369 4 8 4C9.83631 4 11.3836 5.2374 11.8536 6.92386C11.949 7.26626 12 7.62717 12 8C12 8.02948 11.9997 8.05889 11.999 8.08821ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
    ]
  },
  "location-crosshairs": {
    viewBox: "0 0 16 16",
    paths: [
      "M8.83337 1.33325V2.16659V3.07023C10.9271 3.41919 12.5808 5.07284 12.9297 7.16659H13.8334H14.6667V8.83325H13.8334H12.9297C12.5808 10.927 10.9271 12.5806 8.83337 12.9296V13.8333V14.6666H7.16671V13.8333V12.9296C5.07296 12.5806 3.41931 10.927 3.07035 8.83325H2.16671H1.33337V7.16659H2.16671H3.07035C3.41931 5.07284 5.07296 3.41919 7.16671 3.07023V2.16659V1.33325H8.83337ZM4.66671 7.99992C4.66671 8.88397 5.0179 9.73182 5.64302 10.3569C6.26814 10.9821 7.11599 11.3333 8.00004 11.3333C8.8841 11.3333 9.73194 10.9821 10.3571 10.3569C10.9822 9.73182 11.3334 8.88397 11.3334 7.99992C11.3334 7.11586 10.9822 6.26802 10.3571 5.6429C9.73194 5.01777 8.8841 4.66659 8.00004 4.66659C7.11599 4.66659 6.26814 5.01777 5.64302 5.6429C5.0179 6.26802 4.66671 7.11586 4.66671 7.99992ZM8.00004 5.91659C8.55257 5.91659 9.08248 6.13608 9.47318 6.52678C9.86388 6.91748 10.0834 7.44738 10.0834 7.99992C10.0834 8.55245 9.86388 9.08236 9.47318 9.47306C9.08248 9.86376 8.55257 10.0833 8.00004 10.0833C7.44751 10.0833 6.9176 9.86376 6.5269 9.47306C6.1362 9.08236 5.91671 8.55245 5.91671 7.99992C5.91671 7.44738 6.1362 6.91748 6.5269 6.52678C6.9176 6.13608 7.44751 5.91659 8.00004 5.91659Z"
    ]
  },
  sparkle: {
    paths: [
      "M10.9789 6.43883C11.4321 6.28268 11.4321 6.0051 10.9789 5.83162L8.52121 4.89479C8.08545 4.73865 7.57997 4.23553 7.40567 3.78447L6.46443 1.33831C6.30755 0.88723 6.02867 0.88723 5.85436 1.33831L4.91312 3.78447C4.75625 4.21818 4.25077 4.7213 3.79758 4.89479L1.33989 5.83162C0.886702 5.98777 0.886702 6.26533 1.33989 6.43883L3.79758 7.37566C4.23334 7.5318 4.73882 8.0349 4.91312 8.48598L5.85436 10.9321C6.01124 11.3832 6.29012 11.3832 6.46443 10.9321L7.40567 8.48598C7.56254 8.05225 8.06802 7.54914 8.52121 7.37566L10.9789 6.43883ZM22.9541 15.0093C24.3486 14.6623 24.3486 14.0897 22.9541 13.7427L19.8691 12.9794C18.4746 12.6324 17.0453 11.2098 16.6967 9.82194L15.9298 6.75122C15.5811 5.36333 15.006 5.36333 14.6573 6.75122L13.8904 9.82194C13.5418 11.2098 12.1125 12.6324 10.7181 12.9794L7.63288 13.7427C6.23846 14.0897 6.23846 14.6623 7.63288 15.0093L10.7181 15.7725C12.1125 16.1195 13.5418 17.5421 13.8904 18.93L14.6573 22.0007C15.006 23.3886 15.5811 23.3886 15.9298 22.0007L16.6967 18.93C17.0453 17.5421 18.4746 16.1195 19.8691 15.7725L22.9541 15.0093Z"
    ]
  },
  school: {
    paths: [
      "M12 21L5 17.2V11.2L1 9L12 3L23 9V17H21V10.1L19 11.2V17.2L12 21ZM12 12.7L18.85 9L12 5.3L5.15 9L12 12.7ZM12 18.725L17 16.025V12.25L12 15L7 12.25V16.025L12 18.725Z"
    ]
  },
  database: {
    paths: [
      "M13.5655 3.46623V6.3536C13.1449 6.58797 12.5662 6.81584 11.8326 7.00138C10.7606 7.27482 9.43882 7.43758 8.00002 7.43758C6.56122 7.43758 5.23942 7.27482 4.16743 7.00138C3.4338 6.81584 2.85512 6.59123 2.43454 6.3536V3.46623L2.45352 3.44995C2.62111 3.30347 2.95631 3.10164 3.50337 2.89982C4.58168 2.50594 6.17227 2.22925 8.00002 2.22925C9.82777 2.22925 11.4184 2.50594 12.4967 2.89982C13.0437 3.10164 13.3758 3.30347 13.5465 3.44995L13.5655 3.46623ZM13.5655 8.07235V10.5203C13.1449 10.7546 12.5662 10.9825 11.8326 11.1681C10.7606 11.4415 9.43882 11.6042 8.00002 11.6042C6.56122 11.6042 5.23942 11.4415 4.16743 11.1681C3.4338 10.9825 2.85512 10.7579 2.43454 10.5203V8.07235C2.85512 8.24487 3.3168 8.39461 3.80378 8.51831C5.01174 8.8243 6.45687 9.00008 8.00002 9.00008C9.54318 9.00008 10.9883 8.8243 12.1963 8.51831C12.6832 8.39461 13.1449 8.24813 13.5655 8.07235ZM2.43454 14.5339V12.2423C2.85512 12.4148 3.3168 12.5645 3.80378 12.6882C5.01174 12.991 6.45687 13.1667 8.00002 13.1667C9.54318 13.1667 10.9883 12.991 12.1963 12.685C12.6832 12.5613 13.1449 12.4148 13.5655 12.239V14.5307L13.5465 14.547C13.3789 14.6934 13.0437 14.8953 12.4967 15.0971C11.4184 15.4942 9.82777 15.7709 8.00002 15.7709C6.17227 15.7709 4.58168 15.4942 3.50337 15.1003C2.95631 14.8985 2.62428 14.6967 2.45352 14.5502L2.43454 14.5339ZM13.6319 14.4656C13.6319 14.4656 13.6319 14.4688 13.6256 14.4721L13.6287 14.4656C13.6287 14.4656 13.6287 14.4656 13.6287 14.4623L13.6319 14.4656ZM2.3713 14.4656C2.3713 14.4656 2.3713 14.4688 2.37762 14.4721C2.37446 14.4688 2.37446 14.4656 2.3713 14.4656ZM13.6287 3.52808C13.6319 3.53133 13.6351 3.53459 13.6351 3.53459C13.6351 3.53459 13.6351 3.53133 13.6287 3.52808ZM15.0834 14.7292V3.27092C15.0834 1.83211 11.9117 0.666748 8.00002 0.666748C4.08838 0.666748 0.916687 1.83211 0.916687 3.27092V14.7292C0.916687 16.1681 4.08838 17.3334 8.00002 17.3334C11.9117 17.3334 15.0834 16.1681 15.0834 14.7292Z"
    ],
    viewBox: "0 0 16 18"
  },
  "database-filled": {
    paths: [
      "M15.5416 3.27092V4.83342C15.5416 6.27222 12.2767 7.43758 8.24998 7.43758C4.22329 7.43758 0.958313 6.27222 0.958313 4.83342V3.27092C0.958313 1.83211 4.22329 0.666748 8.24998 0.666748C12.2767 0.666748 15.5416 1.83211 15.5416 3.27092ZM13.7578 7.65568C14.4349 7.4148 15.0566 7.10555 15.5416 6.72469V10.0417C15.5416 11.4806 12.2767 12.6459 8.24998 12.6459C4.22329 12.6459 0.958313 11.4806 0.958313 10.0417V6.72469C1.44334 7.10881 2.06508 7.4148 2.74217 7.65568C4.20376 8.17651 6.15037 8.47925 8.24998 8.47925C10.3496 8.47925 12.2962 8.17651 13.7578 7.65568ZM0.958313 11.933C1.44334 12.3171 2.06508 12.6231 2.74217 12.864C4.20376 13.3848 6.15037 13.6876 8.24998 13.6876C10.3496 13.6876 12.2962 13.3848 13.7578 12.864C14.4349 12.6231 15.0566 12.3139 15.5416 11.933V14.7292C15.5416 16.1681 12.2767 17.3334 8.24998 17.3334C4.22329 17.3334 0.958313 16.1681 0.958313 14.7292V11.933Z"
    ],
    viewBox: "0 0 16 18"
  },
  "file-xml": {
    paths: [
      "M4.5 20.125H6.375V22H4.5C3.12109 22 2 20.8789 2 19.5V4.5C2 3.12109 3.12109 2 4.5 2H10.9648C11.6289 2 12.2656 2.26172 12.7344 2.73047L16.2695 6.26562C16.7383 6.73437 17 7.37109 17 8.03516V13.875H15.125V8.25H12C11.3086 8.25 10.75 7.69141 10.75 7V3.875H4.5C4.15625 3.875 3.875 4.15625 3.875 4.5V19.5C3.875 19.8438 4.15625 20.125 4.5 20.125ZM9.5 16.375C9.5 16.6602 9.58594 16.9375 9.74219 17.1719L10.125 17.7461L10.5078 17.1719C10.6641 16.9336 10.75 16.6562 10.75 16.375C10.75 16.0312 11.0312 15.75 11.375 15.75C11.7188 15.75 12 16.0312 12 16.375C12 16.9063 11.8437 17.4258 11.5469 17.8672L10.875 18.875L11.5469 19.8828C11.8437 20.3242 12 20.8437 12 21.375C12 21.7188 11.7188 22 11.375 22C11.0312 22 10.75 21.7188 10.75 21.375C10.75 21.0898 10.6641 20.8125 10.5078 20.5781L10.125 20L9.74219 20.5742C9.58594 20.8125 9.5 21.0898 9.5 21.3711C9.5 21.7148 9.21875 21.9961 8.875 21.9961C8.53125 21.9961 8.25 21.7148 8.25 21.3711C8.25 20.8398 8.40625 20.3203 8.70313 19.8789L9.375 18.875L8.70313 17.8672C8.40625 17.4258 8.25 16.9063 8.25 16.375C8.25 16.0312 8.53125 15.75 8.875 15.75C9.21875 15.75 9.5 16.0312 9.5 16.375ZM19.5 21.375V16.375C19.5 16.0312 19.7812 15.75 20.125 15.75C20.4688 15.75 20.75 16.0312 20.75 16.375V20.75H21.375C21.7188 20.75 22 21.0312 22 21.375C22 21.7188 21.7188 22 21.375 22H20.125C19.7812 22 19.5 21.7188 19.5 21.375ZM13.707 15.7734C13.9766 15.6992 14.2656 15.8125 14.4102 16.0547L15.75 18.2852L17.0898 16.0547C17.2344 15.8125 17.5234 15.6992 17.793 15.7734C18.0625 15.8477 18.25 16.0938 18.25 16.375V21.375C18.25 21.7188 17.9688 22 17.625 22C17.2812 22 17 21.7188 17 21.375V18.6328L16.2852 19.8242C16.1719 20.0117 15.9687 20.1289 15.75 20.1289C15.5313 20.1289 15.3281 20.0156 15.2148 19.8242L14.5 18.6328V21.375C14.5 21.7188 14.2188 22 13.875 22C13.5312 22 13.25 21.7188 13.25 21.375V16.375C13.25 16.0938 13.4375 15.8477 13.707 15.7734Z"
    ]
  },
  "property-inspection": {
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808V8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ]
  },
  "public-record": {
    paths: [
      "M6.5 10H4.5V17H6.5V10ZM12.5 10H10.5V17H12.5V10ZM21 19H2V21H21V19ZM18.5 10H16.5V17H18.5V10ZM11.5 3.26L16.71 6H6.29L11.5 3.26ZM11.5 1L2 6V8H21V6L11.5 1Z"
    ]
  },
  "user-input": {
    paths: [
      "M15 23L15.5 20.5L19.5734 16.4266L21.5734 18.4266L17.5 22.5L15 23ZM21.9266 18.0734L19.9266 16.0734L21 15L23 17L21.9266 18.0734Z",
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9467 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
    ]
  },
  people: {
    paths: [
      "M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645C16.4732 13.4021 17 14.6739 17 16V22H15V16C15 15.2348 14.7077 14.4985 14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14ZM18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22H20V17.5C20 17.1271 19.8611 16.7676 19.6104 16.4916C19.3597 16.2156 19.0152 16.0428 18.644 16.007L18.5 16C18.325 16 18.157 16.03 18 16.085V16C18 15.334 17.892 14.694 17.691 14.096C17.95 14.033 18.221 14 18.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8ZM18.5 8C19.163 8 19.7989 8.26339 20.2678 8.73223C20.7366 9.20107 21 9.83696 21 10.5C21 11.163 20.7366 11.7989 20.2678 12.2678C19.7989 12.7366 19.163 13 18.5 13C17.837 13 17.2011 12.7366 16.7322 12.2678C16.2634 11.7989 16 11.163 16 10.5C16 9.83696 16.2634 9.20107 16.7322 8.73223C17.2011 8.26339 17.837 8 18.5 8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM18.5 10C18.3674 10 18.2402 10.0527 18.1464 10.1464C18.0527 10.2402 18 10.3674 18 10.5C18 10.6326 18.0527 10.7598 18.1464 10.8536C18.2402 10.9473 18.3674 11 18.5 11C18.6326 11 18.7598 10.9473 18.8536 10.8536C18.9473 10.7598 19 10.6326 19 10.5C19 10.3674 18.9473 10.2402 18.8536 10.1464C18.7598 10.0527 18.6326 10 18.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4Z"
    ]
  },
  signature: {
    viewBox: "0 0 16 16",
    paths: [
      "M3.33333 12.6667H4.276L10.4853 6.45739L9.54267 5.51472L3.33333 11.7241V12.6667ZM14 14.0001H2V11.1714L10.9567 2.21472C11.0817 2.08974 11.2512 2.01953 11.428 2.01953C11.6048 2.01953 11.7743 2.08974 11.8993 2.21472L13.7853 4.10072C13.9103 4.22574 13.9805 4.39528 13.9805 4.57206C13.9805 4.74883 13.9103 4.91837 13.7853 5.04339L6.162 12.6667H14V14.0001ZM10.4853 4.57206L11.428 5.51472L12.3707 4.57206L11.428 3.62939L10.4853 4.57206Z"
    ]
  },
  "signature-draw": {
    viewBox: "0 0 640 640",
    paths: [
      "M192 192C192 174.3 206.3 160 224 160C241.7 160 256 174.3 256 192L256 199.8C256 227.5 253.6 255.1 248.9 282.3L164.5 307.6C123.9 319.8 96.1 357.2 96.1 399.6L96.1 432L24.1 432C10.8 432 .1 442.7 .1 456C.1 469.3 10.8 480 24.1 480L96.6 480C100.8 516 131.4 544 168.6 544C194.6 544 218.6 530.1 231.5 507.5L245.4 483.2C272.2 436.2 291.9 385.5 303.8 332.7L398.2 304.4L385.7 341.9C382.4 351.7 384.1 362.4 390.1 370.7C396.1 379 405.7 384 416 384L544 384C561.7 384 576 369.7 576 352C576 334.3 561.7 320 544 320L460.4 320L478.4 266.1C482.2 254.8 479.3 242.3 471 233.7C462.7 225.1 450.3 221.9 438.8 225.3L316.4 262.1C318.8 241.4 320 220.7 320 199.8L320 192C320 139 277 96 224 96C171 96 128 139 128 192L128 224C128 241.7 142.3 256 160 256C177.7 256 192 241.7 192 224L192 192zM182.8 369L231.8 354.3C221.4 388.1 207.3 420.7 189.7 451.5L175.8 475.8C174.3 478.4 171.5 480.1 168.4 480.1C163.7 480.1 159.9 476.3 159.9 471.6L159.9 399.7C159.9 385.6 169.2 373.1 182.7 369zM616 480C629.3 480 640 469.3 640 456C640 442.7 629.3 432 616 432L323.1 432C316.6 448.3 309.4 464.3 301.5 480L616 480"
    ]
  },
  comment: {
    viewBox: "0 0 24 24",
    paths: [
      "M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM20 5H4V18.385L5.763 17H20V5ZM10.515 7.412L10.962 8.1C9.294 9.003 9.323 10.452 9.323 10.764C9.478 10.744 9.641 10.74 9.803 10.755C10.705 10.839 11.416 11.58 11.416 12.5C11.416 13.466 10.632 14.25 9.666 14.25C9.129 14.25 8.616 14.005 8.292 13.66C7.777 13.114 7.5 12.5 7.5 11.505C7.5 9.755 8.728 8.187 10.515 7.412ZM15.515 7.412L15.962 8.1C14.294 9.003 14.323 10.452 14.323 10.764C14.478 10.744 14.641 10.74 14.803 10.755C15.705 10.839 16.416 11.58 16.416 12.5C16.416 13.466 15.632 14.25 14.666 14.25C14.129 14.25 13.616 14.005 13.292 13.66C12.777 13.114 12.5 12.5 12.5 11.505C12.5 9.755 13.728 8.187 15.515 7.412Z"
    ]
  },
  pdf: {
    viewBox: "0 0 24 24",
    paths: [
      "M5.45801 19.375V19.5C5.45801 20.1148 5.99198 20.625 6.66699 20.625H17.333C18.0092 20.625 18.542 20.1149 18.542 19.5V19.375H20.125V19.5C20.125 20.9554 18.8652 22.125 17.333 22.125H6.66699C5.1327 22.125 3.875 20.9554 3.875 19.5V19.375H5.45801ZM7.66699 11.875C9.01566 11.8752 10.125 12.9041 10.125 14.1875C10.125 15.4709 9.01566 16.4998 7.66699 16.5H7.45801V17.625C7.45801 18.045 7.09671 18.3748 6.66699 18.375C6.23714 18.375 5.875 18.0451 5.875 17.625V12.625C5.875 12.2049 6.23714 11.875 6.66699 11.875H7.66699ZM12.333 11.875C13.4985 11.875 14.458 12.7633 14.458 13.875V16.375C14.458 17.4867 13.4985 18.375 12.333 18.375H11.333C10.9052 18.3748 10.542 18.0452 10.542 17.625V12.625C10.542 12.2048 10.9052 11.8752 11.333 11.875H12.333ZM18 11.875C18.428 11.875 18.792 12.2047 18.792 12.625C18.792 13.0453 18.428 13.375 18 13.375H16.792V14.375H18C18.428 14.375 18.792 14.7047 18.792 15.125C18.792 15.5453 18.428 15.875 18 15.875H16.792V17.625C16.792 18.0453 16.428 18.375 16 18.375C15.572 18.375 15.208 18.0453 15.208 17.625V12.625C15.208 12.2047 15.572 11.875 16 11.875H18ZM12.125 16.875H12.333C12.6384 16.875 12.875 16.6422 12.875 16.375V13.875C12.875 13.6078 12.6384 13.375 12.333 13.375H12.125V16.875ZM7.45801 15H7.66699C8.15969 14.9998 8.54199 14.6304 8.54199 14.1875C8.54199 13.7446 8.15969 13.3752 7.66699 13.375H7.45801V15ZM13.1709 1.875C13.7304 1.87502 14.2738 2.08378 14.6729 2.45801L19.498 6.9834C19.8971 7.35762 20.125 7.87042 20.125 8.40234V10.875H18.542V9.625H14C12.8345 9.625 11.875 8.73667 11.875 7.625V3.375H6.66699C5.99206 3.375 5.45801 3.88628 5.45801 4.5V10.875H3.875V4.5C3.875 3.04263 5.13276 1.875 6.66699 1.875H13.1709ZM13.458 7.625C13.458 7.89224 13.6946 8.125 14 8.125H18.4502C18.4318 8.09951 18.4115 8.07493 18.3877 8.05371L18.3857 8.05176L13.5566 3.52441L13.5547 3.52246C13.5264 3.49504 13.4935 3.47163 13.458 3.45117V7.625Z"
    ]
  },
  inspectifyReport: {
    viewBox: "0 0 24 24",
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ]
  },
  "quality-tiers": {
    viewBox: "0 0 16 16",
    paths: [
      "M9.57655 8.00783C10.2025 8.07293 10.6914 8.60414 10.6914 9.25253V10.5024H12.7609L12.8876 10.5076C13.5136 10.5727 14.0025 11.104 14.0025 11.7523V13.4189L13.9973 13.5465C13.9378 14.135 13.4722 14.6037 12.8902 14.661L12.7634 14.6662H3.24415C2.55866 14.6662 2.0025 14.1063 2.0025 13.4163V10.9165C2.0025 10.2264 2.55866 9.66656 3.24415 9.66656H5.72744V9.24992C5.72744 8.60153 6.21634 8.07032 6.84234 8.00522L6.96909 8.00002H9.45238L9.57914 8.00522L9.57655 8.00783ZM3.24156 13.4163H5.72486V10.9165H3.24156V13.4163ZM6.9665 13.4163H9.4498V9.24992H6.9665V13.4163ZM10.6914 13.4163H12.7609V11.7497H10.6914V13.4163ZM7.9443 1.4979C8.05553 1.27395 8.37112 1.28177 8.472 1.4979L9.08248 2.73999L10.4354 2.93789C10.6759 2.97435 10.7768 3.2738 10.6009 3.45348L9.62052 4.40914L9.85075 5.76581C9.88696 6.00798 9.63604 6.19546 9.41617 6.08349L8.21332 5.44812L7.00013 6.09391C6.77767 6.20588 6.52675 6.01839 6.56555 5.77622L6.79578 4.41955L5.81539 3.45608C5.63949 3.27901 5.74038 2.97956 5.98095 2.9405L7.33382 2.74259L7.9443 1.5005V1.4979Z"
    ]
  }
}, WX = {
  sm: 10,
  md: 16,
  lg: 24,
  xl: 48,
  xxl: 64
};
const Fr = Fe(
  ({ color: e, icon: t, size: n = "md", variant: r = "default", __styleDoNotUse: o, __testId: i }, a) => {
    const { paths: u, viewBox: c = "0 0 24 24" } = zX[t], d = WX[n], p = {
      fill: e ? _r[e] : "currentColor",
      ...o || {}
    }, g = u.map((m, b) => /* @__PURE__ */ x.jsx("path", { d: m }, b));
    return /* @__PURE__ */ x.jsx(
      "svg",
      {
        ref: a,
        className: Qn("icon", r === "outlined" && r),
        "data-testid": i || t,
        width: d,
        height: d,
        viewBox: c,
        xmlns: "http://www.w3.org/2000/svg",
        style: p,
        fillRule: $X(t),
        children: g
      }
    );
  }
);
Fr.displayName = "Icon";
const pb = ({ size: e = 20 }) => /* @__PURE__ */ x.jsxs(
  "div",
  {
    className: "small-roller",
    style: { height: e, width: e, transform: `scale(${e / 80})` },
    children: [
      /* @__PURE__ */ x.jsx("div", {}),
      /* @__PURE__ */ x.jsx("div", {}),
      /* @__PURE__ */ x.jsx("div", {}),
      /* @__PURE__ */ x.jsx("div", {}),
      /* @__PURE__ */ x.jsx("div", {}),
      /* @__PURE__ */ x.jsx("div", {})
    ]
  }
), GX = (e, t) => e === "nav" ? "arrow-left" : t, df = Fe(
  ({
    variant: e = "primary",
    icon: t,
    disabled: n,
    onClick: r,
    onMouseDown: o,
    size: i,
    __dangerDoNotUseSx: a,
    __testId: u,
    title: c,
    text: d,
    isLoading: f,
    "data-trace-name": p,
    fullWidth: g,
    rightIcon: m,
    type: b = "button",
    tabIndex: v,
    marginLeft: y,
    marginRight: w,
    id: I,
    badge: V
  }, M) => {
    const L = GX(e, t);
    return (
      // eslint-disable-next-line aloft/prefer-sound-ui-button
      /* @__PURE__ */ x.jsxs(
        "button",
        {
          ref: M,
          id: I,
          "data-testid": u ?? I,
          "data-trace-name": p,
          className: Qn("button", e, i, (n || f) && "disabled"),
          style: {
            ...a,
            width: g ? "100%" : void 0,
            marginLeft: y,
            marginRight: w,
            position: f ? "relative" : a == null ? void 0 : a.position
          },
          title: c,
          onClick: r,
          onMouseDown: (R) => {
            R.preventDefault(), o == null || o(R);
          },
          disabled: n || f,
          type: b,
          tabIndex: v,
          children: [
            /* @__PURE__ */ x.jsxs("div", { className: Qn("contents", f && "loading"), children: [
              L && /* @__PURE__ */ x.jsx(Fr, { icon: L, size: i }),
              d,
              m && /* @__PURE__ */ x.jsx(Fr, { icon: m, size: i }),
              V && /* @__PURE__ */ x.jsx(hb, { ...V })
            ] }),
            f && /* @__PURE__ */ x.jsx("div", { className: "loader", children: /* @__PURE__ */ x.jsx(
              pb,
              {
                size: i === "sm" || e === "inline" || e === "inlineSecondary" ? 20 : 30
              }
            ) })
          ]
        }
      )
    );
  }
), H2 = Fe(
  ({ children: e, ...t }, n) => /* @__PURE__ */ x.jsx(t4, { ref: n, ...t, children: /* @__PURE__ */ x.jsx(Jo, { children: e }) })
);
const jX = ({
  variant: e,
  inline: t,
  children: n,
  ...r
}) => {
  if (t)
    return /* @__PURE__ */ x.jsx("span", { ...r, children: n });
  switch (e) {
    case "h1":
    case "displaySmall":
    case "displayMedium":
    case "displayLarge":
      return /* @__PURE__ */ x.jsx("h1", { ...r, children: n });
    case "h2":
      return /* @__PURE__ */ x.jsx("h2", { ...r, children: n });
    case "h3":
      return /* @__PURE__ */ x.jsx("h3", { ...r, children: n });
    case "h4":
      return /* @__PURE__ */ x.jsx("h4", { ...r, children: n });
    case "h5":
      return /* @__PURE__ */ x.jsx("h5", { ...r, children: n });
    default:
      return /* @__PURE__ */ x.jsx("p", { ...r, children: n });
  }
}, Or = ({
  children: e,
  color: t,
  variant: n = "body1",
  __dangerDoNotUseSx: r,
  truncate: o = !1,
  casing: i,
  id: a,
  textAlign: u,
  inline: c,
  title: d,
  __testId: f
}) => /* @__PURE__ */ x.jsx(
  jX,
  {
    id: a,
    variant: n,
    inline: c,
    className: Qn("typography", n),
    title: d,
    "data-testid": f,
    style: {
      color: t ? _r[t] : void 0,
      textAlign: u,
      textOverflow: o ? "ellipsis" : void 0,
      overflow: o ? "hidden" : void 0,
      textTransform: i,
      ...r
    },
    children: e
  }
), Qc = Fe(
  ({
    id: e,
    variant: t = "primary",
    ariaLabel: n,
    icon: r,
    disabled: o,
    onClick: i,
    onMouseDown: a,
    size: u = "md",
    __dangerDoNotUseSx: c,
    __testId: d,
    title: f,
    iconSize: p = "md",
    isLoading: g,
    iconColor: m,
    tabIndex: b,
    isRound: v,
    text: y,
    textColor: w
  }, I) => {
    let V = 30;
    return u === "xs" ? V = 16 : u === "sm" && (V = 20), // eslint-disable-next-line aloft/prefer-sound-ui-button
    /* @__PURE__ */ x.jsx(
      "button",
      {
        ref: I,
        className: Qn(
          "button",
          "icon-button",
          t,
          u,
          (o || g) && "disabled",
          v && "round",
          y && "text"
        ),
        id: e,
        tabIndex: b,
        "aria-label": n,
        "data-testid": d ?? e,
        title: f ?? n,
        onClick: i,
        onMouseDown: a,
        disabled: o,
        type: "button",
        style: c,
        children: g ? /* @__PURE__ */ x.jsx("div", { className: "loader", children: /* @__PURE__ */ x.jsx(pb, { size: V }) }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(Fr, { icon: r, size: p, color: m }),
          y && /* @__PURE__ */ x.jsx(Or, { variant: "buttonSmall", color: w, children: y })
        ] })
      }
    );
  }
);
Qc.displayName = "IconButton";
const XX = Fe(
  ({ size: e = "xs", value: t }, n) => {
    if (!t)
      return null;
    const [r, o] = Ee("Copy to clipboard"), i = (a) => {
      a.stopPropagation(), a.preventDefault(), navigator.clipboard.writeText(t), o("Copied!"), setTimeout(() => {
        o("Copy to clipboard");
      }, 2e3);
    };
    return /* @__PURE__ */ x.jsx(H2, { openDelay: 500, label: r, children: /* @__PURE__ */ x.jsx(
      Qc,
      {
        ref: n,
        ariaLabel: "Copy to clipboard",
        icon: "file-copy",
        size: e,
        variant: "tertiary",
        onClick: i
      }
    ) });
  }
);
XX.displayName = "CopyButton";
const Gee = (e) => {
  switch (e) {
    case "xs":
    case "sm":
      return "sm";
    case "md":
      return "md";
    case "lg":
      return "lg";
    default:
      return Pf(e);
  }
}, UX = Fe(
  ({ isChecked: e, onChange: t, isDisabled: n, isIndeterminate: r, children: o }, i) => /* @__PURE__ */ x.jsx(
    S3,
    {
      ref: i,
      isChecked: e,
      onChange: t,
      isDisabled: n,
      isIndeterminate: r,
      children: o
    }
  )
);
UX.displayName = "Checkbox";
function YX(e = {}) {
  const {
    strict: t = !0,
    errorMessage: n = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: r
  } = e, o = Nr(void 0);
  o.displayName = r;
  function i() {
    var a;
    const u = tn(o);
    if (!u && t) {
      const c = new Error(n);
      throw c.name = "ContextError", (a = Error.captureStackTrace) == null || a.call(Error, c, i), c;
    }
    return u;
  }
  return [
    o.Provider,
    i,
    o
  ];
}
const JX = (e, t) => {
  const n = Le(null);
  return Ue(() => {
    const r = (o) => {
      n != null && n.current && o.target && !n.current.contains(o.target) && (t == null || t(), n.current.blur());
    };
    return document.addEventListener("mouseup", r), () => {
      document.removeEventListener("mouseup", r);
    };
  }, [n.current]), q(
    (r) => {
      typeof e == "function" ? e(r) : e !== null && (e.current = r), n.current = r;
    },
    [n, e]
  );
}, qX = (e) => {
  if (Un(e.paddingX) && Un(e.paddingY) && Un(e.paddingX) && Un(e.paddingY))
    return e;
  const t = { ...e };
  return qe(t.paddingX) && (t.paddingLeft = t.paddingLeft ?? t.paddingX, t.paddingRight = t.paddingRight ?? t.paddingX), qe(t.paddingY) && (t.paddingTop = t.paddingTop ?? t.paddingY, t.paddingBottom = t.paddingBottom ?? t.paddingY), qe(t.marginX) && (t.marginLeft = t.marginLeft ?? t.marginX, t.marginRight = t.marginRight ?? t.marginX), qe(t.marginY) && (t.marginTop = t.marginTop ?? t.marginY, t.marginBottom = t.marginBottom ?? t.marginY), t;
}, KX = 4, gb = (e) => `${e * KX}px`, QX = {
  borderRadius: !0,
  borderTopRadius: !0,
  borderBottomRadius: !0,
  borderLeftRadius: !0,
  borderRightRadius: !0,
  borderTopLeftRadius: !0,
  borderTopRightRadius: !0,
  borderBottomLeftRadius: !0,
  borderBottomRightRadius: !0,
  borderWidth: !0,
  borderTopWidth: !0,
  borderBottomWidth: !0,
  borderLeftWidth: !0,
  borderRightWidth: !0,
  bottom: !0,
  columnGap: !0,
  gap: !0,
  height: !0,
  left: !0,
  margin: !0,
  marginTop: !0,
  marginBottom: !0,
  marginLeft: !0,
  marginRight: !0,
  maxWidth: !0,
  maxHeight: !0,
  minHeight: !0,
  minWidth: !0,
  padding: !0,
  paddingY: !0,
  paddingX: !0,
  paddingTop: !0,
  paddingBottom: !0,
  paddingLeft: !0,
  paddingRight: !0,
  right: !0,
  rowGap: !0,
  top: !0,
  width: !0
}, eU = (e) => Object.entries(e).reduce((t, [n, r]) => (QX.hasOwnProperty(n) && typeof r == "number" ? t[n] = gb(r) : t[n] = r, t), {}), Qi = (e) => _r[e], tU = (e) => {
  const [t, n, r] = qe(e.border) ? e.border.split(" ") : [], o = parseInt(t, 10), i = Number.isNaN(parseInt(t, 10)) || o.toString() !== t ? t : gb(o), a = Qi(r || "none"), u = qe(r) ? a : void 0;
  if (Un(e.border) && Un(e.borderColor) && Un(e.borderTopColor) && Un(e.borderBottomColor) && Un(e.borderLeftColor) && Un(e.borderRightColor))
    return e;
  const c = [i, n, u].filter(
    (L) => qe(L)
  ), d = c.length > 0 ? c.join(" ") : void 0, f = Qi(e.borderColor || "none"), p = Qi(e.borderTopColor || "none"), g = Qi(e.borderBottomColor || "none"), m = Qi(e.borderLeftColor || "none"), b = Qi(e.borderRightColor || "none"), v = e.borderColor ? f : void 0, y = e.borderTopColor ? p : void 0, w = e.borderBottomColor ? g : void 0, I = e.borderLeftColor ? m : void 0, V = e.borderRightColor ? b : void 0, M = { ...e };
  return qe(d) && (M.border = d), qe(v) && (M.borderColor = v), qe(y) && (M.borderTopColor = y), qe(w) && (M.borderBottomColor = w), qe(I) && (M.borderLeftColor = I), qe(V) && (M.borderRightColor = V), M;
}, ch = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"], nU = (e) => `${ch[Math.floor(Math.round(255 * e) / 16)]}${ch[Math.round(Math.round(255 * e) % 16)]}`, rU = (e) => {
  const t = Qi(e.backgroundColor || "none");
  if (Un(e.backgroundColor))
    return e;
  const n = qe(e.backgroundOpacity) ? `${t}${nU(e.backgroundOpacity)}` : t;
  return { ...e, backgroundColor: n };
}, oU = (e) => {
  const t = qX(e), n = eU(t), r = tU(n), o = rU(r), i = Object.fromEntries(
    Object.entries(e).filter(([u]) => u.match(/^data-/))
  );
  return { adjustedProps: Object.fromEntries(
    Object.entries(o).filter(([u]) => !u.match(/^data-/))
  ), dataProps: i };
};
function iU(e) {
  return e.colSpan !== void 0 || e.rowSpan !== void 0;
}
const dh = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("div", { ...e, ref: t })
), sU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("li", { ...e, ref: t })
), aU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("ul", { ...e, ref: t })
), lU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("td", { ...e, ref: t })
), uU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("th", { ...e, ref: t })
), cU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("tr", { ...e, ref: t })
), dU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("tbody", { ...e, ref: t })
), fU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("thead", { ...e, ref: t })
), hU = Fe(
  (e, t) => /* @__PURE__ */ x.jsx("table", { ...e, ref: t })
), pU = (e) => {
  switch (e) {
    case "div":
      return dh;
    case "li":
      return sU;
    case "ul":
      return aU;
    case "td":
      return lU;
    case "th":
      return uU;
    case "tr":
      return cU;
    case "tbody":
      return dU;
    case "thead":
      return fU;
    case "table":
      return hU;
    default:
      return dh;
  }
}, Qo = Fe(
  ({
    id: e,
    __testId: t,
    children: n,
    className: r,
    onClick: o,
    onPress: i,
    onBlur: a,
    onFocus: u,
    onMouseDown: c,
    onMouseEnter: d,
    onMouseLeave: f,
    onClickOutside: p,
    onDragEnter: g,
    onDragLeave: m,
    onDragOver: b,
    onDrop: v,
    onKeyDown: y,
    onKeyUp: w,
    tabIndex: I,
    role: V,
    __dangerDoNotUseSx: M,
    ...L
  }, R) => {
    const { adjustedProps: _, dataProps: H } = oU(L), B = JX(R, p), Z = pU(V), G = iU(L) && qe(V) && ["td", "th"].includes(V) ? { colSpan: L.colSpan, rowSpan: L.rowSpan } : {};
    return (
      // @ts-expect-error all of these things have children, hush
      /* @__PURE__ */ x.jsx(
        Z,
        {
          id: e,
          className: r,
          tabIndex: I,
          ref: B,
          role: i && !V ? "button" : void 0,
          onBlur: (se) => {
            a && !se.currentTarget.contains(se.relatedTarget) && a(se);
          },
          onFocus: u,
          onMouseDown: c,
          onMouseEnter: d,
          onMouseLeave: f,
          onDragEnter: g,
          onDragLeave: m,
          onDragOver: b,
          onDrop: v,
          onKeyDown: y,
          style: {
            ..._,
            ...M
          },
          "data-testid": t ?? e,
          onClick: o ?? i,
          onKeyUp: i && ((se) => {
            (se.key === " " || se.code === "Space" || se.key === "Enter" || se.code === "Enter") && i(se);
          }),
          ...G,
          ...H,
          children: n
        }
      )
    );
  }
), vs = Fe((e, t) => /* @__PURE__ */ x.jsx(Qo, { ref: t, ...e, display: "flex" })), [gU, F2] = YX({
  name: "form-size-context",
  strict: !0,
  errorMessage: "missing form size context. see SUI withFormWrapper."
}), Za = (e, t) => {
  const {
    id: n,
    infoText: r,
    helperText: o,
    errorText: i,
    internalFormWrapperErrorText: a,
    isDisabled: u,
    isReadonly: c,
    isRequired: d,
    isInvalid: f,
    label: p,
    size: g = "md",
    fullWidth: m = !0
  } = e;
  return /* @__PURE__ */ x.jsx(
    hC,
    {
      isDisabled: u,
      isReadOnly: c,
      isRequired: d,
      isInvalid: f || !!a,
      size: g,
      width: m ? "100%" : "initial",
      children: /* @__PURE__ */ x.jsxs(gU, { value: g, children: [
        p && /* @__PURE__ */ x.jsx(av, { htmlFor: n, size: g, children: /* @__PURE__ */ x.jsxs("div", { style: { display: "inline-flex", alignItems: "center", gap: "0.5rem" }, children: [
          p,
          r && /* @__PURE__ */ x.jsx(H2, { label: r, placement: "auto", hasArrow: !0, children: /* @__PURE__ */ x.jsx(vs, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ x.jsx(Fr, { icon: "information" }) }) })
        ] }) }),
        t,
        o && /* @__PURE__ */ x.jsx(pC, { children: o }),
        (f && i || !!a) && /* @__PURE__ */ x.jsx(sv, { color: "textError", children: i ?? a })
      ] })
    }
  );
}, mU = (e, t) => {
  if (e)
    return "boxed";
  if (t)
    return "__dangerDoNotUseCheckmarks";
}, CU = ({
  __dangerDoNotUseSx: e,
  __testId: t,
  id: n,
  checked: r,
  label: o,
  multiselect: i,
  onChange: a,
  size: u = "lg",
  value: c,
  forceCheckboxes: d,
  __dangerDoNotUseCheckmarks: f,
  tooltip: p,
  textVariant: g = "h4"
}) => {
  const m = (y) => {
    a && a(c, y.target.checked);
  }, b = i || d ? S3 : Qv, v = /* @__PURE__ */ x.jsx(
    b,
    {
      id: n,
      "data-testid": t,
      isChecked: r,
      onChange: m,
      size: u,
      sx: e,
      value: i ? void 0 : c,
      variant: mU(d, f),
      children: /* @__PURE__ */ x.jsx(Or, { variant: g, children: o })
    }
  );
  return p ? /* @__PURE__ */ x.jsx(t4, { label: p.content, ...p.props, children: v }) : v;
}, vU = (e, t) => {
  const n = e.reduce((r, { value: o }) => (r[o] = !1, r), {});
  return t == null || t.forEach((r) => {
    n[r] = !0;
  }), n;
}, mb = ({
  __testId: e,
  items: t,
  multiselect: n,
  name: r,
  onChange: o,
  size: i,
  value: a,
  isDisabled: u,
  forceCheckboxes: c,
  forceHorizontal: d,
  title: f,
  columnGap: p = "0.5rem",
  gap: g,
  __dangerDoNotUseCheckmarks: m,
  textVariant: b
}) => {
  const v = (M) => {
    o && !n && o(M);
  }, y = (M, L) => {
    if (o && n) {
      const R = [...a || []], _ = R.includes(M);
      !_ && L ? R.push(M) : _ && !L && R.splice(R.indexOf(M), 1), o(R);
    } else
      o && c && v(M);
  }, w = n ? vU(t, a) : {}, I = t.map(
    ({ value: M, id: L, label: R, __testId: _, tooltip: H }) => /* @__PURE__ */ x.jsx(
      CU,
      {
        __testId: _,
        id: L,
        label: R,
        multiselect: n,
        onChange: y,
        size: i,
        value: M,
        checked: c ? a === M : w[M],
        forceCheckboxes: c,
        tooltip: H,
        __dangerDoNotUseCheckmarks: m,
        textVariant: b
      },
      M
    )
  );
  if (n)
    return /* @__PURE__ */ x.jsx(CC, { isDisabled: u, children: /* @__PURE__ */ x.jsx("div", { "data-testid": e, style: { display: "flex", flexDirection: "column", gap: g, columnGap: p }, children: I }) });
  const V = d || c && t.length < 3 ? "row" : "column";
  return /* @__PURE__ */ x.jsx(
    qv,
    {
      isDisabled: u,
      "data-testid": e,
      value: a,
      onChange: v,
      name: r,
      title: f,
      children: /* @__PURE__ */ x.jsx("div", { style: { display: "flex", gap: g, columnGap: p, flexDirection: V }, children: I })
    }
  );
}, bU = ({
  __testId: e,
  items: t,
  onChange: n,
  size: r,
  value: o,
  forceHorizontal: i,
  title: a,
  columnGap: u,
  gap: c,
  textVariant: d,
  ...f
}) => /* @__PURE__ */ x.jsx(
  mb,
  {
    __testId: e,
    items: t,
    onChange: n,
    size: r,
    value: o,
    multiselect: !0,
    forceHorizontal: i,
    title: a,
    columnGap: u,
    gap: c,
    textVariant: d,
    ...f
  }
), jee = Fe(
  (e, t) => Za(e, /* @__PURE__ */ x.jsx(bU, { ...e }))
), Xee = ({ tooltipContent: e, color: t = "textLight" }) => /* @__PURE__ */ x.jsx(H2, { label: e, children: /* @__PURE__ */ x.jsx(vs, { cursor: "help", alignItems: "center", children: /* @__PURE__ */ x.jsx(Fr, { icon: "information", color: t }) }) }), yU = ({
  __testId: e,
  items: t,
  onChange: n,
  name: r,
  size: o = "lg",
  value: i,
  forceCheckboxes: a,
  forceHorizontal: u,
  title: c,
  columnGap: d,
  gap: f,
  __dangerDoNotUseCheckmarks: p,
  textVariant: g
}) => /* @__PURE__ */ x.jsx(
  mb,
  {
    __testId: e,
    value: i,
    items: t,
    name: r,
    onChange: n,
    size: o,
    multiselect: !1,
    forceCheckboxes: a,
    forceHorizontal: u,
    title: c,
    columnGap: d,
    gap: f,
    __dangerDoNotUseCheckmarks: p,
    textVariant: g
  }
), Uee = Fe(
  (e, t) => Za(e, /* @__PURE__ */ x.jsx(yU, { ...e }))
), xU = Fe(
  ({
    href: e,
    children: t,
    isExternal: n = !1,
    variant: r = "default",
    __dangerDoNotUseSx: o,
    as: i,
    color: a
  }, u) => {
    const c = { color: a, textDecoration: "underline" };
    return n ? /* @__PURE__ */ x.jsx(
      Q5,
      {
        ref: u,
        href: e,
        isExternal: n,
        variant: r,
        sx: o,
        as: i,
        color: a,
        _hover: c,
        _active: c,
        _focus: c,
        children: t
      }
    ) : /* @__PURE__ */ x.jsx(
      Q5,
      {
        color: a,
        ref: u,
        as: i,
        to: e,
        variant: r,
        sx: o,
        _hover: c,
        _active: c,
        _focus: c,
        children: t
      }
    );
  }
);
xU.displayName = "Link";
const Yee = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "body1",
  "body2",
  "placeholder",
  "subtitle1",
  "subtitle2",
  "subtitle3",
  "link",
  "buttonSmall",
  "buttonRegular",
  "chip",
  "tableColumnTitle",
  "tableH1",
  "tableH2",
  "tableH3",
  "tableTag",
  "displayLarge",
  "displayMedium",
  "displaySmall",
  "label"
], SU = (e, t, n) => {
  const r = Le(!1);
  Ue(() => {
    var o;
    return e && !r.current && typeof t != "function" && ((o = (t || n).current) == null || o.focus(), r.current = !0), () => {
      r.current = !1;
    };
  }, [e, t]);
}, wU = [
  "price",
  "percent",
  "number",
  "aloftPrice",
  "aloftArea"
], IU = (e) => wU.includes(e), VU = (e, t) => {
  Ue(() => {
    if (IU(e) && typeof t == "object" && typeof t != "function") {
      const n = t == null ? void 0 : t.current, r = (o) => {
        document.activeElement === n && o.preventDefault();
      };
      return n == null || n.addEventListener("wheel", r), () => {
        n == null || n.removeEventListener("wheel", r);
      };
    }
  }, [t, e]);
}, AU = Fe((e, t) => /* @__PURE__ */ x.jsx(
  B2,
  {
    ...e,
    ref: t,
    type: "date",
    value: td.isAloftDate(e.value) ? e.value.toIsoString() : void 0,
    onChange: (n) => {
      try {
        e.onChange(td.fromIsoString(n));
      } catch {
        e.onClear();
      }
    },
    onClear: e.onClear,
    formatValue: (n) => Un(n) ? "" : e.formatValue ? e.formatValue(td.fromIsoString(n)) : n,
    setInternalFormWrapperErrorText: () => null
  }
)), LU = Fe((e, t) => {
  const n = (o) => {
    qe(o) ? e.onChange(nd.fromNumericPrice(o)) : e.onClear();
  }, r = (o) => qe(o) ? e.formatValue ? e.formatValue(nd.fromNumericPrice(o)) : `${o}` : "";
  return /* @__PURE__ */ x.jsx(
    B2,
    {
      ...e,
      ref: t,
      type: "price",
      onClear: e.onClear,
      onChange: n,
      value: nd.isAloftPrice(e.value) ? e.value.toNumericPrice() : void 0,
      formatValue: r,
      setInternalFormWrapperErrorText: () => null
    }
  );
});
var e2 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
e2.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", u = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", p = 1, g = 2, m = 4, b = 1, v = 2, y = 1, w = 2, I = 4, V = 8, M = 16, L = 32, R = 64, _ = 128, H = 256, B = 512, Z = 30, G = "...", se = 800, ue = 16, ce = 1, xe = 2, he = 3, z = 1 / 0, Y = 9007199254740991, ae = 17976931348623157e292, j = 0 / 0, X = 4294967295, ie = X - 1, W = X >>> 1, re = [
      ["ary", _],
      ["bind", y],
      ["bindKey", w],
      ["curry", V],
      ["curryRight", M],
      ["flip", B],
      ["partial", L],
      ["partialRight", R],
      ["rearg", H]
    ], te = "[object Arguments]", ee = "[object Array]", ge = "[object AsyncFunction]", pe = "[object Boolean]", Se = "[object Date]", de = "[object DOMException]", Ve = "[object Error]", K = "[object Function]", Ye = "[object GeneratorFunction]", ve = "[object Map]", ot = "[object Number]", Mt = "[object Null]", ft = "[object Object]", un = "[object Promise]", on = "[object Proxy]", Ct = "[object RegExp]", Pt = "[object Set]", jt = "[object String]", Xt = "[object Symbol]", tr = "[object Undefined]", An = "[object WeakMap]", $r = "[object WeakSet]", vn = "[object ArrayBuffer]", me = "[object DataView]", gt = "[object Float32Array]", zt = "[object Float64Array]", sn = "[object Int8Array]", Zn = "[object Int16Array]", zr = "[object Int32Array]", Hi = "[object Uint8Array]", Fi = "[object Uint8ClampedArray]", nr = "[object Uint16Array]", io = "[object Uint32Array]", za = /\b__p \+= '';/g, ti = /\b(__p \+=) '' \+/g, As = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mr = /&(?:amp|lt|gt|quot|#39);/g, Cr = /[&<>"']/g, ki = RegExp(mr.source), vr = RegExp(Cr.source), Wa = /<%-([\s\S]+?)%>/g, Ls = /<%([\s\S]+?)%>/g, Ms = /<%=([\s\S]+?)%>/g, Ps = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Es = /^\w*$/, rr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Bi = /[\\^$.*+?()[\]{}|]/g, Rs = RegExp(Bi.source), ni = /^\s+/, Ga = /\s/, ja = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, so = /\{\n\/\* \[wrapped with (.+)\] \*/, Xa = /,? & /, F = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, fe = /[()=,{}\[\]\/\s]/, we = /\\(\\)?/g, Ze = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, et = /\w*$/, vt = /^[-+]0x[0-9a-f]+$/i, lt = /^0b[01]+$/i, nt = /^\[object .+?Constructor\]$/, cn = /^0o[0-7]+$/i, Dt = /^(?:0|[1-9]\d*)$/, Nt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Kt = /($^)/, ao = /['\n\r\u2028\u2029\\]/g, xn = "\\ud800-\\udfff", an = "\\u0300-\\u036f", Di = "\\ufe20-\\ufe2f", ri = "\\u20d0-\\u20ff", Oi = an + Di + ri, Dl = "\\u2700-\\u27bf", Ol = "a-z\\xdf-\\xf6\\xf8-\\xff", z2 = "\\xac\\xb1\\xd7\\xf7", Nl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", W2 = "\\u2000-\\u206f", G2 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Zl = "A-Z\\xc0-\\xd6\\xd8-\\xde", $l = "\\ufe0e\\ufe0f", zl = z2 + Nl + W2 + G2, Ua = "['’]", j2 = "[" + xn + "]", Wl = "[" + zl + "]", _s = "[" + Oi + "]", Gl = "\\d+", Ts = "[" + Dl + "]", Hs = "[" + Ol + "]", jl = "[^" + xn + zl + Gl + Dl + Ol + Zl + "]", Ya = "\\ud83c[\\udffb-\\udfff]", Xl = "(?:" + _s + "|" + Ya + ")", Ul = "[^" + xn + "]", Ja = "(?:\\ud83c[\\udde6-\\uddff]){2}", qa = "[\\ud800-\\udbff][\\udc00-\\udfff]", wo = "[" + Zl + "]", Yl = "\\u200d", Jl = "(?:" + Hs + "|" + jl + ")", X2 = "(?:" + wo + "|" + jl + ")", Fs = "(?:" + Ua + "(?:d|ll|m|re|s|t|ve))?", ql = "(?:" + Ua + "(?:D|LL|M|RE|S|T|VE))?", Kl = Xl + "?", Ql = "[" + $l + "]?", ks = "(?:" + Yl + "(?:" + [Ul, Ja, qa].join("|") + ")" + Ql + Kl + ")*", Ka = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Qa = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Bs = Ql + Kl + ks, U2 = "(?:" + [Ts, Ja, qa].join("|") + ")" + Bs, eu = "(?:" + [Ul + _s + "?", _s, Ja, qa, j2].join("|") + ")", e1 = RegExp(Ua, "g"), tu = RegExp(_s, "g"), Wr = RegExp(Ya + "(?=" + Ya + ")|" + eu + Bs, "g"), Ni = RegExp([
      wo + "?" + Hs + "+" + Fs + "(?=" + [Wl, wo, "$"].join("|") + ")",
      X2 + "+" + ql + "(?=" + [Wl, wo + Jl, "$"].join("|") + ")",
      wo + "?" + Jl + "+" + Fs,
      wo + "+" + ql,
      Qa,
      Ka,
      Gl,
      U2
    ].join("|"), "g"), Y2 = RegExp("[" + Yl + xn + Oi + $l + "]"), nu = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, J2 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ru = -1, _t = {};
    _t[gt] = _t[zt] = _t[sn] = _t[Zn] = _t[zr] = _t[Hi] = _t[Fi] = _t[nr] = _t[io] = !0, _t[te] = _t[ee] = _t[vn] = _t[pe] = _t[me] = _t[Se] = _t[Ve] = _t[K] = _t[ve] = _t[ot] = _t[ft] = _t[Ct] = _t[Pt] = _t[jt] = _t[An] = !1;
    var Et = {};
    Et[te] = Et[ee] = Et[vn] = Et[me] = Et[pe] = Et[Se] = Et[gt] = Et[zt] = Et[sn] = Et[Zn] = Et[zr] = Et[ve] = Et[ot] = Et[ft] = Et[Ct] = Et[Pt] = Et[jt] = Et[Xt] = Et[Hi] = Et[Fi] = Et[nr] = Et[io] = !0, Et[Ve] = Et[K] = Et[An] = !1;
    var ou = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, q2 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, E = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, D = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, U = parseFloat, Ae = parseInt, ut = typeof ko == "object" && ko && ko.Object === Object && ko, At = typeof self == "object" && self && self.Object === Object && self, Qe = ut || At || Function("return this")(), it = t && !t.nodeType && t, mt = it && !0 && e && !e.nodeType && e, _n = mt && mt.exports === it, Sn = _n && ut.process, bn = function() {
      try {
        var N = mt && mt.require && mt.require("util").types;
        return N || Sn && Sn.binding && Sn.binding("util");
      } catch {
      }
    }(), Ds = bn && bn.isArrayBuffer, Os = bn && bn.isDate, t1 = bn && bn.isMap, S4 = bn && bn.isRegExp, w4 = bn && bn.isSet, I4 = bn && bn.isTypedArray;
    function or(N, Q, J) {
      switch (J.length) {
        case 0:
          return N.call(Q);
        case 1:
          return N.call(Q, J[0]);
        case 2:
          return N.call(Q, J[0], J[1]);
        case 3:
          return N.call(Q, J[0], J[1], J[2]);
      }
      return N.apply(Q, J);
    }
    function _y(N, Q, J, Me) {
      for (var Je = -1, bt = N == null ? 0 : N.length; ++Je < bt; ) {
        var dn = N[Je];
        Q(Me, dn, J(dn), N);
      }
      return Me;
    }
    function br(N, Q) {
      for (var J = -1, Me = N == null ? 0 : N.length; ++J < Me && Q(N[J], J, N) !== !1; )
        ;
      return N;
    }
    function Ty(N, Q) {
      for (var J = N == null ? 0 : N.length; J-- && Q(N[J], J, N) !== !1; )
        ;
      return N;
    }
    function V4(N, Q) {
      for (var J = -1, Me = N == null ? 0 : N.length; ++J < Me; )
        if (!Q(N[J], J, N))
          return !1;
      return !0;
    }
    function oi(N, Q) {
      for (var J = -1, Me = N == null ? 0 : N.length, Je = 0, bt = []; ++J < Me; ) {
        var dn = N[J];
        Q(dn, J, N) && (bt[Je++] = dn);
      }
      return bt;
    }
    function iu(N, Q) {
      var J = N == null ? 0 : N.length;
      return !!J && Ns(N, Q, 0) > -1;
    }
    function K2(N, Q, J) {
      for (var Me = -1, Je = N == null ? 0 : N.length; ++Me < Je; )
        if (J(Q, N[Me]))
          return !0;
      return !1;
    }
    function Zt(N, Q) {
      for (var J = -1, Me = N == null ? 0 : N.length, Je = Array(Me); ++J < Me; )
        Je[J] = Q(N[J], J, N);
      return Je;
    }
    function ii(N, Q) {
      for (var J = -1, Me = Q.length, Je = N.length; ++J < Me; )
        N[Je + J] = Q[J];
      return N;
    }
    function Q2(N, Q, J, Me) {
      var Je = -1, bt = N == null ? 0 : N.length;
      for (Me && bt && (J = N[++Je]); ++Je < bt; )
        J = Q(J, N[Je], Je, N);
      return J;
    }
    function Hy(N, Q, J, Me) {
      var Je = N == null ? 0 : N.length;
      for (Me && Je && (J = N[--Je]); Je--; )
        J = Q(J, N[Je], Je, N);
      return J;
    }
    function e0(N, Q) {
      for (var J = -1, Me = N == null ? 0 : N.length; ++J < Me; )
        if (Q(N[J], J, N))
          return !0;
      return !1;
    }
    var Fy = t0("length");
    function ky(N) {
      return N.split("");
    }
    function By(N) {
      return N.match(F) || [];
    }
    function A4(N, Q, J) {
      var Me;
      return J(N, function(Je, bt, dn) {
        if (Q(Je, bt, dn))
          return Me = bt, !1;
      }), Me;
    }
    function su(N, Q, J, Me) {
      for (var Je = N.length, bt = J + (Me ? 1 : -1); Me ? bt-- : ++bt < Je; )
        if (Q(N[bt], bt, N))
          return bt;
      return -1;
    }
    function Ns(N, Q, J) {
      return Q === Q ? Yy(N, Q, J) : su(N, L4, J);
    }
    function Dy(N, Q, J, Me) {
      for (var Je = J - 1, bt = N.length; ++Je < bt; )
        if (Me(N[Je], Q))
          return Je;
      return -1;
    }
    function L4(N) {
      return N !== N;
    }
    function M4(N, Q) {
      var J = N == null ? 0 : N.length;
      return J ? r0(N, Q) / J : j;
    }
    function t0(N) {
      return function(Q) {
        return Q == null ? n : Q[N];
      };
    }
    function n0(N) {
      return function(Q) {
        return N == null ? n : N[Q];
      };
    }
    function P4(N, Q, J, Me, Je) {
      return Je(N, function(bt, dn, Tt) {
        J = Me ? (Me = !1, bt) : Q(J, bt, dn, Tt);
      }), J;
    }
    function Oy(N, Q) {
      var J = N.length;
      for (N.sort(Q); J--; )
        N[J] = N[J].value;
      return N;
    }
    function r0(N, Q) {
      for (var J, Me = -1, Je = N.length; ++Me < Je; ) {
        var bt = Q(N[Me]);
        bt !== n && (J = J === n ? bt : J + bt);
      }
      return J;
    }
    function o0(N, Q) {
      for (var J = -1, Me = Array(N); ++J < N; )
        Me[J] = Q(J);
      return Me;
    }
    function Ny(N, Q) {
      return Zt(Q, function(J) {
        return [J, N[J]];
      });
    }
    function E4(N) {
      return N && N.slice(0, H4(N) + 1).replace(ni, "");
    }
    function ir(N) {
      return function(Q) {
        return N(Q);
      };
    }
    function i0(N, Q) {
      return Zt(Q, function(J) {
        return N[J];
      });
    }
    function n1(N, Q) {
      return N.has(Q);
    }
    function R4(N, Q) {
      for (var J = -1, Me = N.length; ++J < Me && Ns(Q, N[J], 0) > -1; )
        ;
      return J;
    }
    function _4(N, Q) {
      for (var J = N.length; J-- && Ns(Q, N[J], 0) > -1; )
        ;
      return J;
    }
    function Zy(N, Q) {
      for (var J = N.length, Me = 0; J--; )
        N[J] === Q && ++Me;
      return Me;
    }
    var $y = n0(ou), zy = n0(q2);
    function Wy(N) {
      return "\\" + D[N];
    }
    function Gy(N, Q) {
      return N == null ? n : N[Q];
    }
    function Zs(N) {
      return Y2.test(N);
    }
    function jy(N) {
      return nu.test(N);
    }
    function Xy(N) {
      for (var Q, J = []; !(Q = N.next()).done; )
        J.push(Q.value);
      return J;
    }
    function s0(N) {
      var Q = -1, J = Array(N.size);
      return N.forEach(function(Me, Je) {
        J[++Q] = [Je, Me];
      }), J;
    }
    function T4(N, Q) {
      return function(J) {
        return N(Q(J));
      };
    }
    function si(N, Q) {
      for (var J = -1, Me = N.length, Je = 0, bt = []; ++J < Me; ) {
        var dn = N[J];
        (dn === Q || dn === f) && (N[J] = f, bt[Je++] = J);
      }
      return bt;
    }
    function au(N) {
      var Q = -1, J = Array(N.size);
      return N.forEach(function(Me) {
        J[++Q] = Me;
      }), J;
    }
    function Uy(N) {
      var Q = -1, J = Array(N.size);
      return N.forEach(function(Me) {
        J[++Q] = [Me, Me];
      }), J;
    }
    function Yy(N, Q, J) {
      for (var Me = J - 1, Je = N.length; ++Me < Je; )
        if (N[Me] === Q)
          return Me;
      return -1;
    }
    function Jy(N, Q, J) {
      for (var Me = J + 1; Me--; )
        if (N[Me] === Q)
          return Me;
      return Me;
    }
    function $s(N) {
      return Zs(N) ? Ky(N) : Fy(N);
    }
    function Gr(N) {
      return Zs(N) ? Qy(N) : ky(N);
    }
    function H4(N) {
      for (var Q = N.length; Q-- && Ga.test(N.charAt(Q)); )
        ;
      return Q;
    }
    var qy = n0(E);
    function Ky(N) {
      for (var Q = Wr.lastIndex = 0; Wr.test(N); )
        ++Q;
      return Q;
    }
    function Qy(N) {
      return N.match(Wr) || [];
    }
    function ex(N) {
      return N.match(Ni) || [];
    }
    var tx = function N(Q) {
      Q = Q == null ? Qe : zs.defaults(Qe.Object(), Q, zs.pick(Qe, J2));
      var J = Q.Array, Me = Q.Date, Je = Q.Error, bt = Q.Function, dn = Q.Math, Tt = Q.Object, a0 = Q.RegExp, nx = Q.String, yr = Q.TypeError, lu = J.prototype, rx = bt.prototype, Ws = Tt.prototype, uu = Q["__core-js_shared__"], cu = rx.toString, Lt = Ws.hasOwnProperty, ox = 0, F4 = function() {
        var s = /[^.]+$/.exec(uu && uu.keys && uu.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), du = Ws.toString, ix = cu.call(Tt), sx = Qe._, ax = a0(
        "^" + cu.call(Lt).replace(Bi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), fu = _n ? Q.Buffer : n, ai = Q.Symbol, hu = Q.Uint8Array, k4 = fu ? fu.allocUnsafe : n, pu = T4(Tt.getPrototypeOf, Tt), B4 = Tt.create, D4 = Ws.propertyIsEnumerable, gu = lu.splice, O4 = ai ? ai.isConcatSpreadable : n, r1 = ai ? ai.iterator : n, Zi = ai ? ai.toStringTag : n, mu = function() {
        try {
          var s = ji(Tt, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), lx = Q.clearTimeout !== Qe.clearTimeout && Q.clearTimeout, ux = Me && Me.now !== Qe.Date.now && Me.now, cx = Q.setTimeout !== Qe.setTimeout && Q.setTimeout, Cu = dn.ceil, vu = dn.floor, l0 = Tt.getOwnPropertySymbols, dx = fu ? fu.isBuffer : n, N4 = Q.isFinite, fx = lu.join, hx = T4(Tt.keys, Tt), fn = dn.max, Ln = dn.min, px = Me.now, gx = Q.parseInt, Z4 = dn.random, mx = lu.reverse, u0 = ji(Q, "DataView"), o1 = ji(Q, "Map"), c0 = ji(Q, "Promise"), Gs = ji(Q, "Set"), i1 = ji(Q, "WeakMap"), s1 = ji(Tt, "create"), bu = i1 && new i1(), js = {}, Cx = Xi(u0), vx = Xi(o1), bx = Xi(c0), yx = Xi(Gs), xx = Xi(i1), yu = ai ? ai.prototype : n, a1 = yu ? yu.valueOf : n, $4 = yu ? yu.toString : n;
      function A(s) {
        if (Ut(s) && !Ke(s) && !(s instanceof dt)) {
          if (s instanceof xr)
            return s;
          if (Lt.call(s, "__wrapped__"))
            return z9(s);
        }
        return new xr(s);
      }
      var Xs = function() {
        function s() {
        }
        return function(l) {
          if (!Wt(l))
            return {};
          if (B4)
            return B4(l);
          s.prototype = l;
          var h = new s();
          return s.prototype = n, h;
        };
      }();
      function xu() {
      }
      function xr(s, l) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!l, this.__index__ = 0, this.__values__ = n;
      }
      A.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Wa,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ls,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ms,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: A
        }
      }, A.prototype = xu.prototype, A.prototype.constructor = A, xr.prototype = Xs(xu.prototype), xr.prototype.constructor = xr;
      function dt(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = X, this.__views__ = [];
      }
      function Sx() {
        var s = new dt(this.__wrapped__);
        return s.__actions__ = $n(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = $n(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = $n(this.__views__), s;
      }
      function wx() {
        if (this.__filtered__) {
          var s = new dt(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function Ix() {
        var s = this.__wrapped__.value(), l = this.__dir__, h = Ke(s), C = l < 0, S = h ? s.length : 0, P = kS(0, S, this.__views__), T = P.start, k = P.end, $ = k - T, ne = C ? k : T - 1, oe = this.__iteratees__, le = oe.length, Ie = 0, Re = Ln($, this.__takeCount__);
        if (!h || !C && S == $ && Re == $)
          return f9(s, this.__actions__);
        var $e = [];
        e:
          for (; $-- && Ie < Re; ) {
            ne += l;
            for (var rt = -1, ze = s[ne]; ++rt < le; ) {
              var ct = oe[rt], ht = ct.iteratee, lr = ct.type, Fn = ht(ze);
              if (lr == xe)
                ze = Fn;
              else if (!Fn) {
                if (lr == ce)
                  continue e;
                break e;
              }
            }
            $e[Ie++] = ze;
          }
        return $e;
      }
      dt.prototype = Xs(xu.prototype), dt.prototype.constructor = dt;
      function $i(s) {
        var l = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++l < h; ) {
          var C = s[l];
          this.set(C[0], C[1]);
        }
      }
      function Vx() {
        this.__data__ = s1 ? s1(null) : {}, this.size = 0;
      }
      function Ax(s) {
        var l = this.has(s) && delete this.__data__[s];
        return this.size -= l ? 1 : 0, l;
      }
      function Lx(s) {
        var l = this.__data__;
        if (s1) {
          var h = l[s];
          return h === c ? n : h;
        }
        return Lt.call(l, s) ? l[s] : n;
      }
      function Mx(s) {
        var l = this.__data__;
        return s1 ? l[s] !== n : Lt.call(l, s);
      }
      function Px(s, l) {
        var h = this.__data__;
        return this.size += this.has(s) ? 0 : 1, h[s] = s1 && l === n ? c : l, this;
      }
      $i.prototype.clear = Vx, $i.prototype.delete = Ax, $i.prototype.get = Lx, $i.prototype.has = Mx, $i.prototype.set = Px;
      function Io(s) {
        var l = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++l < h; ) {
          var C = s[l];
          this.set(C[0], C[1]);
        }
      }
      function Ex() {
        this.__data__ = [], this.size = 0;
      }
      function Rx(s) {
        var l = this.__data__, h = Su(l, s);
        if (h < 0)
          return !1;
        var C = l.length - 1;
        return h == C ? l.pop() : gu.call(l, h, 1), --this.size, !0;
      }
      function _x(s) {
        var l = this.__data__, h = Su(l, s);
        return h < 0 ? n : l[h][1];
      }
      function Tx(s) {
        return Su(this.__data__, s) > -1;
      }
      function Hx(s, l) {
        var h = this.__data__, C = Su(h, s);
        return C < 0 ? (++this.size, h.push([s, l])) : h[C][1] = l, this;
      }
      Io.prototype.clear = Ex, Io.prototype.delete = Rx, Io.prototype.get = _x, Io.prototype.has = Tx, Io.prototype.set = Hx;
      function Vo(s) {
        var l = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++l < h; ) {
          var C = s[l];
          this.set(C[0], C[1]);
        }
      }
      function Fx() {
        this.size = 0, this.__data__ = {
          hash: new $i(),
          map: new (o1 || Io)(),
          string: new $i()
        };
      }
      function kx(s) {
        var l = Hu(this, s).delete(s);
        return this.size -= l ? 1 : 0, l;
      }
      function Bx(s) {
        return Hu(this, s).get(s);
      }
      function Dx(s) {
        return Hu(this, s).has(s);
      }
      function Ox(s, l) {
        var h = Hu(this, s), C = h.size;
        return h.set(s, l), this.size += h.size == C ? 0 : 1, this;
      }
      Vo.prototype.clear = Fx, Vo.prototype.delete = kx, Vo.prototype.get = Bx, Vo.prototype.has = Dx, Vo.prototype.set = Ox;
      function zi(s) {
        var l = -1, h = s == null ? 0 : s.length;
        for (this.__data__ = new Vo(); ++l < h; )
          this.add(s[l]);
      }
      function Nx(s) {
        return this.__data__.set(s, c), this;
      }
      function Zx(s) {
        return this.__data__.has(s);
      }
      zi.prototype.add = zi.prototype.push = Nx, zi.prototype.has = Zx;
      function jr(s) {
        var l = this.__data__ = new Io(s);
        this.size = l.size;
      }
      function $x() {
        this.__data__ = new Io(), this.size = 0;
      }
      function zx(s) {
        var l = this.__data__, h = l.delete(s);
        return this.size = l.size, h;
      }
      function Wx(s) {
        return this.__data__.get(s);
      }
      function Gx(s) {
        return this.__data__.has(s);
      }
      function jx(s, l) {
        var h = this.__data__;
        if (h instanceof Io) {
          var C = h.__data__;
          if (!o1 || C.length < o - 1)
            return C.push([s, l]), this.size = ++h.size, this;
          h = this.__data__ = new Vo(C);
        }
        return h.set(s, l), this.size = h.size, this;
      }
      jr.prototype.clear = $x, jr.prototype.delete = zx, jr.prototype.get = Wx, jr.prototype.has = Gx, jr.prototype.set = jx;
      function z4(s, l) {
        var h = Ke(s), C = !h && Ui(s), S = !h && !C && fi(s), P = !h && !C && !S && qs(s), T = h || C || S || P, k = T ? o0(s.length, nx) : [], $ = k.length;
        for (var ne in s)
          (l || Lt.call(s, ne)) && !(T && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ne == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          S && (ne == "offset" || ne == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          P && (ne == "buffer" || ne == "byteLength" || ne == "byteOffset") || // Skip index properties.
          Po(ne, $))) && k.push(ne);
        return k;
      }
      function W4(s) {
        var l = s.length;
        return l ? s[x0(0, l - 1)] : n;
      }
      function Xx(s, l) {
        return Fu($n(s), Wi(l, 0, s.length));
      }
      function Ux(s) {
        return Fu($n(s));
      }
      function d0(s, l, h) {
        (h !== n && !Xr(s[l], h) || h === n && !(l in s)) && Ao(s, l, h);
      }
      function l1(s, l, h) {
        var C = s[l];
        (!(Lt.call(s, l) && Xr(C, h)) || h === n && !(l in s)) && Ao(s, l, h);
      }
      function Su(s, l) {
        for (var h = s.length; h--; )
          if (Xr(s[h][0], l))
            return h;
        return -1;
      }
      function Yx(s, l, h, C) {
        return li(s, function(S, P, T) {
          l(C, S, h(S), T);
        }), C;
      }
      function G4(s, l) {
        return s && uo(l, yn(l), s);
      }
      function Jx(s, l) {
        return s && uo(l, Wn(l), s);
      }
      function Ao(s, l, h) {
        l == "__proto__" && mu ? mu(s, l, {
          configurable: !0,
          enumerable: !0,
          value: h,
          writable: !0
        }) : s[l] = h;
      }
      function f0(s, l) {
        for (var h = -1, C = l.length, S = J(C), P = s == null; ++h < C; )
          S[h] = P ? n : j0(s, l[h]);
        return S;
      }
      function Wi(s, l, h) {
        return s === s && (h !== n && (s = s <= h ? s : h), l !== n && (s = s >= l ? s : l)), s;
      }
      function Sr(s, l, h, C, S, P) {
        var T, k = l & p, $ = l & g, ne = l & m;
        if (h && (T = S ? h(s, C, S, P) : h(s)), T !== n)
          return T;
        if (!Wt(s))
          return s;
        var oe = Ke(s);
        if (oe) {
          if (T = DS(s), !k)
            return $n(s, T);
        } else {
          var le = Mn(s), Ie = le == K || le == Ye;
          if (fi(s))
            return g9(s, k);
          if (le == ft || le == te || Ie && !S) {
            if (T = $ || Ie ? {} : H9(s), !k)
              return $ ? LS(s, Jx(T, s)) : AS(s, G4(T, s));
          } else {
            if (!Et[le])
              return S ? s : {};
            T = OS(s, le, k);
          }
        }
        P || (P = new jr());
        var Re = P.get(s);
        if (Re)
          return Re;
        P.set(s, T), u7(s) ? s.forEach(function(ze) {
          T.add(Sr(ze, l, h, ze, s, P));
        }) : a7(s) && s.forEach(function(ze, ct) {
          T.set(ct, Sr(ze, l, h, ct, s, P));
        });
        var $e = ne ? $ ? _0 : R0 : $ ? Wn : yn, rt = oe ? n : $e(s);
        return br(rt || s, function(ze, ct) {
          rt && (ct = ze, ze = s[ct]), l1(T, ct, Sr(ze, l, h, ct, s, P));
        }), T;
      }
      function qx(s) {
        var l = yn(s);
        return function(h) {
          return j4(h, s, l);
        };
      }
      function j4(s, l, h) {
        var C = h.length;
        if (s == null)
          return !C;
        for (s = Tt(s); C--; ) {
          var S = h[C], P = l[S], T = s[S];
          if (T === n && !(S in s) || !P(T))
            return !1;
        }
        return !0;
      }
      function X4(s, l, h) {
        if (typeof s != "function")
          throw new yr(a);
        return g1(function() {
          s.apply(n, h);
        }, l);
      }
      function u1(s, l, h, C) {
        var S = -1, P = iu, T = !0, k = s.length, $ = [], ne = l.length;
        if (!k)
          return $;
        h && (l = Zt(l, ir(h))), C ? (P = K2, T = !1) : l.length >= o && (P = n1, T = !1, l = new zi(l));
        e:
          for (; ++S < k; ) {
            var oe = s[S], le = h == null ? oe : h(oe);
            if (oe = C || oe !== 0 ? oe : 0, T && le === le) {
              for (var Ie = ne; Ie--; )
                if (l[Ie] === le)
                  continue e;
              $.push(oe);
            } else
              P(l, le, C) || $.push(oe);
          }
        return $;
      }
      var li = y9(lo), U4 = y9(p0, !0);
      function Kx(s, l) {
        var h = !0;
        return li(s, function(C, S, P) {
          return h = !!l(C, S, P), h;
        }), h;
      }
      function wu(s, l, h) {
        for (var C = -1, S = s.length; ++C < S; ) {
          var P = s[C], T = l(P);
          if (T != null && (k === n ? T === T && !ar(T) : h(T, k)))
            var k = T, $ = P;
        }
        return $;
      }
      function Qx(s, l, h, C) {
        var S = s.length;
        for (h = tt(h), h < 0 && (h = -h > S ? 0 : S + h), C = C === n || C > S ? S : tt(C), C < 0 && (C += S), C = h > C ? 0 : d7(C); h < C; )
          s[h++] = l;
        return s;
      }
      function Y4(s, l) {
        var h = [];
        return li(s, function(C, S, P) {
          l(C, S, P) && h.push(C);
        }), h;
      }
      function wn(s, l, h, C, S) {
        var P = -1, T = s.length;
        for (h || (h = ZS), S || (S = []); ++P < T; ) {
          var k = s[P];
          l > 0 && h(k) ? l > 1 ? wn(k, l - 1, h, C, S) : ii(S, k) : C || (S[S.length] = k);
        }
        return S;
      }
      var h0 = x9(), J4 = x9(!0);
      function lo(s, l) {
        return s && h0(s, l, yn);
      }
      function p0(s, l) {
        return s && J4(s, l, yn);
      }
      function Iu(s, l) {
        return oi(l, function(h) {
          return Eo(s[h]);
        });
      }
      function Gi(s, l) {
        l = ci(l, s);
        for (var h = 0, C = l.length; s != null && h < C; )
          s = s[co(l[h++])];
        return h && h == C ? s : n;
      }
      function q4(s, l, h) {
        var C = l(s);
        return Ke(s) ? C : ii(C, h(s));
      }
      function Tn(s) {
        return s == null ? s === n ? tr : Mt : Zi && Zi in Tt(s) ? FS(s) : US(s);
      }
      function g0(s, l) {
        return s > l;
      }
      function eS(s, l) {
        return s != null && Lt.call(s, l);
      }
      function tS(s, l) {
        return s != null && l in Tt(s);
      }
      function nS(s, l, h) {
        return s >= Ln(l, h) && s < fn(l, h);
      }
      function m0(s, l, h) {
        for (var C = h ? K2 : iu, S = s[0].length, P = s.length, T = P, k = J(P), $ = 1 / 0, ne = []; T--; ) {
          var oe = s[T];
          T && l && (oe = Zt(oe, ir(l))), $ = Ln(oe.length, $), k[T] = !h && (l || S >= 120 && oe.length >= 120) ? new zi(T && oe) : n;
        }
        oe = s[0];
        var le = -1, Ie = k[0];
        e:
          for (; ++le < S && ne.length < $; ) {
            var Re = oe[le], $e = l ? l(Re) : Re;
            if (Re = h || Re !== 0 ? Re : 0, !(Ie ? n1(Ie, $e) : C(ne, $e, h))) {
              for (T = P; --T; ) {
                var rt = k[T];
                if (!(rt ? n1(rt, $e) : C(s[T], $e, h)))
                  continue e;
              }
              Ie && Ie.push($e), ne.push(Re);
            }
          }
        return ne;
      }
      function rS(s, l, h, C) {
        return lo(s, function(S, P, T) {
          l(C, h(S), P, T);
        }), C;
      }
      function c1(s, l, h) {
        l = ci(l, s), s = D9(s, l);
        var C = s == null ? s : s[co(Ir(l))];
        return C == null ? n : or(C, s, h);
      }
      function K4(s) {
        return Ut(s) && Tn(s) == te;
      }
      function oS(s) {
        return Ut(s) && Tn(s) == vn;
      }
      function iS(s) {
        return Ut(s) && Tn(s) == Se;
      }
      function d1(s, l, h, C, S) {
        return s === l ? !0 : s == null || l == null || !Ut(s) && !Ut(l) ? s !== s && l !== l : sS(s, l, h, C, d1, S);
      }
      function sS(s, l, h, C, S, P) {
        var T = Ke(s), k = Ke(l), $ = T ? ee : Mn(s), ne = k ? ee : Mn(l);
        $ = $ == te ? ft : $, ne = ne == te ? ft : ne;
        var oe = $ == ft, le = ne == ft, Ie = $ == ne;
        if (Ie && fi(s)) {
          if (!fi(l))
            return !1;
          T = !0, oe = !1;
        }
        if (Ie && !oe)
          return P || (P = new jr()), T || qs(s) ? R9(s, l, h, C, S, P) : TS(s, l, $, h, C, S, P);
        if (!(h & b)) {
          var Re = oe && Lt.call(s, "__wrapped__"), $e = le && Lt.call(l, "__wrapped__");
          if (Re || $e) {
            var rt = Re ? s.value() : s, ze = $e ? l.value() : l;
            return P || (P = new jr()), S(rt, ze, h, C, P);
          }
        }
        return Ie ? (P || (P = new jr()), HS(s, l, h, C, S, P)) : !1;
      }
      function aS(s) {
        return Ut(s) && Mn(s) == ve;
      }
      function C0(s, l, h, C) {
        var S = h.length, P = S, T = !C;
        if (s == null)
          return !P;
        for (s = Tt(s); S--; ) {
          var k = h[S];
          if (T && k[2] ? k[1] !== s[k[0]] : !(k[0] in s))
            return !1;
        }
        for (; ++S < P; ) {
          k = h[S];
          var $ = k[0], ne = s[$], oe = k[1];
          if (T && k[2]) {
            if (ne === n && !($ in s))
              return !1;
          } else {
            var le = new jr();
            if (C)
              var Ie = C(ne, oe, $, s, l, le);
            if (!(Ie === n ? d1(oe, ne, b | v, C, le) : Ie))
              return !1;
          }
        }
        return !0;
      }
      function Q4(s) {
        if (!Wt(s) || zS(s))
          return !1;
        var l = Eo(s) ? ax : nt;
        return l.test(Xi(s));
      }
      function lS(s) {
        return Ut(s) && Tn(s) == Ct;
      }
      function uS(s) {
        return Ut(s) && Mn(s) == Pt;
      }
      function cS(s) {
        return Ut(s) && Zu(s.length) && !!_t[Tn(s)];
      }
      function e9(s) {
        return typeof s == "function" ? s : s == null ? Gn : typeof s == "object" ? Ke(s) ? r9(s[0], s[1]) : n9(s) : S7(s);
      }
      function v0(s) {
        if (!p1(s))
          return hx(s);
        var l = [];
        for (var h in Tt(s))
          Lt.call(s, h) && h != "constructor" && l.push(h);
        return l;
      }
      function dS(s) {
        if (!Wt(s))
          return XS(s);
        var l = p1(s), h = [];
        for (var C in s)
          C == "constructor" && (l || !Lt.call(s, C)) || h.push(C);
        return h;
      }
      function b0(s, l) {
        return s < l;
      }
      function t9(s, l) {
        var h = -1, C = zn(s) ? J(s.length) : [];
        return li(s, function(S, P, T) {
          C[++h] = l(S, P, T);
        }), C;
      }
      function n9(s) {
        var l = H0(s);
        return l.length == 1 && l[0][2] ? k9(l[0][0], l[0][1]) : function(h) {
          return h === s || C0(h, s, l);
        };
      }
      function r9(s, l) {
        return k0(s) && F9(l) ? k9(co(s), l) : function(h) {
          var C = j0(h, s);
          return C === n && C === l ? X0(h, s) : d1(l, C, b | v);
        };
      }
      function Vu(s, l, h, C, S) {
        s !== l && h0(l, function(P, T) {
          if (S || (S = new jr()), Wt(P))
            fS(s, l, T, h, Vu, C, S);
          else {
            var k = C ? C(D0(s, T), P, T + "", s, l, S) : n;
            k === n && (k = P), d0(s, T, k);
          }
        }, Wn);
      }
      function fS(s, l, h, C, S, P, T) {
        var k = D0(s, h), $ = D0(l, h), ne = T.get($);
        if (ne) {
          d0(s, h, ne);
          return;
        }
        var oe = P ? P(k, $, h + "", s, l, T) : n, le = oe === n;
        if (le) {
          var Ie = Ke($), Re = !Ie && fi($), $e = !Ie && !Re && qs($);
          oe = $, Ie || Re || $e ? Ke(k) ? oe = k : Qt(k) ? oe = $n(k) : Re ? (le = !1, oe = g9($, !0)) : $e ? (le = !1, oe = m9($, !0)) : oe = [] : m1($) || Ui($) ? (oe = k, Ui(k) ? oe = f7(k) : (!Wt(k) || Eo(k)) && (oe = H9($))) : le = !1;
        }
        le && (T.set($, oe), S(oe, $, C, P, T), T.delete($)), d0(s, h, oe);
      }
      function o9(s, l) {
        var h = s.length;
        if (h)
          return l += l < 0 ? h : 0, Po(l, h) ? s[l] : n;
      }
      function i9(s, l, h) {
        l.length ? l = Zt(l, function(P) {
          return Ke(P) ? function(T) {
            return Gi(T, P.length === 1 ? P[0] : P);
          } : P;
        }) : l = [Gn];
        var C = -1;
        l = Zt(l, ir(Oe()));
        var S = t9(s, function(P, T, k) {
          var $ = Zt(l, function(ne) {
            return ne(P);
          });
          return { criteria: $, index: ++C, value: P };
        });
        return Oy(S, function(P, T) {
          return VS(P, T, h);
        });
      }
      function hS(s, l) {
        return s9(s, l, function(h, C) {
          return X0(s, C);
        });
      }
      function s9(s, l, h) {
        for (var C = -1, S = l.length, P = {}; ++C < S; ) {
          var T = l[C], k = Gi(s, T);
          h(k, T) && f1(P, ci(T, s), k);
        }
        return P;
      }
      function pS(s) {
        return function(l) {
          return Gi(l, s);
        };
      }
      function y0(s, l, h, C) {
        var S = C ? Dy : Ns, P = -1, T = l.length, k = s;
        for (s === l && (l = $n(l)), h && (k = Zt(s, ir(h))); ++P < T; )
          for (var $ = 0, ne = l[P], oe = h ? h(ne) : ne; ($ = S(k, oe, $, C)) > -1; )
            k !== s && gu.call(k, $, 1), gu.call(s, $, 1);
        return s;
      }
      function a9(s, l) {
        for (var h = s ? l.length : 0, C = h - 1; h--; ) {
          var S = l[h];
          if (h == C || S !== P) {
            var P = S;
            Po(S) ? gu.call(s, S, 1) : I0(s, S);
          }
        }
        return s;
      }
      function x0(s, l) {
        return s + vu(Z4() * (l - s + 1));
      }
      function gS(s, l, h, C) {
        for (var S = -1, P = fn(Cu((l - s) / (h || 1)), 0), T = J(P); P--; )
          T[C ? P : ++S] = s, s += h;
        return T;
      }
      function S0(s, l) {
        var h = "";
        if (!s || l < 1 || l > Y)
          return h;
        do
          l % 2 && (h += s), l = vu(l / 2), l && (s += s);
        while (l);
        return h;
      }
      function st(s, l) {
        return O0(B9(s, l, Gn), s + "");
      }
      function mS(s) {
        return W4(Ks(s));
      }
      function CS(s, l) {
        var h = Ks(s);
        return Fu(h, Wi(l, 0, h.length));
      }
      function f1(s, l, h, C) {
        if (!Wt(s))
          return s;
        l = ci(l, s);
        for (var S = -1, P = l.length, T = P - 1, k = s; k != null && ++S < P; ) {
          var $ = co(l[S]), ne = h;
          if ($ === "__proto__" || $ === "constructor" || $ === "prototype")
            return s;
          if (S != T) {
            var oe = k[$];
            ne = C ? C(oe, $, k) : n, ne === n && (ne = Wt(oe) ? oe : Po(l[S + 1]) ? [] : {});
          }
          l1(k, $, ne), k = k[$];
        }
        return s;
      }
      var l9 = bu ? function(s, l) {
        return bu.set(s, l), s;
      } : Gn, vS = mu ? function(s, l) {
        return mu(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Y0(l),
          writable: !0
        });
      } : Gn;
      function bS(s) {
        return Fu(Ks(s));
      }
      function wr(s, l, h) {
        var C = -1, S = s.length;
        l < 0 && (l = -l > S ? 0 : S + l), h = h > S ? S : h, h < 0 && (h += S), S = l > h ? 0 : h - l >>> 0, l >>>= 0;
        for (var P = J(S); ++C < S; )
          P[C] = s[C + l];
        return P;
      }
      function yS(s, l) {
        var h;
        return li(s, function(C, S, P) {
          return h = l(C, S, P), !h;
        }), !!h;
      }
      function Au(s, l, h) {
        var C = 0, S = s == null ? C : s.length;
        if (typeof l == "number" && l === l && S <= W) {
          for (; C < S; ) {
            var P = C + S >>> 1, T = s[P];
            T !== null && !ar(T) && (h ? T <= l : T < l) ? C = P + 1 : S = P;
          }
          return S;
        }
        return w0(s, l, Gn, h);
      }
      function w0(s, l, h, C) {
        var S = 0, P = s == null ? 0 : s.length;
        if (P === 0)
          return 0;
        l = h(l);
        for (var T = l !== l, k = l === null, $ = ar(l), ne = l === n; S < P; ) {
          var oe = vu((S + P) / 2), le = h(s[oe]), Ie = le !== n, Re = le === null, $e = le === le, rt = ar(le);
          if (T)
            var ze = C || $e;
          else
            ne ? ze = $e && (C || Ie) : k ? ze = $e && Ie && (C || !Re) : $ ? ze = $e && Ie && !Re && (C || !rt) : Re || rt ? ze = !1 : ze = C ? le <= l : le < l;
          ze ? S = oe + 1 : P = oe;
        }
        return Ln(P, ie);
      }
      function u9(s, l) {
        for (var h = -1, C = s.length, S = 0, P = []; ++h < C; ) {
          var T = s[h], k = l ? l(T) : T;
          if (!h || !Xr(k, $)) {
            var $ = k;
            P[S++] = T === 0 ? 0 : T;
          }
        }
        return P;
      }
      function c9(s) {
        return typeof s == "number" ? s : ar(s) ? j : +s;
      }
      function sr(s) {
        if (typeof s == "string")
          return s;
        if (Ke(s))
          return Zt(s, sr) + "";
        if (ar(s))
          return $4 ? $4.call(s) : "";
        var l = s + "";
        return l == "0" && 1 / s == -z ? "-0" : l;
      }
      function ui(s, l, h) {
        var C = -1, S = iu, P = s.length, T = !0, k = [], $ = k;
        if (h)
          T = !1, S = K2;
        else if (P >= o) {
          var ne = l ? null : RS(s);
          if (ne)
            return au(ne);
          T = !1, S = n1, $ = new zi();
        } else
          $ = l ? [] : k;
        e:
          for (; ++C < P; ) {
            var oe = s[C], le = l ? l(oe) : oe;
            if (oe = h || oe !== 0 ? oe : 0, T && le === le) {
              for (var Ie = $.length; Ie--; )
                if ($[Ie] === le)
                  continue e;
              l && $.push(le), k.push(oe);
            } else
              S($, le, h) || ($ !== k && $.push(le), k.push(oe));
          }
        return k;
      }
      function I0(s, l) {
        return l = ci(l, s), s = D9(s, l), s == null || delete s[co(Ir(l))];
      }
      function d9(s, l, h, C) {
        return f1(s, l, h(Gi(s, l)), C);
      }
      function Lu(s, l, h, C) {
        for (var S = s.length, P = C ? S : -1; (C ? P-- : ++P < S) && l(s[P], P, s); )
          ;
        return h ? wr(s, C ? 0 : P, C ? P + 1 : S) : wr(s, C ? P + 1 : 0, C ? S : P);
      }
      function f9(s, l) {
        var h = s;
        return h instanceof dt && (h = h.value()), Q2(l, function(C, S) {
          return S.func.apply(S.thisArg, ii([C], S.args));
        }, h);
      }
      function V0(s, l, h) {
        var C = s.length;
        if (C < 2)
          return C ? ui(s[0]) : [];
        for (var S = -1, P = J(C); ++S < C; )
          for (var T = s[S], k = -1; ++k < C; )
            k != S && (P[S] = u1(P[S] || T, s[k], l, h));
        return ui(wn(P, 1), l, h);
      }
      function h9(s, l, h) {
        for (var C = -1, S = s.length, P = l.length, T = {}; ++C < S; ) {
          var k = C < P ? l[C] : n;
          h(T, s[C], k);
        }
        return T;
      }
      function A0(s) {
        return Qt(s) ? s : [];
      }
      function L0(s) {
        return typeof s == "function" ? s : Gn;
      }
      function ci(s, l) {
        return Ke(s) ? s : k0(s, l) ? [s] : $9(wt(s));
      }
      var xS = st;
      function di(s, l, h) {
        var C = s.length;
        return h = h === n ? C : h, !l && h >= C ? s : wr(s, l, h);
      }
      var p9 = lx || function(s) {
        return Qe.clearTimeout(s);
      };
      function g9(s, l) {
        if (l)
          return s.slice();
        var h = s.length, C = k4 ? k4(h) : new s.constructor(h);
        return s.copy(C), C;
      }
      function M0(s) {
        var l = new s.constructor(s.byteLength);
        return new hu(l).set(new hu(s)), l;
      }
      function SS(s, l) {
        var h = l ? M0(s.buffer) : s.buffer;
        return new s.constructor(h, s.byteOffset, s.byteLength);
      }
      function wS(s) {
        var l = new s.constructor(s.source, et.exec(s));
        return l.lastIndex = s.lastIndex, l;
      }
      function IS(s) {
        return a1 ? Tt(a1.call(s)) : {};
      }
      function m9(s, l) {
        var h = l ? M0(s.buffer) : s.buffer;
        return new s.constructor(h, s.byteOffset, s.length);
      }
      function C9(s, l) {
        if (s !== l) {
          var h = s !== n, C = s === null, S = s === s, P = ar(s), T = l !== n, k = l === null, $ = l === l, ne = ar(l);
          if (!k && !ne && !P && s > l || P && T && $ && !k && !ne || C && T && $ || !h && $ || !S)
            return 1;
          if (!C && !P && !ne && s < l || ne && h && S && !C && !P || k && h && S || !T && S || !$)
            return -1;
        }
        return 0;
      }
      function VS(s, l, h) {
        for (var C = -1, S = s.criteria, P = l.criteria, T = S.length, k = h.length; ++C < T; ) {
          var $ = C9(S[C], P[C]);
          if ($) {
            if (C >= k)
              return $;
            var ne = h[C];
            return $ * (ne == "desc" ? -1 : 1);
          }
        }
        return s.index - l.index;
      }
      function v9(s, l, h, C) {
        for (var S = -1, P = s.length, T = h.length, k = -1, $ = l.length, ne = fn(P - T, 0), oe = J($ + ne), le = !C; ++k < $; )
          oe[k] = l[k];
        for (; ++S < T; )
          (le || S < P) && (oe[h[S]] = s[S]);
        for (; ne--; )
          oe[k++] = s[S++];
        return oe;
      }
      function b9(s, l, h, C) {
        for (var S = -1, P = s.length, T = -1, k = h.length, $ = -1, ne = l.length, oe = fn(P - k, 0), le = J(oe + ne), Ie = !C; ++S < oe; )
          le[S] = s[S];
        for (var Re = S; ++$ < ne; )
          le[Re + $] = l[$];
        for (; ++T < k; )
          (Ie || S < P) && (le[Re + h[T]] = s[S++]);
        return le;
      }
      function $n(s, l) {
        var h = -1, C = s.length;
        for (l || (l = J(C)); ++h < C; )
          l[h] = s[h];
        return l;
      }
      function uo(s, l, h, C) {
        var S = !h;
        h || (h = {});
        for (var P = -1, T = l.length; ++P < T; ) {
          var k = l[P], $ = C ? C(h[k], s[k], k, h, s) : n;
          $ === n && ($ = s[k]), S ? Ao(h, k, $) : l1(h, k, $);
        }
        return h;
      }
      function AS(s, l) {
        return uo(s, F0(s), l);
      }
      function LS(s, l) {
        return uo(s, _9(s), l);
      }
      function Mu(s, l) {
        return function(h, C) {
          var S = Ke(h) ? _y : Yx, P = l ? l() : {};
          return S(h, s, Oe(C, 2), P);
        };
      }
      function Us(s) {
        return st(function(l, h) {
          var C = -1, S = h.length, P = S > 1 ? h[S - 1] : n, T = S > 2 ? h[2] : n;
          for (P = s.length > 3 && typeof P == "function" ? (S--, P) : n, T && Hn(h[0], h[1], T) && (P = S < 3 ? n : P, S = 1), l = Tt(l); ++C < S; ) {
            var k = h[C];
            k && s(l, k, C, P);
          }
          return l;
        });
      }
      function y9(s, l) {
        return function(h, C) {
          if (h == null)
            return h;
          if (!zn(h))
            return s(h, C);
          for (var S = h.length, P = l ? S : -1, T = Tt(h); (l ? P-- : ++P < S) && C(T[P], P, T) !== !1; )
            ;
          return h;
        };
      }
      function x9(s) {
        return function(l, h, C) {
          for (var S = -1, P = Tt(l), T = C(l), k = T.length; k--; ) {
            var $ = T[s ? k : ++S];
            if (h(P[$], $, P) === !1)
              break;
          }
          return l;
        };
      }
      function MS(s, l, h) {
        var C = l & y, S = h1(s);
        function P() {
          var T = this && this !== Qe && this instanceof P ? S : s;
          return T.apply(C ? h : this, arguments);
        }
        return P;
      }
      function S9(s) {
        return function(l) {
          l = wt(l);
          var h = Zs(l) ? Gr(l) : n, C = h ? h[0] : l.charAt(0), S = h ? di(h, 1).join("") : l.slice(1);
          return C[s]() + S;
        };
      }
      function Ys(s) {
        return function(l) {
          return Q2(y7(b7(l).replace(e1, "")), s, "");
        };
      }
      function h1(s) {
        return function() {
          var l = arguments;
          switch (l.length) {
            case 0:
              return new s();
            case 1:
              return new s(l[0]);
            case 2:
              return new s(l[0], l[1]);
            case 3:
              return new s(l[0], l[1], l[2]);
            case 4:
              return new s(l[0], l[1], l[2], l[3]);
            case 5:
              return new s(l[0], l[1], l[2], l[3], l[4]);
            case 6:
              return new s(l[0], l[1], l[2], l[3], l[4], l[5]);
            case 7:
              return new s(l[0], l[1], l[2], l[3], l[4], l[5], l[6]);
          }
          var h = Xs(s.prototype), C = s.apply(h, l);
          return Wt(C) ? C : h;
        };
      }
      function PS(s, l, h) {
        var C = h1(s);
        function S() {
          for (var P = arguments.length, T = J(P), k = P, $ = Js(S); k--; )
            T[k] = arguments[k];
          var ne = P < 3 && T[0] !== $ && T[P - 1] !== $ ? [] : si(T, $);
          if (P -= ne.length, P < h)
            return L9(
              s,
              l,
              Pu,
              S.placeholder,
              n,
              T,
              ne,
              n,
              n,
              h - P
            );
          var oe = this && this !== Qe && this instanceof S ? C : s;
          return or(oe, this, T);
        }
        return S;
      }
      function w9(s) {
        return function(l, h, C) {
          var S = Tt(l);
          if (!zn(l)) {
            var P = Oe(h, 3);
            l = yn(l), h = function(k) {
              return P(S[k], k, S);
            };
          }
          var T = s(l, h, C);
          return T > -1 ? S[P ? l[T] : T] : n;
        };
      }
      function I9(s) {
        return Mo(function(l) {
          var h = l.length, C = h, S = xr.prototype.thru;
          for (s && l.reverse(); C--; ) {
            var P = l[C];
            if (typeof P != "function")
              throw new yr(a);
            if (S && !T && Tu(P) == "wrapper")
              var T = new xr([], !0);
          }
          for (C = T ? C : h; ++C < h; ) {
            P = l[C];
            var k = Tu(P), $ = k == "wrapper" ? T0(P) : n;
            $ && B0($[0]) && $[1] == (_ | V | L | H) && !$[4].length && $[9] == 1 ? T = T[Tu($[0])].apply(T, $[3]) : T = P.length == 1 && B0(P) ? T[k]() : T.thru(P);
          }
          return function() {
            var ne = arguments, oe = ne[0];
            if (T && ne.length == 1 && Ke(oe))
              return T.plant(oe).value();
            for (var le = 0, Ie = h ? l[le].apply(this, ne) : oe; ++le < h; )
              Ie = l[le].call(this, Ie);
            return Ie;
          };
        });
      }
      function Pu(s, l, h, C, S, P, T, k, $, ne) {
        var oe = l & _, le = l & y, Ie = l & w, Re = l & (V | M), $e = l & B, rt = Ie ? n : h1(s);
        function ze() {
          for (var ct = arguments.length, ht = J(ct), lr = ct; lr--; )
            ht[lr] = arguments[lr];
          if (Re)
            var Fn = Js(ze), ur = Zy(ht, Fn);
          if (C && (ht = v9(ht, C, S, Re)), P && (ht = b9(ht, P, T, Re)), ct -= ur, Re && ct < ne) {
            var en = si(ht, Fn);
            return L9(
              s,
              l,
              Pu,
              ze.placeholder,
              h,
              ht,
              en,
              k,
              $,
              ne - ct
            );
          }
          var Ur = le ? h : this, _o = Ie ? Ur[s] : s;
          return ct = ht.length, k ? ht = YS(ht, k) : $e && ct > 1 && ht.reverse(), oe && $ < ct && (ht.length = $), this && this !== Qe && this instanceof ze && (_o = rt || h1(_o)), _o.apply(Ur, ht);
        }
        return ze;
      }
      function V9(s, l) {
        return function(h, C) {
          return rS(h, s, l(C), {});
        };
      }
      function Eu(s, l) {
        return function(h, C) {
          var S;
          if (h === n && C === n)
            return l;
          if (h !== n && (S = h), C !== n) {
            if (S === n)
              return C;
            typeof h == "string" || typeof C == "string" ? (h = sr(h), C = sr(C)) : (h = c9(h), C = c9(C)), S = s(h, C);
          }
          return S;
        };
      }
      function P0(s) {
        return Mo(function(l) {
          return l = Zt(l, ir(Oe())), st(function(h) {
            var C = this;
            return s(l, function(S) {
              return or(S, C, h);
            });
          });
        });
      }
      function Ru(s, l) {
        l = l === n ? " " : sr(l);
        var h = l.length;
        if (h < 2)
          return h ? S0(l, s) : l;
        var C = S0(l, Cu(s / $s(l)));
        return Zs(l) ? di(Gr(C), 0, s).join("") : C.slice(0, s);
      }
      function ES(s, l, h, C) {
        var S = l & y, P = h1(s);
        function T() {
          for (var k = -1, $ = arguments.length, ne = -1, oe = C.length, le = J(oe + $), Ie = this && this !== Qe && this instanceof T ? P : s; ++ne < oe; )
            le[ne] = C[ne];
          for (; $--; )
            le[ne++] = arguments[++k];
          return or(Ie, S ? h : this, le);
        }
        return T;
      }
      function A9(s) {
        return function(l, h, C) {
          return C && typeof C != "number" && Hn(l, h, C) && (h = C = n), l = Ro(l), h === n ? (h = l, l = 0) : h = Ro(h), C = C === n ? l < h ? 1 : -1 : Ro(C), gS(l, h, C, s);
        };
      }
      function _u(s) {
        return function(l, h) {
          return typeof l == "string" && typeof h == "string" || (l = Vr(l), h = Vr(h)), s(l, h);
        };
      }
      function L9(s, l, h, C, S, P, T, k, $, ne) {
        var oe = l & V, le = oe ? T : n, Ie = oe ? n : T, Re = oe ? P : n, $e = oe ? n : P;
        l |= oe ? L : R, l &= ~(oe ? R : L), l & I || (l &= ~(y | w));
        var rt = [
          s,
          l,
          S,
          Re,
          le,
          $e,
          Ie,
          k,
          $,
          ne
        ], ze = h.apply(n, rt);
        return B0(s) && O9(ze, rt), ze.placeholder = C, N9(ze, s, l);
      }
      function E0(s) {
        var l = dn[s];
        return function(h, C) {
          if (h = Vr(h), C = C == null ? 0 : Ln(tt(C), 292), C && N4(h)) {
            var S = (wt(h) + "e").split("e"), P = l(S[0] + "e" + (+S[1] + C));
            return S = (wt(P) + "e").split("e"), +(S[0] + "e" + (+S[1] - C));
          }
          return l(h);
        };
      }
      var RS = Gs && 1 / au(new Gs([, -0]))[1] == z ? function(s) {
        return new Gs(s);
      } : K0;
      function M9(s) {
        return function(l) {
          var h = Mn(l);
          return h == ve ? s0(l) : h == Pt ? Uy(l) : Ny(l, s(l));
        };
      }
      function Lo(s, l, h, C, S, P, T, k) {
        var $ = l & w;
        if (!$ && typeof s != "function")
          throw new yr(a);
        var ne = C ? C.length : 0;
        if (ne || (l &= ~(L | R), C = S = n), T = T === n ? T : fn(tt(T), 0), k = k === n ? k : tt(k), ne -= S ? S.length : 0, l & R) {
          var oe = C, le = S;
          C = S = n;
        }
        var Ie = $ ? n : T0(s), Re = [
          s,
          l,
          h,
          C,
          S,
          oe,
          le,
          P,
          T,
          k
        ];
        if (Ie && jS(Re, Ie), s = Re[0], l = Re[1], h = Re[2], C = Re[3], S = Re[4], k = Re[9] = Re[9] === n ? $ ? 0 : s.length : fn(Re[9] - ne, 0), !k && l & (V | M) && (l &= ~(V | M)), !l || l == y)
          var $e = MS(s, l, h);
        else
          l == V || l == M ? $e = PS(s, l, k) : (l == L || l == (y | L)) && !S.length ? $e = ES(s, l, h, C) : $e = Pu.apply(n, Re);
        var rt = Ie ? l9 : O9;
        return N9(rt($e, Re), s, l);
      }
      function P9(s, l, h, C) {
        return s === n || Xr(s, Ws[h]) && !Lt.call(C, h) ? l : s;
      }
      function E9(s, l, h, C, S, P) {
        return Wt(s) && Wt(l) && (P.set(l, s), Vu(s, l, n, E9, P), P.delete(l)), s;
      }
      function _S(s) {
        return m1(s) ? n : s;
      }
      function R9(s, l, h, C, S, P) {
        var T = h & b, k = s.length, $ = l.length;
        if (k != $ && !(T && $ > k))
          return !1;
        var ne = P.get(s), oe = P.get(l);
        if (ne && oe)
          return ne == l && oe == s;
        var le = -1, Ie = !0, Re = h & v ? new zi() : n;
        for (P.set(s, l), P.set(l, s); ++le < k; ) {
          var $e = s[le], rt = l[le];
          if (C)
            var ze = T ? C(rt, $e, le, l, s, P) : C($e, rt, le, s, l, P);
          if (ze !== n) {
            if (ze)
              continue;
            Ie = !1;
            break;
          }
          if (Re) {
            if (!e0(l, function(ct, ht) {
              if (!n1(Re, ht) && ($e === ct || S($e, ct, h, C, P)))
                return Re.push(ht);
            })) {
              Ie = !1;
              break;
            }
          } else if (!($e === rt || S($e, rt, h, C, P))) {
            Ie = !1;
            break;
          }
        }
        return P.delete(s), P.delete(l), Ie;
      }
      function TS(s, l, h, C, S, P, T) {
        switch (h) {
          case me:
            if (s.byteLength != l.byteLength || s.byteOffset != l.byteOffset)
              return !1;
            s = s.buffer, l = l.buffer;
          case vn:
            return !(s.byteLength != l.byteLength || !P(new hu(s), new hu(l)));
          case pe:
          case Se:
          case ot:
            return Xr(+s, +l);
          case Ve:
            return s.name == l.name && s.message == l.message;
          case Ct:
          case jt:
            return s == l + "";
          case ve:
            var k = s0;
          case Pt:
            var $ = C & b;
            if (k || (k = au), s.size != l.size && !$)
              return !1;
            var ne = T.get(s);
            if (ne)
              return ne == l;
            C |= v, T.set(s, l);
            var oe = R9(k(s), k(l), C, S, P, T);
            return T.delete(s), oe;
          case Xt:
            if (a1)
              return a1.call(s) == a1.call(l);
        }
        return !1;
      }
      function HS(s, l, h, C, S, P) {
        var T = h & b, k = R0(s), $ = k.length, ne = R0(l), oe = ne.length;
        if ($ != oe && !T)
          return !1;
        for (var le = $; le--; ) {
          var Ie = k[le];
          if (!(T ? Ie in l : Lt.call(l, Ie)))
            return !1;
        }
        var Re = P.get(s), $e = P.get(l);
        if (Re && $e)
          return Re == l && $e == s;
        var rt = !0;
        P.set(s, l), P.set(l, s);
        for (var ze = T; ++le < $; ) {
          Ie = k[le];
          var ct = s[Ie], ht = l[Ie];
          if (C)
            var lr = T ? C(ht, ct, Ie, l, s, P) : C(ct, ht, Ie, s, l, P);
          if (!(lr === n ? ct === ht || S(ct, ht, h, C, P) : lr)) {
            rt = !1;
            break;
          }
          ze || (ze = Ie == "constructor");
        }
        if (rt && !ze) {
          var Fn = s.constructor, ur = l.constructor;
          Fn != ur && "constructor" in s && "constructor" in l && !(typeof Fn == "function" && Fn instanceof Fn && typeof ur == "function" && ur instanceof ur) && (rt = !1);
        }
        return P.delete(s), P.delete(l), rt;
      }
      function Mo(s) {
        return O0(B9(s, n, j9), s + "");
      }
      function R0(s) {
        return q4(s, yn, F0);
      }
      function _0(s) {
        return q4(s, Wn, _9);
      }
      var T0 = bu ? function(s) {
        return bu.get(s);
      } : K0;
      function Tu(s) {
        for (var l = s.name + "", h = js[l], C = Lt.call(js, l) ? h.length : 0; C--; ) {
          var S = h[C], P = S.func;
          if (P == null || P == s)
            return S.name;
        }
        return l;
      }
      function Js(s) {
        var l = Lt.call(A, "placeholder") ? A : s;
        return l.placeholder;
      }
      function Oe() {
        var s = A.iteratee || J0;
        return s = s === J0 ? e9 : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function Hu(s, l) {
        var h = s.__data__;
        return $S(l) ? h[typeof l == "string" ? "string" : "hash"] : h.map;
      }
      function H0(s) {
        for (var l = yn(s), h = l.length; h--; ) {
          var C = l[h], S = s[C];
          l[h] = [C, S, F9(S)];
        }
        return l;
      }
      function ji(s, l) {
        var h = Gy(s, l);
        return Q4(h) ? h : n;
      }
      function FS(s) {
        var l = Lt.call(s, Zi), h = s[Zi];
        try {
          s[Zi] = n;
          var C = !0;
        } catch {
        }
        var S = du.call(s);
        return C && (l ? s[Zi] = h : delete s[Zi]), S;
      }
      var F0 = l0 ? function(s) {
        return s == null ? [] : (s = Tt(s), oi(l0(s), function(l) {
          return D4.call(s, l);
        }));
      } : Q0, _9 = l0 ? function(s) {
        for (var l = []; s; )
          ii(l, F0(s)), s = pu(s);
        return l;
      } : Q0, Mn = Tn;
      (u0 && Mn(new u0(new ArrayBuffer(1))) != me || o1 && Mn(new o1()) != ve || c0 && Mn(c0.resolve()) != un || Gs && Mn(new Gs()) != Pt || i1 && Mn(new i1()) != An) && (Mn = function(s) {
        var l = Tn(s), h = l == ft ? s.constructor : n, C = h ? Xi(h) : "";
        if (C)
          switch (C) {
            case Cx:
              return me;
            case vx:
              return ve;
            case bx:
              return un;
            case yx:
              return Pt;
            case xx:
              return An;
          }
        return l;
      });
      function kS(s, l, h) {
        for (var C = -1, S = h.length; ++C < S; ) {
          var P = h[C], T = P.size;
          switch (P.type) {
            case "drop":
              s += T;
              break;
            case "dropRight":
              l -= T;
              break;
            case "take":
              l = Ln(l, s + T);
              break;
            case "takeRight":
              s = fn(s, l - T);
              break;
          }
        }
        return { start: s, end: l };
      }
      function BS(s) {
        var l = s.match(so);
        return l ? l[1].split(Xa) : [];
      }
      function T9(s, l, h) {
        l = ci(l, s);
        for (var C = -1, S = l.length, P = !1; ++C < S; ) {
          var T = co(l[C]);
          if (!(P = s != null && h(s, T)))
            break;
          s = s[T];
        }
        return P || ++C != S ? P : (S = s == null ? 0 : s.length, !!S && Zu(S) && Po(T, S) && (Ke(s) || Ui(s)));
      }
      function DS(s) {
        var l = s.length, h = new s.constructor(l);
        return l && typeof s[0] == "string" && Lt.call(s, "index") && (h.index = s.index, h.input = s.input), h;
      }
      function H9(s) {
        return typeof s.constructor == "function" && !p1(s) ? Xs(pu(s)) : {};
      }
      function OS(s, l, h) {
        var C = s.constructor;
        switch (l) {
          case vn:
            return M0(s);
          case pe:
          case Se:
            return new C(+s);
          case me:
            return SS(s, h);
          case gt:
          case zt:
          case sn:
          case Zn:
          case zr:
          case Hi:
          case Fi:
          case nr:
          case io:
            return m9(s, h);
          case ve:
            return new C();
          case ot:
          case jt:
            return new C(s);
          case Ct:
            return wS(s);
          case Pt:
            return new C();
          case Xt:
            return IS(s);
        }
      }
      function NS(s, l) {
        var h = l.length;
        if (!h)
          return s;
        var C = h - 1;
        return l[C] = (h > 1 ? "& " : "") + l[C], l = l.join(h > 2 ? ", " : " "), s.replace(ja, `{
/* [wrapped with ` + l + `] */
`);
      }
      function ZS(s) {
        return Ke(s) || Ui(s) || !!(O4 && s && s[O4]);
      }
      function Po(s, l) {
        var h = typeof s;
        return l = l ?? Y, !!l && (h == "number" || h != "symbol" && Dt.test(s)) && s > -1 && s % 1 == 0 && s < l;
      }
      function Hn(s, l, h) {
        if (!Wt(h))
          return !1;
        var C = typeof l;
        return (C == "number" ? zn(h) && Po(l, h.length) : C == "string" && l in h) ? Xr(h[l], s) : !1;
      }
      function k0(s, l) {
        if (Ke(s))
          return !1;
        var h = typeof s;
        return h == "number" || h == "symbol" || h == "boolean" || s == null || ar(s) ? !0 : Es.test(s) || !Ps.test(s) || l != null && s in Tt(l);
      }
      function $S(s) {
        var l = typeof s;
        return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? s !== "__proto__" : s === null;
      }
      function B0(s) {
        var l = Tu(s), h = A[l];
        if (typeof h != "function" || !(l in dt.prototype))
          return !1;
        if (s === h)
          return !0;
        var C = T0(h);
        return !!C && s === C[0];
      }
      function zS(s) {
        return !!F4 && F4 in s;
      }
      var WS = uu ? Eo : ed;
      function p1(s) {
        var l = s && s.constructor, h = typeof l == "function" && l.prototype || Ws;
        return s === h;
      }
      function F9(s) {
        return s === s && !Wt(s);
      }
      function k9(s, l) {
        return function(h) {
          return h == null ? !1 : h[s] === l && (l !== n || s in Tt(h));
        };
      }
      function GS(s) {
        var l = Ou(s, function(C) {
          return h.size === d && h.clear(), C;
        }), h = l.cache;
        return l;
      }
      function jS(s, l) {
        var h = s[1], C = l[1], S = h | C, P = S < (y | w | _), T = C == _ && h == V || C == _ && h == H && s[7].length <= l[8] || C == (_ | H) && l[7].length <= l[8] && h == V;
        if (!(P || T))
          return s;
        C & y && (s[2] = l[2], S |= h & y ? 0 : I);
        var k = l[3];
        if (k) {
          var $ = s[3];
          s[3] = $ ? v9($, k, l[4]) : k, s[4] = $ ? si(s[3], f) : l[4];
        }
        return k = l[5], k && ($ = s[5], s[5] = $ ? b9($, k, l[6]) : k, s[6] = $ ? si(s[5], f) : l[6]), k = l[7], k && (s[7] = k), C & _ && (s[8] = s[8] == null ? l[8] : Ln(s[8], l[8])), s[9] == null && (s[9] = l[9]), s[0] = l[0], s[1] = S, s;
      }
      function XS(s) {
        var l = [];
        if (s != null)
          for (var h in Tt(s))
            l.push(h);
        return l;
      }
      function US(s) {
        return du.call(s);
      }
      function B9(s, l, h) {
        return l = fn(l === n ? s.length - 1 : l, 0), function() {
          for (var C = arguments, S = -1, P = fn(C.length - l, 0), T = J(P); ++S < P; )
            T[S] = C[l + S];
          S = -1;
          for (var k = J(l + 1); ++S < l; )
            k[S] = C[S];
          return k[l] = h(T), or(s, this, k);
        };
      }
      function D9(s, l) {
        return l.length < 2 ? s : Gi(s, wr(l, 0, -1));
      }
      function YS(s, l) {
        for (var h = s.length, C = Ln(l.length, h), S = $n(s); C--; ) {
          var P = l[C];
          s[C] = Po(P, h) ? S[P] : n;
        }
        return s;
      }
      function D0(s, l) {
        if (!(l === "constructor" && typeof s[l] == "function") && l != "__proto__")
          return s[l];
      }
      var O9 = Z9(l9), g1 = cx || function(s, l) {
        return Qe.setTimeout(s, l);
      }, O0 = Z9(vS);
      function N9(s, l, h) {
        var C = l + "";
        return O0(s, NS(C, JS(BS(C), h)));
      }
      function Z9(s) {
        var l = 0, h = 0;
        return function() {
          var C = px(), S = ue - (C - h);
          if (h = C, S > 0) {
            if (++l >= se)
              return arguments[0];
          } else
            l = 0;
          return s.apply(n, arguments);
        };
      }
      function Fu(s, l) {
        var h = -1, C = s.length, S = C - 1;
        for (l = l === n ? C : l; ++h < l; ) {
          var P = x0(h, S), T = s[P];
          s[P] = s[h], s[h] = T;
        }
        return s.length = l, s;
      }
      var $9 = GS(function(s) {
        var l = [];
        return s.charCodeAt(0) === 46 && l.push(""), s.replace(rr, function(h, C, S, P) {
          l.push(S ? P.replace(we, "$1") : C || h);
        }), l;
      });
      function co(s) {
        if (typeof s == "string" || ar(s))
          return s;
        var l = s + "";
        return l == "0" && 1 / s == -z ? "-0" : l;
      }
      function Xi(s) {
        if (s != null) {
          try {
            return cu.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function JS(s, l) {
        return br(re, function(h) {
          var C = "_." + h[0];
          l & h[1] && !iu(s, C) && s.push(C);
        }), s.sort();
      }
      function z9(s) {
        if (s instanceof dt)
          return s.clone();
        var l = new xr(s.__wrapped__, s.__chain__);
        return l.__actions__ = $n(s.__actions__), l.__index__ = s.__index__, l.__values__ = s.__values__, l;
      }
      function qS(s, l, h) {
        (h ? Hn(s, l, h) : l === n) ? l = 1 : l = fn(tt(l), 0);
        var C = s == null ? 0 : s.length;
        if (!C || l < 1)
          return [];
        for (var S = 0, P = 0, T = J(Cu(C / l)); S < C; )
          T[P++] = wr(s, S, S += l);
        return T;
      }
      function KS(s) {
        for (var l = -1, h = s == null ? 0 : s.length, C = 0, S = []; ++l < h; ) {
          var P = s[l];
          P && (S[C++] = P);
        }
        return S;
      }
      function QS() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var l = J(s - 1), h = arguments[0], C = s; C--; )
          l[C - 1] = arguments[C];
        return ii(Ke(h) ? $n(h) : [h], wn(l, 1));
      }
      var ew = st(function(s, l) {
        return Qt(s) ? u1(s, wn(l, 1, Qt, !0)) : [];
      }), tw = st(function(s, l) {
        var h = Ir(l);
        return Qt(h) && (h = n), Qt(s) ? u1(s, wn(l, 1, Qt, !0), Oe(h, 2)) : [];
      }), nw = st(function(s, l) {
        var h = Ir(l);
        return Qt(h) && (h = n), Qt(s) ? u1(s, wn(l, 1, Qt, !0), n, h) : [];
      });
      function rw(s, l, h) {
        var C = s == null ? 0 : s.length;
        return C ? (l = h || l === n ? 1 : tt(l), wr(s, l < 0 ? 0 : l, C)) : [];
      }
      function ow(s, l, h) {
        var C = s == null ? 0 : s.length;
        return C ? (l = h || l === n ? 1 : tt(l), l = C - l, wr(s, 0, l < 0 ? 0 : l)) : [];
      }
      function iw(s, l) {
        return s && s.length ? Lu(s, Oe(l, 3), !0, !0) : [];
      }
      function sw(s, l) {
        return s && s.length ? Lu(s, Oe(l, 3), !0) : [];
      }
      function aw(s, l, h, C) {
        var S = s == null ? 0 : s.length;
        return S ? (h && typeof h != "number" && Hn(s, l, h) && (h = 0, C = S), Qx(s, l, h, C)) : [];
      }
      function W9(s, l, h) {
        var C = s == null ? 0 : s.length;
        if (!C)
          return -1;
        var S = h == null ? 0 : tt(h);
        return S < 0 && (S = fn(C + S, 0)), su(s, Oe(l, 3), S);
      }
      function G9(s, l, h) {
        var C = s == null ? 0 : s.length;
        if (!C)
          return -1;
        var S = C - 1;
        return h !== n && (S = tt(h), S = h < 0 ? fn(C + S, 0) : Ln(S, C - 1)), su(s, Oe(l, 3), S, !0);
      }
      function j9(s) {
        var l = s == null ? 0 : s.length;
        return l ? wn(s, 1) : [];
      }
      function lw(s) {
        var l = s == null ? 0 : s.length;
        return l ? wn(s, z) : [];
      }
      function uw(s, l) {
        var h = s == null ? 0 : s.length;
        return h ? (l = l === n ? 1 : tt(l), wn(s, l)) : [];
      }
      function cw(s) {
        for (var l = -1, h = s == null ? 0 : s.length, C = {}; ++l < h; ) {
          var S = s[l];
          C[S[0]] = S[1];
        }
        return C;
      }
      function X9(s) {
        return s && s.length ? s[0] : n;
      }
      function dw(s, l, h) {
        var C = s == null ? 0 : s.length;
        if (!C)
          return -1;
        var S = h == null ? 0 : tt(h);
        return S < 0 && (S = fn(C + S, 0)), Ns(s, l, S);
      }
      function fw(s) {
        var l = s == null ? 0 : s.length;
        return l ? wr(s, 0, -1) : [];
      }
      var hw = st(function(s) {
        var l = Zt(s, A0);
        return l.length && l[0] === s[0] ? m0(l) : [];
      }), pw = st(function(s) {
        var l = Ir(s), h = Zt(s, A0);
        return l === Ir(h) ? l = n : h.pop(), h.length && h[0] === s[0] ? m0(h, Oe(l, 2)) : [];
      }), gw = st(function(s) {
        var l = Ir(s), h = Zt(s, A0);
        return l = typeof l == "function" ? l : n, l && h.pop(), h.length && h[0] === s[0] ? m0(h, n, l) : [];
      });
      function mw(s, l) {
        return s == null ? "" : fx.call(s, l);
      }
      function Ir(s) {
        var l = s == null ? 0 : s.length;
        return l ? s[l - 1] : n;
      }
      function Cw(s, l, h) {
        var C = s == null ? 0 : s.length;
        if (!C)
          return -1;
        var S = C;
        return h !== n && (S = tt(h), S = S < 0 ? fn(C + S, 0) : Ln(S, C - 1)), l === l ? Jy(s, l, S) : su(s, L4, S, !0);
      }
      function vw(s, l) {
        return s && s.length ? o9(s, tt(l)) : n;
      }
      var bw = st(U9);
      function U9(s, l) {
        return s && s.length && l && l.length ? y0(s, l) : s;
      }
      function yw(s, l, h) {
        return s && s.length && l && l.length ? y0(s, l, Oe(h, 2)) : s;
      }
      function xw(s, l, h) {
        return s && s.length && l && l.length ? y0(s, l, n, h) : s;
      }
      var Sw = Mo(function(s, l) {
        var h = s == null ? 0 : s.length, C = f0(s, l);
        return a9(s, Zt(l, function(S) {
          return Po(S, h) ? +S : S;
        }).sort(C9)), C;
      });
      function ww(s, l) {
        var h = [];
        if (!(s && s.length))
          return h;
        var C = -1, S = [], P = s.length;
        for (l = Oe(l, 3); ++C < P; ) {
          var T = s[C];
          l(T, C, s) && (h.push(T), S.push(C));
        }
        return a9(s, S), h;
      }
      function N0(s) {
        return s == null ? s : mx.call(s);
      }
      function Iw(s, l, h) {
        var C = s == null ? 0 : s.length;
        return C ? (h && typeof h != "number" && Hn(s, l, h) ? (l = 0, h = C) : (l = l == null ? 0 : tt(l), h = h === n ? C : tt(h)), wr(s, l, h)) : [];
      }
      function Vw(s, l) {
        return Au(s, l);
      }
      function Aw(s, l, h) {
        return w0(s, l, Oe(h, 2));
      }
      function Lw(s, l) {
        var h = s == null ? 0 : s.length;
        if (h) {
          var C = Au(s, l);
          if (C < h && Xr(s[C], l))
            return C;
        }
        return -1;
      }
      function Mw(s, l) {
        return Au(s, l, !0);
      }
      function Pw(s, l, h) {
        return w0(s, l, Oe(h, 2), !0);
      }
      function Ew(s, l) {
        var h = s == null ? 0 : s.length;
        if (h) {
          var C = Au(s, l, !0) - 1;
          if (Xr(s[C], l))
            return C;
        }
        return -1;
      }
      function Rw(s) {
        return s && s.length ? u9(s) : [];
      }
      function _w(s, l) {
        return s && s.length ? u9(s, Oe(l, 2)) : [];
      }
      function Tw(s) {
        var l = s == null ? 0 : s.length;
        return l ? wr(s, 1, l) : [];
      }
      function Hw(s, l, h) {
        return s && s.length ? (l = h || l === n ? 1 : tt(l), wr(s, 0, l < 0 ? 0 : l)) : [];
      }
      function Fw(s, l, h) {
        var C = s == null ? 0 : s.length;
        return C ? (l = h || l === n ? 1 : tt(l), l = C - l, wr(s, l < 0 ? 0 : l, C)) : [];
      }
      function kw(s, l) {
        return s && s.length ? Lu(s, Oe(l, 3), !1, !0) : [];
      }
      function Bw(s, l) {
        return s && s.length ? Lu(s, Oe(l, 3)) : [];
      }
      var Dw = st(function(s) {
        return ui(wn(s, 1, Qt, !0));
      }), Ow = st(function(s) {
        var l = Ir(s);
        return Qt(l) && (l = n), ui(wn(s, 1, Qt, !0), Oe(l, 2));
      }), Nw = st(function(s) {
        var l = Ir(s);
        return l = typeof l == "function" ? l : n, ui(wn(s, 1, Qt, !0), n, l);
      });
      function Zw(s) {
        return s && s.length ? ui(s) : [];
      }
      function $w(s, l) {
        return s && s.length ? ui(s, Oe(l, 2)) : [];
      }
      function zw(s, l) {
        return l = typeof l == "function" ? l : n, s && s.length ? ui(s, n, l) : [];
      }
      function Z0(s) {
        if (!(s && s.length))
          return [];
        var l = 0;
        return s = oi(s, function(h) {
          if (Qt(h))
            return l = fn(h.length, l), !0;
        }), o0(l, function(h) {
          return Zt(s, t0(h));
        });
      }
      function Y9(s, l) {
        if (!(s && s.length))
          return [];
        var h = Z0(s);
        return l == null ? h : Zt(h, function(C) {
          return or(l, n, C);
        });
      }
      var Ww = st(function(s, l) {
        return Qt(s) ? u1(s, l) : [];
      }), Gw = st(function(s) {
        return V0(oi(s, Qt));
      }), jw = st(function(s) {
        var l = Ir(s);
        return Qt(l) && (l = n), V0(oi(s, Qt), Oe(l, 2));
      }), Xw = st(function(s) {
        var l = Ir(s);
        return l = typeof l == "function" ? l : n, V0(oi(s, Qt), n, l);
      }), Uw = st(Z0);
      function Yw(s, l) {
        return h9(s || [], l || [], l1);
      }
      function Jw(s, l) {
        return h9(s || [], l || [], f1);
      }
      var qw = st(function(s) {
        var l = s.length, h = l > 1 ? s[l - 1] : n;
        return h = typeof h == "function" ? (s.pop(), h) : n, Y9(s, h);
      });
      function J9(s) {
        var l = A(s);
        return l.__chain__ = !0, l;
      }
      function Kw(s, l) {
        return l(s), s;
      }
      function ku(s, l) {
        return l(s);
      }
      var Qw = Mo(function(s) {
        var l = s.length, h = l ? s[0] : 0, C = this.__wrapped__, S = function(P) {
          return f0(P, s);
        };
        return l > 1 || this.__actions__.length || !(C instanceof dt) || !Po(h) ? this.thru(S) : (C = C.slice(h, +h + (l ? 1 : 0)), C.__actions__.push({
          func: ku,
          args: [S],
          thisArg: n
        }), new xr(C, this.__chain__).thru(function(P) {
          return l && !P.length && P.push(n), P;
        }));
      });
      function eI() {
        return J9(this);
      }
      function tI() {
        return new xr(this.value(), this.__chain__);
      }
      function nI() {
        this.__values__ === n && (this.__values__ = c7(this.value()));
        var s = this.__index__ >= this.__values__.length, l = s ? n : this.__values__[this.__index__++];
        return { done: s, value: l };
      }
      function rI() {
        return this;
      }
      function oI(s) {
        for (var l, h = this; h instanceof xu; ) {
          var C = z9(h);
          C.__index__ = 0, C.__values__ = n, l ? S.__wrapped__ = C : l = C;
          var S = C;
          h = h.__wrapped__;
        }
        return S.__wrapped__ = s, l;
      }
      function iI() {
        var s = this.__wrapped__;
        if (s instanceof dt) {
          var l = s;
          return this.__actions__.length && (l = new dt(this)), l = l.reverse(), l.__actions__.push({
            func: ku,
            args: [N0],
            thisArg: n
          }), new xr(l, this.__chain__);
        }
        return this.thru(N0);
      }
      function sI() {
        return f9(this.__wrapped__, this.__actions__);
      }
      var aI = Mu(function(s, l, h) {
        Lt.call(s, h) ? ++s[h] : Ao(s, h, 1);
      });
      function lI(s, l, h) {
        var C = Ke(s) ? V4 : Kx;
        return h && Hn(s, l, h) && (l = n), C(s, Oe(l, 3));
      }
      function uI(s, l) {
        var h = Ke(s) ? oi : Y4;
        return h(s, Oe(l, 3));
      }
      var cI = w9(W9), dI = w9(G9);
      function fI(s, l) {
        return wn(Bu(s, l), 1);
      }
      function hI(s, l) {
        return wn(Bu(s, l), z);
      }
      function pI(s, l, h) {
        return h = h === n ? 1 : tt(h), wn(Bu(s, l), h);
      }
      function q9(s, l) {
        var h = Ke(s) ? br : li;
        return h(s, Oe(l, 3));
      }
      function K9(s, l) {
        var h = Ke(s) ? Ty : U4;
        return h(s, Oe(l, 3));
      }
      var gI = Mu(function(s, l, h) {
        Lt.call(s, h) ? s[h].push(l) : Ao(s, h, [l]);
      });
      function mI(s, l, h, C) {
        s = zn(s) ? s : Ks(s), h = h && !C ? tt(h) : 0;
        var S = s.length;
        return h < 0 && (h = fn(S + h, 0)), $u(s) ? h <= S && s.indexOf(l, h) > -1 : !!S && Ns(s, l, h) > -1;
      }
      var CI = st(function(s, l, h) {
        var C = -1, S = typeof l == "function", P = zn(s) ? J(s.length) : [];
        return li(s, function(T) {
          P[++C] = S ? or(l, T, h) : c1(T, l, h);
        }), P;
      }), vI = Mu(function(s, l, h) {
        Ao(s, h, l);
      });
      function Bu(s, l) {
        var h = Ke(s) ? Zt : t9;
        return h(s, Oe(l, 3));
      }
      function bI(s, l, h, C) {
        return s == null ? [] : (Ke(l) || (l = l == null ? [] : [l]), h = C ? n : h, Ke(h) || (h = h == null ? [] : [h]), i9(s, l, h));
      }
      var yI = Mu(function(s, l, h) {
        s[h ? 0 : 1].push(l);
      }, function() {
        return [[], []];
      });
      function xI(s, l, h) {
        var C = Ke(s) ? Q2 : P4, S = arguments.length < 3;
        return C(s, Oe(l, 4), h, S, li);
      }
      function SI(s, l, h) {
        var C = Ke(s) ? Hy : P4, S = arguments.length < 3;
        return C(s, Oe(l, 4), h, S, U4);
      }
      function wI(s, l) {
        var h = Ke(s) ? oi : Y4;
        return h(s, Nu(Oe(l, 3)));
      }
      function II(s) {
        var l = Ke(s) ? W4 : mS;
        return l(s);
      }
      function VI(s, l, h) {
        (h ? Hn(s, l, h) : l === n) ? l = 1 : l = tt(l);
        var C = Ke(s) ? Xx : CS;
        return C(s, l);
      }
      function AI(s) {
        var l = Ke(s) ? Ux : bS;
        return l(s);
      }
      function LI(s) {
        if (s == null)
          return 0;
        if (zn(s))
          return $u(s) ? $s(s) : s.length;
        var l = Mn(s);
        return l == ve || l == Pt ? s.size : v0(s).length;
      }
      function MI(s, l, h) {
        var C = Ke(s) ? e0 : yS;
        return h && Hn(s, l, h) && (l = n), C(s, Oe(l, 3));
      }
      var PI = st(function(s, l) {
        if (s == null)
          return [];
        var h = l.length;
        return h > 1 && Hn(s, l[0], l[1]) ? l = [] : h > 2 && Hn(l[0], l[1], l[2]) && (l = [l[0]]), i9(s, wn(l, 1), []);
      }), Du = ux || function() {
        return Qe.Date.now();
      };
      function EI(s, l) {
        if (typeof l != "function")
          throw new yr(a);
        return s = tt(s), function() {
          if (--s < 1)
            return l.apply(this, arguments);
        };
      }
      function Q9(s, l, h) {
        return l = h ? n : l, l = s && l == null ? s.length : l, Lo(s, _, n, n, n, n, l);
      }
      function e7(s, l) {
        var h;
        if (typeof l != "function")
          throw new yr(a);
        return s = tt(s), function() {
          return --s > 0 && (h = l.apply(this, arguments)), s <= 1 && (l = n), h;
        };
      }
      var $0 = st(function(s, l, h) {
        var C = y;
        if (h.length) {
          var S = si(h, Js($0));
          C |= L;
        }
        return Lo(s, C, l, h, S);
      }), t7 = st(function(s, l, h) {
        var C = y | w;
        if (h.length) {
          var S = si(h, Js(t7));
          C |= L;
        }
        return Lo(l, C, s, h, S);
      });
      function n7(s, l, h) {
        l = h ? n : l;
        var C = Lo(s, V, n, n, n, n, n, l);
        return C.placeholder = n7.placeholder, C;
      }
      function r7(s, l, h) {
        l = h ? n : l;
        var C = Lo(s, M, n, n, n, n, n, l);
        return C.placeholder = r7.placeholder, C;
      }
      function o7(s, l, h) {
        var C, S, P, T, k, $, ne = 0, oe = !1, le = !1, Ie = !0;
        if (typeof s != "function")
          throw new yr(a);
        l = Vr(l) || 0, Wt(h) && (oe = !!h.leading, le = "maxWait" in h, P = le ? fn(Vr(h.maxWait) || 0, l) : P, Ie = "trailing" in h ? !!h.trailing : Ie);
        function Re(en) {
          var Ur = C, _o = S;
          return C = S = n, ne = en, T = s.apply(_o, Ur), T;
        }
        function $e(en) {
          return ne = en, k = g1(ct, l), oe ? Re(en) : T;
        }
        function rt(en) {
          var Ur = en - $, _o = en - ne, w7 = l - Ur;
          return le ? Ln(w7, P - _o) : w7;
        }
        function ze(en) {
          var Ur = en - $, _o = en - ne;
          return $ === n || Ur >= l || Ur < 0 || le && _o >= P;
        }
        function ct() {
          var en = Du();
          if (ze(en))
            return ht(en);
          k = g1(ct, rt(en));
        }
        function ht(en) {
          return k = n, Ie && C ? Re(en) : (C = S = n, T);
        }
        function lr() {
          k !== n && p9(k), ne = 0, C = $ = S = k = n;
        }
        function Fn() {
          return k === n ? T : ht(Du());
        }
        function ur() {
          var en = Du(), Ur = ze(en);
          if (C = arguments, S = this, $ = en, Ur) {
            if (k === n)
              return $e($);
            if (le)
              return p9(k), k = g1(ct, l), Re($);
          }
          return k === n && (k = g1(ct, l)), T;
        }
        return ur.cancel = lr, ur.flush = Fn, ur;
      }
      var RI = st(function(s, l) {
        return X4(s, 1, l);
      }), _I = st(function(s, l, h) {
        return X4(s, Vr(l) || 0, h);
      });
      function TI(s) {
        return Lo(s, B);
      }
      function Ou(s, l) {
        if (typeof s != "function" || l != null && typeof l != "function")
          throw new yr(a);
        var h = function() {
          var C = arguments, S = l ? l.apply(this, C) : C[0], P = h.cache;
          if (P.has(S))
            return P.get(S);
          var T = s.apply(this, C);
          return h.cache = P.set(S, T) || P, T;
        };
        return h.cache = new (Ou.Cache || Vo)(), h;
      }
      Ou.Cache = Vo;
      function Nu(s) {
        if (typeof s != "function")
          throw new yr(a);
        return function() {
          var l = arguments;
          switch (l.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, l[0]);
            case 2:
              return !s.call(this, l[0], l[1]);
            case 3:
              return !s.call(this, l[0], l[1], l[2]);
          }
          return !s.apply(this, l);
        };
      }
      function HI(s) {
        return e7(2, s);
      }
      var FI = xS(function(s, l) {
        l = l.length == 1 && Ke(l[0]) ? Zt(l[0], ir(Oe())) : Zt(wn(l, 1), ir(Oe()));
        var h = l.length;
        return st(function(C) {
          for (var S = -1, P = Ln(C.length, h); ++S < P; )
            C[S] = l[S].call(this, C[S]);
          return or(s, this, C);
        });
      }), z0 = st(function(s, l) {
        var h = si(l, Js(z0));
        return Lo(s, L, n, l, h);
      }), i7 = st(function(s, l) {
        var h = si(l, Js(i7));
        return Lo(s, R, n, l, h);
      }), kI = Mo(function(s, l) {
        return Lo(s, H, n, n, n, l);
      });
      function BI(s, l) {
        if (typeof s != "function")
          throw new yr(a);
        return l = l === n ? l : tt(l), st(s, l);
      }
      function DI(s, l) {
        if (typeof s != "function")
          throw new yr(a);
        return l = l == null ? 0 : fn(tt(l), 0), st(function(h) {
          var C = h[l], S = di(h, 0, l);
          return C && ii(S, C), or(s, this, S);
        });
      }
      function OI(s, l, h) {
        var C = !0, S = !0;
        if (typeof s != "function")
          throw new yr(a);
        return Wt(h) && (C = "leading" in h ? !!h.leading : C, S = "trailing" in h ? !!h.trailing : S), o7(s, l, {
          leading: C,
          maxWait: l,
          trailing: S
        });
      }
      function NI(s) {
        return Q9(s, 1);
      }
      function ZI(s, l) {
        return z0(L0(l), s);
      }
      function $I() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return Ke(s) ? s : [s];
      }
      function zI(s) {
        return Sr(s, m);
      }
      function WI(s, l) {
        return l = typeof l == "function" ? l : n, Sr(s, m, l);
      }
      function GI(s) {
        return Sr(s, p | m);
      }
      function jI(s, l) {
        return l = typeof l == "function" ? l : n, Sr(s, p | m, l);
      }
      function XI(s, l) {
        return l == null || j4(s, l, yn(l));
      }
      function Xr(s, l) {
        return s === l || s !== s && l !== l;
      }
      var UI = _u(g0), YI = _u(function(s, l) {
        return s >= l;
      }), Ui = K4(function() {
        return arguments;
      }()) ? K4 : function(s) {
        return Ut(s) && Lt.call(s, "callee") && !D4.call(s, "callee");
      }, Ke = J.isArray, JI = Ds ? ir(Ds) : oS;
      function zn(s) {
        return s != null && Zu(s.length) && !Eo(s);
      }
      function Qt(s) {
        return Ut(s) && zn(s);
      }
      function qI(s) {
        return s === !0 || s === !1 || Ut(s) && Tn(s) == pe;
      }
      var fi = dx || ed, KI = Os ? ir(Os) : iS;
      function QI(s) {
        return Ut(s) && s.nodeType === 1 && !m1(s);
      }
      function eV(s) {
        if (s == null)
          return !0;
        if (zn(s) && (Ke(s) || typeof s == "string" || typeof s.splice == "function" || fi(s) || qs(s) || Ui(s)))
          return !s.length;
        var l = Mn(s);
        if (l == ve || l == Pt)
          return !s.size;
        if (p1(s))
          return !v0(s).length;
        for (var h in s)
          if (Lt.call(s, h))
            return !1;
        return !0;
      }
      function tV(s, l) {
        return d1(s, l);
      }
      function nV(s, l, h) {
        h = typeof h == "function" ? h : n;
        var C = h ? h(s, l) : n;
        return C === n ? d1(s, l, n, h) : !!C;
      }
      function W0(s) {
        if (!Ut(s))
          return !1;
        var l = Tn(s);
        return l == Ve || l == de || typeof s.message == "string" && typeof s.name == "string" && !m1(s);
      }
      function rV(s) {
        return typeof s == "number" && N4(s);
      }
      function Eo(s) {
        if (!Wt(s))
          return !1;
        var l = Tn(s);
        return l == K || l == Ye || l == ge || l == on;
      }
      function s7(s) {
        return typeof s == "number" && s == tt(s);
      }
      function Zu(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= Y;
      }
      function Wt(s) {
        var l = typeof s;
        return s != null && (l == "object" || l == "function");
      }
      function Ut(s) {
        return s != null && typeof s == "object";
      }
      var a7 = t1 ? ir(t1) : aS;
      function oV(s, l) {
        return s === l || C0(s, l, H0(l));
      }
      function iV(s, l, h) {
        return h = typeof h == "function" ? h : n, C0(s, l, H0(l), h);
      }
      function sV(s) {
        return l7(s) && s != +s;
      }
      function aV(s) {
        if (WS(s))
          throw new Je(i);
        return Q4(s);
      }
      function lV(s) {
        return s === null;
      }
      function uV(s) {
        return s == null;
      }
      function l7(s) {
        return typeof s == "number" || Ut(s) && Tn(s) == ot;
      }
      function m1(s) {
        if (!Ut(s) || Tn(s) != ft)
          return !1;
        var l = pu(s);
        if (l === null)
          return !0;
        var h = Lt.call(l, "constructor") && l.constructor;
        return typeof h == "function" && h instanceof h && cu.call(h) == ix;
      }
      var G0 = S4 ? ir(S4) : lS;
      function cV(s) {
        return s7(s) && s >= -Y && s <= Y;
      }
      var u7 = w4 ? ir(w4) : uS;
      function $u(s) {
        return typeof s == "string" || !Ke(s) && Ut(s) && Tn(s) == jt;
      }
      function ar(s) {
        return typeof s == "symbol" || Ut(s) && Tn(s) == Xt;
      }
      var qs = I4 ? ir(I4) : cS;
      function dV(s) {
        return s === n;
      }
      function fV(s) {
        return Ut(s) && Mn(s) == An;
      }
      function hV(s) {
        return Ut(s) && Tn(s) == $r;
      }
      var pV = _u(b0), gV = _u(function(s, l) {
        return s <= l;
      });
      function c7(s) {
        if (!s)
          return [];
        if (zn(s))
          return $u(s) ? Gr(s) : $n(s);
        if (r1 && s[r1])
          return Xy(s[r1]());
        var l = Mn(s), h = l == ve ? s0 : l == Pt ? au : Ks;
        return h(s);
      }
      function Ro(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Vr(s), s === z || s === -z) {
          var l = s < 0 ? -1 : 1;
          return l * ae;
        }
        return s === s ? s : 0;
      }
      function tt(s) {
        var l = Ro(s), h = l % 1;
        return l === l ? h ? l - h : l : 0;
      }
      function d7(s) {
        return s ? Wi(tt(s), 0, X) : 0;
      }
      function Vr(s) {
        if (typeof s == "number")
          return s;
        if (ar(s))
          return j;
        if (Wt(s)) {
          var l = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Wt(l) ? l + "" : l;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = E4(s);
        var h = lt.test(s);
        return h || cn.test(s) ? Ae(s.slice(2), h ? 2 : 8) : vt.test(s) ? j : +s;
      }
      function f7(s) {
        return uo(s, Wn(s));
      }
      function mV(s) {
        return s ? Wi(tt(s), -Y, Y) : s === 0 ? s : 0;
      }
      function wt(s) {
        return s == null ? "" : sr(s);
      }
      var CV = Us(function(s, l) {
        if (p1(l) || zn(l)) {
          uo(l, yn(l), s);
          return;
        }
        for (var h in l)
          Lt.call(l, h) && l1(s, h, l[h]);
      }), h7 = Us(function(s, l) {
        uo(l, Wn(l), s);
      }), zu = Us(function(s, l, h, C) {
        uo(l, Wn(l), s, C);
      }), vV = Us(function(s, l, h, C) {
        uo(l, yn(l), s, C);
      }), bV = Mo(f0);
      function yV(s, l) {
        var h = Xs(s);
        return l == null ? h : G4(h, l);
      }
      var xV = st(function(s, l) {
        s = Tt(s);
        var h = -1, C = l.length, S = C > 2 ? l[2] : n;
        for (S && Hn(l[0], l[1], S) && (C = 1); ++h < C; )
          for (var P = l[h], T = Wn(P), k = -1, $ = T.length; ++k < $; ) {
            var ne = T[k], oe = s[ne];
            (oe === n || Xr(oe, Ws[ne]) && !Lt.call(s, ne)) && (s[ne] = P[ne]);
          }
        return s;
      }), SV = st(function(s) {
        return s.push(n, E9), or(p7, n, s);
      });
      function wV(s, l) {
        return A4(s, Oe(l, 3), lo);
      }
      function IV(s, l) {
        return A4(s, Oe(l, 3), p0);
      }
      function VV(s, l) {
        return s == null ? s : h0(s, Oe(l, 3), Wn);
      }
      function AV(s, l) {
        return s == null ? s : J4(s, Oe(l, 3), Wn);
      }
      function LV(s, l) {
        return s && lo(s, Oe(l, 3));
      }
      function MV(s, l) {
        return s && p0(s, Oe(l, 3));
      }
      function PV(s) {
        return s == null ? [] : Iu(s, yn(s));
      }
      function EV(s) {
        return s == null ? [] : Iu(s, Wn(s));
      }
      function j0(s, l, h) {
        var C = s == null ? n : Gi(s, l);
        return C === n ? h : C;
      }
      function RV(s, l) {
        return s != null && T9(s, l, eS);
      }
      function X0(s, l) {
        return s != null && T9(s, l, tS);
      }
      var _V = V9(function(s, l, h) {
        l != null && typeof l.toString != "function" && (l = du.call(l)), s[l] = h;
      }, Y0(Gn)), TV = V9(function(s, l, h) {
        l != null && typeof l.toString != "function" && (l = du.call(l)), Lt.call(s, l) ? s[l].push(h) : s[l] = [h];
      }, Oe), HV = st(c1);
      function yn(s) {
        return zn(s) ? z4(s) : v0(s);
      }
      function Wn(s) {
        return zn(s) ? z4(s, !0) : dS(s);
      }
      function FV(s, l) {
        var h = {};
        return l = Oe(l, 3), lo(s, function(C, S, P) {
          Ao(h, l(C, S, P), C);
        }), h;
      }
      function kV(s, l) {
        var h = {};
        return l = Oe(l, 3), lo(s, function(C, S, P) {
          Ao(h, S, l(C, S, P));
        }), h;
      }
      var BV = Us(function(s, l, h) {
        Vu(s, l, h);
      }), p7 = Us(function(s, l, h, C) {
        Vu(s, l, h, C);
      }), DV = Mo(function(s, l) {
        var h = {};
        if (s == null)
          return h;
        var C = !1;
        l = Zt(l, function(P) {
          return P = ci(P, s), C || (C = P.length > 1), P;
        }), uo(s, _0(s), h), C && (h = Sr(h, p | g | m, _S));
        for (var S = l.length; S--; )
          I0(h, l[S]);
        return h;
      });
      function OV(s, l) {
        return g7(s, Nu(Oe(l)));
      }
      var NV = Mo(function(s, l) {
        return s == null ? {} : hS(s, l);
      });
      function g7(s, l) {
        if (s == null)
          return {};
        var h = Zt(_0(s), function(C) {
          return [C];
        });
        return l = Oe(l), s9(s, h, function(C, S) {
          return l(C, S[0]);
        });
      }
      function ZV(s, l, h) {
        l = ci(l, s);
        var C = -1, S = l.length;
        for (S || (S = 1, s = n); ++C < S; ) {
          var P = s == null ? n : s[co(l[C])];
          P === n && (C = S, P = h), s = Eo(P) ? P.call(s) : P;
        }
        return s;
      }
      function $V(s, l, h) {
        return s == null ? s : f1(s, l, h);
      }
      function zV(s, l, h, C) {
        return C = typeof C == "function" ? C : n, s == null ? s : f1(s, l, h, C);
      }
      var m7 = M9(yn), C7 = M9(Wn);
      function WV(s, l, h) {
        var C = Ke(s), S = C || fi(s) || qs(s);
        if (l = Oe(l, 4), h == null) {
          var P = s && s.constructor;
          S ? h = C ? new P() : [] : Wt(s) ? h = Eo(P) ? Xs(pu(s)) : {} : h = {};
        }
        return (S ? br : lo)(s, function(T, k, $) {
          return l(h, T, k, $);
        }), h;
      }
      function GV(s, l) {
        return s == null ? !0 : I0(s, l);
      }
      function jV(s, l, h) {
        return s == null ? s : d9(s, l, L0(h));
      }
      function XV(s, l, h, C) {
        return C = typeof C == "function" ? C : n, s == null ? s : d9(s, l, L0(h), C);
      }
      function Ks(s) {
        return s == null ? [] : i0(s, yn(s));
      }
      function UV(s) {
        return s == null ? [] : i0(s, Wn(s));
      }
      function YV(s, l, h) {
        return h === n && (h = l, l = n), h !== n && (h = Vr(h), h = h === h ? h : 0), l !== n && (l = Vr(l), l = l === l ? l : 0), Wi(Vr(s), l, h);
      }
      function JV(s, l, h) {
        return l = Ro(l), h === n ? (h = l, l = 0) : h = Ro(h), s = Vr(s), nS(s, l, h);
      }
      function qV(s, l, h) {
        if (h && typeof h != "boolean" && Hn(s, l, h) && (l = h = n), h === n && (typeof l == "boolean" ? (h = l, l = n) : typeof s == "boolean" && (h = s, s = n)), s === n && l === n ? (s = 0, l = 1) : (s = Ro(s), l === n ? (l = s, s = 0) : l = Ro(l)), s > l) {
          var C = s;
          s = l, l = C;
        }
        if (h || s % 1 || l % 1) {
          var S = Z4();
          return Ln(s + S * (l - s + U("1e-" + ((S + "").length - 1))), l);
        }
        return x0(s, l);
      }
      var KV = Ys(function(s, l, h) {
        return l = l.toLowerCase(), s + (h ? v7(l) : l);
      });
      function v7(s) {
        return U0(wt(s).toLowerCase());
      }
      function b7(s) {
        return s = wt(s), s && s.replace(Nt, $y).replace(tu, "");
      }
      function QV(s, l, h) {
        s = wt(s), l = sr(l);
        var C = s.length;
        h = h === n ? C : Wi(tt(h), 0, C);
        var S = h;
        return h -= l.length, h >= 0 && s.slice(h, S) == l;
      }
      function eA(s) {
        return s = wt(s), s && vr.test(s) ? s.replace(Cr, zy) : s;
      }
      function tA(s) {
        return s = wt(s), s && Rs.test(s) ? s.replace(Bi, "\\$&") : s;
      }
      var nA = Ys(function(s, l, h) {
        return s + (h ? "-" : "") + l.toLowerCase();
      }), rA = Ys(function(s, l, h) {
        return s + (h ? " " : "") + l.toLowerCase();
      }), oA = S9("toLowerCase");
      function iA(s, l, h) {
        s = wt(s), l = tt(l);
        var C = l ? $s(s) : 0;
        if (!l || C >= l)
          return s;
        var S = (l - C) / 2;
        return Ru(vu(S), h) + s + Ru(Cu(S), h);
      }
      function sA(s, l, h) {
        s = wt(s), l = tt(l);
        var C = l ? $s(s) : 0;
        return l && C < l ? s + Ru(l - C, h) : s;
      }
      function aA(s, l, h) {
        s = wt(s), l = tt(l);
        var C = l ? $s(s) : 0;
        return l && C < l ? Ru(l - C, h) + s : s;
      }
      function lA(s, l, h) {
        return h || l == null ? l = 0 : l && (l = +l), gx(wt(s).replace(ni, ""), l || 0);
      }
      function uA(s, l, h) {
        return (h ? Hn(s, l, h) : l === n) ? l = 1 : l = tt(l), S0(wt(s), l);
      }
      function cA() {
        var s = arguments, l = wt(s[0]);
        return s.length < 3 ? l : l.replace(s[1], s[2]);
      }
      var dA = Ys(function(s, l, h) {
        return s + (h ? "_" : "") + l.toLowerCase();
      });
      function fA(s, l, h) {
        return h && typeof h != "number" && Hn(s, l, h) && (l = h = n), h = h === n ? X : h >>> 0, h ? (s = wt(s), s && (typeof l == "string" || l != null && !G0(l)) && (l = sr(l), !l && Zs(s)) ? di(Gr(s), 0, h) : s.split(l, h)) : [];
      }
      var hA = Ys(function(s, l, h) {
        return s + (h ? " " : "") + U0(l);
      });
      function pA(s, l, h) {
        return s = wt(s), h = h == null ? 0 : Wi(tt(h), 0, s.length), l = sr(l), s.slice(h, h + l.length) == l;
      }
      function gA(s, l, h) {
        var C = A.templateSettings;
        h && Hn(s, l, h) && (l = n), s = wt(s), l = zu({}, l, C, P9);
        var S = zu({}, l.imports, C.imports, P9), P = yn(S), T = i0(S, P), k, $, ne = 0, oe = l.interpolate || Kt, le = "__p += '", Ie = a0(
          (l.escape || Kt).source + "|" + oe.source + "|" + (oe === Ms ? Ze : Kt).source + "|" + (l.evaluate || Kt).source + "|$",
          "g"
        ), Re = "//# sourceURL=" + (Lt.call(l, "sourceURL") ? (l.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ru + "]") + `
`;
        s.replace(Ie, function(ze, ct, ht, lr, Fn, ur) {
          return ht || (ht = lr), le += s.slice(ne, ur).replace(ao, Wy), ct && (k = !0, le += `' +
__e(` + ct + `) +
'`), Fn && ($ = !0, le += `';
` + Fn + `;
__p += '`), ht && (le += `' +
((__t = (` + ht + `)) == null ? '' : __t) +
'`), ne = ur + ze.length, ze;
        }), le += `';
`;
        var $e = Lt.call(l, "variable") && l.variable;
        if (!$e)
          le = `with (obj) {
` + le + `
}
`;
        else if (fe.test($e))
          throw new Je(u);
        le = ($ ? le.replace(za, "") : le).replace(ti, "$1").replace(As, "$1;"), le = "function(" + ($e || "obj") + `) {
` + ($e ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (k ? ", __e = _.escape" : "") + ($ ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + le + `return __p
}`;
        var rt = x7(function() {
          return bt(P, Re + "return " + le).apply(n, T);
        });
        if (rt.source = le, W0(rt))
          throw rt;
        return rt;
      }
      function mA(s) {
        return wt(s).toLowerCase();
      }
      function CA(s) {
        return wt(s).toUpperCase();
      }
      function vA(s, l, h) {
        if (s = wt(s), s && (h || l === n))
          return E4(s);
        if (!s || !(l = sr(l)))
          return s;
        var C = Gr(s), S = Gr(l), P = R4(C, S), T = _4(C, S) + 1;
        return di(C, P, T).join("");
      }
      function bA(s, l, h) {
        if (s = wt(s), s && (h || l === n))
          return s.slice(0, H4(s) + 1);
        if (!s || !(l = sr(l)))
          return s;
        var C = Gr(s), S = _4(C, Gr(l)) + 1;
        return di(C, 0, S).join("");
      }
      function yA(s, l, h) {
        if (s = wt(s), s && (h || l === n))
          return s.replace(ni, "");
        if (!s || !(l = sr(l)))
          return s;
        var C = Gr(s), S = R4(C, Gr(l));
        return di(C, S).join("");
      }
      function xA(s, l) {
        var h = Z, C = G;
        if (Wt(l)) {
          var S = "separator" in l ? l.separator : S;
          h = "length" in l ? tt(l.length) : h, C = "omission" in l ? sr(l.omission) : C;
        }
        s = wt(s);
        var P = s.length;
        if (Zs(s)) {
          var T = Gr(s);
          P = T.length;
        }
        if (h >= P)
          return s;
        var k = h - $s(C);
        if (k < 1)
          return C;
        var $ = T ? di(T, 0, k).join("") : s.slice(0, k);
        if (S === n)
          return $ + C;
        if (T && (k += $.length - k), G0(S)) {
          if (s.slice(k).search(S)) {
            var ne, oe = $;
            for (S.global || (S = a0(S.source, wt(et.exec(S)) + "g")), S.lastIndex = 0; ne = S.exec(oe); )
              var le = ne.index;
            $ = $.slice(0, le === n ? k : le);
          }
        } else if (s.indexOf(sr(S), k) != k) {
          var Ie = $.lastIndexOf(S);
          Ie > -1 && ($ = $.slice(0, Ie));
        }
        return $ + C;
      }
      function SA(s) {
        return s = wt(s), s && ki.test(s) ? s.replace(mr, qy) : s;
      }
      var wA = Ys(function(s, l, h) {
        return s + (h ? " " : "") + l.toUpperCase();
      }), U0 = S9("toUpperCase");
      function y7(s, l, h) {
        return s = wt(s), l = h ? n : l, l === n ? jy(s) ? ex(s) : By(s) : s.match(l) || [];
      }
      var x7 = st(function(s, l) {
        try {
          return or(s, n, l);
        } catch (h) {
          return W0(h) ? h : new Je(h);
        }
      }), IA = Mo(function(s, l) {
        return br(l, function(h) {
          h = co(h), Ao(s, h, $0(s[h], s));
        }), s;
      });
      function VA(s) {
        var l = s == null ? 0 : s.length, h = Oe();
        return s = l ? Zt(s, function(C) {
          if (typeof C[1] != "function")
            throw new yr(a);
          return [h(C[0]), C[1]];
        }) : [], st(function(C) {
          for (var S = -1; ++S < l; ) {
            var P = s[S];
            if (or(P[0], this, C))
              return or(P[1], this, C);
          }
        });
      }
      function AA(s) {
        return qx(Sr(s, p));
      }
      function Y0(s) {
        return function() {
          return s;
        };
      }
      function LA(s, l) {
        return s == null || s !== s ? l : s;
      }
      var MA = I9(), PA = I9(!0);
      function Gn(s) {
        return s;
      }
      function J0(s) {
        return e9(typeof s == "function" ? s : Sr(s, p));
      }
      function EA(s) {
        return n9(Sr(s, p));
      }
      function RA(s, l) {
        return r9(s, Sr(l, p));
      }
      var _A = st(function(s, l) {
        return function(h) {
          return c1(h, s, l);
        };
      }), TA = st(function(s, l) {
        return function(h) {
          return c1(s, h, l);
        };
      });
      function q0(s, l, h) {
        var C = yn(l), S = Iu(l, C);
        h == null && !(Wt(l) && (S.length || !C.length)) && (h = l, l = s, s = this, S = Iu(l, yn(l)));
        var P = !(Wt(h) && "chain" in h) || !!h.chain, T = Eo(s);
        return br(S, function(k) {
          var $ = l[k];
          s[k] = $, T && (s.prototype[k] = function() {
            var ne = this.__chain__;
            if (P || ne) {
              var oe = s(this.__wrapped__), le = oe.__actions__ = $n(this.__actions__);
              return le.push({ func: $, args: arguments, thisArg: s }), oe.__chain__ = ne, oe;
            }
            return $.apply(s, ii([this.value()], arguments));
          });
        }), s;
      }
      function HA() {
        return Qe._ === this && (Qe._ = sx), this;
      }
      function K0() {
      }
      function FA(s) {
        return s = tt(s), st(function(l) {
          return o9(l, s);
        });
      }
      var kA = P0(Zt), BA = P0(V4), DA = P0(e0);
      function S7(s) {
        return k0(s) ? t0(co(s)) : pS(s);
      }
      function OA(s) {
        return function(l) {
          return s == null ? n : Gi(s, l);
        };
      }
      var NA = A9(), ZA = A9(!0);
      function Q0() {
        return [];
      }
      function ed() {
        return !1;
      }
      function $A() {
        return {};
      }
      function zA() {
        return "";
      }
      function WA() {
        return !0;
      }
      function GA(s, l) {
        if (s = tt(s), s < 1 || s > Y)
          return [];
        var h = X, C = Ln(s, X);
        l = Oe(l), s -= X;
        for (var S = o0(C, l); ++h < s; )
          l(h);
        return S;
      }
      function jA(s) {
        return Ke(s) ? Zt(s, co) : ar(s) ? [s] : $n($9(wt(s)));
      }
      function XA(s) {
        var l = ++ox;
        return wt(s) + l;
      }
      var UA = Eu(function(s, l) {
        return s + l;
      }, 0), YA = E0("ceil"), JA = Eu(function(s, l) {
        return s / l;
      }, 1), qA = E0("floor");
      function KA(s) {
        return s && s.length ? wu(s, Gn, g0) : n;
      }
      function QA(s, l) {
        return s && s.length ? wu(s, Oe(l, 2), g0) : n;
      }
      function eL(s) {
        return M4(s, Gn);
      }
      function tL(s, l) {
        return M4(s, Oe(l, 2));
      }
      function nL(s) {
        return s && s.length ? wu(s, Gn, b0) : n;
      }
      function rL(s, l) {
        return s && s.length ? wu(s, Oe(l, 2), b0) : n;
      }
      var oL = Eu(function(s, l) {
        return s * l;
      }, 1), iL = E0("round"), sL = Eu(function(s, l) {
        return s - l;
      }, 0);
      function aL(s) {
        return s && s.length ? r0(s, Gn) : 0;
      }
      function lL(s, l) {
        return s && s.length ? r0(s, Oe(l, 2)) : 0;
      }
      return A.after = EI, A.ary = Q9, A.assign = CV, A.assignIn = h7, A.assignInWith = zu, A.assignWith = vV, A.at = bV, A.before = e7, A.bind = $0, A.bindAll = IA, A.bindKey = t7, A.castArray = $I, A.chain = J9, A.chunk = qS, A.compact = KS, A.concat = QS, A.cond = VA, A.conforms = AA, A.constant = Y0, A.countBy = aI, A.create = yV, A.curry = n7, A.curryRight = r7, A.debounce = o7, A.defaults = xV, A.defaultsDeep = SV, A.defer = RI, A.delay = _I, A.difference = ew, A.differenceBy = tw, A.differenceWith = nw, A.drop = rw, A.dropRight = ow, A.dropRightWhile = iw, A.dropWhile = sw, A.fill = aw, A.filter = uI, A.flatMap = fI, A.flatMapDeep = hI, A.flatMapDepth = pI, A.flatten = j9, A.flattenDeep = lw, A.flattenDepth = uw, A.flip = TI, A.flow = MA, A.flowRight = PA, A.fromPairs = cw, A.functions = PV, A.functionsIn = EV, A.groupBy = gI, A.initial = fw, A.intersection = hw, A.intersectionBy = pw, A.intersectionWith = gw, A.invert = _V, A.invertBy = TV, A.invokeMap = CI, A.iteratee = J0, A.keyBy = vI, A.keys = yn, A.keysIn = Wn, A.map = Bu, A.mapKeys = FV, A.mapValues = kV, A.matches = EA, A.matchesProperty = RA, A.memoize = Ou, A.merge = BV, A.mergeWith = p7, A.method = _A, A.methodOf = TA, A.mixin = q0, A.negate = Nu, A.nthArg = FA, A.omit = DV, A.omitBy = OV, A.once = HI, A.orderBy = bI, A.over = kA, A.overArgs = FI, A.overEvery = BA, A.overSome = DA, A.partial = z0, A.partialRight = i7, A.partition = yI, A.pick = NV, A.pickBy = g7, A.property = S7, A.propertyOf = OA, A.pull = bw, A.pullAll = U9, A.pullAllBy = yw, A.pullAllWith = xw, A.pullAt = Sw, A.range = NA, A.rangeRight = ZA, A.rearg = kI, A.reject = wI, A.remove = ww, A.rest = BI, A.reverse = N0, A.sampleSize = VI, A.set = $V, A.setWith = zV, A.shuffle = AI, A.slice = Iw, A.sortBy = PI, A.sortedUniq = Rw, A.sortedUniqBy = _w, A.split = fA, A.spread = DI, A.tail = Tw, A.take = Hw, A.takeRight = Fw, A.takeRightWhile = kw, A.takeWhile = Bw, A.tap = Kw, A.throttle = OI, A.thru = ku, A.toArray = c7, A.toPairs = m7, A.toPairsIn = C7, A.toPath = jA, A.toPlainObject = f7, A.transform = WV, A.unary = NI, A.union = Dw, A.unionBy = Ow, A.unionWith = Nw, A.uniq = Zw, A.uniqBy = $w, A.uniqWith = zw, A.unset = GV, A.unzip = Z0, A.unzipWith = Y9, A.update = jV, A.updateWith = XV, A.values = Ks, A.valuesIn = UV, A.without = Ww, A.words = y7, A.wrap = ZI, A.xor = Gw, A.xorBy = jw, A.xorWith = Xw, A.zip = Uw, A.zipObject = Yw, A.zipObjectDeep = Jw, A.zipWith = qw, A.entries = m7, A.entriesIn = C7, A.extend = h7, A.extendWith = zu, q0(A, A), A.add = UA, A.attempt = x7, A.camelCase = KV, A.capitalize = v7, A.ceil = YA, A.clamp = YV, A.clone = zI, A.cloneDeep = GI, A.cloneDeepWith = jI, A.cloneWith = WI, A.conformsTo = XI, A.deburr = b7, A.defaultTo = LA, A.divide = JA, A.endsWith = QV, A.eq = Xr, A.escape = eA, A.escapeRegExp = tA, A.every = lI, A.find = cI, A.findIndex = W9, A.findKey = wV, A.findLast = dI, A.findLastIndex = G9, A.findLastKey = IV, A.floor = qA, A.forEach = q9, A.forEachRight = K9, A.forIn = VV, A.forInRight = AV, A.forOwn = LV, A.forOwnRight = MV, A.get = j0, A.gt = UI, A.gte = YI, A.has = RV, A.hasIn = X0, A.head = X9, A.identity = Gn, A.includes = mI, A.indexOf = dw, A.inRange = JV, A.invoke = HV, A.isArguments = Ui, A.isArray = Ke, A.isArrayBuffer = JI, A.isArrayLike = zn, A.isArrayLikeObject = Qt, A.isBoolean = qI, A.isBuffer = fi, A.isDate = KI, A.isElement = QI, A.isEmpty = eV, A.isEqual = tV, A.isEqualWith = nV, A.isError = W0, A.isFinite = rV, A.isFunction = Eo, A.isInteger = s7, A.isLength = Zu, A.isMap = a7, A.isMatch = oV, A.isMatchWith = iV, A.isNaN = sV, A.isNative = aV, A.isNil = uV, A.isNull = lV, A.isNumber = l7, A.isObject = Wt, A.isObjectLike = Ut, A.isPlainObject = m1, A.isRegExp = G0, A.isSafeInteger = cV, A.isSet = u7, A.isString = $u, A.isSymbol = ar, A.isTypedArray = qs, A.isUndefined = dV, A.isWeakMap = fV, A.isWeakSet = hV, A.join = mw, A.kebabCase = nA, A.last = Ir, A.lastIndexOf = Cw, A.lowerCase = rA, A.lowerFirst = oA, A.lt = pV, A.lte = gV, A.max = KA, A.maxBy = QA, A.mean = eL, A.meanBy = tL, A.min = nL, A.minBy = rL, A.stubArray = Q0, A.stubFalse = ed, A.stubObject = $A, A.stubString = zA, A.stubTrue = WA, A.multiply = oL, A.nth = vw, A.noConflict = HA, A.noop = K0, A.now = Du, A.pad = iA, A.padEnd = sA, A.padStart = aA, A.parseInt = lA, A.random = qV, A.reduce = xI, A.reduceRight = SI, A.repeat = uA, A.replace = cA, A.result = ZV, A.round = iL, A.runInContext = N, A.sample = II, A.size = LI, A.snakeCase = dA, A.some = MI, A.sortedIndex = Vw, A.sortedIndexBy = Aw, A.sortedIndexOf = Lw, A.sortedLastIndex = Mw, A.sortedLastIndexBy = Pw, A.sortedLastIndexOf = Ew, A.startCase = hA, A.startsWith = pA, A.subtract = sL, A.sum = aL, A.sumBy = lL, A.template = gA, A.times = GA, A.toFinite = Ro, A.toInteger = tt, A.toLength = d7, A.toLower = mA, A.toNumber = Vr, A.toSafeInteger = mV, A.toString = wt, A.toUpper = CA, A.trim = vA, A.trimEnd = bA, A.trimStart = yA, A.truncate = xA, A.unescape = SA, A.uniqueId = XA, A.upperCase = wA, A.upperFirst = U0, A.each = q9, A.eachRight = K9, A.first = X9, q0(A, function() {
        var s = {};
        return lo(A, function(l, h) {
          Lt.call(A.prototype, h) || (s[h] = l);
        }), s;
      }(), { chain: !1 }), A.VERSION = r, br(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        A[s].placeholder = A;
      }), br(["drop", "take"], function(s, l) {
        dt.prototype[s] = function(h) {
          h = h === n ? 1 : fn(tt(h), 0);
          var C = this.__filtered__ && !l ? new dt(this) : this.clone();
          return C.__filtered__ ? C.__takeCount__ = Ln(h, C.__takeCount__) : C.__views__.push({
            size: Ln(h, X),
            type: s + (C.__dir__ < 0 ? "Right" : "")
          }), C;
        }, dt.prototype[s + "Right"] = function(h) {
          return this.reverse()[s](h).reverse();
        };
      }), br(["filter", "map", "takeWhile"], function(s, l) {
        var h = l + 1, C = h == ce || h == he;
        dt.prototype[s] = function(S) {
          var P = this.clone();
          return P.__iteratees__.push({
            iteratee: Oe(S, 3),
            type: h
          }), P.__filtered__ = P.__filtered__ || C, P;
        };
      }), br(["head", "last"], function(s, l) {
        var h = "take" + (l ? "Right" : "");
        dt.prototype[s] = function() {
          return this[h](1).value()[0];
        };
      }), br(["initial", "tail"], function(s, l) {
        var h = "drop" + (l ? "" : "Right");
        dt.prototype[s] = function() {
          return this.__filtered__ ? new dt(this) : this[h](1);
        };
      }), dt.prototype.compact = function() {
        return this.filter(Gn);
      }, dt.prototype.find = function(s) {
        return this.filter(s).head();
      }, dt.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, dt.prototype.invokeMap = st(function(s, l) {
        return typeof s == "function" ? new dt(this) : this.map(function(h) {
          return c1(h, s, l);
        });
      }), dt.prototype.reject = function(s) {
        return this.filter(Nu(Oe(s)));
      }, dt.prototype.slice = function(s, l) {
        s = tt(s);
        var h = this;
        return h.__filtered__ && (s > 0 || l < 0) ? new dt(h) : (s < 0 ? h = h.takeRight(-s) : s && (h = h.drop(s)), l !== n && (l = tt(l), h = l < 0 ? h.dropRight(-l) : h.take(l - s)), h);
      }, dt.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, dt.prototype.toArray = function() {
        return this.take(X);
      }, lo(dt.prototype, function(s, l) {
        var h = /^(?:filter|find|map|reject)|While$/.test(l), C = /^(?:head|last)$/.test(l), S = A[C ? "take" + (l == "last" ? "Right" : "") : l], P = C || /^find/.test(l);
        S && (A.prototype[l] = function() {
          var T = this.__wrapped__, k = C ? [1] : arguments, $ = T instanceof dt, ne = k[0], oe = $ || Ke(T), le = function(ct) {
            var ht = S.apply(A, ii([ct], k));
            return C && Ie ? ht[0] : ht;
          };
          oe && h && typeof ne == "function" && ne.length != 1 && ($ = oe = !1);
          var Ie = this.__chain__, Re = !!this.__actions__.length, $e = P && !Ie, rt = $ && !Re;
          if (!P && oe) {
            T = rt ? T : new dt(this);
            var ze = s.apply(T, k);
            return ze.__actions__.push({ func: ku, args: [le], thisArg: n }), new xr(ze, Ie);
          }
          return $e && rt ? s.apply(this, k) : (ze = this.thru(le), $e ? C ? ze.value()[0] : ze.value() : ze);
        });
      }), br(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var l = lu[s], h = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", C = /^(?:pop|shift)$/.test(s);
        A.prototype[s] = function() {
          var S = arguments;
          if (C && !this.__chain__) {
            var P = this.value();
            return l.apply(Ke(P) ? P : [], S);
          }
          return this[h](function(T) {
            return l.apply(Ke(T) ? T : [], S);
          });
        };
      }), lo(dt.prototype, function(s, l) {
        var h = A[l];
        if (h) {
          var C = h.name + "";
          Lt.call(js, C) || (js[C] = []), js[C].push({ name: l, func: h });
        }
      }), js[Pu(n, w).name] = [{
        name: "wrapper",
        func: n
      }], dt.prototype.clone = Sx, dt.prototype.reverse = wx, dt.prototype.value = Ix, A.prototype.at = Qw, A.prototype.chain = eI, A.prototype.commit = tI, A.prototype.next = nI, A.prototype.plant = oI, A.prototype.reverse = iI, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = sI, A.prototype.first = A.prototype.head, r1 && (A.prototype[r1] = rI), A;
    }, zs = tx();
    mt ? ((mt.exports = zs)._ = zs, it._ = zs) : Qe._ = zs;
  }).call(ko);
})(e2, e2.exports);
var r4 = e2.exports;
const MU = (e, t) => {
  if (qe(e) && qe(t))
    return Tp.fromNumber(r4.round(e.unitAmount, t), e.unit);
}, o4 = (e) => e.target.value, i4 = Fe(({ leftAddon: e, rightAddon: t, input: n, leftAddonProps: r = {}, rightAddonProps: o = {} }, i) => {
  const a = F2();
  return /* @__PURE__ */ x.jsxs(k3, { size: a, children: [
    qe(e) && /* @__PURE__ */ x.jsx(
      D3,
      {
        ...r,
        backgroundColor: "transparent",
        borderColor: "transparent",
        height: r.height || "2.75rem",
        children: e
      }
    ),
    n,
    qe(t) && /* @__PURE__ */ x.jsx(
      O3,
      {
        ...o,
        backgroundColor: "transparent",
        borderColor: "transparent",
        children: t
      }
    )
  ] });
});
i4.displayName = "InputWithAddons";
const PU = ({
  commonProps: e,
  ...t
}) => {
  var c;
  const { prefix: n, suffix: r } = t, o = ((c = t.value) == null ? void 0 : c.unit) ?? t.unit, i = {};
  (o || r) && (i.rightAddon = r ?? o, i.rightAddonProps = {
    height: "100%",
    marginY: "auto"
  }), n && (i.leftAddon = n, i.leftAddonProps = {
    height: "100%",
    marginY: "auto"
  });
  const a = t.formatValue ?? ((d) => d == null ? void 0 : d.unitAmount), u = (d) => {
    var p;
    const f = o4(d);
    if (f === "")
      t.onClear();
    else {
      const g = Tp.fromString(f, ((p = t.value) == null ? void 0 : p.unit) ?? "sqft");
      t.onChange(g);
    }
  };
  return /* @__PURE__ */ x.jsx(
    i4,
    {
      ...i,
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          ...e,
          paddingInlineStart: "8px",
          type: "number",
          precision: t.precision,
          onChange: u,
          onBlur: () => {
            var f;
            const d = MU(t.value, t.precision);
            (f = t.onBlur) == null || f.call(t, d);
          },
          value: qe(t.value) && t.value !== "" ? a(t.value) : ""
        }
      )
    }
  );
}, $a = (e) => e ?? "", Ti = (e, t) => (n) => {
  const r = o4(n);
  r === "" ? t() : e(r);
}, EU = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? $a;
  return /* @__PURE__ */ x.jsx(
    er,
    {
      ...e,
      type: "date",
      value: n(t.value),
      onChange: Ti(t.onChange, t.onClear)
    }
  );
}, RU = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? $a;
  return /* @__PURE__ */ x.jsx(
    er,
    {
      ...e,
      type: "email",
      value: n(t.value),
      onChange: Ti(t.onChange, t.onClear)
    }
  );
}, fh = {
  fields: ["address_components"],
  componentRestrictions: { country: ["us"] }
};
function Cb(e, t) {
  const n = Le(document.createElement("div")), r = Le(null), o = Le(null), i = Le(null), a = q(() => {
    var d;
    const u = i.current, c = u == null ? void 0 : u.getPlace();
    if (c) {
      t(c, (d = o.current) == null ? void 0 : d.value);
      return;
    }
    e && (async () => {
      var f;
      try {
        const { AutocompleteService: p, PlacesService: g } = await e.importLibrary("places"), m = ((f = o.current) == null ? void 0 : f.value) ?? "";
        new p().getPlacePredictions(
          { input: m },
          (v, y) => {
            y === google.maps.places.PlacesServiceStatus.OK && (v != null && v.length) && new g(
              r.current
            ).getDetails(
              { placeId: v[0].place_id, ...fh },
              (I) => {
                I && t(I, m);
              }
            );
          }
        );
      } catch (p) {
        console.error("Google Maps fallback failed", p);
      }
    })();
  }, [t, e]);
  return Ue(() => {
    if (!e || !o.current)
      return;
    let u = null;
    return (async () => {
      try {
        const { Autocomplete: c } = await e.importLibrary("places");
        u = new c(o.current, fh), i.current = u, u.addListener("place_changed", a);
        const { Map: d } = await e.importLibrary("maps");
        r.current = new d(n.current, {
          center: { lat: -33.866, lng: 151.196 },
          zoom: 15
        });
      } catch (c) {
        console.error("Google Maps initialization failed", c);
      }
    })(), () => {
      u && google.maps.event.clearInstanceListeners(u);
    };
  }, [a, e]), o;
}
const Rr = (e, t) => {
  var n;
  return (n = e.address_components.find((r) => r.types.includes(t))) == null ? void 0 : n.short_name;
}, _U = (e, t) => {
  var c;
  if (!e)
    return;
  const n = Rr(e, "street_number") || ((c = t == null ? void 0 : t.match(/\d+/)) == null ? void 0 : c[0]);
  if (!n)
    return;
  const r = Rr(e, "route");
  if (!r)
    return;
  const o = Rr(e, "subpremise"), i = Rr(e, "locality");
  if (!i)
    return;
  const a = Rr(e, "administrative_area_level_1");
  if (!a)
    return;
  const u = Rr(e, "postal_code");
  if (u)
    return {
      AddressLineText: `${n} ${r}`,
      unitNumber: o,
      CityName: i,
      StateCode: a,
      PostalCode: u
    };
}, Vs = Fe(({ input: e, icon: t, placeIconRight: n }, r) => {
  const o = F2(), i = /* @__PURE__ */ x.jsx(Fr, { icon: t, size: o === "xs" ? "md" : "lg", color: "textTertiary" });
  return /* @__PURE__ */ x.jsxs(k3, { size: o, children: [
    !n && /* @__PURE__ */ x.jsx(N3, { height: "full", children: i }),
    e,
    n && /* @__PURE__ */ x.jsx(Z3, { height: "full", children: i })
  ] });
});
Vs.displayName = "IconInput";
const TU = ({
  commonProps: e,
  ...t
}) => {
  const n = (o, i) => {
    const a = _U(o, i);
    a && t.onPlaceChanged && t.onPlaceChanged(a);
  }, r = Cb(t.mapsLoader, n);
  return /* @__PURE__ */ x.jsx(
    Vs,
    {
      icon: "map-pin",
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          ...e,
          ref: r,
          type: "text",
          value: t.value ?? "",
          onChange: Ti(t.onChange, t.onClear),
          placeholder: "Enter an address"
        }
      )
    }
  );
}, HU = (e, t) => {
  var c;
  if (!e)
    return;
  const n = Rr(e, "street_number") || ((c = t == null ? void 0 : t.match(/\d+/)) == null ? void 0 : c[0]);
  if (!n)
    return;
  const r = Rr(e, "route");
  if (!r)
    return;
  const o = Rr(e, "subpremise"), i = Rr(e, "locality");
  if (!i)
    return;
  const a = Rr(e, "administrative_area_level_1");
  if (!a)
    return;
  const u = Rr(e, "postal_code");
  if (u)
    return `${n} ${r}${o ? `, ${o}` : ""}, ${i}, ${a}, ${u}`;
}, FU = ({
  commonProps: e,
  ...t
}) => {
  const [n, r] = Ee(
    t.value ? CL(t.value) : ""
  ), [o, i] = Ee(!0), a = (p) => {
    r(p.target.value);
  }, u = () => {
    var p;
    (p = t.onBlur) == null || p.call(t), o || t.setInternalFormWrapperErrorText("Address format isn't valid");
  }, c = (p, g) => {
    const m = HU(p, g);
    m && r(m);
  }, d = Cb(t.mapsLoader, c), f = t.formatValue ?? ((p) => p);
  return Ue(() => {
    if (n)
      try {
        t.onChange(vL(n)), t.setInternalFormWrapperErrorText(void 0), i(!0);
      } catch {
        i(!1);
      }
    else
      t.onClear();
  }, [n]), /* @__PURE__ */ x.jsx(
    Vs,
    {
      icon: "map-pin",
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          ...e,
          ref: d,
          type: "text",
          value: f(n),
          onChange: a,
          onBlur: u
        }
      )
    }
  );
}, kU = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? $a;
  return /* @__PURE__ */ x.jsx(
    er,
    {
      ...e,
      type: "month",
      value: n(t.value),
      onChange: Ti(t.onChange, t.onClear)
    }
  );
}, BU = Fe(({ commonProps: e, ...t }, n) => {
  const r = t.formatValue ?? $a;
  return /* @__PURE__ */ x.jsx(
    ab,
    {
      ...e,
      ref: n,
      onChange: Ti(t.onChange, t.onClear),
      value: r(t.value),
      inputMode: "text"
    }
  );
}), vb = (e, t, n) => {
  qe(e) && qe(t) && e !== "" && n(r4.round(e, t));
}, s4 = (e) => Number.isNaN(e) || !qe(e) ? "" : e, a4 = (e, t) => (n) => {
  const r = o4(n);
  r === "" ? t() : e(+r);
}, DU = ({
  commonProps: e,
  ...t
}) => {
  const n = a4(t.onChange, t.onClear), r = t.formatValue ?? s4, { prefix: o, suffix: i } = t, a = {};
  return i && (a.rightAddon = i, a.rightAddonProps = {
    height: "100%",
    marginY: "auto"
  }), o && (a.leftAddon = o, a.leftAddonProps = {
    height: "100%",
    marginY: "auto"
  }), /* @__PURE__ */ x.jsx(
    i4,
    {
      ...a,
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          ...e,
          value: r(t.value),
          onChange: n,
          onBlur: () => {
            var u;
            vb(t.value, t.precision, t.onChange), (u = t.onBlur) == null || u.call(t);
          },
          type: "number"
        }
      )
    }
  );
}, OU = ({
  commonProps: e,
  ...t
}) => {
  const n = a4(t.onChange, t.onClear), r = t.formatValue ?? s4;
  return /* @__PURE__ */ x.jsx(
    Vs,
    {
      icon: "percent",
      placeIconRight: !0,
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          type: "number",
          ...e,
          onChange: n,
          onBlur: () => {
            var o;
            vb(t.value, t.precision, t.onChange), (o = t.onBlur) == null || o.call(t);
          },
          value: r(t.value)
        }
      )
    }
  );
};
function hh(e) {
  const { anchorOffset: t = 0, focusOffset: n = 0 } = e.ownerDocument.getSelection() || {}, r = Math.min(t, n), o = Math.max(t, n);
  return [r, o];
}
function NU(e, [t, n]) {
  var r, o;
  const i = e.ownerDocument, a = i.createRange();
  a.setStart(e.firstChild || e, Math.min(t, ((r = e.textContent) === null || r === void 0 ? void 0 : r.length) || 0)), a.setEnd(e.lastChild || e, Math.min(n, ((o = e.textContent) === null || o === void 0 ? void 0 : o.length) || 0));
  const u = i.getSelection();
  u && (u.removeAllRanges(), u.addRange(a));
}
class ZU {
  constructor(t) {
    this.element = t, this.maxLength = 1 / 0;
  }
  get value() {
    return this.element.innerText.replace(/\n\n$/, `
`);
  }
  set value(t) {
    this.element.innerHTML = t.replace(/\n$/, `

`);
  }
  get selectionStart() {
    return hh(this.element)[0];
  }
  get selectionEnd() {
    return hh(this.element)[1];
  }
  setSelectionRange(t, n) {
    NU(this.element, [t || 0, n || 0]);
  }
  select() {
    this.setSelectionRange(0, this.value.length);
  }
}
function $U(e) {
  const t = new ZU(e);
  return new Proxy(e, {
    get(n, r) {
      if (r in t)
        return t[r];
      const o = n[r];
      return typeof o == "function" ? o.bind(n) : o;
    },
    set(n, r, o, i) {
      return Reflect.set(r in t ? t : n, r, o, i);
    }
  });
}
const zU = (e) => e.isContentEditable ? $U(e) : e.querySelector("input,textarea") || e, l4 = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class WU {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, i) => o !== t.selection[i]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, { inputType: n, data: null });
  }
}
function GU(e, ...t) {
  return t.every(({ value: n }) => n === e.value);
}
function jU(e, ...t) {
  return t.every(({ value: n, selection: r }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function XU({ value: e, selection: t }, n, r) {
  const [o, i] = t, a = typeof r == "function" ? r({ value: e, selection: t }) : r;
  return {
    value: e,
    selection: a === "replace" ? [o, o + n.length] : [o, i]
  };
}
function k2(e) {
  return typeof e == "string";
}
function ph(e, t, n, r) {
  let o = "";
  for (let i = t.length; i < e.length; i++) {
    const a = e[i], u = (r == null ? void 0 : r.value[i]) === a;
    if (!k2(a) || a === n && !u)
      return o;
    o += a;
  }
  return o;
}
function bb(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r];
    return k2(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function UU(e, t, n) {
  let r = null, o = null;
  const i = Array.from(e.value).reduce((u, c, d) => {
    const f = ph(t, u, c, n), p = u + f, g = t[p.length];
    return k2(g) ? p + g : c.match(g) ? (r === null && d >= e.selection[0] && (r = p.length), o === null && d >= e.selection[1] && (o = p.length), p + c) : p;
  }, ""), a = ph(t, i, "", n);
  return {
    value: bb(i + a, t) ? i + a : i,
    selection: [r ?? i.length, o ?? i.length]
  };
}
function YU({ value: e, selection: t }, n) {
  const [r, o] = t;
  let i = r, a = o;
  return { value: Array.from(e).reduce((c, d, f) => {
    const p = c + d;
    return r === f && (i = c.length), o === f && (a = c.length), p.match(n) ? p : c;
  }, ""), selection: [i, a] };
}
function dc(e, t, n = null) {
  if (bb(e.value, t))
    return e;
  const { value: r, selection: o } = Array.isArray(t) ? UU(e, t, n) : YU(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function gh(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], i = Array.from(e.value).reduce((a, u, c) => {
    const d = t[c];
    return c === n && o.push(a.length), c === r && o.push(a.length), k2(d) && d === u ? a : a + u;
  }, "");
  return o.length < 2 && o.push(...new Array(2 - o.length).fill(i.length)), {
    value: i,
    selection: [o[0], o[1]]
  };
}
class ff {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const { value: r, selection: o } = dc(this.initialElementState, this.getMaskExpression(this.initialElementState));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const { value: o } = this, i = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), a = { value: o, selection: [t, n] }, u = gh(a, i), [c, d] = XU(u, r, this.maskOptions.overwriteMode).selection, f = u.value.slice(0, c) + r, p = f.length, g = dc({
      value: f + u.value.slice(d),
      selection: [p, p]
    }, i, a);
    if (// eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    o.slice(0, c) === dc({
      value: f,
      selection: [p, p]
    }, i, a).value || jU(this, g))
      throw new Error("Invalid mask value");
    this.value = g.value, this.selection = g.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const { value: r } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), i = { value: r, selection: [t, n] }, a = gh(i, o), [u, c] = a.selection, d = a.value.slice(0, u) + a.value.slice(c), f = dc({ value: d, selection: [u, u] }, o, i);
    this.value = f.value, this.selection = f.selection;
  }
  getMaskExpression(t) {
    const { mask: n } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class JU {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
const Qr = {
  CTRL: 1,
  ALT: 2,
  SHIFT: 4,
  META: 8
}, el = {
  Y: 89,
  Z: 90
};
function tl(e, t, n) {
  return e.ctrlKey === !!(t & Qr.CTRL) && e.altKey === !!(t & Qr.ALT) && e.shiftKey === !!(t & Qr.SHIFT) && e.metaKey === !!(t & Qr.META) && /**
   * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
   * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
   * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
   */
  e.keyCode === n;
}
function qU(e) {
  return tl(e, Qr.CTRL, el.Y) || // Windows
  tl(e, Qr.CTRL | Qr.SHIFT, el.Z) || // Windows & Android
  tl(e, Qr.META | Qr.SHIFT, el.Z);
}
function KU(e) {
  return tl(e, Qr.CTRL, el.Z) || // Windows & Android
  tl(e, Qr.META, el.Z);
}
function Fa(e, t) {
  var n;
  const r = e.value;
  if (typeof t == "string")
    e.value = t;
  else {
    const [o, i] = t.selection;
    e.value = t.value, e.matches(":focus") && ((n = e.setSelectionRange) === null || n === void 0 || n.call(e, o, i));
  }
  e.value !== r && e.dispatchEvent(new Event(
    "input",
    /**
     * React handles this event only on bubbling phase
     *
     * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
     * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
     */
    { bubbles: !0 }
  ));
}
function QU({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const i = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : i, n ? i : o];
}
function eY({ value: e, selection: t }, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((a) => Math.min(Math.max(a, 0), e.length));
}
const tY = /\s+$/g, nY = /^\s+/g, mh = /\s/;
function rY({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const c = e.slice(r), [d] = c.match(nY) || [
      ""
    ], f = c.trimStart().search(mh);
    return [
      r,
      f !== -1 ? r + d.length + f : e.length
    ];
  }
  const i = e.slice(0, o), [a] = i.match(tY) || [""], u = i.trimEnd().split("").reverse().findIndex((c) => c.match(mh));
  return [
    u !== -1 ? o - a.length - u : 0,
    o
  ];
}
function t2(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function _l(e, t) {
  const n = Object.assign(Object.assign({}, l4), t), r = t2(n.preprocessors), o = t2(n.postprocessors), i = typeof e == "string" ? { value: e, selection: [0, 0] } : e, { elementState: a } = r({ elementState: i, data: "" }, "validation"), u = new ff(a, n), { value: c, selection: d } = o(u, i);
  return typeof e == "string" ? c : { value: c, selection: d };
}
function oY(e) {
  return (t, n) => {
    const r = t.selectionStart || 0, o = t.selectionEnd || 0;
    Fa(t, {
      value: _l(t.value, e || n),
      selection: [r, o]
    });
  };
}
class iY extends WU {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new JU(this.element), this.options = Object.assign(Object.assign({}, l4), this.maskitoOptions), this.preprocessor = t2(this.options.preprocessors), this.postprocessor = t2(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (qU(r))
        return r.preventDefault(), this.redo();
      if (KU(r))
        return r.preventDefault(), this.undo();
    }), this.eventListener.listen("beforeinput", (r) => {
      var o;
      const i = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: i,
            selection: eY(this.elementState, i)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: i,
            selection: rY(this.elementState, i),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: i,
            selection: QU(this.elementState, i),
            force: !0
          });
        case "insertCompositionText":
          return;
        case "insertReplacementText":
          return;
        case "insertLineBreak":
        case "insertParagraph":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || // `event.data` for `contentEditable` is always `null` for paste/drop events
          ((o = r.dataTransfer) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
      }
    }), this.eventListener.listen("input", ({ inputType: r }) => {
      r !== "insertCompositionText" && (this.ensureValueFitsMask(), this.updateHistory(this.elementState));
    }), this.eventListener.listen("compositionend", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const { value: t, selectionStart: n, selectionEnd: r } = this.element;
    return {
      value: t,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const { maxLength: t } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({ value: t, selection: n }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), o !== t && this.dispatchInputEvent(r);
  }
  updateSelectionRange([t, n]) {
    var r;
    const { element: o } = this;
    o.matches(":focus") && (o.selectionStart !== t || o.selectionEnd !== n) && ((r = o.setSelectionRange) === null || r === void 0 || r.call(o, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(_l(this.elementState, this.options));
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    globalThis.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), { bubbles: !0, cancelable: !1 })));
  }
  handleDelete({ event: t, selection: n, isForward: r, force: o = !1 }) {
    const i = {
      value: this.elementState.value,
      selection: n
    }, [a, u] = i.selection, { elementState: c } = this.preprocessor({
      elementState: i,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), d = new ff(c, this.options), [f, p] = c.selection;
    d.deleteCharacters([f, p]);
    const g = this.postprocessor(d, i);
    if (!(i.value.slice(0, a) + i.value.slice(u) === g.value && !o && !this.element.isContentEditable)) {
      if (t.preventDefault(), GU(i, c, d, g))
        return this.updateSelectionRange(r ? [p, p] : [f, f]);
      this.updateElementState(g, {
        inputType: t.inputType,
        data: null
      }), this.updateHistory(g);
    }
  }
  handleInsert(t, n) {
    const r = this.elementState, { elementState: o, data: i = n } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), a = new ff(o, this.options);
    try {
      a.addCharacters(o.selection, i);
    } catch {
      return t.preventDefault();
    }
    const [u, c] = o.selection, d = r.value.slice(0, u) + n + r.value.slice(c), f = this.postprocessor(a, r);
    if (f.value.length > this.maxLength)
      return t.preventDefault();
    (d !== f.value || this.element.isContentEditable) && (t.preventDefault(), this.updateElementState(f, {
      data: n,
      inputType: t.inputType
    }), this.updateHistory(f));
  }
  handleEnter(t) {
    (this.isTextArea || this.element.isContentEditable) && this.handleInsert(t, `
`);
  }
}
function ka(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
const sY = [".", ",", "б", "ю"], aY = [":", "."], lY = " ", uY = "​", yb = "–", xb = "—", n2 = "-", hf = "−", Sb = "ー", wb = /[\\^$.*+?()[\]{}|]/g, cY = new RegExp(wb.source);
function Nn(e) {
  return e && cY.test(e) ? e.replaceAll(wb, "\\$&") : e;
}
function oo(e, { prefix: t, postfix: n }) {
  var r, o;
  const i = new RegExp(`^${Nn(t)}`), a = new RegExp(`${Nn(n)}$`), [u = ""] = (r = e.match(i)) !== null && r !== void 0 ? r : [], [c = ""] = (o = e.match(a)) !== null && o !== void 0 ? o : [], d = e.replace(i, "").replace(a, "");
  return { extractedPrefix: u, extractedPostfix: c, cleanValue: d };
}
function dY(e, t) {
  let n = "";
  for (let r = 0; r < e.length; r++) {
    if (e[r] !== t[r])
      return n;
    n += e[r];
  }
  return n;
}
function Tl(e) {
  return e;
}
function Ch(e) {
  return e.replaceAll(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248));
}
function fY() {
  return ({ elementState: e, data: t }) => {
    const { value: n, selection: r } = e;
    return {
      elementState: {
        selection: r,
        value: Ch(n)
      },
      data: Ch(t)
    };
  };
}
function hY(e) {
  const t = new RegExp(`${Nn(e)}$`);
  return e ? ({ value: n, selection: r }, o) => {
    if (!n && !o.value.endsWith(e))
      return { value: n, selection: r };
    if (!n.endsWith(e) && !o.value.endsWith(e))
      return { selection: r, value: n + e };
    const i = o.value.replace(t, ""), a = o.selection[1] >= i.length, u = dY(i, n);
    return {
      selection: r,
      value: Array.from(e).reverse().reduce((c, d, f) => {
        const p = c.length - 1 - f, g = u[p] === d && a;
        return c[p] !== d || g ? c.slice(0, p + 1) + d + c.slice(p + 1) : c;
      }, n)
    };
  } : Tl;
}
function pY(e) {
  return e ? ({ value: t, selection: n }, r) => {
    if (t.startsWith(e) || // already valid
    !t && !r.value.startsWith(e))
      return { value: t, selection: n };
    const [o, i] = n, a = Array.from(e).reduce((c, d, f) => c[f] === d ? c : c.slice(0, f) + d + c.slice(f), t), u = a.length - t.length;
    return {
      selection: [o + u, i + u],
      value: a
    };
  } : Tl;
}
function ml(e, t, n) {
  return (r, o) => {
    const i = () => t(r, o);
    return r.addEventListener(e, i, n), () => r.removeEventListener(e, i, n);
  };
}
function Ib(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, i = () => {
      r = Math.max(--r, 0);
    }, a = () => {
      if (!t.matches(":focus"))
        return;
      if (r)
        return n.addEventListener("mouseup", a, {
          once: !0,
          passive: !0
        });
      const u = t.selectionStart || 0, c = t.selectionEnd || 0, [d, f] = e(t.value, [u, c]);
      (d > u || f < c) && t.setSelectionRange(ka(u, d, f), ka(c, d, f));
    };
    return n.addEventListener("selectionchange", a, { passive: !0 }), t.addEventListener("mousedown", o, { passive: !0 }), n.addEventListener("mouseup", i, { passive: !0 }), () => {
      n.removeEventListener("selectionchange", a), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", i);
    };
  };
}
function gY(e, t = !1) {
  let n = "", r = "validation";
  const o = (u) => {
    for (let c = u.length - 1; c >= n.length; c--)
      if (u[c] !== e[c])
        return u.slice(0, c + 1);
    return u.slice(0, n.length);
  }, i = [Ib((u) => [0, o(u).length])];
  let a = !1;
  if (t) {
    const u = ml("focus", (d) => {
      a = !0, Fa(d, d.value + e.slice(d.value.length));
    }, { capture: !0 }), c = ml("blur", (d) => {
      a = !1, Fa(d, o(d.value));
    }, { capture: !0 });
    i.push(u, c);
  }
  return {
    plugins: i,
    removePlaceholder: o,
    preprocessors: [
      ({ elementState: u, data: c }, d) => {
        r = d;
        const { value: f, selection: p } = u;
        return {
          elementState: {
            selection: p,
            value: o(f)
          },
          data: c
        };
      }
    ],
    postprocessors: [
      ({ value: u, selection: c }, d) => {
        n = u;
        const f = u !== d.value && (a || !t) ? u + e.slice(u.length) : u;
        if (f === d.value && r === "deleteBackward") {
          const [p] = d.selection;
          return {
            value: f,
            selection: [p, p]
          };
        }
        return { value: f, selection: c };
      }
    ]
  };
}
new RegExp(`[${aY.map(Nn).join("")}]$`);
function mY({ prefix: e, postfix: t }) {
  return ({ elementState: n, data: r }) => {
    const { cleanValue: o } = oo(r, {
      prefix: e,
      postfix: t
    });
    return {
      elementState: n,
      data: o
    };
  };
}
function Vb({ decimalSeparator: e, isNegativeAllowed: t, precision: n, thousandSeparator: r, prefix: o, postfix: i, decimalPseudoSeparators: a = [], pseudoMinuses: u = [], minusSign: c }) {
  const d = vh(o), f = "\\d", p = t ? `[${c}${u.map((v) => `\\${v}`).join("")}]?` : "", g = r ? `[${f}${Nn(r).replaceAll(/\s/g, "\\s")}]*` : `[${f}]*`, m = n > 0 ? `([${Nn(e)}${a.map(Nn).join("")}]${f}{0,${Number.isFinite(n) ? n : ""}})?` : "", b = vh(i);
  return new RegExp(`^${d}${p}${g}${m}${b}$`);
}
function vh(e) {
  return e ? `${e.split("").map((t) => `${Nn(t)}?`).join("")}` : "";
}
function u4(e, t = ".") {
  const n = !!e.match(new RegExp(`^\\D*[${hf}\\${n2}${yb}${xb}${Sb}]`)), r = Nn(t), o = e.replaceAll(new RegExp(`${r}(?!\\d)`, "g"), "").replaceAll(new RegExp(`[^\\d${r}]`, "g"), "").replace(t, ".");
  return o ? Number((n ? n2 : "") + o) : NaN;
}
function CY(e) {
  const t = String(e), [n, r] = t.split("e-");
  let o = t;
  if (r) {
    const [, i] = n.split("."), a = Number(r) + ((i == null ? void 0 : i.length) || 0);
    o = e.toFixed(a);
  }
  return o;
}
function Ab(e, { decimalSeparator: t, thousandSeparator: n }) {
  const [r = "", o = ""] = e.split(t), [, i = "", a = ""] = r.match(new RegExp(`([^\\d${Nn(n)}]+)?(.*)`)) || [];
  return { minus: i, integerPart: a, decimalPart: o };
}
function vY({ decimalSeparator: e, thousandSeparator: t, decimalPseudoSeparators: n = sY }) {
  return n.filter((r) => r !== t && r !== e);
}
function bY({ decimalSeparator: e, precision: t, decimalZeroPadding: n, prefix: r, postfix: o }) {
  return t <= 0 || !n ? Tl : ({ value: i, selection: a }) => {
    const { cleanValue: u, extractedPrefix: c, extractedPostfix: d } = oo(i, {
      prefix: r,
      postfix: o
    });
    if (Number.isNaN(u4(u, e)))
      return { value: i, selection: a };
    const [f, p = ""] = u.split(e);
    return {
      value: c + f + e + p.padEnd(t, "0") + d,
      selection: a
    };
  };
}
function yY({ prefix: e, postfix: t, decimalSeparator: n, thousandSeparator: r }) {
  return ({ value: o, selection: i }) => {
    const [a] = i, { cleanValue: u, extractedPrefix: c, extractedPostfix: d } = oo(o, {
      prefix: e,
      postfix: t
    }), { minus: f, integerPart: p, decimalPart: g } = Ab(u, {
      decimalSeparator: n,
      thousandSeparator: r
    }), m = !p && !g && u.includes(n);
    return !p && !Number(g) && a === (f + c).length || m ? {
      selection: i,
      value: c + f + d
    } : { value: o, selection: i };
  };
}
function xY({ decimalSeparator: e, decimalPseudoSeparators: t, pseudoMinuses: n, prefix: r, postfix: o, minusSign: i }) {
  let a = !0;
  const u = Vb({
    decimalSeparator: e,
    decimalPseudoSeparators: t,
    pseudoMinuses: n,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: 1 / 0,
    isNegativeAllowed: !0,
    minusSign: i
  });
  return ({ elementState: c, data: d }) => {
    if (!a)
      return { elementState: c, data: d };
    a = !1;
    const { value: f, selection: p } = c, [g, m] = p, { extractedPrefix: b, cleanValue: v, extractedPostfix: y } = oo(f, {
      prefix: r,
      postfix: o
    }), w = _l({
      selection: [
        Math.max(g - b.length, 0),
        ka(m - b.length, 0, v.length)
      ],
      value: v
    }, {
      mask: u
    }), [I, V] = w.selection;
    return {
      elementState: {
        selection: [
          I + b.length,
          V + b.length
        ],
        value: b + w.value + y
      },
      data: d
    };
  };
}
function SY({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = (a) => {
    const u = Nn(t);
    return a.replace(
      // all leading zeroes followed by another zero
      new RegExp(`^(\\D+)?[0${u}]+(?=0)`),
      "$1"
    ).replace(
      // zero followed by not-zero digit
      new RegExp(`^(\\D+)?[0${u}]+(?=[1-9])`),
      "$1"
    );
  }, i = (a, u) => {
    const c = a.slice(0, u), d = a.slice(u).startsWith("0");
    return c.length - o(c).length + (d ? 1 : 0);
  };
  return ({ value: a, selection: u }) => {
    const [c, d] = u, { cleanValue: f, extractedPrefix: p, extractedPostfix: g } = oo(a, {
      prefix: n,
      postfix: r
    }), m = f.includes(e), [b, v = ""] = f.split(e), y = o(b);
    if (b === y)
      return { value: a, selection: u };
    const w = c - i(a, c), I = d - i(a, d);
    return {
      value: p + y + (m ? e : "") + v + g,
      selection: [Math.max(w, 0), Math.max(I, 0)]
    };
  };
}
function wY({ min: e, max: t, decimalSeparator: n, minusSign: r }) {
  return ({ value: o, selection: i }) => {
    const a = u4(o, n), u = (
      /**
       * We cannot limit lower bound if user enters positive number.
       * The same for upper bound and negative number.
       * ___
       * @example (min = 5)
       * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
       * ___
       * @example (max = -10)
       * Value is -10 => Without this condition user cannot delete 0 to enter another digit
       */
      a > 0 ? Math.min(a, t) : Math.max(a, e)
    );
    if (a && u !== a) {
      const c = `${u}`.replace(".", n).replace(n2, r);
      return {
        value: c,
        selection: [c.length, c.length]
      };
    }
    return {
      value: o,
      selection: i
    };
  };
}
function IY({ decimalSeparator: e, thousandSeparator: t, decimalZeroPadding: n }) {
  return ({ elementState: r, data: o }, i) => {
    const { value: a, selection: u } = r, [c, d] = u, f = a.slice(c, d), p = n ? [e, t] : [t], g = n && c > a.indexOf(e) && !!f.match(/^0+$/gi);
    return i !== "deleteBackward" && i !== "deleteForward" || !p.includes(f) && !g ? {
      elementState: r,
      data: o
    } : {
      elementState: {
        value: a,
        selection: i === "deleteForward" ? [d, d] : [c, c]
      },
      data: o
    };
  };
}
function VY({ decimalSeparator: e, precision: t, prefix: n, postfix: r }) {
  const o = new RegExp(`^\\D*${Nn(e)}`);
  return ({ elementState: i, data: a }) => {
    const { value: u, selection: c } = i, { cleanValue: d, extractedPrefix: f } = oo(u, {
      prefix: n,
      postfix: r
    }), [p, g] = c, m = ka(p - f.length, 0, d.length), b = ka(g - f.length, 0, d.length);
    if (t <= 0 || d.slice(0, m).includes(e) || d.slice(b).includes(e) || !a.match(o))
      return { elementState: i, data: a };
    const v = d.slice(0, m).match(/\d+/);
    return {
      elementState: i,
      data: v ? a : `0${a}`
    };
  };
}
function bh({ validCharacter: e, pseudoCharacters: t, prefix: n, postfix: r }) {
  const o = new RegExp(`[${t.join("")}]`, "gi");
  return ({ elementState: i, data: a }) => {
    const { value: u, selection: c } = i, { cleanValue: d, extractedPostfix: f, extractedPrefix: p } = oo(u, {
      prefix: n,
      postfix: r
    });
    return {
      elementState: {
        selection: c,
        value: p + d.replace(o, e) + f
      },
      data: a.replace(o, e)
    };
  };
}
function AY({ decimalSeparator: e, prefix: t, postfix: n }) {
  return ({ elementState: r, data: o }) => {
    const { value: i, selection: a } = r, [u, c] = a, { cleanValue: d } = oo(i, { prefix: t, postfix: n });
    return {
      elementState: r,
      data: !d.includes(e) || i.slice(u, c + 1).includes(e) ? o : o.replaceAll(new RegExp(Nn(e), "gi"), "")
    };
  };
}
function LY({ thousandSeparator: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (!e)
    return Tl;
  const o = (...i) => i.every((a) => /\s/.test(a));
  return ({ value: i, selection: a }) => {
    const { cleanValue: u, extractedPostfix: c, extractedPrefix: d } = oo(i, {
      prefix: n,
      postfix: r
    }), { minus: f, integerPart: p, decimalPart: g } = Ab(u, {
      decimalSeparator: t,
      thousandSeparator: e
    }), [m, b] = a;
    let [v, y] = a;
    const w = Array.from(p).reduceRight((I, V, M) => {
      const R = !(!M && V === e) && I.length && (I.length + 1) % 4 === 0;
      return R && (V === e || o(V, e)) ? e + I : V === e && !R ? (M && M <= m && v--, M && M <= b && y--, I) : R ? (M <= m && v++, M <= b && y++, V + e + I) : V + I;
    }, "");
    return {
      value: d + f + w + (u.includes(t) ? t : "") + g + c,
      selection: [v, y]
    };
  };
}
function MY({ precision: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (e > 0)
    return Tl;
  const o = new RegExp(`${Nn(t)}.*$`, "g");
  return ({ elementState: i, data: a }) => {
    const { value: u, selection: c } = i, { cleanValue: d, extractedPrefix: f, extractedPostfix: p } = oo(u, {
      prefix: n,
      postfix: r
    }), [g, m] = c, b = f + d.replace(o, "") + p;
    return {
      elementState: {
        selection: [
          Math.min(g, b.length),
          Math.min(m, b.length)
        ],
        value: b
      },
      data: a.replace(o, "")
    };
  };
}
const yh = [0, 0];
function PY({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = SY({
    decimalSeparator: e,
    thousandSeparator: t,
    prefix: n,
    postfix: r
  });
  return ml("blur", (i) => {
    const a = o({
      value: i.value,
      selection: yh
    }, { value: "", selection: yh }).value;
    Fa(i, a);
  }, { capture: !0 });
}
function EY({ min: e, max: t, decimalSeparator: n }) {
  return ml("blur", (r, o) => {
    const i = u4(r.value, n), a = ka(i, e, t);
    !Number.isNaN(i) && i !== a && Fa(r, _l(CY(a), o));
  }, { capture: !0 });
}
function RY({ decimalSeparator: e, prefix: t, postfix: n }) {
  return ml("blur", (r) => {
    const { cleanValue: o, extractedPostfix: i, extractedPrefix: a } = oo(r.value, { prefix: t, postfix: n }), u = a + o.replace(new RegExp(`^(\\D+)?${Nn(e)}`), `$10${e}`) + i;
    Fa(r, u);
  }, { capture: !0 });
}
function _Y({ max: e = Number.MAX_SAFE_INTEGER, min: t = Number.MIN_SAFE_INTEGER, precision: n = 0, thousandSeparator: r = lY, decimalSeparator: o = ".", decimalPseudoSeparators: i, decimalZeroPadding: a = !1, prefix: u = "", postfix: c = "", minusSign: d = hf } = {}) {
  const f = [
    n2,
    yb,
    xb,
    Sb,
    hf
  ].filter((m) => m !== r && m !== o && m !== d), p = vY({
    decimalSeparator: o,
    thousandSeparator: r,
    decimalPseudoSeparators: i
  }), g = u.endsWith(o) && n > 0 ? `${u}${uY}` : u;
  return Object.assign(Object.assign({}, l4), { mask: Vb({
    decimalSeparator: o,
    precision: n,
    thousandSeparator: r,
    prefix: g,
    postfix: c,
    isNegativeAllowed: t < 0,
    minusSign: d
  }), preprocessors: [
    fY(),
    xY({
      decimalSeparator: o,
      decimalPseudoSeparators: p,
      pseudoMinuses: f,
      prefix: g,
      postfix: c,
      minusSign: d
    }),
    mY({ prefix: g, postfix: c }),
    bh({
      validCharacter: d,
      pseudoCharacters: f,
      prefix: g,
      postfix: c
    }),
    bh({
      validCharacter: o,
      pseudoCharacters: p,
      prefix: g,
      postfix: c
    }),
    VY({
      decimalSeparator: o,
      precision: n,
      prefix: g,
      postfix: c
    }),
    IY({
      decimalSeparator: o,
      decimalZeroPadding: a,
      thousandSeparator: r
    }),
    MY({
      precision: n,
      decimalSeparator: o,
      prefix: g,
      postfix: c
    }),
    AY({
      decimalSeparator: o,
      prefix: g,
      postfix: c
    })
  ], postprocessors: [
    wY({ decimalSeparator: o, min: t, max: e, minusSign: d }),
    pY(g),
    hY(c),
    LY({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: g,
      postfix: c
    }),
    bY({
      decimalSeparator: o,
      decimalZeroPadding: a,
      precision: n,
      prefix: g,
      postfix: c
    }),
    yY({ prefix: g, postfix: c, decimalSeparator: o, thousandSeparator: r })
  ], plugins: [
    PY({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: g,
      postfix: c
    }),
    RY({
      decimalSeparator: o,
      prefix: g,
      postfix: c
    }),
    EY({ min: t, max: e, decimalSeparator: o })
  ], overwriteMode: a ? ({ value: m, selection: [b] }) => b <= m.indexOf(o) ? "shift" : "replace" : "shift" });
}
const xh = typeof window < "u" ? Oa : Ue;
function TY(e) {
  return e && typeof e == "object" && "then" in e;
}
const Lb = ({
  options: e = null,
  elementPredicate: t = zU
} = {}) => {
  const [n, r] = Ee(null), [o, i] = Ee(null), a = q((c) => {
    r(c);
  }, []), u = Le(t);
  return u.current = t, xh(() => {
    if (!n)
      return;
    const c = t, d = c(n);
    TY(d) ? d.then((f) => {
      u.current === c && i(f);
    }) : i(d);
  }, [n, t, u]), xh(() => {
    if (!o || !e)
      return;
    const c = new iY(o, e);
    return () => {
      c.destroy();
    };
  }, [e, o]), a;
}, Mb = "(___) ___-____", { removePlaceholder: HY, ...FY } = gY(Mb), kY = {
  ...FY,
  mask: ["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
}, BY = ({
  commonProps: e,
  ...t
}) => {
  const n = Lb({ options: kY }), r = t.formatValue ?? $a, o = () => {
    t.onChange(HY(r(t.value)));
  }, i = e.placeholder || Mb;
  return /* @__PURE__ */ x.jsx(
    Vs,
    {
      icon: "phone",
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          type: "tel",
          onInput: Ti(t.onChange, t.onClear),
          value: r(t.value),
          ...e,
          placeholder: i,
          ref: n,
          onBlur: o
        }
      )
    }
  );
}, DY = ({
  commonProps: e,
  ...t
}) => {
  const n = a4(t.onChange, t.onClear), o = (t.formatValue ? t.formatValue : s4)(t.value), i = /* @__PURE__ */ x.jsx(
    er,
    {
      ...e,
      value: o,
      onChange: n,
      type: "number",
      step: "any",
      autoComplete: "off"
    }
  );
  return t.noIcon ? i : /* @__PURE__ */ x.jsx(Vs, { icon: "money-dollar-circle", input: i });
}, OY = ({
  ref: e,
  ...t
}) => {
  const {
    min: n,
    max: r,
    resetValue: o,
    valueWhenEmpty: i,
    id: a,
    onClear: u,
    autoFocus: c,
    __dangerDoNotUseSx: d,
    ...f
  } = t, p = () => {
    if (!qe(n) && !qe(r))
      return;
    const v = parseFloat(t.value);
    let y;
    return qe(n) && v < n && (y = o ?? n), qe(r) && v > r && (y = o ?? r), y;
  }, g = () => {
    var y, w;
    const v = p();
    qe(v) ? (t.onChange(v), (y = t.onBlur) == null || y.call(t)) : (w = t.onBlur) == null || w.call(t);
  }, m = f.onKeyDown ? (v) => {
    const y = p() ?? t.value;
    f.onKeyDown(v, y);
  } : void 0, b = {
    ...f,
    value: qe(t.value) ? t.value : "",
    onBlur: g,
    onChange: (v, y) => {
      const w = Number.isNaN(y) ? i : y;
      t.onChange(w);
    },
    onKeyDown: m
  };
  return /* @__PURE__ */ x.jsxs(zv, { ...b, clampValueOnBlur: !1, children: [
    /* @__PURE__ */ x.jsx(Gv, { ref: e }),
    qe(b.step) && /* @__PURE__ */ x.jsxs(Wv, { children: [
      /* @__PURE__ */ x.jsx(Uv, {}),
      /* @__PURE__ */ x.jsx(Xv, {})
    ] })
  ] });
}, NY = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? $a, r = Ti(t.onChange, t.onClear);
  return /* @__PURE__ */ x.jsx(
    Vs,
    {
      icon: "search",
      input: /* @__PURE__ */ x.jsx(
        er,
        {
          ...e,
          type: "text",
          onChange: r,
          value: n(t.value)
        }
      )
    }
  );
}, ZY = ({
  commonProps: e,
  ...t
}) => /* @__PURE__ */ x.jsx(
  er,
  {
    ...e,
    type: "text",
    value: t.formatValue ? t.formatValue(t.value) : t.value ?? "",
    onChange: Ti(t.onChange, t.onClear)
  }
), jn = (e) => e, B2 = Fe(
  (e, t) => {
    const n = F2(), r = Le(null), o = {
      id: e.id,
      sx: e.__dangerDoNotUseSx,
      ref: t ?? r,
      "data-testid": e.__testId ?? e.id,
      placeholder: e.placeholderText,
      onKeyDown: e.onKeyDown,
      onFocus: e.onFocus,
      onMouseDown: e.onMouseDown,
      onBlur: () => {
        var i;
        return (i = e.onBlur) == null ? void 0 : i.call(e);
      },
      border: e.border,
      borderRadius: e.borderRadius,
      boxShadow: e.boxShadow,
      size: n
    };
    switch (SU(e.autoFocus, t, r), VU(e.type, o.ref), e.type) {
      case "text": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(ZY, { ...e, commonProps: o, value: i });
      }
      case "search": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(NY, { ...e, commonProps: o, value: i });
      }
      case "multiline": {
        const i = jn(e.value), { ref: a, ...u } = o;
        return /* @__PURE__ */ x.jsx(
          BU,
          {
            ...e,
            commonProps: u,
            value: i,
            ref: t
          }
        );
      }
      case "location": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(FU, { ...e, commonProps: o, value: i });
      }
      case "locationAddressAutocomplete": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(TU, { ...e, commonProps: o, value: i });
      }
      case "number": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(DU, { ...e, commonProps: o, value: i });
      }
      case "percent": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(OU, { ...e, commonProps: o, value: i });
      }
      case "range":
        return /* @__PURE__ */ x.jsx(OY, { ...e });
      case "aloftArea": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(PU, { ...e, commonProps: o, value: i });
      }
      case "price": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(DY, { ...e, commonProps: o, value: i });
      }
      case "aloftPrice": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(LU, { ...e, ref: t, value: i });
      }
      case "email": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(RU, { ...e, commonProps: o, value: i });
      }
      case "date": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(EU, { ...e, commonProps: o, value: i });
      }
      case "month": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(kU, { ...e, commonProps: o, value: i });
      }
      case "aloftDate":
        return /* @__PURE__ */ x.jsx(AU, { ...e, ref: t });
      case "phone": {
        const i = jn(e.value);
        return /* @__PURE__ */ x.jsx(BY, { ...e, commonProps: o, value: i });
      }
      default:
        return Pf(e);
    }
  }
);
B2.displayName = "BaseInput";
const Jee = Fe((e, t) => {
  const [n, r] = Ee(), {
    id: o,
    isDisabled: i,
    isReadonly: a,
    isInvalid: u,
    isRequired: c,
    helperText: d,
    errorText: f,
    label: p,
    ariaLabel: g,
    size: m = "md",
    variant: b,
    clearable: v,
    ...y
  } = e;
  return Za(
    {
      id: o,
      isDisabled: i,
      isReadonly: a,
      isRequired: c,
      isInvalid: u,
      helperText: d,
      errorText: f,
      internalFormWrapperErrorText: n,
      label: p,
      ariaLabel: g,
      size: m,
      variant: b,
      clearable: v
    },
    /* @__PURE__ */ x.jsx(
      B2,
      {
        id: e.id,
        ref: t,
        ...y,
        setInternalFormWrapperErrorText: r
      }
    )
  );
}), $Y = (e, t) => {
  const n = F2(), {
    onChange: r,
    onFocus: o,
    onBlur: i,
    __dangerDoNotUseSx: a,
    placeholder: u,
    options: c,
    value: d,
    border: f = !0,
    radius: p = !0
  } = e;
  return /* @__PURE__ */ x.jsx(
    tb,
    {
      border: f ? void 0 : "hidden",
      borderRadius: p ? void 0 : "none",
      ref: t,
      onChange: (g) => {
        const { value: m } = g.currentTarget;
        r(m === "" ? void 0 : m, g);
      },
      onFocus: o,
      onBlur: i,
      sx: a,
      size: n,
      placeholder: u,
      value: d,
      children: c.map(({ label: g, value: m }) => /* @__PURE__ */ x.jsx("option", { value: m, children: g }, m))
    }
  );
}, zY = Fe($Y), WY = (e, t) => {
  const { variant: n = "native" } = e;
  switch (n) {
    case "native":
      return Za(e, /* @__PURE__ */ x.jsx(zY, { ...e, ref: t }));
    default:
      return null;
  }
}, qee = Fe(WY), Kee = (e) => e.map((t) => ({ value: t, label: r4.startCase(t) })), Qee = Fe((e, t) => /* @__PURE__ */ x.jsx(Qo, { ref: t, ...e, display: "grid" })), GY = Fe((e, t) => /* @__PURE__ */ x.jsx(Qo, { ref: t, ...e, display: "block" })), jY = ({ width: e, height: t }) => /* @__PURE__ */ x.jsxs("svg", { width: e, height: t, viewBox: "0 0 200 200", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ x.jsx("path", { d: "M72.3229 169.049L86.4221 165.965L62.4673 162.46L72.3229 169.049Z", fill: "#3C70A7" }),
  /* @__PURE__ */ x.jsx(
    "path",
    {
      d: "M43.6861 69.4804L64.0226 88.1552L77.2991 140.806L98.9435 98.7906L87.301 76.5295L43.6861 69.4804Z",
      fill: "#3C70A7"
    }
  ),
  /* @__PURE__ */ x.jsx("path", { d: "M41.653 65.4667L83.0325 71.8327L37.0788 47.4518L41.653 65.4667Z", fill: "#1F364E" }),
  /* @__PURE__ */ x.jsx("path", { d: "M117.659 54.2922L152.739 80.3563L126.191 26.4058L117.659 54.2922Z", fill: "#1F364E" }),
  /* @__PURE__ */ x.jsx(
    "path",
    {
      d: "M132.239 134.244L151.254 84.5434L116.486 58.3245L112.456 81.6043L78.2202 147.134L41.9506 155.788L111.571 165.116L154.879 148.766L168.363 150.105L167.04 147.462L157.788 143.938L149.417 136.447L132.239 134.244Z",
      fill: "#73A9EF"
    }
  )
] });
const ete = ({ light: e, message: t, __testId: n }) => /* @__PURE__ */ x.jsxs("div", { className: "loading-indicator", "data-testid": n, children: [
  /* @__PURE__ */ x.jsx(jY, { width: 100, height: 100 }),
  qe(t) ? /* @__PURE__ */ x.jsx(Or, { color: e ? "textOffset" : void 0, children: t }) : null
] }), XY = ({ children: e }) => /* @__PURE__ */ x.jsx(Or, { variant: "h3", __dangerDoNotUseSx: { fontWeight: "normal" }, children: e }), UY = ({ canDismiss: e, status: t, description: n, title: r }) => {
  const [o, i] = Ee(!0), a = () => {
    e && i(!1);
  };
  return o ? /* @__PURE__ */ x.jsxs(
    h3,
    {
      status: t,
      position: "sticky",
      top: 0,
      width: "100vw",
      zIndex: 999999,
      className: "sui-banner",
      children: [
        /* @__PURE__ */ x.jsx(p3, {}),
        /* @__PURE__ */ x.jsxs(vs, { gap: "8px", children: [
          !!r && /* @__PURE__ */ x.jsx(Or, { variant: "h3", children: r }),
          typeof n == "string" ? /* @__PURE__ */ x.jsx(XY, { children: n }) : n
        ] }),
        e && /* @__PURE__ */ x.jsx(A2, { onClick: a, position: "absolute", right: "4" })
      ]
    }
  ) : null;
}, tte = () => {
  const [e, t] = Ee(navigator.onLine);
  return Ue(() => {
    const n = () => t(!0), r = () => t(!1);
    return window.addEventListener("offline", r), window.addEventListener("online", n), () => {
      window.removeEventListener("online", n), window.removeEventListener("offline", r);
    };
  }, []), e ? null : /* @__PURE__ */ x.jsx(
    UY,
    {
      status: "error",
      title: "You are Offline",
      description: "You are not connected to the internet. We cannot guarantee your changes will be saved! Please restore your internet connection before proceeding.",
      canDismiss: !1
    }
  );
}, YY = ({
  content: e,
  title: t
}) => /* @__PURE__ */ x.jsx(Uc, { borderWidth: "1px", borderBottomColor: "strokeDefault", children: /* @__PURE__ */ x.jsx(nC, { children: /* @__PURE__ */ x.jsxs(Uc, { height: "1.5rem", width: "100%", justifyContent: "space-between", alignItems: "center", children: [
  e && e,
  t && /* @__PURE__ */ x.jsx(Or, { variant: "h5", children: t }),
  /* @__PURE__ */ x.jsx(rC, {})
] }) }) }), nte = ({
  panels: e,
  panelState: t
}) => {
  const { index: n, onChange: r } = t || {}, [o, i] = Ee(
    () => Object.keys(e).map((c) => +c)
  ), a = n ?? o, u = r ?? i;
  return /* @__PURE__ */ x.jsx(
    tC,
    {
      variant: "default",
      width: "full",
      index: a,
      onChange: u,
      allowToggle: !0,
      children: e.map(({ id: c, body: d, ...f }) => /* @__PURE__ */ x.jsxs(oC, { children: [
        /* @__PURE__ */ x.jsx(YY, { ...f }),
        /* @__PURE__ */ x.jsx(sC, { paddingBottom: 4, children: d })
      ] }, c))
    }
  );
}, rte = (e) => {
  const {
    children: t,
    variant: n,
    header: r,
    headerProps: o,
    drawerContentProps: i,
    footer: a,
    footerProps: u,
    bodyProps: c,
    ...d
  } = e;
  return /* @__PURE__ */ x.jsxs(fj, { ...d, children: [
    n === "overlay" && /* @__PURE__ */ x.jsx(Q3, {}),
    /* @__PURE__ */ x.jsxs($v, { ...i, children: [
      qe(r) && /* @__PURE__ */ x.jsx(K3, { ...o, children: r }),
      /* @__PURE__ */ x.jsx(J3, { ...c, children: t }),
      qe(a) && /* @__PURE__ */ x.jsx(q3, { ...u, children: a })
    ] })
  ] });
}, Pb = Fe((e, t) => {
  const {
    __testId: n,
    onChange: r,
    value: o,
    isDisabled: i,
    isReadonly: a,
    isInvalid: u,
    isRequired: c,
    size: d,
    __dangerDoNotUseSx: f
  } = e, p = (g) => {
    r(!!g.target.checked);
  };
  return /* @__PURE__ */ x.jsx(
    ib,
    {
      "data-testid": n,
      ref: t,
      isChecked: o,
      onChange: p,
      isDisabled: i,
      isReadOnly: a,
      isInvalid: u,
      isRequired: c,
      size: d,
      sx: f
    }
  );
});
Pb.displayName = "Switch";
const ote = Fe((e, t) => {
  const { __testId: n, label: r, ...o } = e;
  return Za(
    o,
    /* @__PURE__ */ x.jsxs(vs, { alignItems: "center", gap: ".5rem", children: [
      /* @__PURE__ */ x.jsx(Pb, { __testId: n, ref: t, ...o }),
      /* @__PURE__ */ x.jsx(Or, { variant: "h4", children: r })
    ] })
  );
}), JY = ({
  size: e,
  isOpen: t,
  onClose: n,
  variant: r,
  title: o,
  children: i,
  primaryAction: a,
  secondaryAction: u,
  closeOnEsc: c = !0,
  showCloseButton: d = !0,
  overflow: f,
  modalBodyProps: p = {},
  titleBadge: g,
  fullHeight: m = !1,
  leftFooterContent: b
}) => {
  const v = a || u || b;
  return /* @__PURE__ */ x.jsxs(
    Y3,
    {
      isOpen: t,
      onClose: n,
      scrollBehavior: "inside",
      size: e || "lg",
      isCentered: !0,
      closeOnEsc: c,
      closeOnOverlayClick: c,
      children: [
        /* @__PURE__ */ x.jsx(Q3, {}),
        /* @__PURE__ */ x.jsxs(
          Dv,
          {
            onKeyDown: (y) => {
              y.stopPropagation();
            },
            height: m ? "100%" : "auto",
            children: [
              /* @__PURE__ */ x.jsxs(K3, { borderBottom: "1px solid border", children: [
                /* @__PURE__ */ x.jsxs(vs, { alignItems: "center", justifyContent: "flex-start", flexGrow: 1, gap: 2, children: [
                  o,
                  g && /* @__PURE__ */ x.jsx(hb, { ...g, size: "md" })
                ] }),
                d && /* @__PURE__ */ x.jsx(Ov, { onClick: n })
              ] }),
              /* @__PURE__ */ x.jsx(J3, { overflow: f, ...p, children: i }),
              /* @__PURE__ */ x.jsx(q3, { borderTop: "1px solid border", children: v && /* @__PURE__ */ x.jsxs(vs, { justifyContent: "space-between", flex: 1, children: [
                /* @__PURE__ */ x.jsx(sf, { gap: 2, children: b }),
                /* @__PURE__ */ x.jsxs(sf, { gap: 2, children: [
                  u && /* @__PURE__ */ x.jsx(df, { variant: "secondary", ...u }),
                  a && /* @__PURE__ */ x.jsx(
                    H2,
                    {
                      isDisabled: Un(a.tooltipText),
                      label: a.tooltipText,
                      children: /* @__PURE__ */ x.jsx(
                        df,
                        {
                          variant: r === "danger" ? "danger" : "primary",
                          ...a
                        }
                      )
                    }
                  )
                ] })
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, ite = (e) => {
  const [t, n] = Ee(!1);
  return {
    Modal: JY,
    isModalOpen: t,
    openModal: () => {
      var i;
      n(!0), (i = e == null ? void 0 : e.onOpen) == null || i.call(e);
    },
    closeModal: () => {
      var i;
      n(!1), (i = e == null ? void 0 : e.onClose) == null || i.call(e);
    }
  };
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function ste() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Si(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function gr(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: Si(n, r[e])
    }));
  };
}
function D2(e) {
  return e instanceof Function;
}
function qY(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function KY(e, t) {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push(i);
      const a = t(i);
      a != null && a.length && r(a);
    });
  };
  return r(e), n;
}
function je(e, t, n) {
  let r = [], o;
  return (i) => {
    let a;
    n.key && n.debug && (a = Date.now());
    const u = e(i);
    if (!(u.length !== r.length || u.some((f, p) => r[p] !== f)))
      return o;
    r = u;
    let d;
    if (n.key && n.debug && (d = Date.now()), o = t(...u), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const f = Math.round((Date.now() - a) * 100) / 100, p = Math.round((Date.now() - d) * 100) / 100, g = p / 16, m = (b, v) => {
        for (b = String(b); b.length < v; )
          b = " " + b;
        return b;
      };
      console.info(`%c⏱ ${m(p, 5)} /${m(f, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * g, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function Xe(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function QY(e, t, n, r) {
  const o = () => {
    var a;
    return (a = i.getValue()) != null ? a : e.options.renderFallbackValue;
  }, i = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: je(() => [e, n, t, i], (a, u, c, d) => ({
      table: a,
      column: u,
      row: c,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), Xe(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(i, n, t, e);
  }, {}), i;
}
function eJ(e, t, n, r) {
  var o, i;
  const u = {
    ...e._getDefaultColumnDef(),
    ...t
  }, c = u.accessorKey;
  let d = (o = (i = u.id) != null ? i : c ? typeof String.prototype.replaceAll == "function" ? c.replaceAll(".", "_") : c.replace(/\./g, "_") : void 0) != null ? o : typeof u.header == "string" ? u.header : void 0, f;
  if (u.accessorFn ? f = u.accessorFn : c && (c.includes(".") ? f = (g) => {
    let m = g;
    for (const v of c.split(".")) {
      var b;
      m = (b = m) == null ? void 0 : b[v], process.env.NODE_ENV !== "production" && m === void 0 && console.warn(`"${v}" in deeply nested key "${c}" returned undefined.`);
    }
    return m;
  } : f = (g) => g[u.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(u.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let p = {
    id: `${String(d)}`,
    accessorFn: f,
    parent: r,
    depth: n,
    columnDef: u,
    columns: [],
    getFlatColumns: je(() => [!0], () => {
      var g;
      return [p, ...(g = p.columns) == null ? void 0 : g.flatMap((m) => m.getFlatColumns())];
    }, Xe(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: je(() => [e._getOrderColumnsFn()], (g) => {
      var m;
      if ((m = p.columns) != null && m.length) {
        let b = p.columns.flatMap((v) => v.getLeafColumns());
        return g(b);
      }
      return [p];
    }, Xe(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const g of e._features)
    g.createColumn == null || g.createColumn(p, e);
  return p;
}
const Pn = "debugHeaders";
function Sh(e, t, n) {
  var r;
  let i = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], u = (c) => {
        c.subHeaders && c.subHeaders.length && c.subHeaders.map(u), a.push(c);
      };
      return u(i), a;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: t
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(i, e);
  }), i;
}
const tJ = {
  createTable: (e) => {
    e.getHeaderGroups = je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var i, a;
      const u = (i = r == null ? void 0 : r.map((p) => n.find((g) => g.id === p)).filter(Boolean)) != null ? i : [], c = (a = o == null ? void 0 : o.map((p) => n.find((g) => g.id === p)).filter(Boolean)) != null ? a : [], d = n.filter((p) => !(r != null && r.includes(p.id)) && !(o != null && o.includes(p.id)));
      return fc(t, [...u, ...d, ...c], e);
    }, Xe(e.options, Pn, "getHeaderGroups")), e.getCenterHeaderGroups = je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), fc(t, n, e, "center")), Xe(e.options, Pn, "getCenterHeaderGroups")), e.getLeftHeaderGroups = je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((a) => n.find((u) => u.id === a)).filter(Boolean)) != null ? o : [];
      return fc(t, i, e, "left");
    }, Xe(e.options, Pn, "getLeftHeaderGroups")), e.getRightHeaderGroups = je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((a) => n.find((u) => u.id === a)).filter(Boolean)) != null ? o : [];
      return fc(t, i, e, "right");
    }, Xe(e.options, Pn, "getRightHeaderGroups")), e.getFooterGroups = je(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Xe(e.options, Pn, "getFooterGroups")), e.getLeftFooterGroups = je(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Xe(e.options, Pn, "getLeftFooterGroups")), e.getCenterFooterGroups = je(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Xe(e.options, Pn, "getCenterFooterGroups")), e.getRightFooterGroups = je(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Xe(e.options, Pn, "getRightFooterGroups")), e.getFlatHeaders = je(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Xe(e.options, Pn, "getFlatHeaders")), e.getLeftFlatHeaders = je(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Xe(e.options, Pn, "getLeftFlatHeaders")), e.getCenterFlatHeaders = je(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Xe(e.options, Pn, "getCenterFlatHeaders")), e.getRightFlatHeaders = je(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Xe(e.options, Pn, "getRightFlatHeaders")), e.getCenterLeafHeaders = je(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Xe(e.options, Pn, "getCenterLeafHeaders")), e.getLeftLeafHeaders = je(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Xe(e.options, Pn, "getLeftLeafHeaders")), e.getRightLeafHeaders = je(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Xe(e.options, Pn, "getRightLeafHeaders")), e.getLeafHeaders = je(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, i, a, u, c, d;
      return [...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(a = (u = n[0]) == null ? void 0 : u.headers) != null ? a : [], ...(c = (d = r[0]) == null ? void 0 : d.headers) != null ? c : []].map((f) => f.getLeafHeaders()).flat();
    }, Xe(e.options, Pn, "getLeafHeaders"));
  }
};
function fc(e, t, n, r) {
  var o, i;
  let a = 0;
  const u = function(g, m) {
    m === void 0 && (m = 1), a = Math.max(a, m), g.filter((b) => b.getIsVisible()).forEach((b) => {
      var v;
      (v = b.columns) != null && v.length && u(b.columns, m + 1);
    }, 0);
  };
  u(e);
  let c = [];
  const d = (g, m) => {
    const b = {
      depth: m,
      id: [r, `${m}`].filter(Boolean).join("_"),
      headers: []
    }, v = [];
    g.forEach((y) => {
      const w = [...v].reverse()[0], I = y.column.depth === b.depth;
      let V, M = !1;
      if (I && y.column.parent ? V = y.column.parent : (V = y.column, M = !0), w && (w == null ? void 0 : w.column) === V)
        w.subHeaders.push(y);
      else {
        const L = Sh(n, V, {
          id: [r, m, V.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: M,
          placeholderId: M ? `${v.filter((R) => R.column === V).length}` : void 0,
          depth: m,
          index: v.length
        });
        L.subHeaders.push(y), v.push(L);
      }
      b.headers.push(y), y.headerGroup = b;
    }), c.push(b), m > 0 && d(v, m - 1);
  }, f = t.map((g, m) => Sh(n, g, {
    depth: a,
    index: m
  }));
  d(f, a - 1), c.reverse();
  const p = (g) => g.filter((b) => b.column.getIsVisible()).map((b) => {
    let v = 0, y = 0, w = [0];
    b.subHeaders && b.subHeaders.length ? (w = [], p(b.subHeaders).forEach((V) => {
      let {
        colSpan: M,
        rowSpan: L
      } = V;
      v += M, w.push(L);
    })) : v = 1;
    const I = Math.min(...w);
    return y = y + I, b.colSpan = v, b.rowSpan = y, {
      colSpan: v,
      rowSpan: y
    };
  });
  return p((o = (i = c[0]) == null ? void 0 : i.headers) != null ? o : []), c;
}
const nJ = (e, t, n, r, o, i, a) => {
  let u = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (c) => {
      if (u._valuesCache.hasOwnProperty(c))
        return u._valuesCache[c];
      const d = e.getColumn(c);
      if (d != null && d.accessorFn)
        return u._valuesCache[c] = d.accessorFn(u.original, r), u._valuesCache[c];
    },
    getUniqueValues: (c) => {
      if (u._uniqueValuesCache.hasOwnProperty(c))
        return u._uniqueValuesCache[c];
      const d = e.getColumn(c);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (u._uniqueValuesCache[c] = d.columnDef.getUniqueValues(u.original, r), u._uniqueValuesCache[c]) : (u._uniqueValuesCache[c] = [u.getValue(c)], u._uniqueValuesCache[c]);
    },
    renderValue: (c) => {
      var d;
      return (d = u.getValue(c)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: i ?? [],
    getLeafRows: () => KY(u.subRows, (c) => c.subRows),
    getParentRow: () => u.parentId ? e.getRow(u.parentId, !0) : void 0,
    getParentRows: () => {
      let c = [], d = u;
      for (; ; ) {
        const f = d.getParentRow();
        if (!f)
          break;
        c.push(f), d = f;
      }
      return c.reverse();
    },
    getAllCells: je(() => [e.getAllLeafColumns()], (c) => c.map((d) => QY(e, u, d, d.id)), Xe(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: je(() => [u.getAllCells()], (c) => c.reduce((d, f) => (d[f.column.id] = f, d), {}), Xe(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let c = 0; c < e._features.length; c++) {
    const d = e._features[c];
    d == null || d.createRow == null || d.createRow(u, e);
  }
  return u;
}, rJ = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Eb = (e, t, n) => {
  var r, o;
  const i = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(i));
};
Eb.autoRemove = (e) => no(e);
const Rb = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
Rb.autoRemove = (e) => no(e);
const _b = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
_b.autoRemove = (e) => no(e);
const Tb = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
Tb.autoRemove = (e) => no(e);
const Hb = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
Hb.autoRemove = (e) => no(e) || !(e != null && e.length);
const Fb = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
Fb.autoRemove = (e) => no(e) || !(e != null && e.length);
const kb = (e, t, n) => e.getValue(t) === n;
kb.autoRemove = (e) => no(e);
const Bb = (e, t, n) => e.getValue(t) == n;
Bb.autoRemove = (e) => no(e);
const c4 = (e, t, n) => {
  let [r, o] = n;
  const i = e.getValue(t);
  return i >= r && i <= o;
};
c4.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, i = t === null || Number.isNaN(r) ? -1 / 0 : r, a = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > a) {
    const u = i;
    i = a, a = u;
  }
  return [i, a];
};
c4.autoRemove = (e) => no(e) || no(e[0]) && no(e[1]);
const Fo = {
  includesString: Eb,
  includesStringSensitive: Rb,
  equalsString: _b,
  arrIncludes: Tb,
  arrIncludesAll: Hb,
  arrIncludesSome: Fb,
  equals: kb,
  weakEquals: Bb,
  inNumberRange: c4
};
function no(e) {
  return e == null || e === "";
}
const oJ = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: gr("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? Fo.includesString : typeof r == "number" ? Fo.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Fo.equals : Array.isArray(r) ? Fo.arrIncludes : Fo.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return D2(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : Fo[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), i = r == null ? void 0 : r.find((f) => f.id === e.id), a = Si(n, i ? i.value : void 0);
        if (wh(o, a, e)) {
          var u;
          return (u = r == null ? void 0 : r.filter((f) => f.id !== e.id)) != null ? u : [];
        }
        const c = {
          id: e.id,
          value: a
        };
        if (i) {
          var d;
          return (d = r == null ? void 0 : r.map((f) => f.id === e.id ? c : f)) != null ? d : [];
        }
        return r != null && r.length ? [...r, c] : [c];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = Si(t, o)) == null ? void 0 : i.filter((a) => {
          const u = n.find((c) => c.id === a.id);
          if (u) {
            const c = u.getFilterFn();
            if (wh(c, a.value, u))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function wh(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const iJ = (e, t, n) => n.reduce((r, o) => {
  const i = o.getValue(e);
  return r + (typeof i == "number" ? i : 0);
}, 0), sJ = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, aJ = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, lJ = (e, t, n) => {
  let r, o;
  return n.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = o = a) : (r > a && (r = a), o < a && (o = a)));
  }), [r, o];
}, uJ = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let i = o.getValue(e);
    i != null && (i = +i) >= i && (++n, r += i);
  }), n)
    return r / n;
}, cJ = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((i) => i.getValue(e));
  if (!qY(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((i, a) => i - a);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, dJ = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), fJ = (e, t) => new Set(t.map((n) => n.getValue(e))).size, hJ = (e, t) => t.length, r5 = {
  sum: iJ,
  min: sJ,
  max: aJ,
  extent: lJ,
  mean: uJ,
  median: cJ,
  unique: dJ,
  uniqueCount: fJ,
  count: hJ
}, pJ = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: gr("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return r5.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return r5.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return D2(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : r5[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function gJ(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((i) => !t.includes(i.id));
  return n === "remove" ? r : [...t.map((i) => e.find((a) => a.id === i)).filter(Boolean), ...r];
}
const mJ = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: gr("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = je((n) => [nl(t, n)], (n) => n.findIndex((r) => r.id === e.id), Xe(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = nl(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = nl(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = je(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let i = [];
      if (!(t != null && t.length))
        i = o;
      else {
        const a = [...t], u = [...o];
        for (; u.length && a.length; ) {
          const c = a.shift(), d = u.findIndex((f) => f.id === c);
          d > -1 && i.push(u.splice(d, 1)[0]);
        }
        i = [...i, ...u];
      }
      return gJ(i, n, r);
    }, Xe(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, o5 = () => ({
  left: [],
  right: []
}), CJ = {
  getInitialState: (e) => ({
    columnPinning: o5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: gr("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var i, a;
        if (n === "right") {
          var u, c;
          return {
            left: ((u = o == null ? void 0 : o.left) != null ? u : []).filter((p) => !(r != null && r.includes(p))),
            right: [...((c = o == null ? void 0 : o.right) != null ? c : []).filter((p) => !(r != null && r.includes(p))), ...r]
          };
        }
        if (n === "left") {
          var d, f;
          return {
            left: [...((d = o == null ? void 0 : o.left) != null ? d : []).filter((p) => !(r != null && r.includes(p))), ...r],
            right: ((f = o == null ? void 0 : o.right) != null ? f : []).filter((p) => !(r != null && r.includes(p)))
          };
        }
        return {
          left: ((i = o == null ? void 0 : o.left) != null ? i : []).filter((p) => !(r != null && r.includes(p))),
          right: ((a = o == null ? void 0 : o.right) != null ? a : []).filter((p) => !(r != null && r.includes(p)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, i, a;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (a = t.options.enableColumnPinning) != null ? a : t.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((u) => u.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, i = n.some((u) => r == null ? void 0 : r.includes(u)), a = n.some((u) => o == null ? void 0 : o.includes(u));
      return i ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = je(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((a) => !i.includes(a.column.id));
    }, Xe(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = je(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), Xe(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = je(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), Xe(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? o5() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : o5());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = je(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Xe(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = je(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Xe(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = je(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((i) => !o.includes(i.id));
    }, Xe(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function vJ(e) {
  return e || (typeof document < "u" ? document : null);
}
const hc = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, i5 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), bJ = {
  getDefaultColumnDef: () => hc,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: i5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: gr("columnSizing", e),
    onColumnSizingInfoChange: gr("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const i = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : hc.minSize, (r = i ?? e.columnDef.size) != null ? r : hc.size), (o = e.columnDef.maxSize) != null ? o : hc.maxSize);
    }, e.getStart = je((n) => [n, nl(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, i) => o + i.getSize(), 0), Xe(t.options, "debugColumns", "getStart")), e.getAfter = je((n) => [n, nl(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, i) => o + i.getSize(), 0), Xe(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          n += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (i) => {
        if (!r || !o || (i.persist == null || i.persist(), s5(i) && i.touches && i.touches.length > 1))
          return;
        const a = e.getSize(), u = e ? e.getLeafHeaders().map((w) => [w.column.id, w.column.getSize()]) : [[r.id, r.getSize()]], c = s5(i) ? Math.round(i.touches[0].clientX) : i.clientX, d = {}, f = (w, I) => {
          typeof I == "number" && (t.setColumnSizingInfo((V) => {
            var M, L;
            const R = t.options.columnResizeDirection === "rtl" ? -1 : 1, _ = (I - ((M = V == null ? void 0 : V.startOffset) != null ? M : 0)) * R, H = Math.max(_ / ((L = V == null ? void 0 : V.startSize) != null ? L : 0), -0.999999);
            return V.columnSizingStart.forEach((B) => {
              let [Z, G] = B;
              d[Z] = Math.round(Math.max(G + G * H, 0) * 100) / 100;
            }), {
              ...V,
              deltaOffset: _,
              deltaPercentage: H
            };
          }), (t.options.columnResizeMode === "onChange" || w === "end") && t.setColumnSizing((V) => ({
            ...V,
            ...d
          })));
        }, p = (w) => f("move", w), g = (w) => {
          f("end", w), t.setColumnSizingInfo((I) => ({
            ...I,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, m = vJ(n), b = {
          moveHandler: (w) => p(w.clientX),
          upHandler: (w) => {
            m == null || m.removeEventListener("mousemove", b.moveHandler), m == null || m.removeEventListener("mouseup", b.upHandler), g(w.clientX);
          }
        }, v = {
          moveHandler: (w) => (w.cancelable && (w.preventDefault(), w.stopPropagation()), p(w.touches[0].clientX), !1),
          upHandler: (w) => {
            var I;
            m == null || m.removeEventListener("touchmove", v.moveHandler), m == null || m.removeEventListener("touchend", v.upHandler), w.cancelable && (w.preventDefault(), w.stopPropagation()), g((I = w.touches[0]) == null ? void 0 : I.clientX);
          }
        }, y = yJ() ? {
          passive: !1
        } : !1;
        s5(i) ? (m == null || m.addEventListener("touchmove", v.moveHandler, y), m == null || m.addEventListener("touchend", v.upHandler, y)) : (m == null || m.addEventListener("mousemove", b.moveHandler, y), m == null || m.addEventListener("mouseup", b.upHandler, y)), t.setColumnSizingInfo((w) => ({
          ...w,
          startOffset: c,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: u,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? i5() : (n = e.initialState.columnSizingInfo) != null ? n : i5());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let pc = null;
function yJ() {
  if (typeof pc == "boolean")
    return pc;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return pc = e, pc;
}
function s5(e) {
  return e.type === "touchstart";
}
const xJ = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: gr("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((i) => i.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = je(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Xe(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = je(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], Xe(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => je(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), Xe(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function nl(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const SJ = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, wJ = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: gr("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, i;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((i = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Fo.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return D2(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : Fo[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, IJ = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: gr("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n)
          return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, i;
      e.setExpanded(r ? {} : (o = (i = e.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const a = i.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((u) => {
          a[u] = !0;
        }) : a = r, n = (o = n) != null ? o : !i, !i && n)
          return {
            ...a,
            [e.id]: !0
          };
        if (i && !n) {
          const {
            [e.id]: u,
            ...c
          } = a;
          return c;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, pf = 0, gf = 10, a5 = () => ({
  pageIndex: pf,
  pageSize: gf
}), VJ = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...a5(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: gr("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n)
          return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (i) => Si(r, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? a5() : (o = e.initialState.pagination) != null ? o : a5());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let i = Si(r, o.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, a)), {
          ...o,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, i;
      e.setPageIndex(r ? pf : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : pf);
    }, e.resetPageSize = (r) => {
      var o, i;
      e.setPageSize(r ? gf : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : gf);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const i = Math.max(1, Si(r, o.pageSize)), a = o.pageSize * o.pageIndex, u = Math.floor(a / i);
        return {
          ...o,
          pageIndex: u,
          pageSize: i
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var i;
      let a = Si(r, (i = e.options.pageCount) != null ? i : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...o,
        pageCount: a
      };
    }), e.getPageOptions = je(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, a) => a)), o;
    }, Xe(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, l5 = () => ({
  top: [],
  bottom: []
}), AJ = {
  getInitialState: (e) => ({
    rowPinning: l5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: gr("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const i = r ? e.getLeafRows().map((c) => {
        let {
          id: d
        } = c;
        return d;
      }) : [], a = o ? e.getParentRows().map((c) => {
        let {
          id: d
        } = c;
        return d;
      }) : [], u = /* @__PURE__ */ new Set([...a, e.id, ...i]);
      t.setRowPinning((c) => {
        var d, f;
        if (n === "bottom") {
          var p, g;
          return {
            top: ((p = c == null ? void 0 : c.top) != null ? p : []).filter((v) => !(u != null && u.has(v))),
            bottom: [...((g = c == null ? void 0 : c.bottom) != null ? g : []).filter((v) => !(u != null && u.has(v))), ...Array.from(u)]
          };
        }
        if (n === "top") {
          var m, b;
          return {
            top: [...((m = c == null ? void 0 : c.top) != null ? m : []).filter((v) => !(u != null && u.has(v))), ...Array.from(u)],
            bottom: ((b = c == null ? void 0 : c.bottom) != null ? b : []).filter((v) => !(u != null && u.has(v)))
          };
        }
        return {
          top: ((d = c == null ? void 0 : c.top) != null ? d : []).filter((v) => !(u != null && u.has(v))),
          bottom: ((f = c == null ? void 0 : c.bottom) != null ? f : []).filter((v) => !(u != null && u.has(v)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, i = n.some((u) => r == null ? void 0 : r.includes(u)), a = n.some((u) => o == null ? void 0 : o.includes(u));
      return i ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o)
        return -1;
      const i = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((a) => {
        let {
          id: u
        } = a;
        return u;
      });
      return (r = i == null ? void 0 : i.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? l5() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : l5());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((a) => {
          const u = e.getRow(a, !0);
          return u.getIsAllParentsExpanded() ? u : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((a) => t.find((u) => u.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, e.getTopRows = je(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Xe(e.options, "debugRows", "getTopRows")), e.getBottomRows = je(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Xe(e.options, "debugRows", "getBottomRows")), e.getCenterRows = je(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((i) => !o.has(i.id));
    }, Xe(e.options, "debugRows", "getCenterRows"));
  }
}, LJ = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: gr("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((i) => {
        mf(o, i.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = je(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? u5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Xe(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = je(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? u5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Xe(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = je(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? u5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Xe(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((i) => {
        var a;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return i;
        const u = {
          ...i
        };
        return mf(u, e.id, n, (a = r == null ? void 0 : r.selectChildren) != null ? a : !0, t), u;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return d4(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Cf(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Cf(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, mf = (e, t, n, r, o) => {
  var i;
  const a = o.getRow(t, !0);
  n ? (a.getCanMultiSelect() || Object.keys(e).forEach((u) => delete e[u]), a.getCanSelect() && (e[t] = !0)) : delete e[t], r && (i = a.subRows) != null && i.length && a.getCanSelectSubRows() && a.subRows.forEach((u) => mf(e, u.id, n, r, o));
};
function u5(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, i = function(a, u) {
    return a.map((c) => {
      var d;
      const f = d4(c, n);
      if (f && (r.push(c), o[c.id] = c), (d = c.subRows) != null && d.length && (c = {
        ...c,
        subRows: i(c.subRows)
      }), f)
        return c;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function d4(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function Cf(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length))
    return !1;
  let o = !0, i = !1;
  return e.subRows.forEach((a) => {
    if (!(i && !o) && (a.getCanSelect() && (d4(a, t) ? i = !0 : o = !1), a.subRows && a.subRows.length)) {
      const u = Cf(a, t);
      u === "all" ? i = !0 : (u === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const vf = /([0-9]+)/gm, MJ = (e, t, n) => Db(Pi(e.getValue(n)).toLowerCase(), Pi(t.getValue(n)).toLowerCase()), PJ = (e, t, n) => Db(Pi(e.getValue(n)), Pi(t.getValue(n))), EJ = (e, t, n) => f4(Pi(e.getValue(n)).toLowerCase(), Pi(t.getValue(n)).toLowerCase()), RJ = (e, t, n) => f4(Pi(e.getValue(n)), Pi(t.getValue(n))), _J = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, TJ = (e, t, n) => f4(e.getValue(n), t.getValue(n));
function f4(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function Pi(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Db(e, t) {
  const n = e.split(vf).filter(Boolean), r = t.split(vf).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), i = r.shift(), a = parseInt(o, 10), u = parseInt(i, 10), c = [a, u].sort();
    if (isNaN(c[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(c[1]))
      return isNaN(a) ? -1 : 1;
    if (a > u)
      return 1;
    if (u > a)
      return -1;
  }
  return n.length - r.length;
}
const M1 = {
  alphanumeric: MJ,
  alphanumericCaseSensitive: PJ,
  text: EJ,
  textCaseSensitive: RJ,
  datetime: _J,
  basic: TJ
}, HJ = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: gr("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const i = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return M1.datetime;
        if (typeof i == "string" && (r = !0, i.split(vf).length > 1))
          return M1.alphanumeric;
      }
      return r ? M1.text : M1.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return D2(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : M1[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      t.setSorting((a) => {
        const u = a == null ? void 0 : a.find((m) => m.id === e.id), c = a == null ? void 0 : a.findIndex((m) => m.id === e.id);
        let d = [], f, p = i ? n : o === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? u ? f = "toggle" : f = "add" : a != null && a.length && c !== a.length - 1 ? f = "replace" : u ? f = "toggle" : f = "replace", f === "toggle" && (i || o || (f = "remove")), f === "add") {
          var g;
          d = [...a, {
            id: e.id,
            desc: p
          }], d.splice(0, d.length - ((g = t.options.maxMultiSortColCount) != null ? g : Number.MAX_SAFE_INTEGER));
        } else
          f === "toggle" ? d = a.map((m) => m.id === e.id ? {
            ...m,
            desc: p
          } : m) : f === "remove" ? d = a.filter((m) => m.id !== e.id) : d = [{
            id: e.id,
            desc: p
          }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const i = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== i && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : a === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, FJ = [
  tJ,
  xJ,
  mJ,
  CJ,
  rJ,
  oJ,
  SJ,
  //depends on ColumnFaceting
  wJ,
  //depends on ColumnFiltering
  HJ,
  pJ,
  //depends on RowSorting
  IJ,
  VJ,
  AJ,
  LJ,
  bJ
];
function kJ(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...FJ, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const i = o._features.reduce((g, m) => Object.assign(g, m.getDefaultOptions == null ? void 0 : m.getDefaultOptions(o)), {}), a = (g) => o.options.mergeOptions ? o.options.mergeOptions(i, g) : {
    ...i,
    ...g
  };
  let c = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((g) => {
    var m;
    c = (m = g.getInitialState == null ? void 0 : g.getInitialState(c)) != null ? m : c;
  });
  const d = [];
  let f = !1;
  const p = {
    _features: r,
    options: {
      ...i,
      ...e
    },
    initialState: c,
    _queue: (g) => {
      d.push(g), f || (f = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        f = !1;
      }).catch((m) => setTimeout(() => {
        throw m;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (g) => {
      const m = Si(g, o.options);
      o.options = a(m);
    },
    getState: () => o.options.state,
    setState: (g) => {
      o.options.onStateChange == null || o.options.onStateChange(g);
    },
    _getRowId: (g, m, b) => {
      var v;
      return (v = o.options.getRowId == null ? void 0 : o.options.getRowId(g, m, b)) != null ? v : `${b ? [b.id, m].join(".") : m}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (g, m) => {
      let b = (m ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[g];
      if (!b && (b = o.getCoreRowModel().rowsById[g], !b))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${g}`) : new Error();
      return b;
    },
    _getDefaultColumnDef: je(() => [o.options.defaultColumn], (g) => {
      var m;
      return g = (m = g) != null ? m : {}, {
        header: (b) => {
          const v = b.header.column.columnDef;
          return v.accessorKey ? v.accessorKey : v.accessorFn ? v.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (b) => {
          var v, y;
          return (v = (y = b.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? v : null;
        },
        ...o._features.reduce((b, v) => Object.assign(b, v.getDefaultColumnDef == null ? void 0 : v.getDefaultColumnDef()), {}),
        ...g
      };
    }, Xe(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: je(() => [o._getColumnDefs()], (g) => {
      const m = function(b, v, y) {
        return y === void 0 && (y = 0), b.map((w) => {
          const I = eJ(o, w, y, v), V = w;
          return I.columns = V.columns ? m(V.columns, I, y + 1) : [], I;
        });
      };
      return m(g);
    }, Xe(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: je(() => [o.getAllColumns()], (g) => g.flatMap((m) => m.getFlatColumns()), Xe(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: je(() => [o.getAllFlatColumns()], (g) => g.reduce((m, b) => (m[b.id] = b, m), {}), Xe(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: je(() => [o.getAllColumns(), o._getOrderColumnsFn()], (g, m) => {
      let b = g.flatMap((v) => v.getLeafColumns());
      return m(b);
    }, Xe(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (g) => {
      const m = o._getAllFlatColumnsById()[g];
      return process.env.NODE_ENV !== "production" && !m && console.error(`[Table] Column with id '${g}' does not exist.`), m;
    }
  };
  Object.assign(o, p);
  for (let g = 0; g < o._features.length; g++) {
    const m = o._features[g];
    m == null || m.createTable == null || m.createTable(o);
  }
  return o;
}
function BJ() {
  return (e) => je(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, a) {
      i === void 0 && (i = 0);
      const u = [];
      for (let d = 0; d < o.length; d++) {
        const f = nJ(e, e._getRowId(o[d], d, a), o[d], d, i, void 0, a == null ? void 0 : a.id);
        if (n.flatRows.push(f), n.rowsById[f.id] = f, u.push(f), e.options.getSubRows) {
          var c;
          f.originalSubRows = e.options.getSubRows(o[d], d), (c = f.originalSubRows) != null && c.length && (f.subRows = r(f.originalSubRows, i + 1, f));
        }
      }
      return u;
    };
    return n.rows = r(t), n;
  }, Xe(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function DJ(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function OJ(e) {
  return (t) => je(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: i
    } = n;
    let {
      rows: a,
      flatRows: u,
      rowsById: c
    } = r;
    const d = o * i, f = d + o;
    a = a.slice(d, f);
    let p;
    t.options.paginateExpandedRows ? p = {
      rows: a,
      flatRows: u,
      rowsById: c
    } : p = DJ({
      rows: a,
      flatRows: u,
      rowsById: c
    }), p.flatRows = [];
    const g = (m) => {
      p.flatRows.push(m), m.subRows.length && m.subRows.forEach(g);
    };
    return p.rows.forEach(g), p;
  }, Xe(t.options, "debugTable", "getPaginationRowModel"));
}
function NJ() {
  return (e) => je(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, o = [], i = r.filter((c) => {
      var d;
      return (d = e.getColumn(c.id)) == null ? void 0 : d.getCanSort();
    }), a = {};
    i.forEach((c) => {
      const d = e.getColumn(c.id);
      d && (a[c.id] = {
        sortUndefined: d.columnDef.sortUndefined,
        invertSorting: d.columnDef.invertSorting,
        sortingFn: d.getSortingFn()
      });
    });
    const u = (c) => {
      const d = c.map((f) => ({
        ...f
      }));
      return d.sort((f, p) => {
        for (let m = 0; m < i.length; m += 1) {
          var g;
          const b = i[m], v = a[b.id], y = v.sortUndefined, w = (g = b == null ? void 0 : b.desc) != null ? g : !1;
          let I = 0;
          if (y) {
            const V = f.getValue(b.id), M = p.getValue(b.id), L = V === void 0, R = M === void 0;
            if (L || R) {
              if (y === "first")
                return L ? -1 : 1;
              if (y === "last")
                return L ? 1 : -1;
              I = L && R ? 0 : L ? y : -y;
            }
          }
          if (I === 0 && (I = v.sortingFn(f, p, b.id)), I !== 0)
            return w && (I *= -1), v.invertSorting && (I *= -1), I;
        }
        return f.index - p.index;
      }), d.forEach((f) => {
        var p;
        o.push(f), (p = f.subRows) != null && p.length && (f.subRows = u(f.subRows));
      }), d;
    };
    return {
      rows: u(n.rows),
      flatRows: o,
      rowsById: n.rowsById
    };
  }, Xe(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ih(e, t) {
  return e ? ZJ(e) ? /* @__PURE__ */ be.createElement(e, t) : e : null;
}
function ZJ(e) {
  return $J(e) || typeof e == "function" || zJ(e);
}
function $J(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function zJ(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function WJ(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = be.useState(() => ({
    current: kJ(t)
  })), [r, o] = be.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      o(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), n.current;
}
const GJ = (e) => {
  if (!e.getCanSort())
    return null;
  const t = e.getIsSorted();
  return t === !1 ? /* @__PURE__ */ x.jsx(Fr, { icon: "arrow-up-down", size: "md" }) : t === "desc" ? /* @__PURE__ */ x.jsx(Fr, { icon: "arrow-down", size: "md" }) : /* @__PURE__ */ x.jsx(Fr, { icon: "arrow-up", size: "md" });
}, ate = ({
  columns: e,
  data: t,
  onClick: n,
  onHover: r,
  initialState: o,
  determineRowColor: i,
  size: a,
  whiteSpace: u
}) => {
  const c = Bn.useMemo(() => t, [t]), d = Bn.useMemo(() => e, [e]), {
    getPageCount: f,
    getHeaderGroups: p,
    previousPage: g,
    nextPage: m,
    getCanPreviousPage: b,
    getCanNextPage: v,
    getState: y,
    getRowModel: w
  } = WJ({
    columns: d,
    data: c,
    getCoreRowModel: BJ(),
    getPaginationRowModel: OJ(),
    getSortedRowModel: NJ(),
    enableSorting: !0,
    initialState: {
      pagination: {
        pageIndex: (o == null ? void 0 : o.pageIndex) ?? 0,
        pageSize: (o == null ? void 0 : o.pageSize) ?? 50
      },
      sorting: o != null && o.sortBy ? o.sortBy : []
    }
  }), I = y(), V = f(), M = I.pagination.pageIndex + 1, L = V > 1, R = p(), _ = v(), H = b(), B = qe(r), Z = qe(n);
  return /* @__PURE__ */ x.jsxs(
    Jo,
    {
      sx: {
        table: {
          "td.sm": { width: "1%", paddingLeft: "6px", paddingRight: "6px" },
          "td.md": { width: "2%" },
          "td.lg": { width: "5%" },
          "th.sm": { width: "1%", paddingLeft: "6px", paddingRight: "6px" },
          "th.md": { width: "2%" },
          "th.lg": { width: "5%" }
        }
      },
      children: [
        /* @__PURE__ */ x.jsxs(sb, { size: a, whiteSpace: u, role: "table", children: [
          /* @__PURE__ */ x.jsx(kj, { children: R.map((G) => /* @__PURE__ */ x.jsx(q8, { role: "row", children: G.headers.map((se) => {
            const ue = se.column.getCanSort(), { isPlaceholder: ce } = se, xe = ue ? {
              onClick: se.column.getToggleSortingHandler(),
              cursor: "pointer",
              userSelect: "none"
            } : {};
            return /* @__PURE__ */ x.jsx(Fj, { role: "columnheader", children: ce ? null : /* @__PURE__ */ x.jsxs(Jo, { ...xe, display: "flex", alignItems: "center", children: [
              Ih(se.column.columnDef.header, se.getContext()),
              ue && /* @__PURE__ */ x.jsx(ye.span, { pl: "4", children: GJ(se.column) })
            ] }) }, se.id);
          }) }, G.id)) }),
          /* @__PURE__ */ x.jsx(Tj, { role: "rowgroup", children: w().rows.map((G) => {
            const se = Z ? {
              sx: {
                ":hover td": {
                  cursor: "pointer"
                }
              },
              onClick: () => n(G.original)
            } : {};
            return /* @__PURE__ */ x.jsx(
              q8,
              {
                role: "row",
                onMouseOver: B ? () => r(G.original) : void 0,
                backgroundColor: i ? i(G.original) : "transparent",
                ...se,
                children: G.getVisibleCells().map((ue) => /* @__PURE__ */ x.jsx(Hj, { children: Ih(ue.column.columnDef.cell, ue.getContext()) }, ue.id))
              },
              G.id
            );
          }) })
        ] }),
        L && /* @__PURE__ */ x.jsxs(Uc, { justifyContent: "center", alignItems: "center", gap: 6, paddingTop: 4, children: [
          /* @__PURE__ */ x.jsx(
            Qc,
            {
              onClick: g,
              disabled: !H,
              ariaLabel: "Back",
              icon: "arrow-left"
            }
          ),
          /* @__PURE__ */ x.jsx(Or, { children: `${M} of ${V}` }),
          /* @__PURE__ */ x.jsx(
            Qc,
            {
              onClick: m,
              disabled: !_,
              ariaLabel: "Next",
              icon: "arrow-right"
            }
          )
        ] })
      ]
    }
  );
}, {
  createElement: Ba,
  createContext: jJ,
  forwardRef: Ob,
  useCallback: Ci,
  useContext: Nb,
  useEffect: jo,
  useImperativeHandle: Zb,
  useLayoutEffect: XJ,
  useMemo: UJ,
  useRef: dr,
  useState: rl
} = be, Vh = be["useId".toString()], r2 = XJ, YJ = typeof Vh == "function" ? Vh : () => null;
let JJ = 0;
function h4(e = null) {
  const t = YJ(), n = dr(e || t || null);
  return n.current === null && (n.current = "" + JJ++), n.current;
}
const O2 = jJ(null);
O2.displayName = "PanelGroupContext";
function $b({
  children: e = null,
  className: t = "",
  collapsedSize: n = 0,
  collapsible: r = !1,
  defaultSize: o = null,
  forwardedRef: i,
  id: a = null,
  maxSize: u = 100,
  minSize: c = 10,
  onCollapse: d = null,
  onResize: f = null,
  order: p = null,
  style: g = {},
  tagName: m = "div"
}) {
  const b = Nb(O2);
  if (b === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const v = h4(a), {
    collapsePanel: y,
    expandPanel: w,
    getPanelStyle: I,
    registerPanel: V,
    resizePanel: M,
    unregisterPanel: L
  } = b, R = dr({
    onCollapse: d,
    onResize: f
  });
  if (jo(() => {
    R.current.onCollapse = d, R.current.onResize = f;
  }), c < 0 || c > 100)
    throw Error(`Panel minSize must be between 0 and 100, but was ${c}`);
  if (u < 0 || u > 100)
    throw Error(`Panel maxSize must be between 0 and 100, but was ${u}`);
  if (o !== null) {
    if (o < 0 || o > 100)
      throw Error(`Panel defaultSize must be between 0 and 100, but was ${o}`);
    c > o && !r && (console.error(`Panel minSize ${c} cannot be greater than defaultSize ${o}`), o = c);
  }
  const _ = I(v, o), H = dr({
    size: Ah(_)
  }), B = dr({
    callbacksRef: R,
    collapsedSize: n,
    collapsible: r,
    defaultSize: o,
    id: v,
    idWasAutoGenerated: a == null,
    maxSize: u,
    minSize: c,
    order: p
  });
  return r2(() => {
    H.current.size = Ah(_), B.current.callbacksRef = R, B.current.collapsedSize = n, B.current.collapsible = r, B.current.defaultSize = o, B.current.id = v, B.current.idWasAutoGenerated = a == null, B.current.maxSize = u, B.current.minSize = c, B.current.order = p;
  }), r2(() => (V(v, B), () => {
    L(v);
  }), [p, v, V, L]), Zb(i, () => ({
    collapse: () => y(v),
    expand: () => w(v),
    getCollapsed() {
      return H.current.size === 0;
    },
    getSize() {
      return H.current.size;
    },
    resize: (Z) => M(v, Z)
  }), [y, w, v, M]), Ba(m, {
    children: e,
    className: t,
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-id": v,
    "data-panel-size": parseFloat("" + _.flexGrow).toFixed(1),
    id: `data-panel-id-${v}`,
    style: {
      ..._,
      ...g
    }
  });
}
const bf = Ob((e, t) => Ba($b, {
  ...e,
  forwardedRef: t
}));
$b.displayName = "Panel";
bf.displayName = "forwardRef(Panel)";
function Ah(e) {
  const {
    flexGrow: t
  } = e;
  return typeof t == "string" ? parseFloat(t) : t;
}
const bs = 10;
function D1(e, t, n, r, o, i, a, u) {
  const {
    sizes: c
  } = u || {}, d = c || i;
  if (o === 0)
    return d;
  const f = Er(t), p = d.concat();
  let g = 0;
  {
    const v = o < 0 ? r : n, y = f.findIndex((M) => M.current.id === v), w = f[y], I = d[y], V = Lh(w, Math.abs(o), I, e);
    if (I === V)
      return d;
    V === 0 && I > 0 && a.set(v, I), o = o < 0 ? I - V : V - I;
  }
  let m = o < 0 ? n : r, b = f.findIndex((v) => v.current.id === m);
  for (; ; ) {
    const v = f[b], y = d[b], w = Math.abs(o) - Math.abs(g), I = Lh(v, 0 - w, y, e);
    if (y !== I && (I === 0 && y > 0 && a.set(v.current.id, y), g += y - I, p[b] = I, g.toPrecision(bs).localeCompare(Math.abs(o).toPrecision(bs), void 0, {
      numeric: !0
    }) >= 0))
      break;
    if (o < 0) {
      if (--b < 0)
        break;
    } else if (++b >= f.length)
      break;
  }
  return g === 0 ? d : (m = o < 0 ? r : n, b = f.findIndex((v) => v.current.id === m), p[b] = d[b] + g, p);
}
function ia(e, t, n) {
  t.forEach((r, o) => {
    const i = e[o];
    if (!i)
      return;
    const {
      callbacksRef: a,
      collapsedSize: u,
      collapsible: c,
      id: d
    } = i.current, f = n[d];
    if (f !== r) {
      n[d] = r;
      const {
        onCollapse: p,
        onResize: g
      } = a.current;
      g && g(r, f), c && p && ((f == null || f === u) && r !== u ? p(!1) : f !== u && r === u && p(!0));
    }
  });
}
function c5(e, t) {
  if (t.length < 2)
    return [null, null];
  const n = t.findIndex((a) => a.current.id === e);
  if (n < 0)
    return [null, null];
  const r = n === t.length - 1, o = r ? t[n - 1].current.id : e, i = r ? e : t[n + 1].current.id;
  return [o, i];
}
function zb(e, t, n) {
  if (e.size === 1)
    return "100";
  const o = Er(e).findIndex((a) => a.current.id === t), i = n[o];
  return i == null ? "0" : i.toPrecision(bs);
}
function qJ(e) {
  const t = document.querySelector(`[data-panel-id="${e}"]`);
  return t || null;
}
function p4(e) {
  const t = document.querySelector(`[data-panel-group-id="${e}"]`);
  return t || null;
}
function N2(e) {
  const t = document.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return t || null;
}
function KJ(e) {
  return Wb().findIndex((r) => r.getAttribute("data-panel-resize-handle-id") === e) ?? null;
}
function Wb() {
  return Array.from(document.querySelectorAll("[data-panel-resize-handle-id]"));
}
function Gb(e) {
  return Array.from(document.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function g4(e, t, n) {
  var c, d, f, p;
  const r = N2(t), o = Gb(e), i = r ? o.indexOf(r) : -1, a = ((d = (c = n[i]) == null ? void 0 : c.current) == null ? void 0 : d.id) ?? null, u = ((p = (f = n[i + 1]) == null ? void 0 : f.current) == null ? void 0 : p.id) ?? null;
  return [a, u];
}
function Er(e) {
  return Array.from(e.values()).sort((t, n) => {
    const r = t.current.order, o = n.current.order;
    return r == null && o == null ? 0 : r == null ? -1 : o == null ? 1 : r - o;
  });
}
function Lh(e, t, n, r) {
  var f;
  const o = n + t, {
    collapsedSize: i,
    collapsible: a,
    maxSize: u,
    minSize: c
  } = e.current;
  if (a) {
    if (n > i) {
      if (o <= c / 2 + i)
        return i;
    } else if (!((f = r == null ? void 0 : r.type) == null ? void 0 : f.startsWith("key")) && o < c)
      return i;
  }
  return Math.min(u, Math.max(c, o));
}
function jb(e, t = "Assertion failed!") {
  if (!e)
    throw console.error(t), Error(t);
}
function QJ({
  committedValuesRef: e,
  groupId: t,
  panels: n,
  setSizes: r,
  sizes: o,
  panelSizeBeforeCollapse: i
}) {
  jo(() => {
    const {
      direction: a,
      panels: u
    } = e.current, c = p4(t), {
      height: d,
      width: f
    } = c.getBoundingClientRect(), g = Gb(t).map((m) => {
      const b = m.getAttribute("data-panel-resize-handle-id"), v = Er(u), [y, w] = g4(t, b, v);
      if (y == null || w == null)
        return () => {
        };
      let I = 0, V = 100, M = 0, L = 0;
      v.forEach((G) => {
        G.current.id === y ? (V = G.current.maxSize, I = G.current.minSize) : (M += G.current.minSize, L += G.current.maxSize);
      });
      const R = Math.min(V, 100 - M), _ = Math.max(I, (v.length - 1) * 100 - L), H = zb(u, y, o);
      m.setAttribute("aria-valuemax", "" + Math.round(R)), m.setAttribute("aria-valuemin", "" + Math.round(_)), m.setAttribute("aria-valuenow", "" + Math.round(parseInt(H)));
      const B = (G) => {
        if (!G.defaultPrevented)
          switch (G.key) {
            case "Enter": {
              G.preventDefault();
              const se = v.findIndex((ue) => ue.current.id === y);
              if (se >= 0) {
                const ue = v[se], ce = o[se];
                if (ce != null) {
                  let xe = 0;
                  ce.toPrecision(bs) <= ue.current.minSize.toPrecision(bs) ? xe = a === "horizontal" ? f : d : xe = -(a === "horizontal" ? f : d);
                  const he = D1(G, u, y, w, xe, o, i.current, null);
                  o !== he && r(he);
                }
              }
              break;
            }
          }
      };
      m.addEventListener("keydown", B);
      const Z = qJ(y);
      return Z != null && m.setAttribute("aria-controls", Z.id), () => {
        m.removeAttribute("aria-valuemax"), m.removeAttribute("aria-valuemin"), m.removeAttribute("aria-valuenow"), m.removeEventListener("keydown", B), Z != null && m.removeAttribute("aria-controls");
      };
    });
    return () => {
      g.forEach((m) => m());
    };
  }, [e, t, n, i, r, o]);
}
function eq({
  disabled: e,
  handleId: t,
  resizeHandler: n
}) {
  jo(() => {
    if (e || n == null)
      return;
    const r = N2(t);
    if (r == null)
      return;
    const o = (i) => {
      if (!i.defaultPrevented)
        switch (i.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            i.preventDefault(), n(i);
            break;
          }
          case "F6": {
            i.preventDefault();
            const a = Wb(), u = KJ(t);
            jb(u !== null);
            const c = i.shiftKey ? u > 0 ? u - 1 : a.length - 1 : u + 1 < a.length ? u + 1 : 0;
            a[c].focus();
            break;
          }
        }
    };
    return r.addEventListener("keydown", o), () => {
      r.removeEventListener("keydown", o);
    };
  }, [e, t, n]);
}
function tq(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Xb(e, t, n, r = 0, o = null) {
  const i = n === "horizontal";
  let a = 0;
  if (yf(e))
    a = i ? e.clientX : e.clientY;
  else if (xf(e)) {
    const f = e.touches[0];
    a = i ? f.screenX : f.screenY;
  } else
    return 0;
  const u = N2(t), c = o || u.getBoundingClientRect(), d = i ? c.left : c.top;
  return a - d - r;
}
function nq(e, t, n, r, o, i, a) {
  const {
    dragOffset: u = 0,
    dragHandleRect: c,
    sizes: d
  } = a || {}, f = d || i;
  if (rq(e)) {
    const p = o === "horizontal", m = p4(t).getBoundingClientRect(), b = p ? m.width : m.height, v = e.shiftKey ? 10 : 100, y = b / v;
    let w = 0;
    switch (e.key) {
      case "ArrowDown":
        w = p ? 0 : y;
        break;
      case "ArrowLeft":
        w = p ? -y : 0;
        break;
      case "ArrowRight":
        w = p ? y : 0;
        break;
      case "ArrowUp":
        w = p ? 0 : -y;
        break;
      case "End":
        w = b;
        break;
      case "Home":
        w = -b;
        break;
    }
    const [I, V] = g4(t, n, r), M = w < 0 ? I : V, L = r.findIndex((_) => _.current.id === M), R = r[L];
    if (R.current.collapsible) {
      const _ = f[L];
      (_ === 0 || _.toPrecision(bs) === R.current.minSize.toPrecision(bs)) && (w = w < 0 ? -R.current.minSize * b : R.current.minSize * b);
    }
    return w;
  } else
    return Xb(e, n, o, u, c);
}
function rq(e) {
  return e.type === "keydown";
}
function yf(e) {
  return e.type.startsWith("mouse");
}
function xf(e) {
  return e.type.startsWith("touch");
}
let Sf = null, is = null;
function Ub(e) {
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "horizontal-max":
      return "w-resize";
    case "horizontal-min":
      return "e-resize";
    case "vertical":
      return "ns-resize";
    case "vertical-max":
      return "n-resize";
    case "vertical-min":
      return "s-resize";
  }
}
function oq() {
  is !== null && (document.head.removeChild(is), Sf = null, is = null);
}
function d5(e) {
  if (Sf === e)
    return;
  Sf = e;
  const t = Ub(e);
  is === null && (is = document.createElement("style"), document.head.appendChild(is)), is.innerHTML = `*{cursor: ${t}!important;}`;
}
function iq(e, t = 10) {
  let n = null;
  return (...o) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...o);
    }, t);
  };
}
function Yb(e) {
  return e.map((t) => {
    const {
      minSize: n,
      order: r
    } = t.current;
    return r ? `${r}:${n}` : `${n}`;
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function Jb(e, t) {
  try {
    const n = t.getItem(`PanelGroup:sizes:${e}`);
    if (n) {
      const r = JSON.parse(n);
      if (typeof r == "object" && r != null)
        return r;
    }
  } catch {
  }
  return null;
}
function sq(e, t, n) {
  const r = Jb(e, n);
  if (r) {
    const o = Yb(t);
    return r[o] ?? null;
  }
  return null;
}
function aq(e, t, n, r) {
  const o = Yb(t), i = Jb(e, r) || {};
  i[o] = n;
  try {
    r.setItem(`PanelGroup:sizes:${e}`, JSON.stringify(i));
  } catch (a) {
    console.error(a);
  }
}
const f5 = {};
function Mh(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
const O1 = {
  getItem: (e) => (Mh(O1), O1.getItem(e)),
  setItem: (e, t) => {
    Mh(O1), O1.setItem(e, t);
  }
};
function qb({
  autoSaveId: e,
  children: t = null,
  className: n = "",
  direction: r,
  disablePointerEventsDuringResize: o = !1,
  forwardedRef: i,
  id: a = null,
  onLayout: u,
  storage: c = O1,
  style: d = {},
  tagName: f = "div"
}) {
  const p = h4(a), [g, m] = rl(null), [b, v] = rl(/* @__PURE__ */ new Map()), y = dr(null);
  dr({
    didLogDefaultSizeWarning: !1,
    didLogIdAndOrderWarning: !1,
    prevPanelIds: []
  });
  const w = dr({
    onLayout: u
  });
  jo(() => {
    w.current.onLayout = u;
  });
  const I = dr({}), [V, M] = rl([]), L = dr(/* @__PURE__ */ new Map()), R = dr(0), _ = dr({
    direction: r,
    panels: b,
    sizes: V
  });
  Zb(i, () => ({
    getLayout: () => {
      const {
        sizes: z
      } = _.current;
      return z;
    },
    setLayout: (z) => {
      const Y = z.reduce((ie, W) => ie + W, 0);
      jb(Y === 100, "Panel sizes must add up to 100%");
      const {
        panels: ae
      } = _.current, j = I.current, X = Er(ae);
      M(z), ia(X, z, j);
    }
  }), []), r2(() => {
    _.current.direction = r, _.current.panels = b, _.current.sizes = V;
  }), QJ({
    committedValuesRef: _,
    groupId: p,
    panels: b,
    setSizes: M,
    sizes: V,
    panelSizeBeforeCollapse: L
  }), jo(() => {
    const {
      onLayout: z
    } = w.current, {
      panels: Y,
      sizes: ae
    } = _.current;
    if (ae.length > 0) {
      z && z(ae);
      const j = I.current, X = Er(Y);
      ia(X, ae, j);
    }
  }, [V]), r2(() => {
    if (_.current.sizes.length === b.size)
      return;
    let Y = null;
    if (e) {
      const ae = Er(b);
      Y = sq(e, ae, c);
    }
    if (Y != null)
      M(Y);
    else {
      const ae = Er(b);
      let j = 0, X = 0, ie = 0;
      if (ae.forEach((W) => {
        ie += W.current.minSize, W.current.defaultSize === null ? j++ : X += W.current.defaultSize;
      }), X > 100)
        throw new Error("Default panel sizes cannot exceed 100%");
      if (ae.length > 1 && j === 0 && X !== 100)
        throw new Error("Invalid default sizes specified for panels");
      if (ie > 100)
        throw new Error("Minimum panel sizes cannot exceed 100%");
      M(ae.map((W) => W.current.defaultSize === null ? (100 - X) / j : W.current.defaultSize));
    }
  }, [e, b, c]), jo(() => {
    if (e) {
      if (V.length === 0 || V.length !== b.size)
        return;
      const z = Er(b);
      f5[e] || (f5[e] = iq(aq, 100)), f5[e](e, z, V, c);
    }
  }, [e, b, V, c]);
  const H = Ci((z, Y) => {
    const {
      panels: ae
    } = _.current;
    return ae.size === 0 ? {
      flexBasis: 0,
      flexGrow: Y ?? void 0,
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden"
    } : {
      flexBasis: 0,
      flexGrow: zb(ae, z, V),
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden",
      // Disable pointer events inside of a panel during resize.
      // This avoid edge cases like nested iframes.
      pointerEvents: o && g !== null ? "none" : void 0
    };
  }, [g, o, V]), B = Ci((z, Y) => {
    v((ae) => {
      if (ae.has(z))
        return ae;
      const j = new Map(ae);
      return j.set(z, Y), j;
    });
  }, []), Z = Ci((z) => (ae) => {
    ae.preventDefault();
    const {
      direction: j,
      panels: X,
      sizes: ie
    } = _.current, W = Er(X), [re, te] = g4(p, z, W);
    if (re == null || te == null)
      return;
    let ee = nq(ae, p, z, W, j, ie, y.current);
    if (ee === 0)
      return;
    const pe = p4(p).getBoundingClientRect(), Se = j === "horizontal";
    document.dir === "rtl" && Se && (ee = -ee);
    const de = Se ? pe.width : pe.height, Ve = ee / de * 100, K = D1(ae, X, re, te, Ve, ie, L.current, y.current), Ye = !tq(ie, K);
    if ((yf(ae) || xf(ae)) && R.current != Ve && d5(Ye ? Se ? "horizontal" : "vertical" : Se ? ee < 0 ? "horizontal-min" : "horizontal-max" : ee < 0 ? "vertical-min" : "vertical-max"), Ye) {
      const ve = I.current;
      M(K), ia(W, K, ve);
    }
    R.current = Ve;
  }, [p]), G = Ci((z) => {
    v((Y) => {
      if (!Y.has(z))
        return Y;
      const ae = new Map(Y);
      return ae.delete(z), ae;
    });
  }, []), se = Ci((z) => {
    const {
      panels: Y,
      sizes: ae
    } = _.current, j = Y.get(z);
    if (j == null)
      return;
    const {
      collapsedSize: X,
      collapsible: ie
    } = j.current;
    if (!ie)
      return;
    const W = Er(Y), re = W.indexOf(j);
    if (re < 0)
      return;
    const te = ae[re];
    if (te === X)
      return;
    L.current.set(z, te);
    const [ee, ge] = c5(z, W);
    if (ee == null || ge == null)
      return;
    const Se = re === W.length - 1 ? te : X - te, de = D1(null, Y, ee, ge, Se, ae, L.current, null);
    if (ae !== de) {
      const Ve = I.current;
      M(de), ia(W, de, Ve);
    }
  }, []), ue = Ci((z) => {
    const {
      panels: Y,
      sizes: ae
    } = _.current, j = Y.get(z);
    if (j == null)
      return;
    const {
      collapsedSize: X,
      minSize: ie
    } = j.current, W = L.current.get(z) || ie;
    if (!W)
      return;
    const re = Er(Y), te = re.indexOf(j);
    if (te < 0 || ae[te] !== X)
      return;
    const [ge, pe] = c5(z, re);
    if (ge == null || pe == null)
      return;
    const de = te === re.length - 1 ? X - W : W, Ve = D1(null, Y, ge, pe, de, ae, L.current, null);
    if (ae !== Ve) {
      const K = I.current;
      M(Ve), ia(re, Ve, K);
    }
  }, []), ce = Ci((z, Y) => {
    const {
      panels: ae,
      sizes: j
    } = _.current, X = ae.get(z);
    if (X == null)
      return;
    const {
      collapsedSize: ie,
      collapsible: W,
      maxSize: re,
      minSize: te
    } = X.current, ee = Er(ae), ge = ee.indexOf(X);
    if (ge < 0)
      return;
    const pe = j[ge];
    if (pe === Y)
      return;
    W && Y === ie || (Y = Math.min(re, Math.max(te, Y)));
    const [Se, de] = c5(z, ee);
    if (Se == null || de == null)
      return;
    const K = ge === ee.length - 1 ? pe - Y : Y - pe, Ye = D1(null, ae, Se, de, K, j, L.current, null);
    if (j !== Ye) {
      const ve = I.current;
      M(Ye), ia(ee, Ye, ve);
    }
  }, []), xe = UJ(() => ({
    activeHandleId: g,
    collapsePanel: se,
    direction: r,
    expandPanel: ue,
    getPanelStyle: H,
    groupId: p,
    registerPanel: B,
    registerResizeHandle: Z,
    resizePanel: ce,
    startDragging: (z, Y) => {
      if (m(z), yf(Y) || xf(Y)) {
        const ae = N2(z);
        y.current = {
          dragHandleRect: ae.getBoundingClientRect(),
          dragOffset: Xb(Y, z, r),
          sizes: _.current.sizes
        };
      }
    },
    stopDragging: () => {
      oq(), m(null), y.current = null;
    },
    unregisterPanel: G
  }), [g, se, r, ue, H, p, B, Z, ce, G]), he = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return Ba(O2.Provider, {
    children: Ba(f, {
      children: t,
      className: n,
      "data-panel-group": "",
      "data-panel-group-direction": r,
      "data-panel-group-id": p,
      style: {
        ...he,
        ...d
      }
    }),
    value: xe
  });
}
const Kb = Ob((e, t) => Ba(qb, {
  ...e,
  forwardedRef: t
}));
qb.displayName = "PanelGroup";
Kb.displayName = "forwardRef(PanelGroup)";
function Qb({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  id: r = null,
  onDragging: o,
  style: i = {},
  tagName: a = "div"
}) {
  const u = dr(null), c = dr({
    onDragging: o
  });
  jo(() => {
    c.current.onDragging = o;
  });
  const d = Nb(O2);
  if (d === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    activeHandleId: f,
    direction: p,
    groupId: g,
    registerResizeHandle: m,
    startDragging: b,
    stopDragging: v
  } = d, y = h4(r), w = f === y, [I, V] = rl(!1), [M, L] = rl(null), R = Ci(() => {
    u.current.blur(), v();
    const {
      onDragging: B
    } = c.current;
    B && B(!1);
  }, [v]);
  jo(() => {
    if (n)
      L(null);
    else {
      const H = m(y);
      L(() => H);
    }
  }, [n, y, m]), jo(() => {
    if (n || M == null || !w)
      return;
    const H = (se) => {
      M(se);
    }, B = (se) => {
      M(se);
    }, G = u.current.ownerDocument;
    return G.body.addEventListener("contextmenu", R), G.body.addEventListener("mousemove", H), G.body.addEventListener("touchmove", H), G.body.addEventListener("mouseleave", B), window.addEventListener("mouseup", R), window.addEventListener("touchend", R), () => {
      G.body.removeEventListener("contextmenu", R), G.body.removeEventListener("mousemove", H), G.body.removeEventListener("touchmove", H), G.body.removeEventListener("mouseleave", B), window.removeEventListener("mouseup", R), window.removeEventListener("touchend", R);
    };
  }, [p, n, w, M, R]), eq({
    disabled: n,
    handleId: y,
    resizeHandler: M
  });
  const _ = {
    cursor: Ub(p),
    touchAction: "none",
    userSelect: "none"
  };
  return Ba(a, {
    children: e,
    className: t,
    "data-resize-handle-active": w ? "pointer" : I ? "keyboard" : void 0,
    "data-panel-group-direction": p,
    "data-panel-group-id": g,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": y,
    onBlur: () => V(!1),
    onFocus: () => V(!0),
    onMouseDown: (H) => {
      b(y, H.nativeEvent);
      const {
        onDragging: B
      } = c.current;
      B && B(!0);
    },
    onMouseUp: R,
    onTouchCancel: R,
    onTouchEnd: R,
    onTouchStart: (H) => {
      b(y, H.nativeEvent);
      const {
        onDragging: B
      } = c.current;
      B && B(!0);
    },
    ref: u,
    role: "separator",
    style: {
      ..._,
      ...i
    },
    tabIndex: 0
  });
}
Qb.displayName = "PanelResizeHandle";
const lte = ({ direction: e, config: t = {}, panelA: n, panelB: r }) => {
  var o;
  return /* @__PURE__ */ x.jsxs(Kb, { direction: e, ...t.panelGroupProps, ref: t.panelGroupRef, children: [
    /* @__PURE__ */ x.jsx(bf, { ...t.panelAProps, ref: t.panelARef, children: n }),
    t.isResizable && /* @__PURE__ */ x.jsx(
      Qb,
      {
        style: {
          ...e === "vertical" ? { maxHeight: "10px" } : { maxWidth: "10px" }
        },
        children: /* @__PURE__ */ x.jsx(
          Jo,
          {
            height: e === "vertical" ? "10px" : "full",
            width: e === "vertical" ? "full" : "10px",
            backgroundColor: "hoverTransparentLight",
            _hover: { backgroundColor: "hoverTransparentLight" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            role: "group",
            children: /* @__PURE__ */ x.jsx(
              Jo,
              {
                ...e === "vertical" ? {
                  width: "20",
                  height: 1
                } : { height: "20", width: 1 },
                borderRadius: "lg",
                backgroundColor: "strokeDefault",
                _groupHover: { backgroundColor: "hoverTransparentLight" }
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ x.jsx(
      bf,
      {
        ...t.panelBProps,
        ref: t.panelBRef,
        ...(o = t.panelBProps) != null && o.isCollapsed ? { defaultSize: 0 } : {},
        children: r
      }
    )
  ] });
}, ute = ({
  wrapperProps: e = {},
  children: t,
  footer: n,
  header: r,
  bodyProps: o,
  footerProps: i,
  headerProps: a
}) => /* @__PURE__ */ x.jsxs(hZ, { ...e, children: [
  qe(r) && /* @__PURE__ */ x.jsx(mZ, { ...a, children: r }),
  /* @__PURE__ */ x.jsx(pZ, { ...o, children: t }),
  qe(n) && /* @__PURE__ */ x.jsx(gZ, { ...i, children: n })
] }), cte = (e) => /* @__PURE__ */ x.jsx(xv, { ...e }), dte = (e) => /* @__PURE__ */ x.jsx(Sv, { ...e }), fte = (e) => /* @__PURE__ */ x.jsx(Vv, { ...e }), hte = (e) => /* @__PURE__ */ x.jsx(Av, { ...e }), lq = ({
  tab: e,
  onClick: t,
  isSelected: n,
  variant: r
}) => {
  let o = "textTertiary";
  n && (o = r === "primary" ? "textOffset" : "textPrimary");
  const i = (a) => {
    (a.key === "Enter" || a.key === " ") && (a.preventDefault(), t());
  };
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      "data-tab-value": e.value,
      onClick: t,
      onKeyDown: i,
      role: "tab",
      tabIndex: 0,
      "aria-selected": n,
      className: Qn("tab", n && "selected"),
      children: bL(e.label) ? /* @__PURE__ */ x.jsx(Or, { variant: "h3", color: o, __dangerDoNotUseSx: { whiteSpace: "nowrap" }, children: e.label }) : e.label
    }
  );
};
const pte = ({
  tabs: e,
  activeTab: t,
  setActiveTab: n,
  variant: r = "primary"
}) => /* @__PURE__ */ x.jsx("div", { className: `tabs wrapper ${r}`, "data-active-tab": t, children: e.map((o) => /* @__PURE__ */ x.jsx(
  lq,
  {
    variant: r,
    isSelected: o.value === t,
    tab: o,
    onClick: () => n(o.value)
  },
  `${o.label}-${o.value}`
)) }), gte = (e) => `${e}px`;
function mte({ items: e, value: t, onChange: n, ...r }) {
  const { getRootProps: o, getRadioProps: i } = Yv({
    defaultValue: void 0,
    value: t,
    onChange: n
  });
  return Za(
    { ...r, fullWidth: !1 },
    /* @__PURE__ */ x.jsx(Jo, { display: "flex", gap: "8px", ...o(), children: e.map(({ label: a, value: u }) => {
      const c = i({ value: u });
      return /* @__PURE__ */ x.jsx(uq, { ...c, children: a }, u);
    }) })
  );
}
const uq = (e) => {
  const { getInputProps: t, getRadioProps: n } = Kv(e), { isChecked: r, children: o } = e, i = t(), a = n();
  return /* @__PURE__ */ x.jsxs(Jo, { as: "label", flexShrink: "0", children: [
    /* @__PURE__ */ x.jsx("input", { ...i }),
    /* @__PURE__ */ x.jsx(
      Jo,
      {
        ...a,
        cursor: "pointer",
        borderWidth: "1px",
        borderRadius: "20px",
        border: "1px solid",
        borderColor: "strokeDefault",
        paddingX: "16px",
        paddingY: "6px",
        width: "fit-content",
        backgroundColor: "surface1",
        children: /* @__PURE__ */ x.jsx(
          Or,
          {
            variant: "chip",
            color: r ? "buttonDefault" : void 0,
            children: o
          }
        )
      }
    )
  ] });
}, cq = (e) => e.type === "number" || e.type === "date" || e.type === "month" || e.type === "count", dq = (e) => e.type === "number" || e.type === "count", Hl = (e, t, n) => n ? ["simple-field-filler"] : e === "grid" ? ["simple-field-sizer", "simple-field-size-grid"] : ["simple-field-sizer", `simple-field-size-${t}`], Fl = (e, t = "100%") => e ? {} : { width: t };
const Ph = ({
  addon: e,
  variant: t = "outline"
}) => {
  const n = Qn("simple-addon", t), r = { flex: "0 0 auto" };
  return /* @__PURE__ */ x.jsx("div", { style: r, className: n, children: e });
};
function fq(e) {
  const t = e;
  return t.leftAddon !== void 0 || t.rightAddon !== void 0;
}
const hq = (e) => {
  const {
    width: t = "100%",
    leftAddon: n,
    rightAddon: r,
    children: o,
    variant: i = "outline",
    size: a = "md",
    isWrapped: u
  } = e, c = Fl(u, t), d = Hl(i, a, u);
  return /* @__PURE__ */ x.jsxs("div", { style: c, className: Qn("simple-addon-wrapper", ...d), children: [
    n && /* @__PURE__ */ x.jsx(Ph, { addon: n, ...e }),
    o,
    r && /* @__PURE__ */ x.jsx(Ph, { addon: r, ...e })
  ] });
};
function pq(e) {
  const t = e;
  return (t.errorMessage !== void 0 || t.label !== void 0) && t.variant !== "grid";
}
const gq = ({
  label: e,
  labelTypographyVariant: t = "label",
  id: n,
  children: r,
  errorMessage: o,
  required: i
}) => /* @__PURE__ */ x.jsxs("div", { className: "simple-field-wrapper", children: [
  /* @__PURE__ */ x.jsxs("div", { className: "simple-field-input-with-label", children: [
    e && /* @__PURE__ */ x.jsxs("label", { htmlFor: n, className: "simple-field-label", children: [
      /* @__PURE__ */ x.jsx(Or, { variant: t, children: e }),
      i && /* @__PURE__ */ x.jsx("span", { className: "simple-field-required", children: "*" })
    ] }),
    r
  ] }),
  o && /* @__PURE__ */ x.jsx("div", { className: "simple-field-error-message", children: /* @__PURE__ */ x.jsx(Or, { variant: "body2", color: "alertError", children: o }) })
] }), Eh = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), ey = ",", mq = ".", Cq = 10, vq = 0, bq = ({
  prefix: e = "",
  postfix: t = "",
  useSeparator: n = !1,
  type: r = "number",
  precision: o,
  min: i,
  max: a
}) => {
  const { plugins: u, ...c } = _Y({
    postfix: t,
    prefix: e,
    thousandSeparator: n ? ey : "",
    decimalSeparator: mq,
    precision: qe(o) ? o : r === "number" ? Cq : vq,
    min: qe(i) ? +i : void 0,
    max: qe(a) ? +a : void 0
  });
  return {
    ...c,
    plugins: [
      ...u,
      // Forbids caret to be placed in pre or postfix
      Ib((d) => [e.length - 1, d.length - t.length]),
      oY()
    ]
  };
}, yq = ({ postfix: e, prefix: t, useSeparator: n }) => {
  const r = [];
  return I7(t) && r.push((o) => o.replace(new RegExp(`^${Eh(t)}`), "")), I7(e) && r.push((o) => o.replace(new RegExp(`${Eh(e)}$`), "")), n && r.push(
    (o) => o.replace(new RegExp(`(?!^)${ey}(?!$)`, "g"), "")
  ), r;
}, xq = ({
  children: e,
  postfix: t,
  prefix: n,
  useSeparator: r,
  type: o,
  precision: i,
  width: a,
  variant: u = "outline",
  size: c = "md",
  min: d,
  max: f,
  isWrapped: p,
  placeholder: g,
  onChange: m,
  value: b
}) => {
  const v = at(
    () => bq({
      postfix: t,
      prefix: n,
      useSeparator: r,
      type: o,
      precision: i,
      min: d,
      max: f
    }),
    [t, n, r, o, i, d, f]
  ), y = Lb({ options: v }), w = _l(qe(b) ? b : "", v), I = q(
    (R) => {
      const _ = (H) => yq({ postfix: t, prefix: n, useSeparator: r }).reduce((B, Z) => Z(B), H);
      if (m) {
        const H = _(R.currentTarget.value);
        m({
          // Emit unmasked val
          ...R,
          target: { ...R.target, value: H },
          currentTarget: { ...R.currentTarget, value: H }
        });
      }
    },
    [m, t, n, r]
  ), V = g || `${n || ""} ${t || ""}`, M = Fl(p, a), L = Hl(u, c, p);
  return /* @__PURE__ */ x.jsx("div", { ref: y, style: M, className: Qn("simple-field-mask", ...L), children: bo(
    e,
    {
      onInput: I,
      // this is the html input element inside of simple input, so onInput is a valid prop
      placeholder: V,
      value: w
    },
    null
  ) });
}, Sq = [
  {
    isSizerWrapper: !1,
    predicate: (e) => pq(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ x.jsx(gq, { ...t, isWrapped: e, children: n })
  },
  {
    isSizerWrapper: !0,
    predicate: (e) => fq(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ x.jsx(hq, { ...t, isWrapped: e, children: n })
  },
  {
    isSizerWrapper: !0,
    predicate: (e) => dq(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ x.jsx(xq, { ...t, isWrapped: e, children: n })
  }
], kl = (e) => {
  const t = [];
  let n = !1;
  for (const { predicate: o, decorator: i, isSizerWrapper: a } of Sq)
    o(e) && (t.push(i(n, e)), a && (n = !0));
  return { decorate: (o) => t.reduceRight((i, a) => a(i), o), isWrapped: n };
}, Bl = (e) => Le(e ?? yL()).current;
const wq = {
  text: "text",
  number: "text",
  count: "text",
  date: "date",
  month: "month"
}, Iq = (e) => wq[e || "text"], Vq = Fe((e, t) => {
  const {
    id: n,
    name: r,
    type: o,
    value: i,
    onChange: a,
    onBlur: u,
    invalid: c,
    width: d = "100%",
    variant: f = "outline",
    size: p = "md",
    placeholder: g,
    disabled: m,
    errorMessage: b,
    textAlign: v
  } = e, y = Bl(n), { decorate: w, isWrapped: I } = kl({ ...e, id: y }), { min: V, max: M } = cq(e) ? e : { min: void 0, max: void 0 }, L = { ...Fl(I, d), ...v ? { textAlign: v } : {} }, R = [
    "simple-field",
    "simple-input",
    f,
    c || qe(b) ? "invalid" : "",
    ...Hl(f, p, I)
  ];
  return w(
    /* @__PURE__ */ x.jsx(
      "input",
      {
        className: Qn(...R),
        ref: t,
        id: y,
        name: r,
        type: Iq(o),
        value: i,
        onChange: a,
        onBlur: u,
        style: L,
        min: V,
        max: M,
        placeholder: g,
        autoComplete: "off",
        disabled: m
      }
    )
  );
}), Aq = `
  .simple-dollar-input {
    position: relative;
    width: 100%;
  }

  .simple-dollar-input__glyph {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
    color: inherit;
  }

  .simple-dollar-input:has(.simple-input.grid) .simple-dollar-input__glyph {
    left: 4px;
  }

  .simple-dollar-input:has(.simple-input:disabled) .simple-dollar-input__glyph {
    opacity: 0.5;
  }

  .simple-dollar-input .simple-input.outline {
    padding-left: 24px;
  }

  .simple-dollar-input .simple-input.grid {
    padding-left: 20px;
  }
`, Lq = Fe(
  ({ precision: e = 0, useSeparator: t = !0, width: n = "100%", ...r }, o) => /* @__PURE__ */ x.jsxs("div", { className: "simple-dollar-input", style: { width: n }, children: [
    /* @__PURE__ */ x.jsx("style", { children: Aq }),
    /* @__PURE__ */ x.jsx("span", { className: "simple-dollar-input__glyph", "aria-hidden": "true", children: "$" }),
    /* @__PURE__ */ x.jsx(
      Vq,
      {
        ref: o,
        type: "number",
        precision: e,
        useSeparator: t,
        ...r,
        width: "100%"
      }
    )
  ] })
);
Lq.displayName = "SimpleDollarInput";
const Cte = Fe(
  (e, t) => {
    const {
      children: n,
      id: r,
      name: o,
      value: i,
      invalid: a,
      onChange: u,
      onBlur: c,
      variant: d = "outline",
      size: f = "md",
      width: p = "100%",
      disabled: g
    } = e, m = Bl(r), { decorate: b, isWrapped: v } = kl({ ...e, id: m });
    return b(
      /* @__PURE__ */ x.jsx(
        "select",
        {
          className: Qn(
            "simple-field",
            "simple-select",
            d,
            a && "invalid",
            ...Hl(d, f, v)
          ),
          style: Fl(v, p),
          ref: t,
          id: m,
          name: o,
          value: i,
          onChange: u,
          onBlur: c,
          disabled: g,
          children: n
        }
      )
    );
  }
);
const vte = Fe((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    onChange: i,
    onBlur: a,
    invalid: u,
    width: c = "100%",
    variant: d = "outline",
    size: f = "md",
    resize: p = "both",
    disabled: g
  } = e, m = Bl(n), { decorate: b, isWrapped: v } = kl({ ...e, id: m });
  return b(
    /* @__PURE__ */ x.jsx(
      "textarea",
      {
        className: Qn(
          "simple-field",
          "simple-textarea",
          d,
          u && "invalid",
          "simple-field-sizer",
          ...Hl(d, f, v)
        ),
        style: { resize: p, ...Fl(v, c) },
        ref: t,
        id: m,
        name: r,
        value: o,
        onChange: i,
        onBlur: a,
        disabled: g
      }
    )
  );
});
function Rh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rh(Object(n), !0).forEach(function(r) {
      Ca(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Mq(e) {
  if (Array.isArray(e))
    return e;
}
function Pq(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, u = [], c = !0, d = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); c = !0)
          ;
    } catch (f) {
      d = !0, o = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return u;
  }
}
function wf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ty(e, t) {
  if (e) {
    if (typeof e == "string")
      return wf(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? wf(e, t) : void 0;
  }
}
function Eq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xo(e, t) {
  return Mq(e) || Pq(e, t) || ty(e, t) || Eq();
}
function ei(e, t) {
  if (e == null)
    return {};
  var n, r, o = bC(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var Rq = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function _q(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, i = e.defaultValue, a = i === void 0 ? null : i, u = e.inputValue, c = e.menuIsOpen, d = e.onChange, f = e.onInputChange, p = e.onMenuClose, g = e.onMenuOpen, m = e.value, b = ei(e, Rq), v = Ee(u !== void 0 ? u : n), y = Xo(v, 2), w = y[0], I = y[1], V = Ee(c !== void 0 ? c : o), M = Xo(V, 2), L = M[0], R = M[1], _ = Ee(m !== void 0 ? m : a), H = Xo(_, 2), B = H[0], Z = H[1], G = q(function(Y, ae) {
    typeof d == "function" && d(Y, ae), Z(Y);
  }, [d]), se = q(function(Y, ae) {
    var j;
    typeof f == "function" && (j = f(Y, ae)), I(j !== void 0 ? j : Y);
  }, [f]), ue = q(function() {
    typeof g == "function" && g(), R(!0);
  }, [g]), ce = q(function() {
    typeof p == "function" && p(), R(!1);
  }, [p]), xe = u !== void 0 ? u : w, he = c !== void 0 ? c : L, z = m !== void 0 ? m : B;
  return Be(Be({}, b), {}, {
    inputValue: xe,
    menuIsOpen: he,
    onChange: G,
    onInputChange: se,
    onMenuClose: ce,
    onMenuOpen: ue,
    value: z
  });
}
function Tq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _h(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, HC(r.key), r);
  }
}
function Hq(e, t, n) {
  return t && _h(e.prototype, t), n && _h(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Fq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Yc(e, t);
}
function o2(e) {
  return o2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, o2(e);
}
function ny() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ny = function() {
    return !!e;
  })();
}
function kq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bq(e, t) {
  if (t && (gs(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return kq(e);
}
function Dq(e) {
  var t = ny();
  return function() {
    var n, r = o2(e);
    if (t) {
      var o = o2(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return Bq(this, n);
  };
}
function Oq(e) {
  if (Array.isArray(e))
    return wf(e);
}
function Nq(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Zq() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m4(e) {
  return Oq(e) || Nq(e) || ty(e) || Zq();
}
function $q(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const zq = Math.min, Wq = Math.max, i2 = Math.round, gc = Math.floor, s2 = (e) => ({
  x: e,
  y: e
});
function Gq(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Z2() {
  return typeof window < "u";
}
function ry(e) {
  return iy(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ro(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function oy(e) {
  var t;
  return (t = (iy(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function iy(e) {
  return Z2() ? e instanceof Node || e instanceof ro(e).Node : !1;
}
function If(e) {
  return Z2() ? e instanceof Element || e instanceof ro(e).Element : !1;
}
function C4(e) {
  return Z2() ? e instanceof HTMLElement || e instanceof ro(e).HTMLElement : !1;
}
function Th(e) {
  return !Z2() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ro(e).ShadowRoot;
}
function sy(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = v4(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function jq() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Xq(e) {
  return ["html", "body", "#document"].includes(ry(e));
}
function v4(e) {
  return ro(e).getComputedStyle(e);
}
function Uq(e) {
  if (ry(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Th(e) && e.host || // Fallback.
    oy(e)
  );
  return Th(t) ? t.host : t;
}
function ay(e) {
  const t = Uq(e);
  return Xq(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : C4(t) && sy(t) ? t : ay(t);
}
function a2(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = ay(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = ro(o);
  if (i) {
    const u = Vf(a);
    return t.concat(a, a.visualViewport || [], sy(o) ? o : [], u && n ? a2(u) : []);
  }
  return t.concat(o, a2(o, [], n));
}
function Vf(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Yq(e) {
  const t = v4(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = C4(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, u = i2(n) !== i || i2(r) !== a;
  return u && (n = i, r = a), {
    width: n,
    height: r,
    $: u
  };
}
function b4(e) {
  return If(e) ? e : e.contextElement;
}
function h5(e) {
  const t = b4(e);
  if (!C4(t))
    return s2(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Yq(t);
  let a = (i ? i2(n.width) : n.width) / r, u = (i ? i2(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: a,
    y: u
  };
}
const Jq = /* @__PURE__ */ s2(0);
function qq(e) {
  const t = ro(e);
  return !jq() || !t.visualViewport ? Jq : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Kq(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ro(e) ? !1 : t;
}
function Hh(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = b4(e);
  let a = s2(1);
  t && (r ? If(r) && (a = h5(r)) : a = h5(e));
  const u = Kq(i, n, r) ? qq(i) : s2(0);
  let c = (o.left + u.x) / a.x, d = (o.top + u.y) / a.y, f = o.width / a.x, p = o.height / a.y;
  if (i) {
    const g = ro(i), m = r && If(r) ? ro(r) : r;
    let b = g, v = Vf(b);
    for (; v && r && m !== b; ) {
      const y = h5(v), w = v.getBoundingClientRect(), I = v4(v), V = w.left + (v.clientLeft + parseFloat(I.paddingLeft)) * y.x, M = w.top + (v.clientTop + parseFloat(I.paddingTop)) * y.y;
      c *= y.x, d *= y.y, f *= y.x, p *= y.y, c += V, d += M, b = ro(v), v = Vf(b);
    }
  }
  return Gq({
    width: f,
    height: p,
    x: c,
    y: d
  });
}
function ly(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Qq(e, t) {
  let n = null, r;
  const o = oy(e);
  function i() {
    var u;
    clearTimeout(r), (u = n) == null || u.disconnect(), n = null;
  }
  function a(u, c) {
    u === void 0 && (u = !1), c === void 0 && (c = 1), i();
    const d = e.getBoundingClientRect(), {
      left: f,
      top: p,
      width: g,
      height: m
    } = d;
    if (u || t(), !g || !m)
      return;
    const b = gc(p), v = gc(o.clientWidth - (f + g)), y = gc(o.clientHeight - (p + m)), w = gc(f), V = {
      rootMargin: -b + "px " + -v + "px " + -y + "px " + -w + "px",
      threshold: Wq(0, zq(1, c)) || 1
    };
    let M = !0;
    function L(R) {
      const _ = R[0].intersectionRatio;
      if (_ !== c) {
        if (!M)
          return a();
        _ ? a(!1, _) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !ly(d, e.getBoundingClientRect()) && a(), M = !1;
    }
    try {
      n = new IntersectionObserver(L, {
        ...V,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(L, V);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function eK(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, d = b4(e), f = o || i ? [...d ? a2(d) : [], ...a2(t)] : [];
  f.forEach((w) => {
    o && w.addEventListener("scroll", n, {
      passive: !0
    }), i && w.addEventListener("resize", n);
  });
  const p = d && u ? Qq(d, n) : null;
  let g = -1, m = null;
  a && (m = new ResizeObserver((w) => {
    let [I] = w;
    I && I.target === d && m && (m.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var V;
      (V = m) == null || V.observe(t);
    })), n();
  }), d && !c && m.observe(d), m.observe(t));
  let b, v = c ? Hh(e) : null;
  c && y();
  function y() {
    const w = Hh(e);
    v && !ly(v, w) && n(), v = w, b = requestAnimationFrame(y);
  }
  return n(), () => {
    var w;
    f.forEach((I) => {
      o && I.removeEventListener("scroll", n), i && I.removeEventListener("resize", n);
    }), p == null || p(), (w = m) == null || w.disconnect(), m = null, c && cancelAnimationFrame(b);
  };
}
var Af = Oa, tK = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], l2 = function() {
};
function nK(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function rK(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var i = [].concat(r);
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && i.push("".concat(nK(e, a)));
  return i.filter(function(u) {
    return u;
  }).map(function(u) {
    return String(u).trim();
  }).join(" ");
}
var Fh = function(t) {
  return fK(t) ? t.filter(Boolean) : gs(t) === "object" && t !== null ? [t] : [];
}, uy = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = ei(t, tK);
  return Be({}, n);
}, qt = function(t, n, r) {
  var o = t.cx, i = t.getStyles, a = t.getClassNames, u = t.className;
  return {
    css: i(n, t),
    className: o(r ?? {}, a(n, t), u)
  };
};
function $2(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function oK(e) {
  return $2(e) ? window.innerHeight : e.clientHeight;
}
function cy(e) {
  return $2(e) ? window.pageYOffset : e.scrollTop;
}
function u2(e, t) {
  if ($2(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function iK(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function sK(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function mc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : l2, o = cy(e), i = t - o, a = 10, u = 0;
  function c() {
    u += a;
    var d = sK(u, o, i, n);
    u2(e, d), u < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function kh(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? u2(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && u2(e, Math.max(t.offsetTop - o, 0));
}
function aK(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function Bh() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function lK() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var dy = !1, uK = {
  get passive() {
    return dy = !0;
  }
}, Cc = typeof window < "u" ? window : {};
Cc.addEventListener && Cc.removeEventListener && (Cc.addEventListener("p", l2, uK), Cc.removeEventListener("p", l2, !1));
var cK = dy;
function dK(e) {
  return e != null;
}
function fK(e) {
  return Array.isArray(e);
}
function vc(e, t, n) {
  return e ? t : n;
}
var hK = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var i = Object.entries(t).filter(function(a) {
    var u = Xo(a, 1), c = u[0];
    return !r.includes(c);
  });
  return i.reduce(function(a, u) {
    var c = Xo(u, 2), d = c[0], f = c[1];
    return a[d] = f, a;
  }, {});
}, pK = ["children", "innerProps"], gK = ["children", "innerProps"];
function mK(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, i = e.shouldScroll, a = e.isFixedPosition, u = e.controlHeight, c = iK(n), d = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return d;
  var f = c.getBoundingClientRect(), p = f.height, g = n.getBoundingClientRect(), m = g.bottom, b = g.height, v = g.top, y = n.offsetParent.getBoundingClientRect(), w = y.top, I = a ? window.innerHeight : oK(c), V = cy(c), M = parseInt(getComputedStyle(n).marginBottom, 10), L = parseInt(getComputedStyle(n).marginTop, 10), R = w - L, _ = I - v, H = R + V, B = p - V - v, Z = m - I + V + M, G = V + v - L, se = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (_ >= b)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (B >= b && !a)
        return i && mc(c, Z, se), {
          placement: "bottom",
          maxHeight: t
        };
      if (!a && B >= r || a && _ >= r) {
        i && mc(c, Z, se);
        var ue = a ? _ - M : B - M;
        return {
          placement: "bottom",
          maxHeight: ue
        };
      }
      if (o === "auto" || a) {
        var ce = t, xe = a ? R : H;
        return xe >= r && (ce = Math.min(xe - M - u, t)), {
          placement: "top",
          maxHeight: ce
        };
      }
      if (o === "bottom")
        return i && u2(c, Z), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (R >= b)
        return {
          placement: "top",
          maxHeight: t
        };
      if (H >= b && !a)
        return i && mc(c, G, se), {
          placement: "top",
          maxHeight: t
        };
      if (!a && H >= r || a && R >= r) {
        var he = t;
        return (!a && H >= r || a && R >= r) && (he = a ? R - L : H - L), i && mc(c, G, se), {
          placement: "top",
          maxHeight: he
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return d;
}
function CK(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var fy = function(t) {
  return t === "auto" ? "bottom" : t;
}, vK = function(t, n) {
  var r, o = t.placement, i = t.theme, a = i.borderRadius, u = i.spacing, c = i.colors;
  return Be((r = {
    label: "menu"
  }, Ca(r, CK(o), "100%"), Ca(r, "position", "absolute"), Ca(r, "width", "100%"), Ca(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: a,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: u.menuGutter,
    marginTop: u.menuGutter
  });
}, hy = /* @__PURE__ */ Nr(null), bK = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, i = t.menuPlacement, a = t.menuPosition, u = t.menuShouldScrollIntoView, c = t.theme, d = tn(hy) || {}, f = d.setPortalPlacement, p = Le(null), g = Ee(o), m = Xo(g, 2), b = m[0], v = m[1], y = Ee(null), w = Xo(y, 2), I = w[0], V = w[1], M = c.spacing.controlHeight;
  return Af(function() {
    var L = p.current;
    if (L) {
      var R = a === "fixed", _ = u && !R, H = mK({
        maxHeight: o,
        menuEl: L,
        minHeight: r,
        placement: i,
        shouldScroll: _,
        isFixedPosition: R,
        controlHeight: M
      });
      v(H.maxHeight), V(H.placement), f == null || f(H.placement);
    }
  }, [o, i, a, u, r, f, M]), n({
    ref: p,
    placerProps: Be(Be({}, t), {}, {
      placement: I || fy(i),
      maxHeight: b
    })
  });
}, yK = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return He("div", Te({}, qt(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, xK = yK, SK = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return Be({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, wK = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, i = t.isMulti;
  return He("div", Te({}, qt(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: o
  }, r), n);
}, py = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, i = r.colors;
  return Be({
    textAlign: "center"
  }, n ? {} : {
    color: i.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, IK = py, VK = py, AK = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, i = ei(t, pK);
  return He("div", Te({}, qt(Be(Be({}, i), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, LK = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, i = ei(t, gK);
  return He("div", Te({}, qt(Be(Be({}, i), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, MK = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, PK = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, i = t.innerProps, a = t.menuPlacement, u = t.menuPosition, c = Le(null), d = Le(null), f = Ee(fy(a)), p = Xo(f, 2), g = p[0], m = p[1], b = at(function() {
    return {
      setPortalPlacement: m
    };
  }, []), v = Ee(null), y = Xo(v, 2), w = y[0], I = y[1], V = q(function() {
    if (o) {
      var _ = aK(o), H = u === "fixed" ? 0 : window.pageYOffset, B = _[g] + H;
      (B !== (w == null ? void 0 : w.offset) || _.left !== (w == null ? void 0 : w.rect.left) || _.width !== (w == null ? void 0 : w.rect.width)) && I({
        offset: B,
        rect: _
      });
    }
  }, [o, u, g, w == null ? void 0 : w.offset, w == null ? void 0 : w.rect.left, w == null ? void 0 : w.rect.width]);
  Af(function() {
    V();
  }, [V]);
  var M = q(function() {
    typeof d.current == "function" && (d.current(), d.current = null), o && c.current && (d.current = eK(o, c.current, V, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, V]);
  Af(function() {
    M();
  }, [M]);
  var L = q(function(_) {
    c.current = _, M();
  }, [M]);
  if (!n && u !== "fixed" || !w)
    return null;
  var R = He("div", Te({
    ref: L
  }, qt(Be(Be({}, t), {}, {
    offset: w.offset,
    position: u,
    rect: w.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), r);
  return He(hy.Provider, {
    value: b
  }, n ? /* @__PURE__ */ Mf(R, n) : R);
}, EK = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, RK = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, i = t.isRtl;
  return He("div", Te({}, qt(t, "container", {
    "--is-disabled": o,
    "--is-rtl": i
  }), r), n);
}, _K = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, i = t.hasValue, a = t.selectProps.controlShouldRenderValue;
  return Be({
    alignItems: "center",
    display: o && i && a ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, TK = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, i = t.hasValue;
  return He("div", Te({}, qt(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": i
  }), r), n);
}, HK = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, FK = function(t) {
  var n = t.children, r = t.innerProps;
  return He("div", Te({}, qt(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, Dh, kK = ["size"], BK = ["innerProps", "isRtl", "size"];
function DK() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var OK = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: DK
}, gy = function(t) {
  var n = t.size, r = ei(t, kK);
  return He("svg", Te({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: OK
  }, r));
}, y4 = function(t) {
  return He(gy, Te({
    size: 20
  }, t), He("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, my = function(t) {
  return He(gy, Te({
    size: 20
  }, t), He("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Cy = function(t, n) {
  var r = t.isFocused, o = t.theme, i = o.spacing.baseUnit, a = o.colors;
  return Be({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? a.neutral60 : a.neutral20,
    padding: i * 2,
    ":hover": {
      color: r ? a.neutral80 : a.neutral40
    }
  });
}, NK = Cy, ZK = function(t) {
  var n = t.children, r = t.innerProps;
  return He("div", Te({}, qt(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || He(my, null));
}, $K = Cy, zK = function(t) {
  var n = t.children, r = t.innerProps;
  return He("div", Te({}, qt(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || He(y4, null));
}, WK = function(t, n) {
  var r = t.isDisabled, o = t.theme, i = o.spacing.baseUnit, a = o.colors;
  return Be({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? a.neutral10 : a.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, GK = function(t) {
  var n = t.innerProps;
  return He("span", Te({}, n, qt(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, jK = Cl(Dh || (Dh = $q([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), XK = function(t, n) {
  var r = t.isFocused, o = t.size, i = t.theme, a = i.colors, u = i.spacing.baseUnit;
  return Be({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? a.neutral60 : a.neutral20,
    padding: u * 2
  });
}, p5 = function(t) {
  var n = t.delay, r = t.offset;
  return He("span", {
    css: /* @__PURE__ */ _p({
      animation: "".concat(jK, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, UK = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, i = o === void 0 ? 4 : o, a = ei(t, BK);
  return He("div", Te({}, qt(Be(Be({}, a), {}, {
    innerProps: n,
    isRtl: r,
    size: i
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), He(p5, {
    delay: 0,
    offset: r
  }), He(p5, {
    delay: 160,
    offset: !0
  }), He(p5, {
    delay: 320,
    offset: !r
  }));
}, YK = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, i = t.theme, a = i.colors, u = i.borderRadius, c = i.spacing;
  return Be({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? a.neutral5 : a.neutral0,
    borderColor: r ? a.neutral10 : o ? a.primary : a.neutral20,
    borderRadius: u,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(a.primary) : void 0,
    "&:hover": {
      borderColor: o ? a.primary : a.neutral30
    }
  });
}, JK = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, i = t.innerRef, a = t.innerProps, u = t.menuIsOpen;
  return He("div", Te({
    ref: i
  }, qt(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": u
  }), a, {
    "aria-disabled": r || void 0
  }), n);
}, qK = JK, KK = ["data"], QK = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, eQ = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, i = t.getClassNames, a = t.Heading, u = t.headingProps, c = t.innerProps, d = t.label, f = t.theme, p = t.selectProps;
  return He("div", Te({}, qt(t, "group", {
    group: !0
  }), c), He(a, Te({}, u, {
    selectProps: p,
    theme: f,
    getStyles: o,
    getClassNames: i,
    cx: r
  }), d), He("div", null, n));
}, tQ = function(t, n) {
  var r = t.theme, o = r.colors, i = r.spacing;
  return Be({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, nQ = function(t) {
  var n = uy(t);
  n.data;
  var r = ei(n, KK);
  return He("div", Te({}, qt(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, rQ = eQ, oQ = ["innerRef", "isDisabled", "isHidden", "inputClassName"], iQ = function(t, n) {
  var r = t.isDisabled, o = t.value, i = t.theme, a = i.spacing, u = i.colors;
  return Be(Be({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, sQ), n ? {} : {
    margin: a.baseUnit / 2,
    paddingBottom: a.baseUnit / 2,
    paddingTop: a.baseUnit / 2,
    color: u.neutral80
  });
}, vy = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, sQ = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Be({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, vy)
}, aQ = function(t) {
  return Be({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, vy);
}, lQ = function(t) {
  var n = t.cx, r = t.value, o = uy(t), i = o.innerRef, a = o.isDisabled, u = o.isHidden, c = o.inputClassName, d = ei(o, oQ);
  return He("div", Te({}, qt(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), He("input", Te({
    className: n({
      input: !0
    }, c),
    ref: i,
    style: aQ(u),
    disabled: a
  }, d)));
}, uQ = lQ, cQ = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.borderRadius, a = r.colors;
  return Be({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: a.neutral10,
    borderRadius: i / 2,
    margin: o.baseUnit / 2
  });
}, dQ = function(t, n) {
  var r = t.theme, o = r.borderRadius, i = r.colors, a = t.cropWithEllipsis;
  return Be({
    overflow: "hidden",
    textOverflow: a || a === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, fQ = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.borderRadius, a = r.colors, u = t.isFocused;
  return Be({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: i / 2,
    backgroundColor: u ? a.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: a.dangerLight,
      color: a.danger
    }
  });
}, by = function(t) {
  var n = t.children, r = t.innerProps;
  return He("div", r, n);
}, hQ = by, pQ = by;
function gQ(e) {
  var t = e.children, n = e.innerProps;
  return He("div", Te({
    role: "button"
  }, n), t || He(y4, {
    size: 14
  }));
}
var mQ = function(t) {
  var n = t.children, r = t.components, o = t.data, i = t.innerProps, a = t.isDisabled, u = t.removeProps, c = t.selectProps, d = r.Container, f = r.Label, p = r.Remove;
  return He(d, {
    data: o,
    innerProps: Be(Be({}, qt(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": a
    })), i),
    selectProps: c
  }, He(f, {
    data: o,
    innerProps: Be({}, qt(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), He(p, {
    data: o,
    innerProps: Be(Be({}, qt(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, u),
    selectProps: c
  }));
}, CQ = mQ, vQ = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, i = t.isSelected, a = t.theme, u = a.spacing, c = a.colors;
  return Be({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: i ? c.primary : o ? c.primary25 : "transparent",
    color: r ? c.neutral20 : i ? c.neutral0 : "inherit",
    padding: "".concat(u.baseUnit * 2, "px ").concat(u.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : i ? c.primary : c.primary50
    }
  });
}, bQ = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, i = t.isSelected, a = t.innerRef, u = t.innerProps;
  return He("div", Te({}, qt(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": i
  }), {
    ref: a,
    "aria-disabled": r
  }, u), n);
}, yQ = bQ, xQ = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.colors;
  return Be({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: i.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, SQ = function(t) {
  var n = t.children, r = t.innerProps;
  return He("div", Te({}, qt(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, wQ = SQ, IQ = function(t, n) {
  var r = t.isDisabled, o = t.theme, i = o.spacing, a = o.colors;
  return Be({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? a.neutral40 : a.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, VQ = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return He("div", Te({}, qt(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, AQ = VQ, LQ = {
  ClearIndicator: zK,
  Control: qK,
  DropdownIndicator: ZK,
  DownChevron: my,
  CrossIcon: y4,
  Group: rQ,
  GroupHeading: nQ,
  IndicatorsContainer: FK,
  IndicatorSeparator: GK,
  Input: uQ,
  LoadingIndicator: UK,
  Menu: xK,
  MenuList: wK,
  MenuPortal: PK,
  LoadingMessage: LK,
  NoOptionsMessage: AK,
  MultiValue: CQ,
  MultiValueContainer: hQ,
  MultiValueLabel: pQ,
  MultiValueRemove: gQ,
  Option: yQ,
  Placeholder: wQ,
  SelectContainer: RK,
  SingleValue: AQ,
  ValueContainer: TK
}, MQ = function(t) {
  return Be(Be({}, LQ), t.components);
}, Oh = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function PQ(e, t) {
  return !!(e === t || Oh(e) && Oh(t));
}
function EQ(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!PQ(e[n], t[n]))
      return !1;
  return !0;
}
function RQ(e, t) {
  t === void 0 && (t = EQ);
  var n = null;
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, o);
    return n = {
      lastResult: a,
      lastArgs: o,
      lastThis: this
    }, a;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function _Q() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var TQ = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _Q
}, HQ = function(t) {
  return He("span", Te({
    css: TQ
  }, t));
}, Nh = HQ, FQ = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, i = t.context, a = t.isInitialFocus;
    switch (i) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return a ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, i = t.labels, a = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return a ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, i = t.label, a = i === void 0 ? "" : i, u = t.selectValue, c = t.isDisabled, d = t.isSelected, f = t.isAppleDevice, p = function(v, y) {
      return v && v.length ? "".concat(v.indexOf(y) + 1, " of ").concat(v.length) : "";
    };
    if (n === "value" && u)
      return "value ".concat(a, " focused, ").concat(p(u, r), ".");
    if (n === "menu" && f) {
      var g = c ? " disabled" : "", m = "".concat(d ? " selected" : "").concat(g);
      return "".concat(a).concat(m, ", ").concat(p(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, kQ = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, i = t.focusableOptions, a = t.isFocused, u = t.selectValue, c = t.selectProps, d = t.id, f = t.isAppleDevice, p = c.ariaLiveMessages, g = c.getOptionLabel, m = c.inputValue, b = c.isMulti, v = c.isOptionDisabled, y = c.isSearchable, w = c.menuIsOpen, I = c.options, V = c.screenReaderStatus, M = c.tabSelectsValue, L = c.isLoading, R = c["aria-label"], _ = c["aria-live"], H = at(function() {
    return Be(Be({}, FQ), p || {});
  }, [p]), B = at(function() {
    var xe = "";
    if (n && H.onChange) {
      var he = n.option, z = n.options, Y = n.removedValue, ae = n.removedValues, j = n.value, X = function(pe) {
        return Array.isArray(pe) ? null : pe;
      }, ie = Y || he || X(j), W = ie ? g(ie) : "", re = z || ae || void 0, te = re ? re.map(g) : [], ee = Be({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ie && v(ie, u),
        label: W,
        labels: te
      }, n);
      xe = H.onChange(ee);
    }
    return xe;
  }, [n, H, v, u, g]), Z = at(function() {
    var xe = "", he = r || o, z = !!(r && u && u.includes(r));
    if (he && H.onFocus) {
      var Y = {
        focused: he,
        label: g(he),
        isDisabled: v(he, u),
        isSelected: z,
        options: i,
        context: he === r ? "menu" : "value",
        selectValue: u,
        isAppleDevice: f
      };
      xe = H.onFocus(Y);
    }
    return xe;
  }, [r, o, g, v, H, i, u, f]), G = at(function() {
    var xe = "";
    if (w && I.length && !L && H.onFilter) {
      var he = V({
        count: i.length
      });
      xe = H.onFilter({
        inputValue: m,
        resultsMessage: he
      });
    }
    return xe;
  }, [i, m, w, H, I, V, L]), se = (n == null ? void 0 : n.action) === "initial-input-focus", ue = at(function() {
    var xe = "";
    if (H.guidance) {
      var he = o ? "value" : w ? "menu" : "input";
      xe = H.guidance({
        "aria-label": R,
        context: he,
        isDisabled: r && v(r, u),
        isMulti: b,
        isSearchable: y,
        tabSelectsValue: M,
        isInitialFocus: se
      });
    }
    return xe;
  }, [R, r, o, b, v, y, w, H, u, M, se]), ce = He(ol, null, He("span", {
    id: "aria-selection"
  }, B), He("span", {
    id: "aria-focused"
  }, Z), He("span", {
    id: "aria-results"
  }, G), He("span", {
    id: "aria-guidance"
  }, ue));
  return He(ol, null, He(Nh, {
    id: d
  }, se && ce), He(Nh, {
    "aria-live": _,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, a && !se && ce));
}, BQ = kQ, Lf = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], DQ = new RegExp("[" + Lf.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), yy = {};
for (var g5 = 0; g5 < Lf.length; g5++)
  for (var m5 = Lf[g5], C5 = 0; C5 < m5.letters.length; C5++)
    yy[m5.letters[C5]] = m5.base;
var xy = function(t) {
  return t.replace(DQ, function(n) {
    return yy[n];
  });
}, OQ = RQ(xy), Zh = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, NQ = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, ZQ = function(t) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var o = Be({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: NQ,
      trim: !0,
      matchFrom: "any"
    }, t), i = o.ignoreCase, a = o.ignoreAccents, u = o.stringify, c = o.trim, d = o.matchFrom, f = c ? Zh(r) : r, p = c ? Zh(u(n)) : u(n);
    return i && (f = f.toLowerCase(), p = p.toLowerCase()), a && (f = OQ(f), p = xy(p)), d === "start" ? p.substr(0, f.length) === f : p.indexOf(f) > -1;
  };
}, $Q = ["innerRef"];
function zQ(e) {
  var t = e.innerRef, n = ei(e, $Q), r = hK(n, "onExited", "in", "enter", "exit", "appear");
  return He("input", Te({
    ref: t
  }, r, {
    css: /* @__PURE__ */ _p({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var WQ = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function GQ(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, i = e.onTopLeave, a = Le(!1), u = Le(!1), c = Le(0), d = Le(null), f = q(function(y, w) {
    if (d.current !== null) {
      var I = d.current, V = I.scrollTop, M = I.scrollHeight, L = I.clientHeight, R = d.current, _ = w > 0, H = M - L - V, B = !1;
      H > w && a.current && (r && r(y), a.current = !1), _ && u.current && (i && i(y), u.current = !1), _ && w > H ? (n && !a.current && n(y), R.scrollTop = M, B = !0, a.current = !0) : !_ && -w > V && (o && !u.current && o(y), R.scrollTop = 0, B = !0, u.current = !0), B && WQ(y);
    }
  }, [n, r, o, i]), p = q(function(y) {
    f(y, y.deltaY);
  }, [f]), g = q(function(y) {
    c.current = y.changedTouches[0].clientY;
  }, []), m = q(function(y) {
    var w = c.current - y.changedTouches[0].clientY;
    f(y, w);
  }, [f]), b = q(function(y) {
    if (y) {
      var w = cK ? {
        passive: !1
      } : !1;
      y.addEventListener("wheel", p, w), y.addEventListener("touchstart", g, w), y.addEventListener("touchmove", m, w);
    }
  }, [m, g, p]), v = q(function(y) {
    y && (y.removeEventListener("wheel", p, !1), y.removeEventListener("touchstart", g, !1), y.removeEventListener("touchmove", m, !1));
  }, [m, g, p]);
  return Ue(function() {
    if (t) {
      var y = d.current;
      return b(y), function() {
        v(y);
      };
    }
  }, [t, b, v]), function(y) {
    d.current = y;
  };
}
var $h = ["boxSizing", "height", "overflow", "paddingRight", "position"], zh = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Wh(e) {
  e.preventDefault();
}
function Gh(e) {
  e.stopPropagation();
}
function jh() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function Xh() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Uh = !!(typeof window < "u" && window.document && window.document.createElement), P1 = 0, sa = {
  capture: !1,
  passive: !1
};
function jQ(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = Le({}), i = Le(null), a = q(function(c) {
    if (Uh) {
      var d = document.body, f = d && d.style;
      if (r && $h.forEach(function(b) {
        var v = f && f[b];
        o.current[b] = v;
      }), r && P1 < 1) {
        var p = parseInt(o.current.paddingRight, 10) || 0, g = document.body ? document.body.clientWidth : 0, m = window.innerWidth - g + p || 0;
        Object.keys(zh).forEach(function(b) {
          var v = zh[b];
          f && (f[b] = v);
        }), f && (f.paddingRight = "".concat(m, "px"));
      }
      d && Xh() && (d.addEventListener("touchmove", Wh, sa), c && (c.addEventListener("touchstart", jh, sa), c.addEventListener("touchmove", Gh, sa))), P1 += 1;
    }
  }, [r]), u = q(function(c) {
    if (Uh) {
      var d = document.body, f = d && d.style;
      P1 = Math.max(P1 - 1, 0), r && P1 < 1 && $h.forEach(function(p) {
        var g = o.current[p];
        f && (f[p] = g);
      }), d && Xh() && (d.removeEventListener("touchmove", Wh, sa), c && (c.removeEventListener("touchstart", jh, sa), c.removeEventListener("touchmove", Gh, sa)));
    }
  }, [r]);
  return Ue(function() {
    if (t) {
      var c = i.current;
      return a(c), function() {
        u(c);
      };
    }
  }, [t, a, u]), function(c) {
    i.current = c;
  };
}
function XQ() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var UQ = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, YQ = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbE1hbmFnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9EVSIsImZpbGUiOiJTY3JvbGxNYW5hZ2VyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRnJhZ21lbnQsIFJlYWN0RWxlbWVudCwgUmVmQ2FsbGJhY2ssIE1vdXNlRXZlbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdXNlU2Nyb2xsQ2FwdHVyZSBmcm9tICcuL3VzZVNjcm9sbENhcHR1cmUnO1xuaW1wb3J0IHVzZVNjcm9sbExvY2sgZnJvbSAnLi91c2VTY3JvbGxMb2NrJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgcmVhZG9ubHkgY2hpbGRyZW46IChyZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PikgPT4gUmVhY3RFbGVtZW50O1xuICByZWFkb25seSBsb2NrRW5hYmxlZDogYm9vbGVhbjtcbiAgcmVhZG9ubHkgY2FwdHVyZUVuYWJsZWQ6IGJvb2xlYW47XG4gIHJlYWRvbmx5IG9uQm90dG9tQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Cb3R0b21MZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG4gIHJlYWRvbmx5IG9uVG9wQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Ub3BMZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG59XG5cbmNvbnN0IGJsdXJTZWxlY3RJbnB1dCA9IChldmVudDogTW91c2VFdmVudDxIVE1MRGl2RWxlbWVudD4pID0+IHtcbiAgY29uc3QgZWxlbWVudCA9IGV2ZW50LnRhcmdldCBhcyBIVE1MRGl2RWxlbWVudDtcbiAgcmV0dXJuIChcbiAgICBlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCAmJlxuICAgIChlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCBhcyBIVE1MRWxlbWVudCkuYmx1cigpXG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBTY3JvbGxNYW5hZ2VyKHtcbiAgY2hpbGRyZW4sXG4gIGxvY2tFbmFibGVkLFxuICBjYXB0dXJlRW5hYmxlZCA9IHRydWUsXG4gIG9uQm90dG9tQXJyaXZlLFxuICBvbkJvdHRvbUxlYXZlLFxuICBvblRvcEFycml2ZSxcbiAgb25Ub3BMZWF2ZSxcbn06IFByb3BzKSB7XG4gIGNvbnN0IHNldFNjcm9sbENhcHR1cmVUYXJnZXQgPSB1c2VTY3JvbGxDYXB0dXJlKHtcbiAgICBpc0VuYWJsZWQ6IGNhcHR1cmVFbmFibGVkLFxuICAgIG9uQm90dG9tQXJyaXZlLFxuICAgIG9uQm90dG9tTGVhdmUsXG4gICAgb25Ub3BBcnJpdmUsXG4gICAgb25Ub3BMZWF2ZSxcbiAgfSk7XG4gIGNvbnN0IHNldFNjcm9sbExvY2tUYXJnZXQgPSB1c2VTY3JvbGxMb2NrKHsgaXNFbmFibGVkOiBsb2NrRW5hYmxlZCB9KTtcblxuICBjb25zdCB0YXJnZXRSZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PiA9IChlbGVtZW50KSA9PiB7XG4gICAgc2V0U2Nyb2xsQ2FwdHVyZVRhcmdldChlbGVtZW50KTtcbiAgICBzZXRTY3JvbGxMb2NrVGFyZ2V0KGVsZW1lbnQpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEZyYWdtZW50PlxuICAgICAge2xvY2tFbmFibGVkICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIG9uQ2xpY2s9e2JsdXJTZWxlY3RJbnB1dH1cbiAgICAgICAgICBjc3M9e3sgcG9zaXRpb246ICdmaXhlZCcsIGxlZnQ6IDAsIGJvdHRvbTogMCwgcmlnaHQ6IDAsIHRvcDogMCB9fVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICAgIHtjaGlsZHJlbih0YXJnZXRSZWYpfVxuICAgIDwvRnJhZ21lbnQ+XG4gICk7XG59XG4iXX0= */",
  toString: XQ
};
function JQ(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, i = e.onBottomArrive, a = e.onBottomLeave, u = e.onTopArrive, c = e.onTopLeave, d = GQ({
    isEnabled: o,
    onBottomArrive: i,
    onBottomLeave: a,
    onTopArrive: u,
    onTopLeave: c
  }), f = jQ({
    isEnabled: n
  }), p = function(m) {
    d(m), f(m);
  };
  return He(ol, null, n && He("div", {
    onClick: UQ,
    css: YQ
  }), t(p));
}
function qQ() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var KQ = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: qQ
}, QQ = function(t) {
  var n = t.name, r = t.onFocus;
  return He("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: KQ,
    value: "",
    onChange: function() {
    }
  });
}, eee = QQ;
function x4(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function tee() {
  return x4(/^iPhone/i);
}
function Sy() {
  return x4(/^Mac/i);
}
function nee() {
  return x4(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Sy() && navigator.maxTouchPoints > 1;
}
function ree() {
  return tee() || nee();
}
function oee() {
  return Sy() || ree();
}
var iee = function(t) {
  return t.label;
}, see = function(t) {
  return t.label;
}, aee = function(t) {
  return t.value;
}, lee = function(t) {
  return !!t.isDisabled;
}, uee = {
  clearIndicator: $K,
  container: EK,
  control: YK,
  dropdownIndicator: NK,
  group: QK,
  groupHeading: tQ,
  indicatorsContainer: HK,
  indicatorSeparator: WK,
  input: iQ,
  loadingIndicator: XK,
  loadingMessage: VK,
  menu: vK,
  menuList: SK,
  menuPortal: MK,
  multiValue: cQ,
  multiValueLabel: dQ,
  multiValueRemove: fQ,
  noOptionsMessage: IK,
  option: vQ,
  placeholder: xQ,
  singleValue: IQ,
  valueContainer: _K
}, cee = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, dee = 4, wy = 4, fee = 38, hee = wy * 2, pee = {
  baseUnit: wy,
  controlHeight: fee,
  menuGutter: hee
}, v5 = {
  borderRadius: dee,
  colors: cee,
  spacing: pee
}, gee = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Bh(),
  captureMenuScroll: !Bh(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: ZQ(),
  formatGroupLabel: iee,
  getOptionLabel: see,
  getOptionValue: aee,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: lee,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !lK(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Yh(e, t, n, r) {
  var o = Ay(e, t, n), i = Ly(e, t, n), a = Vy(e, t), u = c2(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: i,
    label: a,
    value: u,
    index: r
  };
}
function Fc(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(a, u) {
        return Yh(e, a, t, u);
      }).filter(function(a) {
        return qh(e, a);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var i = Yh(e, n, t, r);
    return qh(e, i) ? i : void 0;
  }).filter(dK);
}
function Iy(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, m4(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function Jh(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, m4(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function mee(e, t) {
  return Iy(Fc(e, t));
}
function qh(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, i = t.isSelected, a = t.label, u = t.value;
  return (!Py(e) || !i) && My(e, {
    label: a,
    value: u,
    data: o
  }, r);
}
function Cee(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var i = t.indexOf(n);
    if (i > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function vee(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var b5 = function(t, n) {
  var r, o = (r = t.find(function(i) {
    return i.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, Vy = function(t, n) {
  return t.getOptionLabel(n);
}, c2 = function(t, n) {
  return t.getOptionValue(n);
};
function Ay(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Ly(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = c2(e, t);
  return n.some(function(o) {
    return c2(e, o) === r;
  });
}
function My(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var Py = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, bee = 1, Ey = /* @__PURE__ */ function(e) {
  Fq(n, e);
  var t = Dq(n);
  function n(r) {
    var o;
    if (Tq(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = oee(), o.controlRef = null, o.getControlRef = function(c) {
      o.controlRef = c;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(c) {
      o.focusedOptionRef = c;
    }, o.menuListRef = null, o.getMenuListRef = function(c) {
      o.menuListRef = c;
    }, o.inputRef = null, o.getInputRef = function(c) {
      o.inputRef = c;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(c, d) {
      var f = o.props, p = f.onChange, g = f.name;
      d.name = g, o.ariaOnChange(c, d), p(c, d);
    }, o.setValue = function(c, d, f) {
      var p = o.props, g = p.closeMenuOnSelect, m = p.isMulti, b = p.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: b
      }), g && (o.setState({
        inputIsHiddenAfterUpdate: !m
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(c, {
        action: d,
        option: f
      });
    }, o.selectOption = function(c) {
      var d = o.props, f = d.blurInputOnSelect, p = d.isMulti, g = d.name, m = o.state.selectValue, b = p && o.isOptionSelected(c, m), v = o.isOptionDisabled(c, m);
      if (b) {
        var y = o.getOptionValue(c);
        o.setValue(m.filter(function(w) {
          return o.getOptionValue(w) !== y;
        }), "deselect-option", c);
      } else if (!v)
        p ? o.setValue([].concat(m4(m), [c]), "select-option", c) : o.setValue(c, "select-option");
      else {
        o.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: g
        });
        return;
      }
      f && o.blurInput();
    }, o.removeValue = function(c) {
      var d = o.props.isMulti, f = o.state.selectValue, p = o.getOptionValue(c), g = f.filter(function(b) {
        return o.getOptionValue(b) !== p;
      }), m = vc(d, g, g[0] || null);
      o.onChange(m, {
        action: "remove-value",
        removedValue: c
      }), o.focusInput();
    }, o.clearValue = function() {
      var c = o.state.selectValue;
      o.onChange(vc(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, o.popValue = function() {
      var c = o.props.isMulti, d = o.state.selectValue, f = d[d.length - 1], p = d.slice(0, d.length - 1), g = vc(c, p, p[0] || null);
      o.onChange(g, {
        action: "pop-value",
        removedValue: f
      });
    }, o.getFocusedOptionId = function(c) {
      return b5(o.state.focusableOptionsWithIds, c);
    }, o.getFocusableOptionsWithIds = function() {
      return Jh(Fc(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var c = arguments.length, d = new Array(c), f = 0; f < c; f++)
        d[f] = arguments[f];
      return rK.apply(void 0, [o.props.classNamePrefix].concat(d));
    }, o.getOptionLabel = function(c) {
      return Vy(o.props, c);
    }, o.getOptionValue = function(c) {
      return c2(o.props, c);
    }, o.getStyles = function(c, d) {
      var f = o.props.unstyled, p = uee[c](d, f);
      p.boxSizing = "border-box";
      var g = o.props.styles[c];
      return g ? g(p, d) : p;
    }, o.getClassNames = function(c, d) {
      var f, p;
      return (f = (p = o.props.classNames)[c]) === null || f === void 0 ? void 0 : f.call(p, d);
    }, o.getElementId = function(c) {
      return "".concat(o.state.instancePrefix, "-").concat(c);
    }, o.getComponents = function() {
      return MQ(o.props);
    }, o.buildCategorizedOptions = function() {
      return Fc(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return Iy(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(c, d) {
      o.setState({
        ariaSelection: Be({
          value: c
        }, d)
      });
    }, o.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(c) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var d = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && o.onMenuClose() : d && o.openMenu("first") : (d && (o.openAfterFocus = !0), o.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !o.props.isDisabled) {
        var d = o.props, f = d.isMulti, p = d.menuIsOpen;
        o.focusInput(), p ? (o.setState({
          inputIsHiddenAfterUpdate: !f
        }), o.onMenuClose()) : o.openMenu("first"), c.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (o.clearValue(), c.preventDefault(), o.openAfterFocus = !1, c.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(c) {
      typeof o.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && $2(c.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(c) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(c) {
      var d = c.touches, f = d && d.item(0);
      f && (o.initialTouchX = f.clientX, o.initialTouchY = f.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(c) {
      var d = c.touches, f = d && d.item(0);
      if (f) {
        var p = Math.abs(f.clientX - o.initialTouchX), g = Math.abs(f.clientY - o.initialTouchY), m = 5;
        o.userIsDragging = p > m || g > m;
      }
    }, o.onTouchEnd = function(c) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(c.target) && o.menuListRef && !o.menuListRef.contains(c.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(c) {
      o.userIsDragging || o.onControlMouseDown(c);
    }, o.onClearIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onClearIndicatorMouseDown(c);
    }, o.onDropdownIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(c);
    }, o.handleInputChange = function(c) {
      var d = o.props.inputValue, f = c.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(f, {
        action: "input-change",
        prevInputValue: d
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(c) {
      o.props.onFocus && o.props.onFocus(c), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(c) {
      var d = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(c), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: d
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(c) {
      if (!(o.blockOptionHover || o.state.focusedOption === c)) {
        var d = o.getFocusableOptions(), f = d.indexOf(c);
        o.setState({
          focusedOption: c,
          focusedOptionId: f > -1 ? o.getFocusedOptionId(c) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return Py(o.props);
    }, o.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), o.focus();
    }, o.onKeyDown = function(c) {
      var d = o.props, f = d.isMulti, p = d.backspaceRemovesValue, g = d.escapeClearsValue, m = d.inputValue, b = d.isClearable, v = d.isDisabled, y = d.menuIsOpen, w = d.onKeyDown, I = d.tabSelectsValue, V = d.openMenuOnFocus, M = o.state, L = M.focusedOption, R = M.focusedValue, _ = M.selectValue;
      if (!v && !(typeof w == "function" && (w(c), c.defaultPrevented))) {
        switch (o.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!f || m)
              return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!f || m)
              return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (m)
              return;
            if (R)
              o.removeValue(R);
            else {
              if (!p)
                return;
              f ? o.popValue() : b && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || c.shiftKey || !y || !I || !L || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            V && o.isOptionSelected(L, _))
              return;
            o.selectOption(L);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (y) {
              if (!L || o.isComposing)
                return;
              o.selectOption(L);
              break;
            }
            return;
          case "Escape":
            y ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: m
            }), o.onMenuClose()) : b && g && o.clearValue();
            break;
          case " ":
            if (m)
              return;
            if (!y) {
              o.openMenu("first");
              break;
            }
            if (!L)
              return;
            o.selectOption(L);
            break;
          case "ArrowUp":
            y ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            y ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!y)
              return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!y)
              return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!y)
              return;
            o.focusOption("first");
            break;
          case "End":
            if (!y)
              return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++bee), o.state.selectValue = Fh(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var i = o.getFocusableOptionsWithIds(), a = o.buildFocusableOptions(), u = a.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = i, o.state.focusedOption = a[u], o.state.focusedOptionId = b5(i, a[u]);
    }
    return o;
  }
  return Hq(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && kh(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var i = this.props, a = i.isDisabled, u = i.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !a && o.isDisabled || // ensure focus is on the Input when the menu opens
      c && u && !o.menuIsOpen) && this.focusInput(), c && a && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !a && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (kh(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, i) {
      this.props.onInputChange(o, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var i = this, a = this.state, u = a.selectValue, c = a.isFocused, d = this.buildFocusableOptions(), f = o === "first" ? 0 : d.length - 1;
      if (!this.props.isMulti) {
        var p = d.indexOf(u[0]);
        p > -1 && (f = p);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: d[f],
        focusedOptionId: this.getFocusedOptionId(d[f])
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var i = this.state, a = i.selectValue, u = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = a.indexOf(u);
        u || (c = -1);
        var d = a.length - 1, f = -1;
        if (a.length) {
          switch (o) {
            case "previous":
              c === 0 ? f = 0 : c === -1 ? f = d : f = c - 1;
              break;
            case "next":
              c > -1 && c < d && (f = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: f !== -1,
            focusedValue: a[f]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, a = this.state.focusedOption, u = this.getFocusableOptions();
      if (u.length) {
        var c = 0, d = u.indexOf(a);
        a || (d = -1), o === "up" ? c = d > 0 ? d - 1 : u.length - 1 : o === "down" ? c = (d + 1) % u.length : o === "pageup" ? (c = d - i, c < 0 && (c = 0)) : o === "pagedown" ? (c = d + i, c > u.length - 1 && (c = u.length - 1)) : o === "last" && (c = u.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: u[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(u[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(v5) : Be(Be({}, v5), this.props.theme) : v5;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, i = this.cx, a = this.getStyles, u = this.getClassNames, c = this.getValue, d = this.selectOption, f = this.setValue, p = this.props, g = p.isMulti, m = p.isRtl, b = p.options, v = this.hasValue();
      return {
        clearValue: o,
        cx: i,
        getStyles: a,
        getClassNames: u,
        getValue: c,
        hasValue: v,
        isMulti: g,
        isRtl: m,
        options: b,
        selectOption: d,
        selectProps: p,
        setValue: f,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, i = o.isClearable, a = o.isMulti;
      return i === void 0 ? a : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, i) {
      return Ay(this.props, o, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, i) {
      return Ly(this.props, o, i);
    }
  }, {
    key: "filterOption",
    value: function(o, i) {
      return My(this.props, o, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var a = this.props.inputValue, u = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: i,
          inputValue: a,
          selectValue: u
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, i = o.isDisabled, a = o.isSearchable, u = o.inputId, c = o.inputValue, d = o.tabIndex, f = o.form, p = o.menuIsOpen, g = o.required, m = this.getComponents(), b = m.Input, v = this.state, y = v.inputIsHidden, w = v.ariaSelection, I = this.commonProps, V = u || this.getElementId("input"), M = Be(Be(Be({
          "aria-autocomplete": "list",
          "aria-expanded": p,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": g,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, p && {
          "aria-controls": this.getElementId("listbox")
        }), !a && {
          "aria-readonly": !0
        }), this.hasValue() ? (w == null ? void 0 : w.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return a ? /* @__PURE__ */ be.createElement(b, Te({}, I, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: V,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: y,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: d,
          form: f,
          type: "text",
          value: c
        }, M)) : /* @__PURE__ */ be.createElement(zQ, Te({
          id: V,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: l2,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: d,
          inputMode: "none",
          form: f,
          value: ""
        }, M));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, i = this.getComponents(), a = i.MultiValue, u = i.MultiValueContainer, c = i.MultiValueLabel, d = i.MultiValueRemove, f = i.SingleValue, p = i.Placeholder, g = this.commonProps, m = this.props, b = m.controlShouldRenderValue, v = m.isDisabled, y = m.isMulti, w = m.inputValue, I = m.placeholder, V = this.state, M = V.selectValue, L = V.focusedValue, R = V.isFocused;
      if (!this.hasValue() || !b)
        return w ? null : /* @__PURE__ */ be.createElement(p, Te({}, g, {
          key: "placeholder",
          isDisabled: v,
          isFocused: R,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), I);
      if (y)
        return M.map(function(H, B) {
          var Z = H === L, G = "".concat(o.getOptionLabel(H), "-").concat(o.getOptionValue(H));
          return /* @__PURE__ */ be.createElement(a, Te({}, g, {
            components: {
              Container: u,
              Label: c,
              Remove: d
            },
            isFocused: Z,
            isDisabled: v,
            key: G,
            index: B,
            removeProps: {
              onClick: function() {
                return o.removeValue(H);
              },
              onTouchEnd: function() {
                return o.removeValue(H);
              },
              onMouseDown: function(ue) {
                ue.preventDefault();
              }
            },
            data: H
          }), o.formatOptionLabel(H, "value"));
        });
      if (w)
        return null;
      var _ = M[0];
      return /* @__PURE__ */ be.createElement(f, Te({}, g, {
        data: _,
        isDisabled: v
      }), this.formatOptionLabel(_, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), i = o.ClearIndicator, a = this.commonProps, u = this.props, c = u.isDisabled, d = u.isLoading, f = this.state.isFocused;
      if (!this.isClearable() || !i || c || !this.hasValue() || d)
        return null;
      var p = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ be.createElement(i, Te({}, a, {
        innerProps: p,
        isFocused: f
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), i = o.LoadingIndicator, a = this.commonProps, u = this.props, c = u.isDisabled, d = u.isLoading, f = this.state.isFocused;
      if (!i || !d)
        return null;
      var p = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ be.createElement(i, Te({}, a, {
        innerProps: p,
        isDisabled: c,
        isFocused: f
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), i = o.DropdownIndicator, a = o.IndicatorSeparator;
      if (!i || !a)
        return null;
      var u = this.commonProps, c = this.props.isDisabled, d = this.state.isFocused;
      return /* @__PURE__ */ be.createElement(a, Te({}, u, {
        isDisabled: c,
        isFocused: d
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), i = o.DropdownIndicator;
      if (!i)
        return null;
      var a = this.commonProps, u = this.props.isDisabled, c = this.state.isFocused, d = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ be.createElement(i, Te({}, a, {
        innerProps: d,
        isDisabled: u,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, i = this.getComponents(), a = i.Group, u = i.GroupHeading, c = i.Menu, d = i.MenuList, f = i.MenuPortal, p = i.LoadingMessage, g = i.NoOptionsMessage, m = i.Option, b = this.commonProps, v = this.state.focusedOption, y = this.props, w = y.captureMenuScroll, I = y.inputValue, V = y.isLoading, M = y.loadingMessage, L = y.minMenuHeight, R = y.maxMenuHeight, _ = y.menuIsOpen, H = y.menuPlacement, B = y.menuPosition, Z = y.menuPortalTarget, G = y.menuShouldBlockScroll, se = y.menuShouldScrollIntoView, ue = y.noOptionsMessage, ce = y.onMenuScrollToTop, xe = y.onMenuScrollToBottom;
      if (!_)
        return null;
      var he = function(W, re) {
        var te = W.type, ee = W.data, ge = W.isDisabled, pe = W.isSelected, Se = W.label, de = W.value, Ve = v === ee, K = ge ? void 0 : function() {
          return o.onOptionHover(ee);
        }, Ye = ge ? void 0 : function() {
          return o.selectOption(ee);
        }, ve = "".concat(o.getElementId("option"), "-").concat(re), ot = {
          id: ve,
          onClick: Ye,
          onMouseMove: K,
          onMouseOver: K,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : pe
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ be.createElement(m, Te({}, b, {
          innerProps: ot,
          data: ee,
          isDisabled: ge,
          isSelected: pe,
          key: ve,
          label: Se,
          type: te,
          value: de,
          isFocused: Ve,
          innerRef: Ve ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(W.data, "menu"));
      }, z;
      if (this.hasOptions())
        z = this.getCategorizedOptions().map(function(ie) {
          if (ie.type === "group") {
            var W = ie.data, re = ie.options, te = ie.index, ee = "".concat(o.getElementId("group"), "-").concat(te), ge = "".concat(ee, "-heading");
            return /* @__PURE__ */ be.createElement(a, Te({}, b, {
              key: ee,
              data: W,
              options: re,
              Heading: u,
              headingProps: {
                id: ge,
                data: ie.data
              },
              label: o.formatGroupLabel(ie.data)
            }), ie.options.map(function(pe) {
              return he(pe, "".concat(te, "-").concat(pe.index));
            }));
          } else if (ie.type === "option")
            return he(ie, "".concat(ie.index));
        });
      else if (V) {
        var Y = M({
          inputValue: I
        });
        if (Y === null)
          return null;
        z = /* @__PURE__ */ be.createElement(p, b, Y);
      } else {
        var ae = ue({
          inputValue: I
        });
        if (ae === null)
          return null;
        z = /* @__PURE__ */ be.createElement(g, b, ae);
      }
      var j = {
        minMenuHeight: L,
        maxMenuHeight: R,
        menuPlacement: H,
        menuPosition: B,
        menuShouldScrollIntoView: se
      }, X = /* @__PURE__ */ be.createElement(bK, Te({}, b, j), function(ie) {
        var W = ie.ref, re = ie.placerProps, te = re.placement, ee = re.maxHeight;
        return /* @__PURE__ */ be.createElement(c, Te({}, b, j, {
          innerRef: W,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: V,
          placement: te
        }), /* @__PURE__ */ be.createElement(JQ, {
          captureEnabled: w,
          onTopArrive: ce,
          onBottomArrive: xe,
          lockEnabled: G
        }, function(ge) {
          return /* @__PURE__ */ be.createElement(d, Te({}, b, {
            innerRef: function(Se) {
              o.getMenuListRef(Se), ge(Se);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": b.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: V,
            maxHeight: ee,
            focusedOption: v
          }), z);
        }));
      });
      return Z || B === "fixed" ? /* @__PURE__ */ be.createElement(f, Te({}, b, {
        appendTo: Z,
        controlElement: this.controlRef,
        menuPlacement: H,
        menuPosition: B
      }), X) : X;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, i = this.props, a = i.delimiter, u = i.isDisabled, c = i.isMulti, d = i.name, f = i.required, p = this.state.selectValue;
      if (f && !this.hasValue() && !u)
        return /* @__PURE__ */ be.createElement(eee, {
          name: d,
          onFocus: this.onValueInputFocus
        });
      if (!(!d || u))
        if (c)
          if (a) {
            var g = p.map(function(v) {
              return o.getOptionValue(v);
            }).join(a);
            return /* @__PURE__ */ be.createElement("input", {
              name: d,
              type: "hidden",
              value: g
            });
          } else {
            var m = p.length > 0 ? p.map(function(v, y) {
              return /* @__PURE__ */ be.createElement("input", {
                key: "i-".concat(y),
                name: d,
                type: "hidden",
                value: o.getOptionValue(v)
              });
            }) : /* @__PURE__ */ be.createElement("input", {
              name: d,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ be.createElement("div", null, m);
          }
        else {
          var b = p[0] ? this.getOptionValue(p[0]) : "";
          return /* @__PURE__ */ be.createElement("input", {
            name: d,
            type: "hidden",
            value: b
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, i = this.state, a = i.ariaSelection, u = i.focusedOption, c = i.focusedValue, d = i.isFocused, f = i.selectValue, p = this.getFocusableOptions();
      return /* @__PURE__ */ be.createElement(BQ, Te({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: a,
        focusedOption: u,
        focusedValue: c,
        isFocused: d,
        selectValue: f,
        focusableOptions: p,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), i = o.Control, a = o.IndicatorsContainer, u = o.SelectContainer, c = o.ValueContainer, d = this.props, f = d.className, p = d.id, g = d.isDisabled, m = d.menuIsOpen, b = this.state.isFocused, v = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ be.createElement(u, Te({}, v, {
        className: f,
        innerProps: {
          id: p,
          onKeyDown: this.onKeyDown
        },
        isDisabled: g,
        isFocused: b
      }), this.renderLiveRegion(), /* @__PURE__ */ be.createElement(i, Te({}, v, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: g,
        isFocused: b,
        menuIsOpen: m
      }), /* @__PURE__ */ be.createElement(c, Te({}, v, {
        isDisabled: g
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ be.createElement(a, Te({}, v, {
        isDisabled: g
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, i) {
      var a = i.prevProps, u = i.clearFocusValueOnUpdate, c = i.inputIsHiddenAfterUpdate, d = i.ariaSelection, f = i.isFocused, p = i.prevWasFocused, g = i.instancePrefix, m = o.options, b = o.value, v = o.menuIsOpen, y = o.inputValue, w = o.isMulti, I = Fh(b), V = {};
      if (a && (b !== a.value || m !== a.options || v !== a.menuIsOpen || y !== a.inputValue)) {
        var M = v ? mee(o, I) : [], L = v ? Jh(Fc(o, I), "".concat(g, "-option")) : [], R = u ? Cee(i, I) : null, _ = vee(i, M), H = b5(L, _);
        V = {
          selectValue: I,
          focusedOption: _,
          focusedOptionId: H,
          focusableOptionsWithIds: L,
          focusedValue: R,
          clearFocusValueOnUpdate: !1
        };
      }
      var B = c != null && o !== a ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, Z = d, G = f && p;
      return f && !G && (Z = {
        value: vc(w, I, I[0] || null),
        options: I,
        action: "initial-input-focus"
      }, G = !p), (d == null ? void 0 : d.action) === "initial-input-focus" && (Z = null), Be(Be(Be({}, V), B), {}, {
        prevProps: o,
        ariaSelection: Z,
        prevWasFocused: G
      });
    }
  }]), n;
}(fL);
Ey.defaultProps = gee;
var yee = /* @__PURE__ */ Fe(function(e, t) {
  var n = _q(e);
  return /* @__PURE__ */ be.createElement(Ey, Te({
    ref: t
  }, n));
}), xee = yee;
const Ry = ({
  children: e,
  onMouseDown: t
}) => /* @__PURE__ */ x.jsx(
  vs,
  {
    paddingX: "5px",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    onMouseDown: t,
    children: e
  }
), See = ({
  innerProps: e
}) => /* @__PURE__ */ x.jsx(Ry, { ...e, children: /* @__PURE__ */ x.jsx(Fr, { icon: "close" }) }), wee = () => /* @__PURE__ */ x.jsx(Ry, { children: /* @__PURE__ */ x.jsx(Fr, { icon: "arrow-down-s" }) }), Kh = (e, { isFocused: t }) => ({
  "&:hover": {
    borderColor: e ? _r.alertError : t ? _r.selected2 : _r.hover2
  },
  boxShadow: t ? e ? `inset 0 0 0 1px ${_r.alertError}` : `inset 0 0 0 1px ${_r.selected2}` : "none"
}), Iee = (e, t, n, r) => e === "grid" ? {
  borderRadius: "0px",
  border: "1px solid transparent",
  minHeight: "25px",
  height: "100%",
  // consume all space if grid row is more than one line
  // body-2
  fontSize: "0.75rem",
  fontWeight: "400",
  backgroundColor: n ? _r.alertWarningLight : "transparent",
  outline: "none !important",
  ...Kh(n, r)
} : {
  minHeight: {
    xs: "1.5rem",
    sm: "2rem",
    md: "2.75rem",
    lg: "3rem"
  }[t],
  height: "100%",
  borderColor: n ? _r.alertError : _r.strokeDefault,
  ...Kh(n, r)
}, Vee = (e, t, n, r) => ({ minHeight: o, ...i }, a) => ({
  ...i,
  ...Iee(e, t, n, a),
  ...r,
  alignItems: "center"
}), Aee = (e, t) => e === "grid" ? { fontSize: "12px" } : { fontSize: {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px"
}[t] }, Lee = (e, t) => ({ margin: n, ...r }, o) => ({ ...r, ...Aee(e, t) }), Mee = (e, t, n, r) => ({ ...o }) => ({
  ...o,
  ...r
}), Pee = (e, t) => e === "grid" ? { fontSize: "12px" } : { fontSize: {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px"
}[t] }, Eee = (e, t) => ({ margin: n, ...r }, o) => ({ ...r, ...Pee(e, t) }), Ree = (e, t) => {
  if (e === "grid")
    return { padding: ".125rem", gap: ".125rem" };
  switch (t) {
    case "xs":
      return { padding: ".125rem", gap: ".125rem", minHeight: "1.5rem" };
    case "sm":
      return { padding: ".25rem", gap: ".25rem" };
    case "md":
      return { padding: ".5rem", gap: ".375rem" };
    case "lg":
      return { padding: ".625Rem", gap: ".5rem" };
    default:
      Pf(t);
  }
}, _ee = (e, t) => (n, r) => ({
  ...n,
  ...Ree(e, t),
  lineHeight: "normal"
}), Tee = (e) => {
  const t = at(
    () => e.reduce((n, r) => (n[r.value] = r, n), {}),
    [e]
  );
  return q(
    (n) => Un(n) ? null : t[n],
    []
  );
};
const bte = Fe((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    invalid: i,
    onChange: a,
    variant: u = "outline",
    size: c = "md",
    width: d = "100%",
    disabled: f,
    options: p,
    filterOption: g,
    placeholder: m,
    defaultMenuIsOpen: b,
    isClearable: v = !0
  } = e, y = Tee(p), w = Bl(n), { decorate: I } = kl({ ...e, id: w }), V = (M) => {
    a == null || a((M == null ? void 0 : M.value) ?? "");
  };
  return I(
    /* @__PURE__ */ x.jsx(
      xee,
      {
        id: w,
        ref: t,
        name: r,
        defaultMenuIsOpen: b ?? !1,
        options: p,
        filterOption: g,
        value: y(o),
        onChange: V,
        isDisabled: f,
        placeholder: m,
        isClearable: v,
        menuShouldScrollIntoView: !1,
        components: { ClearIndicator: See, DropdownIndicator: wee },
        styles: {
          control: Vee(u, c, i, { width: d }),
          input: Lee(u, c),
          menu: Mee(u, c, i, { width: d }),
          multiValue: Eee(u, c),
          valueContainer: _ee(u, c)
        }
      }
    )
  );
});
const yte = Fe((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    onChange: i,
    onBlur: a,
    width: u = "100%",
    disabled: c,
    min: d,
    max: f,
    step: p = 1
  } = e, g = Bl(n), { decorate: m } = kl({ ...e, id: g });
  return m(
    /* @__PURE__ */ x.jsxs("div", { className: "simple-range-wrapper", style: { width: u }, children: [
      /* @__PURE__ */ x.jsx("div", { className: "simple-range-selected-fill", children: /* @__PURE__ */ x.jsx(
        "input",
        {
          type: "range",
          min: d,
          max: f,
          value: o,
          step: p,
          onChange: () => null,
          disabled: c,
          tabIndex: -1
        }
      ) }),
      /* @__PURE__ */ x.jsx("div", { className: "simple-range-input", children: /* @__PURE__ */ x.jsx(
        "input",
        {
          id: g,
          ref: t,
          type: "range",
          name: r,
          min: d,
          max: f,
          value: o,
          step: p,
          onChange: i,
          onBlur: a,
          disabled: c
        }
      ) })
    ] })
  );
}), xte = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ x.jsx(GY, { className: Qn("sound-ui-table-container", t), ...n, children: e }), Ste = ({
  children: e,
  stickyFirstColumn: t,
  variant: n,
  className: r,
  ...o
}) => {
  const i = ["sound-ui-table", r];
  return t && i.push("sticky-first-column"), n === "grid" ? i.push("grid") : i.push("default"), /* @__PURE__ */ x.jsx(Qo, { role: "table", className: Qn(i), ...o, children: e });
}, wte = ({ children: e, ...t }) => /* @__PURE__ */ x.jsx(Qo, { role: "tbody", ...t, children: e }), Ite = ({ children: e, ...t }) => /* @__PURE__ */ x.jsx(Qo, { role: "thead", ...t, children: e }), Vte = ({ children: e, ...t }) => /* @__PURE__ */ x.jsx(Qo, { role: "tr", ...t, children: e }), Ate = Fe(
  ({ children: e, ...t }, n) => /* @__PURE__ */ x.jsx(Qo, { role: "th", ref: n, ...t, children: e })
), Lte = Fe(
  ({ children: e, ...t }, n) => /* @__PURE__ */ x.jsx(Qo, { role: "td", ref: n, ...t, children: e })
), Mte = ({
  items: e,
  value: t,
  size: n,
  variant: r,
  disabled: o = !1,
  onChange: i
}) => /* @__PURE__ */ x.jsx("div", { className: "mode-switcher", children: e.map((a) => /* @__PURE__ */ x.jsx(
  df,
  {
    text: a.label,
    onClick: () => i(a.id),
    disabled: t === a.id || o,
    size: n,
    variant: r,
    icon: a.icon
  },
  a.id
)) });
export {
  nte as Accordion,
  Wee as Avatar,
  hb as Badge,
  UY as Banner,
  XY as BannerDescription,
  GY as Block,
  df as Button,
  ute as Card,
  UX as Checkbox,
  jee as CheckboxGroup,
  XX as CopyButton,
  rte as Drawer,
  vs as Flex,
  Qee as Grid,
  Fr as Icon,
  Qc as IconButton,
  Xee as InfoIcon,
  Jee as Input,
  xU as Link,
  ete as LoadingIndicator,
  jY as Logo,
  cte as Menu,
  dte as MenuButton,
  fte as MenuItem,
  hte as MenuList,
  JY as Modal,
  Mte as ModeSwitcher,
  tte as OfflineBanner,
  mte as RadioCardGroup,
  Uee as RadioGroup,
  ate as ReactTableUI,
  qee as Select,
  Lq as SimpleDollarInput,
  Vq as SimpleInput,
  yte as SimpleRange,
  Cte as SimpleSelect,
  bte as SimpleSingleCombo,
  vte as SimpleTextArea,
  pb as SmallLoader,
  zee as SoundUIProvider,
  lte as SplitLayout,
  ote as Switch,
  Ste as Table,
  xte as TableContainer,
  pte as Tabs,
  wte as Tbody,
  Lte as Td,
  Ate as Th,
  Ite as Thead,
  H2 as Tooltip,
  Vte as Tr,
  Or as Typography,
  Qj as appraisifyColors,
  $ee as appraisifyPDFTheme,
  Gee as buttonSizeToIconSize,
  _r as colors,
  ste as createColumnHelper,
  $X as getFillRule,
  GJ as getSortIcon,
  dq as hasMask,
  cq as hasMinMax,
  zX as icons,
  iU as isCellProps,
  IU as isNumberLikeInputType,
  gte as makePxlStr,
  NX as theme,
  Kee as toOpts,
  Yee as typographyVariants,
  F2 as useFormSizeContext,
  ite as useModal,
  Qi as useThemeColor,
  Za as withFormWrapper
};
//# sourceMappingURL=main.mjs.map
